
(function() {
  'use strict';
  // load every angular module or plugin of the site
  angular
    .module('loadsAppWeb', [
      'ngAnimate',
      'ngCookies',
      'ngTouch',
      'ngSanitize',
      'ngMessages',
      'ngAria',
      'ngResource',
      'ui.router',
      'toastr',
      'pascalprecht.translate',
      'ngStorage',
      'angularMoment',
      'datatables',
      'daterangepicker',
      'uiGmapgoogle-maps',
      'google.places',
      'ui.bootstrap',
      'ngFileUpload',
      'permission',
      'permission.ui',
      'thatisuday.ng-image-gallery',
      'moment-picker',
      'ngMaterial',
      'ngMessages',
      'flux',
      '19degrees.ngSweetAlert2',
      'swangular'
    ]);

})();

angular.module('loadsAppWeb').controller('LoadController',[
  '$state',
  'toastr',
  '$filter',
  'Config',
  'Loads',
  'Auth',
  'DatatableTool',
  '$q',
  '$uibModal',
  'sweetAlert',
  'swangular',
  '$scope',
  LoadController
]);

function LoadController (
  $state,
  toastr,
  $filter,
  Config,
  Loads,
  Auth,
  DatatableTool,
  $q,
  $uibModal,
  sweetAlert,
  swangular,
  $scope
){

  $scope.construct = function (){
      $scope.dataLoads = {};
      $scope.savingLoad = false;
  }
  $scope.registerLoad = function (){
    $scope.savingLoad = true;
  }

}

(function() {
  'use strict';
/* Truck services
 * Get trucks by carrier
 * Get truck info
 * Create truck
 * Update truck
 * Looking for interesting points
 * Count trucks by carrier
 */

  angular
    .module('loadsAppWeb')
    .service('Trucks', TruckServices);

  /** @ngInject */
  function TruckServices($q, $http, Config, Upload) {
	var vm = this;
	vm.api_endpoint_trucks = Config.ENV.API_ENDPOINT +'v1/' + 'trucks/';
  vm.api_companies_endpoint_trucks_drivers = Config.ENV.API_COMPANIES_ENDPOINT + Config.ENV.API_COMPANIES_PATH_ENDPOINT + 'truck';

	vm.trucksForCarrier = function(params)
	{
		// Defer
        var defer = $q.defer();
        // Url
        var url = vm.api_endpoint_trucks + 'trucksForCarrier';

        // Get
        $http.post(url, params)
            .then(function(response) {
                // Success
                if(response.data.status == 'ok' ){
                	defer.resolve(response.data.message);
                }else{
					defer.reject(false);
                }
            })
            .catch(function(response) {
                // Error

                defer.reject(false);
            });

        return defer.promise;
	};

  vm.trucksDetails = function(params)
  {
    // Defer
        var defer = $q.defer();
        // Url
        var url = vm.api_endpoint_trucks + 'DetailTruck';

        // Get
        $http.post(url, params)
            .then(function(response) {
                // Success
                if(response.data.status == 'ok' ){
                  defer.resolve(response.data.message);
                }else{
          defer.reject(false);
                }
            })
            .catch(function(response) {
                // Error

                defer.reject(false);
            });

        return defer.promise;
  };

  vm.createTruck = function(params)
  {
    // Defer
        var defer = $q.defer();
        // Url
        var url = vm.api_endpoint_trucks + 'createTruck';

        // Get
        Upload.upload({url: url, data: params})
          .then(function(response) {
                // Success
                //console.log(response);
                if(response.data.status == 'ok' ){
                  defer.resolve(response.data.message);
                }else{
                  defer.reject(response.data.message);
                }
            })
            .catch(function(response) {
                // Error

                defer.reject(false);
            });

        return defer.promise;
  };

  vm.updateTruck = function(params, withImg)
  {
    // Defer
    var defer = $q.defer();
    // Url
    var url = vm.api_endpoint_trucks + 'UpdateTruck';

    if(withImg){
      // Get
      Upload.upload({url: url, data: params})
        .then(function(response) {
              // Success
              //Upload.abort();
              //console.log(response);
              if(response.data.status == 'ok' ){
                defer.resolve(response.data.message);
              }else{
                defer.reject(response.data.message);
              }
          })
          .catch(function(response) {
              // Error

              defer.reject(response.data.message);
          });
    }else{
      //console.log(params);
      $http.post(url, params)
          .then(function(response) {
              // Success
              if(response.data.status == 'ok' ){
                defer.resolve(response.data.message);
              }else{
                defer.reject(response.data.message);
              }
          })
          .catch(function(response) {
              // Error

              defer.reject(response.data.message);
          });
    }

    return defer.promise;
  };

  vm.searchInterestPoints = function(params)
  {
    // Defer
        var defer = $q.defer();
        // Url
        var url = vm.api_endpoint_trucks + 'PointsOfInterest';

        // Get
        $http.post(url, params)
            .then(function(response) {
                // Success
                if(response.data.status == 'ok' ){
                  defer.resolve(response.data.message);
                }else{
                  defer.reject(false);
                }
            })
            .catch(function(response) {
                // Error

                defer.reject(false);
            });

        return defer.promise;
  };

  vm.countTrucksxCarrier = function(params)
  {
    // Defer
        var defer = $q.defer();
        // Url
        var url = vm.api_endpoint_trucks + 'CountTruckxCarrier';

        // Get
        $http.post(url, params)
            .then(function(response) {
                // Success
                if(response.data.status == 'ok' ){
                  defer.resolve(response.data.message);
                }else{
          defer.reject(false);
                }
            })
            .catch(function(response) {
                // Error

                defer.reject(false);
            });

        return defer.promise;
  };

  vm.trucksListCarrier = function(params)
  {
    // Defer
        var defer = $q.defer();
        // Url
        var url = vm.api_endpoint_trucks + 'trucksListCarrier';

        // Get
        $http.post(url, params)
          .then(function(response) {
              // Success
              if(response.data.status == 'ok' ){
                defer.resolve(response.data.message);
              }else{
                defer.reject(false);
              }
          })
          .catch(function(response) {
              // Error

              defer.reject(false);
          });

        return defer.promise;
  };

  vm.trucksDriversUploadCompanies = function(formData)
  {
    // Defer
        var defer = $q.defer();
        // Url
        var url = vm.api_companies_endpoint_trucks_drivers;

        // Get
        $http.post(url, formData)
            .then(function(response) {
                // Success
                if(response.data.message){
                  defer.resolve(response.data);
                }else{
                  defer.reject(response);
                }
            })
            .catch(function(response) {
                // Error

                defer.reject(response);
            });

        return defer.promise;
  };

  vm.trucksDriversUploadUpdateCompanies = function(formData)
  {
    // Defer
        var defer = $q.defer();
        // Url
        var url = vm.api_companies_endpoint_trucks_drivers;

        // Get
        $http.put(url, formData)
            .then(function(response) {
                // Success
                if(response.data.message){
                  defer.resolve(response.data);
                }else{
                  defer.reject(response);
                }
            })
            .catch(function(response) {
                // Error

                defer.reject(response);
            });

        return defer.promise;
  };


  }
})();

(function() {
  'use strict';

  /* Truck details Directive
   * It shows truck info in dropdown of trucks table list
   * It is a generic element is loaded when user click in dropdown button of item */

  angular
    .module('loadsAppWeb')
    .directive('truckDetailsRow', truckDetailsRow);

  /** @ngInject */
  function truckDetailsRow($rootScope, Auth, Trucks, uiGmapGoogleMapApi, $uibModal, toastr, $filter, $state) {
    return {
        templateUrl: 'app/trucks/templates/directives/truck-details-row.html', // directive template
        restrict: 'E',
        replace: true,
        scope: {
          truckId: '=', //Input of directive, Truck id
          reloadParent: '&' //Input of directive, function which reloads trucks table list
        },
        link: function(scope) {
            scope.truckData = {};
            scope.loadingTruckData = true;
            /**
             * Initialize
             */
            scope.initialize = function() {
                scope.truckOptions = {
                  'token': Auth.getUserToken(),
                  'id': scope.truckId
                };

                scope.getTruckDetails();
            };

            /* Get truck info from data received */
            scope.getTruckDetails =  function() {
              Trucks.trucksDetails(scope.truckOptions)
                .then(function(response){
                  scope.truckData = response.Truck_Details[0];
                  if(angular.isDefined(scope.truckData.skills_truck) && scope.truckData.skills_truck.length){
                    var arr_skills = [];
                    for(var sk in scope.truckData.skills_truck){
                      arr_skills.push(scope.truckData.skills_truck[sk].skills_name);
                    }
                    scope.truckData.SkillsTruckText = arr_skills.join(', ');
                  }else{
                    scope.truckData.SkillsTruckText = "---";
                  }

                  if(angular.isDefined(scope.truckData.truck_availability) && scope.truckData.truck_availability.length){
                    var arr_availability = [];
                    for(var av in scope.truckData.truck_availability){
                      arr_availability.push(scope.truckData.truck_availability[av].availablity_name);
                    }
                    scope.truckData.AvailabilityTruckText = arr_availability.join(', ');
                  }else{
                    scope.truckData.AvailabilityTruckText = "---";
                  }

                  if(angular.isDefined(scope.truckData.length) && scope.truckData.length != null){
                    if(scope.truckData.length.indexOf("FT ft") !== -1){
                      scope.truckData.length = scope.truckData.length.replace("FT ft", "FT");
                    }
                  }

                  if(angular.isDefined(scope.truckData.max_distance) && scope.truckData.max_distance != null){
                    if(scope.truckData.max_distance.indexOf("mi mi") !== -1){
                      scope.truckData.max_distance = scope.truckData.max_distance.replace("mi mi", "Km");
                    }
                  }

                  scope.truckData.configuration = "";
                  if(angular.isDefined(scope.truckData.truck_size) && scope.truckData.truck_size != null){
                    switch(scope.truckData.truck_size.id.toString()){
                      case "1":
                        scope.truckData.configuration = "SENCILLO";
                        break;
                      case "2":
                        scope.truckData.configuration = "FULL";
                        break;
                    }
                  }

                  /*scope.truckData.trailer_type_desc = '';
                  if(angular.isDefined(scope.truckData.trailer_type)){
                    if(angular.isDefined(scope.truckData.trailer_type.id)){
                      scope.truckData.trailer_type_desc = scope.truckData.trailer_type.trailer_type_name;
                    }
                  }*/

                  scope.loadingTruckData = false;
                })
                .catch(function (error) {
                  scope.loadingTruckData = false;
                });
            };

            /* Active or inactive truck */
            scope.truckToggleActive = function() {
              var truckStatus = (scope.truckData.status == '1') ? '0' : '1';              
              var truckDataToUpdate = { token: Auth.getUserToken(), id_truck: scope.truckData.id, status: truckStatus};
              Trucks.updateTruck(truckDataToUpdate, false)
                    .then(function(response) {
                        // Success
                        if(truckStatus == '1'){
                          toastr.success($filter('translate')('trucks:details:active:action'));
                        }else{
                          toastr.success($filter('translate')('trucks:details:inactive:action'));
                        }
                        scope.reloadParent();
                    })
                    .catch(function(error) {
                        // Error
                        toastr.error($filter('translate')('trucks:details:active:error'));
                    });
            };

            scope.goToSeeDriver = function(driver_name_search){
              $state.go('private.drivers.params', { driver_name: driver_name_search});
            };

            scope.goToSeeTrailerId = function(trailer_id_search){
              $state.go('private.trailers.params', { trailer_id: trailer_id_search, dummy1: null, dummy2: null});
            };

            // Initialize
            scope.initialize();
        }
    };
  }
})();

(function() {
  'use strict';

  /* Upload file to create trucks modal controller
   * Receive token 
   */

  angular
    .module('loadsAppWeb')
    .directive('ngFiles', ['$parse', function ($parse) {
        function fn_link(scope, element, attrs) {
            var onChange = $parse(attrs.ngFiles);
            element.on('change', function (event) {
                onChange(scope, { $files: event.target.files });
            });
        };

        return {
            link: fn_link
        }
    } ])
    .controller('TrucksUploadModalController', TrucksUploadModalController);

  /** @ngInject */
  function TrucksUploadModalController($state, token, uploadMethod, Auth, Trucks, $uibModalInstance, DatatableTool, $q, toastr, $filter, $http, $localStorage) {
	  var vm = this;
    vm.formdata = new FormData();
    vm.filesSelected = [];


    /* Function executed at strart, get load id and get carrier requests  */
    vm.initialize = function() {
      vm.userDataProfile = Auth.getUserDataProfile();
      vm.dataHeader = {};
      vm.dataHeader.company_id = '';
      if(vm.userDataProfile){
        if(angular.isDefined(vm.userDataProfile.user_hash)){
          vm.dataHeader.company_id = vm.userDataProfile.user_hash;
        }
      }
      vm.dataHeader.api_key = null;
      vm.dataHeader.notificacion_email = null;

      vm.saving = false;
    };

    vm.getFiles = function ($files) {
      console.log($files);
        angular.forEach($files, function (value, key) {
          console.log(value); console.log(key);
            vm.formdata.append(key, value);
            vm.filesSelected.push({k: key, v: value});
            console.log(vm.formdata);
        });
    };

    vm.sendDataUpload = function (trucksUploadFormName) {
      vm.saving = true;
      if (trucksUploadFormName.$invalid) {

          // Email
          if (!trucksUploadFormName.notification_email.$valid && trucksUploadFormName.notification_email.$error.email) {
              toastr.error($filter('translate')('login:email:error'));
              return;
          }else if (trucksUploadFormName.$error.required) {
              toastr.error($filter('translate')('loads:add:form:required:fields:error'));
          } else {
              toastr.error($filter('translate')('loads:add:form:required:fields:invalid'));
          }
          vm.saving = false;
          return;
      }

      if(vm.filesSelected.length <= 0){
        toastr.error($filter('translate')('loads:add:form:required:fields:error'));
        vm.saving = false;
          return;
      }

      $localStorage.companiesHeaderReq = {
                                              'x_api_key': vm.dataHeader.api_key,
                                              'company_id': vm.dataHeader.company_id,
                                              'notification_email': vm.dataHeader.notificacion_email
                                          };

      if(uploadMethod == 'POST'){

        Trucks.trucksDriversUploadCompanies(vm.formdata)
              .then(function(response){
                if(response.code == 100){
                  toastr.success($filter('translate')('modals:truck_upload:process:success:msg'));
                  vm.saving = false;
                  vm.closePopup();
                }else if(response.code == 200){
                  toastr.error($filter('translate')('modals:truck_upload:process:error_general:msg'));
                  vm.saving = false;
                }else if(response.code == 201){
                  toastr.error($filter('translate')('modals:truck_upload:process:error_201:msg'));
                  vm.saving = false;
                }else{
                  toastr.error($filter('translate')('modals:truck_upload:process:error_general:msg'));
                  vm.saving = false;
                }
              })
              .catch(function (error) {
                toastr.error($filter('translate')('modals:truck_upload:process:error_general:msg'));
                vm.saving = false;
              });
      }else if(uploadMethod == 'PUT'){
        Trucks.trucksDriversUploadUpdateCompanies(vm.formdata)
              .then(function(response){
                if(response.code == 100){
                  toastr.success($filter('translate')('modals:truck_upload:process:success:msg'));
                  vm.saving = false;
                  vm.closePopup();
                }else if(response.code == 200){
                  toastr.error($filter('translate')('modals:truck_upload:process:error_general:msg'));
                  vm.saving = false;
                }else if(response.code == 201){
                  toastr.error($filter('translate')('modals:truck_upload:process:error_201:msg'));
                  vm.saving = false;
                }else{
                  toastr.error($filter('translate')('modals:truck_upload:process:error_general:msg'));
                  vm.saving = false;
                }
              })
              .catch(function (error) {
                toastr.error($filter('translate')('modals:truck_upload:process:error_general:msg'));
                vm.saving = false;
              });
      }
    };

    /* Close popup */
    vm.closePopup = function() {
        $uibModalInstance.close();
    };

    vm.initialize();
    
  }
})();

(function() {
  'use strict';

  /* Truck loads controller
   * Set filter options
   * Get loads list by truck
   * Show load details in dropdown
   */

  angular
    .module('loadsAppWeb')
    .controller('TrucksLoadsController', TrucksLoadsController);

  /** @ngInject */
  function TrucksLoadsController($state, $stateParams, toastr, $filter, Config, Loads, Auth, DatatableTool, DTOptionsBuilder, DTColumnBuilder, $sce) {
	  var vm = this;

    /* Function executed at strart, set filters and get loads list  */
	  vm.initialize = function() {
      var search_type = '';
      vm.profile = Auth.getUserProfile();
      vm.doCustomSearch = false;

      switch(vm.profile){
        case 'GENERADOR_CARGA':
          search_type = 'my_loads';
          break;
        case 'CARRIER':
        case 'DRIVER':
        case 'OWNER':
          if($stateParams.id){
            vm.doCustomSearch = true;
            search_type = 'by_truck';
            vm.paramsCustomSearch = {};
            vm.paramsCustomSearch.token = Auth.getUserToken();
            vm.paramsCustomSearch.page = 1;
            vm.paramsCustomSearch.search_type = search_type;
            vm.paramsCustomSearch.id_truck = $stateParams.id;
          }else{
            if(vm.profile == 'CARRIER' || vm.profile == 'OWNER'){
              search_type = 'all';
            }

            if(vm.profile == 'DRIVER'){
              search_type = 'current';
            }
          }
          break;
      }

      vm.loadsOptions = {
        'search_type': (search_type != '') ? search_type : 'my_loads',
        'token': Auth.getUserToken(),
        'page': 1
      };
      vm.loadsList = [];
      vm.loadingLoadData = true;
      vm.initializedList = false;

      vm.loadTab();  
    };

    /* Load table first time or reload it  */
    vm.loadTab = function() {
      if (vm.initializedList) {
        vm.reloadList();
      } else {
        vm.initializeList();
      }
    };

    /* Change filter between all or current  */
    vm.changeCategory = function(cat) {
      vm.loadingLoadData = true;
      vm.loadsOptions.search_type = cat;
      vm.loadsOptions.page = 1;

      vm.loadTab();
    };

    /* Get loads list and set datatable  */
    vm.initializeList = function() {
      vm.datatableOptions = DTOptionsBuilder.newOptions()
                            .withOption('ajax', function(data, callback, settings){

                              if(vm.loadsOptions.search_type == 'by_truck' && vm.doCustomSearch){
                                // Page
                                vm.paramsCustomSearch.page = DatatableTool.getPage(data);

                                Loads.getByUserRol(vm.paramsCustomSearch)
                                  .then(function(response){
                                    var records = DatatableTool.getRecords(response);
                                    //console.log(records);

                                    // Info
                                    if (!angular.isUndefined(records.data)) {
                                        _.forEach(records.data, function(value, key) {

                                            if(vm.profile == 'CARRIER' || vm.profile == 'DRIVER' || vm.profile == 'OWNER'){
                                              value.full_name_shipper = value.loadGenerator.company_name;
                                              value.img_shipper = false;
                                              if(angular.isDefined(value.loadGenerator.user.img_perfil_imagenes)){
                                                value.img_shipper = value.loadGenerator.user.img_perfil_imagenes[0]['imagen-60'];
                                              }
                                            }

                                            value.status_btn = '';
                                            var bgColorBtn = ''
                                            , colorBtn = '';

                                            switch(value.status_loads){
                                              case 'NOT_ASSIGNED':
                                                bgColorBtn = 'bg-color-7';
                                                colorBtn = 'color-armadillo';
                                                break;
                                              case 'ACEPTADA':
                                                bgColorBtn = 'bg-color-10';
                                                colorBtn = 'color-white';
                                                break;
                                              case 'EN_TRANSITO':
                                                bgColorBtn = 'bg-color-5';
                                                colorBtn = 'color-black';
                                                break;
                                              case 'ENTREGADA': 
                                                bgColorBtn = 'bg-color-9';
                                                colorBtn = 'color-black';
                                                break;
                                              case 'CANCELADA': 
                                                bgColorBtn = 'bg-color-4';
                                                colorBtn = 'color-black';
                                                break;
                                              case 'PAGADA': 
                                                bgColorBtn = 'bg-color-8';
                                                colorBtn = 'color-white';
                                                break;
                                              default:
                                                bgColorBtn = 'bg-color-7';
                                                colorBtn = 'color-armadillo';
                                                break;
                                            }

                                            value.status_btn = $sce.trustAsHtml('<button class="btn btn-class2 btn-status-load '+bgColorBtn+' '+colorBtn+'">'+$filter('translate')('loads:table:status:' +value.status_loads.toLowerCase()+ ':text')+'</button>');

                                            value.pickup_date_formatted = moment(value.pickup_date, "YYYY-MM-DD HH:mm:ss").format("MMM DD YYYY");
                                            value.delivery_date_formatted = moment(value.delivery_date, "YYYY-MM-DD HH:mm:ss").format("MMM DD YYYY");

                                            value.actions = '<i ng-click="loads.showDetailsUnique('+value.load_id+')" class="fa fa-angle-down show-load-details-btn"></i>';
                                        });
                                    }
                                    vm.loadsList = records.data;
                                    records.data = [{img_shipper: false, full_name_shipper: '', status_btn: '', from: '', to: '', pickup_date_formatted: '', delivery_date_formatted: '', distance: '', length_loads: '', weight: '', dimension: '', price: '', load_date: '', actions: ''}];
                                    callback(records);
                                  })
                                  .catch(function (error) {
                                    vm.loadsList = [];
                                    callback(DatatableTool.getRecords(null));
                                  });

                              }else{
                                if(vm.loadsOptions.search_type == 'by_truck'){
                                  if(vm.profile == 'CARRIER' || vm.profile == 'OWNER'){
                                    vm.loadsOptions.search_type = 'all';
                                  }

                                  if(vm.profile == 'DRIVER'){
                                    vm.loadsOptions.search_type = 'current';
                                  }
                                }
                                // Page
                                vm.loadsOptions.page = DatatableTool.getPage(data);

                                Loads.getByUserRol(vm.loadsOptions)
                                  .then(function(response){
                                    var records = DatatableTool.getRecords(response);

                                    // Info
                                    if (!angular.isUndefined(records.data)) {
                                        _.forEach(records.data, function(value, key) {

                                            if(vm.profile == 'CARRIER' || vm.profile == 'DRIVER' || vm.profile == 'OWNER'){
                                              value.full_name_shipper = value.loadGenerator.company_name;
                                              value.img_shipper = false;
                                              if(angular.isDefined(value.loadGenerator.user.img_perfil_arr) && value.loadGenerator.user.img_perfil_arr != null){
                                                value.img_shipper = value.loadGenerator.user.img_perfil_arr[0]['imagen-60'];
                                              }
                                            }

                                            value.status_btn = '';
                                            var bgColorBtn = ''
                                            , colorBtn = '';

                                            switch(value.status_loads){
                                              case 'NOT_ASSIGNED':
                                                bgColorBtn = 'bg-color-7';
                                                colorBtn = 'color-armadillo';
                                                break;
                                              case 'ACEPTADA':
                                                bgColorBtn = 'bg-color-2';
                                                colorBtn = 'color-armadillo';
                                                break;
                                              case 'EN_TRANSITO':
                                                bgColorBtn = 'bg-color-5';
                                                colorBtn = 'color-armadillo';
                                                break;
                                              case 'ENTREGADA': 
                                                bgColorBtn = 'bg-color-3';
                                                colorBtn = 'color-armadillo';
                                                break;
                                              default:
                                                bgColorBtn = 'bg-color-7';
                                                colorBtn = 'color-armadillo';
                                                break;
                                            }

                                            value.status_btn = $sce.trustAsHtml('<button class="btn btn-class2 btn-status-load '+bgColorBtn+' '+colorBtn+'">'+$filter('translate')('loads:table:status:' +value.status_loads.toLowerCase()+ ':text')+'</button>');

                                            value.pickup_date_formatted = moment(value.pickup_date, "YYYY-MM-DD HH:mm:ss").format("MMM DD YYYY");
                                            value.delivery_date_formatted = moment(value.delivery_date, "YYYY-MM-DD HH:mm:ss").format("MMM DD YYYY");

                                            value.actions = '<i ng-click="loads.showDetailsUnique('+value.load_id+')" class="fa fa-angle-down show-load-details-btn"></i>';
                                        });
                                    }
                                    vm.loadsList = records.data;
                                    records.data = [{img_shipper: false, full_name_shipper: '', status_btn: '', from: '', to: '', pickup_date_formatted: '', delivery_date_formatted: '', distance: '', length_loads: '', weight: '', dimension: '', price: '', load_date: '', actions: ''}];
                                    callback(records);
                                  })
                                  .catch(function (error) {
                                    vm.loadsList = [];
                                    callback(DatatableTool.getRecords(null));
                                  });
                              }
                            })
                            .withDataProp('data')
                            .withOption('processing', true)
                            .withOption('serverSide', true)
                            .withOption('searching', false)
                            .withOption('info', false)
                            .withOption('lengthChange', false)
                            .withOption('pageLength', DatatableTool.getLimit(null))
                            .withOption('responsive', true)
                            .withLanguage(DatatableTool.getDefaultLanguageSettings())
                            .withPaginationType('numbers');
      switch(vm.profile){
        case 'GENERADOR_CARGA':
          vm.dtColumns = [
            DTColumnBuilder.newColumn('status_btn'),
            DTColumnBuilder.newColumn('from'),
            DTColumnBuilder.newColumn('to'),
            DTColumnBuilder.newColumn('pickup_date_formatted'),
            DTColumnBuilder.newColumn('delivery_date_formatted'),
            DTColumnBuilder.newColumn('distance'),
            DTColumnBuilder.newColumn('length_loads'),
            DTColumnBuilder.newColumn('weight'),
            DTColumnBuilder.newColumn('dimension'),
            DTColumnBuilder.newColumn('price'),
            DTColumnBuilder.newColumn('load_date'),
            DTColumnBuilder.newColumn('actions')
          ];
          break;
        case 'CARRIER':
        case 'DRIVER':
        case 'OWNER':
          vm.dtColumns = [
            DTColumnBuilder.newColumn('img_shipper'),
            DTColumnBuilder.newColumn('full_name_shipper'),
            DTColumnBuilder.newColumn('from'),
            DTColumnBuilder.newColumn('to'),
            DTColumnBuilder.newColumn('pickup_date_formatted'),
            DTColumnBuilder.newColumn('delivery_date_formatted'),
            DTColumnBuilder.newColumn('length_loads'),
            DTColumnBuilder.newColumn('weight'),
            DTColumnBuilder.newColumn('dimension'),
            DTColumnBuilder.newColumn('price'),
            DTColumnBuilder.newColumn('load_date'),
            DTColumnBuilder.newColumn('status_btn'),
            DTColumnBuilder.newColumn('actions')
          ];
          break;
      }

      vm.loadingLoadData = false;
      vm.initializedList = true;
    };

    /* Reload data table  */
    vm.reloadList = function() {
        // Reload datatables
        DatatableTool.reload();
    };

    /* Show Load details in drop down tab */
    vm.showDetailsUnique = function(load_id) {
      for(var i in vm.loadsList){
        if(vm.loadsList[i].load_id == load_id){
          vm.loadsList[i].expanded = !vm.loadsList[i].expanded;
        }else{
          vm.loadsList[i].expanded = false;
        }
      }
    };

    vm.initialize();
  }
})();

(function() {
  'use strict';

  /* Truck edition controller
   * Set form vars
   * Get truck info
   * Get drivers list
   * Get other params for characteristics of truck
   * Validate and submit form data*/

  angular.module('loadsAppWeb').controller('TrucksEditController', TrucksEditController);

  /** @ngInject */
  function TrucksEditController(
    $state,
    $stateParams,
    toastr,
    $filter,
    Config,
    Trucks,
    Loads,
    Carriers,
    Trailers,
    Auth,
    DatatableTool,
    $q,
    DocumentService,
    sweetAlert,
    swangular,
    $scope
  ) {
	  var vm = this;

    /* Function executed at strart, set form vars and get drivers list and other truck params  */
	  vm.initialize = function() {
      vm.submitReturnList = false;
      vm.loadingTruckDetails = true;
      vm.truckId = $stateParams.id|| 0;
      vm.truckData = false;
      vm.dataUpdateTruck = {};
      vm.dataUpdateTruck.id_truck = null;
      vm.dataUpdateTruck.token = Auth.getUserToken();
      vm.dataUpdateTruck.unity_id = null;
      vm.dataUpdateTruck.brand = null;
      vm.dataUpdateTruck.model = null;
      vm.dataUpdateTruck.year = null;
      vm.dataUpdateTruck.plate = null;
      vm.dataUpdateTruck.id_driver = null;
      vm.dataUpdateTruck.id_truck_type = null;
      vm.dataUpdateTruck.length = null;
      vm.dataUpdateTruck.weight = null,
      //vm.dataUpdateTruck.id_capacity_size = null;
      vm.dataUpdateTruck.max_distance = '';
      vm.dataUpdateTruck.additional_info = null;
      vm.dataUpdateTruck.pic = null;
      vm.dataUpdateTruck.skils_truck = [];
      vm.dataUpdateTruck.availablity = [];
      vm.dataUpdateTruck.loadsize_id = null;
      vm.dataUpdateTruck.trailer_type_id = null;
      vm.dataUpdateTruck.trailer_id = null;

      vm.truckTypeRequired = null;
      vm.lenghtType = 'NA';
      vm.truckTypeConf = 'NA';
      vm.TruckTypesRemolque = [];
      vm.showExtraRequired = false;

      vm.savingTruck = false;

      vm.getItemsSizeLengthLoads();
      vm.getMyDrivers();
      vm.getMyTrailers();
      vm.truckOptions = {
        'token': Auth.getUserToken(),
        'id': vm.truckId
      };
      vm.getDocuments();
      vm.user = {
        profile: 'trucks',
        user_id : vm.truckId
      };
    };
    vm.isSet = function (tabNum){
      return vm.tab === tabNum;
    }
    vm.setTab = function (newTab){
      vm.tab = newTab;
    }
    vm.getDocuments = function (){
      vm.profile = 'trucks';
      DocumentService.display(vm.profile.toLowerCase(),vm.truckId).then(function (resp){
        if(resp.status === 200){
          vm.documents = resp.data.results;
          let tabSetter = (vm.documents.length > 0 && $stateParams.tab == 2)? 2 : $stateParams.tab;
          vm.isSet(tabSetter);
          vm.setTab(tabSetter);
        }
      });
    }
    /* Get drivers list */
    vm.getMyDrivers = function(){
      var params = {};
      params.token = Auth.getUserToken();
      vm.myDriversList = [];

      Carriers.getDriverxCarrier(params)
        .then(function(response){
          if(response.list_drivers){
            vm.myDriversList = response.list_drivers;
          }
        });
    };

    vm.getMyTrailers = function(){
      var params = {};
      params.token = Auth.getUserToken();
      vm.myTrailersList = [];

      Trailers.trailersList(params)
        .then(function(response){
          if(response.result){
            vm.myTrailersList = response.result;
          }
        }).catch(function (error) {

        });
    };

    /* Get truck skills list, availabilities and brands  */
    vm.getItemsSizeLengthLoads = function() {
      vm.itemsSizeLenLoads = {};
      Loads.getItemsSizeLengthLoads()
        .then(function(response){
          if(response){
            vm.itemsSizeLenLoads = response;
            if(angular.isDefined(vm.itemsSizeLenLoads.TrucksSkills_list)){
              vm.setTruckSkillList();
            }

            if(angular.isDefined(vm.itemsSizeLenLoads.TruckAvailability_list)){
              vm.setTruckAvailabilityList();
            }

            if(angular.isDefined(vm.itemsSizeLenLoads.BrandsTruck_list)){
              vm.brandTruckList = vm.itemsSizeLenLoads.BrandsTruck_list;
            }else{
              vm.brandTruckList = [];
            }

            if(angular.isDefined(vm.itemsSizeLenLoads.Trucktypes_list)){
              vm.setSimpleTruckTypes();
              vm.setFullTruckTypes();
            }

            if(angular.isDefined(vm.itemsSizeLenLoads.LoadsLength_list)){
              vm.setSimpleLoadsLength();
              vm.setFullLoadsLength();
            }
          }
          vm.getDataTruck();
        });
    };

    /* Get truck info  */
    vm.getDataTruck =  function() {
      Trucks.trucksDetails(vm.truckOptions)
        .then(function(response){
          vm.truckData = response.Truck_Details[0];
          vm.setDataToForm();
          vm.loadingTruckDetails = false;
        }).catch(function (error) {
          vm.loadingTruckDetails = false;
          $state.go('private.trucks');
        });
    };

    /* Set truck skills list in local var to be used in checkboxes */
    vm.setTruckSkillList = function() {
      vm.skillList = [];
      if(vm.itemsSizeLenLoads.TrucksSkills_list.length){
        for(var i in vm.itemsSizeLenLoads.TrucksSkills_list){
          vm.skillList.push({id: vm.itemsSizeLenLoads.TrucksSkills_list[i].id, name: vm.itemsSizeLenLoads.TrucksSkills_list[i].skills_name, checked: false});
        }
      }
    };

    /* Set truck availabilities list in local var to be used in checkboxes */
    vm.setTruckAvailabilityList = function() {
      vm.availabilityList = [];
      if(vm.itemsSizeLenLoads.TruckAvailability_list.length){
        for(var i in vm.itemsSizeLenLoads.TruckAvailability_list){
          vm.availabilityList.push({id: vm.itemsSizeLenLoads.TruckAvailability_list[i].id, name: vm.itemsSizeLenLoads.TruckAvailability_list[i].availablity_name, checked: false});
        }
      }
    };

    vm.setSimpleLoadsLength = function() {
      vm.simpleLoadsLength = [];
      if(vm.itemsSizeLenLoads.LoadsLength_list.length){
        for(var i in vm.itemsSizeLenLoads.LoadsLength_list){
          if(vm.itemsSizeLenLoads.LoadsLength_list[i].type_length == "s"){
            vm.simpleLoadsLength.push({id: vm.itemsSizeLenLoads.LoadsLength_list[i].id, name: vm.itemsSizeLenLoads.LoadsLength_list[i].name, checked: false});
          }
        }
      }
    };

    vm.setFullLoadsLength = function() {
      vm.fullLoadsLength = [];
      if(vm.itemsSizeLenLoads.LoadsLength_list.length){
        for(var i in vm.itemsSizeLenLoads.LoadsLength_list){
          if(vm.itemsSizeLenLoads.LoadsLength_list[i].type_length == "f"){
            vm.fullLoadsLength.push({id: vm.itemsSizeLenLoads.LoadsLength_list[i].id, name: vm.itemsSizeLenLoads.LoadsLength_list[i].name, checked: false});
          }
        }
      }
    };

    vm.setSimpleTruckTypes = function() {
      vm.simpleTruckTypes = [];
      if(vm.itemsSizeLenLoads.Trucktypes_list.length){
        for(var i in vm.itemsSizeLenLoads.Trucktypes_list){
          if(vm.itemsSizeLenLoads.Trucktypes_list[i].type_config == "s"){
            vm.simpleTruckTypes.push({id: vm.itemsSizeLenLoads.Trucktypes_list[i].id, name: vm.itemsSizeLenLoads.Trucktypes_list[i].truck_type_name, checked: false});

            if(vm.itemsSizeLenLoads.Trucktypes_list[i].required_length == 'Y'){
              vm.TruckTypesRemolque.push(parseInt(vm.itemsSizeLenLoads.Trucktypes_list[i].id));
            }
          }
        }
      }
    }

    vm.setFullTruckTypes = function() {
      vm.fullTruckTypes = [];
      if(vm.itemsSizeLenLoads.Trucktypes_list.length){
        for(var i in vm.itemsSizeLenLoads.Trucktypes_list){
          if(vm.itemsSizeLenLoads.Trucktypes_list[i].type_config == "f"){
            vm.fullTruckTypes.push({id: vm.itemsSizeLenLoads.Trucktypes_list[i].id, name: vm.itemsSizeLenLoads.Trucktypes_list[i].truck_type_name, checked: false});

            if(vm.itemsSizeLenLoads.Trucktypes_list[i].required_length == 'Y'){
              vm.TruckTypesRemolque.push(parseInt(vm.itemsSizeLenLoads.Trucktypes_list[i].id));
            }
          }
        }
      }
    }

    /* After get truck info, it sets them in locak vars */
    vm.setDataToForm = function() {
      vm.dataUpdateTruck.id_truck = (angular.isDefined(vm.truckData.id)) ? vm.truckData.id : vm.truckId;
      vm.dataUpdateTruck.unity_id = (angular.isDefined(vm.truckData.company_id_unity)) ? vm.truckData.company_id_unity : null;
      vm.dataUpdateTruck.brand = (angular.isDefined(vm.truckData.brand)) ? vm.truckData.brand : null;
      vm.dataUpdateTruck.model = (angular.isDefined(vm.truckData.model)) ? vm.truckData.model : null;
      vm.dataUpdateTruck.year = (angular.isDefined(vm.truckData.year)) ? parseInt(vm.truckData.year) : null;
      vm.dataUpdateTruck.plate = (angular.isDefined(vm.truckData.plate)) ? vm.truckData.plate : null;
      vm.dataUpdateTruck.id_driver = (angular.isDefined(vm.truckData.truck_driver) && vm.truckData.truck_driver != null) ? vm.truckData.truck_driver.toString() : null;
      if(vm.truckData.loadsize_id && vm.itemsSizeLenLoads.LoadsSize_list.length > 0){
        for(var sizeindex in vm.itemsSizeLenLoads.LoadsSize_list){
          if(vm.itemsSizeLenLoads.LoadsSize_list[sizeindex].id == vm.truckData.loadsize_id){
            vm.dataUpdateTruck.loadsize_id = vm.itemsSizeLenLoads.LoadsSize_list[sizeindex].id.toString();
            if(vm.dataUpdateTruck.loadsize_id == "1"){
              vm.truckTypeConf = 'S';
            }else if(vm.dataUpdateTruck.loadsize_id == "2"){
              vm.truckTypeConf = 'F';
            }
          }
        }
      }

      vm.dataUpdateTruck.id_truck_type = null;
      vm.truckTypeRequired = null;

      if(angular.isDefined(vm.truckData.truck_type)){
        if(angular.isDefined(vm.truckData.truck_type.id)){
          vm.dataUpdateTruck.id_truck_type = vm.truckData.truck_type.id.toString();
          vm.truckTypeRequired = vm.truckData.truck_type.id.toString();
        }
      }

      if(vm.truckTypeRequired != null && vm.truckTypeRequired != "0" && vm.truckTypeRequired != 0){
        if(vm.TruckTypesRemolque.indexOf(parseInt(vm.truckTypeRequired)) !== -1){
          if(vm.dataUpdateTruck.loadsize_id == "1"){
            vm.lenghtType = 'S';
          }else if(vm.dataUpdateTruck.loadsize_id == "2"){
            vm.lenghtType = 'F';
          }
        }
      }

      if(vm.lenghtType != 'NA' && angular.isDefined(vm.truckData.length)){
        if(vm.truckData.length.indexOf("FT ft") !== -1){
          vm.truckData.length = vm.truckData.length.replace("FT ft", "FT");
        }

        vm.dataUpdateTruck.length = null;

        for(var i in vm.itemsSizeLenLoads.LoadsLength_list){
          if(vm.itemsSizeLenLoads.LoadsLength_list[i].name.toString() == vm.truckData.length.toString()){
            vm.dataUpdateTruck.length = vm.itemsSizeLenLoads.LoadsLength_list[i].name.toString();
          }
        }
      }else{
        vm.dataUpdateTruck.length = null;
      }

      vm.dataUpdateTruck.weight = (angular.isDefined(vm.truckData.weight)) ? parseInt(vm.truckData.weight) : null;
      //vm.dataUpdateTruck.id_capacity_size = (angular.isDefined(vm.truckData.truck_capacity.id)) ? vm.truckData.truck_capacity.id.toString() : null;
      vm.dataUpdateTruck.max_distance = (angular.isDefined(vm.truckData.max_distance)) ? parseInt(vm.truckData.max_distance) : null;
      vm.dataUpdateTruck.additional_info = (angular.isDefined(vm.truckData.additional_info)) ? vm.truckData.additional_info : null;
      vm.dataUpdateTruck.pic = (angular.isDefined(vm.truckData.imagenes_trucks) && vm.truckData.imagenes_trucks != null) ? vm.truckData.imagenes_trucks[0]['imagen-270'] : null;

      if(angular.isDefined(vm.truckData.skills_truck) && vm.truckData.skills_truck.length > 0){
        vm.dataUpdateTruck.skils_truck = [];
        vm.truckData.skills_truck.forEach(function(item) {
          vm.dataUpdateTruck.skils_truck.push(item.id);
        });

        if(angular.isDefined(vm.skillList) && vm.skillList.length){
          vm.skillList.forEach(function(item) {
            if(vm.dataUpdateTruck.skils_truck.indexOf(item.id) != -1){
              item.checked = true;
            }
          });
        }
      }

      if(angular.isDefined(vm.truckData.truck_availability) && vm.truckData.truck_availability.length > 0){
        vm.dataUpdateTruck.availablity = [];
        vm.truckData.truck_availability.forEach(function(item) {
          vm.dataUpdateTruck.availablity.push(item.id);
        });

        if(angular.isDefined(vm.availabilityList) && vm.availabilityList.length){
          vm.availabilityList.forEach(function(item) {
            if(vm.dataUpdateTruck.availablity.indexOf(item.id) != -1){
              item.checked = true;
            }
          });
        }
      }

      if( vm.truckData.trailer_type != null && angular.isDefined(vm.truckData.trailer_type.id)){
        vm.dataUpdateTruck.trailer_type_id = vm.truckData.trailer_type.id.toString();
      }


      if(angular.isDefined(vm.truckData.trailer)){
        if(vm.truckData.trailer != null){
          vm.dataUpdateTruck.trailer_id = vm.truckData.trailer.idtrailer_box.toString();
        }
      }

    };

    /* Validate and send form data to API */
    vm.save = function(postTruckFormName) {
      vm.savingTruck = true; var withImg = true;
      if (postTruckFormName.$invalid) {
          // If there was an error for required fields.
          if (postTruckFormName.$error.required) {
              toastr.error($filter('translate')('loads:add:form:required:fields:error'));
          } else {
              toastr.error($filter('translate')('loads:add:form:required:fields:invalid'));
          }
          return vm.savingTruck = false;

      }

      if(vm.dataUpdateTruck.loadsize_id == "1" || vm.dataUpdateTruck.loadsize_id == "2"){
        if(vm.truckTypeRequired != '' && vm.truckTypeRequired != '0' && vm.truckTypeRequired != 0 && vm.truckTypeRequired != null){
          vm.dataUpdateTruck.id_truck_type = vm.truckTypeRequired;

          if(vm.TruckTypesRemolque.indexOf(parseInt(vm.truckTypeRequired)) !== -1){
            if(vm.dataUpdateTruck.lenght <= 0 || vm.dataUpdateTruck.lenght === null){
              toastr.error($filter('translate')('loads:add:form:required:fields:error'));
              return vm.savingTruck = false;
            }
          }else{
            vm.dataUpdateTruck.lenght = null;
          }
        }else{
          vm.savingTruck = false;
          return toastr.error($filter('translate')('loads:add:form:required:fields:error'));
        }
      }

      if(angular.isDefined(vm.skillList)){
        vm.dataUpdateTruck.skils_truck = [];
        vm.skillList.forEach(function(item) {
          if (item.checked) vm.dataUpdateTruck.skils_truck.push(item.id);
        });

        vm.dataUpdateTruck.skils_truck = JSON.stringify(vm.dataUpdateTruck.skils_truck);
      }

      if(angular.isDefined(vm.availabilityList)){
        vm.dataUpdateTruck.availablity = [];
        vm.availabilityList.forEach(function(item) {
          if (item.checked) vm.dataUpdateTruck.availablity.push(item.id);
        });

        vm.dataUpdateTruck.availablity = JSON.stringify(vm.dataUpdateTruck.availablity);
      }

      if(typeof vm.dataUpdateTruck.pic == 'string' || vm.dataUpdateTruck.pic == null){
        delete vm.dataUpdateTruck.pic;
        withImg = false;
      }

      Trucks.updateTruck(vm.dataUpdateTruck, withImg).then(function(response) {
        toastr.success($filter('translate')('trucks:edit:form:success'));
        vm.getDataTruck();
        vm.savingTruck = false;
      }).catch(function(error) {
        if(error === 'image_exceeded_limit'){
          toastr.error($filter('translate')('trucks:add:form:pic_size:over'));
        }else if(error === 'duplicate_truck'){
          toastr.error($filter('translate')('trucks:add:form:duplicate_truck:error'));
        }else if(error === 'assigned_truck'){
          toastr.error($filter('translate')('trucks:add:form:assigned_truck:error'));
        }else{
          toastr.error($filter('translate')('loads:add:form:required:fields:invalid'));
        }
        vm.dataNewTruck.skils_truck = []; vm.dataNewTruck.availablity = [];
        vm.savingTruck = false;
      });

    };

    /* Set return list var and send form data to API */
    vm.submitReturnListFunc = function(postTruckFormName) {
      vm.submitReturnList = true;
      vm.save(postTruckFormName);
    };

    vm.sizeConfigurationChange = function() {
      switch(vm.dataUpdateTruck.loadsize_id){
        case "1":
          vm.lenghtType = 'NA';
          vm.truckTypeConf = 'S';
          vm.truckTypeRequired = null;
          vm.dataUpdateTruck.length = null;
          break;
        case "2":
          vm.lenghtType = 'NA';
          vm.truckTypeConf = 'F';
          vm.truckTypeRequired = null;
          vm.dataUpdateTruck.length = null;
          break;
        default:
          vm.lenghtType = 'NA';
          vm.truckTypeConf = 'NA';
          vm.truckTypeRequired = null;
          vm.dataUpdateTruck.length = null;
          break;
      }
    };

    vm.truckTypeChange = function() {
      if(vm.dataUpdateTruck.loadsize_id == '1'){
        if(vm.TruckTypesRemolque.indexOf(parseInt(vm.truckTypeRequired)) !== -1){
          vm.lenghtType = 'S';
          vm.dataUpdateTruck.length = null;
        }else{
          vm.lenghtType = 'NA';
          vm.dataUpdateTruck.length = null;
        }
      }else if(vm.dataUpdateTruck.loadsize_id == '2'){
        if(vm.TruckTypesRemolque.indexOf(parseInt(vm.truckTypeRequired)) !== -1){
          vm.lenghtType = 'F';
          vm.dataUpdateTruck.length = null;
        }else{
          vm.lenghtType = 'NA';
          vm.dataUpdateTruck.length= null;
        }
      }else{
        vm.lenghtType = 'NA';
        vm.truckTypeConf = 'NA';
        vm.truckTypeRequired = null;
        vm.dataUpdateTruck.length = null;
      }
    }

    /*vm.truckTypeChange = function() {
      vm.lenghtType = 'NA';

      for(var i in vm.itemsSizeLenLoads.Trucktypes_list){
        if(vm.itemsSizeLenLoads.Trucktypes_list[i].id.toString() == vm.dataUpdateTruck.id_truck_type.toString()){
          if(vm.itemsSizeLenLoads.Trucktypes_list[i].type_config == 's' || vm.itemsSizeLenLoads.Trucktypes_list[i].type_config == 'f'){
            if(vm.itemsSizeLenLoads.Trucktypes_list[i].truck_type_name.indexOf('Remolque') !== -1){
              vm.lenghtType = vm.itemsSizeLenLoads.Trucktypes_list[i].type_config.toUpperCase();
              break;
            }
          }
        }
      }
    }*/

    vm.initialize();
  }
})();

(function() {
  'use strict';

  /* Truck controller
   * Set filter options
   * Get trucks list
   * Show truck details in dropdown
   */

  angular
    .module('loadsAppWeb')
    .controller('TrucksController', TrucksController);

  /** @ngInject */
  function TrucksController($state, $stateParams, toastr, $filter, Config, Trucks, Auth, DatatableTool, DTOptionsBuilder, DTColumnBuilder, $sce, $uibModal) {
	  var vm = this;

    /* Function executed at strart, set filters and get trucks list  */
	  vm.initialize = function() {
      var search_type = '';
      vm.profile = Auth.getUserProfile();

      switch(vm.profile){
        case 'CARRIER':
        case 'OWNER':
          search_type = 'all';
          break;
      }

      vm.truckOptions = {
        'truck_id': '',
        'shortcut': (search_type != '') ? search_type : 'all',
        'token': Auth.getUserToken(),
        'page': 1
      };
      vm.trucksList = [];
      vm.loadingTruckData = true;
      vm.initializedList = false;

      if($stateParams.truck_id){
        vm.truckOptions.truck_id = $stateParams.truck_id;
      }

      vm.loadTab();  
    };

    /* Load table first time or reload it  */
    vm.loadTab = function() {
      if (vm.initializedList) {
        vm.reloadList();
      } else {
        vm.initializeList();
      }
    };

    /* Change filter between active, inactive or all  */
    vm.changeCategory = function(cat) {
      vm.loadingTruckData = true;
      vm.truckOptions.shortcut = cat;
      vm.truckOptions.page = 1;

      vm.loadTab();
    };

    vm.setTruckIdFilter = function() {
      vm.loadingTruckData = true;
      vm.truckOptions.page = 1;

      vm.loadTab();
    };

    /* Get trucks list and set datatable  */
    vm.initializeList = function() {
      DatatableTool.setLimit(20);
      vm.datatableOptions = DTOptionsBuilder.newOptions()
                            .withOption('ajax', function(data, callback, settings){
                              // Page
                              vm.truckOptions.page = DatatableTool.getPage(data);
                              console.log(vm.truckOptions.page);

                              Trucks.trucksForCarrier(vm.truckOptions)
                                .then(function(response){
                                  var records = DatatableTool.getRecordsTrucks(response);

                                  // Info
                                  if (!angular.isUndefined(records.data)) {
                                      _.forEach(records.data, function(value, key) {

                                          value.truck_img = false;
                                          console.log(value.img_truck_imagenes);
                                          if(angular.isDefined(value.img_truck_imagenes) && value.img_truck_imagenes != null){
                                            value.truck_img = value.img_truck_imagenes[0]['imagen-60'];
                                          }

                                          value.truck_name = value.brand+'  '+value.model;

                                          value.driver_name = '--';

                                          if(value.driver !== null){
                                            value.driver_name = value.driver.user.user_first_name+' '+value.driver.user.user_last_name;
                                          }

                                          value.truck_status = '';
                                            var bgColorBtn = ''
                                            , colorBtn = '';

                                            switch(value.status){
                                              case '1':
                                                bgColorBtn = 'bg-color-9';
                                                colorBtn = 'color-black';
                                                break;
                                              case '0':
                                                bgColorBtn = 'bg-color-7';
                                                colorBtn = 'color-armadillo';
                                                break;
                                            }

                                            value.truck_status = $sce.trustAsHtml('<button class="btn btn-class2 '+bgColorBtn+' '+colorBtn+'">'+$filter('translate')('trucks:table:status:' +value.status+ ':text')+'</button>');

                                          value.actions = '<i ng-click="trucks.showDetailsUnique('+value.id+')" class="fa fa-angle-down show-load-details-btn"></i>';
                                      });
                                  }
                                  vm.trucksList = records.data;
                                  records.data = [{truck_img: '', truck_full_name: '', truck_status: '', actions: ''}];
                                  callback(records);
                                })
                                .catch(function (error) {
                                  vm.trucksList = [];
                                  callback(DatatableTool.getRecords(null));
                                });
                            })
                            .withDataProp('data')
                            .withOption('processing', true)
                            .withOption('serverSide', true)
                            .withOption('searching', false)
                            .withOption('info', false)
                            .withOption('lengthChange', false)
                            .withOption('pageLength', DatatableTool.getLimit(null))
                            .withOption('responsive', true)
                            .withLanguage(DatatableTool.getDefaultLanguageSettings())
                            .withPaginationType('numbers');
      switch(vm.profile){
        case 'CARRIER':
        case 'OWNER':
          vm.dtColumns = [
            DTColumnBuilder.newColumn('truck_img').withTitle(''),
            DTColumnBuilder.newColumn('truck_full_name').withTitle(''),
            DTColumnBuilder.newColumn('truck_status').withTitle(''),
            DTColumnBuilder.newColumn('actions').withTitle('')
          ];
          break;
      }

      vm.loadingTruckData = false;
      vm.initializedList = true;
    };

    /* Reload data table  */
    vm.reloadList = function() {
        // Reload datatables
        DatatableTool.reload();
    };

    /* Show Truck details in drop down tab */
    vm.showDetailsUnique = function(truck_id) {
      for(var i in vm.trucksList){
        if(vm.trucksList[i].id == truck_id){
          vm.trucksList[i].expanded = !vm.trucksList[i].expanded;
        }else{
          vm.trucksList[i].expanded = false;
        }
      }
    };

    vm.goToSeeDriver = function(driver_name_search){
      $state.go('private.drivers.params', { driver_name: driver_name_search});
    };

    vm.openUploadTrucksModal = function() {
      var modalInstance = $uibModal.open({
        controller: 'TrucksUploadModalController as trucksupload',
        windowClass: 'trucks-upload-modal',
        templateUrl: 'app/trucks/templates/modal/trucks-upload.html',
        resolve: {
            token: function() {
                return Auth.getUserToken();
            },
            uploadMethod: function() {
                return 'POST'
            }
        }
      });

      modalInstance.result.then(function() {
          vm.loadingTruckData = true;
          vm.truckOptions.shortcut = 'all';
          vm.truckOptions.page = 1;

          vm.loadTab();
      });
    };

    vm.openUploadTrucksUpdateModal = function() {
      var modalInstance2 = $uibModal.open({
        controller: 'TrucksUploadModalController as trucksupload',
        windowClass: 'trucks-upload-modal',
        templateUrl: 'app/trucks/templates/modal/trucks-upload.html',
        resolve: {
            token: function() {
                return Auth.getUserToken();
            },
            uploadMethod: function() {
                return 'PUT'
            }
        }
      });

      modalInstance2.result.then(function() {
          vm.loadingTruckData = true;
          vm.truckOptions.shortcut = 'all';
          vm.truckOptions.page = 1;

          vm.loadTab();
      });
    };

    vm.initialize();
  }
})();

(function() {
  'use strict';

  /* Truck creation controller
   * Set form vars
   * Get drivers list
   * Get other params for characteristics of truck
   * Validate and submit form data*/

  angular
    .module('loadsAppWeb')
    .controller('TrucksAddController', TrucksAddController);

  /** @ngInject */
  function TrucksAddController($state, toastr, $filter, Config, Trucks, Loads, Carriers, Trailers, Auth, DatatableTool, $q) {
	  var vm = this;

    /* Function executed at strart, set form vars and get drivers list and other truck params  */
	  vm.initialize = function() {
      vm.submitReturnList = false;

      vm.dataNewTruck = {};
      vm.dataNewTruck.token = Auth.getUserToken();
      vm.dataNewTruck.unity_id = null;
      vm.dataNewTruck.brand = null;
      vm.dataNewTruck.model = null;
      vm.dataNewTruck.year = null;
      vm.dataNewTruck.plate = null;
      vm.dataNewTruck.id_driver = null;
      vm.dataNewTruck.id_truck_type = null;
      vm.dataNewTruck.length = null;
      vm.dataNewTruck.weight = null,
      //vm.dataNewTruck.id_capacity_size = null;
      vm.dataNewTruck.max_distance = '';
      vm.dataNewTruck.additional_info = null;
      vm.dataNewTruck.skils_truck = [];
      vm.dataNewTruck.availablity = [];
      vm.dataNewTruck.loadsize_id = null;
      vm.dataNewTruck.trailer_type_id = null;
      vm.dataNewTruck.trailer_id = null;

      vm.truckTypeRequired = null;
      vm.lenghtType = 'NA';
      vm.truckTypeConf = 'NA';
      vm.TruckTypesRemolque = [];
      vm.showExtraRequired = false;

      vm.savingNewTruck = false;

      vm.getItemsSizeLengthLoads();
      vm.getMyDrivers();
      vm.getMyTrailers();

    };

    /* Get drivers list  */
    vm.getMyDrivers = function(){
      var params = {};
      params.token = Auth.getUserToken();
      vm.myDriversList = [];

      Carriers.getDriverxCarrier(params)
        .then(function(response){
          if(response.list_drivers){
            vm.myDriversList = response.list_drivers;
          }
        });
    };

    vm.getMyTrailers = function(){
      var params = {};
      params.token = Auth.getUserToken();
      vm.myTrailersList = [];

      Trailers.trailersList(params)
        .then(function(response){
          if(response.result){
            vm.myTrailersList = response.result;
          }
        }).catch(function (error) {

        });
    };

    /* Get truck skills list, availabilities and brands  */
    vm.getItemsSizeLengthLoads = function() {
      vm.itemsSizeLenLoads = {};
      Loads.getItemsSizeLengthLoads()
        .then(function(response){
          if(response){
            console.log(response);
            vm.itemsSizeLenLoads = response;
            if(angular.isDefined(vm.itemsSizeLenLoads.TrucksSkills_list)){
              vm.setTruckSkillList();
            }

            if(angular.isDefined(vm.itemsSizeLenLoads.TruckAvailability_list)){
              vm.setTruckAvailabilityList();
            }

            if(angular.isDefined(vm.itemsSizeLenLoads.BrandsTruck_list)){
              vm.brandTruckList = vm.itemsSizeLenLoads.BrandsTruck_list;
            }else{
              vm.brandTruckList = [];
            }

            if(angular.isDefined(vm.itemsSizeLenLoads.Trucktypes_list)){
              vm.setSimpleTruckTypes();
              vm.setFullTruckTypes();
            }

            if(angular.isDefined(vm.itemsSizeLenLoads.LoadsLength_list)){
              vm.setSimpleLoadsLength();
              vm.setFullLoadsLength();
            }
          }
        });
    };

    /* Set truck skills list in local var to be used in checkboxes */
    vm.setTruckSkillList = function() {
      vm.skillList = [];
      if(vm.itemsSizeLenLoads.TrucksSkills_list.length){
        for(var i in vm.itemsSizeLenLoads.TrucksSkills_list){
          vm.skillList.push({id: vm.itemsSizeLenLoads.TrucksSkills_list[i].id, name: vm.itemsSizeLenLoads.TrucksSkills_list[i].skills_name, checked: false});
        }
      }
    };

    /* Set truck availabilities list in local var to be used in checkboxes */
    vm.setTruckAvailabilityList = function() {
      vm.availabilityList = [];
      if(vm.itemsSizeLenLoads.TruckAvailability_list.length){
        for(var i in vm.itemsSizeLenLoads.TruckAvailability_list){
          vm.availabilityList.push({id: vm.itemsSizeLenLoads.TruckAvailability_list[i].id, name: vm.itemsSizeLenLoads.TruckAvailability_list[i].availablity_name, checked: false});
        }
      }
    };

    vm.setSimpleLoadsLength = function() {
      vm.simpleLoadsLength = [];
      if(vm.itemsSizeLenLoads.LoadsLength_list.length){
        for(var i in vm.itemsSizeLenLoads.LoadsLength_list){
          if(vm.itemsSizeLenLoads.LoadsLength_list[i].type_length == "s"){
            vm.simpleLoadsLength.push({id: vm.itemsSizeLenLoads.LoadsLength_list[i].id, name: vm.itemsSizeLenLoads.LoadsLength_list[i].name, checked: false});
          }
        }
      }
    };

    vm.setFullLoadsLength = function() {
      vm.fullLoadsLength = [];
      if(vm.itemsSizeLenLoads.LoadsLength_list.length){
        for(var i in vm.itemsSizeLenLoads.LoadsLength_list){
          if(vm.itemsSizeLenLoads.LoadsLength_list[i].type_length == "f"){
            vm.fullLoadsLength.push({id: vm.itemsSizeLenLoads.LoadsLength_list[i].id, name: vm.itemsSizeLenLoads.LoadsLength_list[i].name, checked: false});
          }
        }
      }
    };

    vm.setSimpleTruckTypes = function() {
      vm.simpleTruckTypes = [];
      if(vm.itemsSizeLenLoads.Trucktypes_list.length){
        for(var i in vm.itemsSizeLenLoads.Trucktypes_list){
          if(vm.itemsSizeLenLoads.Trucktypes_list[i].type_config == "s"){
            vm.simpleTruckTypes.push({id: vm.itemsSizeLenLoads.Trucktypes_list[i].id, name: vm.itemsSizeLenLoads.Trucktypes_list[i].truck_type_name, checked: false});

            if(vm.itemsSizeLenLoads.Trucktypes_list[i].required_length == 'Y'){
              vm.TruckTypesRemolque.push(parseInt(vm.itemsSizeLenLoads.Trucktypes_list[i].id));
            }
          }
        }
      }
    }

    vm.setFullTruckTypes = function() {
      vm.fullTruckTypes = [];
      if(vm.itemsSizeLenLoads.Trucktypes_list.length){
        for(var i in vm.itemsSizeLenLoads.Trucktypes_list){
          if(vm.itemsSizeLenLoads.Trucktypes_list[i].type_config == "f"){
            vm.fullTruckTypes.push({id: vm.itemsSizeLenLoads.Trucktypes_list[i].id, name: vm.itemsSizeLenLoads.Trucktypes_list[i].truck_type_name, checked: false});

            if(vm.itemsSizeLenLoads.Trucktypes_list[i].required_length == 'Y'){
              vm.TruckTypesRemolque.push(parseInt(vm.itemsSizeLenLoads.Trucktypes_list[i].id));
            }
          }
        }
      }
    }

    /* Validate and send form data to API */
    vm.save = function(postTruckFormName) {
      vm.savingNewTruck = true;vm.showExtraRequired = false;
      if (postTruckFormName.$invalid) {
          if (postTruckFormName.$error.required) {
              toastr.error($filter('translate')('loads:add:form:required:fields:error'));
          } else {
              toastr.error($filter('translate')('loads:add:form:required:fields:invalid'));
          }
          return vm.savingNewTruck = false;
      }

      if(vm.dataNewTruck.loadsize_id == "1" || vm.dataNewTruck.loadsize_id == "2"){
        if(vm.truckTypeRequired != '' && vm.truckTypeRequired != '0' && vm.truckTypeRequired != 0 && vm.truckTypeRequired != null){
          vm.dataNewTruck.id_truck_type = vm.truckTypeRequired;
          if(vm.TruckTypesRemolque.indexOf(parseInt(vm.truckTypeRequired)) !== -1){
            if(vm.dataNewTruck.lenght <= 0 || vm.dataNewTruck.lenght === null){
              vm.savingNewTruck = false;
              return toastr.error($filter('translate')('loads:add:form:required:fields:error'));
            }
          }else{
            vm.dataNewTruck.lenght = null;
          }
        }else{
          vm.savingNewTruck = false;
          return toastr.error($filter('translate')('loads:add:form:required:fields:error'));
        }
      }

      if(angular.isDefined(vm.skillList)){
        vm.skillList.forEach(function(item) {
          if (item.checked) vm.dataNewTruck.skils_truck.push(item.id);
        });
      }

      if(angular.isDefined(vm.availabilityList)){
        vm.availabilityList.forEach(function(item) {
          if (item.checked) vm.dataNewTruck.availablity.push(item.id);
        });
      }
      vm.dataNewTruck.skils_truck = JSON.stringify(vm.dataNewTruck.skils_truck);
      vm.dataNewTruck.availablity = JSON.stringify(vm.dataNewTruck.availablity);
      Trucks.createTruck(vm.dataNewTruck).then(function(response) {
        toastr.success($filter('translate')('trucks:add:form:success'));
        if(vm.submitReturnList){
          $state.go('private.trucks');
        }else{
          vm.initialize();
        }
        vm.savingNewTruck = false;
      }).catch(function(error) {
        let errors = Object.values(error);
        if(error === 'image_exceeded_limit'){
          toastr.error($filter('translate')('trucks:add:form:pic_size:over'));
        }else if(error === 'duplicate_truck'){
          toastr.error($filter('translate')('trucks:add:form:duplicate_truck:error'));
        }else if(error === 'assigned_truck'){
          toastr.error($filter('translate')('trucks:add:form:assigned_truck:error'));
        }else{
          //toastr.error($filter('translate')('loads:add:form:required:fields:invalid'));
          toastr.error(errors[0][0]);
        }
        vm.dataNewTruck.skils_truck = []; vm.dataNewTruck.availablity = [];
        vm.savingNewTruck = false;
      });

    };

    /* Set return list var and send form data to API */
    vm.submitReturnListFunc = function(postTruckFormName) {
      vm.submitReturnList = true;
      vm.save(postTruckFormName);
    };

    vm.sizeConfigurationChange = function() {
      switch(vm.dataNewTruck.loadsize_id){
        case "1":
          vm.lenghtType = 'NA';
          vm.truckTypeConf = 'S';
          vm.truckTypeRequired = null;
          vm.dataNewTruck.length = null;
          break;
        case "2":
          vm.lenghtType = 'NA';
          vm.truckTypeConf = 'F';
          vm.truckTypeRequired = null;
          vm.dataNewTruck.length = null;
          break;
        default:
          vm.lenghtType = 'NA';
          vm.truckTypeConf = 'NA';
          vm.truckTypeRequired = null;
          vm.dataNewTruck.length = null;
          break;
      }
    };

    vm.truckTypeChange = function() {
      if(vm.dataNewTruck.loadsize_id == '1'){
        if(vm.TruckTypesRemolque.indexOf(parseInt(vm.truckTypeRequired)) !== -1){
          vm.lenghtType = 'S';
          vm.dataNewTruck.length = null;
        }else{
          vm.lenghtType = 'NA';
          vm.dataNewTruck.length = null;
        }
      }else if(vm.dataNewTruck.loadsize_id == '2'){
        if(vm.TruckTypesRemolque.indexOf(parseInt(vm.truckTypeRequired)) !== -1){
          vm.lenghtType = 'F';
          vm.dataNewTruck.length = null;
        }else{
          vm.lenghtType = 'NA';
          vm.dataNewTruck.length= null;
        }
      }else{
        vm.lenghtType = 'NA';
        vm.truckTypeConf = 'NA';
        vm.truckTypeRequired = null;
        vm.dataNewTruck.length = null;
      }
    }

    /*vm.truckTypeChange = function() {
      vm.lenghtType = 'NA';

      for(var i in vm.itemsSizeLenLoads.Trucktypes_list){
        if(vm.itemsSizeLenLoads.Trucktypes_list[i].id.toString() == vm.dataNewTruck.id_truck_type.toString()){
          if(vm.itemsSizeLenLoads.Trucktypes_list[i].type_config == 's' || vm.itemsSizeLenLoads.Trucktypes_list[i].type_config == 'f'){
            if(vm.itemsSizeLenLoads.Trucktypes_list[i].truck_type_name.indexOf('Remolque') !== -1){
              vm.lenghtType = vm.itemsSizeLenLoads.Trucktypes_list[i].type_config.toUpperCase();
              break;
            }
          }
        }
      }
    }*/

    vm.initialize();
  }
})();

(function() {
  'use strict';
/* Trailers services
 * Get trailers by carrier
 * Get trailer info
 * Create trailer
 * Update trailer
 */

  angular
    .module('loadsAppWeb')
    .service('Trailers', TrailersServices);

  /** @ngInject */
  function TrailersServices($q, $http, Config, Upload) {
	var vm = this;
	vm.api_endpoint_trailers = Config.ENV.API_ENDPOINT +'v1/' + 'trailer/';
  vm.api_companies_endpoint_trailers = Config.ENV.API_COMPANIES_ENDPOINT + Config.ENV.API_COMPANIES_PATH_ENDPOINT + 'trailer';

	vm.trailersForCarrier = function(params)
	{
		// Defer
        var defer = $q.defer();
        // Url
        var url = vm.api_endpoint_trailers + 'trailersForCarrier';

        // Get
        $http.post(url, params)
            .then(function(response) {
                // Success
                if(response.data.status == 'ok' ){
                	defer.resolve(response.data.message);
                }else{
					        defer.reject(response.data.message);
                }
            })
            .catch(function(response) {
                // Error

                defer.reject(response.data.message);
            });

        return defer.promise;
	};

  vm.trailersList = function(params)
  {
    // Defer
        var defer = $q.defer();
        // Url
        var url = vm.api_endpoint_trailers + 'list';

        // Get
        $http.post(url, params)
            .then(function(response) {
                // Success
                if(response.data.status == 'ok' ){
                  defer.resolve(response.data.message);
                }else{
                  defer.reject(response.data.message);
                }
            })
            .catch(function(response) {
                // Error

                defer.reject(response.data.message);
            });

        return defer.promise;
  };

  vm.createTrailer = function(params)
  {
    // Defer
        var defer = $q.defer();
        // Url
        var url = vm.api_endpoint_trailers + 'add';

        $http.post(url, params)
            .then(function(response) {
                // Success
                if(response.data.status == 'ok' ){
                  defer.resolve(response.data.message);
                }else{
                  defer.reject(response.data.message);
                }
            })
            .catch(function(response) {
                // Error

                defer.reject(response.data.message);
            });

        return defer.promise;
  };

  vm.updateTrailer = function(params)
  {
    // Defer
    var defer = $q.defer();
    // Url
    var url = vm.api_endpoint_trailers + 'edit';

    //console.log(params);
    $http.post(url, params)
        .then(function(response) {
            // Success
            if(response.data.status == 'ok' ){
              defer.resolve(response.data.message);
            }else{
              defer.reject(response.data.message);
            }
        })
        .catch(function(response) {
            // Error

            defer.reject(response.data.message);
        });

    return defer.promise;
  };

  vm.trailersUploadCompanies = function(formData)
  {
    // Defer
        var defer = $q.defer();
        // Url
        var url = vm.api_companies_endpoint_trailers;

        // Get
        $http.post(url, formData)
            .then(function(response) {
                // Success
                if(response.data.message){
                  defer.resolve(response.data);
                }else{
                  defer.reject(response);
                }
            })
            .catch(function(response) {
                // Error

                defer.reject(response);
            });

        return defer.promise;
  };

  vm.trailersUploadUpdateCompanies = function(formData)
  {
    // Defer
        var defer = $q.defer();
        // Url
        var url = vm.api_companies_endpoint_trailers;

        // Get
        $http.put(url, formData)
            .then(function(response) {
                // Success
                if(response.data.message){
                  defer.resolve(response.data);
                }else{
                  defer.reject(response);
                }
            })
            .catch(function(response) {
                // Error

                defer.reject(response);
            });

        return defer.promise;
  };


  }
})();

(function() {
  'use strict';

  /* Trailer details Directive
   * It shows trailer info in dropdown of trailers table list
   * It is a generic element is loaded when user click in dropdown button of item */

  angular
    .module('loadsAppWeb')
    .directive('trailerDetailsRow', trailerDetailsRow);

  /** @ngInject */
  function trailerDetailsRow($rootScope, Auth, Trailers, uiGmapGoogleMapApi, $uibModal, toastr, $filter, $state) {
    return {
        templateUrl: 'app/trailers/templates/directives/trailer-details-row.html', // directive template
        restrict: 'E',
        replace: true,
        scope: {
          trailerInfo: '=', //Input of directive, Trailer info
          reloadParent: '&' //Input of directive, function which reloads trailers table list
        },
        link: function(scope) {
            scope.trailerData = scope.trailerInfo;
            scope.loadingTrailerData = false;
            scope.statusName = '';

            if(angular.isDefined(scope.trailerData.estatus)){
              scope.statusName = $filter('translate')('trucks:table:status:' +scope.trailerData.estatus+ ':text');
            }

            scope.trailerToggleActive = function() {
              var trailerStatus = (scope.trailerData.estatus == '1') ? '0' : '1';              
              var trailerDataToUpdate = { token: Auth.getUserToken(), trailer_id: scope.trailerData.idtrailer_box, status: trailerStatus};
              if(scope.trailerData.trucks_id != null){
                trailerDataToUpdate.truck_id = scope.trailerData.trucks_id;
              }
              Trailers.updateTrailer(trailerDataToUpdate)
                    .then(function(response) {
                        // Success
                        if(trailerStatus == '1'){
                          toastr.success($filter('translate')('trailers:details:active:action'));
                        }else{
                          toastr.success($filter('translate')('trailers:details:inactive:action'));
                        }
                        scope.reloadParent();
                    })
                    .catch(function(error) {
                        // Error
                        toastr.error($filter('translate')('trailers:details:active:error'));
                    });
            };

            scope.goToSeeTruck = function(truck_id){
              $state.go('private.trucks.params', { truck_id: truck_id, dummy1: null, dummy2: null});
            };

            // Initialize
            //scope.initialize();
        }
    };
  }
})();

(function() {
  'use strict';

  /* Upload file to create trailers modal controller
   * Receive token 
   */

  angular
    .module('loadsAppWeb')
    .directive('ngFiles', ['$parse', function ($parse) {
        function fn_link(scope, element, attrs) {
            var onChange = $parse(attrs.ngFiles);
            element.on('change', function (event) {
                onChange(scope, { $files: event.target.files });
            });
        };

        return {
            link: fn_link
        }
    } ])
    .controller('TrailersUploadModalController', TrailersUploadModalController);

  /** @ngInject */
  function TrailersUploadModalController($state, token, uploadMethod, Auth, Trailers, $uibModalInstance, DatatableTool, $q, toastr, $filter, $http, $localStorage) {
	  var vm = this;
    vm.formdata = new FormData();
    vm.filesSelected = [];

    /* Function executed at strart, get load id and get carrier requests  */
    vm.initialize = function() {
      vm.userDataProfile = Auth.getUserDataProfile();
      vm.dataHeader = {};
      vm.dataHeader.company_id = '';
      if(vm.userDataProfile){
        if(angular.isDefined(vm.userDataProfile.user_hash)){
          vm.dataHeader.company_id = vm.userDataProfile.user_hash;
        }
      }
      vm.dataHeader.api_key = null;
      vm.dataHeader.notificacion_email = null;

      vm.saving = false;
    };

    vm.getFiles = function ($files) {
      console.log($files);
        angular.forEach($files, function (value, key) {
          console.log(value); console.log(key);
            vm.formdata.append(key, value);
            vm.filesSelected.push({k: key, v: value});
            console.log(vm.formdata);
        });
    };

    vm.sendDataUpload = function (trailersUploadFormName) {
      vm.saving = true;
      if (trailersUploadFormName.$invalid) {

          // Email
          if (!trailersUploadFormName.notification_email.$valid && trailersUploadFormName.notification_email.$error.email) {
              toastr.error($filter('translate')('login:email:error'));
              return;
          }else if (trailersUploadFormName.$error.required) {
              toastr.error($filter('translate')('loads:add:form:required:fields:error'));
          } else {
              toastr.error($filter('translate')('loads:add:form:required:fields:invalid'));
          }
          vm.saving = false;
          return;
      }

      if(vm.filesSelected.length <= 0){
        toastr.error($filter('translate')('loads:add:form:required:fields:error'));
        vm.saving = false;
          return;
      }

      $localStorage.companiesHeaderReq = {
                                              'x_api_key': vm.dataHeader.api_key,
                                              'company_id': vm.dataHeader.company_id,
                                              'notification_email': vm.dataHeader.notificacion_email
                                          };
      if(uploadMethod == 'POST'){

        Trailers.trailersUploadCompanies(vm.formdata)
              .then(function(response){
                if(response.code == 100){
                  toastr.success($filter('translate')('modals:trailer_upload:process:success:msg'));
                  vm.saving = false;
                  vm.closePopup();
                }else if(response.code == 200){
                  toastr.error($filter('translate')('modals:trailer_upload:process:error_general:msg'));
                  vm.saving = false;
                }else if(response.code == 201){
                  toastr.error($filter('translate')('modals:trailer_upload:process:error_201:msg'));
                  vm.saving = false;
                }else{
                  toastr.error($filter('translate')('modals:trailer_upload:process:error_general:msg'));
                  vm.saving = false;
                }
              })
              .catch(function (error) {
                toastr.error($filter('translate')('modals:trailer_upload:process:error_general:msg'));
                vm.saving = false;
              });
      }else if(uploadMethod == 'PUT'){
        Trailers.trailersUploadUpdateCompanies(vm.formdata)
              .then(function(response){
                if(response.code == 100){
                  toastr.success($filter('translate')('modals:trailer_upload:process:success:msg'));
                  vm.saving = false;
                  vm.closePopup();
                }else if(response.code == 200){
                  toastr.error($filter('translate')('modals:trailer_upload:process:error_general:msg'));
                  vm.saving = false;
                }else if(response.code == 201){
                  toastr.error($filter('translate')('modals:trailer_upload:process:error_201:msg'));
                  vm.saving = false;
                }else{
                  toastr.error($filter('translate')('modals:trailer_upload:process:error_general:msg'));
                  vm.saving = false;
                }
              })
              .catch(function (error) {
                toastr.error($filter('translate')('modals:trailer_upload:process:error_general:msg'));
                vm.saving = false;
              });
      }
    };

    /* Close popup */
    vm.closePopup = function() {
        $uibModalInstance.close();
    };

    vm.initialize();
    
  }
})();

(function() {
  'use strict';

  /* Trailer edition controller
   * Set form vars
   * Get trailer info
   * Validate and submit form data*/

  angular
    .module('loadsAppWeb')
    .controller('TrailersEditController', TrailersEditController);

  /** @ngInject */
  function TrailersEditController($state, $stateParams, toastr, $filter, Config, Trailers, Trucks, Loads, Carriers, Auth, DatatableTool, $q) {
	  var vm = this;

    /* Function executed at strart, set form vars and get drivers list and other truck params  */
	  vm.initialize = function() {
      vm.submitReturnList = false;
      vm.loadingTrailerDetails = true;
      vm.trailerId = $stateParams.id|| false;
      vm.trailerData = false;

      vm.dataUpdateTrailer = {};
      vm.dataUpdateTrailer.trailer_id = vm.trailerId;
      vm.dataUpdateTrailer.token = Auth.getUserToken();
      vm.dataUpdateTrailer.trailer_type = null;
      vm.dataUpdateTrailer.length = null;
      vm.dataUpdateTrailer.plate = null;
      vm.dataUpdateTrailer.location = null;
      vm.dataUpdateTrailer.status = null;
      vm.dataUpdateTrailer.truck_id = null;

      vm.showExtraRequired = false;

      vm.savingTrailer = false;

      vm.getItemsSizeLengthLoads();

    };

    /* Get trucks list  */
    vm.getMyTrucks = function(){
      var params = {};
      params.token = Auth.getUserToken();
      params.page = 1;
      params.shortcut = "active";
      vm.myTrucksList = [];

      Trucks.trucksForCarrier(params)
        .then(function(response){
          if(response.truck_results){
            vm.myTrucksList = response.truck_results;
          }
        }); 

      for(var i in vm.myTrucksList){
        if(vm.myTrucksList[i].company_id_unity == null){
          vm.myTrucksList[i].company_id_unity_select = '';
        }else{
          vm.myTrucksList[i].company_id_unity_select = vm.myTrucksList[i].company_id_unity;
        }
      }

      vm.getDataTrailer();     
    };

    /* Get truck skills list, availabilities and brands  */
    vm.getItemsSizeLengthLoads = function() {
      vm.itemsSizeLenLoads = {};
      Loads.getItemsSizeLengthLoads()
        .then(function(response){
          if(response){
            vm.itemsSizeLenLoads = response;
            if(angular.isDefined(vm.itemsSizeLenLoads.LoadsLength_list)){
              vm.setLoadsLength();
            }

            if(angular.isDefined(vm.itemsSizeLenLoads.TrailerType)){
              vm.setTrailerTypes();
            }

            vm.getMyTrucks();
          }
        }); 
    };

    vm.setTrailerTypes = function() {
      vm.trailerTypesList = [];
      if(vm.itemsSizeLenLoads.TrailerType.length){
        for(var i in vm.itemsSizeLenLoads.TrailerType){
          vm.trailerTypesList.push({id: vm.itemsSizeLenLoads.TrailerType[i].id, name: vm.itemsSizeLenLoads.TrailerType[i].trailer_type_name, checked: false});
        }
      }
    };

    vm.setLoadsLength = function() {
      vm.loadsLengthList = [];
      if(vm.itemsSizeLenLoads.LoadsLength_list.length){
        for(var i in vm.itemsSizeLenLoads.LoadsLength_list){
          if(vm.itemsSizeLenLoads.LoadsLength_list[i].type_length == "s"){
            vm.loadsLengthList.push({id: vm.itemsSizeLenLoads.LoadsLength_list[i].id, name: vm.itemsSizeLenLoads.LoadsLength_list[i].name, checked: false});
          }
        }
      }
    };

    /* Get trailer info  */
    vm.getDataTrailer =  function() {
      vm.trailerOptions = {
        'token': Auth.getUserToken(),
        'page': 1,
        'trailer_id': vm.trailerId
      };
      Trailers.trailersForCarrier(vm.trailerOptions)
        .then(function(response){
          //console.log(response);
          vm.trailerData = response.result[0];
          console.log(vm.trailerData);
          vm.setDataToForm();

          vm.loadingTrailerDetails = false;
        })
        .catch(function (error) {
          vm.loadingTrailerDetails = false;
        });
    };

    /* Set truck skills list in local var to be used in checkboxes */
    vm.setTruckSkillList = function() {
      vm.skillList = [];
      if(vm.itemsSizeLenLoads.TrucksSkills_list.length){
        for(var i in vm.itemsSizeLenLoads.TrucksSkills_list){
          vm.skillList.push({id: vm.itemsSizeLenLoads.TrucksSkills_list[i].id, name: vm.itemsSizeLenLoads.TrucksSkills_list[i].skills_name, checked: false});
        }
      }
    };

    /* Set truck availabilities list in local var to be used in checkboxes */
    vm.setTruckAvailabilityList = function() {
      vm.availabilityList = [];
      if(vm.itemsSizeLenLoads.TruckAvailability_list.length){
        for(var i in vm.itemsSizeLenLoads.TruckAvailability_list){
          vm.availabilityList.push({id: vm.itemsSizeLenLoads.TruckAvailability_list[i].id, name: vm.itemsSizeLenLoads.TruckAvailability_list[i].availablity_name, checked: false});
        }
      }
    };

    vm.setSimpleLoadsLength = function() {
      vm.simpleLoadsLength = [];
      if(vm.itemsSizeLenLoads.LoadsLength_list.length){
        for(var i in vm.itemsSizeLenLoads.LoadsLength_list){
          if(vm.itemsSizeLenLoads.LoadsLength_list[i].type_length == "s"){
            vm.simpleLoadsLength.push({id: vm.itemsSizeLenLoads.LoadsLength_list[i].id, name: vm.itemsSizeLenLoads.LoadsLength_list[i].name, checked: false});
          }
        }
      }
    };

    vm.setFullLoadsLength = function() {
      vm.fullLoadsLength = [];
      if(vm.itemsSizeLenLoads.LoadsLength_list.length){
        for(var i in vm.itemsSizeLenLoads.LoadsLength_list){
          if(vm.itemsSizeLenLoads.LoadsLength_list[i].type_length == "f"){
            vm.fullLoadsLength.push({id: vm.itemsSizeLenLoads.LoadsLength_list[i].id, name: vm.itemsSizeLenLoads.LoadsLength_list[i].name, checked: false});
          }
        }
      }
    };

    vm.setSimpleTruckTypes = function() {
      vm.simpleTruckTypes = [];
      if(vm.itemsSizeLenLoads.Trucktypes_list.length){
        for(var i in vm.itemsSizeLenLoads.Trucktypes_list){
          if(vm.itemsSizeLenLoads.Trucktypes_list[i].type_config == "s"){
            vm.simpleTruckTypes.push({id: vm.itemsSizeLenLoads.Trucktypes_list[i].id, name: vm.itemsSizeLenLoads.Trucktypes_list[i].truck_type_name, checked: false});

            if(vm.itemsSizeLenLoads.Trucktypes_list[i].required_length == 'Y'){
              vm.TruckTypesRemolque.push(parseInt(vm.itemsSizeLenLoads.Trucktypes_list[i].id));
            }
          }
        }
      }
    }

    vm.setFullTruckTypes = function() {
      vm.fullTruckTypes = [];
      if(vm.itemsSizeLenLoads.Trucktypes_list.length){
        for(var i in vm.itemsSizeLenLoads.Trucktypes_list){
          if(vm.itemsSizeLenLoads.Trucktypes_list[i].type_config == "f"){
            vm.fullTruckTypes.push({id: vm.itemsSizeLenLoads.Trucktypes_list[i].id, name: vm.itemsSizeLenLoads.Trucktypes_list[i].truck_type_name, checked: false});

            if(vm.itemsSizeLenLoads.Trucktypes_list[i].required_length == 'Y'){
              vm.TruckTypesRemolque.push(parseInt(vm.itemsSizeLenLoads.Trucktypes_list[i].id));
            }
          }
        }
      }
    }

    /* After get truck info, it sets them in locak vars */
    vm.setDataToForm = function() {
      vm.dataUpdateTrailer.trailer_type = (angular.isDefined(vm.trailerData.trailer_type_id)) ? vm.trailerData.trailer_type_id.toString() : null;
      vm.dataUpdateTrailer.length = (angular.isDefined(vm.trailerData.loadlength_id)) ? vm.trailerData.loadlength_id.toString() : null;
      vm.dataUpdateTrailer.plate = (angular.isDefined(vm.trailerData.placa)) ? vm.trailerData.placa : null;
      vm.dataUpdateTrailer.location = (angular.isDefined(vm.trailerData.ubicacion)) ? vm.trailerData.ubicacion : null;
      vm.dataUpdateTrailer.status = (angular.isDefined(vm.trailerData.estatus)) ? parseInt(vm.trailerData.estatus) : null;
      vm.dataUpdateTrailer.truck_id = (angular.isDefined(vm.trailerData.trucks_id)) ? vm.trailerData.trucks_id.toString() : null;
      console.log(vm.dataUpdateTrailer);
    };

    /* Validate and send form data to API */
    vm.save = function(postTrailerFormName) {
      vm.savingTrailer = true;
      // Validate form.
      if (postTrailerFormName.$invalid) {
          // If there was an error for required fields.
          if (postTrailerFormName.$error.required) {
              toastr.error($filter('translate')('loads:add:form:required:fields:error'));
          } else {
              toastr.error($filter('translate')('loads:add:form:required:fields:invalid'));
          }
          vm.savingTrailer = false;
          return;
      }

      Trailers.updateTrailer(vm.dataUpdateTrailer)
            .then(function(response) {
                // Success
                toastr.success($filter('translate')('trailers:edit:form:success'));
                vm.getDataTrailer();
                vm.savingTrailer = false;
            })
            .catch(function(error) {
                // Error
                if(error === 'duplicate_trailer_box'){
                  toastr.error($filter('translate')('trailers:add:form:duplicate_trailer'));
                }else if(error === 'trailer_box_invalid'){
                  toastr.error($filter('translate')('trailers:add:form:trailer_box_invalid'));
                }else{
                  toastr.error($filter('translate')('trailers:add:form:internal_error'));
                }
                // Loading
                vm.savingTrailer = false;
            });

    };

    /* Set return list var and send form data to API */
    vm.submitReturnListFunc = function(postTrailerFormName) {
      vm.submitReturnList = true;
      vm.save(postTrailerFormName);
    };

    vm.initialize();
  }
})();

(function() {
  'use strict';

  /* Trailers controller
   * Set filter options
   * Get trailers list
   * Show trailer details in dropdown
   */

  angular
    .module('loadsAppWeb')
    .controller('TrailersController', TrailersController);

  /** @ngInject */
  function TrailersController($state, $stateParams, toastr, $filter, Config, Trailers, Auth, DatatableTool, DTOptionsBuilder, DTColumnBuilder, $sce, $uibModal) {
	  var vm = this;

    /* Function executed at strart, set filters and get trucks list  */
    vm.initialize = function() {
      vm.profile = Auth.getUserProfile();

      vm.trailerOptions = {
        'token': Auth.getUserToken(),
        'page': 1,
        'plate': '',
        'trailer_id': ''
      };
      vm.trailersList = [];
      vm.loadingTrailerData = true;
      vm.initializedList = false;

      if($stateParams.trailer_id){
        vm.trailerOptions.trailer_id = $stateParams.trailer_id;
      }

      vm.loadTab();  
    };

    /* Load table first time or reload it  */
    vm.loadTab = function() {
      if (vm.initializedList) {
        vm.reloadList();
      } else {
        vm.initializeList();
      }
    };

    vm.setTrailerPlateFilter = function() {
      vm.loadingTrailerData = true;
      vm.trailerOptions.page = 1;
      vm.trailerOptions.trailer_id = '';

      vm.loadTab();
    };

    /* Get trailers list and set datatable  */
    vm.initializeList = function() {
      DatatableTool.setLimit(20);
      vm.datatableOptions = DTOptionsBuilder.newOptions()
                            .withOption('ajax', function(data, callback, settings){
                              // Page
                              vm.trailerOptions.page = DatatableTool.getPage(data);
                              console.log(vm.trailerOptions.page);

                              Trailers.trailersForCarrier(vm.trailerOptions)
                                .then(function(response){
                                  var records = DatatableTool.getRecordsTrailers(response);

                                  // Info
                                  if (!angular.isUndefined(records.data)) {
                                      _.forEach(records.data, function(value, key) {

                                          value.trailer_full_name = "Trailer "+$filter('translate')('trailers:add:form:plate')+": "+value.placa;
                                          value.truck_full_name = "";
                                          if(value.trucks_id != null){
                                            value.truck_full_name = $filter('translate')('trucks:details:company_id_unity:title')+": ";
                                            if(value.truck != null){
                                              if(value.truck.company_id_unity != null){
                                                value.truck_full_name += value.truck.company_id_unity;
                                              }else{
                                                value.truck_full_name += 'Sin ID';
                                              }

                                              value.truck_full_name += " - "+value.truck.brand + " " + value.truck.model;
                                            }else{
                                              value.truck_full_name += '';
                                            }
                                          }

                                          value.trailer_status = '';
                                          var bgColorBtn = ''
                                          , colorBtn = '';

                                          switch(value.estatus){
                                            case '1':
                                              bgColorBtn = 'bg-color-9';
                                              colorBtn = 'color-black';
                                              break;
                                            case '0':
                                              bgColorBtn = 'bg-color-7';
                                              colorBtn = 'color-armadillo';
                                              break;
                                          }

                                          value.trailer_status = $sce.trustAsHtml('<button class="btn btn-class2 '+bgColorBtn+' '+colorBtn+'">'+$filter('translate')('trucks:table:status:' +value.estatus+ ':text')+'</button>');

                                          value.actions = '<i ng-click="trucks.showDetailsUnique('+value.idtrailer_box+')" class="fa fa-angle-down show-load-details-btn"></i>';
                                      });
                                  }
                                  vm.trailersList = records.data;
                                  records.data = [{trailer_full_name: '', trailer_status: '', actions: ''}];
                                  callback(records);
                                })
                                .catch(function (error) {
                                  vm.trailersList = [];
                                  callback(DatatableTool.getRecords(null));
                                });
                            })
                            .withDataProp('data')
                            .withOption('processing', true)
                            .withOption('serverSide', true)
                            .withOption('searching', false)
                            .withOption('info', false)
                            .withOption('lengthChange', false)
                            .withOption('pageLength', DatatableTool.getLimit(null))
                            .withOption('responsive', true)
                            .withLanguage(DatatableTool.getDefaultLanguageSettings())
                            .withPaginationType('numbers');
      switch(vm.profile){
        case 'CARRIER':
        case 'OWNER':
          vm.dtColumns = [
            DTColumnBuilder.newColumn('trailer_full_name').withTitle(''),
            DTColumnBuilder.newColumn('trailer_status').withTitle(''),
            DTColumnBuilder.newColumn('actions').withTitle('')
          ];
          break;
      }

      vm.loadingTrailerData = false;
      vm.initializedList = true;
    };

    /* Reload data table  */
    vm.reloadList = function() {
        // Reload datatables
        DatatableTool.reload();
    };

    vm.openUploadTrailersModal = function() {
      var modalInstance = $uibModal.open({
        controller: 'TrailersUploadModalController as trailersupload',
        windowClass: 'trailers-upload-modal',
        templateUrl: 'app/trailers/templates/modal/trailers-upload.html',
        resolve: {
            token: function() {
                return Auth.getUserToken();
            },
            uploadMethod: function() {
                return 'POST'
            }
        }
      });

      modalInstance.result.then(function() {
        vm.loadingTrailerData = true;
        vm.trailerOptions.page = 1;
        vm.trailerOptions.trailer_id = '';

        vm.loadTab();
      });
    };

    vm.openUploadTrailersUpdateModal = function() {
      var modalInstance2 = $uibModal.open({
        controller: 'TrailersUploadModalController as trailersupload',
        windowClass: 'trailers-upload-modal',
        templateUrl: 'app/trailers/templates/modal/trailers-upload.html',
        resolve: {
            token: function() {
                return Auth.getUserToken();
            },
            uploadMethod: function() {
                return 'PUT'
            }
        }
      });

      modalInstance2.result.then(function() {
          vm.loadingTrailerData = true;
          vm.trailerOptions.page = 1;
          vm.trailerOptions.trailer_id = '';

          vm.loadTab();
      });
    };

    /* Show Truck details in drop down tab */
    vm.showDetailsUnique = function(trailer_id) {
      for(var i in vm.trailersList){
        if(vm.trailersList[i].idtrailer_box == trailer_id){
          vm.trailersList[i].expanded = !vm.trailersList[i].expanded;
        }else{
          vm.trailersList[i].expanded = false;
        }
      }
    };


    vm.initialize();
  }
})();
(function() {
  'use strict';

  /* Trailer creation controller
   * Validate and submit form data*/

  angular
    .module('loadsAppWeb')
    .controller('TrailersAddController', TrailersAddController);

  /** @ngInject */
  function TrailersAddController($state, toastr, $filter, Config, Trailers, Loads, Trucks, Carriers, Auth, DatatableTool, $q) {
	  var vm = this;

    /* Function executed at strart, set form vars and get drivers list and other truck params  */
	  vm.initialize = function() {
      vm.submitReturnList = false;

      vm.dataNewTrailer = {};
      vm.dataNewTrailer.token = Auth.getUserToken();
      vm.dataNewTrailer.trailer_type = null;
      vm.dataNewTrailer.length = null;
      vm.dataNewTrailer.plate = null;
      vm.dataNewTrailer.location = null;
      vm.dataNewTrailer.status = 0;
      vm.dataNewTrailer.truck_id = null;

      vm.showExtraRequired = false;

      vm.savingNewTrailer = false;

      vm.getItemsSizeLengthLoads();
      vm.getMyTrucks();

    };

    /* Get trucks list  */
    vm.getMyTrucks = function(){
      var params = {};
      params.token = Auth.getUserToken();
      params.page = 1;
      params.shortcut = "active";
      vm.myTrucksList = [];

      Trucks.trucksForCarrier(params)
        .then(function(response){
          if(response.truck_results){
            vm.myTrucksList = response.truck_results;
          }
        }); 

      for(var i in vm.myTrucksList){
        if(vm.myTrucksList[i].company_id_unity == null){
          vm.myTrucksList[i].company_id_unity_select = '';
        }else{
          vm.myTrucksList[i].company_id_unity_select = vm.myTrucksList[i].company_id_unity;
        }
      }     
    };

    /* Get truck skills list, availabilities and brands  */
    vm.getItemsSizeLengthLoads = function() {
      vm.itemsSizeLenLoads = {};
      Loads.getItemsSizeLengthLoads()
        .then(function(response){
          if(response){
            vm.itemsSizeLenLoads = response;
            if(angular.isDefined(vm.itemsSizeLenLoads.LoadsLength_list)){
              vm.setLoadsLength();
            }

            if(angular.isDefined(vm.itemsSizeLenLoads.TrailerType)){
              vm.setTrailerTypes();
            }
          }
        }); 
    };

    vm.setTrailerTypes = function() {
      vm.trailerTypesList = [];
      if(vm.itemsSizeLenLoads.TrailerType.length){
        for(var i in vm.itemsSizeLenLoads.TrailerType){
          vm.trailerTypesList.push({id: vm.itemsSizeLenLoads.TrailerType[i].id, name: vm.itemsSizeLenLoads.TrailerType[i].trailer_type_name, checked: false});
        }
      }
    };

    vm.setLoadsLength = function() {
      vm.loadsLengthList = [];
      if(vm.itemsSizeLenLoads.LoadsLength_list.length){
        for(var i in vm.itemsSizeLenLoads.LoadsLength_list){
          if(vm.itemsSizeLenLoads.LoadsLength_list[i].type_length == "s"){
            vm.loadsLengthList.push({id: vm.itemsSizeLenLoads.LoadsLength_list[i].id, name: vm.itemsSizeLenLoads.LoadsLength_list[i].name, checked: false});
          }
        }
      }
    };

    /* Validate and send form data to API */
    vm.save = function(postTrailerFormName) {
      vm.savingNewTrailer = true;
      vm.showExtraRequired = false;
      // Validate form.
      if (postTrailerFormName.$invalid) {
          // If there was an error for required fields.
          if (postTrailerFormName.$error.required) {
              toastr.error($filter('translate')('loads:add:form:required:fields:error'));
          } else {
              toastr.error($filter('translate')('loads:add:form:required:fields:invalid'));
          }
          vm.savingNewTrailer = false;
          return;
      }

      Trailers.createTrailer(vm.dataNewTrailer)
            .then(function(response) {
                // Success
                console.log(response);
                toastr.success($filter('translate')('trailers:add:form:success'));
                if(vm.submitReturnList){
                  $state.go('private.trailers');
                }else{
                  vm.initialize();
                }
                vm.savingNewTrailer = false;
            })
            .catch(function(error) {
                // Error
                if(error === 'duplicate_trailer_box'){
                  toastr.error($filter('translate')('trailers:add:form:duplicate_trailer'));
                }else{
                  toastr.error($filter('translate')('trailers:add:form:internal_error'));
                }
                // Loading
                vm.savingNewTrailer = false;
            });

    };

    /* Set return list var and send form data to API */
    vm.submitReturnListFunc = function(postTrailerFormName) {
      vm.submitReturnList = true;
      vm.save(postTrailerFormName);
    };

    vm.initialize();
  }
})();

angular.module('loadsAppWeb').service('DocumentService',[
  "$q",
  "$http",
  "Config",
  "Upload",
  function ($q,http,Config,Upload) {

    function DocumentService() {};

    DocumentService.prototype.create = function (fields) {
      let api = 'api/documents/insert';
      return http.post(api, fields);
    };

    DocumentService.prototype.update = function (resource,resource_id,document_id,fields) {
      let api = Config.ENV.API_ENDPOINT +'v1/' + resource +'/'+ resource_id +'/documents/' + document_id;
      return http.put(api, fields);
    };

    DocumentService.prototype.display = function (resource, resource_id) {
      let api = Config.ENV.API_ENDPOINT +'v1/' + resource +'/'+ resource_id +'/requirements';
      return http.get(api, null);
    };

    DocumentService.prototype.upload = function (resource,resource_id,fields) {
      let api = Config.ENV.API_ENDPOINT +'v1/' + resource +'/'+ resource_id +'/documents';
      return http({
        method: 'POST',
        url: api,
        headers: {'Content-Type': undefined },
        data: fields,
      });
    };

    DocumentService.prototype.destroy = function (resource,resource_id,document_id,file_id) {
      let api = Config.ENV.API_ENDPOINT +'v1/' + resource +'/'+ resource_id +'/documents/' + document_id + '/files/' + file_id;
      return http.delete(api, null);
    };

    DocumentService.prototype.show = function (id) {
      let api = 'api/document/' + id + '/show';
      return http.get(api, null);
    };

    DocumentService.prototype.sendReview = function (resource,resource_id) {
      let api = Config.ENV.API_ENDPOINT +'v1/' + resource +'/'+ resource_id +'/documents/review';
      return http.post(api, null);
    };

    return new DocumentService();

  }]);

(function() {
  'use strict';

  /* Profile controller
   * Get user data
   * If user is carrier, it'll get trucks info
   * Open profile edition modal
   * Change pic profile*/
  angular.module('loadsAppWeb').controller('ProfileController', ProfileController);
  /** @ngInject */
  function ProfileController(
    toastr,
    $filter,
    Config,
    Trucks,
    DocumentService,
    DatatableTool,
    $q,
    Auth,
    uiGmapGoogleMapApi,
    DTOptionsBuilder,
    DTColumnBuilder,
    $sce,
    $uibModal,
    $window,
    $scope
  ) {
	var vm = this;

    /* Function executed at strart, set vars and get trucks info  */
	  vm.initialize = function() {
      vm.profileText = Auth.getUserProfile();
      vm.profile = (Auth.getUserProfile() == 'GENERADOR_CARGA')
        ? 'shippers'
        : (Auth.getUserProfile() == 'OWNER') ? 'carriers': Auth.getUserProfile()+'s';
      vm.myProfileData = Auth.getUserData();
      vm.specificProfileData = Auth.getUserDataProfile();
      vm.infoCompany = Auth.getUserInfoCompany();
      vm.countTrucks = 0;
      vm.infoTruck = false;
      vm.fileSaving = false;

      if(vm.profileText == 'CARRIER' || vm.profileText == 'OWNER'){
        vm.getCountTrucks();
      }/*else if(vm.profileText == 'DRIVER'){
        vm.getInfoTruck();
      }*/

      vm.infoCompanyFinal = {};
      vm.infoCompanyFinal.mc_number = "---";
      vm.infoCompanyFinal.dot_number = "---";
      vm.infoCompanyFinal.corp_number = "---";
      vm.infoCompanyFinal.ein_number = "---";
      vm.infoCompanyFinal.address_company = "---";
      vm.infoCompanyFinal.city_company = "---";
      vm.infoCompanyFinal.state_company = "---";
      vm.infoCompanyFinal.country_company = "---";
      vm.infoCompanyFinal.phone_company = "---";
      vm.infoCompanyFinal.email_company = "---";
      vm.infoCompanyFinal.company_name = "---";
      if(vm.infoCompany){
        if(angular.isDefined(vm.infoCompany.mc_number)){vm.infoCompanyFinal.mc_number = vm.infoCompany.mc_number;}
        if(angular.isDefined(vm.infoCompany.dot_number)){vm.infoCompanyFinal.dot_number = vm.infoCompany.dot_number;}
        if(angular.isDefined(vm.infoCompany.corp_number)){vm.infoCompanyFinal.corp_number = vm.infoCompany.corp_number;}
        if(angular.isDefined(vm.infoCompany.ein_number)){vm.infoCompanyFinal.ein_number = vm.infoCompany.ein_number;}
        if(angular.isDefined(vm.infoCompany.address_company)){vm.infoCompanyFinal.address_company = vm.infoCompany.address_company;}
        if(angular.isDefined(vm.infoCompany.city_company)){vm.infoCompanyFinal.city_company = vm.infoCompany.city_company;}
        if(angular.isDefined(vm.infoCompany.state_company)){vm.infoCompanyFinal.state_company = vm.infoCompany.state_company;}
        if(angular.isDefined(vm.infoCompany.country_company)){vm.infoCompanyFinal.country_company = vm.infoCompany.country_company;}else if(angular.isDefined(vm.myProfileData.user_contry)){vm.infoCompanyFinal.country_company = vm.myProfileData.user_contry;}
        if(angular.isDefined(vm.infoCompany.phone_company)){vm.infoCompanyFinal.phone_company = vm.infoCompany.phone_company;}
        if(angular.isDefined(vm.infoCompany.email_company)){vm.infoCompanyFinal.email_company = vm.infoCompany.email_company;}
        if(angular.isDefined(vm.infoCompany.company_name)){vm.infoCompanyFinal.company_name = vm.infoCompany.company_name;}
      }else{
        if(angular.isDefined(vm.specificProfileData.mc_number)){vm.infoCompanyFinal.mc_number = vm.specificProfileData.mc_number;}
        if(angular.isDefined(vm.specificProfileData.dot_number)){vm.infoCompanyFinal.dot_number = vm.specificProfileData.dot_number;}
        if(angular.isDefined(vm.specificProfileData.corp_number)){vm.infoCompanyFinal.corp_number = vm.specificProfileData.corp_number;}
        if(angular.isDefined(vm.specificProfileData.ein_number)){vm.infoCompanyFinal.ein_number = vm.specificProfileData.ein_number;}
        if(angular.isDefined(vm.specificProfileData.address_company)){vm.infoCompanyFinal.address_company = vm.specificProfileData.address_company;}
        if(angular.isDefined(vm.specificProfileData.city_company)){vm.infoCompanyFinal.city_company = vm.specificProfileData.city_company;}
        if(angular.isDefined(vm.specificProfileData.state_company)){vm.infoCompanyFinal.state_company = vm.specificProfileData.state_company;}
        if(angular.isDefined(vm.specificProfileData.country_company)){vm.infoCompanyFinal.country_company = vm.specificProfileData.country_company;}
        if(angular.isDefined(vm.specificProfileData.phone_company)){vm.infoCompanyFinal.phone_company = vm.specificProfileData.phone_company;}
        if(angular.isDefined(vm.specificProfileData.email_company)){vm.infoCompanyFinal.email_company = vm.specificProfileData.email_company;}
        if(angular.isDefined(vm.specificProfileData.company_name)){vm.infoCompanyFinal.company_name = vm.specificProfileData.company_name;}
      }
      vm.getDocuments();
      vm.getInfoUser();
      vm.user = {
        profile: vm.profile.toLowerCase(),
        user_id : vm.myProfileData.id
      };
    };
	  vm.getInfoUser = function (){
	      Auth.getInfoUser().then(function (resp){
          vm.data = resp.data.userData;
        });
    }
    vm.isSet = function (tabNum){
      return vm.tab === tabNum;
    }
    vm.setTab = function (newTab){
        vm.tab = newTab;
    }
    vm.getDocuments = function (){
        DocumentService.display(vm.profile.toLowerCase(),vm.myProfileData.id).then(function (resp){
            if(resp.status === 200){
              vm.documents = resp.data.results;
              let tabSetter = (vm.documents.length > 0)? 2 : 1;
              vm.isSet(tabSetter);
              vm.setTab(tabSetter);
            }
        });
    }
    /* Get trucks count if user is carrier */
    vm.getCountTrucks = function() {
      var params = {};
      params.token = Auth.getUserToken();

      Trucks.countTrucksxCarrier(params)
        .then(function(response){
          if(angular.isDefined(response.truck_total_results)){
            vm.countTrucks = response.truck_total_results;
          }
        }).catch(function(error){

        });
    };
    /*vm.getInfoTruck = function() {

    };*/
    /* Open profile edition modal */
    vm.openEditProfileModal = function() {
      var modalInstance = $uibModal.open({
        controller: 'EditProfileModalController as editprofile',
        windowClass: 'edit-profile-modal',
        templateUrl: 'app/profile/templates/modal/edit.html',
        resolve: {
            mainData: function() {
                return vm.myProfileData;
            },
            specificData: function() {
                return vm.specificProfileData;
            },
            infoCompany: function() {
                return vm.infoCompany;
            }
        }
      });

      modalInstance.result.then(function(data) {
        $window.location.reload();
      });
    };
    /* Change profile pic */
    vm.uploadImgProfile = function(file, invalidFiles) {
      if (file) {
        // Loading
        vm.fileSaving = true;

        // Upload
        var params = {
            token: Auth.getUserToken(),
            pic: file
        };
        Auth.uploadMyPic(params)
            .then(function(response) {
                // Success
                if(angular.isDefined(response.Imagen_user)){
                  var arr_img = angular.fromJson(response.Imagen_user)
                  , test = angular.copy(vm.myProfileData.img_perfil_imagenes[0]);
                  angular.extend(vm.myProfileData.img_perfil_imagenes[0], arr_img);

                }
                toastr.success($filter('translate')('loads:edit:invoice:upload:successfully'));

                // Loading
                vm.fileSaving = false;
            })
            .catch(function(error) {
                // Loading
                vm.fileSaving = false;

                // Message.
                toastr.error($filter('translate')('profile:pic:upload:error'));
            });
    }
    };
    vm.initialize();
  }
})();

(function() {
  'use strict';

  /* Profile edition modal controller
   * Get user data
   * Set form var with user info
   * Validate and send form to API to update profile
   * Validate form by steps*/

  angular
    .module('loadsAppWeb')
    .controller('EditProfileModalController', EditProfileModalController);

  /** @ngInject */
  function EditProfileModalController($state, mainData, specificData, infoCompany, Auth, Trucks, $uibModalInstance, DatatableTool, $q, toastr, $filter) {
	  var vm = this;

    /* Function executed at strart, get user data and set form vars  */
    vm.initialize = function() {
      vm.mainData = mainData;
      vm.specificData = specificData;
      vm.infoCompany = infoCompany;
      vm.profileEdit = null;
      if(angular.isDefined(vm.mainData.user_profile)){
        if(angular.isDefined(vm.mainData.user_profile[0])){
          vm.profileEdit = vm.mainData.user_profile[0].profile_name;
        }
      }

      vm.formsToValidate = [{form: 'basic_info', validated: false, subtitle: ''},
                {form: 'company_info', validated: false, subtitle: '2'}];
      vm.validateForm = vm.formsToValidate[0].form;
      vm.validateFormIndex = 0;
      vm.subtitleForm = vm.formsToValidate[0].subtitle;

      vm.dataUser = {};
      vm.dataUser.token = Auth.getUserToken();

      //contact information
      vm.dataUser.user_first_name = (angular.isDefined(vm.mainData.user_first_name)) ? vm.mainData.user_first_name : null;
      vm.dataUser.user_last_name = (angular.isDefined(vm.mainData.user_last_name)) ? vm.mainData.user_last_name : null;
      vm.dataUser.document_type = (angular.isDefined(vm.mainData.document_type)) ? vm.mainData.document_type : null;
      vm.dataUser.document_number = (angular.isDefined(vm.mainData.document_number)) ? vm.mainData.document_number : null;
      vm.dataUser.user_phone = (angular.isDefined(vm.mainData.user_phone)) ? vm.mainData.user_phone : null;
      vm.dataUser.user_email = (angular.isDefined(vm.mainData.user_email)) ? vm.mainData.user_email : null;
      vm.dataUser.user_new_password = null;

      //company information
      if(vm.infoCompany){
        vm.dataUser.company_name = (angular.isDefined(vm.infoCompany.company_name)) ? vm.infoCompany.company_name : null;
        vm.dataUser.city_company = (angular.isDefined(vm.infoCompany.city_company)) ? vm.infoCompany.city_company : null;
        vm.dataUser.state_company = (angular.isDefined(vm.infoCompany.state_company)) ? vm.infoCompany.state_company : null;
        vm.dataUser.country_company = (angular.isDefined(vm.infoCompany.country_company)) ? vm.infoCompany.country_company : null;
        vm.dataUser.phone_company = (angular.isDefined(vm.infoCompany.phone_company)) ? vm.infoCompany.phone_company : null;
        vm.dataUser.email_company = (angular.isDefined(vm.infoCompany.email_company)) ? vm.infoCompany.email_company : null;
        vm.dataUser.address_company = (angular.isDefined(vm.infoCompany.address_company)) ? vm.infoCompany.address_company : null;
        vm.dataUser.mc_number = (angular.isDefined(vm.infoCompany.mc_number)) ? vm.infoCompany.mc_number : null;
        vm.dataUser.dot_number = (angular.isDefined(vm.infoCompany.dot_number)) ? vm.infoCompany.dot_number : null;
        vm.dataUser.user_ein_ssn = (angular.isDefined(vm.specificData.ein_number)) ? vm.specificData.ein_number : null;
        vm.dataUser.corp_number = (angular.isDefined(vm.mainData.corp_number)) ? vm.mainData.corp_number : null;
      }else{
        vm.dataUser.company_name = (angular.isDefined(vm.specificData.company_name)) ? vm.specificData.company_name : null;
        vm.dataUser.city_company = (angular.isDefined(vm.specificData.city_company)) ? vm.specificData.city_company : null;
        vm.dataUser.state_company = (angular.isDefined(vm.specificData.state_company)) ? vm.specificData.state_company : null;
        vm.dataUser.country_company = (angular.isDefined(vm.specificData.country_company)) ? vm.specificData.country_company : null;
        vm.dataUser.phone_company = (angular.isDefined(vm.specificData.phone_company)) ? vm.specificData.phone_company : null;
        vm.dataUser.email_company = (angular.isDefined(vm.specificData.email_company)) ? vm.specificData.email_company : null;
        vm.dataUser.address_company = (angular.isDefined(vm.specificData.address_company)) ? vm.specificData.address_company : null;
        vm.dataUser.mc_number = (angular.isDefined(vm.specificData.mc_number)) ? vm.specificData.mc_number : null;
        vm.dataUser.dot_number = (angular.isDefined(vm.specificData.dot_number)) ? vm.specificData.dot_number : null;
        vm.dataUser.user_ein_ssn = (angular.isDefined(vm.specificData.ein_number)) ? vm.specificData.ein_number : null;
        vm.dataUser.corp_number = (angular.isDefined(vm.mainData.corp_number)) ? vm.mainData.corp_number : null;
      }

      //insurance information
      vm.dataUser.bond_insurance_num_policy = (angular.isDefined(vm.specificData.bond_insurance_policy_num)) ? vm.specificData.bond_insurance_policy_num : null;
      vm.dataUser.bond_insurance_comp = (angular.isDefined(vm.specificData.bond_insurance_comp)) ? vm.specificData.bond_insurance_comp : null;
      vm.dataUser.bond_insurance_num = (angular.isDefined(vm.mainData.bond_insurance_num)) ? vm.mainData.bond_insurance_num : null;
      vm.dataUser.name_bank = (angular.isDefined(vm.mainData.name_bank)) ? vm.mainData.name_bank : null;
      vm.dataUser.number_account_bank = (angular.isDefined(vm.mainData.number_account_bank)) ? vm.mainData.number_account_bank : null;

      vm.companyCitySelect = (angular.isDefined(vm.specificData.city_company)) ? vm.specificData.city_company : null;
      vm.companyStateSelect = (angular.isDefined(vm.specificData.state_company)) ? vm.specificData.state_company : null;
      vm.companyCountrySelect = (angular.isDefined(vm.specificData.country_company)) ? vm.specificData.country_company : null;

      vm.shipperDocTypeOptions = [
                             {id: null, name: $filter('translate')('form:default:select:null_option')},
                             {id: 'rfc', name: $filter('translate')('sign_up:form:document_number:rfc')}
                            ];

      vm.notShipperDocTypeOptions = [
                             {id: null, name: $filter('translate')('form:default:select:null_option')},
                             {id: 'nit', name: $filter('translate')('sign_up:form:document_number:nit')},
                             {id: 'ps', name: $filter('translate')('sign_up:form:document_number:passport')},
                             {id: 'ce', name: $filter('translate')('sign_up:form:document_number:ce')},
                             {id: 'nuip', name: $filter('translate')('sign_up:form:document_number:nuip')}
                            ];
    };

    /* close modal */
    vm.closePopup = function(data_return) {
        $uibModalInstance.close(data_return);
    };

    /* Validate form by steps and update profile  */
    vm.validateEdit = function(userForm) {
    // Validate form.
        if (userForm.$invalid) {
            // If there was an error for required fields.
            if (userForm.$error.required) {
                toastr.error($filter('translate')('sign_up:form:required:fields:error'));
            } else {
                toastr.error($filter('translate')('sign_up:form:required:fields:invalid'));
            }
            return;
        }

        if(userForm.$name == 'signupFormName2'){
            if(vm.profileEdit == 'CARRIER' || vm.profileEdit == 'OWNER'){
                if(!vm.dataUser.mc_number && !vm.dataUser.dot_number){
                    toastr.error($filter('translate')('sign_up:form:required:fields:error'));
                    return;
                }

                if(!vm.dataUser.ein_number && !vm.dataUser.corp_number){
                    toastr.error($filter('translate')('sign_up:form:required:fields:error'));
                    return;
                }
            }
        }

        if(userForm.$name == 'signupFormName3'){
            if(vm.profileEdit == 'CARRIER' || vm.profileEdit == 'OWNER'){
                if(!vm.dataUser.bond_insurance_num_policy || !vm.dataUser.bond_insurance_comp || !vm.dataUser.bond_insurance_num){
                    toastr.error($filter('translate')('sign_up:form:required:fields:error'));
                    return;
                }
            }
        }

        vm.formsToValidate[vm.validateFormIndex].validated = true;

        var moreValidateForm = true
        , indexform = 0;


        while(moreValidateForm){
          if(indexform <= vm.validateFormIndex){
            indexform++;
          }else{
            if(angular.isDefined(vm.formsToValidate[indexform])){
              if(vm.profileEdit == 'GENERADOR_CARGA' && indexform == 2){
                  vm.updateProfile();
              }else{
                vm.validateForm = vm.formsToValidate[indexform].form;
                vm.validateFormIndex = indexform;
                vm.subtitleForm = vm.formsToValidate[indexform].subtitle;
              }
            }else{
              vm.updateProfile();
            }
            moreValidateForm = false;
          }
        }
  };

  /* Send data to API and show response  */
  vm.updateProfile = function() {
    var user_new_password = vm.dataUser.user_new_password;
    if(vm.dataUser.user_new_password != null && vm.dataUseruser_new_password != ''){
      vm.dataUser.user_password = CryptoJS.SHA1(vm.dataUser.user_new_password.toString()).toString();
      delete vm.dataUser.user_new_password;
    }

    if(vm.profileEdit != 'GENERADOR_CARGA'){
      if(typeof vm.companyCitySelect != typeof vm.dataUser.city_company){
        vm.dataUser.city_company = (angular.isDefined(vm.companyCitySelect.name) ? vm.companyCitySelect.name : vm.companyCitySelect.formatted_address);
      }

      if(typeof vm.companyStateSelect != typeof vm.dataUser.state_company){
        vm.dataUser.state_company = (angular.isDefined(vm.companyStateSelect.name) ? vm.companyStateSelect.name : vm.companyStateSelect.formatted_address);
      }

      if(typeof vm.companyCountrySelect != typeof vm.dataUser.country_company){
        vm.dataUser.country_company = (angular.isDefined(vm.companyCountrySelect.name) ? vm.companyCountrySelect.name : vm.companyCountrySelect.formatted_address);
      }
    }

    Auth.updateProfile(vm.dataUser)
        .then(function(response) {
          if(angular.isDefined(response.status) && response.status != 'error'){
                toastr.success($filter('translate')('profile:edit:success'));
                vm.closePopup(vm.dataUser);
            }else{
              vm.dataUser.user_new_password = user_new_password;

              if(response.message == "user_exist"){
                toastr.error($filter('translate')('sign_up:form:error:user_exists'));
              }else{
                toastr.error($filter('translate')('profile:edit:error'));
              }
            }
        })
        .catch(function(error) {
            vm.dataUser.user_new_password = user_new_password;
            toastr.error($filter('translate')('profile:edit:error'));
        });
  };

  /* Come back in each step of the form  */
  vm.comeBackForm = function () {
      if(vm.validateFormIndex > 0){
          if(angular.isDefined(vm.formsToValidate[vm.validateFormIndex - 1])){
              vm.validateFormIndex = vm.validateFormIndex - 1;
              vm.validateForm = vm.formsToValidate[vm.validateFormIndex].form;
              vm.subtitleForm = vm.formsToValidate[vm.validateFormIndex].subtitle;
          }
      }
  };

    vm.initialize();

  }
})();

angular.module('loadsAppWeb').directive('uploadDocument', uploadDocument);

function uploadDocument(sweetAlert, swangular, DocumentService, toastr, $filter, Auth){
  return {
    templateUrl: "app/profile/templates/tabs/tab-document.html",
    restrict: 'E',
    scope:{
      data:"="
    },
    controller : function ($scope){
      $scope.construct = function (){
          this.profile = $scope.data.profile;
          this.user_id = $scope.data.user_id;
          
          this.options = {
            singleDatePicker: true,
            showDropdowns: true,
            locale: {
              format: "YYYY-MM-DD",
              applyClass: 'btn-green',
              applyLabel: $filter('translate')('daterangepicker:btn:success:text'),
              fromLabel: $filter('translate')('daterangepicker:label:from'),
              toLabel: $filter('translate')('daterangepicker:label:to'),
              cancelLabel: $filter('translate')('daterangepicker:btn:cancel:text'),
              customRangeLabel: $filter('translate')('daterangepicker:title:text'),
              firstDay: 1
            }
          };
          this.today = new Date().toISOString().slice(0, 10);
          $scope.getDocuments();
      }
      $scope.getDocuments = function (){
        DocumentService.display($scope.data.profile,$scope.data.user_id).then(function (resp){
          if(resp.status === 200){
            $scope.documents = []; $scope.files = []; $scope.requered = [];
            if (resp.data.results.length > 0){
              angular.forEach(resp.data.results, function (value){
                //var date = (value.document != null) ? new Date(value.document.expiration) : "";
                if (value.required == true) {
                  $scope.requered.push(value.required);
                }
                $scope.documents.push({
                  id          : value.id,
                  name        : value.name,
                  description : value.description,
                  format      : value.format,
                  required    : value.required,
                  template    : value.template,
                  editable    : value.editable,
                  comment     : (value.document != null) ? value.document.comment : null,
                  hide        : value.hide,
                  document_id : (value.document != null)? value.document.id : null,
                  expiration  : value.expiration,
                  expired     : (value.document != null)? value.document.expiration : "",
                  files       : $scope.getByDocument(value.document)
                });
              });
            }
          }
          $scope.getDataUser();
        });
      }
      $scope.getByDocument = function (fields){
        var files = [];
        if (fields != null && fields.files.length > 0){
          angular.forEach(fields.files,function (value){
            $scope.files.push(value);
            var ext = value.path.substr(-3,3);
            files.push({
              id          : value.id,
              document_id : fields.id,
              url         : value.path,
              filename    : value.filename,
              expiration  : fields.expiration,
              ext         : ext,
              status      : fields.status
            });
          });
        }
        return files;
      }
      $scope.removeImage = function (item, field){
        sweetAlert.swal({
          title: "¿Esta Seguro?",
          html: "¿Esta Seguro de Eliminar el Archivo?",
          type: "question",
          showCancelButton: true,
          showConfirmButton : true,
          buttonsStyling: true,
          confirmButtonColor: "#D4DD55",
          cancelButtonColor: "#d33",
          confirmButtonText: "Aceptar",
          cancelButtonText: "Cancelar",
          allowOutsideClick: false,
          closeOnConfirm: true,
          closeOnCancel: true,
        }).then(function(result) {
          if (angular.isDefined(result.value) && result.value) {

            DocumentService.destroy(
              $scope.data.profile,
              $scope.data.user_id,
              field.document_id,
              field.id
            ).then(function (resp){
              if (resp.status == 204 ){
                toastr.success($filter('translate')('profile:document:success'));
                $scope.getDocuments();
              }
            });

          }
        });
      }
      $scope.editImage = function (document){
        $scope.editDataDocument = {
          'document' : document
        }
        swangular.open({
          title: "¡Agregar fecha de expiración!",
          htmlTemplate: "app/profile/templates/form/form-edit-document.html",
          type: "info",
          scope: $scope,
          buttonsStyling: true,
          confirmButtonColor: "#D4DD55",
          cancelButtonColor: "#d33",
          showCancelButton: true,
          showConfirmButton: true,
          confirmButtonText: "Aceptar",
          cancelButtonText: "Cancelar",
          allowOutsideClick: false,
          closeOnConfirm: true,
          closeOnCancel: true,
          showLoaderOnConfirm: true,
          width: '500px',
        }).then(function(result) {
          if(angular.isDefined(result)) {
            if(result.value) {
              if (!$scope.editDataDocument.document.expired){
                return toastr.warning($filter('translate')('profile:document:message:warning'));
              }
              let dateExpired = new Date($scope.editDataDocument.document.expired).toISOString().slice(0, 10);
              let fields = {expiration : dateExpired};
              DocumentService.update(
                $scope.data.profile,
                $scope.data.user_id,
                $scope.editDataDocument.document.document_id ,
                fields
              ).then(function (resp){
                if (resp.status == 200){
                  toastr.success($filter('translate')('profile:document:edit:success'));
                  $scope.getDocuments();
                }
              });

            }
          }
        });
      }
      $scope.uploadDocument = function (file, document){
        var formData = new FormData();
        formData.append('file', file);
        formData.append('requirement_id', document.id);
        formData.append('device', document.name);
        /*I call the new Document service for uploader the file*/
        DocumentService.upload(
          $scope.data.profile,
          $scope.data.user_id,
          formData
        ).then(function (resp){
          if (resp.status == 200 || resp.status == 201){
            toastr.success($filter('translate')('profile:document:upload:success'));
            if (document.expiration){
              $scope.editImage({
                document_id : resp.data.id,
                expired     : resp.data.expiration
              });
            }
            $scope.getDocuments();
          }

        });
      }
      $scope.sendReview = function (){
        DocumentService.sendReview($scope.data.profile, $scope.data.user_id).then(function (resp){
          if (resp.data.status == "error"){
            return toastr.error($filter('translate')('profile:document:validate:error'));
          }
          $scope.getDocuments();
          return toastr.success($filter('translate')('profile:document:validate:success'));
        });
      };
      $scope.getDataUser = function (){
        Auth.getInfoUser().then(function (resp){
          $scope.user = resp.data.Info_perfil.dataUser;
        });
      }
      $scope.construct();

    }
  }
}

angular.module('loadsAppWeb').service('UploadService',[
  "$q",
  "$http",
  "Config",
  function ($q,http,Config) {

    function UploadService() {};

    UploadService.prototype.create = function (fields) {
      let api = 'api/documents/insert';
      return http.post(api, fields,this.headers);
    };
    UploadService.prototype.update = function (resource,resource_id,document_id,fields) {
      let api = Config.ENV.API_ENDPOINT +'v2/' + resource +'/'+ resource_id +'/metrics/' + document_id;
      return http.put(api, fields,this.headers);
    };
    UploadService.prototype.display = function () {
      let api = Config.ENV.API_ENDPOINT +'v1/metrics';
      return http.get(api,null);
    };
    UploadService.prototype.destroy = function (resource,resource_id,document_id,file_id) {
      let api = Config.ENV.API_ENDPOINT +'v2/' + resource +'/'+ resource_id +'/metrics/' + document_id + '/files/' + file_id;
      return http.delete(api, null,this.headers);
    };
    UploadService.prototype.upload = function (fields,name) {
      let api = Config.ENV.API_ENDPOINT +'v1/'+ name +'/import';
      return http({
        method: 'POST',
        url: api,
        headers: {'Content-Type': undefined },
        data: fields,
      });
    };
    UploadService.prototype.uploadFile = function (fields) {
      let api = Config.ENV.API_ENDPOINT +'v1/upload';
      return http({
        method: 'POST',
        url: api,
        headers: {'Content-Type': undefined },
        data: fields,
      });
    };

    return new UploadService();

  }]);

(function() {
  'use strict';

/* Notification services
 * Get notification list
 * Set new notifications as read
 * Save notification settings
 */

  angular
    .module('loadsAppWeb')
    .service('Notification', NotificationServices);

  /** @ngInject */
  function NotificationServices($q, $http, Config) {
	var vm = this;
	vm.api_endpoint = Config.ENV.API_ENDPOINT +'v1/' + 'notification/';

	vm.getNotifications = function(params)
	{
		// Defer
        var defer = $q.defer();
        // Url
        var url = vm.api_endpoint + 'userNotificationList';

        // Get
        $http.post(url, params)
            .then(function(response) {
                // Success
                if(response.data.status == 'ok' ){
                	defer.resolve(response.data.message);
                }else{
					defer.reject(false);
                }
            })
            .catch(function(response) {
                // Error

                defer.reject(false);
            });

        return defer.promise;
	};

  vm.setReadNotifications = function(params)
  {
    // Defer
        var defer = $q.defer();
        // Url
        var url = vm.api_endpoint + 'makeAsReadNotifications';

        // Get
        $http.post(url, params)
            .then(function(response) {
                // Success
                if(response.data.status == 'ok' ){
                  defer.resolve(response.data.message);
                }else{
          defer.reject(false);
                }
            })
            .catch(function(response) {
                // Error

                defer.reject(false);
            });

        return defer.promise;
  };

  vm.saveUserSettingsMessages = function(params)
  {
        var defer = $q.defer();
        // Url
        var url = Config.ENV.API_ENDPOINT +'v1/'+ 'user/user-settings-message';

        // Get
        $http.post(url, params)
            .then(function(response) {
                // Success
                defer.resolve(response.data);
            })
            .catch(function(response) {
                // Error

                defer.reject(false);
            });

        return defer.promise;
  };
  }
})();

(function() {
  'use strict';

/* Generic services
 * Set automatic assign in loads
 * Get nearby loafs or carriers from user location
 */

  angular
    .module('loadsAppWeb')
    .service('MainServ', MainServices);

  /** @ngInject */
  function MainServices($q, $http, Config) {
	var vm = this;
	vm.api_endpoint = Config.ENV.API_ENDPOINT +'v1/';

	vm.searchForLocation = function(params)
	{
		// Defer
        var defer = $q.defer();
        // Url
        var url = vm.api_endpoint + 'searchForLocation';

        // Get
        $http.post(url, params)
            .then(function(response) {
                // Success
                if(response.data.status == 'ok' ){
                	defer.resolve(response.data.message);
                }else{
					       defer.reject(false);
                }
            })
            .catch(function(response) {
                // Error

                defer.reject(false);
            });

        return defer.promise;
	};

  vm.setAutomaticLoadAssign =  function(params)
  {
    var defer = $q.defer();
        // Url
        var url = vm.api_endpoint + 'loads/setAutomaticLoad';

        // Get
        $http.post(url, params)
            .then(function(response) {
                // Success
               defer.resolve(response.data);
            })
            .catch(function(response) {
                // Error

                defer.reject(response);
            });

        return defer.promise;
  };

  }
})();

(function() {
  'use strict';

/* Help services (Get info from API)
 * Get Terms and conditions
 * Get Eula info
 * Get Privacy and Policy
 * Get FAQs
 */

  angular
    .module('loadsAppWeb')
    .service('HelpServ', HelpServices);

  /** @ngInject */
  function HelpServices($q, $http, Config) {
	var vm = this;
	//vm.api_endpoint = Config.ENV.STORAGE_ENDPOINT;
  vm.api_endpoint = Config.ENV.API_ENDPOINT +'v1/';

	vm.getTyC = function(language)
	{
    console.log(language);
		// Defer
        var defer = $q.defer();

        var url = vm.api_endpoint + 'viewDocument';
        var params = '';

        if(language){
          if(params != ''){
            params += "&";
          }
          params += "lang="+language;
        }

        if(params != ''){
          params += "&";
        }
        params += "file=tyc";

        if(params != ''){
          params += "&";
        }
        params += "type=html";

        if(params != ''){
          url = url + "?" + params;
        }

        // Get
        $http.get(url)
            .then(function(response) {
                // Success
                defer.resolve(response);
            })
            .catch(function(response) {
                // Error

                defer.reject(false);
            });

        return defer.promise;
	};

  vm.getEula = function(language)
  {
    // Defer
        var defer = $q.defer();
        // Url
        var url = vm.api_endpoint + 'viewDocument';
        var params = '';

        if(language){
          if(params != ''){
            params += "&";
          }
          params += "lang="+language;
        }

        if(params != ''){
          params += "&";
        }
        params += "file=eula";

        if(params != ''){
          params += "&";
        }
        params += "type=html";

        if(params != ''){
          url = url + "?" + params;
        }

        // Get
        $http.get(url)
            .then(function(response) {
                // Success
                defer.resolve(response);
            })
            .catch(function(response) {
                // Error

                defer.reject(false);
            });

        return defer.promise;
  };

  vm.getPrivacyPolicy = function(language)
  {
    // Defer
        var defer = $q.defer();
        // Url
        var url = vm.api_endpoint + 'viewDocument';
        var params = '';

        if(language){
          if(params != ''){
            params += "&";
          }
          params += "lang="+language;
        }

        if(params != ''){
          params += "&";
        }
        params += "file=privacy-policy";

        if(params != ''){
          params += "&";
        }
        params += "type=html";

        if(params != ''){
          url = url + "?" + params;
        }

        // Get
        $http.get(url)
            .then(function(response) {
                // Success
                defer.resolve(response);
            })
            .catch(function(response) {
                // Error

                defer.reject(false);
            });

        return defer.promise;
  };

  vm.getFaqs = function(language)
  {
    // Defer
        var defer = $q.defer();
        // Url
        var url = vm.api_endpoint + 'viewDocument';
        var params = '';

        if(language){
          if(params != ''){
            params += "&";
          }
          params += "lang="+language;
        }

        if(params != ''){
          params += "&";
        }
        params += "file=faq";

        if(params != ''){
          params += "&";
        }
        params += "type=html";

        if(params != ''){
          url = url + "?" + params;
        }

        // Get
        $http.get(url)
            .then(function(response) {
                // Success
                defer.resolve(response);
            })
            .catch(function(response) {
                // Error

                defer.reject(false);
            });

        return defer.promise;
  };
  }
})();

(function() {
  'use strict';

  /* Datatable services
   * Functions to build and to control rows and actions in data table */

  angular
    .module('loadsAppWeb')
    .service('DatatableTool', DatatableServices);

  /** @ngInject */
  function DatatableServices($q, $http, Config, $filter) {
	  var vm = this;

    vm.pageLength = 7;

  	vm.getDefaultSettings = function()
  	{
  		  var config = {
          searching: false,
          ordering: true,
          info: false,
          lengthChange: false
        };

        return config;
  	};

    vm.getDefaultLanguageSettings = function()
    {
      return {
        emptyTable: $filter('translate')('loads:list:empty:text'),
        processing: $filter('translate')('table:loading_data:text'),
        //processing: $compile('<loading-icon class="full-height full-height-absolute"></loading-icon>')($rootScope),
        paginate: {
          previous: $filter('translate')('table:pagination:prev:text'),
          next: $filter('translate')('table:pagination:next:text'),
          first: $filter('translate')('table:pagination:first:text'),
          last: $filter('translate')('table:pagination:last:text'),
        }
      };
    };

    vm.setLimit = function(data) {
      vm.pageLength = data;
    };

    vm.getLimit = function(data) {
      var limit = vm.pageLength;

      if (!angular.isUndefined(data) && data != null) {
          limit = data.length;
      }

      return limit;
    };

    /**
     * Returns the page for the tables
     * @param data
     */
    vm.getPage = function(data) {
        console.log(data);
        var page = 1;

        if (!angular.isUndefined(data)) {
            page = parseInt(data.start / vm.getLimit(data)) + 1;
        }

        return page;
    };

    vm.getRecords = function(data) {
        var records = {
            recordsTotal: 0,
            recordsFiltered: 0,
            data: []
        };

        if (data && !angular.isUndefined(data.total_results_system) && !angular.isUndefined(data.results)) {
            records.recordsTotal = data.total_results_system;
            records.recordsFiltered = data.total_results_system;
            records.data = data.results;
        }

        return records;
    };

    vm.getRecordsTrucks = function(data) {
        var records = {
            recordsTotal: 0,
            recordsFiltered: 0,
            data: []
        };

        if (data && !angular.isUndefined(data.truck_total_results) && !angular.isUndefined(data.truck_results)) {
            records.recordsTotal = data.truck_total_results;
            records.recordsFiltered = data.truck_total_results;
            records.data = data.truck_results;
        }

        return records;
    };

    vm.getRecordsTrailers = function(data) {
        var records = {
            recordsTotal: 0,
            recordsFiltered: 0,
            data: []
        };

        if (data && !angular.isUndefined(data.total) && !angular.isUndefined(data.result)) {
            records.recordsTotal = data.total;
            records.recordsFiltered = data.total;
            records.data = data.result;
        }

        return records;
    };

    vm.getRecordsDrivers = function(data) {
        var records = {
            recordsTotal: 0,
            recordsFiltered: 0,
            data: []
        };

        if (data && !angular.isUndefined(data.list_drivers) && !angular.isUndefined(data.total_pages)) {
            records.recordsTotal = vm.getLimit(null) * data.total_pages;
            records.recordsFiltered = vm.getLimit(null) * data.total_pages;
            records.data = data.list_drivers;
        }

        return records;
    };

    /**
     * Returns an instance for datatables.
     */
    vm.getInstance = function() {
        // Instance
        var instance = null;

        // Tables
        var tables = $.fn.dataTable.tables(true);
        if (angular.isArray(tables) && tables.length > 0) {
            instance = $(tables[0]).DataTable();
        }

        return instance;
    };

    /**
     * Reload the datatables
     */
    vm.reload = function() {
        var table = vm.getInstance();

        if (table) {
            var callback = null,
                resetPaging = true;
            table.ajax.reload(callback, resetPaging);
        }
    };
  }
})();

angular.module('loadsAppWeb').service('MetricService',[
  "$q",
  "$http",
  "Config",
  function ($q,http,Config) {

    function MetricService() {
      this.headers = {headers : {} };
      this.headers.headers["Authorization"] = 'Bearer ' + sessionStorage.getItem('_to');
    };

    MetricService.prototype.create = function (fields) {
      let api = 'api/documents/insert';
      return http.post(api, fields,this.headers);
    };
    MetricService.prototype.update = function (resource,resource_id,document_id,fields) {
      let api = Config.ENV.API_ENDPOINT +'v2/' + resource +'/'+ resource_id +'/metrics/' + document_id;
      return http.put(api, fields,this.headers);
    };
    MetricService.prototype.display = function () {
      let api = Config.ENV.API_ENDPOINT +'v1/metrics';
      return http.get(api,null);
    };
    MetricService.prototype.destroy = function (resource,resource_id,document_id,file_id) {
      let api = Config.ENV.API_ENDPOINT +'v2/' + resource +'/'+ resource_id +'/metrics/' + document_id + '/files/' + file_id;
      return http.delete(api, null,this.headers);
    };
    MetricService.prototype.show = function (fields) {
      const params = new URLSearchParams(fields);
      let api = Config.ENV.API_ENDPOINT +'v1/metrics?'+ params.toString();
      return http.get(api, null);
    };


    return new MetricService();

  }]);

(function() {
  'use strict';

  /* Capitalize function */

  angular
    .module('loadsAppWeb')
    .filter('capitalize', Capitalize);

  /** @ngInject */
  function Capitalize() {
    return function(input) {
        return (input) ? input.charAt(0).toUpperCase() + input.substr(1).toLowerCase() : '';
    }
  }
})();

(function() {
  'use strict';

  /* Loads counter module Directive
   * Module shows total ofa: current loads, loads pending to assign, posted loads, available trucks, all loads */

  angular
    .module('loadsAppWeb')
    .directive('totalItems', TotalItems);

  /** @ngInject */
  function TotalItems($rootScope, Loads, Auth) {
    return {
        templateUrl: 'app/main/templates/directives/total-items.html',
        restrict: 'E',
        replace: true,
        scope: {},
        link: function(scope) {
            /**
             * Initialize
             */
            scope.initialize = function() {

              scope.totalItems = {};
              scope.loadingItemsData = true;

              scope.getTotalItems();
            };

            scope.getTotalItems = function(){
              var params = {token: Auth.getUserToken()};
              Loads.totalItems(params)
                .then(function(response) {
                  scope.totalItems.current_loads = (response.loads_current) ? response.loads_current : 0;
                  scope.totalItems.pending_assign = (response.loads_pending) ? response.loads_pending : 0;
                  scope.totalItems.posted_loads = (response.loads_post) ? response.loads_post : 0;
                  scope.totalItems.available_trucks = (response.total_trucks) ? response.total_trucks : 0;
                  scope.totalItems.all_loads = (response.total_loads) ? response.total_loads : 0;
                  scope.loadingItemsData = false;
                });
            }

            // Initialize
            scope.initialize();
        }
    };
  }
})();

(function() {
  'use strict';

  /* Notification list Directive
   * Dropdown with notification list */

  angular
    .module('loadsAppWeb')
    .directive('notificationList', NotificationList);

  /** @ngInject */
  function NotificationList($rootScope, Auth, Notification) {
    return {
        templateUrl: 'app/main/templates/directives/notification-list.html',
        restrict: 'E',
        replace: true,
        scope: {
          listType: '='
        },
        link: function(scope) {
            /**
             * Initialize
             */
            scope.initialize = function() {
                scope.fakeNotificationList = [];

                scope.fakeNotificationList.push({active: true, text: 'Shipper name has accepted your request ID load 203384', date: '2017-08-06 15:00:00'});
                scope.fakeNotificationList.push({active: true, text: 'Shipper name has accepted your request ID load 203384', date: '2017-08-06 15:01:00'});
                scope.fakeNotificationList.push({active: true, text: 'Shipper name has accepted your request ID load 203384', date: '2017-08-06 15:02:00'});
                scope.fakeNotificationList.push({active: false, text: 'Shipper name has accepted your request ID load 203384', date: '2017-08-03 15:03:00'});

                scope.notifOptions = {
                  'token': Auth.getUserToken(),
                  'page': 1
                };
                scope.notificationList = [];
                scope.currentPage = 1;
                scope.totalPages = 1;

                scope.getNotifications();
            };

            scope.getNotifications =  function() {
              Notification.getNotifications(scope.notifOptions)
                .then(function(response){
                  if(angular.isDefined(response.notif_results)){
                    scope.notificationList = response.notif_results;
                    scope.totalPages = response.total_pages;
                    scope.currentPage = response.current_page;
                  }
                });
            };

            // Initialize
            scope.initialize();

            $(document).ready(function(){
               $('.notification-content-scroll').on('scroll', function() {
                    var div = $(this).get(0);
                    if(div.scrollTop + div.clientHeight >= div.scrollHeight) {
                      //console.log("entra1");
                      if(scope.totalPages > scope.currentPage){
                        //console.log("entra2");
                        scope.notifOptions.page = scope.currentPage + 1;

                        Notification.getNotifications(scope.notifOptions)
                            .then(function(response){
                              if(angular.isDefined(response.notif_results)){
                                for(var i in response.notif_results){
                                  scope.notificationList.push(response.notif_results[i]);
                                }
                                scope.totalPages = response.total_pages;
                                scope.currentPage = response.current_page;
                              }
                            });
                      }
                    }
                });
            });
        }
    };
  }
})();

(function() {
  'use strict';

  /* Enter action Directive
   * Allow to do something from enter action in forms */

  angular
    .module('loadsAppWeb')
    .directive('ngEnter', NgEnter);

  /** @ngInject */
  function NgEnter($state, $stateParams) {
    return function(scope, element, attrs) {
        element.bind("keydown keypress", function(event) {
            if(event.which === 13) {
                scope.$apply(function(){
                    scope.$eval(attrs.ngEnter, {'event': event});
                });

                event.preventDefault();
            }
        });
    };
  }
})();

(function() {
  'use strict';

  /* Loader Directive
   * Loader loop image */

  angular
    .module('loadsAppWeb')
    .directive('mainLoader', MainLoader);

  /** @ngInject */
  function MainLoader() {
    return {
        templateUrl: 'app/main/templates/directives/main-loader.html',
        restrict: 'E',
        replace: true,
        scope: {},
        link: function(scope) {
            
        }
    };
  }
})();

(function() {
  'use strict';

  /* Invite to join dropdown Directive
   * Dropdown that is at header */

  angular
    .module('loadsAppWeb')
    .directive('inviteJoin', InviteJoin);

  /** @ngInject */
  function InviteJoin($rootScope, Auth, $filter, Config, toastr) {
    return {
        templateUrl: 'app/main/templates/directives/invite-join.html',
        restrict: 'E',
        replace: true,
        scope: {
          type: '='
        },
        link: function(scope) {
            /**
             * Initialize
             */
            scope.initialize = function() {
              scope.dataSend = {}
              scope.dataSend.emailsString = '';
            };

            scope.sendMailInvitation = function(inviteJoinFormName){
              if (inviteJoinFormName.$invalid) {
                  // If there was an error for required fields.
                  if (inviteJoinFormName.$error.required) {
                      toastr.error($filter('translate')('header:invite_join:form:required:fields:error'));
                  } else {
                      toastr.error($filter('translate')('header:invite_join:form:required:fields:invalid'));
                  }
                  return;
              }
              var subject = $filter('translate')('header:invite_join:mail:send:subject')
              , body = $filter('translate')('header:invite_join:mail:send:body') + " " + Config.ENV.INVITE_JOIN_MAIL_BODY_URL;
              window.location.href="mailto:"+scope.dataSend.emailsString+"?subject="+subject+"&body="+body;
            };

            scope.shareFacebook = function() {
              FB.ui({
                method: 'share',
                href: Config.ENV.INVITE_JOIN_MAIL_BODY_URL,
                quote: $filter('translate')('header:invite_join:mail:send:body') + " " + Config.ENV.INVITE_JOIN_MAIL_BODY_URL
              }, function(response){});
            };

            scope.shareTwitter = function() {
              var title = $filter('translate')('header:invite_join:mail:send:subject')
              , body = $filter('translate')('header:invite_join:mail:send:body') + " " + Config.ENV.INVITE_JOIN_MAIL_BODY_URL;
              window.open('http://twitter.com/share?url='+Config.ENV.INVITE_JOIN_MAIL_BODY_URL+'&text='+body, '', 'left=0,top=0,width=550,height=450,personalbar=0,toolbar=0,scrollbars=0,resizable=0');
            };


            // Initialize
            scope.initialize();
        }
    };
  }
})();

(function() {
  'use strict';

  /* Header Directive
   * Left panel where is main menu */

  angular
    .module('loadsAppWeb')
    .directive('appHeader', AppHeader);

  /** @ngInject */
  function AppHeader($rootScope, Auth, $state, $uibModal, Notification, $timeout) {
    return {
        templateUrl: 'app/main/templates/directives/app-header.html',
        restrict: 'E',
        replace: true,
        scope: {},
        link: function(scope) {
            /**
             * Initialize
             */
            scope.initialize = function() {
                scope.notificationTypeList = "widget";
                scope.profile = Auth.getUserProfile();
                scope.user = Auth.getUserData();
                scope.userDataProfile = Auth.getUserDataProfile();
                scope.notificationsCount = '';

                if(scope.profile){
                  scope.profile = scope.profile.toLowerCase();
                }
                //scope.appTitle = angular.copy($rootScope.appTitle);

                scope.getInfoNotifications();
            };

            /* Get notification list and set new notifications count */
            scope.getInfoNotifications =  function() {
              scope.notifOptions = {
                'token': Auth.getUserToken(),
                'page': 1
              };

              Notification.getNotifications(scope.notifOptions)
                .then(function(response){
                  if(angular.isDefined(response.notif_total_results)){
                    if(response.notif_total_results > 0){
                      var countNotifAux = 0;
                      scope.notificationsCount = '';
                      for(var i in response.notif_results){
                        if(response.notif_results[i].is_read == 'N'){
                          countNotifAux++;
                        }
                      }
                      
                      scope.notificationsCount = (countNotifAux > 0) ? countNotifAux : '';
                    }
                  }
                });
            };

            /* Logout option */
            scope.logout = function() {
              Auth.logout();
              $state.go('public.login');
            };

            /* Call carrier searching modal */
            scope.openSearchCarriersModal = function() {
              var modalInstance = $uibModal.open({
                controller: 'SearchCarrierModalController as searchcarrier',
                windowClass: 'search-carrier-modal',
                templateUrl: 'app/main/templates/modal/search-carrier.html'
              });
            };

            /* Call loads searching modal */
            scope.openSearchLoadsModal = function() {
              var modalInstance = $uibModal.open({
                controller: 'SearchLoadModalController as searchload',
                windowClass: 'search-load-modal',
                templateUrl: 'app/main/templates/modal/search-load.html'
              });
            };

            /* Redirect to profile page */
            scope.goToProfile = function(){
              $state.go('private.my_profile');
            };

            /* Set new notifications as read */
            scope.setReadNotifications = function(){
              if(!angular.element('#notify-header-item-dropdown').hasClass('show')){
                $timeout(function () {
                  var params = {};
                  params.token = Auth.getUserToken();
                  Notification.setReadNotifications(params)
                    .then(function(response){
                      scope.getInfoNotifications();
                    });
                }, 2000);
              }
            }

            // Initialize
            scope.initialize();
        }
    };
  }
})();

(function() {
  'use strict';
  /* Aside Directive
   * Left panel where is main menu */
  angular
    .module('loadsAppWeb')
    .directive('appAside', AppAside);
  /** @ngInject */
  function AppAside($state, $rootScope, Auth,  flux, userStore) {
    return {
      templateUrl: 'app/main/templates/directives/app-aside.html',
      restrict: 'E',
      replace: true,
      scope: {},
      link: function(scope) {
        /**
         * Initialize
         */
        var vm = this;

        scope.me = userStore.profile || Auth.getUserData();

        if(!userStore.profile){
          flux.dispatch('fetchProfile', {});
        }

        scope.$listenTo(userStore, function () {
          scope.me = userStore.profile;
        });

        scope.initialize = function() {
          scope.profile = Auth.getUserProfile();
          scope.loadsActive = $state.includes('private.loads');
          scope.carriersActive = $state.includes('private.carriers');
          if(scope.profile){
            scope.profile = scope.profile.toLowerCase();
          }
        };
        scope.getUserFields = function(){
          Auth.getInfoUser().then(function (resp){
              scope.data    = resp.data.userData;
          });
        }
        // Initialize
        scope.initialize();
        //scope.getUserFields();
      }
    };
  }
})();

(function() {
  'use strict';

  /* Looking for loads modal controller
   * Set searching form vars 
   * Get load attributes 
   * Redirect to loads view with searching params
   */

  angular
    .module('loadsAppWeb')
    .controller('SearchLoadModalController', SearchLoadModalController);

  /** @ngInject */
  function SearchLoadModalController($state, $uibModalInstance, $filter, Loads) {
	  var vm = this;
      vm.from_any = false;
      vm.to_any = false;
      vm.price_any = false;
      vm.searchData = {};
      vm.searchData.fromObject = null;
      vm.searchData.from = null;
      vm.searchData.toObject = null;
      vm.searchData.to = null;
      vm.searchData.pickup = null;
      vm.searchData.delivery = null;
      vm.searchData.price_min = null;
      vm.searchData.price_max = null;
      vm.searchData.length = null;
      vm.searchData.truck_type = null;
      vm.searchData.size = null;
      vm.searchData.weight = null;
      vm.searchData.load_type = null;
      vm.searchData.load_id = null;
      vm.searchData.deadhead = null;
      vm.searchData.shipper = null;
      vm.searchData.review = 0;

      vm.advancedOptions = false;

      vm.dateDeliveryDisabled = true;
      vm.datePickerMinDate = moment();
      vm.optsDatePicker = {
          singleDatePicker: true,
          showDropdowns: true,
          locale: {
              format: "YYYY-MM-DD",
              applyClass: 'btn-green',
              applyLabel: $filter('translate')('daterangepicker:btn:success:text'),
              fromLabel: $filter('translate')('daterangepicker:label:from'),
              toLabel: $filter('translate')('daterangepicker:label:to'),
              cancelLabel: $filter('translate')('daterangepicker:btn:cancel:text'),
              customRangeLabel: $filter('translate')('daterangepicker:title:text'),
              firstDay: 1
          }
        };

      vm.priceMaxDisabled = true;

      vm.lenghtType = 'NA';
      vm.truckTypeConf = 'NA';
      vm.TruckTypesRemolque = [];

      /* if user selects any option in "date from", set vars as null */
      vm.fromAnyChanged = function() {
        if(vm.from_any){
          vm.searchData.fromObject = null;
          vm.searchData.from = null;
        }
      };

      /* if user selects any option in "date to", set vars as null */
      vm.toAnyChanged = function() {
        if(vm.to_any){
          vm.searchData.toObject = null;
          vm.searchData.to = null;
        }
      };

      /* if user selects any option in "price", set vars as null */
      vm.priceAnyChanged = function() {
        if(vm.price_any){
          vm.searchData.price_min = 0;
          vm.searchData.price_max = 0;
        }
      };

      /* Validate form and redirect to loads view with params */
      vm.sendDataFormSearch = function() {
        if(!vm.from_any){
          if(vm.searchData.fromObject != null){
            if(angular.isDefined(vm.searchData.fromObject.address_components)){
              vm.searchData.from = vm.searchData.fromObject.address_components[0].long_name;
            }
          }
        }else{
          vm.searchData.from = 0;
        }

        if(!vm.to_any){
          if(vm.searchData.toObject != null){
            if(angular.isDefined(vm.searchData.toObject.address_components)){
              vm.searchData.to = vm.searchData.toObject.address_components[0].long_name;
            }
          }
        }else{
          vm.searchData.to = 0;
        }

        if(vm.searchData.review == 0){
          vm.searchData.review = null;
        }
      	$state.go('private.loads.params', { from: vm.searchData.from, to: vm.searchData.to, pickup: vm.searchData.pickup, delivery: vm.searchData.delivery, price_min: vm.searchData.price_min, price_max: vm.searchData.price_max, length: vm.searchData.length, size: vm.searchData.size, weight: vm.searchData.weight, load_type: vm.searchData.load_type, load_id: vm.searchData.load_id, shipper: vm.searchData.shipper, review: vm.searchData.review, deadhead: vm.searchData.deadhead});
      	vm.closePopup();
      };

    /* Close modal */
      vm.closePopup = function() {
      	$uibModalInstance.close();
	  };

    /* Validate pickup date and allow to set delivery date */
    vm.allowDeliveryDate = function() {
      if(vm.searchData.pickup != null && vm.searchData.pickup != ""){
        //vm.dateDeliveryDisabled = false;
        vm.searchData.delivery = null;
        /*if(vm.searchData.delivery < vm.searchData.pickup){
          vm.searchData.delivery = vm.searchData.pickup;
        }*/
      }else{
        //vm.dateDeliveryDisabled = true;
        vm.searchData.delivery = null;
      }
    };

    /* Validate delivery date and allow to set pickup date */
    vm.allowPickupDate = function() {
      if(vm.searchData.delivery != null && vm.searchData.delivery != ""){
        //vm.dateDeliveryDisabled = false;
        vm.searchData.pickup = null;
        /*if(vm.searchData.delivery < vm.searchData.pickup){
          vm.searchData.delivery = vm.searchData.pickup;
        }*/
      }else{
        //vm.dateDeliveryDisabled = true;
        vm.searchData.pickup = null;
      }
    };

    /* Validate price min and allow to set price max */
    vm.allowPriceMax = function() {
      if(vm.searchData.price_min != null && vm.searchData.price_min >= 0){
        vm.priceMaxDisabled = false;
        if(vm.searchData.price_max < vm.searchData.price_min){
          vm.searchData.price_max = vm.searchData.price_min;
        }
      }else{
        vm.priceMaxDisabled = true;
        vm.searchData.price_max = null;
      }
    };

    /* Advanced filters toogle */
    vm.showHideAdvancedFilters = function(){
      vm.advancedOptions = !vm.advancedOptions;

      if(!vm.advancedOptions){
        vm.resetFilters('advanced');
      }
    };

    /* Reset filters */
    vm.resetFilters = function(mode){
      switch(mode){
        case 'advanced':
          vm.from_any = false;
          vm.to_any = false;
          vm.price_any = false;
          vm.searchData.price_min = null;
          vm.searchData.price_max = null;
          vm.searchData.length = null;
          vm.searchData.size = null;
          vm.searchData.weight = null;
          vm.searchData.load_type = null;
          vm.searchData.load_id = null;
          vm.searchData.shipper = null;
          vm.searchData.review = 0;

          vm.priceMaxDisabled = true;

          vm.lenghtType = 'NA';
          vm.truckTypeConf = 'NA';
          vm.searchData.truck_type = null;
          break;
        default:
          if(confirm($filter('translate')('modals:search_load:reset_filter:warning:text'))){
            vm.from_any = false;
            vm.to_any = false;
            vm.price_any = false;
            vm.searchData.fromObject = null;
            vm.searchData.from = null;
            vm.searchData.toObject = null;
            vm.searchData.to = null;
            vm.searchData.pickup = '';
            vm.searchData.delivery = '';
            vm.searchData.price_min = null;
            vm.searchData.price_max = null;
            vm.searchData.length = null;
            vm.searchData.size = null;
            vm.searchData.weight = null;
            vm.searchData.load_type = null;
            vm.searchData.shipper = null;
            vm.searchData.load_id = null;
            vm.searchData.review = 0;

            vm.dateDeliveryDisabled = true;
            vm.datePickerMinDate = moment();
            vm.priceMaxDisabled = true;

            vm.lenghtType = 'NA';
            vm.truckTypeConf = 'NA';
            vm.searchData.truck_type = null;
          }
          break;
      }
    };

    /* Validate review selected by user */
    vm.setReview = function(ind){
      ind = parseInt(ind);
      if(ind >=0 && ind <= 5){
        vm.searchData.review = ind;
      }
    };

    /* Get load attributes */
    vm.getItemsSizeLengthLoads = function(){
      vm.itemsSizeLenLoads = {};
      Loads.getItemsSizeLengthLoads()
        .then(function(response){
          if(response){
            vm.itemsSizeLenLoads = response;

            if(angular.isDefined(vm.itemsSizeLenLoads.Trucktypes_list)){
              vm.setSimpleTruckTypes();
              vm.setFullTruckTypes();
            }

            if(angular.isDefined(vm.itemsSizeLenLoads.LoadsLength_list)){
              vm.setSimpleLoadsLength();
              vm.setFullLoadsLength();
            }
          }
        });
    };

    vm.setSimpleLoadsLength = function() {
      vm.simpleLoadsLength = [];
      if(vm.itemsSizeLenLoads.LoadsLength_list.length){
        for(var i in vm.itemsSizeLenLoads.LoadsLength_list){
          if(vm.itemsSizeLenLoads.LoadsLength_list[i].type_length == "s"){
            vm.simpleLoadsLength.push({id: vm.itemsSizeLenLoads.LoadsLength_list[i].id, name: vm.itemsSizeLenLoads.LoadsLength_list[i].name, checked: false});
          }
        }
      }
    };

    vm.setFullLoadsLength = function() {
      vm.fullLoadsLength = [];
      if(vm.itemsSizeLenLoads.LoadsLength_list.length){
        for(var i in vm.itemsSizeLenLoads.LoadsLength_list){
          if(vm.itemsSizeLenLoads.LoadsLength_list[i].type_length == "f"){
            vm.fullLoadsLength.push({id: vm.itemsSizeLenLoads.LoadsLength_list[i].id, name: vm.itemsSizeLenLoads.LoadsLength_list[i].name, checked: false});
          }
        }
      }
    };

    vm.setSimpleTruckTypes = function() {
      vm.simpleTruckTypes = [];
      if(vm.itemsSizeLenLoads.Trucktypes_list.length){
        for(var i in vm.itemsSizeLenLoads.Trucktypes_list){
          if(vm.itemsSizeLenLoads.Trucktypes_list[i].type_config == "s"){
            vm.simpleTruckTypes.push({id: vm.itemsSizeLenLoads.Trucktypes_list[i].id, name: vm.itemsSizeLenLoads.Trucktypes_list[i].truck_type_name, checked: false});

            if(vm.itemsSizeLenLoads.Trucktypes_list[i].truck_type_name.indexOf('Remolque') !== -1){
              vm.TruckTypesRemolque.push(parseInt(vm.itemsSizeLenLoads.Trucktypes_list[i].id));
            }
          }
        }
      }
    }

    vm.setFullTruckTypes = function() {
      vm.fullTruckTypes = [];
      if(vm.itemsSizeLenLoads.Trucktypes_list.length){
        for(var i in vm.itemsSizeLenLoads.Trucktypes_list){
          if(vm.itemsSizeLenLoads.Trucktypes_list[i].type_config == "f"){
            console.log(vm.itemsSizeLenLoads.Trucktypes_list[i].truck_type_name);
            vm.fullTruckTypes.push({id: vm.itemsSizeLenLoads.Trucktypes_list[i].id, name: vm.itemsSizeLenLoads.Trucktypes_list[i].truck_type_name, checked: false});

            if(vm.itemsSizeLenLoads.Trucktypes_list[i].truck_type_name.indexOf('Remolque') !== -1){
              vm.TruckTypesRemolque.push(parseInt(vm.itemsSizeLenLoads.Trucktypes_list[i].id));
            }
          }
        }
      }
    }

    vm.sizeConfigurationChange = function() {
      switch(vm.searchData.size){
        case "1":
          vm.lenghtType = 'NA';
          vm.truckTypeConf = 'S';
          vm.searchData.truck_type = null;
          vm.searchData.length = null;
          break;
        case "2":
          vm.lenghtType = 'NA';
          vm.truckTypeConf = 'F';
          vm.searchData.truck_type = null;
          vm.searchData.length = null;
          break;
        default:
          vm.lenghtType = 'NA';
          vm.truckTypeConf = 'NA';
          vm.searchData.truck_type = null;
          vm.searchData.length = null;
          break;
      }
    };

    vm.truckTypeChange = function() {
      if(vm.searchData.size == '1'){
        if(vm.TruckTypesRemolque.indexOf(parseInt(vm.searchData.truck_type)) !== -1){
          vm.lenghtType = 'S';
          vm.searchData.length = null;
        }else{
          vm.lenghtType = 'NA';
          vm.searchData.length = null;
        }
      }else if(vm.searchData.size == '2'){
        if(vm.TruckTypesRemolque.indexOf(parseInt(vm.searchData.truck_type)) !== -1){
          vm.lenghtType = 'F';
          vm.searchData.length= null;
        }else{
          vm.lenghtType = 'NA';
          vm.searchData.length = null;
        }
      }else{
        vm.lenghtType = 'NA';
        vm.truckTypeConf = 'NA';
        vm.searchData.truck_type = null;
        vm.searchData.length = null;
      }
    }

    vm.getItemsSizeLengthLoads();
  }
})();

(function() {
  'use strict';

  /* Looking for carrier modal controller
   * Set searching form vars 
   * Get load attributes and truck skills list
   * Redirect to carriers view with searching params
   */

  angular
    .module('loadsAppWeb')
    .controller('SearchCarrierModalController', SearchCarrierModalController);

  /** @ngInject */
  function SearchCarrierModalController($state, $uibModalInstance, Loads) {
	  var vm = this;
      vm.searchData = {};
      vm.searchData.company = null;
      vm.searchData.trailer_type = null;
      vm.searchData.len = null;
      vm.searchData.wei = null;
      vm.searchData.size = null;
      vm.searchData.reviews = 0;
      vm.searchData.skils_truck = [];

      /* Redirect to carriers view with params */
      vm.sendDataFormSearch = function() {
        if(angular.isDefined(vm.skillList)){
          vm.skillList.forEach(function(item) {
            if (item.checked) vm.searchData.skils_truck.push(item.id);
          });
        }

      	$state.go('private.carriers.params', { company: vm.searchData.company, trailer_type: vm.searchData.trailer_type, len: vm.searchData.len, wei: vm.searchData.wei, size: vm.searchData.size, skils_truck: vm.searchData.skils_truck, reviews: vm.searchData.reviews });
      	vm.closePopup();
      };

      /* Close modal */
      vm.closePopup = function() {
      	$uibModalInstance.close();
	    };

      /* Get load attributes */
      vm.getItemsSizeLengthLoads = function(){
        vm.itemsSizeLenLoads = {};
        Loads.getItemsSizeLengthLoads()
          .then(function(response){
            if(response){
              vm.itemsSizeLenLoads = response;
              console.log(vm.itemsSizeLenLoads);
              if(angular.isDefined(vm.itemsSizeLenLoads.TrucksSkills_list)){
                vm.setTruckSkillList();
              }
            }
          });
      };

      /* Set truck skills list in local var */
      vm.setTruckSkillList = function() {
        vm.skillList = [];
        if(vm.itemsSizeLenLoads.TrucksSkills_list.length){
          for(var i in vm.itemsSizeLenLoads.TrucksSkills_list){
            vm.skillList.push({id: vm.itemsSizeLenLoads.TrucksSkills_list[i].id, name: vm.itemsSizeLenLoads.TrucksSkills_list[i].skills_name, checked: false});
          }
        }
      };

      /* Set review when it is selected */
      vm.setReview = function(ind){
        ind = parseInt(ind);
        if(ind >=0 && ind <= 5){
          vm.searchData.reviews = ind;
        }
      };

      /* Reset form */
      vm.resetDataFormSearch = function(){
        vm.searchData.company = null;
        vm.searchData.trailer_type = null;
        vm.searchData.len = null;
        vm.searchData.wei = null;
        vm.searchData.size = null;
        vm.searchData.reviews = 0;
        vm.searchData.skils_truck = [];

        vm.setTruckSkillList();
      };

      vm.getItemsSizeLengthLoads();
  }
})();

(function() {
  'use strict';

  /* Public controller
   * Content pages where user doesn't need to be logged
   */

  angular
    .module('loadsAppWeb')
    .controller('PublicController', PublicController);

  /** @ngInject */
  function PublicController() {
	var vm = this;

    vm.isPublicPage = true;
  }
})();

(function() {
  'use strict';

  /* Private controller
   * Content pages where user has to be logged
   */

  angular
    .module('loadsAppWeb')
    .controller('PrivateController', PrivateController);

  /** @ngInject */
  function PrivateController() {
	var vm = this;

    vm.isPublicPage = false;
  }
})();

(function() {
  'use strict';

  /* Notification settings controller
   * Get settings info from auth service
   * Set and save notification settings
   * Set and save auto assign load setting
   */

  angular
    .module('loadsAppWeb')
    .controller('NotificationSettingsPageController', NotificationSettingsPageController);

  /** @ngInject */
  function NotificationSettingsPageController(toastr, $filter, Config, Auth, Notification, MainServ) {
	var vm = this;

	/* Function executed at strart, Set vars and get notification and auto assign settings */
	vm.initialize = function() {
		vm.saving = false;
		vm.settingsValues = {
			statusload_message: 0,
			cancelload_message: 0,
			deliveryload_message: 0,
			assignedload_message: 0
		};
		vm.automaticAssingParams = {
			token: Auth.getUserToken(),
			automatic_load: 0
		}
		vm.userData = Auth.getUserData();

		if(angular.isDefined(vm.userData.statusload_message)){
			vm.settingsValues.statusload_message = vm.userData.statusload_message;
		}

		if(angular.isDefined(vm.userData.cancelload_message)){
			vm.settingsValues.cancelload_message = vm.userData.cancelload_message;
		}

		if(angular.isDefined(vm.userData.deliveryload_message)){
			vm.settingsValues.deliveryload_message = vm.userData.deliveryload_message;
		}

		if(angular.isDefined(vm.userData.assignedload_message)){
			vm.settingsValues.assignedload_message = vm.userData.assignedload_message;
		}

		if(angular.isDefined(vm.userData.automatic_asign)){
			vm.automaticAssingParams.automatic_load = vm.userData.automatic_asign;
		}
	};

	/* Save notification settings */
	vm.saveSettings = function() {
		var params = {
			token: Auth.getUserToken(),
			statusload_message: vm.settingsValues.statusload_message,
			cancelload_message: vm.settingsValues.cancelload_message,
			deliveryload_message: vm.settingsValues.deliveryload_message,
			assignedload_message: vm.settingsValues.assignedload_message
		};

		Notification.saveUserSettingsMessages(params)
	        .then(function(response){
	          if(response.status == 'ok'){
	          	toastr.success($filter('translate')('notification_settings:save:success'));
	          }else{
	          	toastr.error($filter('translate')('notification_settings:save:error'));
	          }
	        });
	};

	/* Save auto assign settings */
	vm.saveAutoAssign = function() {
		console.log(vm.automaticAssingParams);
		MainServ.setAutomaticLoadAssign(vm.automaticAssingParams)
	        .then(function(response){
	          if(response.status == 'ok'){
	          	var refreshUserData = Auth.setAutomaticAssign(parseInt(vm.automaticAssingParams.automatic_load));
	          	toastr.success($filter('translate')('notification_settings:automatic_assign:save:success'));
	          }else{
	          	toastr.error($filter('translate')('notification_settings:automatic_assign:save:error'));
	          }
	        })
	   		.catch(function(error){
	   			console.log(error);
	   		});
	}
 
	vm.initialize();
  }
})();

(function() {
  'use strict';

  /* Notifications controller
   */

  angular
    .module('loadsAppWeb')
    .controller('NotificationsPageController', NotificationsPageController);

  /** @ngInject */
  function NotificationsPageController(toastr, $filter, Config) {
	var vm = this;
	vm.notificationTypeList = "page";
  }
})();

(function() {
  'use strict';

  angular
    .module('loadsAppWeb')
    .controller('MainController', MainController);

  /** @ngInject */
  function MainController() {
    var vm = this;
  }
})();

(function() {
  'use strict';

  /* Invite Join controller
   */

  angular
    .module('loadsAppWeb')
    .controller('InviteJoinPageController', InviteJoinPageController);

  /** @ngInject */
  function InviteJoinPageController(toastr, $filter, Config) {
	var vm = this;
	vm.type = "page";
  }
})();

(function() {
  'use strict';

  /* Home controller
   * Get geolocation and set it in a map
   * Get available loads for carrier
   * Get carriers for shipper
   * Show carrier or load details
   */

  angular
    .module('loadsAppWeb')
    .controller('HomeController', HomeController);

  /** @ngInject */
  function HomeController(
    toastr,
    $filter,
    Config,
    Loads,
    DatatableTool,
    MainServ,
    $q,
    Auth,
    uiGmapGoogleMapApi,
    DTOptionsBuilder,
    DTColumnBuilder,
    $timeout,
    $location
  ) {
	var vm = this;

    /* Function executed at strart, Set table and map vars and get geolocation  */
	  vm.initialize = function() {
      vm.hiddenMap = false;
      vm.nearbyCarriersOrLoads = [];
      vm.userLocation = {};
      vm.userLocation.latitude = false;
      vm.userLocation.longitude = false;
      vm.datatableOptions = DatatableTool.getDefaultSettings();
      vm.datatableOptions.paging = false;
      vm.noResultsTable = '';
      vm.initializeLanguage();
      $timeout(function(){
        vm.initializeLanguage();
      }, 1000);
      vm.loadingMap = true;
      vm.loadingData = true;

      try {
        vm.getGeoLocation();
      } catch(err) {
        vm.nearbyCarriersOrLoads = [];
        vm.loadingMap = false;
        vm.loadingData = false;
      }
      vm.getUserFields();
    };
    vm.getUserFields = function(){
      Auth.getInfoUser().then(function (resp){
        vm.dataUser    = resp.data.userData;
        sessionStorage.setItem('_us',JSON.stringify(resp.data.Info_perfil.dataUser));
        vm.getDocuments();
      });
    }
    vm.redirectProfile = function (){
      $location.path('profile');
    }
    vm.initializeLanguage = function(){
      vm.profileText = Auth.getUserProfile()+'s';
      switch(Auth.getUserProfile()){
          case 'GENERADOR_CARGA':
            vm.noResultsTable = $filter('translate')('home:nearby_carriers:find_carrier:noresults');
            vm.profileText = 'shippers';
            break;
          case 'CARRIER':
          case 'DRIVER':
          case 'OWNER':
            vm.noResultsTable = $filter('translate')('home:nearby_carriers:find_loads:noresults');
            break;
        }
    };
    vm.getDocuments = function (){
      let profile = (Auth.getUserProfile() == 'OWNER') ? 'carriers': vm.profileText.toLowerCase();
      Auth.getUserDocumentation(profile,vm.dataUser.id).then(function (resp){
          if (resp.status == 200){
            vm.documentations = [];
            vm.resources = resp.data.results;
            if (vm.resources.length > 0){
              angular.forEach(vm.resources, function (value){
                if (value.document != null && value.document.files.length > 0){
                  vm.documentations.push(value.document);
                }
              });
            }
          }
      });
    }
    /*vm.testList = function() {
      vm.testParams = {};
      vm.testParams.token = Auth.getUserToken();
      vm.testParams.search_type = "not_assigned";
      vm.testParams.page = 1;

      vm.dataExample = [];

      /*vm.newDatatableOptions = angular.extend(DatatableTool.getDefaultOptions2(), {
        ajax: function (data, callback, settings) {
            // Page
            vm.testParams.page = DatatableTool.getPage(data);

            Loads.getByUserRol(vm.testParams)
              .then(function(response){
                var records = DatatableTool.getRecords(response);
                vm.dataExample = records.data;
                callback(records);
              });
        }
      });*/

      /*vm.newDatatableOptions = DTOptionsBuilder.newOptions()
                            .withOption('ajax', function(data, callback, settings){
                              // Page
                              vm.testParams.page = DatatableTool.getPage(data);

                              Loads.getByUserRol(vm.testParams)
                                .then(function(response){
                                  var records = DatatableTool.getRecords(response);
                                  vm.dataExample = records.data;
                                  callback(records);
                                });
                            })
                            .withDataProp('data')
                            .withOption('processing', true)
                            .withOption('serverSide', true)
                            .withOption('searching', false)
                            .withOption('info', false)
                            .withOption('lengthChange', false)
                            .withOption('pageLength', DatatableTool.getLimit(null))
                            .withOption(DatatableTool.getDefaultSettings())
                            .withPaginationType('full_numbers');
      vm.dtColumns = [
          DTColumnBuilder.newColumn('load_id').withTitle('ID')
      ];
    };*/

    /* Load map and set user geolocation */
    vm.initializeMap = function () {
      uiGmapGoogleMapApi.then(function(maps) {
       vm.loadingMap = false;
       vm.map = { center: { latitude: vm.userLocation.latitude, longitude: vm.userLocation.longitude }, zoom: 14 };
      });
    };

    /* Get nearby carriers or loads */
    vm.getNearbyCarriersOrLoads = function() {
      var params = {};
      params.token = Auth.getUserToken();
      params.lat_user = vm.userLocation.latitude;
      params.lon_user = vm.userLocation.longitude;

      //params.lat_user = 4.525;
      //params.lon_user = -74.135;

      MainServ.searchForLocation(params)
        .then(function(response){
          if(angular.isDefined(response.results)){
            vm.nearbyCarriersOrLoads = response.results;
            vm.datatableOptions.language = {emptyTable: vm.noResultsTable};
            console.log(vm.noResultsTable);
            console.log(vm.datatableOptions.language);
            switch(Auth.getUserProfile()){
              case 'GENERADOR_CARGA':
                vm.fixDataNearbyCarriers();
                break;
              case 'CARRIER':
              case 'OWNER':
                break;
            }
            vm.setMarkers();
            vm.loadingData = false;
          }else{
            vm.nearbyCarriersOrLoads = [];
            vm.datatableOptions.language = {emptyTable: vm.noResultsTable};
            console.log(vm.noResultsTable);
            console.log(vm.datatableOptions.language);
            vm.loadingData = false;
          }
        }).catch(function(error){
          vm.nearbyCarriersOrLoads = [];
          vm.datatableOptions.language = {emptyTable: vm.noResultsTable};
          console.log(vm.noResultsTable);
          console.log(vm.datatableOptions.language);
          vm.loadingData = false;
        });
    };

    // fix some data will show to shipper
    vm.fixDataNearbyCarriers = function() {
      if(vm.nearbyCarriersOrLoads.length){
        for(var i in vm.nearbyCarriersOrLoads){
          if(angular.isDefined(vm.nearbyCarriersOrLoads[i].skills_truck) && vm.nearbyCarriersOrLoads[i].skills_truck.length){
            var arr_skills = [];
            for(var sk in vm.nearbyCarriersOrLoads[i].skills_truck){
              arr_skills.push(vm.nearbyCarriersOrLoads[i].skills_truck[sk].skills_name);
            }
            vm.nearbyCarriersOrLoads[i].skills_truck_text = arr_skills.join(', ');
          }
        }
      }
    };

    // Set markers in map
    vm.setMarkers = function(){
      vm.mapMarkers = [];
      if(vm.nearbyCarriersOrLoads.length){
        switch(Auth.getUserProfile()){
          case 'GENERADOR_CARGA':
            for(var i in vm.nearbyCarriersOrLoads){
              if(angular.isDefined(vm.nearbyCarriersOrLoads[i].latitud_truck) && angular.isDefined(vm.nearbyCarriersOrLoads[i].longitud_truck)){
                vm.mapMarkers.push({
                                id: vm.nearbyCarriersOrLoads[i].id,
                                options: {
                                  icon: 'assets/images/common/marker.png'
                                },
                                coords: {
                                    latitude: vm.nearbyCarriersOrLoads[i].latitud_truck,
                                    longitude: vm.nearbyCarriersOrLoads[i].longitud_truck
                                }
                              });
              }
            }
            break;
          case 'CARRIER':
          case 'DRIVER':
          case 'OWNER':
            for(var i in vm.nearbyCarriersOrLoads){
              if(angular.isDefined(vm.nearbyCarriersOrLoads[i].lat_pickup_adress) && angular.isDefined(vm.nearbyCarriersOrLoads[i].long_pickup_adress)){
                vm.mapMarkers.push({
                                id: vm.nearbyCarriersOrLoads[i].id,
                                options: {
                                  icon: 'assets/images/common/marker.png'
                                },
                                coords: {
                                    latitude: vm.nearbyCarriersOrLoads[i].lat_pickup_adress,
                                    longitude: vm.nearbyCarriersOrLoads[i].long_pickup_adress
                                }
                              });
              }
            }
            break;
        }
      }
    };

    /* Get user geolocation */
    vm.getGeoLocation = function() {
      if (navigator.geolocation) {
        navigator.permissions.query({name:'geolocation'}).then(function (resp){
          switch (resp.state) {
            case "denied":
              $timeout(function(){
                toastr.info($filter('translate')('home:advice:location:settings:active', {timeOut: 10000}));
              }, 1000);
              break
            case "granted":
              navigator.geolocation.getCurrentPosition(vm.setGeoLocation);
              break;
            case "prompt":
              $timeout(function(){
                toastr.info($filter('translate')('home:advice:location:settings:active', {timeOut: 10000}));
              }, 1000);
              navigator.geolocation.getCurrentPosition(vm.setGeoLocation);
              break
          }
          resp.onchange = function() {
            if (resp.state == "prompt" || resp.state == "denied"){
              $timeout(function(){
                toastr.info($filter('translate')('home:advice:location:settings:active', {timeOut: 10000}));
              }, 1000);
            }
          }
        });

      }
    };

    /* Set user geolocation in map */
    vm.setGeoLocation = function (position) {
      vm.userLocation.latitude = position.coords.latitude;
      vm.userLocation.longitude = position.coords.longitude;
      vm.initializeMap();
      vm.getNearbyCarriersOrLoads();
    };

    /* Show details in dropdown */
    vm.showDetailsUnique = function(item_id) {
      for(var i in vm.nearbyCarriersOrLoads){
        if(vm.nearbyCarriersOrLoads[i].id == item_id && vm.dataUser.user_status != 0 ){
          vm.nearbyCarriersOrLoads[i].expanded = !vm.nearbyCarriersOrLoads[i].expanded;
          vm.hiddenMap = (vm.nearbyCarriersOrLoads[i].expanded == true) ? vm.nearbyCarriersOrLoads[i].expanded : false;
        }else{
          vm.nearbyCarriersOrLoads[i].expanded = false;
        }
      }
    };

    vm.initialize();
  }
})();

(function() {
  'use strict';

  /* Help controller
   * Get each one of help topics
   * Append topic to content appointed 
   */

  angular
    .module('loadsAppWeb')
    .controller('HelpController', HelpController);

  /** @ngInject */
  function HelpController(toastr, $filter, Config, HelpServ, $window, $log) {
    var vm = this;

  /* Function executed at strart, Determinate current site language and get each one of help texts  */
    vm.initialize = function() {
    var lang = $window.navigator.language || $window.navigator.userLanguage;
    $log.log(lang.substr(0,2)); 
      
    if(lang){
      if(lang.substr(0,2) == 'es'){
        vm.languageHelp = "es";
      }else{
        vm.languageHelp = "en";
      }
    }else{
      vm.languageHelp = "en";
    }


      vm.getTermsAndConditions();
      vm.getEula();
      vm.getPrivacyPolicy();
      vm.getFaqs();
    };

    /* Get terms and conditions */
    vm.getTermsAndConditions = function() {
      HelpServ.getTyC(vm.languageHelp)
        .then(function(response){
          if(response.data){
            angular.element(angular.element("#content-terms-conditions")).append(response.data.message);
          }
        }).catch(function(error){
          $log.log("error "+error);
        });
    };

    /* Get Eula */
    vm.getEula = function() {
      HelpServ.getEula(vm.languageHelp)
        .then(function(response){
          if(response.data){
            angular.element(angular.element("#content-eula")).append(response.data.message);
          }
        }).catch(function(error){
          $log.log("error "+error);
        });
    };

    /* Get Privacy Policy */
    vm.getPrivacyPolicy = function() {
      HelpServ.getPrivacyPolicy(vm.languageHelp)
        .then(function(response){
          if(response.data){
            angular.element(angular.element("#content-privacy-policy")).append(response.data.message);
          }
        }).catch(function(error){
          $log.log("error "+ error);
        });
    };

    /* Get Faqs */
    vm.getFaqs = function() {
      HelpServ.getFaqs(vm.languageHelp)
        .then(function(response){
          if(response.data){
            angular.element(angular.element("#content-faqs")).append(response.data.message);
          }
        }).catch(function(error){
          $log.log("error "+ error);
        });
    };

    vm.initialize();
  }
})();

angular.module('loadsAppWeb').directive('uploadComponent', uploadComponent);

function uploadComponent(sweetAlert, swangular, UploadService, toastr, $filter, Auth, $location){
  return {
    templateUrl: "app/main/templates/upload/uploads.html",
    restrict: 'E',
    scope:{
      data:"="
    },
    controller : function ($scope){

      $scope.construct = function (){
        this.today        = new Date().toISOString().slice(0, 10);
        this.profile      = localStorage.getItem('ngStorage-userProfile').slice(1,-1);
        this.options      = {
          singleDatePicker: true,
          showDropdowns: true,
          locale: {
            format: "YYYY-MM-DD",
            applyClass: 'btn-green',
            applyLabel: $filter('translate')('daterangepicker:btn:success:text'),
            fromLabel: $filter('translate')('daterangepicker:label:from'),
            toLabel: $filter('translate')('daterangepicker:label:to'),
            cancelLabel: $filter('translate')('daterangepicker:btn:cancel:text'),
            customRangeLabel: $filter('translate')('daterangepicker:title:text'),
            firstDay: 1
          },
          eventHandlers: {
            'apply.daterangepicker': function(event, picker) {
              $scope.sendBetweenDate();
            }
          }
        };
        this.fields       = [];
        this.path         = $location.path();
        this.getDataUser();
        this.setResources();
      }
      $scope.getDataUser = function (){
        Auth.getInfoUser().then(function (resp){
          $scope.user     = resp.data.Info_perfil.dataUser;
        });
      }
      $scope.uploadFile = function (file){
        var formData = new FormData();
        formData.append('template', file);
        if ($scope.role != ""){
          formData.append('role', 'driver');
        }
        /*I going to upload a template for massive load*/
        UploadService.upload(formData,$scope.api).then(function (resp){
          if (resp.status == 200){
            toastr.success($filter('translate')('profile:document:upload:success'));
          }
        }).catch(function (error){
          console.error(error);
          toastr.error(error.data.message);
        });
      }
      $scope.throwUploadMassive = function (){
        swangular.open({
          title: "¡Cargar template!",
          htmlTemplate: "app/main/templates/upload/form-upload-file.html",
          type: "info",
          scope: $scope,
          buttonsStyling: true,
          confirmButtonColor: "#D4DD55",
          cancelButtonColor: "#d33",
          showCancelButton: true,
          showConfirmButton: true,
          confirmButtonText: "Aceptar",
          cancelButtonText: "Cancelar",
          allowOutsideClick: false,
          closeOnConfirm: true,
          closeOnCancel: true,
          showLoaderOnConfirm: true,
          width: '500px',
        }).then(function(result) {
          if(angular.isDefined(result)) {
            if(result.value) {

            }
          }
        }).catch(function (error){
          console.error(error);
        });
      }
      $scope.setResources = function (){
        $scope.role = '';
        if (this.path.indexOf('/trucks') > -1 ){
            $scope.textButon = $filter('translate')('trucks:upload:btn');
            $scope.textUpload = $filter('translate')('trucks:upload:new:opt');
            $scope.api = 'trucks';
        }
        if (this.path.indexOf('/drivers') > -1 ){
          $scope.textButon = $filter('translate')('drivers:upload:btn');
          $scope.textUpload = $filter('translate')('drivers:upload:new:opt');
          $scope.api = 'users';
          $scope.role = 'driver';
        }
        if (this.path.indexOf('/loads') > -1 ){
          $scope.textButon = $filter('translate')('loads:upload:btn');
          $scope.textUpload = $filter('translate')('loads:upload:new:opt');
          $scope.api = 'loads';
        }
        if (this.path.indexOf('/trailers') > -1 ) {
          $scope.textButon = $filter('translate')('trailers:upload:btn');
          $scope.textUpload = $filter('translate')('trailers:upload:new:opt');
          $scope.api = 'trailers';
        }
      }

      $scope.construct();

    }
  }
}

angular.module('loadsAppWeb').directive('metricMain', metricMain);

function metricMain(sweetAlert, swangular, MetricService, toastr, $filter, Auth){
  return {
    templateUrl: "app/main/templates/directives/metrics.html",
    restrict: 'E',
    scope:{
      data:"="
    },
    controller : function ($scope){
      am4core.ready(function() {
        am4core.useTheme(am4themes_animated);
      });

      $scope.construct = function (){
        this.today = new Date().toISOString().slice(0, 10);
        this.betweenDate = "";
        this.options = {
          singleDatePicker: true,
          showDropdowns: true,
          locale: {
            format: "YYYY-MM-DD",
            applyClass: 'btn-green',
            applyLabel: $filter('translate')('daterangepicker:btn:success:text'),
            fromLabel: $filter('translate')('daterangepicker:label:from'),
            toLabel: $filter('translate')('daterangepicker:label:to'),
            cancelLabel: $filter('translate')('daterangepicker:btn:cancel:text'),
            customRangeLabel: $filter('translate')('daterangepicker:title:text'),
            firstDay: 1
          }
        };
        this.option = {
          eventHandlers: {
            'apply.daterangepicker': function(event, picker) {
              $scope.sendBetweenDate();
            }
        }
        }
        $scope.totalPublished = 0;
        $scope.fields = [];
        $scope.profile = localStorage.getItem('ngStorage-userProfile').slice(1,-1);
        $scope.getMetrics();
      }
      $scope.getMetrics = function (){
        MetricService.display().then(function (resp){
          if(resp.status === 200){
              $scope.totalPublished = resp.data.metrics.published;
              $scope.assigned = resp.data.metrics.accepted;
              $scope.delivered = resp.data.metrics.delivered;
              $scope.cancelled = resp.data.metrics.cancelled;
              $scope.pod = resp.data.metrics.pod;

              $scope.fields = [resp.data.metrics];
              $scope.implementsCharts();
          }
        });
      }
      $scope.implementsCharts = function (){
        var configChart = {
          'status'    : ['published','accepted'],
          'status2'   : ['accepted','delivered'],
          'status3'   : ['cancelled','assigned','in_transit'],
          'status4'   : ['pod','delivered'],
          'lenguage'  : {
            'published' : $filter('translate')('metrics:status:published'),
            'accepted'  : $filter('translate')('metrics:status:assigned')
          },
          'lenguage2'  : {
            'accepted'  : $filter('translate')('metrics:status:assigned'),
            'delivered' : $filter('translate')('metrics:status:delivered')
          },
          'lenguage3'  : {
            'cancelled' : $filter('translate')('metrics:status:cancelled'),
            'assigned' : $filter('translate')('metrics:status:assigned'),
            'in_transit' : $filter('translate')('metrics:status:in_transit')
          },
          'lenguage4'  : {
            'pod' : $filter('translate')('metrics:status:pod'),
            'delivered' : $filter('translate')('metrics:status:delivered')
          },
          'colors' :  {'published':'#0422DC','assigned':'#00b4e4'},
          'colors2' : {'assigned':'#00b4e4','delivered':'#D4DD55'},
          'colors3' : {'cancelled':'#FF0000','assigned':'#00b4e4','in_transit':'#FFFB04'},
          'colors4' : {'pod':'#FF7304','delivered':'#D4DD55'},
        };
        var configChartCarrier = {
          'status'    : ['assigned','accepted'],
          'status2'   : ['accepted','delivered'],
          'status3'   : ['cancelled','assigned'],
          'status4'   : ['pod','delivered'],
          'lenguage'  : {
            'accepted' : $filter('translate')('metrics:status:accepted'),
            'assigned' : $filter('translate')('metrics:status:assigned')
          },
          'lenguage2'  : {
            'accepted' : $filter('translate')('metrics:status:accepted'),
            'delivered' : $filter('translate')('metrics:status:delivered')
          },
          'lenguage3'  : {
            'cancelled' : $filter('translate')('metrics:status:cancelled'),
            'assigned' : $filter('translate')('metrics:status:assigned')
          },
          'lenguage4'  : {
            'pod' : $filter('translate')('metrics:status:pod'),
            'delivered' : $filter('translate')('metrics:status:delivered')
          },
          'colors' :  {'accepted':'#0422DC','assigned':'#00b4e4'},
          'colors2' : {'accepted':'#0422DC','delivered':'#D4DD55'},
          'colors3' : {'cancelled':'#FF0000','assigned':'#D4DD55'},
          'colors4' : {'pod':'#FF7304','delivered':'#D4DD55'},
        };
        var configure = ($scope.profile == 'CARRIER') ? configChartCarrier : configChart;

        $scope.makeChartBar3D('chartdiv', configure.status,  configure.lenguage, configure.colors);
        $scope.makeChartBar3D('chart2div',configure.status2, configure.lenguage2, configure.colors2);
        $scope.makeChartBar3D('chart3div',configure.status3, configure.lenguage3, configure.colors3);
        $scope.makeChartBar3D('chart4div',configure.status4, configure.lenguage4, configure.colors4);

      }
      $scope.getCharts = function (elem, status,lenguage,colors){
        var chart = am4core.create(elem, am4charts.PieChart);
        chart.data = processPieData(status)['data'];
        // Add and configure Series
        var pieSeries = chart.series.push(new am4charts.PieSeries());
        pieSeries.dataFields.value = "value";
        pieSeries.dataFields.category = "text";
        pieSeries.slices.template.stroke = am4core.color("#fff");
        pieSeries.slices.template.strokeWidth = 2;
        pieSeries.slices.template.strokeOpacity = 1;
        // This creates initial animation
        pieSeries.hiddenState.properties.opacity = 1;
        pieSeries.hiddenState.properties.endAngle = -90;
        pieSeries.hiddenState.properties.startAngle = -90;

        chart.hiddenState.properties.radius = am4core.percent(0);


        $scope.$on("$destroy", function () {
          chart.dispose();
        });


      };
      $scope.getCharts3D = function (element,status,lenguage,colors){
        var chart = am4core.create(element, am4charts.PieChart3D);
        chart.hiddenState.properties.opacity = 0; // this creates initial fade-in

        chart.data = processPieData(status);

        chart.innerRadius = am4core.percent(100);
        chart.depth = 120;

        //chart.legend = new am4charts.Legend();

        var series = chart.series.push(new am4charts.PieSeries3D());
        series.dataFields.value = "value";
        series.dataFields.category = "text";
        series.slices.template.cornerRadius = 5;
        series.colors.step = 3;
      }
      $scope.makeChartBar = function (element,status,lenguage,colors){
        // Create chart instance
        var chart = am4core.create(element, am4charts.XYChart);
        chart.scrollbarX = new am4core.Scrollbar();
        // Add data
        chart.data = processPieData(status);
        // Create axes
        var categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "text";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;
        categoryAxis.renderer.minHeight = 110;

        var valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.renderer.minWidth = 50;
        // Create series
        var series = chart.series.push(new am4charts.ColumnSeries());
        series.sequencedInterpolation = true;
        series.dataFields.valueY = "value";
        series.dataFields.categoryX = "text";
        series.tooltipText = "[{categoryX}: bold]{valueY}[/]";
        series.columns.template.strokeWidth = 0;

        series.tooltip.pointerOrientation = "vertical";

        series.columns.template.column.cornerRadiusTopLeft = 10;
        series.columns.template.column.cornerRadiusTopRight = 10;
        series.columns.template.column.fillOpacity = 0.8;
        // on hover, make corner radiuses bigger
        var hoverState = series.columns.template.column.states.create("hover");
        hoverState.properties.cornerRadiusTopLeft = 0;
        hoverState.properties.cornerRadiusTopRight = 0;
        hoverState.properties.fillOpacity = 1;

        series.columns.template.adapter.add("fill", function(fill, target) {
          return chart.colors.getIndex(target.dataItem.index);
        });
        // Cursor
        chart.cursor = new am4charts.XYCursor();

        $scope.$on("$destroy", function () {
          chart.dispose();
        });

      }
      $scope.makeChartBar3D = function (element,status,lenguage,colors){
        // Create chart instance
        var chart = am4core.create(element, am4charts.XYChart3D);
        // Add data
        chart.data = processPieData(status,lenguage,colors)['data'];
        // Create axes
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "text";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.renderer.labels.template.hideOversized = false;
        categoryAxis.renderer.minGridDistance = 20;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.tooltip.label.rotation = 270;
        categoryAxis.tooltip.label.horizontalCenter = "right";
        categoryAxis.tooltip.label.verticalCenter = "middle";

        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.title.text = "Cargas";
        valueAxis.title.fontWeight = "bold";

        // Create series
        var series = chart.series.push(new am4charts.ColumnSeries3D());
        series.dataFields.valueY = "value";
        series.dataFields.categoryX = "text";
        series.name = "Cargas";
        series.tooltipText = "{categoryX}: [bold]{valueY}[/]";
        series.columns.template.fillOpacity = .8;

        var columnTemplate = series.columns.template;
        columnTemplate.strokeWidth = 2;
        columnTemplate.strokeOpacity = 1;
        columnTemplate.stroke = am4core.color("#FFFFFF");

        var color = processPieData(status,lenguage,colors)['color'];

        series.columns.template.adapter.add("fill", function(fill, target){
          return am4core.color(color[target.dataItem.index]);
        });

        columnTemplate.adapter.add("stroke", function(stroke, target) {
          return chart.colors.getIndex(target.dataItem.index);
        })

        chart.cursor = new am4charts.XYCursor();
        chart.cursor.lineX.strokeOpacity = 0;
        chart.cursor.lineY.strokeOpacity = 0;

        $scope.$on("$destroy", function () {
          chart.dispose();
        });

      }
      $scope.getDataUser = function (){
        Auth.getInfoUser().then(function (resp){
          $scope.user     = resp.data.Info_perfil.dataUser;
        });
      }
      var processPieData = function(status,lenguage,colors){
        var data = [];var keys = [];var values = {}; var color = [];var published = 0;
        if($scope.fields.length > 0){
          keys = Object.keys($scope.fields[0]);
          angular.forEach(keys, function(value, key){
            values[value] = 0;
          });
        }
        angular.forEach($scope.fields, function(item, key){
          angular.forEach(keys, function(value, key){
            values[value] = values[value] + item[value];
          });
        });
        angular.forEach(values, function(value, key){
          if(key !== 'date' && status.indexOf(key) > -1){
            data.push({text: lenguage[key], value: value});
            color.push(colors[key]);
          }
          if(key == 'published'){
            published += value;
          }

        });

        fields = {'data' : data,'color': color, 'total' : published};
        return fields;
      };
      $scope.sendBetweenDate = function (){
        var fields = {
            'from' : $scope.betweenDate.startDate.format('YYYY-MM-DD'),
            'to' : $scope.betweenDate.endDate.format('YYYY-MM-DD')
        }
        MetricService.show(fields).then(function (resp){
          if (resp.data.metrics.length < 1){
            return toastr.warning($filter('translate')('metrics:empty:info'));
          }
          $scope.totalPublished = resp.data.metrics.published;
          $scope.assigned = resp.data.metrics.accepted;
          $scope.delivered = resp.data.metrics.delivered;
          $scope.cancelled = resp.data.metrics.cancelled;
          $scope.pod = resp.data.metrics.pod;
          
          $scope.fields = [resp.data.metrics];
          $scope.implementsCharts();
        });
      }

      $scope.construct();

    }
  }
}

(function() {
  'use strict';
/* Load services
 * Get different counts of loads
 * Get loads by user profile
 * Get loads log by user profile
 * Get load attributes lists
 * Create and update load
 * Get load info
 * Get carrier requests of a load
 * Create request to apply to the load by carrier
 * Cancel my request sent (carrier)
 * Accept carrier request
 * Upload invoice to the load
 * Looking for loads
 * Report issue
 * Cancel load by shipper
 */

  angular
    .module('loadsAppWeb')
    .service('Loads', LoadServices);

  /** @ngInject */
  function LoadServices($q, $http, Config, Upload, $localStorage, $location) {
	var vm = this;
	vm.api_endpoint_loads = Config.ENV.API_ENDPOINT +'v1/'+ 'loads/';

	vm.totalItems = function(params)
	{
	  var defer = $q.defer();
	  var url = vm.api_endpoint_loads + 'LoadsByProfile';
    $http.post(url, params).then(function(response) {
      if(response.data.status == 'ok' ){
          defer.resolve(response.data.message);
        }else{
          defer.reject(false);
        }

    }).catch(function(response) {
      /*I do created method for token validate by code 401*/
      vm.tokenValidate(response);
      defer.reject(false);
    });

    return defer.promise;

	};
	vm.tokenValidate = function (items){
	  switch (items.status) {
      case 401:
          $localStorage.$reset();
          $location.path('login');
        break
    }
  }
  vm.getByUserRol = function(params)
  {
    // Defer
        var defer = $q.defer();
        // Url
        var url = vm.api_endpoint_loads + 'getLoadsforUserRol';

        // Get
        $http.post(url, params)
            .then(function(response) {
                // Success
                if(response.data.status == 'ok' ){
                  defer.resolve(response.data.message);
                }else{
                  defer.reject(false);
                }
            })
            .catch(function(response) {
                // Error

                defer.reject(false);
            });

        return defer.promise;
  };

  vm.getLoadsHistoryByUserRol = function(params)
  {
    // Defer
        var defer = $q.defer();
        // Url
        var url = vm.api_endpoint_loads + 'getLoadsHistoryforUserRol';

        // Get
        $http.post(url, params)
            .then(function(response) {
                // Success
                if(response.data.status == 'ok' ){
                  defer.resolve(response.data.message);
                }else{
                  defer.reject(false);
                }
            })
            .catch(function(response) {
                // Error

                defer.reject(false);
            });

        return defer.promise;
  };

  vm.getItemsSizeLengthLoads = function()
  {
    // Defer
        var defer = $q.defer();
        // Url
        var url = vm.api_endpoint_loads + 'getItemsSizeLengthLoads';

        // Get
        $http.post(url)
            .then(function(response) {
                // Success
                if(response.data.status == 'ok' ){
                  defer.resolve(response.data.message);
                }else{
                  defer.reject(false);
                }
            })
            .catch(function(response) {
                // Error

                defer.reject(false);
            });

        return defer.promise;
  };

  vm.saveLoad = function(params)
  {
    // Defer
        var defer = $q.defer();
        // Url
        var url = vm.api_endpoint_loads + 'loadPostByLoadGenerator';

        // Get
        $http.post(url, params)
            .then(function(response) {
                // Success
                if(response.data.status == 'ok' ){
                  defer.resolve(response.data.message);
                }else{
                  defer.reject(false);
                }
            })
            .catch(function(response) {
                // Error

                defer.reject(false);
            });

        return defer.promise;
  };

  vm.updateLoad = function(params)
  {
    // Defer
        var defer = $q.defer();
        // Url
        var url = vm.api_endpoint_loads + 'loadupdateByLoadGenerator';

        // Get
        $http.post(url, params)
            .then(function(response) {
                // Success
                if(response.data.status == 'ok' ){
                  defer.resolve(response.data.message);
                }else{
                  defer.reject(false);
                }
            })
            .catch(function(response) {
                // Error

                defer.reject(false);
            });

        return defer.promise;
  };

  vm.getLoadDetails = function(params)
  {
    // Defer
        var defer = $q.defer();
        // Url
        var url = vm.api_endpoint_loads + 'loadDetails';

        // Get
        $http.post(url, params)
            .then(function(response) {
                // Success
                if(response.data.status == 'ok' ){
                  defer.resolve(response.data.message);
                }else{
                  defer.reject(false);
                }
            })
            .catch(function(response) {
                // Error

                defer.reject(false);
            });

        return defer.promise;
  };

  vm.getCarrierRequests = function(params)
  {
    // Defer
        var defer = $q.defer();
        // Url
        var url = vm.api_endpoint_loads + 'getRequestCarrierLoads';

        // Get
        $http.post(url, params)
            .then(function(response) {
                // Success
                if(response.data.status == 'ok' ){
                  defer.resolve(response.data.message);
                }else{
                  defer.reject(false);
                }
            })
            .catch(function(response) {
                // Error

                defer.reject(false);
            });

        return defer.promise;
  };

  vm.acceptCarrierRequest = function(params)
  {
    // Defer
        var defer = $q.defer();
        // Url
        var url = vm.api_endpoint_loads + 'setRequestCarrierLoads';

        // Get
        $http.post(url, params)
            .then(function(response) {
                // Success
                if(response.data.status == 'ok' ){
                  defer.resolve(response.data.message);
                }else{
                  defer.reject(false);
                }
            })
            .catch(function(response) {
                // Error

                defer.reject(false);
            });

        return defer.promise;
  };

  vm.uploadInvoiceToLoad = function(params)
  {
    // Defer
        var defer = $q.defer();
        // Url
        var url = vm.api_endpoint_loads + 'uploadInvoiceToLoad';

        // Get
        Upload.upload({url: url, data: params})
          .then(function(response) {
                // Success
                console.log(response);
                if(response.data.status == 'ok' ){
                  defer.resolve(response.data.message);
                }else{
                  defer.reject(false);
                }
            })
            .catch(function(response) {
                // Error

                defer.reject(false);
            });

        return defer.promise;
  };

  vm.searchLoads = function(params)
  {
    // Defer
        var defer = $q.defer();
        // Url
        var url = vm.api_endpoint_loads + 'searchLoads';

        // Get
        $http.post(url, params)
            .then(function(response) {
                // Success
                if(response.data.status == 'ok' ){
                  defer.resolve(response.data.message);
                }else{
                  defer.reject(false);
                }
            })
            .catch(function(response) {
                // Error

                defer.reject(false);
            });

        return defer.promise;
  };

  vm.createRequestCarrierLoad = function(params)
  {
    // Defer
        var defer = $q.defer();
        // Url
        var url = vm.api_endpoint_loads + 'CreateRequestCarrierLoads';

        // Get
        $http.post(url, params)
            .then(function(response) {
                // Success
                if(response.data.status == 'ok' ){
                  defer.resolve(response.data.message);
                }else{
                  defer.reject(false);
                }
            })
            .catch(function(response) {
                // Error

                defer.reject(false);
            });

        return defer.promise;
  };

  vm.cancelRequestCarrierLoad = function(params)
  {
    // Defer
        var defer = $q.defer();
        // Url
        var url = vm.api_endpoint_loads + 'CanceldRequestCarrierLoads';

        // Get
        $http.post(url, params)
            .then(function(response) {
                // Success
                if(response.data.status == 'ok' ){
                  defer.resolve(response.data.message);
                }else{
                  defer.reject(false);
                }
            })
            .catch(function(response) {
                // Error

                defer.reject(false);
            });

        return defer.promise;
  };

  vm.setLoadInTransitByDriver = function(params)
  {
    // Defer
    var defer = $q.defer();
    // Url
    var url = vm.api_endpoint_loads + 'loadChangueStatus';
    params.load_status = Config.ENV.IN_TRANSIT_STATUS;

    // Get
    $http.post(url, params)
        .then(function(response) {
            // Success
            if(response.data.status == 'ok' ){
              defer.resolve(response.data.message);
            }else{
              defer.reject(false);
            }
        })
        .catch(function(response) {
            // Error

            defer.reject(false);
        });

    return defer.promise;

  };

    vm.setLoadStatus = function(params)
    {
      // Defer
      var defer = $q.defer();
      // Url
      var url = vm.api_endpoint_loads + 'loadChangueStatus';
      // Get
      $http.post(url, params)
        .then(function(response) {
          // Success
          if(response.data.status == 'ok' ){
            defer.resolve(response.data.message);
          }else{
            defer.reject(false);
          }
        })
        .catch(function(response) {
          // Error

          defer.reject(false);
        });

      return defer.promise;
    };

  vm.setLoadDeliveredByDriver = function(params)
  {
    // Defer
    var defer = $q.defer();
    // Url
    var url = vm.api_endpoint_loads + 'loadChangueStatus';
    params.load_status = Config.ENV.DELIVERED_STATUS;

    // Get
    $http.post(url, params)
        .then(function(response) {
            // Success
            if(response.data.status == 'ok' ){
              defer.resolve(response.data.message);
            }else{
              defer.reject(false);
            }
        })
        .catch(function(response) {
            // Error

            defer.reject(false);
        });

    return defer.promise;

  };

  vm.reportIssueToLoad = function(params)
  {
    // Defer
        var defer = $q.defer();
        // Url
        var url = vm.api_endpoint_loads + 'ReportLoadIssues';

        // Get
        $http.post(url, params)
            .then(function(response) {
                // Success
                if(response.data.status == 'ok' ){
                  defer.resolve(response.data.message);
                }else{
                  defer.reject(false);
                }
            })
            .catch(function(response) {
                // Error

                defer.reject(false);
            });

        return defer.promise;
  };

  vm.cancelLoad = function(params)
  {
    // Defer
        var defer = $q.defer();
        // Url
        var url = vm.api_endpoint_loads + 'cancelLoad';

        // Get
        $http.post(url, params)
            .then(function(response) {
                // Success
                if(response.data.status == 'ok' ){
                  defer.resolve(response.data.message);
                }else{
                  defer.reject(false);
                }
            })
            .catch(function(response) {
                // Error

                defer.reject(false);
            });

        return defer.promise;
  };

    vm.rejectTmsRequest = function(params)
    {
      // Defer
      var defer = $q.defer();
      // Url
      var url = vm.api_endpoint_loads + 'loadChangueStatus';
      params.load_status = Config.ENV.CANCELLED_STATUS;

      // Get
      $http.post(url, params)
        .then(function(response) {
          // Success
          if(response.data.status == 'ok' ){
            defer.resolve(response.data.message);
          }else{
            defer.reject(false);
          }
        })
        .catch(function(response) {
          // Error

          defer.reject(false);
        });

      return defer.promise;

    };

  vm.checkLoadPriceWs = function(params)
  {
    // Defer
        var defer = $q.defer();
        // Url
        var url = vm.api_endpoint_loads + 'getPriceLoads';

        // Get
        $http.post(url, params)
            .then(function(response) {
                // Success
                if(response.data.status == 'ok' ){
                  defer.resolve(response.data.message);
                }else{
                  defer.reject(false);
                }
            })
            .catch(function(response) {
                // Error

                defer.reject(false);
            });

        return defer.promise;
  };
    vm.getZipCodeByCountry = function(zip_code,country){
      let api = Config.ENV.API_ENDPOINT +'v1/postal-codes?codes=' + zip_code + '&country=' +country;
      return $http.get(api, null);
    };
    vm.stopDisplay = function (id){
      let api = Config.ENV.API_ENDPOINT +'v1/loads/'+ id +'/stops';
      return $http.get(api, null);
    }
    vm.stopEvinceForm = function (load_id,stop_id){
      let api = Config.ENV.API_ENDPOINT +'v1/loads/'+ load_id +'/stops/'+stop_id+'/checklist';
      return $http.get(api, null);
    }
    vm.getStatusByLoad = function (id){
      let api = Config.ENV.API_ENDPOINT +'v1/loads/'+ id +'/status';
      return $http.get(api, null);
    }
    vm.updateStatusLoad = function (load_id,stop_id,fields){
      let api = Config.ENV.API_ENDPOINT +'v1/loads/'+ load_id +'/stops/'+ stop_id+'/status';
      return $http.post(api, fields);
    }
    vm.createAnswerStop = function(load_id,stop_id,checklist_id,fields){
      let api = Config.ENV.API_ENDPOINT +'v1/loads/'+ load_id +'/stops/'+ stop_id +'/checklist/'+ checklist_id +'/answer';
      return $http.post(api, fields);
    }
    vm.createFormByStop = function(load_id,stop_id,fields){
      let api = Config.ENV.API_ENDPOINT +'v1/loads/'+ load_id +'/stops/'+ stop_id +'/checklist';
      return $http.post(api, fields);
    }
    vm.removeFormByStop = function(load_id,stop_id,checklist_id){
      let api = Config.ENV.API_ENDPOINT +'v1/loads/'+ load_id +'/stops/'+ stop_id +'/checklist/'+checklist_id;
      return $http.delete(api, null);
    }
    vm.removeFieldByForm = function(form_id,field_id){
      let api = Config.ENV.API_ENDPOINT +'v1/forms/'+ form_id +'/fields/'+ field_id;
      return $http.delete(api, null);
    }
    vm.updateInfoForm = function(form_id,fields){
      let api = Config.ENV.API_ENDPOINT +'v1/forms/'+ form_id;
      return $http.put(api, fields);
    }
    vm.storeFieldByForm = function(form_id,fields){
      let api = Config.ENV.API_ENDPOINT +'v1/forms/'+ form_id+'/fields';
      return $http.post(api, fields);
    }


  }
})();

angular.module('loadsAppWeb').directive('stopComponent', stopComponent);

function stopComponent(sweetAlert, swangular, Loads, toastr, $filter, Auth){
  return {
    templateUrl: "app/loads/templates/tabs/tab-stop.html",
    restrict: 'E',
    scope:{
      data:"="
    },
    controller : function ($scope, $stateParams){

      $scope.construct = function (){
        $scope.load_id = $stateParams.id;
        $scope.evince = [];
        $scope.i = 0; $scope.j = 0;
        $scope.checkboxs = [];
        $scope.moreAddFields = [];
        $scope.getDataUser();
        $scope.getStopsByLoads();
      }

      $scope.getDataUser = function (){
        Auth.getInfoUser().then(function (resp){
          $scope.user     = resp.data.Info_perfil.dataUser;
        });
      }
      $scope.getStopsByLoads = function (){
        $scope.loading = true;
        Loads.stopDisplay($scope.load_id).then(function (response){
          $scope.items = response.data.results;
          $scope.loading = false;
        });
      }
      $scope.displayForms = function (display){
        var that = this;
         angular.forEach($scope.items, function (item){
              if (item.id == that.item.id){
                  $scope.evince[item.id] = !display;
              }else{
                $scope.evince[item.id] = false;
              }
         });
         $scope.stop_id = that.item.id;
         $scope.evinceFormByStop(that.item.id);
      }

      $scope.evinceFormByStop = function (stop_id){
        $scope.loading = true;
        $scope.checklistForm = [];
        $scope.answers = {};
        Loads.stopEvinceForm($scope.load_id,stop_id).then(function(response){
          if(angular.isDefined(response.data.results[0])){
            $scope.checklistForm = response.data.results;
            if ($scope.checklistForm.length > 0){
              angular.forEach($scope.checklistForm,function (value){
                angular.forEach(value.form.fields, function (values){
                  $scope.answers[values.id] = values.answer;
                });
              });
            }
          }
          $scope.loading = false;
        });

      }

      $scope.setTypeField = function (){
        if ($scope.item.form.fields[this.field.id].type == "checkbox" || $scope.item.form.fields[this.field.id].type == "select"){
            $scope.addMoreCheck();
        }

      }
      $scope.makeFormLetter = function (){
        $scope.item = {
          form:{
              name: 'Checklist',
              type: 'instruction-letter',
              fields: {}
            }
        };
        $scope.moreAddFields = [];
        $scope.addMoreFields();
        $scope.getTypeFields();
          swangular.open({
            title: "¡ Agregar Instrucciones!",
            htmlTemplate: "app/loads/templates/forms/create-form.html",
            type: "info",
            scope: $scope,
            buttonsStyling: true,
            confirmButtonColor: "#D4DD55",
            cancelButtonColor: "#d33",
            showCancelButton: true,
            showConfirmButton: true,
            confirmButtonText: "Aceptar",
            cancelButtonText: "Cancelar",
            allowOutsideClick: false,
            closeOnConfirm: true,
            closeOnCancel: true,
            showLoaderOnConfirm: true,
            width: '700px'
          }).then(function(result) {
            if(angular.isDefined(result)) {
              if(result.value) {
                  Loads.createFormByStop($scope.load_id,$scope.stop_id,$scope.item).then(function (response){
                      if (response.status == 201){
                        toastr.success("Se creo correctamente el formulario");
                        $scope.evinceFormByStop($scope.stop_id);
                      }
                  });
              }
            }
          });

      }
      $scope.getTypeFields = function (){
        $scope.cmbTypeFields =[
          {id: "number",name:"Numerico"},
          {id: "text", name:"Respuesta Corta"},
          {id: "checkbox", name:"Casillas"},
          {id: "select", name:"Desplegable"},
          {id: "textarea", name:"Parrafo"},
          {id: "sign", name:"Firma"},
          {id: "gallery", name:"Galeria"},
          {id: "file", name:"Archivo"},
          {id: "pod", name:"POD"}
        ]
      }
      $scope.addMoreCheck = function (edit){
        if (edit){
          $scope.ii++;
          $scope.checkboxs.push({id: $scope.ii, value: "", text : "" });
        }else{
          $scope.checkboxs.push({id: $scope.i, value: "", text : "" });
          $scope.i++;
        }

      }
      $scope.removeCheck = function (indice,edit){
        angular.forEach($scope.checkboxs, function (value, key){
          if (edit && value.id == indice){
            console.log(value);
          }
          if(value.id == indice){
            $scope.checkboxs.splice(key,1);
          }
        });
        $scope.i--;$scope.ii--;

      }
      $scope.addMoreFields = function (edit){
        if (edit){
          angular.forEach($scope.moreAddFields, function (value,key){
              $scope.jj++
          });
          $scope.moreAddFields.push({id: $scope.jj, title:"",type:""});
          console.log($scope.moreAddFields);
        }else{
          $scope.moreAddFields.push({id: $scope.j, title:"",type:""});
          $scope.j++;
        }

      }
      $scope.removeFields = function (indice,edit){
        angular.forEach($scope.moreAddFields, function (value, key){
          if (edit && value.id == indice && angular.isDefined($scope.item.form.fields[indice])){
            var field_id = $scope.item.form.fields[indice].id;
            var form_id = $scope.item.form.id;
            Loads.removeFieldByForm(form_id,field_id).then(function (resp){
                $scope.evinceFormByStop($scope.stop_id);
            });
          }
          if(value.id == indice){
            $scope.moreAddFields.splice(key,1);
            delete $scope.moreAddFields[key];
          }
        });
        $scope.j--;$scope.jj--;
      }
      $scope.setTextOfOption = function (){
          $scope.item.form.fields[this.field.id].options[this.checkbox.id].text = $scope.item.form.fields[this.field.id].options[this.checkbox.id].value
      }
      $scope.removeFormByStop = function (){
         var checklist_id = this.dynamic.id;
        $scope.loading = true;
         Loads.removeFormByStop($scope.load_id,$scope.stop_id,checklist_id).then(function (response){
              if (response.status == 204){
                toastr.success("Se elmino correctamente el registro");
                $scope.evinceFormByStop($scope.stop_id);
              }
           $scope.loading = false;
         });
      }
      $scope.editFormLetter = function (){
        $scope.item = this.dynamic;
        $scope.edit = true;
        $scope.getTypeFields();
        $scope.moreAddFields = [];
        $scope.checkboxs = [];
        $scope.ii = 0; $scope.jj = 0;
        angular.forEach($scope.item.form.fields, function (value){
          $scope.moreAddFields.push({id: $scope.ii, title: value.title ,type: value.type});

          if (value.type == "checkbox" || value.type == "select"){
            angular.forEach(value.options,function (option){
              $scope.checkboxs.push({id: $scope.jj, value: option.value, text : option.text });
              $scope.jj ++;
            });
          }
          $scope.ii ++;

        });
        swangular.open({
          title: "¡ Agregar Instrucciones!",
          htmlTemplate: "app/loads/templates/forms/create-form.html",
          type: "info",
          scope: $scope,
          buttonsStyling: true,
          confirmButtonColor: "#D4DD55",
          cancelButtonColor: "#d33",
          showCancelButton: true,
          showConfirmButton: true,
          confirmButtonText: "Aceptar",
          cancelButtonText: "Cancelar",
          allowOutsideClick: false,
          closeOnConfirm: true,
          closeOnCancel: true,
          showLoaderOnConfirm: true,
          width: '700px'
        }).then(function(result) {
          if(angular.isDefined(result)) {
            if(result.value) {
              var fields = {
                'name' : $scope.item.form.name
              }
              Loads.updateInfoForm($scope.item.form.id, fields).then(function (response){
                if (response.status == 200){
                  toastr.success("Se actualizo el formulario");
                  $scope.evinceFormByStop($scope.stop_id);
                }
              });
            }
          }
        });
      }
      $scope.storeFields = function (indice, edit){
        if (edit){
          var form_id = this.item.form.id;
          if (this.item.form.fields.length > 0){
            var fields = this.item.form.fields[indice];
            Loads.storeFieldByForm(form_id,fields).then(function (resp){
              $scope.evinceFormByStop($scope.stop_id);
            });
          }
        }
      }
      $scope.saveAnswers = function (){
        $scope.answer = [];
        var that = this;
        angular.forEach($scope.answers, function(value,key){
          $scope.answer.push({
            field_id : key,
            value : value
          });
        });
        $scope.loading = true;
        angular.forEach($scope.answer, function(answer){
          Loads.createAnswerStop($scope.load_id,$scope.stop_id,that.dynamic.id,answer).then(function(response){
            console.log(response);
            //toastr.success("¡Se envio la informacion correctamente!");
          });
        });
        $scope.loading = false;
        toastr.success("¡Se envio la informacion correctamente!");

      }

      $scope.construct();

    }
  }
}

(function() {
  'use strict';

  /* Load details Directive
   * It shows load info in dropdown of trucks table list
   * It is a generic element is loaded when user click in dropdown button of item */

  angular.module('loadsAppWeb').directive('loadDetailsRow', loadDetailsRow);
  /** @ngInject */
  function loadDetailsRow(
    $rootScope,
    Auth,
    Loads,
    uiGmapGoogleMapApi,
    uiGmapIsReady,
    $uibModal,
    $filter,
    Config,
    Trucks,
    Carriers,
    $log,
    toastr,
    flux,
    sweetAlert,
    swangular
  ) {
    return {
        templateUrl: 'app/loads/templates/directives/load-details-row.html',
        restrict: 'E',
        replace: true,
        scope: {
          loadId: '=', //Input of directive, Load id
          reloadParent: '&', //Input of directive, Funcion from loads table which reload items of the table
          posteverywhere: '=' //Input of directive, posteverywhere info
        },
        link: function(scope) {
            scope.loadingMap = true;
            scope.loadData = {};
            scope.loadingLoadData = true;
            scope.loadInvoiceImgFilesList = [];
            scope.loadInvoiceDocsFilesList = [];
            scope.loadLegalImgFilesList = [];
            scope.loadLegalDocsFilesList = [];
            scope.legalDocFileSaving = false;
            scope.userDataProfile = Auth.getUserDataProfile();
            scope.dataUser = Auth.getUserData();
            /**
             * Initialize
             */
            scope.initialize = function() {
                scope.loadOptions = {
                  'token': Auth.getUserToken(),
                  'load_id': scope.loadId
                };
                scope.getLoadDetails();
                scope.getStatusByLoad();
            };

            /* Load the map and set load coordinates */
            scope.initializeMap = function(){
              if( angular.isDefined(scope.loadData.from_lat)  &&
                  scope.loadData.from_lat != ""               &&
                  angular.isDefined(scope.loadData.from_long) &&
                  scope.loadData.from_long != ""              &&
                  angular.isDefined(scope.loadData.to_lat)    &&
                  scope.loadData.to_lat != ""                 &&
                  angular.isDefined(scope.loadData.to_long)   &&
                  scope.loadData.to_long != ""
              ){
                uiGmapGoogleMapApi.then(function(maps) {
                 scope.loadingMap = false;
                 scope.map = { center: { latitude: scope.loadData.from_lat, longitude: scope.loadData.from_long }, zoom: 14 };
                 scope.markers = [
                                  {id: 111, coords: { latitude: scope.loadData.from_lat, longitude: scope.loadData.from_long}, options: { icon: "assets/images/common/start_point.png" } },
                                  {id: 222, coords: { latitude: scope.loadData.to_lat, longitude: scope.loadData.to_long}, options: { icon: "assets/images/common/end_point.png" } }];

                 if(angular.isDefined(scope.loadData.info_truck)){
                    if(angular.isDefined(scope.loadData.info_truck.latitud_truck) && angular.isDefined(scope.loadData.info_truck.longitud_truck)){
                      scope.markers.push({id: 333, coords: {latitude: scope.loadData.info_truck.latitud_truck, longitude: scope.loadData.info_truck.longitud_truck}, options: { icon: "assets/images/common/truck-marker.png"} });
                    }
                  }

                  if(angular.isDefined(scope.loadData.stops_loads)){
                    if(scope.loadData.stops_loads.length > 0){
                      for(var imstp in scope.loadData.stops_loads){
                        var sumatoria = parseInt(imstp) + 1;

                        if(sumatoria > 10){
                          scope.markers.push({id: scope.loadData.stops_loads[imstp].loads_id+""+scope.loadData.stops_loads[imstp].id.toString(), coords: {latitude: scope.loadData.stops_loads[imstp].lat_stop, longitude: scope.loadData.stops_loads[imstp].long_stop}, options: { icon: "assets/images/common/point_greater_10.png" }});
                        }else{
                          scope.markers.push({id: scope.loadData.stops_loads[imstp].loads_id+""+scope.loadData.stops_loads[imstp].id.toString(), coords: {latitude: scope.loadData.stops_loads[imstp].lat_stop, longitude: scope.loadData.stops_loads[imstp].long_stop}, options: { icon: "assets/images/common/point_"+sumatoria+".png" }});
                        }
                      }
                    }
                  }
                });

                uiGmapIsReady.promise(1).then(function(maps) {
                  google.maps.event.trigger(maps, 'resize');
                });
              }
            };

            /* Get load info */
            scope.getLoadDetails =  function() {
              Loads.getLoadDetails(scope.loadOptions).then(function(response){
                  scope.loadData = response.result;
                  scope.search_type = $rootScope.search_type;
                  if(angular.isDefined(scope.loadData.load_documents) && scope.loadData.load_documents.length){
                    var arr_img; var elements_img;
                    scope.loadData.load_documents.forEach(function (value){
                        if (value.type_file == 'pdf'){
                          elements_img = value.invoice_file.split("/");
                          if(value.invoice_type == 'legal_doc'){
                            scope.loadLegalDocsFilesList.push({
                              id            : value.id,
                              url           : value.invoice_file,
                              title         : elements_img[elements_img.length - 1],
                              invoice_name  : value.invoice_name
                            });
                          }else{
                            scope.loadInvoiceDocsFilesList.push({
                              id: value.id,
                              url: value.invoice_file,
                              title: elements_img[elements_img.length - 1],
                              invoice_name: value.invoice_name
                            });
                          }

                        }else{
                          arr_img = $.parseJSON('['+value.invoice_file+']');
                          elements_img = arr_img[0][0].normal.split("/");
                          if(value.invoice_type == 'legal_doc'){
                            scope.loadLegalImgFilesList.push({
                              id: value.id,
                              url: arr_img[0][0].normal,
                              invoice_name: elements_img[elements_img.length - 1],
                              title: value.invoice_name
                            });
                          }else{
                            scope.loadInvoiceImgFilesList.push({
                              id: value.id,
                              url: arr_img[0][0].normal,
                              invoice_name: elements_img[elements_img.length - 1],
                              title: value.invoice_name
                            });
                          }

                        }
                    });
                  }
                  if(angular.isDefined(scope.loadData.status_loads)){
                    var bgColorBtn = ''
                    , colorBtn = '';
                    switch(scope.loadData.status_loads){
                      case 'NOT_ASSIGNED':
                        bgColorBtn = 'bg-color-7';
                        colorBtn = 'color-armadillo';
                        break;
                      case 'ACEPTADA':
                        bgColorBtn = 'bg-color-10';
                        colorBtn = 'color-white';
                        break;
                      case 'EN_TRANSITO':
                        bgColorBtn = 'bg-color-5';
                        colorBtn = 'color-black';
                        break;
                      case 'ENTREGADA':
                        bgColorBtn = 'bg-color-9';
                        colorBtn = 'color-black';
                        break;
                      default:
                        bgColorBtn = 'bg-color-7';
                        colorBtn = 'color-armadillo';
                        break;
                    }

                    scope.loadData.status_load_btnbg = bgColorBtn;
                    scope.loadData.status_load_btncolor = colorBtn;
                    scope.loadData.status_load_btntext = $filter('translate')('loads:table:status:' +scope.loadData.status_loads.toLowerCase()+ ':text');
                  }
                  if(angular.isDefined(scope.loadData.type_load) && scope.loadData.type_load.length){
                    var arr_typeload = [];
                    for(var i in scope.loadData.type_load){
                      arr_typeload.push(scope.loadData.type_load[i].skill_name);
                    }
                    scope.loadData.type_load_text = arr_typeload.join(', ');
                  }else{
                    scope.loadData.type_load_text = "";
                  }
                  if(angular.isDefined(scope.loadData.skills_required_carrier) && scope.loadData.skills_required_carrier.length){
                    var arr_carrier_skills_required = [];
                    for(var i in scope.loadData.skills_required_carrier){
                      arr_carrier_skills_required.push(scope.loadData.skills_required_carrier[i].skills_required_name);
                    }
                    scope.loadData.carrier_skills_required_text = arr_carrier_skills_required.join(', ');
                  }else{
                    scope.loadData.carrier_skills_required_text = "";
                  }

                  scope.loadData.truck_type_text = "";
                  if(angular.isDefined(scope.loadData.truck_type_load)){
                    if(angular.isDefined(scope.loadData.truck_type_load.id)){
                      scope.loadData.truck_type_text = scope.loadData.truck_type_load.truck_type_name;
                    }
                  }

                  scope.loadData.price_to_show = '$' + scope.loadData.price;
                  if(scope.loadData.posteverywhere === "1" && scope.loadData.price === 0){
                    scope.loadData.price_to_show = $filter('translate')('loads:table:price:call:text');
                  }

                  scope.loadData.trailer_type_desc = '';
                  if(angular.isDefined(scope.loadData.trailer_type)){
                    if(angular.isDefined(scope.loadData.trailer_type.id)){
                      scope.loadData.trailer_type_desc = scope.loadData.trailer_type.trailer_type_name;
                    }
                  }

                  /*if(scope.loadData.timer_star_pickup){
                    var timer_star_pickup_aux = moment.tz(scope.loadData.timer_star_pickup, "UTC");
                    scope.loadData.timer_star_pickup = timer_star_pickup_aux.clone().tz("America/Mexico_City").format('YYYY-MM-DD HH:mm:ss');
                  }

                  if(scope.loadData.timer_finish_pickup){
                    var timer_finish_pickup_aux = moment.tz(scope.loadData.timer_finish_pickup, "UTC");
                    scope.loadData.timer_finish_pickup = timer_finish_pickup_aux.clone().tz("America/Mexico_City").format('YYYY-MM-DD HH:mm:ss');
                  }

                  if(scope.loadData.timer_start_delivery){
                    var timer_start_delivery_aux = moment.tz(scope.loadData.timer_start_delivery, "UTC");
                    scope.loadData.timer_start_delivery = timer_start_delivery_aux.clone().tz("America/Mexico_City").format('YYYY-MM-DD HH:mm:ss');
                  }

                  if(scope.loadData.timer_finish_delivery){
                    var timer_finish_delivery_aux = moment.tz(scope.loadData.timer_finish_delivery, "UTC");
                    scope.loadData.timer_finish_delivery = timer_finish_delivery_aux.clone().tz("America/Mexico_City").format('YYYY-MM-DD HH:mm:ss');
                  }*/

                  if(scope.loadData.weight != null && scope.loadData.weight != ''){
                    if(scope.loadData.weight.indexOf("lb") !== -1){
                      scope.loadData.weight = scope.loadData.weight.replace("lb", "kg");
                    }
                  }
                  scope.initializeMap();
                  scope.verifyOptionsDropdown();
                  scope.loadingLoadData = false;
                })
                .catch(function (error) {
                  $log.error(error);
                  scope.loadingLoadData = false;
                });
            };

            /* Call Carrier request list modal */
            scope.openCarrierRequestModal = function() {
              var modalInstance = $uibModal.open({
                controller: 'CarrierRequestsModalController as carrierrequests',
                windowClass: 'carrier-requests-modal',
                templateUrl: 'app/loads/templates/modal/carrier-requests.html',
                resolve: {
                    load: function() {
                        return scope.loadId;
                    }
                }
              });

              modalInstance.result.then(function() {
                  scope.loadingLoadData = true;
                  scope.initialize();
              });
            };

            /* Call Carrier assigned info modal */
            scope.openCarrierAssignedInfoModal = function() {
              var modalInstance = $uibModal.open({
                controller: 'CarrierAssignedInfoModalController as carrierassignedinfo',
                windowClass: 'carrier-assigned-info-modal',
                templateUrl: 'app/loads/templates/modal/carrier-assigned-info.html',
                resolve: {
                    carrier: function() {
                        return scope.loadData.carrier;
                    }
                }
              });
            };

            /* Call Load activity info modal */
            scope.openLoadActivityInfoModal = function() {
              var modalInstance = $uibModal.open({
                controller: 'LoadActivityInfoModalController as loadactivityinfo',
                windowClass: 'load-activity-info-modal',
                templateUrl: 'app/loads/templates/modal/load-activity-info.html',
                resolve: {
                    load: function() {
                        return scope.loadData;
                    }
                }
              });
            };

            /* Call Truck assigned info modal */
            scope.openTruckAssignedInfoModal = function() {
              var modalInstance = $uibModal.open({
                controller: 'TruckAssignedInfoModalController as truckassignedinfo',
                windowClass: 'truck-assigned-info-modal',
                templateUrl: 'app/loads/templates/modal/truck-assigned-info.html',
                resolve: {
                    truck: function() {
                        return scope.loadData.info_truck;
                    }
                }
              });
            };

            scope.getTrucksActive = function (){
              let truckOptions = {
                'shortcut': 'active',
                'token': Auth.getUserToken(),
                'page': 1
              };
              Trucks.trucksForCarrier(truckOptions).then(function (resp){
                scope.cmbTrucks = [];
                if (resp.truck_results.length > 0){
                  angular.forEach(resp.truck_results, function (value){
                    if (value.truck_type.id == scope.loadData.truck_type_load.id){
                      scope.cmbTrucks.push(value);
                    }
                    //scope.cmbTrucks.push(value);
                  });
                  scope.items.truck_id = (scope.loadData.info_truck || scope.loadData.info_truck != 0 )
                    ? scope.loadData.info_truck.id : "";
                }
              }).catch(function (error) {
                console.error(error);
              });
            }
            scope.getDriversActive = function (){
              Carriers.getDriverxCarrier({token: Auth.getUserToken()}).then(function(resp){
                scope.cmbDrivers = [];
                  if(resp.list_drivers.length > 0){
                    scope.cmbDrivers = resp.list_drivers;
                    scope.items.driver_id = (scope.loadData.info_truck || scope.loadData.info_truck != 0 )
                      ? (scope.loadData.info_truck.driver != null) ? scope.loadData.info_truck.driver.user_id: ""
                      : "";
                  }

              });
            }
            scope.selectTruckAndDriver = function (){
              scope.items = {};
              scope.getTrucksActive();
              scope.getDriversActive();
              swangular.open({
                title: $filter('translate')('modals:load_truck_select:title'),
                htmlTemplate: "app/loads/templates/forms/form-select-truck.html",
                type: "info",
                scope: scope,
                buttonsStyling: true,
                confirmButtonColor: "#D4DD55",
                cancelButtonColor: "#d33",
                showCancelButton: true,
                showConfirmButton: true,
                confirmButtonText: "Aceptar",
                cancelButtonText: "Cancelar",
                allowOutsideClick: false,
                closeOnConfirm: false,
                closeOnCancel: true,
                showLoaderOnConfirm: true,
                width: '500px',
              }).then(function(result) {
                if(angular.isDefined(result)) {
                  if(result.value) {
                    scope.items.load_id = scope.loadId;
                    if (angular.isUndefined(scope.items.truck_id) || scope.items.truck_id == ""){
                      return toastr.warning($filter('translate')('modals:load_truck_empty:title'));
                    }
                    if (angular.isUndefined(scope.items.driver_id) ||  scope.items.driver_id == ""){
                      return toastr.warning($filter('translate')('modals:load_driver_empty:title'));
                    }
                    Carriers.assignTruckToLoad(scope.items).then(function (response) {
                      scope.initialize();
                      toastr.success($filter('translate')('modals:load_truck_select:form:success'));
                    }, function (error) {
                      console.error(error);
                      scope.initialize();
                      toastr.error($filter('translate')('modals:load_truck_select:form:required:fields:invalid'));
                    });

                  }
                }
              });

            }
            /* Call Truck list to assign modal */
            scope.openChooseTruckModal = function() {
              var modalInstance = $uibModal.open({
                controller: 'LoadTruckSelectModalController as loadtruckselect',
                windowClass: 'load-truck-select-modal',
                templateUrl: 'app/loads/templates/modal/load-truck-select.html',
                resolve: {
                    load: function() {
                        return scope.loadId;
                    },
                    carrier: function() {
                        return scope.loadData.carrier;
                    }
                }
              });

              modalInstance.result.then(function() {
                  scope.loadingLoadData = true;
                  scope.initialize();
              });
            };

            /* Call Report issues modal */
            scope.openReportIssuesLoadModal = function() {
              var modalInstance = $uibModal.open({
                controller: 'ReportIssuesLoadModalController as reportissuesload',
                windowClass: 'report-issues-load-modal',
                templateUrl: 'app/loads/templates/modal/report-issues-load.html',
                resolve: {
                    load: function() {
                        return scope.loadId;
                    }
                }
              });
            };

            /* Call cancel load by shipper modal */
            scope.openCancelLoadModal = function() {
              var modalInstance = $uibModal.open({
                controller: 'CancelLoadModalController as cancelload',
                windowClass: 'cancel-load-modal',
                templateUrl: 'app/loads/templates/modal/cancel-load.html',
                resolve: {
                    load: function() {
                        return scope.loadId;
                    }
                }
              });

              modalInstance.result.then(function(data) {
                if(data === true){
                  scope.reloadParent();
                }
              });
            };

            /* Call Apply to load by carrier modal */
            scope.createRequestCarrierLoad = function() {
              Loads.createRequestCarrierLoad(scope.loadOptions)
                .then(function(response){
                  if(angular.isDefined(response.request_created)){
                    if(angular.isDefined(response.request_created.idrequest_loads)){
                      scope.loadingMap = true;
                      scope.loadingLoadData = true;
                      scope.getLoadDetails();
                    }
                  }
                });
            };

            /* Call Cancel my request to apply to the load modal */
            scope.cancelRequestCarrierLoad = function() {
              Loads.cancelRequestCarrierLoad(scope.loadOptions)
                .then(function(response){
                  scope.loadingMap = true;
                  scope.loadingLoadData = true;
                  scope.getLoadDetails();
                });
            };

          scope.rejectTmsRequest = function() {
            Loads.rejectTmsRequest(scope.loadOptions)
              .then(function(response){
                scope.loadingMap = true;
                scope.loadingLoadData = true;
                scope.getLoadDetails();
              });
          };

            scope.changeStatusLoadByDriver = function() {
              if(scope.loadData.status_loads){
                var profile = Auth.getUserProfile();

                if(profile == 'DRIVER'){
                  if(scope.loadData.status_loads == Config.ENV.ACCEPTED_STATUS){
                    scope.loadOptions.load_status = '';
                    Loads.setLoadInTransitByDriver(scope.loadOptions)
                      .then(function(response){
                        scope.loadingMap = true;
                        scope.loadingLoadData = true;
                        scope.getLoadDetails();
                      });
                  }

                  if(scope.loadData.status_loads == Config.ENV.IN_TRANSIT_STATUS){
                    scope.loadOptions.load_status = '';
                    Loads.setLoadDeliveredByDriver(scope.loadOptions)
                      .then(function(response){
                        scope.loadingMap = true;
                        scope.loadingLoadData = true;
                        scope.getLoadDetails();
                      });
                  }
                }
              }
            };

          scope.changeStatusLoad = function(status) {
            if(scope.loadData.status_loads){
              var profile = Auth.getUserProfile();
              scope.loadOptions.load_status = status;
              Loads.setLoadStatus(scope.loadOptions)
                .then(function(response){
                  scope.loadingMap = true;
                  scope.loadingLoadData = true;
                  scope.getLoadDetails();
                  flux.dispatch('fetchLoads', null);
                });
            }
          };

            /* Validate if dropdown is able to show depending on user profile*/
            scope.verifyOptionsDropdown = function() {
              scope.allowDropdown = false;
              var profile = Auth.getUserProfile();

              switch(profile){
                case 'CARRIER':
                case 'OWNER':
                  if(scope.loadData.status_loads =='ACEPTADA' || scope.loadData.status_loads =='EN_TRANSITO'){
                    scope.allowDropdown = true;
                  }

                  break;
                case 'GENERADOR_CARGA':
                  if(scope.loadData.status_loads !='CANCELADA'){
                    scope.allowDropdown = true;
                  }
                  break;
              }
            };

            /* Upload images and documents to the load */
            scope.uploadLegalDoc = function(file) {
                  // Upload logo image.
                  //console.log(file);
                  if (file) {
                      // Loading
                      scope.legalDocFileSaving = true;
                      var nameFile = scope.loadId+'_'+moment().milliseconds();

                      if(file.name){
                        var nameFileArr = file.name;
                        nameFileArr = nameFileArr.split(".");
                        nameFile = nameFileArr[0];
                      }

                      // Upload
                      var params = {
                          token: Auth.getUserToken(),
                          invoice_name: nameFile,
                          load_id: scope.loadId,
                          invoice_type: 'legal_doc',
                          pic: file
                      };
                      Loads.uploadInvoiceToLoad(params)
                          .then(function(response) {
                              // Success
                              var elements_invoice = '';
                              if(angular.isDefined(response.invoice_name) && response.invoice_name.length > 0){
                                if(response.type_file =='pdf'){
                                  elements_invoice = response.invoice_name.split("/");
                                  scope.loadLegalDocsFilesList.push({url: response.invoice_name, title: elements_invoice[elements_invoice.length - 1], invoice_name:nameFile });
                                }else{
                                  elements_invoice = response.invoice_name[0].normal.split("/");
                                  scope.loadLegalImgFilesList.push({url: response.invoice_name[0].normal, title: elements_invoice[elements_invoice.length - 1], invoice_name:nameFile });
                                }
                              }
                              toastr.success($filter('translate')('loads:edit:invoice:upload:successfully'));

                              // Loading
                              scope.legalDocFileSaving = false;
                          })
                          .catch(function(error) {
                              // Loading
                              $log.error(error);
                              scope.legalDocFileSaving = false;
                              // Message.
                              toastr.error($filter('translate')('loads:edit:invoice:upload:error'));
                          });
                  }
              };

            scope.getImageMapPoint = function(index){
              if(index > 10){
                return "point_greater_10";
              }else{
                return "point_"+index;
              }
            };
            scope.getStatusByLoad = function (){
              scope.status = []; var status = [];
              Loads.getStatusByLoad(scope.loadId).then(function (response){
                 response.data.status.forEach(function(value){
                      if (value.completed == false) {
                          status.push({
                            "event": value.event,
                            "status": value.status,
                            "status_id": value.status_id,
                            "stop_id": value.stop_id,
                            "completed": value.completed
                        });
                      }
                 });
                  scope.status.push(status[0]);
              });

            }
            scope.changeStatus = function (){
                var fields = {status : this.item.status};
                Loads.updateStatusLoad(scope.loadId,this.item.stop_id,fields).then(function (resp){
                  toastr.success("Se actualizo el estatus con exito");
                  scope.getStatusByLoad();
                });
            }

            // Initialize
            scope.initialize();
        }
    };
  }
})();

(function() {
  'use strict';

  /* Truck assigned info modal controller
   * Get truck id 
   * Look for truck info
   * Redirect to loads by truck
   */

  angular
    .module('loadsAppWeb')
    .controller('TruckAssignedInfoModalController', TruckAssignedInfoModalController);

  /** @ngInject */
  function TruckAssignedInfoModalController($state, truck, Auth, Trucks, $uibModalInstance, $q, toastr, $filter) {
	  var vm = this;

    /* Function executed at strart, get truck id and look for truck info  */
    vm.initialize = function() {
      vm.truckInfoReceived = truck;
      vm.params = {};
      vm.params.id = null;
      vm.params.token = Auth.getUserToken();
      vm.finalTruckData = false;
      vm.loadingInfo = true;

      if(angular.isDefined(vm.truckInfoReceived.id)){
        vm.params.id =  vm.truckInfoReceived.id;

        vm.getTruckSearch();
      }else{
        vm.loadingInfo = false;
      }
    };

    /* Get truck info */
    vm.getTruckSearch = function() {

      Trucks.trucksDetails(vm.params)
        .then(function(response){
          console.log(response);
          vm.finalTruckData = response.Truck_Details[0];

          if(vm.finalTruckData){
            if(angular.isDefined(vm.finalTruckData.skills_truck) && vm.finalTruckData.skills_truck.length){
              var arr_skills = [];
              for(var sk in vm.finalTruckData.skills_truck){
                arr_skills.push(vm.finalTruckData.skills_truck[sk].skills_name);
              }
              vm.finalTruckData.SkillsTruckText = arr_skills.join(', ');
            }else{
              vm.finalTruckData.SkillsTruckText = "---";
            }

            if(angular.isDefined(vm.finalTruckData.truck_availability) && vm.finalTruckData.truck_availability.length){
              var arr_availability = [];
              for(var av in vm.finalTruckData.truck_availability){
                arr_availability.push(vm.finalTruckData.truck_availability[av].availablity_name);
              }
              vm.finalTruckData.AvailabilityTruckText = arr_availability.join(', ');
            }else{
              vm.finalTruckData.AvailabilityTruckText = "---";
            }
          }

          vm.loadingInfo = false;
        })
        .catch(function (error) {
          scope.loadingInfo = false;
        });
    };

    /* Redirect to loads by truck information */
    vm.goToTruckLoads = function() {
      $state.go('private.trucks.loads', {id: vm.finalTruckData.id});
      vm.closePopup();
    };

    /* Close popup */
    vm.closePopup = function() {
        $uibModalInstance.close();
    };

    vm.initialize();
    
  }
})();

angular.module('loadsAppWeb').controller('StopController',[
  '$state',
  'toastr',
  '$filter',
  'Config',
  'Loads',
  'UploadService',
  'Auth',
  'DatatableTool',
  '$q',
  '$uibModal',
  'sweetAlert',
  'swangular',
  '$scope',
  '$stateParams',
  StopController
]);

function StopController(
  $state,
  toastr,
  $filter,
  Config,
  Loads,
  Upload,
  Auth,
  DatatableTool,
  $q,
  $uibModal,
  sweetAlert,
  swangular,
  $scope,
  $stateParams
){

  $scope.construct = function (){
    $scope.load_id = $stateParams.id;
    $scope.index();
    //$scope.getStatus();
    $scope.getStatusByLoad();
    $scope.items = [];
  };

  $scope.index = function (){
    if ($scope.load_id){
      $scope.loading = true;
        Loads.stopDisplay($scope.load_id).then(function (response){
          $scope.items = response.data.results;
          $scope.loading = false;
        });
      return;
    }
    toastr.warning("Favor de seleccionar una carga");
    $state.go('private.loads');
  }
  $scope.makeFormDinamic = function (){
    $scope.stop_id = this.item.id;
    $scope.loading = true;
      Loads.stopEvinceForm($scope.load_id,$scope.stop_id).then(function(response){
          $scope.checklistForm = response.data.results;
          if(angular.isDefined($scope.checklistForm[0])){
              $scope.throwFormDinamic();
          }else{
              toastr.error("No tiene formulario asignado a esta parada");
          }

          $scope.loading = false;
      });
  }
  $scope.throwFormDinamic = function(){
      $scope.answers = {};
      var titleDinamicForm = (angular.isDefined($scope.checklistForm[0]))? $scope.checklistForm[0].form : "¡Agregar!"; 
      swangular.open({
          title: "¡ "+titleDinamicForm.name+" !",
          htmlTemplate: "app/loads/templates/forms/form-dinamic-checklist.html",
          type: "info",
          scope: $scope,
          buttonsStyling: true,
          confirmButtonColor: "#D4DD55",
          cancelButtonColor: "#d33",
          showCancelButton: true,
          showConfirmButton: true,
          confirmButtonText: "Aceptar",
          cancelButtonText: "Cancelar",
          allowOutsideClick: false,
          closeOnConfirm: true,
          closeOnCancel: true,
          showLoaderOnConfirm: true,
          width: '500px',
        }).then(function(result) {
          if(angular.isDefined(result)) {
            if(result.value) {
                $scope.sendChecklistStop();
            }
          }
        });

  }

  $scope.getStatusByLoad = function (){
    Loads.getStatusByLoad($scope.load_id).then(function (response){
      $scope.status = response.data;
    });
  }
  
  $scope.sendChecklistStop = function (){
      $scope.answer = [];
      angular.forEach($scope.answers, function(value,key){
          $scope.answer.push({
            field_id : key,
            value : value
          });
      });
      $scope.loading = true;
      angular.forEach($scope.answer, function(answer){
        Loads.createAnswerStop($scope.load_id,$scope.stop_id,$scope.checklistForm[0].id,answer).then(function(response){
            
        });
      });
      $scope.loading = false;
      toastr.success("¡Se envio la informacion correctamente!");
  }
  $scope.uploadFile = function(file,field){
      var formData = new FormData();
        formData.append('file', file);
      Upload.uploadFile(formData).then(function(response){
          $scope.answers[field.id] = [response.data.url];
      });
  };

  $scope.construct();

}

(function() {
  'use strict';

  /* Load log searching modal controller
   * Set form data filters 
   * Send form data to API
   */

  angular
    .module('loadsAppWeb')
    .controller('SearchLoadLogModalController', SearchLoadLogModalController);

  /** @ngInject */
  function SearchLoadLogModalController($state, $uibModalInstance, $filter, Loads, toastr) {

    /* Set form vars  */
	  var vm = this;
      vm.searchData = {};
      vm.searchData.shortcut = 'custom';
      vm.searchData.date_from = null;
      vm.searchData.date_to = null;
      vm.searchData.load_id = null;

      vm.dateToDisabled = true;
      vm.datePickerMinDate = moment();
      vm.optsDatePicker = {
          singleDatePicker: true,
          showDropdowns: true,
          locale: {
              format: "YYYY-MM-DD",
              applyClass: 'btn-green',
              applyLabel: $filter('translate')('daterangepicker:btn:success:text'),
              fromLabel: $filter('translate')('daterangepicker:label:from'),
              toLabel: $filter('translate')('daterangepicker:label:to'),
              cancelLabel: $filter('translate')('daterangepicker:btn:cancel:text'),
              customRangeLabel: $filter('translate')('daterangepicker:title:text'),
              firstDay: 1
          },
          eventHandlers: {
            'apply.daterangepicker': function(event, picker) { vm.allowDateTo(); }
          } 
        };

      vm.optsDatePicker2 = {
          singleDatePicker: true,
          showDropdowns: true,
          locale: {
              format: "YYYY-MM-DD",
              applyClass: 'btn-green',
              applyLabel: $filter('translate')('daterangepicker:btn:success:text'),
              fromLabel: $filter('translate')('daterangepicker:label:from'),
              toLabel: $filter('translate')('daterangepicker:label:to'),
              cancelLabel: $filter('translate')('daterangepicker:btn:cancel:text'),
              customRangeLabel: $filter('translate')('daterangepicker:title:text'),
              firstDay: 1
          }
        };

      vm.shortCutTypes = [{id: 'today', name: $filter('translate')('modals:loads_log:search:fields:type:today')},
                          {id: 'yesterday', name: $filter('translate')('modals:loads_log:search:fields:type:yesterday')},
                          {id: 'sevenday', name: $filter('translate')('modals:loads_log:search:fields:type:sevenday')},
                          {id: 'thismonth', name: $filter('translate')('modals:loads_log:search:fields:type:thismonth')},
                          {id: 'lastsixmonths', name: $filter('translate')('modals:loads_log:search:fields:type:lastsixmonths')},
                          {id: 'lastyear', name: $filter('translate')('modals:loads_log:search:fields:type:lastyear')},
                          {id: 'custom', name: $filter('translate')('modals:loads_log:search:fields:type:custom')}];


    /* Validate and send form data to API */
    vm.sendDataLoadsLog = function(searchLoadLogFormName) {
      // Validate form.
      if (searchLoadLogFormName.$invalid) {
          // If there was an error for required fields.
          if (searchLoadLogFormName.$error.required) {
              toastr.error($filter('translate')('modals:loads_log:search:form:required:fields:error'));
          } else {
              toastr.error($filter('translate')('modals:loads_log:search:form:required:fields:invalid'));
          }
          return;
      }

      if(vm.searchData.shortcut == 'custom' && !vm.searchData.load_id){
        if(!vm.searchData.date_from || !vm.searchData.date_to || angular.isDefined(vm.searchData.date_from.startDate) || angular.isDefined(vm.searchData.date_to.startDate)){
          toastr.error($filter('translate')('modals:loads_log:search:form:required:fields:error'));
          return;
        }
      }

      vm.closePopup(vm.searchData);
    };

    /* Close popup */
    vm.closePopup = function(resp) {
        $uibModalInstance.close(resp);
    };

    /* Validate if date_to is greater than date_from */
    vm.allowDateTo = function() {
      if(vm.searchData.date_from != null && vm.searchData.date_from != "" && !angular.isDefined(vm.searchData.date_from.startDate)){
        vm.dateToDisabled = false;
        if(vm.searchData.date_to < vm.searchData.date_from){
          vm.searchData.date_to = vm.searchData.date_from;
        }
      }else{
        vm.dateToDisabled = true;
        vm.searchData.date_to = null;
      }
    };
  }
})();

(function() {
  'use strict';

  /* Report issues load modal controller
   * Receive load id 
   * Send form data to API
   */

  angular
    .module('loadsAppWeb')
    .controller('ReportIssuesLoadModalController', ReportIssuesLoadModalController);

  /** @ngInject */
  function ReportIssuesLoadModalController($state, load, Auth, Loads, $uibModalInstance, DatatableTool, $q, toastr, $filter) {
	  var vm = this;

    /* Function executed at strart, set form vars  */
    vm.initialize = function() {
      vm.loadId = load;
      vm.dataToSend = {};
      vm.dataToSend.token = Auth.getUserToken();
      vm.dataToSend.load_id = vm.loadId;
      vm.dataToSend.description = null;
      vm.savingReport = false;
    };

    /* Validate and send form data to API */
    vm.sendReport = function(reportIssuesLoadFormName) {
      vm.savingReport = true;
      // Validate form.
      if (reportIssuesLoadFormName.$invalid) {
          // If there was an error for required fields.
          if (reportIssuesLoadFormName.$error.required) {
              toastr.error($filter('translate')('modals:report_issues_load:form:required:fields:error'));
          } else {
              toastr.error($filter('translate')('modals:report_issues_load:form:required:fields:invalid'));
          }
          vm.savingReport = false;
          return;
      }

      var defer = $q.defer();

      Loads.reportIssueToLoad(vm.dataToSend)
          .then(function (response) {
                  toastr.success($filter('translate')('modals:report_issues_load:form:success'));
                  vm.closePopup();
              }, function (error) {
                  toastr.error($filter('translate')('modals:report_issues_load:form:required:fields:invalid'));
              });

      vm.savingReport = false;
    };

    /* Close popup */
    vm.closePopup = function() {
        $uibModalInstance.close();
    };

    vm.initialize();
    
  }
})();

(function() {
  'use strict';

  /* Loads log list controller
   * Set filter data
   * Look for loads log list about filters
   * Show load details in dropdown
   */

  angular
    .module('loadsAppWeb')
    .controller('LoadsLogController', LoadsLogController);

  /** @ngInject */
  function LoadsLogController(
    toastr,
    $filter,
    Config,
    Loads,
    Auth,
    DatatableTool,
    DTOptionsBuilder,
    DTColumnBuilder,
    $sce,
    $uibModal,
    loadLogStore,
    $scope,
    flux
  ) {
	  var vm = this;

    vm.currentLoadId = null;
    vm.totalItems = 64;
    vm.currentPage = 4;
    vm.setPage = function (pageNo) {
      vm.currentPage = pageNo;
    };
    vm.pageChanged = function() {
      console.log('Page changed to: ' + vm.currentPage);
    };
    $scope.bigMaxSize = 5;
    $scope.bigTotalItems = 175;
    $scope.bigCurrentPage = 1;


    vm.loads = loadLogStore.loads;

    $scope.$listenTo(loadLogStore, function () {
      vm.loads = loadLogStore.loads;

      _.forEach(vm.loads.results, function(value, key) {
        if(vm.profile == 'CARRIER' || vm.profile == 'DRIVER' || vm.profile == 'OWNER'){
          value.full_name_shipper = value.loadGenerator.company_name;
          value.img_shipper = false;
          if(angular.isDefined(value.loadGenerator.user.img_perfil_arr) && value.loadGenerator.user.img_perfil_arr != null){
            value.img_shipper = value.loadGenerator.user.img_perfil_arr[0]['imagen-60'];
          }
        }
        value.status_btn = '';
        var bgColorBtn = '', colorBtn = '';
        switch(value.status_loads){
          case 'NOT_ASSIGNED':
            bgColorBtn = 'bg-color-7';
            colorBtn = 'color-armadillo';
            break;
          case 'ACEPTADA':
            bgColorBtn = 'bg-color-10';
            colorBtn = 'color-white';
            break;
          case 'EN_TRANSITO':
            bgColorBtn = 'bg-color-5';
            colorBtn = 'color-black';
            break;
          case 'ENTREGADA':
            bgColorBtn = 'bg-color-9';
            colorBtn = 'color-black';
            break;
          case 'CANCELADA':
            bgColorBtn = 'bg-color-4';
            colorBtn = 'color-black';
            break;
          case 'PAGADA':
            bgColorBtn = 'bg-color-8';
            colorBtn = 'color-white';
            break;
          case 'HACIA_ORIGEN':
          case 'EN_ORIGEN':
          case 'CARGANDO':
          case 'CARGADO':
          case 'EN_DESTINO':
          case 'DESCARGANDO':
          case 'DESCARGADO':
            bgColorBtn = 'bg-color-5';
            colorBtn = 'color-black';
            break;
          default:
            bgColorBtn = 'bg-color-7';
            colorBtn = 'color-armadillo';
            break;
        }
        value.status_btn = $sce.trustAsHtml(
          '<button class="btn btn-class2 btn-status-load '+bgColorBtn+' '+colorBtn+'">'+
          $filter('translate')('loads:table:status:' +value.status_loads.toLowerCase()+ ':text')+
          '</button>'
        );
        value.pickup_date_formatted = moment(value.pickup_date, "YYYY-MM-DD HH:mm:ss").format("MMM DD YYYY");
        value.delivery_date_formatted = moment(value.delivery_date, "YYYY-MM-DD HH:mm:ss").format("MMM DD YYYY");
        value.price_to_show = "$"+value.price;
        if(value.weight != null && value.weight != ''){
          if(value.weight.indexOf("lb") !== -1){
            value.weight = value.weight.replace("lb", "kg");
          }
        }
        if(value.posteverywhere == "1" && value.price == 0){
          value.price_to_show = $filter('translate')('loads:table:price:call:text');
        }
        if(value.load_date){
          var load_date_aux = moment.tz(value.load_date, "UTC");
          value.load_date = load_date_aux.clone().tz("America/Mexico_City").format('YYYY-MM-DD HH:mm:ss');
        }
        value.actions = '<i ng-click="loads.showDetailsUnique('+value.load_id+')" class="fa fa-angle-down show-load-details-btn"></i>';
      });

    });

    vm.changePage = function(page){
      vm.loadsOptions.page = page;
      flux.dispatch('fetchLoads', vm.loadsOptions);
    };

    /* Function executed at strart, Set first params and look for loads  */
	  vm.initialize = function() {
      vm.profile = Auth.getUserProfile();

      vm.datePicker = {};
      vm.datePicker.date = {startDate: null, endDate: null};
      vm.loadsOptions = {
        'token': Auth.getUserToken(),
        'page': 1
      };
      vm.loadsList = [];
      vm.loadingLoadData = true;
      vm.initializedList = false;

      vm.countLoads = 0;

      vm.loadTab();

      //vm.getLoadsLogData();
    };

    /* Load table first time or reload it  */
    vm.loadTab = function() {
      if (vm.initializedList) {
        vm.reloadList();
      } else {
        vm.initializeList();
      }
    };

    /* Get loads list and set datatable  */
    vm.initializeList = function() {
      vm.datatableOptions = DTOptionsBuilder.newOptions().withOption('ajax', function(data, callback, settings){
        vm.countLoads = 0;
        // Page
        vm.loadsOptions.page = DatatableTool.getPage(data);
        Loads.getLoadsHistoryByUserRol(vm.loadsOptions).then(function(response){
          var records = DatatableTool.getRecords(response);
          flux.dispatch('fetchLoads', vm.loadsOptions);
          if (!angular.isUndefined(records.recordsTotal)) {
            vm.countLoads = records.recordsTotal;
          }
          // Info
          if (!angular.isUndefined(records.data)) {
            _.forEach(records.data, function(value, key) {
              if(vm.profile == 'CARRIER' || vm.profile == 'DRIVER' || vm.profile == 'OWNER'){
                value.full_name_shipper = value.loadGenerator.company_name;
                value.img_shipper = false;
                if(angular.isDefined(value.loadGenerator.user.img_perfil_arr) && value.loadGenerator.user.img_perfil_arr != null){
                  value.img_shipper = value.loadGenerator.user.img_perfil_arr[0]['imagen-60'];
                }
              }
              value.status_btn = '';
              var bgColorBtn = '', colorBtn = '';
              console.log(value.status_loads);
              switch(value.status_loads){
                case 'NOT_ASSIGNED':
                  bgColorBtn = 'bg-color-7';
                  colorBtn = 'color-armadillo';
                  break;
                  case 'ACEPTADA':
                    bgColorBtn = 'bg-color-10';
                    colorBtn = 'color-white';
                    break;
                    case 'EN_TRANSITO':
                      bgColorBtn = 'bg-color-5';
                      colorBtn = 'color-black';
                      break;
                      case 'ENTREGADA':
                        bgColorBtn = 'bg-color-9';
                        colorBtn = 'color-black';
                        break;
                        case 'CANCELADA':
                          bgColorBtn = 'bg-color-4';
                          colorBtn = 'color-black';
                          break;
                          case 'PAGADA':
                            bgColorBtn = 'bg-color-8';
                            colorBtn = 'color-white';
                            break;
                            case 'POD':
                              bgColorBtn = 'bg-color-8';
                              colorBtn = 'color-armadillo';
                              break;
                              case 'HACIA_ORIGEN':
                                case 'EN_ORIGEN':
                                  case 'CARGANDO':
                                    case 'CARGADO':
                                      case 'EN_DESTINO':
                                        case 'DESCARGANDO':
                                          case 'DESCARGADO':
                                            bgColorBtn = 'bg-color-5';
                                            colorBtn = 'color-black';
                                            break;
                                            default:
                                              bgColorBtn = 'bg-color-7';
                                              colorBtn = 'color-armadillo';
                                              break;
              }
              value.status_btn = $sce.trustAsHtml(
                '<button class="btn btn-class2 btn-status-load '+bgColorBtn+' '+colorBtn+'">'+
                $filter('translate')('loads:table:status:' +value.status_loads.toLowerCase()+ ':text')+
                '</button>'
              );
              value.pickup_date_formatted = moment(value.pickup_date, "YYYY-MM-DD HH:mm:ss").format("MMM DD YYYY");
              value.delivery_date_formatted = moment(value.delivery_date, "YYYY-MM-DD HH:mm:ss").format("MMM DD YYYY");
              value.price_to_show = "$"+value.price;
              if(value.weight != null && value.weight != ''){
                if(value.weight.indexOf("lb") !== -1){
                  value.weight = value.weight.replace("lb", "kg");
                }
              }
              if(value.posteverywhere == "1" && value.price == 0){
                value.price_to_show = $filter('translate')('loads:table:price:call:text');
              }
              if(value.load_date){
                var load_date_aux = moment.tz(value.load_date, "UTC");
                value.load_date = load_date_aux.clone().tz("America/Mexico_City").format('YYYY-MM-DD HH:mm:ss');
              }
              value.actions = '<i ng-click="loadslog.showDetailsUnique('+value.load_id+')" class="fa fa-angle-down show-load-details-btn"></i>';
            });
          }
          vm.loadsList = records.data;
          records.data = [{img_shipper: false, full_name_shipper: '', status_btn: '', from: '', to: '', pickup_date_formatted: '', delivery_date_formatted: '', distance: '', length_loads: '', weight: '', dimension: '', price_to_show: '', load_date: '', actions: ''}];
          callback(records);
        }).catch(function (error) {
          vm.loadsList = [];
          callback(DatatableTool.getRecords(null));
        });
      })
        .withDataProp('data')
        .withOption('processing', true)
        .withOption('serverSide', true)
        .withOption('searching', false)
        .withOption('info', false)
        .withOption('lengthChange', false)
        .withOption('pageLength', DatatableTool.getLimit(null))
        .withOption('responsive', true)
        .withLanguage(DatatableTool.getDefaultLanguageSettings())
        .withPaginationType('numbers');
      switch(vm.profile){
        case 'GENERADOR_CARGA':
          vm.dtColumns = [
            DTColumnBuilder.newColumn('status_btn'),
            DTColumnBuilder.newColumn('from'),
            DTColumnBuilder.newColumn('to'),
            DTColumnBuilder.newColumn('pickup_date_formatted'),
            DTColumnBuilder.newColumn('delivery_date_formatted'),
            DTColumnBuilder.newColumn('distance'),
            DTColumnBuilder.newColumn('length_loads'),
            DTColumnBuilder.newColumn('weight'),
            DTColumnBuilder.newColumn('dimension'),
            DTColumnBuilder.newColumn('price_to_show'),
            DTColumnBuilder.newColumn('load_date'),
            DTColumnBuilder.newColumn('actions')
          ];
          break;
        case 'CARRIER':
        case 'DRIVER':
        case 'OWNER':
          vm.dtColumns = [
            DTColumnBuilder.newColumn('img_shipper'),
            DTColumnBuilder.newColumn('full_name_shipper'),
            DTColumnBuilder.newColumn('from'),
            DTColumnBuilder.newColumn('to'),
            DTColumnBuilder.newColumn('pickup_date_formatted'),
            DTColumnBuilder.newColumn('delivery_date_formatted'),
            DTColumnBuilder.newColumn('length_loads'),
            DTColumnBuilder.newColumn('weight'),
            DTColumnBuilder.newColumn('dimension'),
            DTColumnBuilder.newColumn('price_to_show'),
            DTColumnBuilder.newColumn('load_date'),
            DTColumnBuilder.newColumn('status_btn'),
            DTColumnBuilder.newColumn('actions')
          ];
          break;
      }

      vm.loadingLoadData = false;
      vm.initializedList = true;
    };

    /* Reload data table  */
    vm.reloadList = function() {
        // Reload datatables
        DatatableTool.reload();
    };

    vm.queryLoads = function(params) {
      Loads.getLoadsHistoryByUserRol(params)
        .then(function(response){
          return response;
        }, function(error){
          return false;
        });
    };

    /* Get loads log list  */
    vm.getLoadsLogData = function() {
      vm.loadsList = [];

      Loads.getLoadsHistoryByUserRol(vm.loadsOptions)
        .then(function(response){
          console.log(response);
          if(angular.isDefined(response.results)){
            vm.loadsList = response.results;
          }else{
            vm.loadsList = [];
          }

          vm.loadingLoadData = false;
        }, function(error){
          vm.loadsList = [];
          vm.loadingLoadData = false;
        });
    };

    /* Show Load details in drop down tab */
    vm.showDetailsUnique = function(load_id) {
      for(var i in vm.loadsList){
        if(vm.loadsList[i].load_id == load_id){
          vm.loadsList[i].expanded = !vm.loadsList[i].expanded;
        }else{
          vm.loadsList[i].expanded = false;
        }
      }
    };

    /* Open searching params modal */
    vm.openSearchLoadsLogsModal = function() {
      var modalInstance = $uibModal.open({
        controller: 'SearchLoadLogModalController as searchloadlog',
        windowClass: 'search-load-log-modal',
        templateUrl: 'app/loads/templates/modal/search-load-log.html'
      });

      modalInstance.result.then(function(data) {
        if(data.shortcut){
          vm.loadsOptions.shortcut = data.shortcut;
          if(data.shortcut == 'custom'){
            vm.loadsOptions.date_from = moment(data.date_from).format('YYYY-MM-DD');
            vm.loadsOptions.date_to = moment(data.date_to).format('YYYY-MM-DD');
          }else{
            if(angular.isDefined(vm.loadsOptions.date_from)){
              delete vm.loadsOptions.date_from;
            }

            if(angular.isDefined(vm.loadsOptions.date_to)){
              delete vm.loadsOptions.date_to;
            }
          }
        }else{
          if(angular.isDefined(vm.loadsOptions.shortcut)){
            delete vm.loadsOptions.shortcut;
          }

          if(angular.isDefined(vm.loadsOptions.date_from)){
            delete vm.loadsOptions.date_from;
          }

          if(angular.isDefined(vm.loadsOptions.date_to)){
            delete vm.loadsOptions.date_to;
          }
        }

        if(data.load_id){
          vm.loadsOptions.load_id = data.load_id;
        }else{
          if(angular.isDefined(vm.loadsOptions.load_id)){
            delete vm.loadsOptions.load_id;
          }
        }

        vm.reloadList();
      });
    };

    vm.initialize();
  }
})();

(function() {
  'use strict';

  /* Load edition controller
   * Set form vars
   * Get load attributes
   * Get load info
   * Validate and submit form data
   * Upload images and documents
   */

  angular
    .module('loadsAppWeb')
    .controller('LoadsEditController', LoadsEditController);

  /** @ngInject */
  function LoadsEditController($state, $stateParams, toastr, $filter, Config, Loads, Auth, DatatableTool, $q, $uibModal, $log) {
    var vm = this;

    /* Function which validates pickup date against delivery date and this doesn't allow pickup date being greater than delivery date */
    vm.allowDeliveryDate = function() {
      if(vm.dataUpdateLoad.pickup_date != null && vm.dataUpdateLoad.pickup_date != ""){
        vm.dateDeliveryDisabled = false;

        if(vm.dataUpdateLoad.delivery_date < vm.dataUpdateLoad.pickup_date){
          vm.dataUpdateLoad.delivery_date = vm.dataUpdateLoad.pickup_date;
        }
      }else{
        vm.dateDeliveryDisabled = true;
        vm.dataUpdateLoad.delivery_date = null;
      }
    };

    vm.checkOriginZip = function() {
      if(angular.isDefined(vm.dataSelectPickupAddress.address_components)){
        for(var i in vm.dataSelectPickupAddress.address_components){
          if(vm.dataSelectPickupAddress.address_components[i].types.indexOf('postal_code') != -1){
            vm.dataUpdateLoad.zip_code_pickup = vm.dataSelectPickupAddress.address_components[i].long_name;
          }
        }
      }
    };

    vm.checkDestinationZip = function() {
      if(angular.isDefined(vm.dataSelectDeliveryAddress.address_components)){
        for(var i in vm.dataSelectDeliveryAddress.address_components){
          if(vm.dataSelectDeliveryAddress.address_components[i].types.indexOf('postal_code') != -1){
            vm.dataUpdateLoad.zip_code_delivery = vm.dataSelectDeliveryAddress.address_components[i].long_name;
          }
        }
      }
    };

    /* Function executed at strart, set form vars and get load attributes  */
    vm.initialize = function() {
      vm.reviewPriceWs = true;
      vm.priceSuggested = 0;
      vm.validStatuses = ['NOT_ASSIGNED'];
      vm.loadId = $stateParams.id|| false;
      vm.loadData = false;
      vm.dataSelectPickupCity = null;
      vm.dataSelectDeliveryCity = null;
      vm.dataSelectPickupAddress = null;
      vm.dataSelectDeliveryAddress = null;

      vm.dateDeliveryDisabled = true;
      vm.datePickerMinDate = moment();
      vm.optsDatePicker = {
          singleDatePicker: true,
          showDropdowns: true,
          locale: {
              format: "YYYY-MM-DD",
              applyClass: 'btn-green',
              applyLabel: $filter('translate')('daterangepicker:btn:success:text'),
              fromLabel: $filter('translate')('daterangepicker:label:from'),
              toLabel: $filter('translate')('daterangepicker:label:to'),
              cancelLabel: $filter('translate')('daterangepicker:btn:cancel:text'),
              customRangeLabel: $filter('translate')('daterangepicker:title:text'),
              firstDay: 1
          }
        };

      vm.dataUpdateLoad = {};
      vm.dataUpdateLoad.token = Auth.getUserToken();
      vm.dataUpdateLoad.load_id = null;
      vm.dataUpdateLoad.city_pickup = null;
      vm.dataUpdateLoad.pickup_date = null;
      vm.pickup_start_time_hour = '00';
      vm.pickup_start_time_minutes = '00';
      vm.dataUpdateLoad.timer_star_pickup = null;
      vm.pickup_finish_time_hour = '00';
      vm.pickup_finish_time_minutes = '00';
      vm.dataUpdateLoad.timer_finish_pickup = null;
      vm.dataUpdateLoad.pickup_address = null;
      vm.dataUpdateLoad.detail_address_pickup = null;
      vm.dataUpdateLoad.lat_pickup_address = null;
      vm.dataUpdateLoad.long_pickup_address = null;
      vm.dataUpdateLoad.zip_code_pickup = null;
      vm.dataUpdateLoad.city_delivery = null;
      vm.dataUpdateLoad.delivery_date = null;
      vm.delivery_start_time_hour = '00';
      vm.delivery_start_time_minutes = '00';
      vm.dataUpdateLoad.timer_start_delivery = null;
      vm.delivery_finish_time_hour = '00';
      vm.delivery_finish_time_minutes = '00';
      vm.dataUpdateLoad.timer_finish_delivery = null;
      vm.dataUpdateLoad.delivery_address = null;
      vm.dataUpdateLoad.detail_address_delivery = null;
      vm.dataUpdateLoad.lat_delivery_address = null;
      vm.dataUpdateLoad.long_delivery_address = null;
      vm.dataUpdateLoad.zip_code_delivery = null;
      vm.dataUpdateLoad.weight = null;
      vm.dataUpdateLoad.load_type = null;
      vm.load_type_combo_box = null;
      vm.dataUpdateLoad.noot_load = null;
      vm.dataUpdateLoad.lenght = null;
      vm.dataUpdateLoad.dimension = null;
      vm.dataUpdateLoad.price = null;
      vm.dataUpdateLoad.frecuency_active = 0;
      vm.dataUpdateLoad.load_comments = null;
      vm.dataUpdateLoad.truck_type_id = null;
      vm.dataUpdateLoad.consignee = null;
      vm.dataUpdateLoad.receiver = null;
      //vm.dataUpdateLoad.load_type_license_id = null;
      vm.dataUpdateLoad.commodity_id = null;
      vm.dataUpdateLoad.allow_multiple_stops = 0;
      vm.dataUpdateLoad.stops_initial = [];
      vm.dataUpdateLoad.stops = [];
      vm.dataUpdateLoad.trailer_type = null;
      vm.dataUpdateLoad.weight_unit   = null;
      vm.dataUpdateLoad.distance_unit = null;

      vm.loadFilesList = [];
      vm.loadFilesPdfList = [];

      vm.savingUpdateLoad = false;
      vm.loadingDataDetails = true;

      vm.loadTypeFieldRequired = false;
      vm.carrierSkillsRequired = false;
      vm.truckTypeRequired = null;
      vm.lenghtType = 'NA';
      vm.truckTypeConf = 'NA';
      vm.TruckTypesRemolque = [];
      vm.loadLicenseTypeTitle = '';
      vm.loadLicenseTypeInfo = '';
      vm.commodityExcludedInfo = '';

      vm.indiceParadasMultiples = 0;
      vm.camposParadasMultiples = [];

      vm.optionsGoogleInputCity = {
        types: ['(cities)']
      }

      vm.hour_select = ['00','01','02','03','04','05','06','07','08','09','10','11','12','13','14','15','16','17','18','19','20','21','22','23'];
      vm.minutes_select = ['00','01','02','03','04','05','06','07','08','09','10','11','12','13','14','15','16','17','18','19','20','21','22','23','24','25','26','27','28','29','30','31','32','33','34','35','36','37','38','39','40','41','42','43','44','45','46','47','48','49','50','51','52','53','54','55','56','57','58','59'];

      vm.getItemsSizeLengthLoads();
    };

    /* Get load attributes */
    vm.getItemsSizeLengthLoads = function() {
      vm.itemsSizeLenLoads = {};
      Loads.getItemsSizeLengthLoads().then(function(response){
          if(response){
            vm.itemsSizeLenLoads = response;
            if(angular.isDefined(vm.itemsSizeLenLoads.LoadsSkillsRequired_list)){
              vm.setLoadsSkillsRequiredList();
            }
            if(angular.isDefined(vm.itemsSizeLenLoads.LoadsType_list)){
              vm.setLoadsTypeList();
            }
            if(angular.isDefined(vm.itemsSizeLenLoads.Trucktypes_list)){
              vm.cmbTruckTypes();
            }
            if(angular.isDefined(vm.itemsSizeLenLoads.LoadsLength_list)){
              vm.cmbLoadsLength();
            }
            if (angular.isDefined(vm.itemsSizeLenLoads.ContainerType)){
              vm.cmbContainerType();
            }
            if (angular.isDefined(vm.itemsSizeLenLoads.ProfitCenter)){
              vm.cmbProfitCenter();
            }
            if (angular.isDefined(vm.itemsSizeLenLoads.WeightUnit)){
              vm.cmbWeightUnit();
            }
            if (angular.isDefined(vm.itemsSizeLenLoads.DistanceUnit)){
              vm.cmbDistanceUnit();
            }
            if (angular.isDefined(vm.itemsSizeLenLoads.Addresses)){
              vm.cmbAddresses();
            }

            vm.getDataLoad();
          }else{
            $state.go('private.loads');
          }

        }).catch(function (error) {
          $log.error(error)
          $state.go('private.loads');
        });

    };
    vm.cmbLoadsLength = function (){
      vm.cmbLoadsLengths = [];
      if (vm.itemsSizeLenLoads.LoadsLength_list.length > 0){
        angular.forEach(vm.itemsSizeLenLoads.LoadsLength_list,function (value){
          if (value.id != 8 && value.id != 9 && value.id != 10){
            vm.cmbLoadsLengths.push({
              id      : value.id,
              name    : value.name,
              checked : false
            });
          }
        });
      }

    }
    vm.cmbTruckTypes = function (){
      vm.simpleTruckTypes = [];
      if (vm.itemsSizeLenLoads.Trucktypes_list.length > 0){
        angular.forEach(vm.itemsSizeLenLoads.Trucktypes_list, function (value){
          vm.simpleTruckTypes.push({
            id      : value.id,
            name    : value.truck_type_name,
            checked : false
          });
          if(value.required_length == 'Y'){
            vm.TruckTypesRemolque.push(parseInt(value.id));
          }
        });
      }
    }
    vm.cmbProfitCenter = function (){
      vm.cmbProfitCenters = [];
      if (vm.itemsSizeLenLoads.ProfitCenter.length > 0){
        angular.forEach(vm.itemsSizeLenLoads.ProfitCenter,function (value){
          vm.cmbProfitCenters.push({
            value   : value.value,
            text    : value.text,
            checked : false
          });
        });
      }
    }
    vm.cmbContainerType = function (){
      vm.cmbContainerTypes = [];
      if (vm.itemsSizeLenLoads.ContainerType.length > 0){
        angular.forEach(vm.itemsSizeLenLoads.ContainerType,function (value){
          vm.cmbContainerTypes.push({
            value   : value.value,
            text    : value.text,
            checked : false
          });
        });
      }
    }
    vm.cmbDistanceUnit = function (){
      vm.cmbDistanceUnits = [];
      if (vm.itemsSizeLenLoads.DistanceUnit.length > 0){
        angular.forEach(vm.itemsSizeLenLoads.DistanceUnit, function (value){
          vm.cmbDistanceUnits.push({
            value   : value.value,
            text    : value.text
          });
        });
        vm.dataUpdateLoad.distance_unit = 'm';
      }
    }
    vm.setterInformation = function (){
      if (vm.itemsSizeLenLoads.Addresses.length > 0){
        angular.forEach(vm.itemsSizeLenLoads.Addresses,function (value){
          vm.setterPickup(value);
          vm.setterDelivery(value);

        });

      }
    }
    vm.setterDelivery = function (value){
      if (value.id == vm.dataUpdateLoad.delivery_address_id){
        vm.dataSelectDeliveryCity                 = value.line_1;
        vm.dataSelectDeliveryAddress              = value.line_1;

        vm.dataUpdateLoad.city_delivery              = value.city;
        vm.dataUpdateLoad.country_delivery           = value.country;
        vm.dataUpdateLoad.delivery_address           = value.line_1;
        vm.dataUpdateLoad.lat_delivery_address       = value.latitude;
        vm.dataUpdateLoad.long_delivery_address      = value.longitude;

        vm.dataUpdateLoad.detail_address_delivery    = value.description;
        vm.dataUpdateLoad.zip_code_delivery          = value.zip_code;
      }
      if (vm.dataUpdateLoad.delivery_address_id == null){
        vm.dataSelectDeliveryCity                 = "";
        vm.dataSelectDeliveryAddress              = "";

        vm.dataUpdateLoad.city_delivery              = "";
        vm.dataUpdateLoad.country_delivery           = "";
        vm.dataUpdateLoad.delivery_address           = "";
        vm.dataUpdateLoad.lat_delivery_address       = "";
        vm.dataUpdateLoad.long_delivery_address      = "";

        vm.dataUpdateLoad.detail_address_delivery    = "";
        vm.dataUpdateLoad.zip_code_delivery          = "";
      }
    }
    vm.setterPickup = function (value){
      $log.log(vm.dataUpdateLoad.pickup_address_id);
      if (value.id == vm.dataUpdateLoad.pickup_address_id){
        vm.dataSelectPickupCity                 = value.line_1;
        vm.dataSelectPickupAddress              = value.line_1;

        vm.dataUpdateLoad.city_pickup              = value.city;
        vm.dataUpdateLoad.country_pickup           = value.country;
        vm.dataUpdateLoad.pickup_address           = value.line_1;
        vm.dataUpdateLoad.lat_pickup_address       = value.latitude;
        vm.dataUpdateLoad.long_pickup_address      = value.longitude;

        vm.dataUpdateLoad.detail_address_pickup    = value.description;
        vm.dataUpdateLoad.zip_code_pickup          = value.zip_code;
      }
      if (vm.dataUpdateLoad.pickup_address_id == null){
        vm.dataSelectPickupCity                 = "";
        vm.dataSelectPickupAddress              = "";
        vm.dataUpdateLoad.city_pickup              = "";
        vm.dataUpdateLoad.country_pickup           = "";
        vm.dataUpdateLoad.pickup_address           = "";
        vm.dataUpdateLoad.lat_pickup_address       = "";
        vm.dataUpdateLoad.long_pickup_address      = "";
        vm.dataUpdateLoad.detail_address_pickup    = "";
        vm.dataUpdateLoad.zip_code_pickup          = "";
      }
    }
    vm.cmbWeightUnit = function (){
      vm.cmbWeightUnits = [];
      if (vm.itemsSizeLenLoads.WeightUnit.length > 0){
        angular.forEach(vm.itemsSizeLenLoads.WeightUnit, function (value){
          vm.cmbWeightUnits.push({
            value   : value.value,
            text    : value.text
          });
          vm.dataUpdateLoad.weight_unit = 't';
        });
      }
    }
    vm.cmbAddresses = function (){
      vm.cmbAddresses = [];
      if (vm.itemsSizeLenLoads.Addresses.length > 0){
        angular.forEach(vm.itemsSizeLenLoads.Addresses,function (value){
          vm.cmbAddresses.push({
            id      : value.id,
            text    : value.line_1,
            checked : false
          });
        });
      }
    }
    vm.cleanLoadHeightValue = function() {
      if(vm.dataUpdateLoad.height !== undefined && vm.dataUpdateLoad.height !== null){
        var textToConvert = vm.dataUpdateLoad.height.toString();
        textToConvert = textToConvert.replace(/[a-zA-Z\s\W]/gm, "");
        return vm.dataUpdateLoad.height = parseInt(textToConvert);
      }
      vm.dataUpdateLoad.height = 0;
    };
    vm.cleanLoadWidthValue = function() {
      if(vm.dataUpdateLoad.width !== undefined && vm.dataUpdateLoad.width !== null){
        var textToConvert = vm.dataUpdateLoad.width.toString();
        textToConvert = textToConvert.replace(/[a-zA-Z\s\W]/gm, "");
        return vm.dataUpdateLoad.width = parseInt(textToConvert);
      }
      vm.dataUpdateLoad.width = 0;
    };
    /* Set load skills list as local var */
    vm.setLoadsSkillsRequiredList = function() {
      vm.skillsRequiredCarrier = [];
      if(vm.itemsSizeLenLoads.LoadsSkillsRequired_list.length){
        for(var i in vm.itemsSizeLenLoads.LoadsSkillsRequired_list){
          vm.skillsRequiredCarrier.push({
            id      : vm.itemsSizeLenLoads.LoadsSkillsRequired_list[i].id,
            name    : vm.itemsSizeLenLoads.LoadsSkillsRequired_list[i].skills_required_name,
            checked : false
          });
        }
      }
    };

    /* Set load types list as local var */
    vm.setLoadsTypeList = function() {
      vm.loadTypeList = [];
      if(vm.itemsSizeLenLoads.LoadsType_list.length){
        for(var i in vm.itemsSizeLenLoads.LoadsType_list){
          vm.loadTypeList.push({id: vm.itemsSizeLenLoads.LoadsType_list[i].id, name: vm.itemsSizeLenLoads.LoadsType_list[i].skill_name, checked: false});
        }
      }
    };

    vm.setSimpleLoadsLength = function() {
      vm.simpleLoadsLength = [];
      if(vm.itemsSizeLenLoads.LoadsLength_list.length){
        for(var i in vm.itemsSizeLenLoads.LoadsLength_list){
          if(vm.itemsSizeLenLoads.LoadsLength_list[i].type_length == "s"){
            vm.simpleLoadsLength.push({id: vm.itemsSizeLenLoads.LoadsLength_list[i].id, name: vm.itemsSizeLenLoads.LoadsLength_list[i].name, checked: false});
          }
        }
      }
    };

    vm.setFullLoadsLength = function() {
      vm.fullLoadsLength = [];
      if(vm.itemsSizeLenLoads.LoadsLength_list.length){
        for(var i in vm.itemsSizeLenLoads.LoadsLength_list){
          if(vm.itemsSizeLenLoads.LoadsLength_list[i].type_length == "f"){
            vm.fullLoadsLength.push({id: vm.itemsSizeLenLoads.LoadsLength_list[i].id, name: vm.itemsSizeLenLoads.LoadsLength_list[i].name, checked: false});
          }
        }
      }
    };

    /* Get load info  */
    vm.getDataLoad = function() {
      var loadOptions = {
        'token': Auth.getUserToken(),
        'load_id': (vm.loadId) ? vm.loadId : false
      };

      if(loadOptions.load_id){
        Loads.getLoadDetails(loadOptions).then(function(response){
            if(response.result){
              if(vm.validStatuses.indexOf(response.result.status_loads) != -1){
                vm.loadData = response.result;
                if(angular.isDefined(vm.loadData.load_documents) && vm.loadData.load_documents.length){
                  var arr_img = '';var elements_img = '';var elements_file = '';

                  for(var f_index in vm.loadData.load_documents){
                    if(vm.loadData.load_documents[f_index].type_file == 'pdf'){
                      $log.log(vm.loadData.load_documents[f_index]);
                      vm.loadFilesPdfList.push({
                        id    : f_index + 1,
                        url   : vm.loadData.load_documents[f_index].invoice_file,
                        invoice_name : vm.loadData.load_documents[f_index].invoice_name
                      });
                    }else{
                      if(vm.loadData.load_documents[f_index].invoice_file.indexOf("[{") !== -1){
                        arr_img = $.parseJSON('['+vm.loadData.load_documents[f_index].invoice_file+']');
                        elements_img = arr_img[0][0].normal.split("/");
                        vm.loadFilesList.push({
                          id    : f_index + 1,
                          url   : arr_img[0][0].normal,
                          invoice_name : elements_img[elements_img.length - 1]
                        });
                      }else{
                        elements_file = vm.loadData.load_documents[f_index].invoice_file.split("/");
                        vm.loadFilesList.push({
                          id: f_index + 1,
                          url: vm.loadData.load_documents[f_index].invoice_file,
                          invoice_name: elements_file[elements_file.length - 1]
                        });
                      }
                    }
                  }
                }
                vm.setDataToForm();
                vm.loadingDataDetails = false;
              }else{
                $state.go('private.loads');
              }
            }else{
              $state.go('private.loads');
            }
          })
          .catch(function (error) {
            vm.loadingDataDetails = false;
            $log.error(error);
            $state.go('private.loads');
          });
      }else{
        vm.loadingDataDetails = false;
        $state.go('private.loads');
      }
    };
    /* Set load info in local vars  */
    vm.setDataToForm = function() {
      vm.dataUpdateLoad.load_id     = (angular.isDefined(vm.loadData.load_id))
        ? vm.loadData.load_id
        : null;
      vm.dataUpdateLoad.city_pickup = (angular.isDefined(vm.loadData.from))
        ? vm.loadData.from
        : null;
      vm.dataUpdateLoad.pickup_date = (angular.isDefined(vm.loadData.pickup_date))
        ? moment(vm.loadData.pickup_date)
        : null;

      if(angular.isDefined(vm.loadData.timer_star_pickup)){
        var aux_timer_star_pickup = new Date(vm.loadData.timer_star_pickup);

        vm.pickup_start_time_hour = (aux_timer_star_pickup.getHours() > 9)
          ? aux_timer_star_pickup.getHours().toString()
          : '0' + aux_timer_star_pickup.getHours().toString();
        vm.pickup_start_time_minutes = (aux_timer_star_pickup.getMinutes() > 9)
          ? aux_timer_star_pickup.getMinutes().toString()
          : '0' + aux_timer_star_pickup.getMinutes().toString();

      }

      if(angular.isDefined(vm.loadData.timer_finish_pickup)){
        var aux_timer_finish_pickup = new Date(vm.loadData.timer_finish_pickup);

        vm.pickup_finish_time_hour = (aux_timer_finish_pickup.getHours() > 9)
          ? aux_timer_finish_pickup.getHours().toString()
          : '0' + aux_timer_finish_pickup.getHours().toString();
        vm.pickup_finish_time_minutes = (aux_timer_finish_pickup.getMinutes() > 9)
          ? aux_timer_finish_pickup.getMinutes().toString()
          :'0' + aux_timer_finish_pickup.getMinutes().toString();
      }

      vm.dataUpdateLoad.pickup_address        = (angular.isDefined(vm.loadData.pickup_address))
        ? vm.loadData.pickup_address
        : null;
      vm.dataUpdateLoad.detail_address_pickup = (angular.isDefined(vm.loadData.detail_address_pickup))
        ? vm.loadData.detail_address_pickup
        : null;
      vm.dataUpdateLoad.lat_pickup_address    = (angular.isDefined(vm.loadData.lat_pickup_adress))
        ? vm.loadData.lat_pickup_adress
        : null;
      vm.dataUpdateLoad.long_pickup_address   = (angular.isDefined(vm.loadData.long_pickup_adress))
        ? vm.loadData.long_pickup_adress
        : null;
      vm.dataUpdateLoad.zip_code_pickup       = (angular.isDefined(vm.loadData.zip_code_pickup))
        ? vm.loadData.zip_code_pickup
        : null;
      vm.dataUpdateLoad.city_delivery         = (angular.isDefined(vm.loadData.to))
        ? vm.loadData.to
        : null;
      vm.dataUpdateLoad.delivery_date         = (angular.isDefined(vm.loadData.delivery_date))
        ? moment(vm.loadData.delivery_date)
        : null;

      if(angular.isDefined(vm.loadData.timer_start_delivery)){
        var aux_timer_start_delivery = new Date(vm.loadData.timer_start_delivery);

        if(aux_timer_start_delivery.getHours() > 9){
          vm.delivery_start_time_hour = aux_timer_start_delivery.getHours().toString();
        }else{
          vm.delivery_start_time_hour ='0' + aux_timer_start_delivery.getHours().toString();
        }

        if(aux_timer_start_delivery.getMinutes() > 9){
          vm.delivery_start_time_minutes = aux_timer_start_delivery.getMinutes().toString();
        }else{
          vm.delivery_start_time_minutes = '0' + aux_timer_start_delivery.getMinutes().toString();
        }
      }

      if(angular.isDefined(vm.loadData.timer_finish_delivery)){
        var aux_timer_finish_delivery = new Date(vm.loadData.timer_finish_delivery);

        if(aux_timer_finish_delivery.getHours() > 9){
          vm.delivery_finish_time_hour = aux_timer_finish_delivery.getHours().toString();
        }else{
          vm.delivery_finish_time_hour ='0' + aux_timer_finish_delivery.getHours().toString();
        }

        if(aux_timer_finish_delivery.getMinutes() > 9){
          vm.delivery_finish_time_minutes = aux_timer_finish_delivery.getMinutes().toString();
        }else{
          vm.delivery_finish_time_minutes = '0' + aux_timer_finish_delivery.getMinutes().toString();
        }
      }

      vm.dataUpdateLoad.delivery_address        = (angular.isDefined(vm.loadData.delivery_address)) ? vm.loadData.delivery_address : null;
      vm.dataUpdateLoad.detail_address_delivery = (angular.isDefined(vm.loadData.detail_address_delivery)) ? vm.loadData.detail_address_delivery : null;
      vm.dataUpdateLoad.lat_delivery_address    = (angular.isDefined(vm.loadData.lat_delivery_address)) ? vm.loadData.lat_delivery_address : null;
      vm.dataUpdateLoad.long_delivery_address   = (angular.isDefined(vm.loadData.long_delivery_address)) ? vm.loadData.long_delivery_address : null;
      vm.dataUpdateLoad.zip_code_delivery       = (angular.isDefined(vm.loadData.zip_code_delivery)) ? vm.loadData.zip_code_delivery : null;
      vm.dataUpdateLoad.weight                  = (angular.isDefined(vm.loadData.weight)) ? parseInt(vm.loadData.weight) : null;
      vm.dataUpdateLoad.width                   = (angular.isDefined(vm.loadData.width)) ? parseInt(vm.loadData.width) : null;
      vm.dataUpdateLoad.height                  = (angular.isDefined(vm.loadData.height)) ? parseInt(vm.loadData.height) : null;
      vm.dataUpdateLoad.length_loads            = (angular.isDefined(vm.loadData.length_loads)) ? parseInt(vm.loadData.length_loads) : null;
      vm.dataUpdateLoad.container_type_code     = (angular.isDefined(vm.loadData.container_type_code))
        ? vm.loadData.container_type_code
        : null;
      vm.dataUpdateLoad.profit_center_code      = (angular.isDefined(vm.loadData.profit_center_code))
        ? vm.loadData.profit_center_code
        : null;


      if(vm.loadData.type_load && vm.loadData.type_load.length > 0){
        vm.dataUpdateLoad.load_type = [];
        for(var index in vm.loadData.type_load){
          vm.dataUpdateLoad.load_type.push(vm.loadData.type_load[index].id.toString());
          vm.load_type_combo_box = vm.loadData.type_load[index].id.toString();
        }

        if(angular.isDefined(vm.loadTypeList) && vm.loadTypeList.length){
          vm.loadTypeList.forEach(function(item) {
            if(vm.dataUpdateLoad.load_type.indexOf(item.id.toString()) != -1){
              item.checked = true;
            }
          });
        }
      }
      vm.dataUpdateLoad.noot_load = (angular.isDefined(vm.loadData.noot_load)) ? vm.loadData.noot_load : null;
      if(vm.loadData.dimension && vm.itemsSizeLenLoads.LoadsSize_list.length > 0){
        for(var sizeindex in vm.itemsSizeLenLoads.LoadsSize_list){
          if(vm.itemsSizeLenLoads.LoadsSize_list[sizeindex].name == vm.loadData.dimension){
            vm.dataUpdateLoad.dimension = vm.itemsSizeLenLoads.LoadsSize_list[sizeindex].id.toString();
            if(vm.dataUpdateLoad.dimension == "1"){
              vm.truckTypeConf = 'S';
            }else if(vm.dataUpdateLoad.dimension == "2"){
              vm.truckTypeConf = 'F';
            }
          }
        }
      }

      vm.dataUpdateLoad.truck_type_id = null;
      vm.truckTypeRequired = null;

      if(angular.isDefined(vm.loadData.truck_type_load)){
        if(angular.isDefined(vm.loadData.truck_type_load.id)){
          vm.dataUpdateLoad.truck_type_id = vm.loadData.truck_type_load.id.toString();
          vm.truckTypeRequired = vm.loadData.truck_type_load.id.toString();
        }
      }

      if(vm.truckTypeRequired != null && vm.truckTypeRequired != "0" && vm.truckTypeRequired != 0){
        if(vm.TruckTypesRemolque.indexOf(parseInt(vm.truckTypeRequired)) !== -1){
          if(vm.dataUpdateLoad.dimension == "1"){
            vm.lenghtType = 'S';
          }else if(vm.dataUpdateLoad.dimension == "2"){
            vm.lenghtType = 'F';
          }
        }
      }

      /*vm.dataUpdateLoad.lenght = (angular.isDefined(vm.loadData.length_loads)) ? vm.loadData.length_loads.toString() : null;
      if(vm.dataUpdateLoad.lenght != null){
        if(vm.dataUpdateLoad.lenght.indexOf("FT ft") !== -1){
          vm.dataUpdateLoad.lenght = vm.dataUpdateLoad.lenght.replace("FT ft", "FT");
        }
      }*/

      vm.dataUpdateLoad.price = (angular.isDefined(vm.loadData.price)) ? vm.loadData.price : null;
      vm.dataUpdateLoad.frecuency_active = (angular.isDefined(vm.loadData.recurrent_load_status)) ? (vm.loadData.recurrent_load_status == 'True' ? 1 : 0) : 0;
      if(angular.isDefined(vm.loadData.recurrent)){
        if(angular.isDefined(vm.loadData.recurrent.id)){
          vm.dataUpdateLoad.frecuency_id = vm.loadData.recurrent.id.toString();

          if(vm.dataUpdateLoad.frecuency_id == '6' && angular.isDefined(vm.loadData.recurrent_load_frecuency_days)){
            vm.dataUpdateLoad.frecuency_data = moment(vm.loadData.recurrent_load_frecuency_days);
          }
        }
      }

      if(vm.loadData.skills_required_carrier && vm.loadData.skills_required_carrier.length > 0){
        vm.dataUpdateLoad.skills_required_carrier = [];
        for(var carrierskillindex in vm.loadData.skills_required_carrier){
          vm.dataUpdateLoad.skills_required_carrier.push(vm.loadData.skills_required_carrier[carrierskillindex].id.toString());
        }

        if(angular.isDefined(vm.skillsRequiredCarrier) && vm.skillsRequiredCarrier.length){
          vm.skillsRequiredCarrier.forEach(function(item) {
            if(vm.dataUpdateLoad.skills_required_carrier.indexOf(item.id.toString()) != -1){
              item.checked = true;
            }
          });
        }
      }

      vm.dataUpdateLoad.consignee = (angular.isDefined(vm.loadData.consignee)) ? vm.loadData.consignee : null;
      vm.dataUpdateLoad.receiver = (angular.isDefined(vm.loadData.receiver)) ? vm.loadData.receiver : null;
      vm.dataUpdateLoad.commodity_id = null;
      if(angular.isDefined(vm.loadData.commodity)){
        if(angular.isDefined(vm.loadData.commodity[0])){
          vm.dataUpdateLoad.commodity_id = vm.loadData.commodity[0].id.toString();
        }
      }

      vm.dataUpdateLoad.load_comments = (angular.isDefined(vm.loadData.comments)) ? vm.loadData.comments : null;

      vm.dataSelectPickupCity = (angular.isDefined(vm.loadData.from)) ? vm.loadData.from : null;
      vm.dataSelectDeliveryCity = (angular.isDefined(vm.loadData.to)) ? vm.loadData.to : null;
      vm.dataSelectPickupAddress = (angular.isDefined(vm.loadData.pickup_address)) ? vm.loadData.pickup_address : null;
      vm.dataSelectDeliveryAddress = (angular.isDefined(vm.loadData.delivery_address)) ? vm.loadData.delivery_address : null;

      if(angular.isDefined(vm.loadData.stops_loads)){
        if(vm.loadData.stops_loads.length > 0){
          vm.dataUpdateLoad.allow_multiple_stops = 1;
          vm.indiceParadasMultiples = 0;
          vm.camposParadasMultiples = [];
          vm.dataUpdateLoad.stops_initial = [];

          for(var i in vm.loadData.stops_loads){
            vm.camposParadasMultiples.push({id: vm.indiceParadasMultiples, address: vm.loadData.stops_loads[i].address_stop});
            vm.dataUpdateLoad.stops_initial.push({address: vm.loadData.stops_loads[i].address_stop, lat: vm.loadData.stops_loads[i].lat_stop, long: vm.loadData.stops_loads[i].long_stop});
            vm.indiceParadasMultiples++;
          }
        }
      }

      if(angular.isDefined(vm.loadData.trailer_type)){
        if(angular.isDefined(vm.loadData.trailer_type.id)){
          vm.dataUpdateLoad.trailer_type = vm.loadData.trailer_type.id.toString();
        }
      }

    };
    /* Validate and send form data to API */
    vm.save = function(postLoadFormName) {
      vm.carrierSkillsRequired = false;
      vm.savingUpdateLoad = true;
      // Validate form.
      if (postLoadFormName.$invalid) {

          if(angular.isDefined(vm.skillsRequiredCarrier)){
            var carrierSkillsChecked = 0;
            vm.skillsRequiredCarrier.forEach(function(item) {
              if (item.checked) carrierSkillsChecked++;
            });

            if(carrierSkillsChecked <= 0){
              vm.carrierSkillsRequired = true;
            }
          }

          // If there was an error for required fields.
          if (postLoadFormName.$error.required) {
              toastr.error($filter('translate')('loads:add:form:required:fields:error'));
          } else {
              toastr.error($filter('translate')('loads:add:form:required:fields:invalid'));
          }
          vm.savingUpdateLoad = false;
          return;
      }

      if(parseInt(vm.pickup_start_time_hour) > parseInt(vm.pickup_finish_time_hour)){
        toastr.error($filter('translate')('loads:add:form:pickup_date_range:fields:error'));
        vm.savingUpdateLoad = false;
        return;
      }else{
        var aux_date_pickup = new Date(vm.dataUpdateLoad.pickup_date);

        vm.dataUpdateLoad.timer_star_pickup = '';
        vm.dataUpdateLoad.timer_finish_pickup = '';
        vm.dataUpdateLoad.timer_star_pickup += aux_date_pickup.getFullYear() + '-';
        if((aux_date_pickup.getMonth() + 1) > 9){
          vm.dataUpdateLoad.timer_star_pickup += (aux_date_pickup.getMonth() + 1) + '-';
        }else{
          vm.dataUpdateLoad.timer_star_pickup += '0' + (aux_date_pickup.getMonth() + 1) + '-';
        }

        if(aux_date_pickup.getDate() > 9){
          vm.dataUpdateLoad.timer_star_pickup += aux_date_pickup.getDate() + ' ';
        }else{
          vm.dataUpdateLoad.timer_star_pickup += '0' + aux_date_pickup.getDate() + ' ';
        }

        vm.dataUpdateLoad.timer_finish_pickup += vm.dataUpdateLoad.timer_star_pickup;

        vm.dataUpdateLoad.timer_star_pickup += vm.pickup_start_time_hour + ':';
        vm.dataUpdateLoad.timer_star_pickup += vm.pickup_start_time_minutes + ':';
        vm.dataUpdateLoad.timer_star_pickup += '00';

        vm.dataUpdateLoad.timer_finish_pickup += vm.pickup_finish_time_hour + ':';
        vm.dataUpdateLoad.timer_finish_pickup += vm.pickup_finish_time_minutes + ':';
        vm.dataUpdateLoad.timer_finish_pickup += '00';
      }

      if(parseInt(vm.delivery_start_time_hour) > parseInt(vm.delivery_finish_time_hour)){
        toastr.error($filter('translate')('loads:add:form:delivery_date_range:fields:error'));
        vm.savingUpdateLoad = false;
        return;
      }else{
        var aux_date_delivery = new Date(vm.dataUpdateLoad.delivery_date);

        vm.dataUpdateLoad.timer_start_delivery = '';
        vm.dataUpdateLoad.timer_finish_delivery = '';
        vm.dataUpdateLoad.timer_start_delivery += aux_date_delivery.getFullYear() + '-';
        if((aux_date_delivery.getMonth() + 1) > 9){
          vm.dataUpdateLoad.timer_start_delivery += (aux_date_delivery.getMonth() + 1) + '-';
        }else{
          vm.dataUpdateLoad.timer_start_delivery += '0' + (aux_date_delivery.getMonth() + 1) + '-';
        }

        if(aux_date_delivery.getDate() > 9){
          vm.dataUpdateLoad.timer_start_delivery += aux_date_delivery.getDate() + ' ';
        }else{
          vm.dataUpdateLoad.timer_start_delivery += '0' + aux_date_delivery.getDate() + ' ';
        }

        vm.dataUpdateLoad.timer_finish_delivery += vm.dataUpdateLoad.timer_start_delivery;

        vm.dataUpdateLoad.timer_start_delivery += vm.delivery_start_time_hour + ':';
        vm.dataUpdateLoad.timer_start_delivery += vm.delivery_start_time_minutes + ':';
        vm.dataUpdateLoad.timer_start_delivery += '00';

        vm.dataUpdateLoad.timer_finish_delivery += vm.delivery_finish_time_hour + ':';
        vm.dataUpdateLoad.timer_finish_delivery += vm.delivery_finish_time_minutes + ':';
        vm.dataUpdateLoad.timer_finish_delivery += '00';
      }

      if(vm.dataUpdateLoad.dimension == "1" || vm.dataUpdateLoad.dimension == "2"){
        if(vm.truckTypeRequired != '' && vm.truckTypeRequired != '0' && vm.truckTypeRequired != 0 && vm.truckTypeRequired != null){
          vm.dataUpdateLoad.truck_type_id = vm.truckTypeRequired;

          if(vm.TruckTypesRemolque.indexOf(parseInt(vm.truckTypeRequired)) !== -1){
            if(vm.dataUpdateLoad.lenght <= 0 || vm.dataUpdateLoad.lenght === null){
              toastr.error($filter('translate')('loads:add:form:required:fields:error'));
              vm.savingUpdateLoad = false;
              return;
            }
          }else{
            vm.dataUpdateLoad.lenght = null;
          }
        }else{
          toastr.error($filter('translate')('loads:add:form:required:fields:error'));
          vm.savingUpdateLoad = false;
          return;
        }
      }

      if(vm.dataUpdateLoad.weight <= 0 || vm.dataUpdateLoad.weight === null || vm.dataUpdateLoad.weight === null){
        toastr.error($filter('translate')('loads:add:form:weight:value:invalid'));
        vm.savingUpdateLoad = false;
        return;
      }

      vm.dataUpdateLoad.load_type = [];
      if(angular.isDefined(vm.load_type_combo_box)){

        if(vm.load_type_combo_box == '' || vm.load_type_combo_box == null){
          toastr.error($filter('translate')('loads:add:form:required:fields:error'));
          vm.savingUpdateLoad = false;
          return;
        }else{
          vm.dataUpdateLoad.load_type.push(vm.load_type_combo_box);
        }

        vm.dataUpdateLoad.load_type = JSON.stringify(vm.dataUpdateLoad.load_type);
      }

      if(angular.isDefined(vm.skillsRequiredCarrier)){
        vm.dataUpdateLoad.skills_required_carrier = [];
        vm.skillsRequiredCarrier.forEach(function(item) {
          if (item.checked) vm.dataUpdateLoad.skills_required_carrier.push(item.id);
        });

        if(vm.dataUpdateLoad.skills_required_carrier.length <= 0){
          toastr.error($filter('translate')('loads:add:form:required:fields:error'));
          vm.carrierSkillsRequired = true;
          vm.savingUpdateLoad = false;
          return;
        }

        vm.dataUpdateLoad.skills_required_carrier = JSON.stringify(vm.dataUpdateLoad.skills_required_carrier);
      }

      if(typeof vm.dataSelectPickupCity != typeof vm.dataUpdateLoad.city_pickup){
        vm.dataUpdateLoad.city_pickup = (angular.isDefined(vm.dataSelectPickupCity.name) ? vm.dataSelectPickupCity.name : vm.dataSelectPickupCity.formatted_address);
      }

      if(typeof vm.dataSelectPickupAddress != typeof vm.dataUpdateLoad.pickup_address){
        vm.dataUpdateLoad.pickup_address = vm.dataSelectPickupAddress.formatted_address;
        vm.dataUpdateLoad.lat_pickup_address = (angular.isDefined(vm.dataSelectPickupAddress.geometry) ? vm.dataSelectPickupAddress.geometry.location.lat() : null);
        vm.dataUpdateLoad.long_pickup_address = (angular.isDefined(vm.dataSelectPickupAddress.geometry) ? vm.dataSelectPickupAddress.geometry.location.lng() : null);

        if(angular.isDefined(vm.dataSelectPickupAddress.address_components)){
          for(var i in vm.dataSelectPickupAddress.address_components){
            if(vm.dataSelectPickupAddress.address_components[i].types.indexOf('administrative_area_level_1') != -1){
              vm.dataUpdateLoad.state_pickup = vm.dataSelectPickupAddress.address_components[i].long_name;
            }

            if(vm.dataSelectPickupAddress.address_components[i].types.indexOf('country') != -1){
              vm.dataUpdateLoad.country_pickup = vm.dataSelectPickupAddress.address_components[i].long_name;
            }
          }
        }
      }

      if(typeof vm.dataSelectDeliveryCity != typeof vm.dataUpdateLoad.city_delivery){
        vm.dataUpdateLoad.city_delivery = (angular.isDefined(vm.dataSelectDeliveryCity.name) ? vm.dataSelectDeliveryCity.name : vm.dataSelectDeliveryCity.formatted_address);
      }

      if(typeof vm.dataSelectDeliveryAddress != typeof vm.dataUpdateLoad.delivery_address){
        vm.dataUpdateLoad.delivery_address = vm.dataSelectDeliveryAddress.formatted_address;
        vm.dataUpdateLoad.lat_delivery_address = (angular.isDefined(vm.dataSelectDeliveryAddress.geometry) ? vm.dataSelectDeliveryAddress.geometry.location.lat() : null);
        vm.dataUpdateLoad.long_delivery_address = (angular.isDefined(vm.dataSelectDeliveryAddress.geometry) ? vm.dataSelectDeliveryAddress.geometry.location.lng() : null);

        if(angular.isDefined(vm.dataSelectDeliveryAddress.address_components)){
          for(var i in vm.dataSelectDeliveryAddress.address_components){
            if(vm.dataSelectDeliveryAddress.address_components[i].types.indexOf('administrative_area_level_1') != -1){
              vm.dataUpdateLoad.state_delivery = vm.dataSelectDeliveryAddress.address_components[i].long_name;
            }

            if(vm.dataSelectDeliveryAddress.address_components[i].types.indexOf('country') != -1){
              vm.dataUpdateLoad.country_delivery = vm.dataSelectDeliveryAddress.address_components[i].long_name;
            }
          }
        }
      }

      if(angular.isDefined(vm.dataUpdateLoad.country_pickup)){
        if((vm.dataUpdateLoad.country_pickup    != "Mexico"   &&
            vm.dataUpdateLoad.country_pickup    != "México")  ||
          (vm.dataUpdateLoad.country_delivery   != "Mexico"   &&
            vm.dataUpdateLoad.country_delivery  != "México")
        ){
          toastr.error($filter('translate')('loads:add:form:country:fields:error'));
          vm.savingUpdateLoad = false;
          return;
        }
      }

      var multiplestops_errors = false;
      if(vm.dataUpdateLoad.allow_multiple_stops == 1){
        vm.dataUpdateLoad.stops = [];
        var temp_address = null
        , temp_lat = null
        , temp_long = null
        , temp_country = null;
        for(var imstp in vm.camposParadasMultiples){
          if(vm.camposParadasMultiples[imstp].address != null && vm.camposParadasMultiples[imstp].address != ""){
            if(angular.isDefined(vm.camposParadasMultiples[imstp].address.formatted_address) && angular.isDefined(vm.camposParadasMultiples[imstp].address.address_components)){

              for(var add_comp in vm.camposParadasMultiples[imstp].address.address_components){
                if(vm.camposParadasMultiples[imstp].address.address_components[add_comp].types.indexOf('country') != -1){
                  temp_country = vm.camposParadasMultiples[imstp].address.address_components[add_comp].long_name;
                }
              }

              if(temp_country == "Mexico" || temp_country == "México"){
                temp_address = vm.camposParadasMultiples[imstp].address.formatted_address;
                temp_lat = (angular.isDefined(vm.camposParadasMultiples[imstp].address.geometry) ? vm.camposParadasMultiples[imstp].address.geometry.location.lat() : null);
                temp_long = (angular.isDefined(vm.camposParadasMultiples[imstp].address.geometry) ? vm.camposParadasMultiples[imstp].address.geometry.location.lng() : null);

                if(temp_address && temp_lat && temp_long){
                  vm.dataUpdateLoad.stops.push({address: temp_address, lat: temp_lat, long: temp_long});
                }else{
                  multiplestops_errors = true;
                }
              }else{
                multiplestops_errors = true;
              }

            }else{
              var found_add = false;
              for(var ini in vm.dataUpdateLoad.stops_initial){
                if(vm.dataUpdateLoad.stops_initial[ini].address == vm.camposParadasMultiples[imstp].address){
                  found_add = true;
                  vm.dataUpdateLoad.stops.push({address: vm.dataUpdateLoad.stops_initial[ini].address, lat: vm.dataUpdateLoad.stops_initial[ini].lat, long: vm.dataUpdateLoad.stops_initial[ini].long});
                }
              }

              if(!found_add){
                multiplestops_errors = true;
              }

            }

            temp_address = null;
            temp_lat = null;
            temp_long = null;
            temp_country = null;
          }else{
            multiplestops_errors = true;
          }
        }
      }

      if(multiplestops_errors){
        toastr.error($filter('translate')('loads:add:form:multiple_stops:error'));
        vm.savingUpdateLoad = false;
        return;
      }else{
        if(vm.dataUpdateLoad.allow_multiple_stops == 1){
          vm.dataUpdateLoad.stops = JSON.stringify(vm.dataUpdateLoad.stops);
        }
      }

      if(vm.reviewPriceWs === true){
        var paramsCheckPrice = {};
        paramsCheckPrice.token = vm.dataUpdateLoad.token;
        paramsCheckPrice.origin_city = vm.dataUpdateLoad.city_pickup;
        paramsCheckPrice.origin_state = angular.isDefined(vm.dataUpdateLoad.state_pickup) ? vm.dataUpdateLoad.state_pickup : vm.dataUpdateLoad.city_pickup;
        paramsCheckPrice.destini_city = vm.dataUpdateLoad.city_delivery;
        paramsCheckPrice.destini_state = angular.isDefined(vm.dataUpdateLoad.state_delivery) ? vm.dataUpdateLoad.state_delivery : vm.dataUpdateLoad.city_delivery;
        paramsCheckPrice.type_equipament = vm.dataUpdateLoad.load_type;
        paramsCheckPrice.skills_required_carrier = vm.dataUpdateLoad.skills_required_carrier;

        Loads.checkLoadPriceWs(paramsCheckPrice).then(function (response) {
          vm.priceSuggested = response.price;
          vm.openCheckedPriceModal();
        }, function (error) {
          vm.priceSuggested = 0;
          $log.error(error);
          vm.openCheckedPriceModal();
        });
      }else{
        var defer = $q.defer();
        Loads.updateLoad(vm.dataUpdateLoad).then(function (response) {
          toastr.success($filter('translate')('loads:add:form:success'));
          $state.go('private.loads');
        }, function (error) {
            toastr.error($filter('translate')('loads:add:form:required:fields:invalid'));
            $log.error(error);
        });

        vm.savingUpdateLoad = false;
      }


    };
    vm.openCheckedPriceModal = function() {
      var modalInstance = $uibModal.open({
        controller: 'CheckedLoadPriceModalController as loadprice',
        windowClass: 'load-price-modal',
        templateUrl: 'app/loads/templates/modal/checked-load-price.html',
        resolve: {
            price: function() {
                return vm.priceSuggested;
            },
            load: function() {
                return vm.dataUpdateLoad;
            }
        }
      });

      modalInstance.result.then(function(price) {
          vm.dataUpdateLoad.price = price;
          Loads.updateLoad(vm.dataUpdateLoad).then(function (response) {
            toastr.success($filter('translate')('loads:add:form:success'));
            $state.go('private.loads');
          }, function (error) {
            $log.error(error)
            toastr.error($filter('translate')('loads:add:form:required:fields:invalid'));
          });

            vm.savingUpdateLoad = false;
      });
    };
    /* Upload documents */
    vm.uploadLegalDoc = function(file) {
            // Upload logo image.
            if (file) {
                // Loading
                vm.fileSaving = true;

                var nameFile = vm.dataUpdateLoad.load_id+'_'+moment().milliseconds();

                if(file.name){
                  var nameFileArr = file.name;
                  nameFileArr = nameFileArr.split(".");
                  nameFile = nameFileArr[0];
                }

                // Upload
                var params = {
                    token: Auth.getUserToken(),
                    invoice_name: nameFile,
                    load_id: vm.dataUpdateLoad.load_id,
                    invoice_type: 'legal_doc',
                    pic: file
                };
                Loads.uploadInvoiceToLoad(params)
                    .then(function(response) {
                        // Success
                        var elements_invoice = '';
                        if(angular.isDefined(response.invoice_name)){
                          if(response.type_file == "pdf"){
                            elements_invoice = response.invoice_name.split("/");
                            vm.loadFilesPdfList.push({ url: response.invoice_name, title: elements_invoice[elements_invoice.length - 1], invoice_name:nameFile});
                          }else{
                            if(response.invoice_name.length > 0){
                              elements_invoice = response.invoice_name[0].normal.split("/");
                              vm.loadFilesList.push({url: response.invoice_name[0].normal, title: elements_invoice[elements_invoice.length - 1], invoice_name:nameFile});
                            }
                          }
                        }
                        toastr.success($filter('translate')('loads:edit:invoice:upload:successfully'));

                        // Loading
                        vm.fileSaving = false;
                    })
                    .catch(function(error) {
                        // Error
                        $log.error(error);
                        // Loading
                        vm.fileSaving = false;

                        // Message.
                        toastr.error($filter('translate')('loads:edit:invoice:upload:error'));
                    });
            }
        };

    vm.cleanLoadLengthValue = function() {
      if(vm.dataUpdateLoad.length_loads !== undefined && vm.dataUpdateLoad.length_loads !== null){
        var textToConvert = vm.dataUpdateLoad.length_loads.toString();
        textToConvert = textToConvert.replace(/[a-zA-Z\s\W]/gm, "");
        vm.dataUpdateLoad.length_loads = parseInt(textToConvert);
      }else{
        vm.dataUpdateLoad.length_loads = 0;
      }
    }
    vm.cleanLoadWeightValue = function() {
      if(vm.dataUpdateLoad.weight !== undefined && vm.dataUpdateLoad.weight !== null){
        var textToConvert = vm.dataUpdateLoad.weight.toString();
        textToConvert = textToConvert.replace(/[a-zA-Z\s\W]/gm, "");
        vm.dataUpdateLoad.weight = parseInt(textToConvert);
      }else{
        vm.dataUpdateLoad.weight = 0;
      }
    }

    vm.sizeConfigurationChange = function() {
      switch(vm.dataUpdateLoad.dimension){
        case "1":
          vm.lenghtType = 'NA';
          vm.truckTypeConf = 'S';
          vm.truckTypeRequired = null;
          vm.dataUpdateLoad.lenght = null;
          break;
        case "2":
          vm.lenghtType = 'NA';
          vm.truckTypeConf = 'F';
          vm.truckTypeRequired = null;
          vm.dataUpdateLoad.lenght = null;
          break;
        default:
          vm.lenghtType = 'NA';
          vm.truckTypeConf = 'NA';
          vm.truckTypeRequired = null;
          vm.dataUpdateLoad.lenght = null;
          break;
      }
    };
    vm.truckTypeChange = function() {
      if(vm.dataUpdateLoad.dimension == '1'){
        if(vm.TruckTypesRemolque.indexOf(parseInt(vm.truckTypeRequired)) !== -1){
          vm.lenghtType = null;
          vm.dataUpdateLoad.lenght = null;
        }else{
          vm.lenghtType = 'NA';
          vm.dataUpdateLoad.lenght = null;
        }
      }else if(vm.dataUpdateLoad.dimension == '2'){
        if(vm.TruckTypesRemolque.indexOf(parseInt(vm.truckTypeRequired)) !== -1){
          vm.lenghtType = 'F';
          vm.dataUpdateLoad.lenght = null;
        }else{
          vm.lenghtType = 'NA';
          vm.dataUpdateLoad.lenght = null;
        }
      }else{
        vm.lenghtType = 'NA';
        vm.truckTypeConf = 'NA';
        vm.truckTypeRequired = null;
        vm.dataUpdateLoad.lenght = null;
      }
    }
    vm.driverLicenseChange = function(){
      var found = false;
      for(var i in vm.itemsSizeLenLoads.loadTypeLicense){
        if(vm.itemsSizeLenLoads.loadTypeLicense[i].id.toString() == vm.dataUpdateLoad.load_type_license_id){
          found = true;
          vm.loadLicenseTypeInfo = vm.itemsSizeLenLoads.loadTypeLicense[i].descrip_categori;
          vm.loadLicenseTypeTitle = $filter('translate')('loads:add:form:load_type_license_id:title1') + " " + vm.itemsSizeLenLoads.loadTypeLicense[i].categoria + " " + $filter('translate')('loads:add:form:load_type_license_id:title2');
        }
      }

      if(!found){
        vm.loadLicenseTypeInfo = '';
        vm.loadLicenseTypeTitle = '';
      }

    }

    vm.commodityChange = function(){
      var found = false;
      for(var i in vm.itemsSizeLenLoads.ListCommodity){
        if(vm.itemsSizeLenLoads.ListCommodity[i].id.toString() == vm.dataUpdateLoad.commodity_id){
          found = true;
          vm.commodityExcludedInfo = vm.itemsSizeLenLoads.ListCommodity[i].commodity_exclude;
        }
      }

      if(!found){
        vm.commodityExcludedInfo = '';
      }
    }

    vm.resetMultipleStops = function(){
      if(vm.dataUpdateLoad.allow_multiple_stops == 1){
        vm.indiceParadasMultiples = 0;
        vm.camposParadasMultiples = [{id: vm.indiceParadasMultiples, address: null}];
      }else{
        vm.indiceParadasMultiples = 0;
        vm.camposParadasMultiples = [];
      }
    }

    vm.addMultipleStop = function(){
      if(vm.dataUpdateLoad.allow_multiple_stops == 1){
        vm.indiceParadasMultiples++;
        vm.camposParadasMultiples.push({id: vm.indiceParadasMultiples, address: null});
      }
    }

    vm.deleteMultipleStop = function(indice){
      if(indice > 0){
        if(vm.camposParadasMultiples.length > 1){
          for(var i in vm.camposParadasMultiples){
            if(vm.camposParadasMultiples[i].id == indice){
              vm.camposParadasMultiples.splice(i, 1);
            }
          }

          for(var i2 in vm.camposParadasMultiples){
            if(vm.camposParadasMultiples[i2].id > indice){
              vm.camposParadasMultiples[i2].id = vm.camposParadasMultiples[i2].id - 1;
            }
          }

          vm.indiceParadasMultiples--;
        }
      }
    }

    vm.initialize();
  }
})();

(function() {
  'use strict';

  /* Load details controller
   * Get load id
   * Get load attributes
   * Get load data
   * Allow user to do actions over the load
   */

  angular
    .module('loadsAppWeb')
    .controller('LoadsDetailsController', LoadsDetailsController);

  /** @ngInject */
  function LoadsDetailsController(
    $state,
    $stateParams,
    toastr,
    $filter,
    Config,
    Loads,
    Auth,
    DatatableTool,
    $q,
    uiGmapGoogleMapApi,
    uiGmapIsReady,
    $uibModal,
    $rootScope
  ) {
	  var vm = this;

    /* Function executed at strart, Get load id, set some vars about loading map, upload images and get load attributes */
	  vm.initialize = function() {
      vm.loadId = $stateParams.id|| false;
      vm.loadData = false;

      vm.loadInvoiceImgFilesList = [];
      vm.loadInvoiceDocsFilesList = [];
      vm.loadLegalImgFilesList = [];
      vm.loadLegalDocsFilesList = [];
      vm.legalDocFileSaving = false;
      vm.dataUpdateLoad = {};

      vm.loadingDataDetails = true;
      vm.loadingMap = true;

      vm.myData = Auth.getUserDataProfile();
      vm.userData = Auth.getUserData();
      vm.getItemsSizeLengthLoads();
      vm.isSet(1);
      vm.setTab(1);
    };

    vm.isSet = function (tabNum){
      return vm.tab === tabNum;
    }
    vm.setTab = function (newTab){
        vm.tab = newTab;
    }

    /* Get load attributes */
    vm.getItemsSizeLengthLoads = function() {
      vm.itemsSizeLenLoads = {};
      Loads.getItemsSizeLengthLoads()
        .then(function(response){
          if(response){
            vm.itemsSizeLenLoads = response;
            if(angular.isDefined(vm.itemsSizeLenLoads.LoadsSkillsRequired_list)){
              vm.setLoadsSkillsRequiredList();
            }

            if(angular.isDefined(vm.itemsSizeLenLoads.LoadsType_list)){
              vm.setLoadsTypeList();
            }
            vm.getDataLoad();
          }else{
            $state.go('private.loads');
          }
        })
        .catch(function (error) {
          console.log(error);
          $state.go('private.loads');
        });
    };

    /* Set load skills list as local var */
    vm.setLoadsSkillsRequiredList = function() {
      vm.skillsRequiredCarrier = [];
      if(vm.itemsSizeLenLoads.LoadsSkillsRequired_list.length){
        for(var i in vm.itemsSizeLenLoads.LoadsSkillsRequired_list){
          vm.skillsRequiredCarrier.push({id: vm.itemsSizeLenLoads.LoadsSkillsRequired_list[i].id, name: vm.itemsSizeLenLoads.LoadsSkillsRequired_list[i].skills_required_name, checked: false});
        }
      }
    };

    /* Set load types list as local var */
    vm.setLoadsTypeList = function() {
      vm.loadTypeList = [];
      if(vm.itemsSizeLenLoads.LoadsType_list.length){
        for(var i in vm.itemsSizeLenLoads.LoadsType_list){
          vm.loadTypeList.push({id: vm.itemsSizeLenLoads.LoadsType_list[i].id, name: vm.itemsSizeLenLoads.LoadsType_list[i].skill_name, checked: false});
        }
      }
    };

    /* Get load info */
    vm.getDataLoad = function() {
      var loadOptions = {
        'token': Auth.getUserToken(),
        'load_id': (vm.loadId) ? vm.loadId : false
      };

      if(loadOptions.load_id){
        Loads.getLoadDetails(loadOptions).then(function(response){
            if(response.result){
              vm.loadData = response.result;
              vm.search_type = $rootScope.search_type;
              if(angular.isDefined(vm.loadData.load_documents) && vm.loadData.load_documents.length){
                var arr_img; var elements_img;
                for(var f_index in vm.loadData.load_documents){
                  if(vm.loadData.load_documents[f_index].type_file == 'pdf'){

                    elements_img = vm.loadData.load_documents[f_index].invoice_file.split("/");
                    if(vm.loadData.load_documents[f_index].invoice_type == 'legal_doc'){
                      vm.loadLegalDocsFilesList.push({
                        id: f_index + 1,
                        url: vm.loadData.load_documents[f_index].invoice_file,
                        title: elements_img[elements_img.length - 1],
                        invoice_name: vm.loadData.load_documents[f_index].invoice_name
                      });
                    }else{
                      vm.loadInvoiceDocsFilesList.push({
                        id: f_index + 1,
                        url: vm.loadData.load_documents[f_index].invoice_file,
                        title: elements_img[elements_img.length - 1],
                        invoice_name: vm.loadData.load_documents[f_index].invoice_name
                      });
                    }
                  }else{
                    arr_img = $.parseJSON('['+vm.loadData.load_documents[f_index].invoice_file+']');
                    elements_img = arr_img[0][0].normal.split("/");

                    if(vm.loadData.load_documents[f_index].invoice_type == 'legal_doc'){
                      vm.loadLegalImgFilesList.push({
                        id: f_index + 1,
                        url: arr_img[0][0].normal,
                        invoice_name: elements_img[elements_img.length - 1],
                        title: vm.loadData.load_documents[f_index].invoice_name
                      });
                    }else{
                      vm.loadInvoiceImgFilesList.push({
                        id: f_index + 1,
                        url: arr_img[0][0].normal,
                        invoice_name: elements_img[elements_img.length - 1],
                        title: vm.loadData.load_documents[f_index].invoice_name
                      });
                    }
                  }
                }
              }

              if(angular.isDefined(vm.loadData.type_load) && vm.loadData.type_load.length){
                var arr_typeload = [];
                for(var i in vm.loadData.type_load){
                  arr_typeload.push(vm.loadData.type_load[i].skill_name);
                }
                vm.loadData.type_load_text = arr_typeload.join(', ');
              }else{
                vm.loadData.type_load_text = "";
              }

              if(angular.isDefined(vm.loadData.skills_required_carrier) && vm.loadData.skills_required_carrier.length){
                var arr_carrier_skills_required = [];
                for(var i in vm.loadData.skills_required_carrier){
                  arr_carrier_skills_required.push(vm.loadData.skills_required_carrier[i].skills_required_name);
                }
                vm.loadData.carrier_skills_required_text = arr_carrier_skills_required.join(', ');
              }else{
                vm.loadData.carrier_skills_required_text = "";
              }

              vm.loadData.truck_type_text = "";
              if(angular.isDefined(vm.loadData.truck_type_load)){
                if(angular.isDefined(vm.loadData.truck_type_load.id)){
                  vm.loadData.truck_type_text = vm.loadData.truck_type_load.truck_type_name;
                }
              }

              vm.loadData.price_to_show = vm.loadData.price;
              if(vm.loadData.posteverywhere == "1" && vm.loadData.price == 0){
                vm.loadData.price_to_show = $filter('translate')('loads:table:price:call:text');
              }

              vm.loadData.trailer_type_desc = '';
              if(angular.isDefined(vm.loadData.trailer_type)){
                if(angular.isDefined(vm.loadData.trailer_type.id)){
                  vm.loadData.trailer_type_desc = vm.loadData.trailer_type.trailer_type_name;
                }
              }

              /*if(vm.loadData.timer_star_pickup){
                var timer_star_pickup_aux = moment.tz(vm.loadData.timer_star_pickup, "UTC");
                vm.loadData.timer_star_pickup = timer_star_pickup_aux.clone().tz("America/Mexico_City").format('YYYY-MM-DD HH:mm:ss');
              }

              if(vm.loadData.timer_finish_pickup){
                var timer_finish_pickup_aux = moment.tz(vm.loadData.timer_finish_pickup, "UTC");
                vm.loadData.timer_finish_pickup = timer_finish_pickup_aux.clone().tz("America/Mexico_City").format('YYYY-MM-DD HH:mm:ss');
              }

              if(vm.loadData.timer_start_delivery){
                var timer_start_delivery_aux = moment.tz(vm.loadData.timer_start_delivery, "UTC");
                vm.loadData.timer_start_delivery = timer_start_delivery_aux.clone().tz("America/Mexico_City").format('YYYY-MM-DD HH:mm:ss');
              }

              if(vm.loadData.timer_finish_delivery){
                var timer_finish_delivery_aux = moment.tz(vm.loadData.timer_finish_delivery, "UTC");
                vm.loadData.timer_finish_delivery = timer_finish_delivery_aux.clone().tz("America/Mexico_City").format('YYYY-MM-DD HH:mm:ss');
              }*/

              if(vm.loadData.weight != null && vm.loadData.weight != ''){
                if(vm.loadData.weight.indexOf("lb") !== -1){
                  vm.loadData.weight = vm.loadData.weight.replace("lb", "kg");
                }
              }

              vm.initializeMap();
              vm.loadingDataDetails = false;
            }else{
              $state.go('private.loads');
            }
          })
          .catch(function (error) {
            vm.loadingDataDetails = false;
            $state.go('private.loads');
          });
      }else{
        vm.loadingDataDetails = false;
        $state.go('private.loads');
      }
    };

    /* Load the map and set load coordinates */
    vm.initializeMap = function(){
      if(angular.isDefined(vm.loadData.from_lat) && vm.loadData.from_lat != "" && angular.isDefined(vm.loadData.from_long) && vm.loadData.from_long != "" && angular.isDefined(vm.loadData.to_lat) && vm.loadData.to_lat != "" && angular.isDefined(vm.loadData.to_long) && vm.loadData.to_long != ""){
        uiGmapGoogleMapApi.then(function(maps) {
         vm.loadingMap = false;
         vm.map = { center: { latitude: vm.loadData.from_lat, longitude: vm.loadData.from_long }, zoom: 14 };
         vm.markers = [
            {id: 111, coords: { latitude: vm.loadData.from_lat, longitude: vm.loadData.from_long}, options: { icon: "assets/images/common/start_point.png" } },
            {id: 222, coords: { latitude: vm.loadData.to_lat, longitude: vm.loadData.to_long}, options: { icon: "assets/images/common/end_point.png" } }];

         if(angular.isDefined(vm.loadData.stops_loads)){
            if(vm.loadData.stops_loads.length > 0){
              for(var imstp in vm.loadData.stops_loads){
                var sumatoria = parseInt(imstp) + 1;

                if(sumatoria > 10){
                  vm.markers.push({id: vm.loadData.stops_loads[imstp].loads_id+""+vm.loadData.stops_loads[imstp].id.toString(), coords: {latitude: vm.loadData.stops_loads[imstp].lat_stop, longitude: vm.loadData.stops_loads[imstp].long_stop}, options: { icon: "assets/images/common/point_greater_10.png" }});
                }else{
                  vm.markers.push({id: vm.loadData.stops_loads[imstp].loads_id+""+vm.loadData.stops_loads[imstp].id.toString(), coords: {latitude: vm.loadData.stops_loads[imstp].lat_stop, longitude: vm.loadData.stops_loads[imstp].long_stop}, options: { icon: "assets/images/common/point_"+sumatoria+".png" }});
                }
              }
            }
          }
        });

        uiGmapIsReady.promise(1).then(function(maps) {
          google.maps.event.trigger(maps, 'resize');
        });
      }
    };

    /* Call Carrier request list modal */
    vm.openCarrierRequestModal = function() {
      var modalInstance = $uibModal.open({
        controller: 'CarrierRequestsModalController as carrierrequests',
        windowClass: 'carrier-requests-modal',
        templateUrl: 'app/loads/templates/modal/carrier-requests.html',
        resolve: {
            load: function() {
                return vm.loadId;
            }
        }
      });

      modalInstance.result.then(function() {
          vm.loadingDataDetails = true;
          vm.initialize();
      });
    };

    /* Call Carrier assigned info modal */
    vm.openCarrierAssignedInfoModal = function() {
      var modalInstance = $uibModal.open({
        controller: 'CarrierAssignedInfoModalController as carrierassignedinfo',
        windowClass: 'carrier-assigned-info-modal',
        templateUrl: 'app/loads/templates/modal/carrier-assigned-info.html',
        resolve: {
            carrier: function() {
                return vm.loadData.carrier;
            }
        }
      });
    };

    /* Call Load activity info modal */
    vm.openLoadActivityInfoModal = function() {
      var modalInstance = $uibModal.open({
        controller: 'LoadActivityInfoModalController as loadactivityinfo',
        windowClass: 'load-activity-info-modal',
        templateUrl: 'app/loads/templates/modal/load-activity-info.html',
        resolve: {
            load: function() {
                return vm.loadData;
            }
        }
      });
    };

    /* Call Truck assigned info modal */
    vm.openTruckAssignedInfoModal = function() {
      var modalInstance = $uibModal.open({
        controller: 'TruckAssignedInfoModalController as truckassignedinfo',
        windowClass: 'truck-assigned-info-modal',
        templateUrl: 'app/loads/templates/modal/truck-assigned-info.html',
        resolve: {
            truck: function() {
                return vm.loadData.info_truck;
            }
        }
      });
    };
    /* Call Truck list to assign modal */
    vm.openChooseTruckModal = function() {
      var modalInstance = $uibModal.open({
        controller: 'LoadTruckSelectModalController as loadtruckselect',
        windowClass: 'load-truck-select-modal',
        templateUrl: 'app/loads/templates/modal/load-truck-select.html',
        resolve: {
            load: function() {
                return vm.loadId;
            },
            carrier: function() {
                return vm.loadData.carrier;
            }
        }
      });

      modalInstance.result.then(function() {
          vm.loadingDataDetails = true;
          vm.initialize();
      });
    };

    /* Call Report issues modal */
    vm.openReportIssuesLoadModal = function() {
      var modalInstance = $uibModal.open({
        controller: 'ReportIssuesLoadModalController as reportissuesload',
        windowClass: 'report-issues-load-modal',
        templateUrl: 'app/loads/templates/modal/report-issues-load.html',
        resolve: {
            load: function() {
                return vm.loadId;
            }
        }
      });
    };

    /* Call Apply to load by carrier modal */
    vm.createRequestCarrierLoad = function() {
      var loadOptions = {
        'token': Auth.getUserToken(),
        'load_id': (vm.loadId) ? vm.loadId : false
      };
      Loads.createRequestCarrierLoad(loadOptions)
        .then(function(response){
          if(angular.isDefined(response.request_created)){
            if(angular.isDefined(response.request_created.idrequest_loads)){
              vm.loadingMap = true;
              vm.loadingDataDetails = true;
              vm.getDataLoad();
            }
          }
        });
    };

    /* Call Cancel my request to apply to the load modal */
    vm.cancelRequestCarrierLoad = function() {
      var loadOptions = {
        'token': Auth.getUserToken(),
        'load_id': (vm.loadId) ? vm.loadId : false
      };
      Loads.cancelRequestCarrierLoad(loadOptions)
        .then(function(response){
          vm.loadingMap = true;
          vm.loadingDataDetails = true;
          vm.getDataLoad();
          vm.legalDocFileSaving = false;
        });
    };

    /* Reject TMS request */
    vm.rejectTmsRequest = function() {
      var loadOptions = {
        'token': Auth.getUserToken(),
        'load_id': (vm.loadId) ? vm.loadId : false
      };
      Loads.rejectTmsRequest(loadOptions)
        .then(function(response){
          vm.loadingMap = true;
          vm.loadingDataDetails = true;
          vm.getDataLoad();
          vm.legalDocFileSaving = false;
        });
    };

    /* Upload images and documents to the load */
    vm.uploadLegalDoc = function(file, invalidFiles) {
        // Upload logo image.
        if (file) {
            // Loading
            vm.legalDocFileSaving = true;

            var nameFile = vm.loadId+'_'+moment().milliseconds();

            if(file.name){
              var nameFileArr = file.name;
              nameFileArr = nameFileArr.split(".");
              nameFile = nameFileArr[0];
            }

            // Upload
            var params = {
                token: Auth.getUserToken(),
                invoice_name: nameFile,
                load_id: vm.loadId,
                invoice_type: 'legal_doc',
                pic: file
            };
            Loads.uploadInvoiceToLoad(params)
                .then(function(response) {
                    // Success
                    var elements_invoice = '';
                    if(angular.isDefined(response.invoice_name) && response.invoice_name.length > 0){
                      if(response.type_file =='pdf'){
                        elements_invoice = response.invoice_name.split("/");
                        vm.loadLegalDocsFilesList.push({url: response.invoice_name, title: elements_invoice[elements_invoice.length - 1], invoice_name:nameFile });
                      }else{
                        elements_invoice = response.invoice_name[0].normal.split("/");
                        vm.loadLegalImgFilesList.push({url: response.invoice_name[0].normal, title: elements_invoice[elements_invoice.length - 1], invoice_name:nameFile});
                      }
                    }
                    toastr.success($filter('translate')('loads:edit:invoice:upload:successfully'));

                    // Loading
                    vm.legalDocFileSaving = false;

                })
                .catch(function(error) {
                    // Error
                    // Loading
                    vm.legalDocFileSaving = false;

                    // Message.
                    toastr.error($filter('translate')('loads:edit:invoice:upload:error'));
                });
        }
    };

    vm.getImageMapPoint = function(index){
      if(index > 10){
        return "point_greater_10";
      }else{
        return "point_"+index;
      }
    };

    vm.initialize();
  }
})();

(function() {
  'use strict';

  /* Loads list controller
   * Get filter data
   * Look for loads list about filters
   * Show load details in dropdown
   */

  angular.module('loadsAppWeb').controller('LoadsController', LoadsController);
  /** @ngInject */
  function LoadsController(
    $state,
    $rootScope,
    $stateParams,
    toastr,
    $translate,
    $filter,
    Config,
    Loads,
    Auth,
    DatatableTool,
    DTOptionsBuilder,
    DTColumnBuilder,
    $sce,
    $location,
    loadsStore,
    $scope,
    flux
  ) {
    var vm = this;

    vm.currentLoadId = null;
    vm.totalItems = 64;
    vm.currentPage = 4;
    vm.setPage = function (pageNo) {
      vm.currentPage = pageNo;
    };
    vm.pageChanged = function() {
      console.log('Page changed to: ' + vm.currentPage);
    };
    $scope.bigMaxSize = 5;
    $scope.bigTotalItems = 175;
    $scope.bigCurrentPage = 1;


    vm.loads = loadsStore.loads;

    $scope.$listenTo(loadsStore, function () {
      vm.loads = loadsStore.loads;

      _.forEach(vm.loads.results, function(value, key) {
        if(vm.profile == 'CARRIER' || vm.profile == 'DRIVER' || vm.profile == 'OWNER'){
          value.full_name_shipper = value.loadGenerator.company_name;
          value.img_shipper = false;
          if(angular.isDefined(value.loadGenerator.user.img_perfil_arr) && value.loadGenerator.user.img_perfil_arr != null){
            value.img_shipper = value.loadGenerator.user.img_perfil_arr[0]['imagen-60'];
          }
        }
        value.status_btn = '';
        var bgColorBtn = '', colorBtn = '';
        switch(value.status_loads){
          case 'NOT_ASSIGNED':
            bgColorBtn = 'bg-color-7';
            colorBtn = 'color-armadillo';
            break;
          case 'ACEPTADA':
            bgColorBtn = 'bg-color-10';
            colorBtn = 'color-white';
            break;
          case 'EN_TRANSITO':
            bgColorBtn = 'bg-color-5';
            colorBtn = 'color-black';
            break;
          case 'ENTREGADA':
            bgColorBtn = 'bg-color-9';
            colorBtn = 'color-black';
            break;
          case 'CANCELADA':
            bgColorBtn = 'bg-color-4';
            colorBtn = 'color-black';
            break;
          case 'PAGADA':
            bgColorBtn = 'bg-color-8';
            colorBtn = 'color-white';
            break;
          case 'HACIA_ORIGEN':
          case 'EN_ORIGEN':
          case 'CARGANDO':
          case 'CARGADO':
          case 'EN_DESTINO':
          case 'DESCARGANDO':
          case 'DESCARGADO':
            bgColorBtn = 'bg-color-5';
            colorBtn = 'color-black';
            break;
          default:
            bgColorBtn = 'bg-color-7';
            colorBtn = 'color-armadillo';
            break;
        }
        value.status_btn = $sce.trustAsHtml(
          '<button class="btn btn-class2 btn-status-load '+bgColorBtn+' '+colorBtn+'">'+
          $filter('translate')('loads:table:status:' +value.status_loads.toLowerCase()+ ':text')+
          '</button>'
        );
        value.pickup_date_formatted = moment(value.pickup_date, "YYYY-MM-DD HH:mm:ss").format("MMM DD YYYY");
        value.delivery_date_formatted = moment(value.delivery_date, "YYYY-MM-DD HH:mm:ss").format("MMM DD YYYY");
        value.price_to_show = "$"+value.price;
        if(value.weight != null && value.weight != ''){
          if(value.weight.indexOf("lb") !== -1){
            value.weight = value.weight.replace("lb", "kg");
          }
        }
        if(value.posteverywhere == "1" && value.price == 0){
          value.price_to_show = $filter('translate')('loads:table:price:call:text');
        }
        if(value.load_date){
          var load_date_aux = moment.tz(value.load_date, "UTC");
          value.load_date = load_date_aux.clone().tz("America/Mexico_City").format('YYYY-MM-DD HH:mm:ss');
        }
        value.actions = '<i ng-click="loads.showDetailsUnique('+value.load_id+')" class="fa fa-angle-down show-load-details-btn"></i>';
      });

    });

    vm.changePage = function(page){
      vm.loadsOptions.page = page;
      flux.dispatch('fetchLoads', vm.loadsOptions);
    };

    /* Function executed at strart, Get load filters from url params and get loads list  */
    vm.initialize = function() {
      var search_type = '';
      vm.profile = Auth.getUserProfile();
      vm.profileText = Auth.getUserProfile()+'s';
      vm.doCustomSearch = false;
      vm.countLoads = 0;
      vm.v2 = false;

      switch(vm.profile){
        case 'GENERADOR_CARGA':
          search_type = 'my_loads';
          vm.profileText = 'shippers';
          break;
        case 'CARRIER':
        case 'DRIVER':
        case 'OWNER':
          if($stateParams.from || $stateParams.to || $stateParams.pickup || $stateParams.delivery || $stateParams.price_min || $stateParams.price_max || $stateParams.length || $stateParams.size || $stateParams.weight || $stateParams.load_type || $stateParams.shipper || $stateParams.review || $stateParams.deadhead || $stateParams.load_id){
            vm.doCustomSearch = true;
            search_type = 'my_search';
            vm.paramsCustomSearch = {};
            vm.paramsCustomSearch.token = Auth.getUserToken();
            vm.paramsCustomSearch.page = 1;
            if($stateParams.from){
              vm.paramsCustomSearch.from = $stateParams.from;
            }
            if($stateParams.to){
              vm.paramsCustomSearch.to = $stateParams.to;
            }
            if($stateParams.pickup){
              vm.paramsCustomSearch.pickup = moment($stateParams.pickup).format('YYYY-MM-DD');
            }
            if($stateParams.delivery){
              vm.paramsCustomSearch.delivery = moment($stateParams.delivery).format('YYYY-MM-DD');
            }
            if($stateParams.price_min){
              vm.paramsCustomSearch.price_min = $stateParams.price_min;
            }
            if($stateParams.price_max){
              vm.paramsCustomSearch.price_max = $stateParams.price_max;
            }
            if($stateParams.length){
              vm.paramsCustomSearch.length = $stateParams.length;
            }
            if($stateParams.size){
              vm.paramsCustomSearch.size = $stateParams.size;
            }
            if($stateParams.weight){
              vm.paramsCustomSearch.weight = $stateParams.weight;
            }
            if($stateParams.load_type){
              vm.paramsCustomSearch.load_type = $stateParams.load_type;
            }
            if($stateParams.load_id){
              vm.paramsCustomSearch.load_id = $stateParams.load_id;
            }
            if($stateParams.shipper){
              vm.paramsCustomSearch.company = $stateParams.shipper;
            }
            if($stateParams.review){
              vm.paramsCustomSearch.review = $stateParams.review;
            }
            if($stateParams.deadhead){
              vm.paramsCustomSearch.deadhead = $stateParams.deadhead;
            }
          }else{
            if(vm.profile == 'CARRIER' || vm.profile ==  'OWNER'){
              search_type = 'all';
            }

            if(vm.profile == 'DRIVER'){
              search_type = 'current';
            }
          }
          break;
      }

      vm.loadsOptions = {
        'search_type': (search_type != '') ? search_type : 'my_loads',
        'token': Auth.getUserToken(),
        'page': 1,
        'id_load': null
      };
      vm.loadsList = [];
      vm.loadingLoadData = true;
      vm.initializedList = false;

      vm.loadTab();
      vm.getUserFields();
    };
    vm.getUserFields = function(){
      Auth.getInfoUser().then(function (resp){
        vm.dataUser    = resp.data.userData;
        sessionStorage.setItem('_us',JSON.stringify(resp.data.Info_perfil.dataUser));
        vm.getDocuments();
      });
    }
    vm.redirectProfile = function (){
      $location.path('profile');
    }
    /* Load table first time or reload it  */
    vm.loadTab = function() {
      if (vm.initializedList) {
        vm.reloadList();
      } else {
        vm.initializeList();
      }
    };
    vm.getDocuments = function (){
      let profile = (Auth.getUserProfile() == 'OWNER') ? 'carriers': vm.profileText.toLowerCase();
      Auth.getUserDocumentation(profile,vm.dataUser.id).then(function (resp){
        if (resp.status == 200){
          vm.documentations = [];
          vm.resources = resp.data.results;
          if (vm.resources.length > 0){
            angular.forEach(vm.resources, function (value){
              if (value.document != null && value.document.files.length > 0){
                vm.documentations.push(value.document);
              }
            });
          }
        }
      });
    }

    /* Change tab filter  */
    vm.changeCategory = function(cat) {
      vm.loadingLoadData = true;
      vm.loadsOptions.search_type = cat;
      $rootScope.search_type = cat;
      vm.loadsOptions.page = 1;
      vm.loadTab();
    };

    /* Get loads list and set datatable  */
    vm.initializeList = function() {
      vm.datatableOptions = DTOptionsBuilder.newOptions().withOption('ajax', function(data, callback, settings){
        vm.countLoads = 0;
        if(vm.loadsOptions.search_type == 'my_search' && vm.doCustomSearch){
          vm.paramsCustomSearch.page = DatatableTool.getPage(data);
          Loads.searchLoads(vm.paramsCustomSearch).then(function(response){
            var records = DatatableTool.getRecords(response);
            if (!angular.isUndefined(records.recordsTotal)) {
              vm.countLoads = records.recordsTotal;
            }
            if (!angular.isUndefined(records.data)) {
              _.forEach(records.data, function(value, key) {
                if(vm.profile == 'CARRIER' || vm.profile == 'DRIVER' || vm.profile == 'OWNER'){
                  value.full_name_shipper = value.info_load_generator.company_name;
                  value.img_shipper = false;
                  if(angular.isDefined(value.info_load_generator.user.img_perfil_imagenes) && value.info_load_generator.user.img_perfil_imagenes != null){
                    value.img_shipper = value.info_load_generator.user.img_perfil_imagenes[0]['imagen-60'];
                  }
                }
                value.status_btn = '';
                var bgColorBtn = '', colorBtn = '';
                switch(value.status_loads){
                  case 'NOT_ASSIGNED':
                    bgColorBtn = 'bg-color-7';
                    colorBtn = 'color-armadillo';
                    break;
                  case 'ACEPTADA':
                    bgColorBtn = 'bg-color-10';
                    colorBtn = 'color-white';
                    break;
                  case 'EN_TRANSITO':
                    bgColorBtn = 'bg-color-5';
                    colorBtn = 'color-black';
                    break;
                  case 'ENTREGADA':
                    bgColorBtn = 'bg-color-9';
                    colorBtn = 'color-black';
                    break;
                  case 'CANCELADA':
                    bgColorBtn = 'bg-color-4';
                    colorBtn = 'color-black';
                    break;
                  case 'PAGADA':
                    bgColorBtn = 'bg-color-8';
                    colorBtn = 'color-white';
                    break;
                  case 'POD':
                    bgColorBtn = 'bg-color-8';
                    colorBtn = 'color-black';
                    break;
                  case 'HACIA_ORIGEN':
                  case 'EN_ORIGEN':
                  case 'CARGANDO':
                  case 'CARGADO':
                  case 'EN_DESTINO':
                  case 'DESCARGANDO':
                  case 'DESCARGADO':
                    bgColorBtn = 'bg-color-5';
                    colorBtn = 'color-black';
                    break;
                  default:
                    bgColorBtn = 'bg-color-7';
                    colorBtn = 'color-armadillo';
                    break;
                }
                value.status_btn = $sce.trustAsHtml(
                  '<button class="btn btn-class2 btn-status-load ' +bgColorBtn+' '+colorBtn+'">'
                  +$filter('translate')('loads:table:status:' +value.status_loads.toLowerCase()+ ':text')
                  +'</button>'
                );
                value.pickup_date_formatted = moment(value.pickup_date, "YYYY-MM-DD HH:mm:ss").format("MMM DD YYYY");
                value.delivery_date_formatted = moment(value.delivery_date, "YYYY-MM-DD HH:mm:ss").format("MMM DD YYYY");
                value.price_to_show = "$"+value.price;
                if(value.weight != null && value.weight != ''){
                  if(value.weight.indexOf("lb") !== -1){
                    value.weight = value.weight.replace("lb", "kg");
                  }
                }
                if(value.posteverywhere == "1" && value.price == 0){
                  value.price_to_show = $filter('translate')('loads:table:price:call:text');
                }
                if(value.load_date){
                  var load_date_aux = moment.tz(value.load_date, "UTC");
                  value.load_date = load_date_aux.clone().tz("America/Mexico_City").format('YYYY-MM-DD HH:mm:ss');
                }

                value.actions = '<i ng-click="loads.showDetailsUnique('+value.load_id+')" class="fa fa-angle-down show-load-details-btn"></i>';
              });
            }
            vm.loadsList = records.data;
            records.data = [{img_shipper: false, full_name_shipper: '', status_btn: '', from: '', to: '', pickup_date_formatted: '', delivery_date_formatted: '', distance: '', length_loads: '', weight: '', dimension: '', price_to_show: '', load_date: '', actions: ''}];
            callback(records);
          })
            .catch(function (error) {
              vm.loadsList = [];
              callback(DatatableTool.getRecords(null));
            });

        }else{
          if(vm.loadsOptions.search_type == 'my_search'){
            if(vm.profile == 'CARRIER' || vm.profile == 'OWNER'){
              vm.loadsOptions.search_type = 'all';
            }
            if(vm.profile == 'DRIVER'){
              vm.loadsOptions.search_type = 'current';
            }
          }
          vm.loadsOptions.page = DatatableTool.getPage(data);

          Loads.getByUserRol(vm.loadsOptions).then(function(response){
            var records = DatatableTool.getRecords(response);
            flux.dispatch('fetchLoads', vm.loadsOptions);
            vm.defaultDataLoads(records,callback);

          }).catch(function (error) {
            console.error(error);
            vm.loadsList = [];
            callback(DatatableTool.getRecords(null));
          });

        }
      }).withDataProp('data').withOption('processing', true).withOption('serverSide', true).withOption('searching', false)
        .withOption('info', false)
        .withOption('lengthChange', false)
        .withOption('pageLength', 4)
        .withOption('responsive', true)
        .withLanguage(DatatableTool.getDefaultLanguageSettings())
        .withPaginationType('numbers');

      switch(vm.profile){
        case 'GENERADOR_CARGA':
          //alert($translate.instant('loads:table:column:status'));
          vm.dtColumns = [
            DTColumnBuilder.newColumn('status_btn'),
            DTColumnBuilder.newColumn('from'),
            DTColumnBuilder.newColumn('to'),
            DTColumnBuilder.newColumn('pickup_date_formatted'),
            DTColumnBuilder.newColumn('delivery_date_formatted'),
            DTColumnBuilder.newColumn('distance'),
            DTColumnBuilder.newColumn('length_loads'),
            DTColumnBuilder.newColumn('weight'),
            DTColumnBuilder.newColumn('dimension'),
            DTColumnBuilder.newColumn('price_to_show'),
            DTColumnBuilder.newColumn('load_date'),
            DTColumnBuilder.newColumn('actions')
          ];
          break;
        case 'CARRIER':
        case 'DRIVER':
        case 'OWNER':
          vm.dtColumns = [
            DTColumnBuilder.newColumn('img_shipper'),
            DTColumnBuilder.newColumn('full_name_shipper'),
            DTColumnBuilder.newColumn('from'),
            DTColumnBuilder.newColumn('to'),
            DTColumnBuilder.newColumn('pickup_date_formatted'),
            DTColumnBuilder.newColumn('delivery_date_formatted'),
            DTColumnBuilder.newColumn('length_loads'),
            DTColumnBuilder.newColumn('weight'),
            DTColumnBuilder.newColumn('dimension'),
            DTColumnBuilder.newColumn('price_to_show'),
            DTColumnBuilder.newColumn('load_date'),
            DTColumnBuilder.newColumn('status_btn'),
            DTColumnBuilder.newColumn('actions')
          ];
          break;
      }

      vm.loadingLoadData = false;
      vm.initializedList = true;
    };
    vm.defaultDataLoads = function (records,callback){
      if (!angular.isUndefined(records.recordsTotal)) {
        vm.countLoads = records.recordsTotal;
      }
      if (!angular.isUndefined(records.data)) {
        _.forEach(records.data, function(value, key) {
          if(vm.profile == 'CARRIER' || vm.profile == 'DRIVER' || vm.profile == 'OWNER'){
            value.full_name_shipper = value.loadGenerator.company_name;
            value.img_shipper = false;
            if(angular.isDefined(value.loadGenerator.user.img_perfil_arr) && value.loadGenerator.user.img_perfil_arr != null){
              value.img_shipper = value.loadGenerator.user.img_perfil_arr[0]['imagen-60'];
            }
          }
          value.status_btn = '';
          var bgColorBtn = '', colorBtn = '';
          switch(value.status_loads){
            case 'NOT_ASSIGNED':
              bgColorBtn = 'bg-color-7';
              colorBtn = 'color-armadillo';
              break;
            case 'ACEPTADA':
              bgColorBtn = 'bg-color-10';
              colorBtn = 'color-white';
              break;
            case 'EN_TRANSITO':
              bgColorBtn = 'bg-color-5';
              colorBtn = 'color-black';
              break;
            case 'ENTREGADA':
              bgColorBtn = 'bg-color-9';
              colorBtn = 'color-black';
              break;
            case 'CANCELADA':
              bgColorBtn = 'bg-color-4';
              colorBtn = 'color-black';
              break;
            case 'PAGADA':
              bgColorBtn = 'bg-color-8';
              colorBtn = 'color-white';
              break;
            case 'HACIA_ORIGEN':
            case 'EN_ORIGEN':
            case 'CARGANDO':
            case 'CARGADO':
            case 'EN_DESTINO':
            case 'DESCARGANDO':
            case 'DESCARGADO':
              bgColorBtn = 'bg-color-5';
              colorBtn = 'color-black';
              break;
            default:
              bgColorBtn = 'bg-color-7';
              colorBtn = 'color-armadillo';
              break;
          }
          value.status_btn = $sce.trustAsHtml(
            '<button class="btn btn-class2 btn-status-load '+bgColorBtn+' '+colorBtn+'">'+
            $filter('translate')('loads:table:status:' +value.status_loads.toLowerCase()+ ':text')+
            '</button>'
          );
          value.pickup_date_formatted = moment(value.pickup_date, "YYYY-MM-DD HH:mm:ss").format("MMM DD YYYY");
          value.delivery_date_formatted = moment(value.delivery_date, "YYYY-MM-DD HH:mm:ss").format("MMM DD YYYY");
          value.price_to_show = "$"+value.price;
          if(value.weight != null && value.weight != ''){
            if(value.weight.indexOf("lb") !== -1){
              value.weight = value.weight.replace("lb", "kg");
            }
          }
          if(value.posteverywhere == "1" && value.price == 0){
            value.price_to_show = $filter('translate')('loads:table:price:call:text');
          }
          if(value.load_date){
            var load_date_aux = moment.tz(value.load_date, "UTC");
            value.load_date = load_date_aux.clone().tz("America/Mexico_City").format('YYYY-MM-DD HH:mm:ss');
          }
          value.actions = '<i ng-click="loads.showDetailsUnique('+value.load_id+')" class="fa fa-angle-down show-load-details-btn"></i>';
        });
      }
      vm.loadsList = records.data;
      records.data = [{img_shipper: false, full_name_shipper: '', status_btn: '', from: '', to: '', pickup_date_formatted: '', delivery_date_formatted: '', distance: '', length_loads: '', weight: '', dimension: '', price_to_show: '', load_date: '', actions: ''}];
      callback(records);
    }
    /* Reload data table  */
    vm.reloadList = function() {
      // Reload datatables
      DatatableTool.reload();
    };

    vm.detachCurrentLoadId = function(){
      vm.currentLoadId = null;
    };
    vm.showDetailsUnique = function(load_id) {
      vm.currentLoadId = load_id;
      for(var i in vm.loads.results){
        if(vm.loads.results[i].load_id == load_id && vm.dataUser.user_status != 0){
          vm.loads.results[i].expanded = !vm.loads.results[i].expanded;
        }else{
          vm.loads.results[i].expanded = false;
        }
      }

    };

    vm.initialize();
  }
})();

(function() {
  'use strict';

  /* Load creation controller
   * Set form data
   * Get load attributes
   * Validate and send form data to API
   */
  angular.module('loadsAppWeb').controller('LoadsAddController', LoadsAddController);
  /** @ngInject */
  function LoadsAddController(
    $state,
    toastr,
    $filter,
    Config,
    Loads,
    Auth,
    DatatableTool,
    $q,
    $uibModal,
    sweetAlert,
    swangular,
    $scope
  ) {

	  var vm = this;
    vm.reviewPriceWs = true;
    /* Function which validates pickup date against delivery date and this doesn't allow pickup date being greater than delivery date */
    vm.allowDeliveryDate = function() {
      if(vm.dataNewLoad.pickup_date != null && vm.dataNewLoad.pickup_date != ""){
        vm.dateDeliveryDisabled = false;

        if(vm.dataNewLoad.delivery_date < vm.dataNewLoad.pickup_date){
          vm.dataNewLoad.delivery_date = vm.dataNewLoad.pickup_date;
        }
      }else{
        vm.dateDeliveryDisabled = true;
        vm.dataNewLoad.delivery_date = null;
      }
    };
    vm.checkOriginZip = function() {
      if(vm.dataSelectPickupAddress.address_components.length > 0){
        var items = []; var items_name = [];
        angular.forEach(vm.dataSelectPickupAddress.address_components, function (value){
          items_name.push(value.long_name);
          items.push(value.types[0]);
        });
        $scope.setApiGooglePickup();
        if (items.indexOf('postal_code') == -1 && items_name.length < 6){
          return toastr.warning($filter('translate')('loads:add:form:fields:validate:address:zip'));
        }
        if (items_name.length == 6 && vm.dataNewLoad.zip_code_pickup != items_name[5]){
          return toastr.warning($filter('translate')('loads:add:form:fields:match:address:zip'));
        }
      }
    };
    $scope.setApiGooglePickup = function(){
        vm.dataNewLoad.city_pickup              = vm.dataSelectPickupCity;
        vm.dataNewLoad.pickup_address           = vm.dataSelectPickupAddress.formatted_address;
        vm.dataNewLoad.lat_pickup_address       = vm.dataSelectPickupAddress.geometry.location.lat();
        vm.dataNewLoad.long_pickup_address      = vm.dataSelectPickupAddress.geometry.location.lng();
        console.log(vm.dataNewLoad.city_pickup);
    };
    $scope.setApiGoogleDelivery = function(){
      vm.dataNewLoad.city_delivery              = vm.dataSelectDeliveryCity;
      vm.dataNewLoad.delivery_address           = vm.dataSelectDeliveryAddress.formatted_address;
      vm.dataNewLoad.lat_delivery_address       = vm.dataSelectDeliveryAddress.geometry.location.lat();
      vm.dataNewLoad.long_delivery_address      = vm.dataSelectDeliveryAddress.geometry.location.lng();
      console.log(vm.dataNewLoad.city_delivery);
    };
    vm.checkDestinationZip = function() {
      if(vm.dataSelectDeliveryAddress.address_components.length > 0){
        var items = []; var items_name = [];
        angular.forEach(vm.dataSelectDeliveryAddress.address_components, function (value){
          items_name.push(value.long_name);
          items.push(value.types[0]);
        });
        $scope.setApiGoogleDelivery();
        if (items.indexOf('postal_code') == -1 && items_name.length < 6){
          return toastr.warning($filter('translate')('loads:add:form:fields:validate:address:zip'));
        }

        if (items_name.length == 6 && vm.dataNewLoad.zip_code_delivery != items_name[5]){
          return toastr.warning($filter('translate')('loads:add:form:fields:match:address:zip'));
        }
      }
    };
	  $scope.initialize = function() {
      $scope.dataLoads = {};

	    vm.submitReturnList = false;
      vm.priceSuggested = 0;
      vm.dataSelectPickupCity = null;
      vm.dataSelectDeliveryCity = null;
      vm.dataSelectPickupAddress = null;
      vm.dataSelectDeliveryAddress = null;
      vm.dateDeliveryDisabled = true;
      vm.datePickerMinDate = moment();
      vm.optsDatePicker = {
          singleDatePicker: true,
          showDropdowns: true,
          locale: {
              format: "YYYY-MM-DD",
              applyClass: 'btn-green',
              applyLabel: $filter('translate')('daterangepicker:btn:success:text'),
              fromLabel: $filter('translate')('daterangepicker:label:from'),
              toLabel: $filter('translate')('daterangepicker:label:to'),
              cancelLabel: $filter('translate')('daterangepicker:btn:cancel:text'),
              customRangeLabel: $filter('translate')('daterangepicker:title:text'),
              firstDay: 1
          }
        };


      vm.dataNewLoad = {};
      vm.dataNewLoad.token = Auth.getUserToken();
      vm.dataNewLoad.city_pickup = null;
      vm.dataNewLoad.pickup_date = null;
      vm.pickup_start_time_hour = '00';
      vm.pickup_start_time_minutes = '00';
      vm.dataNewLoad.timer_star_pickup = null;
      vm.pickup_finish_time_hour = '00';
      vm.pickup_finish_time_minutes = '00';
      vm.dataNewLoad.timer_finish_pickup = null;
      vm.dataNewLoad.pickup_address = null;
      vm.dataNewLoad.detail_address_pickup = null;
      vm.dataNewLoad.lat_pickup_address = null;
      vm.dataNewLoad.long_pickup_address = null;
      vm.dataNewLoad.country_pickup = null;
      vm.dataNewLoad.state_pickup = null;
      vm.dataNewLoad.zip_code_pickup = null,
      vm.dataNewLoad.city_delivery = null;
      vm.dataNewLoad.delivery_date = null;
      vm.delivery_start_time_hour = '00';
      vm.delivery_start_time_minutes = '00';
      vm.dataNewLoad.timer_start_delivery = null;
      vm.delivery_finish_time_hour = '00';
      vm.delivery_finish_time_minutes = '00';
      vm.dataNewLoad.timer_finish_delivery = null;
      vm.dataNewLoad.delivery_address = null;
      vm.dataNewLoad.detail_address_delivery = null;
      vm.dataNewLoad.lat_delivery_address = null;
      vm.dataNewLoad.long_delivery_address = null;
      vm.dataNewLoad.country_delivery = null;
      vm.dataNewLoad.state_delivery = null;
      vm.dataNewLoad.zip_code_delivery = null;
      vm.dataNewLoad.weight = null;
      vm.dataNewLoad.load_type = [];
      vm.load_type_combo_box = null;
      vm.dataNewLoad.noot_load = null;
      vm.dataNewLoad.length_loads = null;
      vm.dataNewLoad.dimension = null;
      vm.dataNewLoad.price = null;
      vm.dataNewLoad.frecuency_active = 0;
      vm.dataNewLoad.skills_required_carrier = [];
      vm.dataNewLoad.truck_type_id = null;
      vm.dataNewLoad.consignee = null;
      vm.dataNewLoad.receiver = null;
      //vm.dataNewLoad.load_type_license_id = null;
      vm.dataNewLoad.commodity_id = null;
      vm.dataNewLoad.allow_multiple_stops = 0;
      vm.dataNewLoad.trailer_type = null;

      vm.savingNewLoad = false;
      vm.loadTypeFieldRequired = false;
      vm.carrierSkillsRequired = false;
      vm.truckTypeRequired = null;
      vm.lenghtType = 'NA';
      vm.truckTypeConf = 'NA';
      vm.TruckTypesRemolque = [];
      vm.loadLicenseTypeTitle = '';
      vm.loadLicenseTypeInfo = '';
      vm.commodityExcludedInfo = '';

      vm.indiceParadasMultiples = 0;
      vm.camposParadasMultiples = [];

      vm.optionsGoogleInputCity = {
        types: ['(cities)']
      }

      vm.hour_select = ['00','01','02','03','04','05','06','07','08','09','10','11','12','13','14','15','16','17','18','19','20','21','22','23'];
      vm.minutes_select = ['00','01','02','03','04','05','06','07','08','09','10','11','12','13','14','15','16','17','18','19','20','21','22','23','24','25','26','27','28','29','30','31','32','33','34','35','36','37','38','39','40','41','42','43','44','45','46','47','48','49','50','51','52','53','54','55','56','57','58','59'];

      vm.getItemsSizeLengthLoads();

    };
    /* Set load skills list as local var */
    vm.setLoadsSkillsRequiredList = function() {
      vm.skillsRequiredCarrier = [];
      if(vm.itemsSizeLenLoads.LoadsSkillsRequired_list.length){
        for(var i in vm.itemsSizeLenLoads.LoadsSkillsRequired_list){
          vm.skillsRequiredCarrier.push({id: vm.itemsSizeLenLoads.LoadsSkillsRequired_list[i].id, name: vm.itemsSizeLenLoads.LoadsSkillsRequired_list[i].skills_required_name, checked: false});
        }
      }
    };
    /* Get load attributes */
    vm.getItemsSizeLengthLoads = function() {
      vm.itemsSizeLenLoads = {};
      Loads.getItemsSizeLengthLoads().then(function(response){
        if(response){
          vm.itemsSizeLenLoads = response;
          if(angular.isDefined(vm.itemsSizeLenLoads.LoadsSkillsRequired_list)){
            vm.setLoadsSkillsRequiredList();
          }
          if(angular.isDefined(vm.itemsSizeLenLoads.LoadsType_list)){
            vm.setLoadsTypeList();
          }
          if(angular.isDefined(vm.itemsSizeLenLoads.Trucktypes_list)){
            vm.cmbTruckTypes();
          }
          if(angular.isDefined(vm.itemsSizeLenLoads.LoadsLength_list)){
            vm.cmbLoadsLength();
          }
          if (angular.isDefined(vm.itemsSizeLenLoads.ContainerType)){
            vm.cmbContainerType();
          }
          if (angular.isDefined(vm.itemsSizeLenLoads.ProfitCenter)){
            vm.cmbProfitCenter();
          }
          if (angular.isDefined(vm.itemsSizeLenLoads.WeightUnit)){
            vm.cmbWeightUnit();
          }
          if (angular.isDefined(vm.itemsSizeLenLoads.DistanceUnit)){
            vm.cmbDistanceUnit();
          }
          if (angular.isDefined(vm.itemsSizeLenLoads.Addresses)){
            vm.cmbAddresses();
          }
          if (angular.isDefined(vm.itemsSizeLenLoads.Countries)){
            vm.getCountries();
          }
        }
      });
    };
    vm.setLoadsTypeList = function() {
      vm.loadTypeList = [];
      if(vm.itemsSizeLenLoads.LoadsType_list.length){
        for(var i in vm.itemsSizeLenLoads.LoadsType_list){
          vm.loadTypeList.push({
            id: vm.itemsSizeLenLoads.LoadsType_list[i].id,
            name: vm.itemsSizeLenLoads.LoadsType_list[i].skill_name,
            checked: false
          });
        }
      }
    };
    vm.cmbProfitCenter = function (){
      vm.cmbProfitCenters = [];
      if (vm.itemsSizeLenLoads.ProfitCenter.length > 0){
        angular.forEach(vm.itemsSizeLenLoads.ProfitCenter,function (value){
          vm.cmbProfitCenters.push({
            value   : value.value,
            text    : value.text,
            checked : false
          });
        });
      }
    }
    vm.cmbAddresses = function (){
      vm.cmbAddresses = [];
      if (vm.itemsSizeLenLoads.Addresses.length > 0){
        angular.forEach(vm.itemsSizeLenLoads.Addresses,function (value){
          vm.cmbAddresses.push({
            id      : value.id,
            text    : value.line_1,
            checked : false
          });
        });
      }
    }
    vm.getCountries = function (){
      vm.cmbCountries = [];
      if (vm.itemsSizeLenLoads.Countries.length > 0){
        angular.forEach(vm.itemsSizeLenLoads.Countries,function (value){
          vm.cmbCountries.push({
            id        : value.code,
            name      : value.name,
            zip_regex : value.postal_code_regex
          });
        });
        vm.dataNewLoad.countries_delivery =  vm.dataNewLoad.country = "MX"
        vm.setCountriesPickup();
        vm.setCountriesDelivery();
      }
    }
    vm.setCountriesPickup = function (){
      vm.country      = {};
      angular.forEach(vm.cmbCountries,function (value){
          if (value.id == vm.dataNewLoad.country){
            vm.country = value;
          }
      });
      vm.zip_regex_pickup = vm.country.zip_regex;
    }
    vm.setCountriesDelivery = function (){
      vm.countryDelivery      = {};
      angular.forEach(vm.cmbCountries,function (value){
        if (value.id == vm.dataNewLoad.countries_delivery){
          vm.countryDelivery = value;
        }
      });
      vm.zip_regex_delivery = vm.countryDelivery.zip_regex;
    }
    vm.getZipCodePickup = function () {
      if (angular.isUndefined(vm.dataNewLoad.zip_code_pickup) || vm.dataNewLoad.zip_code_pickup == null) {
        vm.dataSelectPickupCity = vm.dataSelectPickupState  = "";
        return toastr.warning($filter('translate')('loads:add:form:fields:validate:zip_code_pickup'));
      }
      Loads.getZipCodeByCountry(vm.dataNewLoad.zip_code_pickup,vm.dataNewLoad.country).then(function (resp){
        if (resp.data.results.length > 0){
          vm.dataSelectPickupCity     = resp.data.results[0].state;
          vm.dataSelectPickupState    = resp.data.results[0].city;
          return;
        }
        return toastr.warning($filter('translate')('loads:add:form:fields:validate:results:zip'));
      });

    }
    vm.getZipCodeDelivery = function (){
      if (angular.isUndefined(vm.dataNewLoad.zip_code_delivery) || vm.dataNewLoad.zip_code_delivery == null) {
        vm.dataSelectDeliveryCity = vm.dataSelectDeliveryState  = "";
        return toastr.warning($filter('translate')('loads:add:form:fields:validate:zip_code_delivery'));
      }
      Loads.getZipCodeByCountry(vm.dataNewLoad.zip_code_delivery,vm.dataNewLoad.countries_delivery).then(function (resp){
        if (resp.data.results.length > 0){
          vm.dataSelectDeliveryCity     = resp.data.results[0].state;
          vm.dataSelectDeliveryState     = resp.data.results[0].city;
          return;
        }
        return toastr.warning($filter('translate')('loads:add:form:fields:validate:zip_code_delivery'));
      });
    }
    vm.cmbContainerType = function (){
      vm.cmbContainerTypes = [];
      if (vm.itemsSizeLenLoads.ContainerType.length > 0){
        angular.forEach(vm.itemsSizeLenLoads.ContainerType,function (value){
          vm.cmbContainerTypes.push({
            value   : value.value,
            text    : value.text,
            checked : false
          });
        });
      }
    }
    vm.cmbLoadsLength = function (){
      vm.cmbLoadsLengths = [];
      if (vm.itemsSizeLenLoads.LoadsLength_list.length > 0){
        angular.forEach(vm.itemsSizeLenLoads.LoadsLength_list,function (value){
          if (value.id != 8 && value.id != 9 && value.id != 10){
            vm.cmbLoadsLengths.push({
              id      : value.id,
              name    : value.name,
              checked : false
            });
          }
        });
      }

    }
    vm.cmbTruckTypes = function (item){
      vm.simpleTruckTypes = [];
      if (vm.itemsSizeLenLoads.Trucktypes_list.length > 0){
        angular.forEach(vm.itemsSizeLenLoads.Trucktypes_list, function (value){
          if (value.type_config == item){
            vm.simpleTruckTypes.push({
              id      : value.id,
              name    : value.truck_type_name,
              checked : false
            });
          }
          if(value.required_length == 'Y'){
            vm.TruckTypesRemolque.push(parseInt(value.id));
          }
        });
      }
    }
    vm.cmbWeightUnit = function (){
      vm.cmbWeightUnits = [];
      if (vm.itemsSizeLenLoads.WeightUnit.length > 0){
        angular.forEach(vm.itemsSizeLenLoads.WeightUnit, function (value){
          vm.cmbWeightUnits.push({
            value   : value.value,
            text    : value.text,
          });
          vm.dataNewLoad.weight_unit = 'kg';
        });
      }
    }
    vm.cmbDistanceUnit = function (){
      vm.cmbDistanceUnits = [];
      if (vm.itemsSizeLenLoads.DistanceUnit.length > 0){
        angular.forEach(vm.itemsSizeLenLoads.DistanceUnit, function (value){
          vm.cmbDistanceUnits.push({
            value   : value.value,
            text    : value.text,
          });
        });
        vm.dataNewLoad.distance_unit = 'm';
      }
    }
    vm.setterInformation = function (){
      if (vm.itemsSizeLenLoads.Addresses.length > 0){
        angular.forEach(vm.itemsSizeLenLoads.Addresses,function (value){
          vm.setterPickup(value);
          vm.setterDelivery(value);
        });
      }
    }
    vm.setterDelivery = function (value){
      if (value.id == vm.dataNewLoad.delivery_address_id){
        vm.dataSelectDeliveryCity                 = value.line_1;
        vm.dataSelectDeliveryAddress              = value.line_1;

        vm.dataNewLoad.city_delivery              = value.city;
        vm.dataNewLoad.country_delivery           = value.country;
        vm.dataNewLoad.delivery_address           = value.line_1;
        vm.dataNewLoad.lat_delivery_address       = value.latitude;
        vm.dataNewLoad.long_delivery_address      = value.longitude;

        vm.dataNewLoad.detail_address_delivery    = value.description;
        vm.dataNewLoad.zip_code_delivery          = value.zip_code;
        vm.getZipCodeDelivery();
      }
    }
    vm.setterPickup = function (value){
      if (value.id == vm.dataNewLoad.pickup_address_id){
        vm.dataSelectPickupCity                 = value.line_1;
        vm.dataSelectPickupAddress              = value.line_1;

        vm.dataNewLoad.city_pickup              = value.city;
        vm.dataNewLoad.country_pickup           = value.country;
        vm.dataNewLoad.pickup_address           = value.line_1;
        vm.dataNewLoad.lat_pickup_address       = value.latitude;
        vm.dataNewLoad.long_pickup_address      = value.longitude;

        vm.dataNewLoad.detail_address_pickup    = value.description;
        vm.dataNewLoad.zip_code_pickup          = value.zip_code;
        vm.getZipCodePickup();
      }
    }
    vm.cleanLoadLengthValue = function() {
      if(vm.dataNewLoad.length_loads !== undefined && vm.dataNewLoad.length_loads !== null){
        var textToConvert = vm.dataNewLoad.length_loads.toString();
        textToConvert = textToConvert.replace(/[a-zA-Z\s\W]/gm, "");
        vm.dataNewLoad.length_loads = parseInt(textToConvert);
      }else{
        vm.dataNewLoad.length_loads = 0;
      }
    };
    vm.cleanLoadWeightValue = function() {
      if(vm.dataNewLoad.weight !== undefined && vm.dataNewLoad.weight !== null){
        var textToConvert = vm.dataNewLoad.weight.toString();
        textToConvert = textToConvert.replace(/[a-zA-Z\s\W]/gm, "");
        vm.dataNewLoad.weight = parseInt(textToConvert);
      }else{
        vm.dataNewLoad.weight = 0;
      }
    };
    vm.cleanLoadHeightValue = function() {
      if(vm.dataNewLoad.height !== undefined && vm.dataNewLoad.height !== null){
        var textToConvert = vm.dataNewLoad.height.toString();
        textToConvert = textToConvert.replace(/[a-zA-Z\s\W]/gm, "");
        vm.dataNewLoad.height = parseInt(textToConvert);
      }else{
        vm.dataNewLoad.height = 0;
      }
    };
    vm.cleanLoadWidthValue = function() {
      if(vm.dataNewLoad.width !== undefined && vm.dataNewLoad.width !== null){
        var textToConvert = vm.dataNewLoad.width.toString();
        textToConvert = textToConvert.replace(/[a-zA-Z\s\W]/gm, "");
        vm.dataNewLoad.width = parseInt(textToConvert);
      }else{
        vm.dataNewLoad.width = 0;
      }
    };
    vm.truckTypeChange = function() {
      if(vm.dataNewLoad.dimension == '1'){
        if(vm.TruckTypesRemolque.indexOf(parseInt(vm.truckTypeRequired)) !== -1){
          vm.lenghtType = null;
          vm.dataNewLoad.lenght = null;
        }else{
          vm.lenghtType = 'NA';
          vm.dataNewLoad.lenght = null;
        }
      }else if(vm.dataNewLoad.dimension == '2'){
        if(vm.TruckTypesRemolque.indexOf(parseInt(vm.truckTypeRequired)) !== -1){
          vm.lenghtType = 'F';
          vm.dataNewLoad.lenght = null;
        }else{
          vm.lenghtType = 'NA';
          vm.dataNewLoad.lenght = null;
        }
      }else{
        vm.lenghtType = 'NA';
        vm.truckTypeConf = 'NA';
        vm.truckTypeRequired = null;
        vm.dataNewLoad.lenght = null;
      }
    }
    vm.sizeConfigurationChange = function() {
      switch(vm.dataNewLoad.dimension){
        case "1":
          vm.lenghtType = 'NA';
          vm.truckTypeConf = 's';
          vm.truckTypeRequired = null;
          vm.dataNewLoad.lenght = null;
          break;
        case "2":
          vm.lenghtType = 'NA';
          vm.truckTypeConf = 'f';
          vm.truckTypeRequired = null;
          vm.dataNewLoad.lenght = null;
          break;
        default:
          vm.lenghtType = 'NA';
          vm.truckTypeConf = 'na';
          vm.truckTypeRequired = null;
          vm.dataNewLoad.lenght = null;
          break;
      }
      vm.cmbTruckTypes(vm.truckTypeConf);

    };

    /* Validate form and send data to API */
    vm.save = function(postLoadFormName) {
      vm.carrierSkillsRequired = false; vm.savingNewLoad = true;
      if (postLoadFormName.$invalid) {
          if(angular.isDefined(vm.skillsRequiredCarrier)){
            var carrierSkillsChecked = 0;
            vm.skillsRequiredCarrier.forEach(function(item) {
              if (item.checked) carrierSkillsChecked++;
            });

            if(carrierSkillsChecked <= 0){
              vm.carrierSkillsRequired = true;
            }
          }
          // If there was an error for required fields.
          if (postLoadFormName.$error.required) {
              toastr.error($filter('translate')('loads:add:form:required:fields:error'));
          } else {
              toastr.error($filter('translate')('loads:add:form:required:fields:invalid'));
          }
          vm.savingNewLoad = false;
          return;
      }

      if(parseInt(vm.pickup_start_time_hour) > parseInt(vm.pickup_finish_time_hour)){
        toastr.error($filter('translate')('loads:add:form:pickup_date_range:fields:error'));
        vm.savingNewLoad = false;
        return;
      }else{
        var aux_date_pickup = new Date(vm.dataNewLoad.pickup_date);

        vm.dataNewLoad.timer_star_pickup = '';
        vm.dataNewLoad.timer_finish_pickup = '';
        vm.dataNewLoad.timer_star_pickup += aux_date_pickup.getFullYear() + '-';
        if((aux_date_pickup.getMonth() + 1) > 9){
          vm.dataNewLoad.timer_star_pickup += (aux_date_pickup.getMonth() + 1) + '-';
        }else{
          vm.dataNewLoad.timer_star_pickup += '0' + (aux_date_pickup.getMonth() + 1) + '-';
        }

        if(aux_date_pickup.getDate() > 9){
          vm.dataNewLoad.timer_star_pickup += aux_date_pickup.getDate() + ' ';
        }else{
          vm.dataNewLoad.timer_star_pickup += '0' + aux_date_pickup.getDate() + ' ';
        }

        vm.dataNewLoad.timer_finish_pickup += vm.dataNewLoad.timer_star_pickup;

        vm.dataNewLoad.timer_star_pickup += vm.pickup_start_time_hour + ':';
        vm.dataNewLoad.timer_star_pickup += vm.pickup_start_time_minutes + ':';
        vm.dataNewLoad.timer_star_pickup += '00';

        vm.dataNewLoad.timer_finish_pickup += vm.pickup_finish_time_hour + ':';
        vm.dataNewLoad.timer_finish_pickup += vm.pickup_finish_time_minutes + ':';
        vm.dataNewLoad.timer_finish_pickup += '00';
      }

      if(parseInt(vm.delivery_start_time_hour) > parseInt(vm.delivery_finish_time_hour)){
        toastr.error($filter('translate')('loads:add:form:delivery_date_range:fields:error'));
        vm.savingNewLoad = false;
        return;
      }else{
        var aux_date_delivery = new Date(vm.dataNewLoad.delivery_date);

        vm.dataNewLoad.timer_start_delivery = '';
        vm.dataNewLoad.timer_finish_delivery = '';
        vm.dataNewLoad.timer_start_delivery += aux_date_delivery.getFullYear() + '-';
        if((aux_date_delivery.getMonth() + 1) > 9){
          vm.dataNewLoad.timer_start_delivery += (aux_date_delivery.getMonth() + 1) + '-';
        }else{
          vm.dataNewLoad.timer_start_delivery += '0' + (aux_date_delivery.getMonth() + 1) + '-';
        }

        if(aux_date_delivery.getDate() > 9){
          vm.dataNewLoad.timer_start_delivery += aux_date_delivery.getDate() + ' ';
        }else{
          vm.dataNewLoad.timer_start_delivery += '0' + aux_date_delivery.getDate() + ' ';
        }

        vm.dataNewLoad.timer_finish_delivery += vm.dataNewLoad.timer_start_delivery;

        vm.dataNewLoad.timer_start_delivery += vm.delivery_start_time_hour + ':';
        vm.dataNewLoad.timer_start_delivery += vm.delivery_start_time_minutes + ':';
        vm.dataNewLoad.timer_start_delivery += '00';

        vm.dataNewLoad.timer_finish_delivery += vm.delivery_finish_time_hour + ':';
        vm.dataNewLoad.timer_finish_delivery += vm.delivery_finish_time_minutes + ':';
        vm.dataNewLoad.timer_finish_delivery += '00';
      }

      if(vm.dataNewLoad.dimension == "1" || vm.dataNewLoad.dimension == "2"){
        if(vm.truckTypeRequired != '' && vm.truckTypeRequired != '0' && vm.truckTypeRequired != 0 && vm.truckTypeRequired != null){
          vm.dataNewLoad.truck_type_id = vm.truckTypeRequired;

          /*if(vm.TruckTypesRemolque.indexOf(parseInt(vm.truckTypeRequired)) !== -1){
            if(vm.dataNewLoad.length_loads <= 0 || vm.dataNewLoad.length_loads === null){
              toastr.error($filter('translate')('loads:add:form:required:fields:error'));
              vm.savingNewLoad = false;
              return;
            }
          }else{
            vm.dataNewLoad.length_loads = null;
          }*/
        }else{
          toastr.error($filter('translate')('loads:add:form:required:fields:error'));
          vm.savingNewLoad = false;
          return;
        }
      }

      if(vm.dataNewLoad.weight <= 0 || vm.dataNewLoad.weight === null || vm.dataNewLoad.weight === null){
        toastr.error($filter('translate')('loads:add:form:weight:value:invalid'));
        vm.savingNewLoad = false;
        return;
      }

      vm.dataNewLoad.load_type = [];
      if(angular.isDefined(vm.load_type_combo_box)){

        if(vm.load_type_combo_box == '' || vm.load_type_combo_box == null){
          toastr.error($filter('translate')('loads:add:form:required:fields:error'));
          vm.savingNewLoad = false;
          return;
        }else{
          vm.dataNewLoad.load_type.push(vm.load_type_combo_box);
        }

        vm.dataNewLoad.load_type = JSON.stringify(vm.dataNewLoad.load_type);
      }

      vm.dataNewLoad.skills_required_carrier = [];
      if(angular.isDefined(vm.skillsRequiredCarrier)){
        vm.skillsRequiredCarrier.forEach(function(item) {
          if (item.checked) vm.dataNewLoad.skills_required_carrier.push(item.id);
        });

        if(vm.dataNewLoad.skills_required_carrier.length <= 0){
          toastr.error($filter('translate')('loads:add:form:required:fields:error'));
          vm.carrierSkillsRequired = true;
          vm.savingNewLoad = false;
          return;
        }

        vm.dataNewLoad.skills_required_carrier = JSON.stringify(vm.dataNewLoad.skills_required_carrier);
      }
      if(vm.dataNewLoad.city_pickup == null ){
        vm.dataNewLoad.city_pickup          = (angular.isDefined(vm.dataSelectPickupCity.name)
          ? vm.dataSelectPickupCity.name
          : vm.dataSelectPickupCity);
        vm.dataNewLoad.pickup_address       = vm.dataSelectPickupAddress.formatted_address;
        vm.dataNewLoad.lat_pickup_address   = (angular.isDefined(vm.dataSelectPickupAddress.geometry)
          ? vm.dataSelectPickupAddress.geometry.location.lat()
          : null);
        vm.dataNewLoad.long_pickup_address  = (angular.isDefined(vm.dataSelectPickupAddress.geometry)
          ? vm.dataSelectPickupAddress.geometry.location.lng()
          : null);
        vm.dataNewLoad.country_pickup       = null;
        vm.dataNewLoad.state_pickup         = null;

      }

      if(angular.isDefined(vm.dataSelectPickupAddress.address_components)){
        for(var i in vm.dataSelectPickupAddress.address_components){
          if(vm.dataSelectPickupAddress.address_components[i].types.indexOf('administrative_area_level_1') != -1){
            vm.dataNewLoad.state_pickup = vm.dataSelectPickupAddress.address_components[i].long_name;
          }

          if(vm.dataSelectPickupAddress.address_components[i].types.indexOf('country') != -1){
            vm.dataNewLoad.country_pickup = vm.dataSelectPickupAddress.address_components[i].long_name;
          }
        }
      }
      if (vm.dataNewLoad.city_delivery == null){
        vm.dataNewLoad.city_delivery          = (angular.isDefined(vm.dataSelectDeliveryCity.name)
          ? vm.dataSelectDeliveryCity.name
          : vm.dataSelectDeliveryCity);
        vm.dataNewLoad.delivery_address       = vm.dataSelectDeliveryAddress.formatted_address;
        vm.dataNewLoad.lat_delivery_address   = (angular.isDefined(vm.dataSelectDeliveryAddress.geometry)
          ? vm.dataSelectDeliveryAddress.geometry.location.lat()
          : null);
        vm.dataNewLoad.long_delivery_address  = (angular.isDefined(vm.dataSelectDeliveryAddress.geometry)
          ? vm.dataSelectDeliveryAddress.geometry.location.lng()
          : null);
        vm.dataNewLoad.country_delivery       = null;
        vm.dataNewLoad.state_delivery         = null;
      }

      if(angular.isDefined(vm.dataSelectDeliveryAddress.address_components)){
        for(var i in vm.dataSelectDeliveryAddress.address_components){
          if(vm.dataSelectDeliveryAddress.address_components[i].types.indexOf('administrative_area_level_1') != -1){
            vm.dataNewLoad.state_delivery = vm.dataSelectDeliveryAddress.address_components[i].long_name;
          }

          if(vm.dataSelectDeliveryAddress.address_components[i].types.indexOf('country') != -1){
            vm.dataNewLoad.country_delivery = vm.dataSelectDeliveryAddress.address_components[i].long_name;
          }
        }
      }
      if((vm.dataNewLoad.country_pickup     != "Mexico"   &&
          vm.dataNewLoad.country_pickup     != "México")  ||
          (vm.dataNewLoad.country_delivery  != "Mexico"   &&
          vm.dataNewLoad.country_delivery   != "México")
      ){
        toastr.error($filter('translate')('loads:add:form:country:fields:error'));
        return vm.savingNewLoad = false;
      }

      if(angular.isDefined(vm.dataSelectPickupAddress.address_components)){
        for(var i in vm.dataSelectPickupAddress.address_components){
          if(vm.dataSelectPickupAddress.address_components[i].types.indexOf('administrative_area_level_1') != -1){
            vm.dataNewLoad.state_pickup = vm.dataSelectPickupAddress.address_components[i].long_name;
          }

          if(vm.dataSelectPickupAddress.address_components[i].types.indexOf('country') != -1){
            vm.dataNewLoad.country_pickup = vm.dataSelectPickupAddress.address_components[i].long_name;
          }
        }
      }

      $scope.saveMultipleStop();

      var defer = $q.defer();

      if(vm.reviewPriceWs === true){
        var paramsCheckPrice = {};
        paramsCheckPrice.token = vm.dataNewLoad.token;
        paramsCheckPrice.origin_city = vm.dataNewLoad.city_pickup;
        paramsCheckPrice.origin_state = vm.dataNewLoad.state_pickup;
        paramsCheckPrice.destini_city = vm.dataNewLoad.city_delivery;
        paramsCheckPrice.destini_state = vm.dataNewLoad.state_delivery;
        paramsCheckPrice.type_equipament = vm.dataNewLoad.load_type;
        paramsCheckPrice.skills_required_carrier = vm.dataNewLoad.skills_required_carrier;

        Loads.checkLoadPriceWs(paramsCheckPrice).then(function (response) {
          vm.priceSuggested = response.price;
          vm.savingNewLoad = false;
          vm.openCheckedPriceModal();
        }, function (error) {
          vm.priceSuggested = 0;
          vm.savingNewLoad = false;
          vm.openCheckedPriceModal();
        });
      }else{
        Loads.saveLoad(vm.dataNewLoad)
        .then(function (response) {
                console.log(response);
                toastr.success($filter('translate')('loads:add:form:success'));
                if(vm.submitReturnList){
                  vm.savingNewLoad = false;
                  $state.go('private.loads');
                }else{
                  $scope.initialize();
                }
            }, function (error) {
                toastr.error($filter('translate')('loads:add:form:required:fields:invalid'));
            });

        vm.savingNewLoad = false;
      }

    };

    /* Set return load list after save a new load */
    vm.submitReturnListFunc = function(postLoadFormName) {
      vm.submitReturnList = true;
      vm.save(postLoadFormName);
    };

    vm.openCheckedPriceModal = function() {
      var modalInstance = $uibModal.open({
        controller: 'CheckedLoadPriceModalController as loadprice',
        windowClass: 'load-price-modal',
        templateUrl: 'app/loads/templates/modal/checked-load-price.html',
        resolve: {
            price: function() {
                return vm.priceSuggested;
            },
            load: function() {
                return vm.dataNewLoad;
            }
        }
      });

      modalInstance.result.then(function(price) {
          vm.dataNewLoad.price = price;
          Loads.saveLoad(vm.dataNewLoad).then(function (response) {
              toastr.success($filter('translate')('loads:add:form:success'));
              if(vm.submitReturnList){
                $state.go('private.loads');
              }else{
                $scope.initialize();
              }
          }, function (error) {
            toastr.error($filter('translate')('loads:add:form:required:fields:invalid'));
          });
            vm.savingNewLoad = false;
      });
    };
    vm.driverLicenseChange = function(){
      var found = false;
      for(var i in vm.itemsSizeLenLoads.loadTypeLicense){
        if(vm.itemsSizeLenLoads.loadTypeLicense[i].id.toString() == vm.dataNewLoad.load_type_license_id){
          found = true;
          vm.loadLicenseTypeInfo = vm.itemsSizeLenLoads.loadTypeLicense[i].descrip_categori;
          vm.loadLicenseTypeTitle = $filter('translate')('loads:add:form:load_type_license_id:title1') + " " + vm.itemsSizeLenLoads.loadTypeLicense[i].categoria + " " + $filter('translate')('loads:add:form:load_type_license_id:title2');
        }
      }

      if(!found){
        vm.loadLicenseTypeInfo = '';
        vm.loadLicenseTypeTitle = '';
      }

    }

    vm.commodityChange = function(){
      var found = false;
      for(var i in vm.itemsSizeLenLoads.ListCommodity){
        if(vm.itemsSizeLenLoads.ListCommodity[i].id.toString() == vm.dataNewLoad.commodity_id){
          found = true;
          vm.commodityExcludedInfo = vm.itemsSizeLenLoads.ListCommodity[i].commodity_exclude;
        }
      }

      if(!found){
        vm.commodityExcludedInfo = '';
      }
    }

    vm.resetMultipleStops = function(){
      if(vm.dataNewLoad.allow_multiple_stops == 1){
        vm.indiceParadasMultiples = 0;
        vm.camposParadasMultiples = [{id: vm.indiceParadasMultiples, address: null}];
      }else{
        vm.indiceParadasMultiples = 0;
        vm.camposParadasMultiples = [];
      }
    }

    vm.addMultipleStop = function(){
      if(vm.dataNewLoad.allow_multiple_stops == 1){
        vm.indiceParadasMultiples++;
        vm.camposParadasMultiples.push({id: vm.indiceParadasMultiples, address: null});
      }
    }

    vm.deleteMultipleStop = function(indice){
      if(indice > 0){
        if(vm.camposParadasMultiples.length > 1){
          for(var i in vm.camposParadasMultiples){
            if(vm.camposParadasMultiples[i].id == indice){
              vm.camposParadasMultiples.splice(i, 1);
            }
          }

          for(var i2 in vm.camposParadasMultiples){
            if(vm.camposParadasMultiples[i2].id > indice){
              vm.camposParadasMultiples[i2].id = vm.camposParadasMultiples[i2].id - 1;
            }
          }

          vm.indiceParadasMultiples--;
        }
      }
    }

    $scope.saveMultipleStop = function (){
      var multiplestops_errors = false;
      if(vm.dataNewLoad.allow_multiple_stops == 1){

        vm.dataNewLoad.stops = [];
        var temp_address = null, temp_lat = null, temp_long = null , temp_country = null;
        console.log(vm.camposParadasMultiples);

        for(var imstp in vm.camposParadasMultiples){
          if(vm.camposParadasMultiples[imstp].address != null && vm.camposParadasMultiples[imstp].address != ""){
            if(vm.camposParadasMultiples[imstp].address.formatted_address && angular.isDefined(vm.camposParadasMultiples[imstp].address.address_components)){
              for(var add_comp in vm.camposParadasMultiples[imstp].address.address_components){
                if(vm.camposParadasMultiples[imstp].address.address_components[add_comp].types.indexOf('country') != -1){
                  temp_country = vm.camposParadasMultiples[imstp].address.address_components[add_comp].long_name;
                }
              }

              if(temp_country == "Mexico" || temp_country == "México"){
                temp_address = vm.camposParadasMultiples[imstp].address.formatted_address;
                temp_lat = (angular.isDefined(vm.camposParadasMultiples[imstp].address.geometry) ? vm.camposParadasMultiples[imstp].address.geometry.location.lat() : null);
                temp_long = (angular.isDefined(vm.camposParadasMultiples[imstp].address.geometry) ? vm.camposParadasMultiples[imstp].address.geometry.location.lng() : null);

                if(temp_address && temp_lat && temp_long){
                  vm.dataNewLoad.stops.push({address: temp_address, lat: temp_lat, long: temp_long});
                }else{
                  multiplestops_errors = true;
                }
              }else{
                multiplestops_errors = true;
              }

              temp_address = null;
              temp_lat = null;
              temp_long = null;
              temp_country = null;
            }else{
              multiplestops_errors = true;
            }
          }else{
            multiplestops_errors = true;
          }
        }
      }

      if(multiplestops_errors){
        toastr.error($filter('translate')('loads:add:form:multiple_stops:error'));
        vm.savingNewLoad = false;
        return;
      }else{
        if(vm.dataNewLoad.allow_multiple_stops == 1){
          vm.dataNewLoad.stops = JSON.stringify(vm.dataNewLoad.stops);
        }
      }
    }

    $scope.initialize();
  }
})();

(function() {
  'use strict';

  /* Set load truck modal controller
   * Receive load id
   * Verify load status to assign truck
   * Get trucks list
   * Assign truck to load
   */

  angular
    .module('loadsAppWeb')
    .controller('LoadTruckSelectModalController', LoadTruckSelectModalController);

  /** @ngInject */
  function LoadTruckSelectModalController($state, load, carrier, Auth, Loads, Carriers, Trucks, $uibModalInstance, DatatableTool, $q, toastr, $filter, $sce) {
	  var vm = this;

    /* Function executed at strart, get load id and verify load  */
    vm.initialize = function() {
      vm.datatableOptions = DatatableTool.getDefaultSettings();
      vm.datatableOptions.paging = false;
      vm.loadId = load;
      vm.carrierInfo = carrier;
      vm.loadingInfo = true;
      vm.savingRequest = false;
      vm.truckOptions = {
        'shortcut': 'active',
        'token': Auth.getUserToken(),
        'page': 1
      };

      vm.dataRequest = {};

      vm.dataTruckSelect = {};
      vm.dataTruckSelect.truck_id = null;

      vm.verifyLoad();
      //vm.getTrucks();
    };

    /* Verify load status to allow assigning the truck */
    vm.verifyLoad = function() {
      var params = {
                    'token': Auth.getUserToken(),
                    'load_id': vm.loadId
                   };

      Loads.getLoadDetails(params)
        .then(function(response){
          vm.loadData = response.result;
          //console.log(vm.loadData);
          vm.getTrucks();
          /*if(vm.loadData.status_loads != 'NOT_ASSIGNED' && vm.loadData.status_loads != 'CANCELADA'){ //&& vm.loadData.info_truck == 0
            vm.getTrucks();
          }else{
            vm.closePopup();
          }*/
        })
        .catch(function (error) {
          vm.closePopup();
        });
    };

    /* Get trucks list by carrier */
    vm.getTrucks = function() {
      Trucks.trucksForCarrier(vm.truckOptions).then(function(response){
          vm.dataRequests = response.truck_results;
          vm.dataRequest = [];
          angular.forEach(vm.dataRequests, function (value){
              if (value.truck_type.id == vm.loadData.trailer_type.id){
                vm.dataRequest.push(value);
              }
          });

          if(vm.dataRequest.length > 0){
            _.forEach(vm.dataRequest, function(value, key) {

                value.truck_img = false;
                if(angular.isDefined(value.img_truck_imagenes) && value.img_truck_imagenes != null){
                  value.truck_img = value.img_truck_imagenes[0]['imagen-60'];
                }

                value.truck_name = $filter('translate')('trucks:details:company_id_unity:title')+': '+(value.company_id_unity == null ? '' : value.company_id_unity)+' - '+value.brand+' '+value.model;

                value.driver_name = '';
                if(angular.isDefined(value.driver.user)){
                  value.driver_name = $filter('translate')('drivers:details:driver_company_id:title')+': '+(value.driver.id_integration_drivers == null ? '' : value.driver.id_integration_drivers)+' - '+value.driver.user.user_first_name+' '+value.driver.user.user_last_name;
                }

                value.truck_status = '';
                  var bgColorBtn = ''
                  , colorBtn = '';

                  switch(value.status){
                    case '1':
                      bgColorBtn = 'bg-color-3';
                      colorBtn = 'color-armadillo';
                      break;
                    case '0':
                      bgColorBtn = 'bg-color-7';
                      colorBtn = 'color-armadillo';
                      break;
                  }

                  value.truck_status = $sce.trustAsHtml('<button class="btn btn-class2 '+bgColorBtn+' '+colorBtn+'">'+$filter('translate')('trucks:table:status:' +value.status+ ':text')+'</button>');
            });
          }
          vm.loadingInfo = false;
        })
        .catch(function (error) {
          vm.loadingInfo = false;
        });
    };

    /* Validate truck selected and send data to API */
    vm.sendConfirmSelect = function(loadTruckSelectFormName) {
      vm.savingRequest = true;
      // Validate form.
      if (loadTruckSelectFormName.$invalid) {
          // If there was an error for required fields.
          if (loadTruckSelectFormName.$error.required) {
              toastr.error($filter('translate')('modals:load_truck_select:form:required:fields:error'));
          } else {
              toastr.error($filter('translate')('modals:load_truck_select:form:required:fields:invalid'));
          }
          vm.savingRequest = false;
          return;
      }
      //var defer = $q.defer();
      var params = {
        'truck_id': vm.dataTruckSelect.truck_id,
        'load_id': vm.loadId,
        'token': Auth.getUserToken()
      };

      Carriers.assignTruckToLoad(params).then(function (response) {
        console.log(response);
        toastr.success($filter('translate')('modals:load_truck_select:form:success'));
        vm.closePopup();
      }, function (error) {
        console.error(error);
        toastr.error($filter('translate')('modals:load_truck_select:form:required:fields:invalid'));
      });

      /*Loads.createRequestCarrierLoad(params).then(function(response){
        console.log(response);
        Carriers.assignTruckToLoad(params).then(function (response) {
          console.log(response);
          toastr.success($filter('translate')('modals:load_truck_select:form:success'));
          vm.closePopup();
        }, function (error) {
          console.error(error);
          toastr.error($filter('translate')('modals:load_truck_select:form:required:fields:invalid'));
        });

      });*/

      vm.savingRequest = false;
    };

    /* Close popup */
    vm.closePopup = function() {
        $uibModalInstance.close();
    };

    vm.initialize();

  }
})();

(function() {
  'use strict';

  /* Load activity info modal controller
   * Receive load activity info 
   */

  angular
    .module('loadsAppWeb')
    .controller('LoadActivityInfoModalController', LoadActivityInfoModalController);

  /** @ngInject */
  function LoadActivityInfoModalController($state, load, Auth, Loads, $uibModalInstance, $q, toastr, $filter) {
	  var vm = this;

    /* Function executed at strart, get load activity info  */
    vm.initialize = function() {
      vm.loadData = load;
    };

    /* Close popup */
    vm.closePopup = function() {
        $uibModalInstance.close();
    };

    vm.initialize();
    
  }
})();

(function() {
  'use strict';

  /* Checked Load Price modal controller
   * Ask to choose a load price between suggested price or shipper price
   * Send form data to API
   */

  angular
    .module('loadsAppWeb')
    .controller('CheckedLoadPriceModalController', CheckedLoadPriceModalController);

  /** @ngInject */
  function CheckedLoadPriceModalController($state, price, load, $uibModalInstance, $filter, Loads, toastr) {

    /* Set form vars  */
    var vm = this;

    /* Function executed at strart, set form vars  */
    vm.initialize = function() {
      vm.priceSuggested = price;
      vm.loadInfo = load;
    };

    vm.selectPrice = function(suggested){
      if(suggested){
        vm.closePopup(vm.priceSuggested);
      }else{
        vm.closePopup(vm.loadInfo.price);
      }
    }

    vm.closePopup = function(resp) {
        $uibModalInstance.close(resp);
    };

    vm.initialize();
  }
})();

(function() {
  'use strict';

  /* Carriers requests list modal controller
   * Receive load id 
   * Get carrier requests by load
   * Assign carrier to load
   */

  angular
    .module('loadsAppWeb')
    .controller('CarrierRequestsModalController', CarrierRequestsModalController);

  /** @ngInject */
  function CarrierRequestsModalController($state, load, Auth, Loads, $uibModalInstance, DatatableTool, $q, toastr, $filter) {
	  var vm = this;

    /* Function executed at strart, get load id and get carrier requests  */
    vm.initialize = function() {
      vm.datatableOptions = DatatableTool.getDefaultSettings();
      vm.datatableOptions.paging = false;
      vm.loadId = load;
      vm.carrierReqList = [];
      vm.loadingInfo = true;
      vm.savingRequest = false;
      vm.loadOptions = {
        'token': Auth.getUserToken(),
        'load_id': vm.loadId,
        'page': 1
      };

      vm.dataRequest = {};
      vm.dataRequest.carrier = null;

      vm.getCarrierRequests();
    };

    /* Get carrier requests */
    vm.getCarrierRequests = function() {
      Loads.getCarrierRequests(vm.loadOptions)
        .then(function(response){
          vm.carrierReqList = response.results;

          if(vm.carrierReqList.length){
            for(var i in vm.carrierReqList){
              if(angular.isDefined(vm.carrierReqList[i].carrier)){
                if(angular.isDefined(vm.carrierReqList[i].carrier.user) && angular.isDefined(vm.carrierReqList[i].carrier.user.img_perfil)){
                  vm.carrierReqList[i].img_perfil_carrier = $.parseJSON('['+vm.carrierReqList[i].carrier.user.img_perfil+']');
                  vm.carrierReqList[i].img_perfil_carrier = vm.carrierReqList[i].img_perfil_carrier[0];
                }
              }

              if(angular.isDefined(vm.carrierReqList[i].SkillsCarrier) && vm.carrierReqList[i].SkillsCarrier.length){
                var arr_skills = [];
                for(var sk in vm.carrierReqList[i].SkillsCarrier){
                  arr_skills.push(vm.carrierReqList[i].SkillsCarrier[sk].skills_name);
                }
                vm.carrierReqList[i].SkillsCarrierText = arr_skills.join(', ');
              }else{
                vm.carrierReqList[i].SkillsCarrierText = "";
              }
            }
          }
          vm.loadingInfo = false;
        })
        .catch(function (error) {
          vm.loadingInfo = false;
        });
    };

    /* Validate radio buttons and send carrier selected to API */
    vm.sendConfirmRequest = function(carrierRequestFormName) {
      vm.savingRequest = true;
      // Validate form.
      if (carrierRequestFormName.$invalid) {
          // If there was an error for required fields.
          if (carrierRequestFormName.$error.required) {
              toastr.error($filter('translate')('modals:carrier_requests:form:required:fields:error'));
          } else {
              toastr.error($filter('translate')('modals:carrier_requests:form:required:fields:invalid'));
          }
          vm.savingRequest = false;
          return;
      }

      var defer = $q.defer();

      var params = {
                'id_request': vm.dataRequest.carrier,
                'token': Auth.getUserToken(),
                'load_id': vm.loadId
              }

      Loads.acceptCarrierRequest(params)
          .then(function (response) {
                  console.log(response);
                  toastr.success($filter('translate')('modals:carrier_requests:form:success'));
                  vm.closePopup();
              }, function (error) {
                  toastr.error($filter('translate')('modals:carrier_requests:form:required:fields:invalid'));
              });

      vm.savingRequest = false;
    };

    /* Redirect to carrier profile */
    vm.seeCarrierProfile = function(carrier_id) {
      vm.closePopup();
      console.log(vm.loadId);
      $state.go('private.carriers.details', {id: carrier_id, load_id: vm.loadId});
    };

    /* Close popup */
    vm.closePopup = function() {
        $uibModalInstance.close();
    };

    vm.initialize();
    
  }
})();

(function() {
  'use strict';

  /* Carrier assigned info modal controller
   * Receive carrier id 
   * Get carrier info
   */

  angular
    .module('loadsAppWeb')
    .controller('CarrierAssignedInfoModalController', CarrierAssignedInfoModalController);

  /** @ngInject */
  function CarrierAssignedInfoModalController($state, carrier, Auth, Carriers, $uibModalInstance, $q, toastr, $filter) {
	  var vm = this;

    /* Function executed at strart, get carrier id and look for it  */
    vm.initialize = function() {
      vm.carrierInfoReceived = carrier;
      vm.params = {};
      vm.params.id_carrier = null;
      vm.params.page = 1;
      vm.params.token = Auth.getUserToken();
      vm.finalCarrierData = false;
      vm.loadingInfo = true;

      if(angular.isDefined(vm.carrierInfoReceived.user_id)){
        vm.params.id_carrier =  vm.carrierInfoReceived.user_id;

        vm.getCarrierSearch();
      }else{
        vm.loadingInfo = false;
      }
    };

    /* Get carrier info */
    vm.getCarrierSearch = function() {

      Carriers.getCarrierInformation(vm.params)
        .then(function(response){
          console.log(response);
          vm.finalCarrierData = response;

          if(vm.finalCarrierData){
            if(angular.isDefined(vm.finalCarrierData.carrier_info)){
              if(angular.isDefined(vm.finalCarrierData.carrier_info.user) && angular.isDefined(vm.finalCarrierData.carrier_info.user.img_perfil)){
                vm.finalCarrierData.img_perfil_carrier = $.parseJSON('['+vm.finalCarrierData.carrier_info.user.img_perfil+']');
                vm.finalCarrierData.img_perfil_carrier = vm.finalCarrierData.img_perfil_carrier[0];
              }
            }

            if(angular.isDefined(vm.finalCarrierData.SkillsCarrier) && vm.finalCarrierData.SkillsCarrier.length){
              var arr_skills = [];
              for(var sk in vm.finalCarrierData.SkillsCarrier){
                arr_skills.push(vm.finalCarrierData.SkillsCarrier[sk].skills_name);
              }
              vm.finalCarrierData.SkillsCarrierText = arr_skills.join(', ');
            }else{
              vm.finalCarrierData.SkillsCarrierText = "";
            }
          }

          vm.loadingInfo = false;
        });
    };

    /* Close popup */
    vm.closePopup = function() {
        $uibModalInstance.close();
    };

    vm.initialize();
    
  }
})();

(function() {
  'use strict';

  /* Cancel load modal controller
   * Receive load id 
   * Set cancel form vars
   * Send form data to API
   */

  angular
    .module('loadsAppWeb')
    .controller('CancelLoadModalController', CancelLoadModalController);

  /** @ngInject */
  function CancelLoadModalController($state, load, Auth, Loads, $uibModalInstance, DatatableTool, $q, toastr, $filter) {
	  var vm = this;

    /* Function executed at strart, set form vars  */
    vm.initialize = function() {
      vm.loadId = load;
      vm.dataToSend = {};
      vm.dataToSend.token = Auth.getUserToken();
      vm.dataToSend.load_id = vm.loadId;
      vm.dataToSend.reason_cancel = null;
      vm.dataToSend.reason_cancel_descrip = null;
      vm.savingCancel = false;

      vm.getItemsSizeLengthLoads();
    };

    /* Get attributes of loads */
    vm.getItemsSizeLengthLoads = function() {
      vm.itemsSizeLenLoads = {};
      Loads.getItemsSizeLengthLoads()
        .then(function(response){
          if(response){
            vm.itemsSizeLenLoads = response;
          }
        }); 
    };

    /* Validate and send form data to API */
    vm.sendCancel = function(cancelLoadFormName) {
      vm.savingCancel = true;
      // Validate form.
      if (cancelLoadFormName.$invalid) {
          // If there was an error for required fields.
          if (cancelLoadFormName.$error.required) {
              toastr.error($filter('translate')('modals:cancel_load:form:required:fields:error'));
          } else {
              toastr.error($filter('translate')('modals:cancel_load:form:required:fields:invalid'));
          }
          vm.savingCancel = false;
          return;
      }

      var defer = $q.defer();

      Loads.cancelLoad(vm.dataToSend)
          .then(function (response) {
                  toastr.success($filter('translate')('modals:cancel_load:form:success'));
                  vm.closePopup(true);
              }, function (error) {
                  toastr.error($filter('translate')('modals:cancel_load:form:required:fields:invalid'));
              });

      vm.savingCancel = false;
    };

    /* Close popup */
    vm.closePopup = function(resp) {
        $uibModalInstance.close(resp);
    };

    vm.initialize();
    
  }
})();

(function() {
  'use strict';

  /* Interesting points controller
   * Get user geolocation
   * Filter places by kinds of interesting points
   * Get places about filters and put them in the map
   */

  angular
    .module('loadsAppWeb')
    .controller('InterestPointsController', InterestPointsController);

  /** @ngInject */
  function InterestPointsController(toastr, $filter, Config, Trucks, DatatableTool, $q, Auth, uiGmapGoogleMapApi, DTOptionsBuilder, DTColumnBuilder, $timeout) {
	var vm = this;

    /* Function executed at strart, set vars and get user geolocation */
	  vm.initialize = function() {
      vm.nearbyPoints = [];
      vm.userLocation = {};
      vm.userLocation.latitude = false;
      vm.userLocation.longitude = false;
      vm.shortcutFilter = null;
      vm.datatableOptions = DatatableTool.getDefaultSettings();
      vm.datatableOptions.paging = false;
      vm.loadingMap = true;
      vm.loadingData = true;
      vm.apikeymaps = Config.ENV.GOOGLE_MAPS_KEY;
      vm.windowOptions = {visible: false};

      vm.filterList = [
                        {name: 'restaurant', full_name: 'Restaurants', checked: true },
                        {name: 'gas_station', full_name: 'Gas stations', checked: true },
                        {name: 'lodging', full_name: 'Hotels', checked: true },
                        {name: 'parking', full_name: 'Parkings', checked: true }
                      ];

      vm.getGeoLocation();
    };

    /* Load map and set as center the user geolocation point, also it sets places as markers */
    vm.initializeMap = function () {
      uiGmapGoogleMapApi.then(function(maps) {
       vm.loadingMap = false;
       vm.map = { center: { latitude: vm.userLocation.latitude, longitude: vm.userLocation.longitude }, zoom: 14 };
       if(vm.nearbyPoints.length){
        vm.setMarkers();
       }
      });
    };

    /* Main function, get interesting points from API, before it sends user geolocation */
    vm.getNearbyPoints = function() {
      var params = {};
      params.token = Auth.getUserToken();
      params.lat = vm.userLocation.latitude;
      params.long = vm.userLocation.longitude;
      params.shortcut = vm.shortcutFilter;

      Trucks.searchInterestPoints(params)
        .then(function(response){
          if(angular.isDefined(response.PointsOfInterest.results)){
            vm.nearbyPoints = response.PointsOfInterest.results;
            vm.initializeMap();
            vm.loadingData = false;
          }else{
            vm.nearbyPoints = [];
            vm.loadingData = false;
          }
        }).catch(function(error){
          vm.nearbyPoints = [];
          vm.loadingData = false;
        });
    };

    /* Set places as markers in the map */
    vm.setMarkers = function(){
      vm.mapMarkers = [];
      if(vm.nearbyPoints.length){
        switch(Auth.getUserProfile()){
          case 'CARRIER':
          case 'DRIVER':
          case 'OWNER':
            //añadir marcadores
            var icon_map = '';
            for(var i=0; i<vm.nearbyPoints.length; i++){
              icon_map = '';
              if(vm.nearbyPoints[i].types.length){
                console.log(vm.nearbyPoints[i].types);
                switch(vm.nearbyPoints[i].types[0]){
                  case "restaurant":
                  case "bar":
                    icon_map = 'assets/images/common/restaurant-point.png';
                    break;
                  case "lodging":
                    icon_map = 'assets/images/common/hotel-point.png';
                    break;
                  case "gas_station":
                    icon_map = 'assets/images/common/gas-station-point.png';
                    break;
                  case "parking":
                    icon_map = 'assets/images/common/parking-point.png';
                    break;
                }
              }
              vm.mapMarkers.push({id: vm.nearbyPoints[i].id, coords: { latitude: vm.nearbyPoints[i].geometry.location.lat, longitude: vm.nearbyPoints[i].geometry.location.lng}, options: { icon: (icon_map != '' ? icon_map : "assets/images/common/end_point.png") }, details: {image: (angular.isDefined(vm.nearbyPoints[i].photos)) ? 'https://maps.googleapis.com/maps/api/place/photo?maxwidth=30&maxheight=30&photoreference='+vm.nearbyPoints[i].photos[0].photo_reference+'&key='+vm.apikeymaps : '', name: (angular.isDefined(vm.nearbyPoints[i].name)) ? vm.nearbyPoints[i].name : '--', type: (vm.nearbyPoints[i].types.length) ? vm.nearbyPoints[i].types[0] : '--', opening: (angular.isDefined(vm.nearbyPoints[i].opening_hours)) ? (angular.isDefined(vm.nearbyPoints[i].opening_hours.weekday_text) ? vm.nearbyPoints[i].opening_hours.weekday_text.join() : '--') : '--', status: angular.isDefined(vm.nearbyPoints[i].opening_hours) ? ((vm.nearbyPoints[i].opening_hours.open_now === true) ? 'open' : ((vm.nearbyPoints[i].opening_hours.open_now === false) ? 'close' : '--')) : '--', coords: { latitude: vm.nearbyPoints[i].geometry.location.lat, longitude: vm.nearbyPoints[i].geometry.location.lng}}});
            }         
            break;
        }
      }
    };

    /* Get browser geolocation */
    vm.getGeoLocation = function() {
      if (navigator.geolocation) {
          navigator.geolocation.getCurrentPosition(vm.setGeoLocation);
      }
    };

    /* Set geolocation founded in local vars */
    vm.setGeoLocation = function (position) {
      vm.userLocation.latitude = position.coords.latitude;
      vm.userLocation.longitude = position.coords.longitude;
      vm.getNearbyPoints();
    };

    /* Set new filter and look for interesting points */
    vm.setFilterPoints = function(){
      var newFilter = [];
      if(angular.isDefined(vm.filterList)){
        vm.filterList.forEach(function(item) {
          if (item.checked) newFilter.push(item.name);
        });

        if(newFilter.length > 0){
          vm.shortcutFilter = newFilter;
        }else{
          vm.shortcutFilter = null;
        }
        vm.loadingData = true;
        vm.getNearbyPoints(); 
      }
    };

    /* marker info window */
    vm.openMapWindow = function(details){
      vm.windowOptions.visible = false;
      vm.detailsMapWindow = details;

      $timeout(function () {
        vm.windowOptions.visible = true;
      }, 1000);
    }

    vm.initialize();
  }
})();

(function() {
  'use strict';
/* Fastpay services
 * Get Carrier Factoring Loads
 */
  angular
    .module('loadsAppWeb')
    .service('Fastpay', FastpayServices);

  /** @ngInject */
  function FastpayServices($q, $http, Config, Upload) {
	var vm = this;
	vm.api_endpoint = Config.ENV.API_ENDPOINT +'v1/';

  vm.getCarrierFactoringLoads = function(params)
  {
    // Defer
        var defer = $q.defer();
        // Url
        var url = vm.api_endpoint + 'loads/getCarrierFactoringLoads';

        // Get
        $http.post(url, params)
            .then(function(response) {
                // Success
                if(response.data.status == 'ok' ){
                  defer.resolve(response.data.message);
                }else{
                  defer.reject(false);
                }
            })
            .catch(function(response) {
                // Error

                defer.reject(false);
            });

        return defer.promise;
  };


  }
})();

(function() {
  'use strict';

  /* Fastpay controller
   * Get Carrier Loads which apply factoring
   */

  angular
    .module('loadsAppWeb')
    .controller('FastPayController', FastPayController);

  /** @ngInject */
  function FastPayController(toastr, $filter, Config, Fastpay, DatatableTool, $q, Auth, uiGmapGoogleMapApi, DTOptionsBuilder, DTColumnBuilder, $sce) {
	var vm = this;

    /* Function executed at strart, set vars and get load list */
	  vm.initialize = function() {
      vm.fastPayData = null;
      vm.loadingData = true;
      vm.datatableOptions = DatatableTool.getDefaultSettings();
      vm.datatableOptions.paging = false;

      vm.getCarrierFactoring();
    };

    /* Get carrier factoring loads list */
    vm.getCarrierFactoring = function() {
      var params = {};
      params.token = Auth.getUserToken();
      params.page = 1;

      Fastpay.getCarrierFactoringLoads(params)
        .then(function(response){
          if(angular.isDefined(response.factoring_status) && angular.isDefined(response.results)){
            vm.fastPayData = response;
            vm.loadingData = false;
            if(vm.fastPayData.results.length){
               _.forEach(vm.fastPayData.results, function(value, key) {
                  value.full_name_shipper = value.load_generator_id.company_name;
                  value.img_shipper = false;
                  if(angular.isDefined(value.load_generator_id.user.img_perfil_arr) && value.load_generator_id.user.img_perfil_arr != null){
                    value.img_shipper = value.load_generator_id.user.img_perfil_arr[0]['imagen-60'];
                  }

                  value.status_btn = '';
                  var bgColorBtn = ''
                  , colorBtn = '';

                  switch(value.status_loads){
                    case 'NOT_ASSIGNED':
                      bgColorBtn = 'bg-color-7';
                      colorBtn = 'color-armadillo';
                      break;
                    case 'ACEPTADA':
                      bgColorBtn = 'bg-color-2';
                      colorBtn = 'color-armadillo';
                      break;
                    case 'EN_TRANSITO':
                      bgColorBtn = 'bg-color-5';
                      colorBtn = 'color-armadillo';
                      break;
                    case 'ENTREGADA': 
                      bgColorBtn = 'bg-color-3';
                      colorBtn = 'color-armadillo';
                      break;
                    default:
                      bgColorBtn = 'bg-color-7';
                      colorBtn = 'color-armadillo';
                      break;
                  }

                  value.status_btn = $sce.trustAsHtml('<button class="btn btn-class2 btn-status-load '+bgColorBtn+' '+colorBtn+'">'+$filter('translate')('loads:table:status:' +value.status_loads.toLowerCase()+ ':text')+'</button>');

                  value.pickup_date_formatted = moment(value.pickup_date, "YYYY-MM-DD HH:mm:ss").format("MMM DD YYYY");
                  value.delivery_date_formatted = moment(value.delivery_date, "YYYY-MM-DD HH:mm:ss").format("MMM DD YYYY");

                  value.actions = '<i ng-click="fastpay.showDetailsUnique('+value.load_id+')" class="fa fa-angle-down show-load-details-btn"></i>';
               });
            }
          }else{
            vm.nearbyPoints = null;
            vm.loadingData = false;
          }
        }).catch(function(error){
          vm.nearbyPoints = null;
          vm.loadingData = false;
        });
    };

    /* Show Load details in drop down tab */
    vm.showDetailsUnique = function(load_id) {
      for(var i in vm.fastPayData.results){
        if(vm.fastPayData.results[i].load_id == load_id){
          if(angular.isDefined(vm.fastPayData.results[i].expanded)){
            vm.fastPayData.results[i].expanded = !vm.fastPayData.results[i].expanded;  
          }else{
            vm.fastPayData.results[i].expanded = true;  
          }
        }else{
          vm.fastPayData.results[i].expanded = false;
        }
      }
    };

    vm.initialize();
  }
})();

(function() {
  'use strict';
/* Driver services
 * Get drivers by Carrier
 * Create driver
 */
  angular
    .module('loadsAppWeb')
    .service('Drivers', DriverServices);

  /** @ngInject */
  function DriverServices($q, $http, Config, Upload) {
	var vm = this;
	vm.api_endpoint_drivers = Config.ENV.API_ENDPOINT+'v1/';

	vm.driversForCarrier = function(params)
	{
		// Defer
        var defer = $q.defer();
        // Url
        var url = vm.api_endpoint_drivers + 'carrier/DriverxCarrierxStatus';

        // Get
        $http.post(url, params)
            .then(function(response) {
                // Success
                if(response.data.status == 'ok' ){
                	defer.resolve(response.data.message);
                }else{
					defer.reject(false);
                }
            })
            .catch(function(response) {
                // Error

                defer.reject(false);
            });

        return defer.promise;
	};

  vm.createDriver = function(params)
  {
    // Defer
        var defer = $q.defer();
        // Url
        var url = vm.api_endpoint_drivers + 'driver/CreateDriverProfile';

        // Get
        Upload.upload({url: url, data: params})
          .then(function(response) {
                // Success
                console.log(response);
                if(response.data.status == 'ok' ){
                  defer.resolve(response.data.message);
                }else{
                  defer.reject(response.data.message);
                }
            })
            .catch(function(response) {
                // Error

                defer.reject(false);
            });

        return defer.promise;
  };

  vm.driverById = function(params)
  {
    // Defer
        var defer = $q.defer();
        // Url
        var url = vm.api_endpoint_drivers + 'driver/CarrierXDriverInformation';

        // Get
        $http.post(url, params)
            .then(function(response) {
                // Success
                if(response.data.status == 'ok' ){
                  defer.resolve(response.data.message);
                }else{
          defer.reject(false);
                }
            })
            .catch(function(response) {
                // Error

                defer.reject(false);
            });

        return defer.promise;
  };

  vm.updateDriver = function(params)
  {
    // Defer
        var defer = $q.defer();
        // Url
        var url = vm.api_endpoint_drivers + 'driver/CarrierXDriverInformationUpdate';

        // Get
        Upload.upload({url: url, data: params})
          .then(function(response) {
                // Success
                console.log(response);
                if(response.data.status == 'ok' ){
                  defer.resolve(response.data.message);
                }else{
                  defer.reject(response.data.message);
                }
            })
            .catch(function(response) {
                // Error

                defer.reject(false);
            });

        return defer.promise;
  };


  }
})();

(function() {
  'use strict';

  /* Driver details Directive
   * It shows driver info in dropdown of driver table list
   * It is a generic element is loaded when user click in dropdown button of item */

  angular
    .module('loadsAppWeb')
    .directive('driverDetailsRow', driverDetailsRow);

  /** @ngInject */
  function driverDetailsRow($rootScope, Auth, Drivers, uiGmapGoogleMapApi, $uibModal, $state) {
    return {
        templateUrl: 'app/drivers/templates/directives/driver-details-row.html', // directive template
        restrict: 'E',
        replace: true,
        scope: {
          driverInfo: '=' //Input of directive, Driver info which feeds this directive
        },
        link: function(scope) {
            scope.driverData = {};
            /**
             * Initialize
             * Set driver info in local var
             */
            scope.initialize = function() {
              scope.driverData = scope.driverInfo;
            };

            scope.goToSeeTruckId = function(truck_id_search){
              $state.go('private.trucks.params', { truck_id: truck_id_search, dummy1: null, dummy2: null});
            };

            // Initialize
            scope.initialize();
        }
    };
  }
})();

(function() {
  'use strict';

  /* Driver edition controller
   */

  angular.module('loadsAppWeb').controller('DriversEditController', DriversEditController);

  /** @ngInject */
  function DriversEditController(
    $state,
    $stateParams,
    toastr,
    $filter,
    Config,
    Trucks,
    Drivers,
    Loads,
    Auth,
    DatatableTool,
    $q,
    DocumentService
  ) {
	  var vm = this;

    /* Function executed at strart, set form vars and get truck list  */
	  vm.initialize = function() {
      vm.submitReturnList = false;

      vm.driverId = $stateParams.id|| 0;
      vm.driverData = false;

      vm.dataUpdateDriver = {};
      vm.dataUpdateDriver.profile = 'DRIVER';
      vm.dataUpdateDriver.token = Auth.getUserToken();
      vm.dataUpdateDriver.driver_id = null;
      vm.dataUpdateDriver.id_integration_drivers = null;
      vm.dataUpdateDriver.user_first_name = null;
      vm.dataUpdateDriver.user_last_name = null;
      vm.dataUpdateDriver.user_phone = null;
      vm.dataUpdateDriver.user_email = null;
      vm.dataUpdateDriver.user_contry = null;
      vm.dataUpdateDriver.bond_insurance_num_policy = null;
      vm.dataUpdateDriver.bond_insurance_comp = null,
      vm.dataUpdateDriver.bond_insurance_num = null;
      vm.dataUpdateDriver.user_postalcode = null;
      vm.dataUpdateDriver.user_city = null;
      vm.dataUpdateDriver.user_state = null;
      vm.dataUpdateDriver.driver_license_num = null;
      vm.dataUpdateDriver.truck_id = null;

      vm.savingUpdateDriver = false;
      vm.submitReturnList = false;
      vm.trucksList = [];

      vm.optionsGoogleInputCity = {
        types: ['(cities)']
      };

      vm.getTruckList();
      vm.getDocuments();
      vm.user = {
        profile: 'drivers',
        user_id : vm.driverId
      };
    };
    vm.isSet = function (tabNum){
      return vm.tab === tabNum;
    }
    vm.setTab = function (newTab){
      vm.tab = newTab;
    }
    vm.getDocuments = function (){
      vm.profile = vm.dataUpdateDriver.profile+'s'
      DocumentService.display(vm.profile.toLowerCase(),vm.driverId).then(function (resp){
        if(resp.status === 200){
          vm.documents = resp.data.results;
          let tabSetter = (vm.documents.length > 0 && $stateParams.tab == 2)? 2 : $stateParams.tab;
          vm.isSet(tabSetter);
          vm.setTab(tabSetter);
        }
      });
    }
    /* Get truck list */
    vm.getTruckList = function() {
      var options = {
        'shortcut': 'active',
        'token': Auth.getUserToken(),
        'page': 1
      };

      Trucks.trucksForCarrier(options)
        .then(function(response){
          vm.trucksList = response.truck_results;
          vm.getDataDriver();
        });
    };

    /* Get data driver */
    vm.getDataDriver = function() {
      var driverOptions = {
        'token': Auth.getUserToken(),
        'driver_id': (vm.driverId) ? vm.driverId : false
      };

      if(driverOptions.driver_id){
        Drivers.driverById(driverOptions)
          .then(function(response){
            if(response.info){
              vm.driverData = response.info[0];
              vm.setDataToForm();
              vm.loadingDataDetails = false;
            }else{
              $state.go('private.drivers');
            }
          })
          .catch(function (error) {
            vm.loadingDataDetails = false;
            $state.go('private.drivers');
          });
      }else{
        vm.loadingDataDetails = false;
        $state.go('private.drivers');
      }
    };

    /* Set load info in local vars  */
    vm.setDataToForm = function() {
      vm.dataUpdateDriver.driver_id = (angular.isDefined(vm.driverData.user_id)) ? vm.driverData.user_id : null;
      vm.dataUpdateDriver.id_integration_drivers = (angular.isDefined(vm.driverData.id_integration_drivers)) ? vm.driverData.id_integration_drivers : null;
      vm.dataUpdateDriver.user_first_name = (angular.isDefined(vm.driverData.user)) ? vm.driverData.user.user_first_name : null;
      vm.dataUpdateDriver.user_last_name = (angular.isDefined(vm.driverData.user)) ? vm.driverData.user.user_last_name : null;
      vm.dataUpdateDriver.user_phone = (angular.isDefined(vm.driverData.user)) ? vm.driverData.user.user_phone : null;
      vm.dataUpdateDriver.user_email = (angular.isDefined(vm.driverData.user)) ? vm.driverData.user.user_email : null;
      vm.dataUpdateDriver.user_contry = (angular.isDefined(vm.driverData.user)) ? vm.driverData.user.user_contry : null;
      vm.dataUpdateDriver.bond_insurance_num_policy = (angular.isDefined(vm.driverData.bond_insurance_num_policy)) ? vm.driverData.bond_insurance_num_policy : null;
      vm.dataUpdateDriver.bond_insurance_comp = (angular.isDefined(vm.driverData.bond_insurance_comp)) ? vm.driverData.bond_insurance_comp : null;
      vm.dataUpdateDriver.bond_insurance_num = (angular.isDefined(vm.driverData.bond_insurance_num)) ? vm.driverData.bond_insurance_num : null;
      vm.dataUpdateDriver.user_postalcode = (angular.isDefined(vm.driverData.user)) ? vm.driverData.user.user_postalcode : null;
      vm.dataUpdateDriver.user_city = (angular.isDefined(vm.driverData.user)) ? vm.driverData.user.user_city : null;
      vm.dataUpdateDriver.user_state = (angular.isDefined(vm.driverData.user)) ? vm.driverData.user.user_state : null;
      vm.dataUpdateDriver.driver_license_num = (angular.isDefined(vm.driverData.driver_license_num)) ? vm.driverData.driver_license_num : null;
      vm.dataUpdateDriver.truck_id = (angular.isDefined(vm.driverData.trucks)) ? (vm.driverData.trucks.length > 0 ? vm.driverData.trucks[0].id.toString() : null) : null;
    };



    /* Validate and send form data to API */
    vm.save = function(postDriverFormName) {
      vm.savingUpdateDriver = true;
      // Validate form.
      if (postDriverFormName.$invalid) {
          // If there was an error for required fields.
          if (postDriverFormName.$error.required) {
              toastr.error($filter('translate')('loads:add:form:required:fields:error'));
          } else {
              toastr.error($filter('translate')('loads:add:form:required:fields:invalid'));
          }
          vm.savingUpdateDriver = false;
          return;
      }

      if(vm.dataUpdateDriver.truck_id == null){
        delete vm.dataUpdateDriver.truck_id;
      }

      Drivers.updateDriver(vm.dataUpdateDriver)
            .then(function(response) {
                // Success
                console.log(response);
                toastr.success($filter('translate')('drivers:add:form:success'));
                if(vm.submitReturnList){
                  $state.go('private.drivers');
                }else{
                  vm.initialize();
                }
                vm.savingUpdateDriver = false;
            })
            .catch(function(error) {
              console.log(error);
                // Error
                if(error === 'image_exceeded_limit'){
                  toastr.error($filter('translate')('drivers:add:form:pic_size:over'));
                }else if(error === 'user_exist'){
                  toastr.error($filter('translate')('sign_up:form:error:user_exists'));
                }else{
                  toastr.error($filter('translate')('loads:add:form:required:fields:invalid'));
                }
                // Loading
                vm.savingUpdateDriver = false;
            });

      vm.savingUpdateDriver = false;


    };

    vm.submitReturnListFunc = function(postDriverFormName) {
      vm.submitReturnList = true;
      vm.save(postDriverFormName);
    };



    vm.initialize();
  }
})();

(function() {
  'use strict';

  /* Driver controller
   * Look for drivers and set structure table
   * Show driver details in dropdown section*/

  angular
    .module('loadsAppWeb')
    .controller('DriversController', DriversController);

  /** @ngInject */
  function DriversController($state, $stateParams, toastr, $filter, Config, Drivers, Auth, DatatableTool, DTOptionsBuilder, DTColumnBuilder, $sce) {
	  var vm = this;

    /* Set controller vars
     * execute searching function at the end*/
	  vm.initialize = function() {
      var search_type = '';
      vm.profile = Auth.getUserProfile();

      switch(vm.profile){
        case 'CARRIER':
        case 'OWNER':
          search_type = 'all';
          break;
      }

      vm.driverOptions = {
        'driver_name': '',
        'shortcut': (search_type != '') ? search_type : 'all',
        'token': Auth.getUserToken(),
        'page': 1
      };
      vm.driversList = [];
      vm.loadingDriverData = true;
      vm.initializedList = false;

      if($stateParams.driver_name){
        vm.driverOptions.driver_name = $stateParams.driver_name;
      }

      vm.loadTab();  
    };

    /* look for drivers and reload table list */
    vm.loadTab = function() {
      if (vm.initializedList) {
        vm.reloadList();
      } else {
        vm.initializeList();
      }
    };

    /* change searching param to look for active, inactive or all drivers */
    vm.changeCategory = function(cat) {
      vm.loadingDriverData = true;
      vm.driverOptions.shortcut = cat;
      vm.driverOptions.page = 1;

      vm.loadTab();
    };

    vm.setDriverNameFilter = function() {
      vm.loadingDriverData = true;
      vm.driverOptions.page = 1;

      vm.loadTab();
    };

    /* Main function that looks for drivers and prepare table list configuration depending of rows received */
    vm.initializeList = function() {
      DatatableTool.setLimit(10);
      vm.datatableOptions = DTOptionsBuilder.newOptions()
                            .withOption('ajax', function(data, callback, settings){
                              // Page
                              vm.driverOptions.page = DatatableTool.getPage(data);
                              console.log(vm.driverOptions.page);

                              Drivers.driversForCarrier(vm.driverOptions)
                                .then(function(response){
                                  var records = DatatableTool.getRecordsDrivers(response);

                                  // Info
                                  if (!angular.isUndefined(records.data)) {
                                      _.forEach(records.data, function(value, key) {

                                          value.driver_img = false;
                                          if(angular.isDefined(value.user.img_perfil_arr) && value.user.img_perfil_arr != null){
                                            value.driver_img = value.user.img_perfil_arr[0]['imagen-60'];
                                          }

                                          value.driver_name = value.user.user_first_name+' '+value.user.user_last_name;

                                          value.driver_details = value.user.user_email+' '+value.user.user_phone;

                                          value.driver_status = '';
                                            var bgColorBtn = ''
                                            , colorBtn = '';

                                            switch(value.user.user_status){
                                              case '1':
                                                bgColorBtn = 'bg-color-9';
                                                colorBtn = 'color-black';
                                                break;
                                              case '0':
                                                bgColorBtn = 'bg-color-7';
                                                colorBtn = 'color-armadillo';
                                                break;
                                            }

                                            value.driver_status = $sce.trustAsHtml('<button class="btn btn-class2 '+bgColorBtn+' '+colorBtn+'">'+$filter('translate')('trucks:table:status:' +value.user.user_status+ ':text')+'</button>');

                                          value.actions = '<i ng-click="drivers.showDetailsUnique('+value.user_id+')" class="fa fa-angle-down show-load-details-btn"></i>';
                                      });
                                  }
                                  vm.driversList = records.data;
                                  records.data = [{driver_img: '', driver_full_name: '', driver_status: '', actions: ''}];
                                  callback(records);
                                })
                                .catch(function (error) {
                                  vm.driversList = [];
                                  callback(DatatableTool.getRecords(null));
                                });
                            })
                            .withDataProp('data')
                            .withOption('processing', true)
                            .withOption('serverSide', true)
                            .withOption('searching', false)
                            .withOption('info', false)
                            .withOption('lengthChange', false)
                            .withOption('pageLength', DatatableTool.getLimit(null))
                            .withOption('responsive', true)
                            .withLanguage(DatatableTool.getDefaultLanguageSettings())
                            .withPaginationType('numbers');
      switch(vm.profile){
        case 'CARRIER':
        case 'OWNER':
          vm.dtColumns = [
            DTColumnBuilder.newColumn('driver_img').withTitle(''),
            DTColumnBuilder.newColumn('driver_full_name').withTitle(''),
            DTColumnBuilder.newColumn('driver_status').withTitle(''),
            DTColumnBuilder.newColumn('actions').withTitle('')
          ];
          break;
      }

      vm.loadingDriverData = false;
      vm.initializedList = true;
    };

    /* Function reloads table list and looks for drivers again */
    vm.reloadList = function() {
        // Reload datatables
        DatatableTool.reload();
    };

    /* Show Driver details in drop down tab */
    vm.showDetailsUnique = function(driver_id) {
      console.log(driver_id);
      for(var i in vm.driversList){
        if(vm.driversList[i].user_id == driver_id){
          vm.driversList[i].expanded = !vm.driversList[i].expanded;
        }else{
          vm.driversList[i].expanded = false;
        }
      }
    };

    vm.addDriverByOwnerMsg = function(){
      toastr.info($filter('translate')('drivers:new_driver:owner:alert'));
    };

    vm.goToSeeTruckId = function(truck_id_search){
      $state.go('private.trucks.params', { truck_id: truck_id_search, dummy1: null, dummy2: null});
    }

    vm.initialize();
  }
})();

(function() {
  'use strict';

  /* Driver creation controller
   * Set vars to create a driver
   * Validate form
   * Send data to API and show successful message or any error
   */

  angular
    .module('loadsAppWeb')
    .controller('DriversAddController', DriversAddController);

  /** @ngInject */
  function DriversAddController($state, toastr, $filter, Config, Trucks, Drivers, Loads, Carriers, Auth, DatatableTool, $q) {
	  var vm = this;

    /* Function executed at strart, set form vars and get truck list */
	  vm.initialize = function() {
      vm.submitReturnList = false;

      vm.dataNewDriver = {};
      vm.dataNewDriver.profile = 'DRIVER';
      vm.dataNewDriver.token = Auth.getUserToken();
      vm.dataNewDriver.id_integration_drivers = null;
      vm.dataNewDriver.user_first_name = null;
      vm.dataNewDriver.user_last_name = null;
      vm.dataNewDriver.user_phone = null;
      vm.dataNewDriver.user_email = null;
      vm.dataNewDriver.user_contry = null;
      vm.dataNewDriver.user_password = null;
      vm.dataNewDriver.user_confirmpassword = null;
      vm.dataNewDriver.bond_insurance_num_policy = null;
      vm.dataNewDriver.bond_insurance_comp = null,
      vm.dataNewDriver.bond_insurance_num = null;
      vm.dataNewDriver.user_postalcode = null;
      vm.dataNewDriver.name_bank = null;
      vm.dataNewDriver.number_account_bank = null;
      vm.dataNewDriver.user_city = null;
      vm.dataNewDriver.user_state = null;
      vm.dataNewDriver.user_postalcode = null;
      vm.dataNewDriver.driver_license_num = null;
      vm.dataNewDriver.id_truck = null;

      vm.savingNewDriver = false;
      vm.trucksList = [];

      vm.getTruckList();

    };

    /* Send data to API after validate form */
    vm.save = function(postDriverFormName) {
      vm.savingNewDriver = true;
      // Validate form.
      if (postDriverFormName.$invalid) {
          // If there was an error for required fields.
          if (postDriverFormName.$error.required) {
              toastr.error($filter('translate')('loads:add:form:required:fields:error'));
          } else {
              toastr.error($filter('translate')('loads:add:form:required:fields:invalid'));
          }
          vm.savingNewDriver = false;
          return;
      }

      if(vm.dataNewDriver.user_password != vm.dataNewDriver.user_confirmpassword){
        toastr.error($filter('translate')('drivers:add:form:password:validate'));
        vm.savingNewDriver = false;
        return;
      }

      vm.dataNewDriver.user_password = CryptoJS.SHA1(vm.dataNewDriver.user_password.toString()).toString();

      Drivers.createDriver(vm.dataNewDriver)
            .then(function(response) {
                // Success
                //console.log(response);
                toastr.success($filter('translate')('drivers:add:form:success'));
                if(vm.submitReturnList){
                  $state.go('private.drivers');
                }else{
                  vm.initialize();
                }
                vm.savingNewDriver = false;
            })
            .catch(function(error) {
              //console.log(error);
                // Error
                if(error === 'image_exceeded_limit'){
                  toastr.error($filter('translate')('drivers:add:form:pic_size:over'));
                }else if(error === 'user_exist'){
                  toastr.error($filter('translate')('sign_up:form:error:user_exists'));
                }else{
                  toastr.error($filter('translate')('loads:add:form:required:fields:invalid'));
                }
                // Loading
                vm.savingNewDriver = false;
            });

    };

    /* Send data to API before set "return list" flag to return the user to driver list after create a new driver */
    vm.submitReturnListFunc = function(postDriverFormName) {
      vm.submitReturnList = true;
      vm.save(postDriverFormName);
    };

    /* Get truck list */
    vm.getTruckList = function() {
      var options = {
        'shortcut': 'active',
        'token': Auth.getUserToken(),
        'page': 1
      };

      Trucks.trucksForCarrier(options)
        .then(function(response){
          vm.trucksList = response.truck_results;
        });
    };

    vm.initialize();
  }
})();

(function() {
  'use strict';

  angular
      .module('loadsAppWeb')
      .service('webDevTec', webDevTec);

  /** @ngInject */
  function webDevTec() {
    var data = [
      {
        'title': 'AngularJS',
        'url': 'https://angularjs.org/',
        'description': 'HTML enhanced for web apps!',
        'logo': 'angular.png'
      },
      {
        'title': 'BrowserSync',
        'url': 'http://browsersync.io/',
        'description': 'Time-saving synchronised browser testing.',
        'logo': 'browsersync.png'
      },
      {
        'title': 'GulpJS',
        'url': 'http://gulpjs.com/',
        'description': 'The streaming build system.',
        'logo': 'gulp.png'
      },
      {
        'title': 'Jasmine',
        'url': 'http://jasmine.github.io/',
        'description': 'Behavior-Driven JavaScript.',
        'logo': 'jasmine.png'
      },
      {
        'title': 'Karma',
        'url': 'http://karma-runner.github.io/',
        'description': 'Spectacular Test Runner for JavaScript.',
        'logo': 'karma.png'
      },
      {
        'title': 'Protractor',
        'url': 'https://github.com/angular/protractor',
        'description': 'End to end test framework for AngularJS applications built on top of WebDriverJS.',
        'logo': 'protractor.png'
      },
      {
        'title': 'Sass (Node)',
        'url': 'https://github.com/sass/node-sass',
        'description': 'Node.js binding to libsass, the C version of the popular stylesheet preprocessor, Sass.',
        'logo': 'node-sass.png'
      }
    ];

    this.getTec = getTec;

    function getTec() {
      return data;
    }
  }

})();

(function() {
  'use strict';

  angular
    .module('loadsAppWeb')
    .component('pagination', {
      templateUrl: 'app/components/pagination/pagination.html',
      controller: function($scope) {


        function UrlWindow(current_page, last_page){
          this.paginator = {
            current_page: current_page,
            last_page: last_page,
          };

          this.getUrlRange = function(start,end,step ){
            step = step || 1;
            let arr = new Array(Math.floor((end - start) / step) + 1).fill(0);
            angular.forEach(arr, function(element,i){
              arr[i] = start + i * step;
            });
            return arr;
          };

          this.getWindowUrl = function(onEachSide){
            onEachSide = onEachSide || 3;
            if(this.lastPage() < (onEachSide * 2)+6){
              return this.getSmallSlider();
            }
            return this.getUrlSlider(onEachSide);
          };
          this.getSmallSlider = function(){
            return {
              'first': this.getUrlRange(1, this.lastPage()),
              'slider':null,
              'last':null
            }
          };
          this.getUrlSlider = function(onEachSide){
            let _window = onEachSide * 2;
            if(!this.hasPages()){
              return {
                'first': null,
                'slider':null,
                'last':null
              }
            }

            if(this.currentPage() <= _window){
              return this.getSliderTooCloseToBeginning(_window);
            }else if(this.currentPage() > (this.lastPage() - _window)){
              return this.getSliderTooCloseToEnding(_window);
            }

            return this.getFullSlider(onEachSide);

          };
          this.getSliderTooCloseToBeginning = function(_window){
            return {
              'first': this.getUrlRange(1, _window + 2),
              'slider':null,
              'last':this.getFinish()
            }
          };
          this.getSliderTooCloseToEnding = function(_window){
            let last = this.getUrlRange(this.lastPage() - (_window +2),this.lastPage());
            return {
              'first': this.getStart(),
              'slider':null,
              'last': last
            }
          };
          this.getFullSlider = function(onEachSide){
            return {
              'first': this.getStart(),
              'slider': this.getAdjacentUrlRange(onEachSide),
              'last':this.getFinish()
            }
          };
          this.getAdjacentUrlRange = function(onEachSide){
            return this.getUrlRange(this.currentPage() - onEachSide, this.currentPage() + onEachSide);
          };
          this.getStart = function(){
            return this.getUrlRange(1,2);
          };
          this.getFinish = function(){
            return this.getUrlRange(this.lastPage()-1,this.lastPage());
          };
          this.hasPages = function(){
            return this.paginator.last_page > 1;
          };
          this.currentPage = function(){
            return this.paginator.current_page;
          };
          this.lastPage = function(){
            return this.paginator.last_page;
          }

        }

        var vm = this;

        $scope.pages = [];
        $scope.currentPage = 0;
        $scope.total = 0;

        $scope.changePage = function(page){
          if(vm.onChange){
            vm.onChange({page: page});
          }
        };

        this.$onChanges = function (values){

          var obj = JSON.parse(this.list);

          $scope.currentPage = obj.page;
          $scope.total = obj.total;

          var _window = (new UrlWindow($scope.currentPage, $scope.total)).getWindowUrl(3);

          var data = [
            _window.first,
            _window.slider instanceof Array ? '...' : null,
            _window.slider,
            _window.last instanceof Array ? '...' : null,
            _window.last
          ];

          var elements = [];
          angular.forEach(data, function(value, key){
            if(value !== null) {
              elements.push(value);
            }
          });

          var pagesArray = [];

          angular.forEach(elements, function(element, key){
            if(element instanceof Array){
              for(var i= 0; i<element.length;i++){
                pagesArray.push(element[i]);
              }
            }else{
              pagesArray.push(element);
            }
          });

          $scope.pages = pagesArray;

        }


      },
      bindings: {
        list : '@',
        onChange: '&'
      }
    });

})();

(function() {
  'use strict';

  angular
    .module('loadsAppWeb')
    .directive('acmeNavbar', acmeNavbar);

  /** @ngInject */
  function acmeNavbar() {
    var directive = {
      restrict: 'E',
      templateUrl: 'app/components/navbar/navbar.html',
      scope: {
          creationDate: '='
      },
      controller: NavbarController,
      controllerAs: 'vm',
      bindToController: true
    };

    return directive;

    /** @ngInject */
    function NavbarController(moment) {
      var vm = this;

      // "vm.creationDate" is available by directive option "bindToController: true"
      vm.relativeDate = moment(vm.creationDate).fromNow();
    }
  }

})();

(function() {
  'use strict';

  angular
    .module('loadsAppWeb')
    .directive('acmeMalarkey', acmeMalarkey);

  /** @ngInject */
  function acmeMalarkey(malarkey) {
    var directive = {
      restrict: 'E',
      scope: {
        extraValues: '='
      },
      template: '&nbsp;',
      link: linkFunc,
      controller: MalarkeyController,
      controllerAs: 'vm'
    };

    return directive;

    function linkFunc(scope, el, attr, vm) {
      var watcher;
      var typist = malarkey(el[0], {
        typeSpeed: 40,
        deleteSpeed: 40,
        pauseDelay: 800,
        loop: true,
        postfix: ' '
      });

      el.addClass('acme-malarkey');

      angular.forEach(scope.extraValues, function(value) {
        typist.type(value).pause().delete();
      });

      watcher = scope.$watch('vm.contributors', function() {
        angular.forEach(vm.contributors, function(contributor) {
          typist.type(contributor.login).pause().delete();
        });
      });

      scope.$on('$destroy', function () {
        watcher();
      });
    }

    /** @ngInject */
    function MalarkeyController($log, githubContributor) {
      var vm = this;

      vm.contributors = [];

      activate();

      function activate() {
        return getContributors().then(function() {
          $log.info('Activated Contributors View');
        });
      }

      function getContributors() {
        return githubContributor.getContributors(10).then(function(data) {
          vm.contributors = data;

          return vm.contributors;
        });
      }
    }

  }

})();

(function() {
  'use strict';

  angular
    .module('loadsAppWeb')
    .factory('githubContributor', githubContributor);

  /** @ngInject */
  function githubContributor($log, $http) {
    var apiHost = 'https://api.github.com/repos/Swiip/generator-gulp-angular';

    var service = {
      apiHost: apiHost,
      getContributors: getContributors
    };

    return service;

    function getContributors(limit) {
      if (!limit) {
        limit = 30;
      }

      return $http.get(apiHost + '/contributors?per_page=' + limit)
        .then(getContributorsComplete)
        .catch(getContributorsFailed);

      function getContributorsComplete(response) {
        return response.data;
      }

      function getContributorsFailed(error) {
        $log.error('XHR Failed for getContributors.\n' + angular.toJson(error.data, true));
      }
    }
  }
})();

(function() {
  'use strict';
/* Carrier services
 * Look for carrier by Shipper
 * Get carrier info
 * Get drivers by carrier
 * Assign truck to load
 */
  angular
    .module('loadsAppWeb')
    .service('Carriers', CarrierServices);

  /** @ngInject */
  function CarrierServices($q, $http, Config) {
	var vm = this;
	//vm.api_endpoint_carriers = Config.ENV.API_ENDPOINT + 'shipper/';

	vm.searchCarrierByShipper = function(params)
	{
		// Defer
        var defer = $q.defer();
        // Url
        var url = Config.ENV.API_ENDPOINT +'v1/' + 'shipper/searchCarrier';

        // Get
        $http.post(url, params)
            .then(function(response) {
                // Success
                if(response.data.status == 'ok' ){
                	defer.resolve(response.data.message);
                }else{
					        defer.reject(false);
                }
            })
            .catch(function(response) {
                // Error

                defer.reject(false);
            });

        return defer.promise;
	};

  vm.getCarrierInformation = function(params)
  {
    // Defer
        var defer = $q.defer();
        // Url
        var url = Config.ENV.API_ENDPOINT +'v1/' + 'carrier/CarrierInformation';

        // Get
        $http.post(url, params)
            .then(function(response) {
                // Success
                if(response.data.status == 'ok' ){
                  defer.resolve(response.data.message);
                }else{
                  defer.reject(false);
                }
            })
            .catch(function(response) {
                // Error

                defer.reject(false);
            });

        return defer.promise;
  };

  vm.getDriverxCarrier = function(params)
  {
    // Defer
        var defer = $q.defer();
        // Url
        var url = Config.ENV.API_ENDPOINT +'v1/' + 'carrier/DriverxCarrier';

        // Get
        $http.post(url, params)
            .then(function(response) {
                // Success
                if(response.data.status == 'ok' ){
                  defer.resolve(response.data.message);
                }else{
                  defer.reject(false);
                }
            })
            .catch(function(response) {
                // Error

                defer.reject(false);
            });

        return defer.promise;
  };

  vm.assignTruckToLoad = function(params)
  {
    // Defer
        var defer = $q.defer();
        // Url
        var url = Config.ENV.API_ENDPOINT +'v1/' + 'carrier/assignTruckandDrivertoLoad';

        // Get
        $http.post(url, params)
            .then(function(response) {
                // Success
                if(response.data.status == 'ok' ){
                  defer.resolve(response.data.message);
                }else{
                  defer.reject(false);
                }
            })
            .catch(function(response) {
                // Error

                defer.reject(false);
            });

        return defer.promise;
  };


  }
})();

(function() {
  'use strict';

  /* Carrier details Directive
   * It shows carrier info in dropdown of carrier table list
   * It is a generic element is loaded when user click in dropdown button of item */

  angular
    .module('loadsAppWeb')
    .directive('carrierDetailsRow', carrierDetailsRow);

  /** @ngInject */
  function carrierDetailsRow($rootScope, Auth, Carriers, $uibModal) {
    return {
        templateUrl: 'app/carriers/templates/directives/carrier-details-row.html', // directive template
        restrict: 'E',
        replace: true,
        scope: {
          carrierInfo: '=' //Input of directive, Carrier info which feeds this directive
        },
        link: function(scope) {
          //console.log(scope.carrierInfo);
            scope.carrierData = scope.carrierInfo;
            scope.loadsTransit = scope.carrierData.LoadsTransit;
            scope.loadingCarrierData = true;
            /**
             * Initialize
             */
            scope.initialize = function() {
                if(angular.isDefined(scope.carrierData.carrier.user_id)){
                  scope.searchCarrierInfo();
                }
            };

            /* Get all carrier info from data received */
            scope.searchCarrierInfo = function(){
              var params = {};
              params.token = Auth.getUserToken();
              params.page = 1;
              params.id_carrier = scope.carrierData.carrier.user_id;

              Carriers.getCarrierInformation(params)
                .then(function(response){
                  if(response){
                    scope.carrierData = response;

                    if(angular.isDefined(scope.carrierData.carrier_info)){
                      if(angular.isDefined(scope.carrierData.carrier_info.user) && angular.isDefined(scope.carrierData.carrier_info.user.img_perfil)){
                        scope.carrierData.img_perfil_carrier = $.parseJSON('['+scope.carrierData.carrier_info.user.img_perfil+']');
                        scope.carrierData.img_perfil_carrier = scope.carrierData.img_perfil_carrier[0];
                      }
                    }
                  }
                });
            };

            /* Open truck info modal when user clic some truck items */
            scope.openTruckModal = function(truck_id){
              var modalInstance = $uibModal.open({
                controller: 'TruckInfoModalController as truckinfomodal',
                windowClass: 'truck-info-modal',
                templateUrl: 'app/carriers/templates/modal/truck-info-modal.html',
                resolve: {
                    truck: function() {
                        return truck_id;
                    }
                }
              });
            };

            // Initialize
            scope.initialize();
        }
    };
  }
})();

(function() {
  'use strict';

  /* Truck info controller of modal
   * It gets a Truck Id and looks for its information*/

  angular
    .module('loadsAppWeb')
    .controller('TruckInfoModalController', TruckInfoModalController);

  /** @ngInject */
  function TruckInfoModalController($state, truck, $uibModalInstance, $filter, Trucks, Auth, toastr) {
	  var vm = this;
    
    vm.truckId = truck;
    vm.loadingData = true;
    vm.infoTruck = false;

    vm.initialize = function(){
      vm.getInfoTruck();
    };

    /* Get truck info */
    vm.getInfoTruck = function(){
      var params = {};
      params.token = Auth.getUserToken();
      params.id = vm.truckId;

      Trucks.trucksDetails(params)
        .then(function(response){
          if(response.Truck_Details[0]){
            vm.infoTruck = response.Truck_Details[0];

            if(vm.infoTruck.skills_truck){
              var arr_skills = [];
              for(var i in vm.infoTruck.skills_truck){
                arr_skills.push(vm.infoTruck.skills_truck[i].skills_name);
              }

              vm.infoTruck.skills_truck_text = arr_skills.join(',');

              //console.log(vm.skills_truck_text);
            }else{
              vm.infoTruck.skills_truck_text = '';
            }

            if(vm.infoTruck.truck_availability){
              var arr_availability = [];
              for(var i in vm.infoTruck.truck_availability){
                arr_availability.push(vm.infoTruck.truck_availability[i].availablity_name);
              }

              vm.infoTruck.truck_availability_text = arr_availability.join(',');
            }else{
              vm.infoTruck.truck_availability_text = '';
            }
          }
          vm.loadingData = false;
          //console.log(vm.infoTruck);
        });
    };

    /* Close modal */
    vm.closePopup = function(resp) {
        $uibModalInstance.close(resp);
    };

    vm.initialize();
  }
})();

(function() {
  'use strict';

  /* Carrier details controller
   * It gets a Carrier Id and looks for their information
   * Look for user data and related info about load if this page is charged after load page*/

  angular
    .module('loadsAppWeb')
    .controller('CarriersDetailsController', CarriersDetailsController);

  /** @ngInject */
  function CarriersDetailsController($state, $stateParams, toastr, $filter, Config, Carriers, Auth, Loads, DatatableTool, $q) {
	  var vm = this;

    /* Function executed at start, it gets carrier Id and load Id (optional) and executes searching function */
	  vm.initialize = function() {
      vm.carrierId = $stateParams.id|| false;
      vm.loadId = $stateParams.load_id|| false;
      vm.loadCarrierRequestOpts = {
        'token': Auth.getUserToken(),
        'load_id': vm.loadId,
        'page': 1
      };
      vm.loadInfoOpts = {
        'token': Auth.getUserToken(),
        'load_id': vm.loadId
      };
      vm.loadCarrierRequest = false;
      vm.loadData = false;
      vm.shipperCanAcceptRequest = false;
      vm.carrierData = false;

      vm.loadingDataDetails = true;

      vm.myData = Auth.getUserDataProfile();

      vm.getCarrierInfo();
    };

    /* Get info about load */
    vm.getLoadInfo = function() {
      Loads.getLoadDetails(vm.loadInfoOpts)
        .then(function(response){
          vm.loadData = response.result;

          if(angular.isDefined(vm.loadData.info_load_generator)){
            var shipperData = Auth.getUserDataProfile();
            if(vm.loadData.info_load_generator.user_id == shipperData.user_id){
              vm.shipperCanAcceptRequest = true;
            }
          }
        })
        .catch(function (error) {
        });
    };

    /* Get info about carrier request to load */
    vm.getLoadRequestByCarrier = function() {
      Loads.getCarrierRequests(vm.loadCarrierRequestOpts)
        .then(function(response){
          var carrierReqList = response.results;

          if(carrierReqList.length){
            for(var i in carrierReqList){
              if(carrierReqList[i].carrier.user_id == vm.carrierData.carrier_info.user_id){
                vm.loadCarrierRequest = carrierReqList[i];
              }
            }
          }
        })
        .catch(function (error) {
        });
    };

    /* Get info about carrier */
    vm.getCarrierInfo = function() {
      var carrierOptions = {
        'token': Auth.getUserToken(),
        'page': 1,
        'id_carrier': (vm.carrierId) ? vm.carrierId : false
      };

      if(carrierOptions.id_carrier){
        Carriers.getCarrierInformation(carrierOptions)
          .then(function(response){
            if(response){
              vm.carrierData = response;

              if(angular.isDefined(vm.carrierData.carrier_info)){
                if(angular.isDefined(vm.carrierData.carrier_info.user) && angular.isDefined(vm.carrierData.carrier_info.user.img_perfil)){
                  vm.carrierData.img_perfil_carrier = $.parseJSON('['+vm.carrierData.carrier_info.user.img_perfil+']');
                  vm.carrierData.img_perfil_carrier = vm.carrierData.img_perfil_carrier[0];
                }
              }

              if(vm.loadId){
                vm.getLoadRequestByCarrier();
                vm.getLoadInfo();
              }

              vm.loadingDataDetails = false;
            }else{
              vm.loadingDataDetails = false;
              $state.go('private.home');
            }
          })
          .catch(function (error) {
            vm.loadingDataDetails = false;
            $state.go('private.home');
          });
      }else{
        vm.loadingDataDetails = false;
        $state.go('private.home');
      }
    };

    /* Function allows shipper accepting some carrier request of the load */
    vm.answerRequestByCarrier = function() {
      if(vm.loadCarrierRequest && vm.shipperCanAcceptRequest){

        var params = {
                'id_request': vm.loadCarrierRequest.id_request,
                'token': Auth.getUserToken(),
                'load_id': vm.loadId
              }

        Loads.acceptCarrierRequest(params)
            .then(function (response) {
                    toastr.success($filter('translate')('modals:carrier_requests:form:success'));
                    vm.shipperCanAcceptRequest = false;
                }, function (error) {
                    toastr.error($filter('translate')('modals:carrier_requests:form:required:fields:invalid'));
                });

      }
    };

    vm.initialize();
  }
})();

(function() {
  'use strict';

  /* Carrier controller
   * If it receives searching params, it'll prepare filter vars to get carriers 
   * Set and reset filters
   * Look for carriers and set structure table
   * Show carrier details in dropdown section*/

  angular
    .module('loadsAppWeb')
    .controller('CarriersController', CarriersController);

  /** @ngInject */
  function CarriersController($state, $stateParams, toastr, $translate, $filter, Config, Carriers, Auth, DatatableTool, DTOptionsBuilder, DTColumnBuilder, $q, $uibModal) {
    var vm = this;

    /* Set controller vars and set filters if it receive some of them 
     * execute searching function at the end*/
    vm.initialize = function() {
      vm.carriersList = [];
      vm.countCarriers = 0;
      vm.tabList = "all";
      vm.initializedList = false;
      vm.loadingCarrierData = true;
      //vm.datatableOptions = DatatableTool.getDefaultSettings();
      //vm.datatableOptions.paging = false;
      vm.params = {};
      vm.params.company = $stateParams.company|| false;
      vm.params.trailer_type = $stateParams.trailer_type|| false;
      vm.params.length = $stateParams.len|| false;
      vm.params.weight = $stateParams.wei|| false;
      vm.params.size = $stateParams.size|| false;
      vm.params.skils_truck = $stateParams.skils_truck|| false;
      vm.params.reviews = $stateParams.reviews|| false;

      vm.searchOptions = {};
      vm.searchOptions.page = 1;
      vm.searchOptions.token = Auth.getUserToken();
      if(vm.params.company){
        vm.tabList = "my_search";
        vm.searchOptions.namecarrier = vm.params.company;
      }
      if(vm.params.trailer_type){
        vm.tabList = "my_search";
        vm.searchOptions.type_trailer = vm.params.trailer_type;
      }
      if(vm.params.length){
        vm.tabList = "my_search";
        vm.searchOptions.lenght = vm.params.length;
      }
      if(vm.params.weight){
        vm.tabList = "my_search";
        vm.searchOptions.weight = vm.params.weight;
      }
      if(vm.params.size){
        vm.tabList = "my_search";
        vm.searchOptions.size = vm.params.size;
      }
      if(vm.params.skils_truck){
        vm.tabList = "my_search";
        //vm.searchOptions.skills = JSON.parse("["+vm.params.skils_truck+"]");
        vm.searchOptions.skills = JSON.stringify(vm.params.skils_truck);
      }
      if(vm.params.reviews && vm.params.reviews > 0){
        vm.tabList = "my_search";
        vm.searchOptions.reviews = vm.params.reviews;
      }

      vm.loadTab();

      //vm.searchCarriers();
    };

    /* Set searching params if user select "Searching" tab */
    vm.setSearchParams = function() {
      var deferred = $q.defer();

      vm.searchOptions = {};
      vm.searchOptions.page = 1;
      vm.searchOptions.token = Auth.getUserToken();
      if(vm.params.company){
        vm.tabList = "my_search";
        vm.searchOptions.namecarrier = vm.params.company;
      }
      if(vm.params.trailer_type){
        vm.tabList = "my_search";
        vm.searchOptions.type_trailer = vm.params.trailer_type;
      }
      if(vm.params.length){
        vm.tabList = "my_search";
        vm.searchOptions.lenght = vm.params.length;
      }
      if(vm.params.weight){
        vm.tabList = "my_search";
        vm.searchOptions.weight = vm.params.weight;
      }
      if(vm.params.size){
        vm.tabList = "my_search";
        vm.searchOptions.size = vm.params.size;
      }
      if(vm.params.skils_truck){
        vm.tabList = "my_search";
        vm.searchOptions.skills = JSON.parse("["+vm.params.skils_truck+"]");
      }
      if(vm.params.reviews && vm.params.reviews > 0){
        vm.tabList = "my_search";
        vm.searchOptions.reviews = vm.params.reviews;
      }

      deferred.resolve(true);
      return deferred.promise;
    };

    /* reset all searching filters */
    vm.resetAllFilters = function() {
      vm.tabList = "all";
      vm.params.company = false;
      vm.params.trailer_type = false;
      vm.params.length = false;
      vm.params.weight = false;
      vm.params.size = false;
      vm.params.skils_truck = false;
      vm.params.reviews = false;

      vm.searchOptions.namecarrier = null;
      vm.searchOptions.type_trailer = null;
      vm.searchOptions.lenght = null;
      vm.searchOptions.weight = null;
      vm.searchOptions.size = null;
      vm.searchOptions.skills = null;
      vm.searchOptions.reviews = null;
      
      vm.reloadList();
    };

    /* Function is executed if user click "searching" tab */
    vm.searchWithParams = function() {
      vm.params.company = ($stateParams.company && $stateParams.company != null) ? $stateParams.company : false;
      vm.params.trailer_type = ($stateParams.trailer_type && $stateParams.trailer_type != null) ? $stateParams.trailer_type : false;
      vm.params.length = ($stateParams.len && $stateParams.len != null) ? $stateParams.len : false;
      vm.params.weight = ($stateParams.wei && $stateParams.wei != null) ? $stateParams.wei : false;
      vm.params.size = ($stateParams.size && $stateParams.size != null) ? $stateParams.size : false;
      vm.params.skils_truck = ($stateParams.skils_truck && $stateParams.skils_truck != null) ? $stateParams.skils_truck : false;
      vm.params.reviews = ($stateParams.reviews && $stateParams.reviews != null) ? $stateParams.reviews : false;
      
      vm.setSearchParams()
        .then(function(){
          vm.reloadList();
        });
    };

    /* look for carriers and reload table list */
    vm.loadTab = function() {
      if (vm.initializedList) {
        vm.reloadList();
      } else {
        vm.searchCarriers();
      }
    };

    /* Main function that looks for carriers and prepare table list configuration depending of rows received */
    vm.searchCarriers = function() {
      vm.datatableOptions = DTOptionsBuilder.newOptions()
                            .withOption('ajax', function(data, callback, settings){

                                vm.countCarriers = 0;

                                // Page
                                vm.searchOptions.page = DatatableTool.getPage(data);

                                Carriers.searchCarrierByShipper(vm.searchOptions)
                                  .then(function(response){
                                    var records = DatatableTool.getRecords(response);

                                    if (!angular.isUndefined(records.recordsTotal)) {
                                      vm.countCarriers = records.recordsTotal;
                                    }

                                    // Info
                                    if (!angular.isUndefined(records.data)) {
                                        _.forEach(records.data, function(value, key) {

                                            value.img_perfil_carrier = null;
                                            value.carrier_company_name = null;
                                            if(angular.isDefined(value.carrier)){
                                              if(angular.isDefined(value.carrier.user) && angular.isDefined(value.carrier.user.img_perfil)){
                                                value.img_perfil_carrier = $.parseJSON('['+value.carrier.user.img_perfil+']');
                                                value.img_perfil_carrier = value.img_perfil_carrier[0];
                                              }

                                              value.carrier_company_name = value.carrier.company_name;
                                            }

                                            value.transported = null;
                                            value.transit = null;
                                            value.trucks = null;
                                            if(angular.isDefined(value.LoadsTransported)){
                                              value.transported = value.LoadsTransported;
                                            }

                                            if(angular.isDefined(value.LoadsTransit)){
                                              value.transit = value.LoadsTransit;
                                            }

                                            if(angular.isDefined(value.CantidadTruck)){
                                              value.trucks = value.CantidadTruck;
                                            }

                                            value.SkillsCarrierText = "";
                                            if(angular.isDefined(value.SkillsCarrier) && value.SkillsCarrier.length){
                                              var arr_skills = [];
                                              for(var sk in value.SkillsCarrier){
                                                arr_skills.push(value.SkillsCarrier[sk].skills_name);
                                              }
                                              value.SkillsCarrierText = arr_skills.join(', ');
                                            }
                                        });
                                    }
                                    vm.carriersList = records.data;
                                    records.data = [{img_perfil_carrier: '', carrier_company_name: '', transported: '', transit: '', trucks: '', skills: '', reviews: '', contact: '', actions: ''}];
                                    callback(records);
                                  })
                                  .catch(function (error) {
                                    vm.carriersList = [];
                                    callback(DatatableTool.getRecords(null));
                                  });
                            })
                            .withDataProp('data')
                            .withOption('processing', true)
                            .withOption('serverSide', true)
                            .withOption('searching', false)
                            .withOption('info', false)
                            .withOption('lengthChange', false)
                            .withOption('pageLength', DatatableTool.getLimit(null))
                            .withOption('responsive', true)
                            .withLanguage(DatatableTool.getDefaultLanguageSettings())
                            .withPaginationType('numbers');
      
      vm.dtColumns = [
        DTColumnBuilder.newColumn('img_perfil_carrier'),
        DTColumnBuilder.newColumn('carrier_company_name'),
        DTColumnBuilder.newColumn('transported'),
        DTColumnBuilder.newColumn('transit'),
        DTColumnBuilder.newColumn('trucks'),
        DTColumnBuilder.newColumn('skills'),
        DTColumnBuilder.newColumn('reviews'),
        DTColumnBuilder.newColumn('contact'),
        DTColumnBuilder.newColumn('actions')
      ];

      vm.loadingCarrierData = false;
      vm.initializedList = true;
    };

    /* Function reloads table list and looks for carriers again */
    vm.reloadList = function() {
        // Reload datatables
        DatatableTool.reload();
    };

    /* Show Carrier details in drop down tab */
    vm.showDetailsUnique = function(carrier_id) {
      for(var i in vm.carriersList){
        if(vm.carriersList[i].id == carrier_id){
          vm.carriersList[i].expanded = !vm.carriersList[i].expanded;
        }else{
          vm.carriersList[i].expanded = false;
        }
      }
    };

    vm.initialize();
  }
})();

'use strict';
/* Interceptor service
 * Add token and some params in http header in each http request made in the site
 * Just in the case the user is logged
 */
angular.module('loadsAppWeb')
    .service('AuthInterceptor', function ($q, $localStorage, Config)
    {

        return {
            request: function (cfg)
            {
                cfg.headers = cfg.headers || {};

                var customHeaders = {
                    headers: {
                        //"Authorization": "",
                        //"Content-Type": "application/json"
                    }
                };

                //Get Access Token.
                //$localStorage.$apply();
              var accessToken = sessionStorage.getItem('_tr');
                if (accessToken && cfg.url.indexOf("api-companies") == -1) {
                    customHeaders.headers["Content-Type"] = "application/json";
                    customHeaders.headers["Authorization"] = 'Bearer ' + accessToken;
                }

                var companiesApiHeader = $localStorage.companiesHeaderReq;
                if(companiesApiHeader && cfg.url.indexOf("api-companies") != -1){
                    customHeaders.headers["Access-Control-Allow-Origin"] = "*";
                    customHeaders.headers["Content-Type"] = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
                    customHeaders.headers["x-api-key"] = companiesApiHeader.x_api_key;
                    customHeaders.headers["company-id"] = companiesApiHeader.company_id;
                    customHeaders.headers["notification-email"] = companiesApiHeader.notification_email;
                }

                //Allow us to override the Interceptor configurtion, sending the headers at a http request.
                if(companiesApiHeader && cfg.url.indexOf("api-companies") != -1){
                    cfg.headers = customHeaders.headers;
                }else{
                    cfg.headers = angular.extend(customHeaders.headers, cfg.headers);
                }

                if(cfg.data && cfg.url.indexOf("api-companies") == -1){
                   cfg.data.contry_register = Config.ENV.API_COUNTRY_REGISTER;
                }

                if(accessToken){
                  cfg.headers.Authorization = 'Bearer ' + accessToken;
                }

                angular.forEach(cfg.data, function(value, key){
                    if(value == null) {
                        delete cfg.data[key];
                    }
                });

                return cfg;

            },
            responseError: function(response) {
                return $q.reject(response);
            }
        };

    });

angular.module('loadsAppWeb')
    .config(['$httpProvider',
        function ($httpProvider)
        {

            $httpProvider.interceptors.push('AuthInterceptor');

        }]);

'use strict';
/* Auth services
 * Login
 * Remember password
 * Signup
 * Update profile
 * Change user pic
 * Logout
 * Functions to resolve if user is authenticated or not
 * Get and set user data and token when user log in site
 */
angular.module('loadsAppWeb').service('Auth', function (Config, $q, $http, $localStorage, Upload, $state) {


        this.construct = function (){
          //this.url            = Config.ENV.API_ENDPOINT.slice(0,-4);
          this.url            = Config.ENV.AUTH_ENDPOINT;
          this.client_id      = Config.ENV.AUTH_CLIENT_ID;
          this.redirect_uri   = Config.ENV.AUTH_REDIRECT_URI;

          if(sessionStorage.getItem('_at') && sessionStorage.getItem('_rt')){
            this.token        = CryptoJS.AES.decrypt(
              sessionStorage.getItem('_at'),
              sessionStorage.getItem('_cv')
            ).toString(CryptoJS.enc.Utf8);
            this.refresh_token = CryptoJS.AES.decrypt(
              sessionStorage.getItem('_rt'),
              sessionStorage.getItem('_cv')
            ).toString(CryptoJS.enc.Utf8);
          }

        }
        this.loginByCredentials = function (params) {
            var q = $q.defer();

            $http.post(Config.ENV.API_ENDPOINT +'v1/' + 'security/auth', params)
                .then(function (response) {
                    q.resolve(response.data);
                })
                .catch(function (response) {
                    q.reject(false);
                });

            return q.promise;
        };
        this.rememberMyPassword = function (params)
        {
            var q = $q.defer();

            $http.post(Config.ENV.API_ENDPOINT +'v1/' + 'security/auth/rememberPassword', params)
                .then(function (response) {
                    q.resolve(response.data);
                })
                .catch(function (response) {
                    q.reject(false);
                });

            return q.promise;
        };
        this.doSignUp = function (params)
        {
            var q = $q.defer();

            $http.post(Config.ENV.API_ENDPOINT +'v1/' + 'user/createUser', params)
                .then(function (response) {
                    q.resolve(response.data);
                })
                .catch(function (response) {
                    q.reject(false);
                });

            return q.promise;
        };
        this.updateProfile = function (params)
        {
            var q = $q.defer();

            $http.post(Config.ENV.API_ENDPOINT +'v1/' + 'user/UpdateUser', params)
                .then(function (response) {
                    q.resolve(response.data);
                })
                .catch(function (response) {
                    q.reject(false);
                });

            return q.promise;
        };
        this.uploadMyPic = function(params)
        {
        // Defer
            var defer = $q.defer();
            // Url
            var url = Config.ENV.API_ENDPOINT +'v1/' + 'user/setMyPicImg';

            // Get
            Upload.upload({url: url, data: params})
              .then(function(response) {
                    // Success
                    //console.log(response);
                    if(response.data.status == 'ok' ){
                      defer.resolve(response.data.message);
                    }else{
                      defer.reject(false);
                    }
                })
                .catch(function(response) {
                    // Error

                    defer.reject(false);
                });

            return defer.promise;
        };
        this.logout = function () {
          $localStorage.$reset();
          sessionStorage.clear();
          location.replace(this.url + 'logout');
          //location.replace(sessionStorage.getItem('redirect_to'));
          //return true;
        };
        this.setSessionUser = function (data) {
            var q = $q.defer();
            if(angular.isDefined(data.userData)) {
                $localStorage.userData = data.userData;
                //sessionStorage.setItem('_tr',data.userData.token);
            }
            if(angular.isDefined(data.Info_perfil)) {
              var profile = data.Info_perfil.dataUser.user.profile_type.substr(4).toUpperCase()
              $localStorage.userProfile = (data.Info_perfil.userProfile)
                  ? data.Info_perfil.userProfile
                  : profile;
                $localStorage.userDataProfile = data.Info_perfil.dataUser;
            }
            if(angular.isDefined(data.capabilities)) {
                $localStorage.userCapabilities = data.capabilities;
            }
            if(angular.isDefined(data.Info_compa)) {
                $localStorage.userCompany = data.Info_compa;
            }
            q.resolve(true);
            return q.promise;
        }
        this.isAuthenticated = function () {
          /*if(angular.isDefined($localStorage.userData) && angular.isDefined($localStorage.userProfile) && angular.isDefined($localStorage.userCapabilities)){
            return true;
          }
          return false;*/
          if(!sessionStorage.getItem('_at') && !sessionStorage.getItem('_rt')) {
              //this.verifyAuthenticated();
            return false;
          }else{
            //this.verifyAuthenticated();
            return true;
          }


        }
        this.verifyAuthenticated = function (){

          if(!sessionStorage.getItem('_at') && !sessionStorage.getItem('_rt')){
            if(!sessionStorage.getItem('_cv')){
              this.getAuthorizationCode();
            }else{
              const urlParams = new URLSearchParams(window.location.search);
              const code      = urlParams.get('code');
              const state     = urlParams.get('state');
              //if(state !== sessionStorage.getItem('state')) return false;
              this.exchangeForAccessToken(code);
            }
          }else{
            //this.changeTokenVersion();
            return true;
          }
        }
        this.getAuthorizationCode = function (){
            let state,codeVerifier;
            if (!sessionStorage.getItem('state')){
              state         = this.randomString(40);
              codeVerifier  = this.randomString(128);
              sessionStorage.clear();
              sessionStorage.setItem('state', state);
              sessionStorage.setItem('_cv', codeVerifier);
            }else{
              state         = sessionStorage.getItem('state');
              codeVerifier  = sessionStorage.getItem('_cv');
            }
            sessionStorage.setItem("redirect_to", window.location.href);
            const digest = CryptoJS.SHA256(codeVerifier);
            const base64Digest = digest.toString(CryptoJS.enc.Base64);
            const codeChallenge = base64Digest
              .replace(/\+/g, "-")
              .replace(/\//g, "_")
              .replace(/=/g, "");

            const params = new URLSearchParams({
              client_id: this.client_id,
              redirect_uri: this.redirect_uri,
              response_type: 'code',
              scope: '*',
              state: state,
              code_challenge: codeChallenge,
              code_challenge_method: 'S256'
            });

            location.replace(this.url +'oauth/authorize?'+params.toString());
        }
        this.randomString = function (len, charSet) {
          charSet = charSet || 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
          let randomString = '';
          for (var i = 0; i < len; i++) {
            var randomPoz = Math.floor(Math.random() * charSet.length);
            randomString += charSet.substring(randomPoz,randomPoz+1);
          }
          return randomString;
        }
        this.exchangeForAccessToken = function (code){
          const codeVerifier = sessionStorage.getItem('_cv');
          const payload = {
            grant_type: 'authorization_code',
            client_id: this.client_id,
            redirect_uri: this.redirect_uri,
            code_verifier: codeVerifier,
            code: code
          };
          return this.createToken(payload);
        }
        /*this.refreshToken = function (){
          let payload = {
            grant_type: 'refresh_token',
            refresh_token: sessionStorage.getItem('_rt'),
            client_id: this.client_id,
            scope: '*',
          };
          return this.createToken(payload);
        }*/
        this.createToken = function (payload){
          let that = this;
          return $http.post(this.url + 'oauth/token',payload).then(function (resp){
            that.token          = resp.data.access_token;
            that.refresh_token  = resp.data.refresh_token;
            sessionStorage.removeItem('state');
            sessionStorage.setItem('_to', resp.data.access_token);
            sessionStorage.setItem('_at', CryptoJS.AES.encrypt(resp.data.access_token, payload.code_verifier).toString());
            sessionStorage.setItem('_rt', CryptoJS.AES.encrypt(resp.data.refresh_token, payload.code_verifier).toString());

            var redirectTo = sessionStorage.getItem('redirect_to');
            if(redirectTo.indexOf('/#/') > -1){
              location.replace(redirectTo);
            }else{
              that.changeTokenVersion();
              //location.replace('/#/');
            }
            //sessionStorage.removeItem('redirect_to');
            //that.changeTokenVersion();
          }).catch(function (error){
            console.log(error);
            sessionStorage.clear();
          });
        }
        this.changeTokenVersion = function (){
          var headers = { headers : {} }; var that = this;
          if (!sessionStorage.getItem('_tr') ){
            let api = Config.ENV.API_ENDPOINT +'v2/token-exchange';
            headers.headers["Authorization"] = 'Bearer ' + sessionStorage.getItem('_to');
            return $http.post(api, null, headers).then(function (resp) {
              //console.log("I going to perform change token v2 by the token old");
              sessionStorage.setItem('_tr',resp.data.access_token);
              that.authLoginSet();
            });

          }
          //location.replace('/#/');
        }
        this.parseJwt = function (token) {
          var base64Url = token.split('.')[1];
          var base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
          var jsonPayload = decodeURIComponent(atob(base64).split('').map(function(c) {
            return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
          }).join(''));

          return JSON.parse(jsonPayload);
        };

  this.getUserData = function ()
        {
            if(angular.isDefined($localStorage.userData)){
                return $localStorage.userData;
            }

            return false;
        }

        this.getUserDataProfile = function ()
        {
            if(angular.isDefined($localStorage.userDataProfile)){
                return $localStorage.userDataProfile;
            }

            return false;
        }

        this.getUserProfile = function ()
        {
            if(angular.isDefined($localStorage.userProfile)){
                return $localStorage.userProfile;
            }

            return false;
        }

        this.getUserInfoCompany = function ()
        {
            if(angular.isDefined($localStorage.userCompany)){
                return $localStorage.userCompany;
            }

            return false;
        }

        this.getUserToken = function ()
        {
            if(angular.isDefined($localStorage.token)){
                return $localStorage.token;
            }

            return false;
        }

        this.setAutomaticAssign = function(newValue)
        {
            var userData = this.getUserData();

            if(userData && (newValue === 1 || newValue === 0)){
                if(angular.isDefined(userData.automatic_asign) && angular.isDefined($localStorage.userData)){
                    $localStorage.userData.automatic_asign = newValue;

                    return true;
                }
            }

            return false;
        }
        this.getUserDocumentation = function (resource,resource_id) {
            let api = Config.ENV.API_ENDPOINT +'v1/' + resource +'/'+ resource_id +'/requirements';
            return $http.get(api, null);
        }
        this.getInfoUser = function (){
          let api = Config.ENV.API_ENDPOINT +'v1/user/me';
          return $http.get(api, null);
        }

        this.authLoginSet = function (){
            var that = this;
            this.getInfoUser().then(function (resp){
                that.setSessionUser(resp.data).then(function (){
                  if (resp.data.userData.user_status == 1 ){
                    //return $state.go('private.home');
                    return location.replace('/#/home');
                  }
                  return location.replace('/#/profile');
                  //return $state.go('private.my_profile');
                });
            });
        };

        this.construct();

    });

(function() {
  'use strict';

  /* Sign up controller
   * Prepare form depending of profile choosed
   * Validate form
   * Send data to API and show successful message or any wrong*/

  angular
    .module('loadsAppWeb')
    .controller('SignUpController', SignUpController);

  /** @ngInject */
  function SignUpController($filter, toastr, $state, Config, Auth, $window) {
	var vm = this;

    /* Function executed at start
     * Prepare the steps of the form
     * set form vars and configuration of profile select
     * Configuration of location fields
     */
	vm.initialize = function() {

		vm.formsToValidate = [{form: 'basic_info', validated: false, subtitle: ''},
							  {form: 'company_info', validated: false, subtitle: '2'}];
							  //{form: 'insurance_info', validated: false, subtitle: '3'}];
		vm.validateForm = vm.formsToValidate[0].form;
		vm.validateFormIndex = 0;
		vm.subtitleForm = vm.formsToValidate[0].subtitle;

        vm.companyCitySelect = null;
        vm.companyStateSelect = null;
        vm.companyCountrySelect = null;

		vm.newUser = {};
		vm.newUser.profile = null;

		//contact information
		vm.newUser.user_first_name = null;
		vm.newUser.user_last_name = null;
		vm.newUser.document_type = null;
        vm.newUser.document_number = null;
        vm.newUser.user_phone = null;
		vm.newUser.user_email = null;
		vm.newUser.user_password = null;

		//company information
		vm.newUser.company_name = null;
		vm.newUser.city_company = null;
		vm.newUser.state_company = null;
        vm.newUser.country_company = null;
		vm.newUser.phone_company = null;
		vm.newUser.email_company = null;
		vm.newUser.address_company = null;
		vm.newUser.mc_number = null;
		vm.newUser.dot_number = null;
		vm.newUser.ein_number = null;
		vm.newUser.corp_number = null;
        vm.newUser.corp_number = null;
        vm.newUser.tyc = {name: 'tyc', checked: false};

		//insurance information
		vm.newUser.bond_insurance_num_policy = null;
		vm.newUser.bond_insurance_comp = null;
		vm.newUser.bond_insurance_num = null;
        vm.newUser.name_bank = null;
        vm.newUser.number_account_bank = null;

		vm.profileOptions = [
							 {id: null, name: $filter('translate')('form:default:select:null_option')},
							 {id: 'CARRIER', name: $filter('translate')('header:profile:carrier:title')},
							 {id: 'GENERADOR_CARGA', name: $filter('translate')('header:profile:generador_carga:title')},
                             {id: 'OWNER', name: $filter('translate')('header:profile:owner:title')}
							];

        vm.shipperDocTypeOptions = [
                             {id: null, name: $filter('translate')('form:default:select:null_option')},
                             {id: 'rfc', name: $filter('translate')('sign_up:form:document_number:rfc')}
                            ];

        vm.notShipperDocTypeOptions = [
                             {id: null, name: $filter('translate')('form:default:select:null_option')},
                             {id: 'rfc', name: $filter('translate')('sign_up:form:document_number:rfc')},
                             {id: 'ps', name: $filter('translate')('sign_up:form:document_number:passport')},
                             {id: 'ce', name: $filter('translate')('sign_up:form:document_number:ce')},
                             {id: 'curp', name: $filter('translate')('sign_up:form:document_number:curp')}
                            ];

        vm.optionsGoogleInputCity = {
            types: ['(cities)']
        };
	};

    /* Catch up info about country, state and city selected */
    vm.autoCompleteStateCountry = function() {
        if(angular.isDefined(vm.companyCitySelect.address_components)) {
            for(var i in vm.companyCitySelect.address_components){
                if(vm.companyCitySelect.address_components[i].types.indexOf('administrative_area_level_1') != -1){
                    vm.companyStateSelect = vm.companyCitySelect.address_components[i].long_name;
                    //console.log(vm.companyStateSelect);
                }

                if(vm.companyCitySelect.address_components[i].types.indexOf('country') != -1){
                    vm.companyCountrySelect = vm.companyCitySelect.address_components[i].long_name;
                    //console.log(vm.companyCountrySelect);
                }
            }
        }
    };

    /* Send data to API and do sign up process */
	vm.doSignUp = function() {
        var user_password_decode = vm.newUser.user_password.toString();
		vm.newUser.user_password = CryptoJS.SHA1(vm.newUser.user_password.toString()).toString();

      vm.newUser.city_company = (angular.isDefined(vm.companyCitySelect.name) ? vm.companyCitySelect.name : vm.companyCitySelect.formatted_address);
        vm.newUser.state_company = ((typeof vm.companyStateSelect == "string" && vm.companyStateSelect != "") ? vm.companyStateSelect : (angular.isDefined(vm.companyStateSelect.name) ? vm.companyStateSelect.name : (angular.isDefined(vm.companyStateSelect.formatted_address) ? vm.companyStateSelect.formatted_address : '')));
        vm.newUser.country_company = ((typeof vm.companyCountrySelect == "string" && vm.companyCountrySelect != "") ? vm.companyCountrySelect : (angular.isDefined(vm.companyCountrySelect.name) ? vm.companyCountrySelect.name : (angular.isDefined(vm.companyCountrySelect.formatted_address) ? vm.companyCountrySelect.formatted_address : '')));

        Auth.doSignUp(vm.newUser)
                .then(function(response) {
                	if(angular.isDefined(response.status) && response.status != 'error'){
                        toastr.success($filter('translate')('sign_up:form:success'));
                        //$state.go('public.login');
                        $window.location.href = Config.ENV.WEB_PAGE_LOADSMX;
                    }else{
                        vm.newUser.user_password = user_password_decode;

                        if(response.message == "user_exist"){
                            toastr.error($filter('translate')('sign_up:form:error:user_exists'));
                        }else{
                            toastr.error($filter('translate')('sign_up:form:error'));
                        }
                    }
                })
                .catch(function(error) {
                    vm.newUser.user_password = user_password_decode;
                    toastr.error($filter('translate')('sign_up:form:error'));
                });
	};

    /* Validate all step of form and allow to send the data to above function to send data to API */
	vm.validateSignup = function(userForm) {
		// Validate form.
        if (userForm.$invalid) {
            // If there was an error for required fields.
            if (userForm.$error.required) {
                toastr.error($filter('translate')('sign_up:form:required:fields:error'));
            } else {
                toastr.error($filter('translate')('sign_up:form:required:fields:invalid'));
            }
            return;
        }

        //Validations of step 2
        if(userForm.$name == 'signupFormName2'){
            if(vm.newUser.profile == 'CARRIER' || vm.newUser.profile == 'OWNER'){
                /*if(!vm.newUser.mc_number && !vm.newUser.dot_number){
                    toastr.error($filter('translate')('sign_up:form:required:fields:error'));
                    return;
                }*/

                if(!vm.newUser.ein_number && !vm.newUser.corp_number){
                    toastr.error($filter('translate')('sign_up:form:required:fields:error'));
                    return;
                }
            }

            if(vm.newUser.profile == 'GENERADOR_CARGA'){
                /*if(!vm.newUser.ein_number && !vm.newUser.corp_number){
                    toastr.error($filter('translate')('sign_up:form:required:fields:error'));
                    return;
                }*/
            }

            if(!vm.newUser.tyc.checked){
                toastr.error($filter('translate')('sign_up:form:required:fields:error_tyc'));
                return;
            }
        }

        //Validations of step 3
        if(userForm.$name == 'signupFormName3'){
            if(vm.newUser.profile == 'CARRIER' || vm.newUser.profile == 'OWNER'){
                if(!vm.newUser.bond_insurance_num_policy || !vm.newUser.bond_insurance_comp || !vm.newUser.bond_insurance_num){
                    toastr.error($filter('translate')('sign_up:form:required:fields:error'));
                    return;
                }
            }
        }

        vm.formsToValidate[vm.validateFormIndex].validated = true;

        var moreValidateForm = true
        , indexform = 0;

        //Cycle allow continuing to next step or do signup
        while(moreValidateForm){
        	if(indexform <= vm.validateFormIndex){
        		indexform++;
        	}else{
        		if(angular.isDefined(vm.formsToValidate[indexform])){
                    if(vm.newUser.profile == 'GENERADOR_CARGA' && indexform == 2){
                        vm.doSignUp();
                    }else{
                        vm.validateForm = vm.formsToValidate[indexform].form;
                        vm.validateFormIndex = indexform;
                        vm.subtitleForm = vm.formsToValidate[indexform].subtitle;
                    }
        		}else{
        			vm.doSignUp();
        		}
        		moreValidateForm = false;
        	}
        }
	};

    // Come back in step of form
    vm.comeBackForm = function () {
        if(vm.validateFormIndex > 0){
            if(angular.isDefined(vm.formsToValidate[vm.validateFormIndex - 1])){
                vm.validateFormIndex = vm.validateFormIndex - 1;
                vm.validateForm = vm.formsToValidate[vm.validateFormIndex].form;
                vm.subtitleForm = vm.formsToValidate[vm.validateFormIndex].subtitle;
            }
        }
    };

    // Function to redirect to login page
    vm.goToLogin = function () {
        $state.go('public.login');
    };

    //Call of function which is executed at start
	vm.initialize();
  }
})();

(function() {
  'use strict';

  /* Login controller
   * form validation
   * Send data to API and if response is right it'll let the user continue*/

  angular
    .module('loadsAppWeb')
    .controller('LoginController', LoginController);

  /** @ngInject */
  function LoginController($state, toastr, $filter, Config, Auth) {
	var vm = this;

    // Validate form and send data to API
	vm.doLogin = function (loginFormName)
    {
        // Valid form
        if (loginFormName.$invalid) {
            // Email
            if (!loginFormName.email.$valid && loginFormName.email.$error.required) {
                toastr.error($filter('translate')('login:email:error'));
                return;
            }

            if (!loginFormName.email.$valid && loginFormName.email.$error.email) {
                toastr.error($filter('translate')('login:email:error'));
                return;
            }

            // Password
            if (!loginFormName.password.$valid && loginFormName.password.$error.required) {
                toastr.error($filter('translate')('login:password:error'));
                return;
            }

            toastr.error($filter('translate')('login:invalid:error'));

            return;
        }

        if(!vm.tyc.checked){
            toastr.error($filter('translate')('sign_up:form:required:fields:error_tyc'));
            return;
        }

        var params = {};
        params.username = vm.credentials.email;
        params.password = CryptoJS.SHA1(vm.credentials.password.toString()).toString(); //Before to send, we excript the password in SHA! encription
        // Service Auth (app/auth/services/auth-serv)
        Auth.loginByCredentials(params).then(function(response) {
            if(angular.isDefined(response.userData) && angular.isDefined(response.Info_perfil)){
                Auth.setSessionUser(response).then(function() {
                  if (response.userData.user_status == 1 ){
                    return $state.go('private.home');
                  }
                  return $state.go('private.my_profile');
                });
            }else{
                if(response.message == "user_disabled"){
                    toastr.error($filter('translate')('login:error:user_disabled'));
                }else{
                    toastr.error($filter('translate')('login:credentials:invalid'));
                }
            }
        }).catch(function(error) {
          //console.log(error);
        });


    };

    // Function executed at start
	vm.initialize = function() {

        vm.tyc = {name: 'tyc', checked: false};

        // Credentials
        vm.credentials = {
            email: null,
            password: null
        };
    };

    vm.validaEmailFormat = function(emailValue){
        var emailRegex = /^[-\w.%+]{1,64}@(?:[A-Z0-9-]{1,63}\.){1,125}[A-Z]{2,63}$/i;
        return emailRegex.test(emailValue);
    }

    vm.initialize();
  }
})();

(function() {
  'use strict';

  /* Forgot password controller
   * form validation
   * Send data to API and receiving a response*/

  angular
    .module('loadsAppWeb')
    .controller('ForgotPasswordController', ForgotPasswordController);

  /** @ngInject */
  function ForgotPasswordController($state, toastr, $filter, Config, Auth) {
	var vm = this;

    // Validate form and send data to API
	vm.sendRequest = function (forgotPasswordFormName)
    {
        // Valid form
        if (forgotPasswordFormName.$invalid) {

            // Email
            if (!forgotPasswordFormName.email.$valid && forgotPasswordFormName.email.$error.required) {
                toastr.error($filter('translate')('forgot_password:email:error'));
                return;
            }

            toastr.error($filter('translate')('forgot_password:invalid:error'));

            return;
        }

        var params = {};
        params.email = vm.data.email;

        // Service Auth (app/auth/services/auth-serv)
        Auth.rememberMyPassword(params)
                .then(function(response) {
                    if(angular.isDefined(response.status) && response.status == "ok"){
                        toastr.success($filter('translate')('forgot_password:request:success'));
                        $state.go('private.home');
                    }else{
                        toastr.error($filter('translate')('forgot_password:data:invalid'));
                    }
                })
                .catch(function(error) {
                    //console.log(error);
                });

    	
    };

	vm.initialize = function() {

        // Forgot Password data
        vm.data = {
            email: null
        };
    };

    vm.initialize();
  }
})();

(function() {
  'use strict';
  // load every angular module or plugin of the site
  angular
    .module('loadsAppWeb')
    .store('userStore', function(Auth) {
      return {
        profile: null,
        handlers: {
          'fetchProfile': 'fetchProfile'
        },
        fetchProfile: function(payload){
          var vm = this;

          Auth.getInfoUser().then(function(response){
            console.log(response);
            vm.profile = response.data.userData;
            vm.emitChange();
          }).catch(function(error){

          });
        },
        exports: {
          get profile(){
            return this.profile;
          },
        }
      };
    });

})();


(function() {
  'use strict';
  // load every angular module or plugin of the site
  angular
    .module('loadsAppWeb')
    .store('loadsStore', function(Loads) {
      return {
        lastFilters: {},
        loads : {
          current_page: 1,
          results: [],
          total_pages: 0,
          total_results_system: 0
        },
        currentLoad: null,
        handlers: {
          'fetchLoads': 'fetchLoads'
        },
        fetchLoads: function(payload){
          var vm = this;
          if(!payload){
            payload = this.lastFilters;
          }
          Loads.getByUserRol(payload).then(function(response){
            vm.lastFilters = payload;
            vm.loads = response;
            vm.emitChange();
          }).catch(function (error) {
            console.error(error);
          });
        },
        exports: {
          getLastFilters: function () {
            return this.lastFilters;
          },
          get lastFilters() {
            return this.lastFilters;
          },
          get loads(){
            return this.loads;
          },
          get currentLoad() {
            return this.currentLoad;
          },
        }
      };
  });

})();



(function() {
  'use strict';
  // load every angular module or plugin of the site
  angular.module('loadsAppWeb').store('loadLogStore', function(Loads) {
      return {
        lastFilters: {},
        loads : {
          current_page: 1,
          results: [],
          total_pages: 0,
          total_results_system: 0
        },
        currentLoad: null,
        handlers: {
          'fetchLoads': 'fetchLoads'
        },
        fetchLoads: function(payload){
          var vm = this;
          if(!payload){
            payload = this.lastFilters;
          }
          Loads.getLoadsHistoryByUserRol(payload).then(function(response){
            vm.lastFilters = payload;
            vm.loads = response;
            vm.emitChange();
          }).catch(function (error) {
            console.error(error);
          });
        },
        exports: {
          getLastFilters: function () {
            return this.lastFilters;
          },
          get lastFilters() {
            return this.lastFilters;
          },
          get loads(){
            return this.loads;
          },
          get currentLoad() {
            return this.currentLoad;
          },
        }
      };
    });

})();



(function() {
  'use strict';

  angular
    .module('loadsAppWeb')
    .run(initialize);

  /** @ngInject */
  function runBlock($log) {

    $log.debug('runBlock end');
  }

  function initialize(amMoment, $translate, PermPermissionStore, PermRoleStore, Auth) {
    $translate.refresh();
    if(Auth.verifyAuthenticated() && !sessionStorage.getItem('_tr')){
      Auth.changeTokenVersion();
    }
    //Auth.verifyAuthenticated();
    /**
     * Moment
     * Configuration of moment JS library (this library allows to show date in different formats)
     */
    moment.locale('en', {
        relativeTime: {
            future: "%s left",
            past: "%s ago",
            s: "seconds",
            m: "1 minute",
            mm: "%d minutes",
            h: "1 hour",
            hh: "%d hours",
            d: "1 day",
            dd: "%d days",
            M: "1 month",
            MM: "%d months",
            y: "1 year",
            yy: "%d years"
        }
    });
    moment.locale('es', {
        relativeTime: {
            future: "%s adelante",
            past: "%s atras",
            s: "segundos",
            m: "1 minuto",
            mm: "%d minutos",
            h: "1 hora",
            hh: "%d horas",
            d: "1 día",
            dd: "%d días",
            M: "1 mes",
            MM: "%d meses",
            y: "1 año",
            yy: "%d años"
        }
    });

    /* Get current language of site and set it in moment JS's configuration */
  	var currentLang = $translate.proposedLanguage() || $translate.use();
    amMoment.changeLocale(currentLang);

    /**
     * Permissions
     * This function compares current logged user role with permission and returns a logical value
     */
    PermRoleStore
      .defineManyRoles({
        'CARRIER':  function (rol) { return Auth.getUserProfile() == 'CARRIER'; },
        'GENERADOR_CARGA':  function (rol) { return Auth.getUserProfile() == 'GENERADOR_CARGA'; },
        'DRIVER':  function (rol) { return Auth.getUserProfile() == 'DRIVER'; },
        'OWNER':  function (rol) { return Auth.getUserProfile() == 'OWNER'; }
      });
  }

})();

(function() {
  'use strict';

  angular
    .module('loadsAppWeb')
    .config(routerConfig);

  /** @ngInject */
  function routerConfig($stateProvider, $urlRouterProvider) {
    /*$stateProvider
      .state('home', {
        url: '/',
        templateUrl: 'app/main/main.html',
        controller: 'MainController',
        controllerAs: 'main'
      });*/

    /* Default route just in the case gets a wrong url */
    $urlRouterProvider.otherwise('/home');

    /**
     * Routes
     * List of site routes
     */
    $stateProvider
        .state('private', { // This is the container for private pages (User has to be logged)
                url: '',
                abstract: true,
                cache: false,
                views: {
                    'app': {
                        templateUrl: 'app/main/templates/layouts/private.html',
                        controller: 'PrivateController',
                        controllerAs: 'private'
                    }
                },
                resolve: {
                    loginRequired: loginRequired //This is a rule that evaluates if the user is logged or not; if this isn't logged, it will return you to login page
                }
            }
        )
        .state('private.home', { // Home page route
            url: '/home',
            cache: false,
            views: {
                'container@private': {
                    templateUrl: 'app/main/templates/home.html',
                    controller: 'HomeController',
                    controllerAs: 'home'
                }
            }
        })
        .state('private.metrics', { // Loads page route
            url: '/metrics',
            cache: false,
            views: {
                'container@private': {
                    templateUrl: 'app/metrics/templates/statistics.html',
                    controller: 'LoadsController',
                    controllerAs: 'metrics'
                }
            }
        })
        .state('private.loads', { // Loads page route
            url: '/loads',
            cache: false,
            views: {
                'container@private': {
                    templateUrl: 'app/loads/templates/loads.html',
                    controller: 'LoadsController',
                    controllerAs: 'loads'
                }
            }
        })
        .state('private.loads.params', { // Loads page route with searching params
            url: '/:from/:to/:pickup/:delivery/:price_min/:price_max/:length/:size/:weight/:load_type/:load_id/:shipper/:review/:deadhead',
            cache: false,
            params: {
                from: null,
                to: null,
                pickup: null,
                delivery: null,
                price_min: null,
                price_max: null,
                length: null,
                size: null,
                weight: null,
                load_type: null,
                load_id: null,
                shipper: null,
                review: null,
                deadhead: null
            },
            views: {
                'container@private': {
                    templateUrl: 'app/loads/templates/loads.html',
                    controller: 'LoadsController',
                    controllerAs: 'loads'
                }
            }
        })
        .state('private.loads.details', { // Load details page route
            url: '/details',
            cache: false,
            params: {
                id: null
            },
            views: {
                'container@private': {
                    templateUrl: 'app/loads/templates/details.html',
                    controller: 'LoadsDetailsController',
                    controllerAs: 'loadsdetails'
                }
            }
        })
      .state('private.loads.stops', { // Load details page route
        url: '/stops',
        cache: false,
        params: {
          id: null
        },
        views: {
          'container@private': {
            templateUrl: 'app/loads/templates/stops.html',
            controller: 'StopController',
            controllerAs: 'stops'
          }
        }
      })
        .state('private.loads.add', { // Load creation page route
            url: '/add',
            cache: false,
            views: {
                'container@private': {
                    templateUrl: 'app/loads/templates/add.html',
                    controller: 'LoadsAddController',
                    controllerAs: 'loadsadd'
                }
            },
            data: {
              permissions: {
                only: ['GENERADOR_CARGA'],
                redirectTo: {
                    state: 'private.home'
                }
              }
            }
        })
      .state('private.loads.register', {
        url: '/v2/register',
        cache: false,
        views: {
          'container@private': {
            templateUrl: 'app/loads/v2/templates/load.html',
            controller: 'LoadController'
          }
        },
        data: {
          permissions: {
            only: ['GENERADOR_CARGA'],
            redirectTo: {
              state: 'private.home'
            }
          }
        }
      })
        .state('private.loads.edit', { // Load edition page route
            url: '/edit',
            cache: false,
            params: {
                id: null
            },
            views: {
                'container@private': {
                    templateUrl: 'app/loads/templates/edit.html',
                    controller: 'LoadsEditController',
                    controllerAs: 'loadsedit'
                }
            },
            data: {
              permissions: {
                only: ['GENERADOR_CARGA'],
                redirectTo: {
                    state: 'private.home'
                }
              }
            }
        })
        .state('private.loadslog', { // Loads log page route
            url: '/loads_log',
            cache: false,
            views: {
                'container@private': {
                    templateUrl: 'app/loads/templates/loads-log.html',
                    controller: 'LoadsLogController',
                    controllerAs: 'loadslog'
                }
            }
        })
        .state('private.carriers', { // Carrier page route
            url: '/carriers',
            cache: false,
            views: {
                'container@private': {
                    templateUrl: 'app/carriers/templates/carriers.html',
                    controller: 'CarriersController',
                    controllerAs: 'carriers'
                }
            },
            data: {
              permissions: {
                only: ['GENERADOR_CARGA'],
                redirectTo: {
                    state: 'private.home'
                }
              }
            }
        })
        .state('private.carriers.params', { // Carrier page with searching params
            url: '/:company/:trailer_type/:len/:wei/:size/:skils_truck/:reviews',
            cache: false,
            params: {
                company: null,
                trailer_type: null,
                len: null,
                wei: null,
                size: null,
                skils_truck: null,
                reviews: null
            },
            views: {
                'container@private': {
                    templateUrl: 'app/carriers/templates/carriers.html',
                    controller: 'CarriersController',
                    controllerAs: 'carriers'
                }
            },
            data: {
              permissions: {
                only: ['GENERADOR_CARGA'],
                redirectTo: {
                    state: 'private.home'
                }
              }
            }
        })
        .state('private.carriers.details', { // Carrier details page route
            url: '/details',
            cache: false,
            params: {
                id: null,
                load_id: null
            },
            views: {
                'container@private': {
                    templateUrl: 'app/carriers/templates/details.html',
                    controller: 'CarriersDetailsController',
                    controllerAs: 'carriersdetails'
                }
            }
        })
        .state('private.trucks', { // Trucks page route
            url: '/trucks',
            cache: false,
            views: {
                'container@private': {
                    templateUrl: 'app/trucks/templates/trucks.html',
                    controller: 'TrucksController',
                    controllerAs: 'trucks'
                }
            },
            data: {
              permissions: {
                only: ['CARRIER','OWNER'],
                redirectTo: {
                    state: 'private.home'
                }
              }
            }
        })
        .state('private.trucks.params', { // Loads page route with searching params
            url: '/:truck_id/:dummy1/:dummy2',
            cache: false,
            params: {
                truck_id: null,
                dummy1: null,
                dummy2: null
            },
            views: {
                'container@private': {
                    templateUrl: 'app/trucks/templates/trucks.html',
                    controller: 'TrucksController',
                    controllerAs: 'trucks'
                }
            },
            data: {
              permissions: {
                only: ['CARRIER','OWNER'],
                redirectTo: {
                    state: 'private.home'
                }
              }
            }
        })
        .state('private.trucks.loads', { // Loads by truck page route
            url: '/truck_loads/:id',
            cache: false,
            params: {
                id: null
            },
            views: {
                'container@private': {
                    templateUrl: 'app/trucks/templates/truck_loads.html',
                    controller: 'TrucksLoadsController',
                    controllerAs: 'truckloads'
                }
            },
            data: {
              permissions: {
                only: ['CARRIER','OWNER'],
                redirectTo: {
                    state: 'private.home'
                }
              }
            }
        })
        .state('private.trucks.add', { // Truck creation page route
            url: '/add',
            cache: false,
            views: {
                'container@private': {
                    templateUrl: 'app/trucks/templates/add.html',
                    controller: 'TrucksAddController',
                    controllerAs: 'trucksadd'
                }
            },
            data: {
              permissions: {
                only: ['CARRIER','OWNER'],
                redirectTo: {
                    state: 'private.home'
                }
              }
            }
        })
        .state('private.trucks.edit', { // Truck edition page route
            url: '/edit',
            cache: false,
            params: {
                id: null,
                tab: 1
            },
            views: {
                'container@private': {
                    templateUrl: 'app/trucks/templates/edit.html',
                    controller: 'TrucksEditController',
                    controllerAs: 'trucksedit'
                }
            },
            data: {
              permissions: {
                only: ['CARRIER','OWNER'],
                redirectTo: {
                    state: 'private.home'
                }
              }
            }
        })
        .state('private.drivers', { // Driver page route
            url: '/drivers',
            cache: false,
            views: {
                'container@private': {
                    templateUrl: 'app/drivers/templates/drivers.html',
                    controller: 'DriversController',
                    controllerAs: 'drivers'
                }
            },
            data: {
              permissions: {
                only: ['CARRIER','OWNER'],
                redirectTo: {
                    state: 'private.home'
                }
              }
            }
        })
        .state('private.drivers.params', { // Loads page route with searching params
            url: '/:driver_name/:dummy1/:dummy2',
            cache: false,
            params: {
                driver_name: null,
                dummy1: null,
                dummy2: null
            },
            views: {
                'container@private': {
                    templateUrl: 'app/drivers/templates/drivers.html',
                    controller: 'DriversController',
                    controllerAs: 'drivers'
                }
            }
        })
        .state('private.drivers.add', { // Driver creation page route
            url: '/add',
            cache: false,
            views: {
                'container@private': {
                    templateUrl: 'app/drivers/templates/add.html',
                    controller: 'DriversAddController',
                    controllerAs: 'driversadd'
                }
            },
            data: {
              permissions: {
                only: ['CARRIER'],
                redirectTo: {
                    state: 'private.home'
                }
              }
            }
        })
        .state('private.drivers.edit', { // Drivers edition page route
            url: '/edit',
            cache: false,
            params: {
                id: null,
                tab: 1
            },
            views: {
                'container@private': {
                    templateUrl: 'app/drivers/templates/edit.html',
                    controller: 'DriversEditController',
                    controllerAs: 'driversedit'
                }
            },
            data: {
              permissions: {
                only: ['CARRIER','OWNER'],
                redirectTo: {
                    state: 'private.home'
                }
              }
            }
        })
        .state('private.trailers', { // Trucks page route
            url: '/trailers',
            cache: false,
            views: {
                'container@private': {
                    templateUrl: 'app/trailers/templates/trailers.html',
                    controller: 'TrailersController',
                    controllerAs: 'trailers'
                }
            },
            data: {
              permissions: {
                only: ['CARRIER','OWNER'],
                redirectTo: {
                    state: 'private.home'
                }
              }
            }
        })
        .state('private.trailers.params', { // Trailers with params
            url: '/:trailer_id/:dummy1/:dummy2',
            cache: false,
            params: {
                trailer_id: null,
                dummy1: null,
                dummy2: null
            },
            views: {
                'container@private': {
                    templateUrl: 'app/trailers/templates/trailers.html',
                    controller: 'TrailersController',
                    controllerAs: 'trailers'
                }
            },
            data: {
              permissions: {
                only: ['CARRIER','OWNER'],
                redirectTo: {
                    state: 'private.home'
                }
              }
            }
        })
        .state('private.trailers.add', { // Truck creation page route
            url: '/add',
            cache: false,
            views: {
                'container@private': {
                    templateUrl: 'app/trailers/templates/add.html',
                    controller: 'TrailersAddController',
                    controllerAs: 'trailersadd'
                }
            },
            data: {
              permissions: {
                only: ['CARRIER','OWNER'],
                redirectTo: {
                    state: 'private.home'
                }
              }
            }
        })
        .state('private.trailers.edit', { // Truck edition page route
            url: '/edit',
            cache: false,
            params: {
                id: null
            },
            views: {
                'container@private': {
                    templateUrl: 'app/trailers/templates/edit.html',
                    controller: 'TrailersEditController',
                    controllerAs: 'trailersedit'
                }
            },
            data: {
              permissions: {
                only: ['CARRIER','OWNER'],
                redirectTo: {
                    state: 'private.home'
                }
              }
            }
        })
        .state('private.fast_pay', { // Fast pay route
            url: '/fast_pay',
            cache: false,
            views: {
                'container@private': {
                    templateUrl: 'app/fastpay/templates/fast-pay.html',
                    controller: 'FastPayController',
                    controllerAs: 'fastpay'
                }
            },
            data: {
              permissions: {
                only: ['CARRIER','OWNER'],
                redirectTo: {
                    state: 'private.home'
                }
              }
            }
        })
        .state('private.interest_points', { // Interesting points page route
            url: '/points-of-interest',
            cache: false,
            views: {
                'container@private': {
                    templateUrl: 'app/interestpoint/templates/interest-points.html',
                    controller: 'InterestPointsController',
                    controllerAs: 'interestpoints'
                }
            },
            data: {
              permissions: {
                only: ['CARRIER', 'DRIVER', 'OWNER'],
                redirectTo: {
                    state: 'private.home'
                }
              }
            }
        })
        .state('private.help', { // Help page route
            url: '/help_about',
            cache: false,
            views: {
                'container@private': {
                    templateUrl: 'app/main/templates/help.html',
                    controller: 'HelpController',
                    controllerAs: 'help'
                }
            }
        })
        .state('private.my_profile', { // Profile page route
            url: '/profile',
            cache: false,
            views: {
                'container@private': {
                    templateUrl: 'app/profile/templates/profile.html',
                    controller: 'ProfileController',
                    controllerAs: 'profile'
                }
            }
        })
        .state('private.notifications', { // Notification page route
            url: '/notifications',
            cache: false,
            views: {
                'container@private': {
                    templateUrl: 'app/main/templates/notifications-page.html',
                    controller: 'NotificationsPageController',
                    controllerAs: 'notificationpage'
                }
            }
        })
        .state('private.invite_join', { // Invite to join page route
            url: '/invite_to_join',
            cache: false,
            views: {
                'container@private': {
                    templateUrl: 'app/main/templates/invite-join-page.html',
                    controller: 'InviteJoinPageController',
                    controllerAs: 'invitejoinpage'
                }
            }
        })
        .state('private.notification_settings', { // Notification settings page route
            url: '/notification_settings',
            cache: false,
            views: {
                'container@private': {
                    templateUrl: 'app/main/templates/notification-settings-page.html',
                    controller: 'NotificationSettingsPageController',
                    controllerAs: 'notificationsettingspage'
                }
            }
        });

    /**
     * Skip if logged in
     * this function verifies if the user is not logged and it let user continue
     */
    function skipIfLoggedIn($q, $location, Auth)
    {
        var deferred = $q.defer();
        if (Auth.isAuthenticated()) {
            $location.path('/home');
        } else {
            deferred.resolve();
        }
        return deferred.promise;
    }

    /**
     * Login required
     * this function verifies if the user is logged and it let user continue
     */
    function loginRequired($q, $location, Auth)
    {
        var deferred = $q.defer();
        if (Auth.isAuthenticated()) {
            deferred.resolve();
        } else {
            deferred.reject();
            //$location.path('/login');
        }
        return deferred.promise;
    }

    /*function viewShipperProfile($q, $location, Auth)
    {
        var deferred = $q.defer();
        var profile = Auth.getUserProfile();
        if (profile == 'GENERADOR_CARGA') {
            deferred.resolve();
        } else {
            $location.path('/login');
        }
        return deferred.promise;
    }

    function viewCarrierProfile($q, $location, Auth)
    {
        var deferred = $q.defer();
        var profile = Auth.getUserProfile();
        if (profile == 'CARRIER') {
            deferred.resolve();
        } else {
            $location.path('/login');
        }
        return deferred.promise;
    }*/
  }

})();

/* global malarkey:false, moment:false */
(function() {
  'use strict';
  // This page loads all constants used in the site
  angular
    .module('loadsAppWeb')
    .constant('malarkey', malarkey)
    .constant('moment', moment)
    .constant('Config', {"ENV":{"API_ENDPOINT":"https://api.traxporta.com/api/","AUTH_CLIENT_ID":"930bc685-ab27-4272-a0dc-378da5f3a51c","AUTH_ENDPOINT":"https://auth.traxporta.com/","AUTH_REDIRECT_URI":"","PREFERRED_LANGUAGE":"es","FALLBACK_LANGUAGE":"es","INVITE_JOIN_MAIL_BODY_URL":"","GOOGLE_MAPS_KEY":"AIzaSyCOr68rWTWKlLf2Ipxt4lnmlvTJ0hVKGvE","STORAGE_ENDPOINT":"https://api-static.traxporta.com/","NOT_ASSIGNED_STATUS":"NOT_ASSIGNED","ACCEPTED_STATUS":"ACEPTADA","IN_TRANSIT_STATUS":"EN_TRANSITO","DELIVERED_STATUS":"ENTREGADA","PAID_STATUS":"PAGADA","CANCELLED_STATUS":"CANCELADA","WEB_PAGE_LOADSMX":"https://traxporta.com/","API_COMPANIES_ENDPOINT":"https://api-companies.traxporta.com/","API_COMPANIES_PATH_ENDPOINT":"v1/","API_COUNTRY_REGISTER":"MX>"},"BUILD":{}});

})();

(function() {
  'use strict';
  // Configuration that it is executed at start of all when angular's components is loading
  angular
    .module('loadsAppWeb')
    .config(config);

  /** @ngInject */
  function config($logProvider, toastrConfig, $translateProvider, $httpProvider, uiGmapGoogleMapApiProvider, ngImageGalleryOptsProvider) {
    // Enable log
    $logProvider.debugEnabled(true);

    // Set params of toastr plugin (It is the plugin shows alerts or messages)
    toastrConfig.allowHtml = true; // allow making alert with html code
    toastrConfig.timeOut = 3000; // time it spends showing the message
    toastrConfig.positionClass = 'toast-top-right'; // css class that resolves where it will show the alert
    toastrConfig.preventDuplicates = false; 
    toastrConfig.progressBar = false;

    /**
     * Translate
     * Configuration about location of all languages texts
     */
    $translateProvider.useStaticFilesLoader({//@see http://angular-translate.github.io/docs/#/guide/12_asynchronous-loading
        files: [{
            prefix: 'app/main/assets/locales/',
            suffix: '.json'
        }]
    });
    $translateProvider.registerAvailableLanguageKeys(['en', 'es'], {
        'en': 'en', 'es': 'es'
    });
    $translateProvider.preferredLanguage('en');
    $translateProvider.fallbackLanguage('es');
    $translateProvider.determinePreferredLanguage();
    $translateProvider.useSanitizeValueStrategy('escapeParameters');
    $translateProvider.forceAsyncReload(true);

    //Configuration Google maps library
    uiGmapGoogleMapApiProvider.configure({
        key: 'AIzaSyCOr68rWTWKlLf2Ipxt4lnmlvTJ0hVKGvE',
        v: '3.20', //defaults to latest 3.X anyhow
        libraries: 'weather,geometry,visualization'
    });

    // Configuration about gallery
    ngImageGalleryOptsProvider.setOpts({
        thumbnails      :   true,
        thumbSize       :   80,
        inline          :   false,
        bubbles         :   true,
        bubbleSize      :   20,
        imgBubbles      :   false,
        bgClose         :   false,
        piracy          :   false,
        imgAnim         :   'fadeup'
    });

  }

})();

angular.module("loadsAppWeb").run(["$templateCache", function($templateCache) {$templateCache.put("app/auth/templates/forgot_password.html","<div id=left_panel_login class=\"col col-md-7 pull-l full-height hidden-xs-down hidden-sm-down bg-carrier-login\"><div class=\"row justify-content-center align-items-center full-height\"><div class=col-10><h3 class=\"title-1 color-white title-info-left uppercase-text\">{{ \'login:left_side:title1\' | translate }}<br>{{ \'login:left_side:title2\' | translate }}</h3><div class=\"full-width text-center content-btn-left\"><a href=\"\" class=\"btn btn-class1 bg-color-2 color-white\">{{ \'forgot_password:left_side:btn:create_an_account\' | translate }}</a></div><div class=\"row justify-content-center content-items-left\"><div class=\"col-3 text-center\"><div class=\"block center item-img-left\"><img src=assets/images/login/time-clock-file-cash.png border=0></div><p class=\"small-text color-white text-center\">{{ \'forgot_password:left_side:icons:instapay\' | translate }}</p></div><div class=col-3><div class=\"block center item-img-left\"><img src=assets/images/login/trip-road-circle.png border=0></div><p class=\"small-text color-white text-center\">{{ \'forgot_password:left_side:icons:route_planner\' | translate }}</p></div><div class=col-3><div class=\"block center item-img-left\"><img src=assets/images/login/shipment-international.png border=0></div><p class=\"small-text color-white text-center\">{{ \'forgot_password:left_side:icons:truck_posting\' | translate }}</p></div><div class=col-3><div class=\"block center item-img-left\"><img src=assets/images/login/alarm-bell-check.png border=0></div><p class=\"small-text color-white text-center\">{{ \'forgot_password:left_side:icons:loads_alerts\' | translate }}</p></div></div></div></div></div><div id=right_panel_login class=\"col col-md-5 pull-l full-height\"><div class=\"row justify-content-center align-items-center full-height\"><div class=col-9><div class=\"full-width text-center content-logo-login\"><img src=assets/images/common/logo.png class=img-fluid></div><div id=buttons-panel class=\"full-width text-left\"><a ui-sref=public.login ui-sref-opts=\"{ reload: true }\"><img src=assets/images/common/back.png class=img-fluid></a></div><p class=\"title-login large-title bold\">{{ \'forgot_password:right_side:title\' | translate }}</p><p class=\"subtitle-login small-text\">{{ \'forgot_password:right_side:subtitle\' | translate }}</p><form method=post id=forgotPasswordFormId name=forgotPasswordFormName ng-submit=forgotpassword.sendRequest(forgotPasswordFormName) novalidate><div class=form-group><label class=\"bold uppercase-text\">{{ \'forgot_password:right_side:fields:email\' | translate }}</label><input type=email name=email ng-model=forgotpassword.data.email class=form-control placeholder=\'{{ \"forgot_password:right_side:fields:email:placeholder\" | translate }}\' required autofocus></div><div class=\"form-group text-right\"><button class=\"btn btn-class1 bg-color-9 color-black\">{{ \'forgot_password:right_side:btn:recovery\' | translate }}</button></div><div class=\"form-group text-right\"><span class=small-text>{{ \'forgot_password:right_side:msg:sign_up\' | translate }} </span><a ui-sref=public.signup ui-sref-opts=\"{ reload: true }\" class=\"small-text normal-link\">{{ \'forgot_password:right_side:link:sign_up\' | translate }}</a></div></form></div></div></div>");
$templateCache.put("app/auth/templates/login.html","<div id=left_panel_login class=\"col col-md-7 pull-l full-height hidden-xs-down hidden-sm-down bg-carrier-login\"><div class=\"row justify-content-center align-items-center full-height\"><div class=col-10><h3 class=\"title-1 color-white title-info-left uppercase-text\">{{ \'login:left_side:title1\' | translate }}<br>{{ \'login:left_side:title2\' | translate }}</h3><div class=\"full-width text-center content-btn-left\"><a ui-sref=public.signup ui-sref-opts=\"{ reload: true }\" class=\"btn btn-class1 bg-color-2 color-white\">{{ \'login:left_side:btn:create_an_account\' | translate }}</a></div><div class=\"row justify-content-center content-items-left\"><div class=\"col-3 text-center\"><div class=\"block center item-img-left\"><img src=assets/images/login/time-clock-file-cash.png border=0></div><p class=\"small-text color-white text-center\">{{ \'login:left_side:icons:instapay\' | translate }}</p></div><div class=col-3><div class=\"block center item-img-left\"><img src=assets/images/login/trip-road-circle.png border=0></div><p class=\"small-text color-white text-center\">{{ \'login:left_side:icons:route_planner\' | translate }}</p></div><div class=col-3><div class=\"block center item-img-left\"><img src=assets/images/login/shipment-international.png border=0></div><p class=\"small-text color-white text-center\">{{ \'login:left_side:icons:truck_posting\' | translate }}</p></div><div class=col-3><div class=\"block center item-img-left\"><img src=assets/images/login/alarm-bell-check.png border=0></div><p class=\"small-text color-white text-center\">{{ \'login:left_side:icons:loads_alerts\' | translate }}</p></div></div></div></div></div><div id=right_panel_login class=\"col col-md-5 pull-l full-height\"><div class=\"row justify-content-center align-items-center full-height\"><div class=col-9><div class=\"full-width text-center content-logo-login\"><img src=assets/images/common/logo.png class=img-fluid></div><p class=\"title-login large-title bold\">{{ \'login:right_side:title\' | translate }}</p><p class=\"subtitle-login small-text\">{{ \'login:right_side:subtitle\' | translate }}</p><form method=post id=loginFormId name=loginFormName ng-submit=login.doLogin(loginFormName) novalidate><div class=form-group><label class=\"bold uppercase-text\">{{ \'login:right_side:fields:email\' | translate }}</label><input type=email name=email class=form-control ng-model=login.credentials.email placeholder=\'{{ \"login:right_side:fields:email:placeholder\" | translate }}\' required autofocus></div><div class=form-group><label class=\"bold uppercase-text\">{{ \'login:right_side:fields:password\' | translate }}</label><input type=password name=password class=form-control ng-model=login.credentials.password placeholder=\'{{ \"login:right_side:fields:password:placeholder\" | translate }}\' required></div><div class=form-group><input type=checkbox id={{login.tyc.name}} name={{login.tyc.name}} ng-model=login.tyc.checked class=custom-checkbox><label for={{login.tyc.name}}><span></span>{{ \'sign_up:form:tyc1:label\' | translate }} <a href=http://www.loadsapp.us/ServicesApp/storage/app/public/about/tyc.html target=_blank>{{ \'sign_up:form:tyc2:label\' | translate }}</a>, <a href=http://www.loadsapp.us/ServicesApp/storage/app/public/about/privacy-policy.html target=_blank>{{ \'sign_up:form:tyc4:label\' | translate }}</a> {{ \'sign_up:form:tyc3:label\' | translate }} {{ \'sign_up:form:tyc5:label\' | translate }}</label></div><div class=form-group><div class=row><div class=col-6><a ui-sref=public.forgotpassword ui-sref-opts=\"{ reload: true }\" class=\"small-text normal-link\">{{ \'login:right_side:link:forgot_pass\' | translate }}</a></div><div class=\"col-6 text-right\"><button type=submit class=\"btn btn-class1 bg-color-9 color-black btn-login\">{{ \'login:right_side:btn:login\' | translate }}</button></div></div></div><div class=\"form-group text-right\"><span class=small-text>{{ \'login:right_side:msg:sign_up\' | translate }} </span><a ui-sref=public.signup ui-sref-opts=\"{ reload: true }\" class=\"small-text normal-link\">{{ \'login:right_side:link:sign_up\' | translate }}</a></div></form></div></div></div>");
$templateCache.put("app/auth/templates/sign_up.html","<div id=left_panel_login class=\"col col-md-7 pull-l full-height hidden-xs-down hidden-sm-down bg-carrier-login\"><div class=\"row justify-content-center align-items-center full-height\"><div class=col-10><h3 class=\"title-1 color-white title-info-left uppercase-text\">{{ \'login:left_side:title1\' | translate }}<br>{{ \'login:left_side:title2\' | translate }}</h3><div class=\"full-width text-center content-btn-left\"><a href=https://www.traxporta.com/ target=_blank class=\"btn btn-class1 bg-color-2 color-white\">{{ \'sign_up:left_side:btn:visit_website\' | translate }}</a></div><div class=\"row justify-content-center content-items-left\"><div class=\"col-3 text-center\"><div class=\"block center item-img-left\"><img src=assets/images/login/time-clock-file-cash.png border=0></div><p class=\"small-text color-white text-center\">{{ \'sign_up:left_side:icons:instapay\' | translate }}</p></div><div class=col-3><div class=\"block center item-img-left\"><img src=assets/images/login/trip-road-circle.png border=0></div><p class=\"small-text color-white text-center\">{{ \'sign_up:left_side:icons:route_planner\' | translate }}</p></div><div class=col-3><div class=\"block center item-img-left\"><img src=assets/images/login/shipment-international.png border=0></div><p class=\"small-text color-white text-center\">{{ \'sign_up:left_side:icons:truck_posting\' | translate }}</p></div><div class=col-3><div class=\"block center item-img-left\"><img src=assets/images/login/alarm-bell-check.png border=0></div><p class=\"small-text color-white text-center\">{{ \'sign_up:left_side:icons:loads_alerts\' | translate }}</p></div></div></div></div></div><div id=right_panel_login class=\"col col-md-5 pull-l full-height\"><div class=\"row justify-content-center align-items-center full-height\"><div class=col-9><div class=\"full-width text-center content-logo-login\"><img src=assets/images/common/logo.png class=img-fluid></div><p class=\"title-login large-title bold\">{{ \'sign_up:right_side:title\' | translate }}</p><p class=\"subtitle-login small-text\">{{ \'sign_up:right_side:subtitle\'+signup.subtitleForm | translate }}</p><div class=full-width><form ng-if=\"signup.validateForm == \'basic_info\'\" class=animationIf method=post id=signupFormId name=signupFormName ng-submit=signup.validateSignup(signupFormName) novalidate><div class=form-group><label class=\"bold uppercase-text\">{{ \'sign_up:form:profile:label\' | translate }}</label><select name=profile id=profile ng-model=signup.newUser.profile class=\"form-control input-md\" required><option ng-repeat=\"profileItem in signup.profileOptions\" value={{profileItem.id}}>{{profileItem.name}}</option></select></div><div class=form-group><div class=row><div class=\"col-12 col-sm-6\"><label class=\"bold uppercase-text\">{{ \'sign_up:form:first_name:label\' | translate }}</label><input id=user_first_name ng-model=signup.newUser.user_first_name name=user_first_name type=text placeholder=\"\" class=\"form-control input-md\" required></div><div class=\"col-12 col-sm-6\"><label class=\"bold uppercase-text\">{{ \'sign_up:form:last_name:label\' | translate }}</label><input id=user_last_name ng-model=signup.newUser.user_last_name name=user_last_name type=text placeholder=\"\" class=\"form-control input-md\" required></div></div></div><div class=form-group><div class=row><div ng-if=\"signup.newUser.profile==\'GENERADOR_CARGA\' || signup.newUser.profile==\'CARRIER\'\" class=\"col-12 col-sm-6\"><label class=\"bold uppercase-text\">{{ \'sign_up:form:document_type:label\' | translate }}</label><select name=document_type id=document_type ng-model=signup.newUser.document_type class=\"form-control input-md\" required><option ng-repeat=\"documentTypeItem in signup.shipperDocTypeOptions\" value={{documentTypeItem.id}}>{{documentTypeItem.name}}</option></select></div><div ng-if=\"signup.newUser.profile!=\'GENERADOR_CARGA\' && signup.newUser.profile!=\'CARRIER\'\" class=\"col-12 col-sm-6\"><label class=\"bold uppercase-text\">{{ \'sign_up:form:document_type:label\' | translate }}</label><select name=document_type id=document_type ng-model=signup.newUser.document_type class=\"form-control input-md\" required><option ng-repeat=\"documentTypeItem2 in signup.notShipperDocTypeOptions\" value={{documentTypeItem2.id}}>{{documentTypeItem2.name}}</option></select></div><div class=\"col-12 col-sm-6\"><label class=\"bold uppercase-text\">{{ \'sign_up:form:document_number:label\' | translate }}</label><input id=document_number ng-model=signup.newUser.document_number name=document_number type=text placeholder=\"\" class=\"form-control input-md\" required></div></div></div><div class=form-group><div class=row><div class=\"col-12 col-sm-6\"><label class=\"bold uppercase-text\">{{ \'sign_up:form:phone:label\' | translate }}</label><input id=user_phone ng-model=signup.newUser.user_phone name=user_phone type=text placeholder=\"\" class=\"form-control input-md\" required></div><div class=\"col-12 col-sm-6\"><label class=\"bold uppercase-text\">{{ \'sign_up:form:email:label\' | translate }}</label><input id=user_email ng-model=signup.newUser.user_email name=user_email type=email placeholder=\"\" class=\"form-control input-md\" required></div></div></div><div class=form-group><div class=row><div class=\"col-12 col-sm-6\"><label class=\"bold uppercase-text\">{{ \'sign_up:form:password:label\' | translate }}</label><input id=user_password ng-model=signup.newUser.user_password name=user_password type=password placeholder=\"\" class=\"form-control input-md\" required></div><!--<div class=\"col-12 col-sm-6\">\n								<label class=\"bold uppercase-text\">{{ \'sign_up:form:bank_name:label\' | translate }}</label>\n								<input id=\"name_bank\" ng-model=\"signup.newUser.name_bank\" name=\"name_bank\" type=\"text\" placeholder=\'\' class=\"form-control input-md\" required>\n							</div>--></div></div><!--<div class=\"form-group\">\n						<div class=\"row\">\n							<div class=\"col-12 col-sm-6\">\n								<label class=\"bold uppercase-text\">{{ \'sign_up:form:bank_account_number:label\' | translate }}</label>\n								<input id=\"number_account_bank\" ng-model=\"signup.newUser.number_account_bank\" name=\"number_account_bank\" type=\"text\" placeholder=\'\' class=\"form-control input-md\" required>\n							</div>\n						</div>\n					</div>--><div class=\"form-group text-right\"><button ng-click=signup.goToLogin() type=button class=\"btn btn-class2 bg-color-white color-black\">{{ \'sign_up:form:back:btn\' | translate }}</button> <button type=submit class=\"btn btn-class2 bg-color-9 color-black\">{{ \'sign_up:form:next:btn\' | translate }}</button></div></form><form ng-if=\"signup.validateForm == \'company_info\'\" class=animationIf method=post id=signupFormId2 name=signupFormName2 ng-submit=signup.validateSignup(signupFormName2) novalidate><div ng-if=\"signup.newUser.profile==\'GENERADOR_CARGA\'\" class=form-group><div class=row><div class=col-12><label class=\"bold uppercase-text\">{{ \'sign_up:form:company_name:label\' | translate }}</label><input id=company_name ng-model=signup.newUser.company_name name=company_name type=text placeholder=\"\" class=\"form-control input-md\" required></div></div></div><div ng-if=\"signup.newUser.profile==\'GENERADOR_CARGA\'\" class=form-group><div class=row><div class=\"col-12 col-sm-6\"><label class=\"bold uppercase-text\">{{ \'sign_up:form:address:label\' | translate }}</label><input id=address_company ng-model=signup.newUser.address_company name=address_company type=text placeholder=\"\" class=\"form-control input-md\" required></div><div class=\"col-12 col-sm-6\"><label class=\"bold uppercase-text\">{{ \'sign_up:form:company_city:label\' | translate }}</label><input type=text name=city_company class=\"form-control input-md\" g-places-autocomplete options=signup.optionsGoogleInputCity force-selection=true ng-model=signup.companyCitySelect ng-change=signup.autoCompleteStateCountry() placeholder=\"\" required></div></div></div><div ng-if=\"signup.newUser.profile==\'GENERADOR_CARGA\'\" class=form-group><div class=row><div class=\"col-12 col-sm-6\"><label class=\"bold uppercase-text\">{{ \'sign_up:form:company_state:label\' | translate }}</label><input type=text name=state_company class=\"form-control input-md\" g-places-autocomplete force-selection=true ng-model=signup.companyStateSelect placeholder=\"\" required></div><div class=\"col-12 col-sm-6\"><label class=\"bold uppercase-text\">{{ \'sign_up:form:company_country:label\' | translate }}</label><input type=text name=country_company class=\"form-control input-md\" g-places-autocomplete force-selection=true ng-model=signup.companyCountrySelect placeholder=\"\" required></div></div></div><div ng-if=\"signup.newUser.profile==\'GENERADOR_CARGA\'\" class=form-group><div class=row><div class=\"col-12 col-sm-6\"><label class=\"bold uppercase-text\">{{ \'sign_up:form:company_phone:label\' | translate }}</label><input id=phone_company ng-model=signup.newUser.phone_company name=phone_company type=text placeholder=\"\" class=\"form-control input-md\" required></div><div class=\"col-12 col-sm-6\"><label class=\"bold uppercase-text\">{{ \'sign_up:form:company_email:label\' | translate }}<br>{{ \'sign_up:form:company_email:notice:label\' | translate }}</label><input id=email_company ng-model=signup.newUser.email_company name=email_company type=email placeholder=\"\" class=\"form-control input-md\" required></div></div></div><div ng-if=\"signup.newUser.profile!=\'GENERADOR_CARGA\'\" class=form-group><div class=row><div class=col-12><label class=\"bold uppercase-text\">{{ \'sign_up:form:company_name:label\' | translate }}</label><input id=company_name ng-model=signup.newUser.company_name name=company_name type=text placeholder=\"\" class=\"form-control input-md\" required></div></div></div><div ng-if=\"signup.newUser.profile!=\'GENERADOR_CARGA\'\" class=form-group><div class=row><div class=\"col-12 col-sm-6\"><label class=\"bold uppercase-text\">{{ \'sign_up:form:mc_number:label\' | translate }}</label><i class=\"fa fa-question-circle\" aria-hidden=true><md-tooltip md-direction=top>{{ \'sign_up:form:mc_number_tooltip:label\' | translate }}</md-tooltip></i><input id=mc_number ng-model=signup.newUser.mc_number name=mc_number type=text placeholder=\"\" class=\"form-control input-md\"></div><div class=\"col-12 col-sm-6\"><label class=\"bold uppercase-text\">{{ \'sign_up:form:dot_number:label\' | translate }}</label><i class=\"fa fa-question-circle\" aria-hidden=true><md-tooltip md-direction=top>{{ \'sign_up:form:dot_number_tooltip:label\' | translate }}</md-tooltip></i><input id=dot_number ng-model=signup.newUser.dot_number name=dot_number type=text placeholder=\"\" class=\"form-control input-md\"></div></div></div><div ng-if=\"signup.newUser.profile!=\'GENERADOR_CARGA\'\" class=form-group><div class=row><div class=\"col-12 col-sm-6\"><label class=\"bold uppercase-text\">{{ \'sign_up:form:ein_number:label\' | translate }}</label><input id=ein_number ng-model=signup.newUser.ein_number name=ein_number type=text placeholder=\"\" class=\"form-control input-md\"></div><div class=\"col-12 col-sm-6\"><label class=\"bold uppercase-text\">{{ \'sign_up:form:corp_number:label\' | translate }}</label><input id=corp_number ng-model=signup.newUser.corp_number name=corp_number type=text placeholder=\"\" class=\"form-control input-md\"></div></div></div><div ng-if=\"signup.newUser.profile!=\'GENERADOR_CARGA\'\" class=form-group><div class=row><div class=\"col-12 col-sm-6\"><label class=\"bold uppercase-text\">{{ \'sign_up:form:address:label\' | translate }}</label><input id=address_company ng-model=signup.newUser.address_company name=address_company type=text placeholder=\"\" class=\"form-control input-md\" required></div><div class=\"col-12 col-sm-6\"><label class=\"bold uppercase-text\">{{ \'sign_up:form:company_city:label\' | translate }}</label><input type=text name=city_company class=\"form-control input-md\" g-places-autocomplete options=signup.optionsGoogleInputCity force-selection=true ng-model=signup.companyCitySelect ng-change=signup.autoCompleteStateCountry() placeholder=\"\" required></div></div></div><div ng-if=\"signup.newUser.profile!=\'GENERADOR_CARGA\'\" class=form-group><div class=row><div class=\"col-12 col-sm-6\"><label class=\"bold uppercase-text\">{{ \'sign_up:form:company_state:label\' | translate }}</label><input type=text name=state_company class=\"form-control input-md\" g-places-autocomplete force-selection=true ng-model=signup.companyStateSelect placeholder=\"\" required></div><div class=\"col-12 col-sm-6\"><label class=\"bold uppercase-text\">{{ \'sign_up:form:company_country:label\' | translate }}</label><input type=text name=country_company class=\"form-control input-md\" g-places-autocomplete force-selection=true ng-model=signup.companyCountrySelect placeholder=\"\" required></div></div></div><div ng-if=\"signup.newUser.profile!=\'GENERADOR_CARGA\'\" class=form-group><div class=row><div class=\"col-12 col-sm-6\"><label class=\"bold uppercase-text\">{{ \'sign_up:form:company_phone:label\' | translate }}</label><input id=phone_company ng-model=signup.newUser.phone_company name=phone_company type=text placeholder=\"\" class=\"form-control input-md\" required></div><div class=\"col-12 col-sm-6\"><label class=\"bold uppercase-text\">{{ \'sign_up:form:company_email:label\' | translate }}</label><input id=email_company ng-model=signup.newUser.email_company name=email_company type=email placeholder=\"\" class=\"form-control input-md\" required></div></div></div><div class=form-group><div class=row><div class=col-12><input type=checkbox id={{signup.newUser.tyc.name}} name={{signup.newUser.tyc.name}} ng-model=signup.newUser.tyc.checked class=custom-checkbox><label for={{signup.newUser.tyc.name}}><span></span>{{ \'sign_up:form:tyc1:label\' | translate }} <a href=http://www.loadsapp.us/ServicesApp/storage/app/public/about/tyc.html target=_blank>{{ \'sign_up:form:tyc2:label\' | translate }}</a>, <a href=http://www.loadsapp.us/ServicesApp/storage/app/public/about/privacy-policy.html target=_blank>{{ \'sign_up:form:tyc4:label\' | translate }}</a> {{ \'sign_up:form:tyc3:label\' | translate }} {{ \'sign_up:form:tyc5:label\' | translate }}</label></div></div></div><div class=\"form-group text-right\"><button ng-click=signup.comeBackForm() type=button class=\"btn btn-class2 bg-color-white color-black\">{{ \'sign_up:form:back:btn\' | translate }}</button><!--<button ng-if=\"signup.newUser.profile!=\'GENERADOR_CARGA\'\" type=\"submit\" class=\"btn btn-class2 bg-color-1 color-white\">{{ \'sign_up:form:next:btn\' | translate }}</button>--> <button type=submit class=\"btn btn-class2 bg-color-9 color-black\">{{ \'sign_up:form:finish:btn\' | translate }}</button></div></form><form ng-if=\"signup.validateForm == \'insurance_info\'\" class=animationIf method=post id=signupFormId3 name=signupFormName3 ng-submit=signup.validateSignup(signupFormName3) novalidate><div class=form-group><div class=row><div class=\"col-12 col-sm-6\"><label class=\"bold uppercase-text\">{{ \'sign_up:form:policy_number:label\' | translate }}</label><input id=bond_insurance_num_policy ng-model=signup.newUser.bond_insurance_num_policy name=bond_insurance_num_policy type=text placeholder=\"\" class=\"form-control input-md\"></div><div class=\"col-12 col-sm-6\"><label class=\"bold uppercase-text\">{{ \'sign_up:form:company_insurance:label\' | translate }}</label><input id=bond_insurance_comp ng-model=signup.newUser.bond_insurance_comp name=bond_insurance_comp type=text placeholder=\"\" class=\"form-control input-md\"></div></div></div><div class=form-group><div class=row><div class=\"col-12 col-sm-6\"><label class=\"bold uppercase-text\">{{ \'sign_up:form:bond_policy_number:label\' | translate }}</label><input id=bond_insurance_num ng-model=signup.newUser.bond_insurance_num name=bond_insurance_num type=text placeholder=\"\" class=\"form-control input-md\"></div><div class=\"col-12 col-sm-6\"><label class=\"bold uppercase-text\">{{ \'sign_up:form:bank_name:label\' | translate }}</label><input id=name_bank ng-model=signup.newUser.name_bank name=name_bank type=text placeholder=\"\" class=\"form-control input-md\" required></div></div></div><div class=form-group><div class=row><div class=\"col-12 col-sm-6\"><label class=\"bold uppercase-text\">{{ \'sign_up:form:bank_account_number:label\' | translate }}</label><input id=number_account_bank ng-model=signup.newUser.number_account_bank name=number_account_bank type=text placeholder=\"\" class=\"form-control input-md\" required></div></div></div><div class=\"form-group text-right\"><button ng-click=signup.comeBackForm() type=button class=\"btn btn-class2 bg-color-white color-black\">{{ \'sign_up:form:back:btn\' | translate }}</button> <button type=submit class=\"btn btn-class2 bg-color-9 color-black\">{{ \'sign_up:form:finish:btn\' | translate }}</button></div></form></div></div></div></div>");
$templateCache.put("app/carriers/templates/carriers.html","<div id=page-section-carriers class=\"page-section col\"><total-items></total-items><div class=\"col content-carrier-list bg-color-white\"><h3 class=\"large-title title-section\">{{ \'carriers:section:title\' | translate }}</h3><div class=row><ul class=\"nav nav-tabs nav-tabs-full-w\" role=tablist><li class=nav-item><a ng-class=\"{active: carriers.tabList == \'all\' }\" ng-click=carriers.resetAllFilters() class=\"nav-link custom-nav-link\" data-toggle=tab role=tab>{{ \'carriers:list:all:title\' | translate }}</a></li><li class=nav-item><a ng-class=\"{active: carriers.tabList == \'my_search\' }\" ng-click=carriers.searchWithParams() class=\"nav-link custom-nav-link\" data-toggle=tab role=tab>{{ \'carriers:list:my_search:title\' | translate }}</a></li></ul></div><div class=\"tab-content tab-content-full-w\"><div class=\"tab-pane active\" id=content_carriers_tab role=tabpanel><h6 class=carriers-found-number>{{ \'carriers:list:count\' | translate:{ count: carriers.countCarriers } }}</h6><!--<p ng-if=\"carriers.loadingCarrierData\">{{ \'table:loading_data:text\' | translate }}</p>\n		  		<p ng-if=\"!carriers.loadingCarrierData && !carriers.carriersList.length\">{{ \'carriers:list:empty:text\' | translate }}</p>--><div class=\"full-width content-tableData\"><table datatable=\"\" dt-options=carriers.datatableOptions class=tableDataSort dt-columns=carriers.dtColumns width=100% border=0><thead><tr><th>{{ \'carriers:table:column:image\' | translate }}</th><th>{{ \'carriers:table:column:carrier\' | translate }}</th><th>{{ \'carriers:table:column:transported\' | translate }}</th><th>{{ \'carriers:table:column:transit\' | translate }}</th><th>{{ \'carriers:table:column:trucks\' | translate }}</th><th width=10%>{{ \'carriers:table:column:skills\' | translate }}</th><th>{{ \'carriers:table:column:reviews\' | translate }}</th><th>{{ \'carriers:table:column:contact\' | translate }}</th><th>{{ \'carriers:table:column:actions\' | translate }}</th></tr></thead><tbody><tr ng-repeat-start=\"carrier in carriers.carriersList\"><td><img ng-if=carrier.img_perfil_carrier ng-src=\"{{carrier.img_perfil_carrier[0][\'imagen-60\']}}\" width=40 border=0></td><td>{{carrier.carrier.company_name}}</td><td>{{carrier.LoadsTransported}}</td><td>{{carrier.LoadsTransit}}</td><td>{{carrier.CantidadTruck}}</td><td>{{carrier.SkillsCarrierText}}</td><td ng-if=carrier.carrier.user.user_votes.length><ul class=\"nav user-calification\"><li class=nav-item><span ng-class=\"carrier.carrier.user.user_votes[0].total_prom >= 1 ? \'fa-star\' : \'fa-star-o\'\" class=fa></span></li><li class=nav-item><span ng-class=\"carrier.carrier.user.user_votes[0].total_prom >= 2 ? \'fa-star\' : \'fa-star-o\'\" class=fa></span></li><li class=nav-item><span ng-class=\"carrier.carrier.user.user_votes[0].total_prom >= 3 ? \'fa-star\' : \'fa-star-o\'\" class=fa></span></li><li class=nav-item><span ng-class=\"carrier.carrier.user.user_votes[0].total_prom >= 4 ? \'fa-star\' : \'fa-star-o\'\" class=fa></span></li><li class=nav-item><span ng-class=\"carrier.carrier.user.user_votes[0].total_prom >= 5 ? \'fa-star\' : \'fa-star-o\'\" class=fa></span></li></ul></td><td ng-if=!carrier.carrier.user.user_votes.length><ul class=\"nav user-calification\"><li class=nav-item><span class=\"fa fa-star-o\"></span></li><li class=nav-item><span class=\"fa fa-star-o\"></span></li><li class=nav-item><span class=\"fa fa-star-o\"></span></li><li class=nav-item><span class=\"fa fa-star-o\"></span></li><li class=nav-item><span class=\"fa fa-star-o\"></span></li></ul></td><td><span class=\"fa fa-phone color-new-blue vertical-middle\"></span> <a ng-href=tel:{{carrier.phone_contact}} class=\"small-text normal-link\">{{carrier.phone_contact}}</a></td><td><i ng-if=!carrier.expanded ng-click=carriers.showDetailsUnique(carrier.id) class=\"fa fa-angle-down show-load-details-btn\"></i> <i ng-if=carrier.expanded ng-click=carriers.showDetailsUnique(carrier.id) class=\"fa fa-angle-up show-load-details-btn\"></i></td></tr><tr class=detail-carrier-table ng-repeat-end><td ng-if=carrier.expanded colspan=12 class=no-padding><carrier-details-row carrier-info=carrier></carrier-details-row></td></tr></tbody></table></div></div></div></div></div>");
$templateCache.put("app/carriers/templates/details.html","<div id=page-section-profile class=\"page-section page-section-with-margin col bg-color-white\"><h3 class=\"large-title title-profile\">{{\'profile:section:title\' | translate }}</h3><form method=post><div class=row><div class=col><div class=section-profile><div class=row><div class=col-2><div ng-if=!carriersdetails.carrierData.img_perfil_carrier class=\"content-img-profile rounded-circle\"></div><img ng-if=carriersdetails.carrierData.img_perfil_carrier[0] ng-src=\"{{carriersdetails.carrierData.img_perfil_carrier[0][\'imagen-270\']}}\" class=\"img-fluid rounded-circle\" border=0><div class=\"full-width text-center\"><ul ng-if=carriersdetails.carrierData.carrier_info.user.user_votes.length class=\"nav user-calification\"><li class=nav-item><span ng-class=\"carriersdetails.carrierData.carrier_info.user.user_votes[0].total_prom >= 1 ? \'fa-star\' : \'fa-star-o\'\" class=fa></span></li><li class=nav-item><span ng-class=\"carriersdetails.carrierData.carrier_info.user.user_votes[0].total_prom >= 2 ? \'fa-star\' : \'fa-star-o\'\" class=fa></span></li><li class=nav-item><span ng-class=\"carriersdetails.carrierData.carrier_info.user.user_votes[0].total_prom >= 3 ? \'fa-star\' : \'fa-star-o\'\" class=fa></span></li><li class=nav-item><span ng-class=\"carriersdetails.carrierData.carrier_info.user.user_votes[0].total_prom >= 4 ? \'fa-star\' : \'fa-star-o\'\" class=fa></span></li><li class=nav-item><span ng-class=\"carriersdetails.carrierData.carrier_info.user.user_votes[0].total_prom >= 5 ? \'fa-star\' : \'fa-star-o\'\" class=fa></span></li></ul><ul ng-if=!carriersdetails.carrierData.carrier_info.user.user_votes.length class=\"nav user-calification\"><li class=nav-item><span class=\"fa fa-star-o\"></span></li><li class=nav-item><span class=\"fa fa-star-o\"></span></li><li class=nav-item><span class=\"fa fa-star-o\"></span></li><li class=nav-item><span class=\"fa fa-star-o\"></span></li><li class=nav-item><span class=\"fa fa-star-o\"></span></li></ul></div></div><div class=col-10><!--<h3 class=\"large-title title-profile\">{{carriersdetails.carrierData.carrier_info.phone_company}}</h3>--><div class=form-group><div class=row><div class=col-6><label>{{ \"carriers:profile:first_name:text\" | translate }}</label><p class=small-text>{{carriersdetails.carrierData.carrier_info.user.user_first_name}}</p></div><div class=col-6><label>{{ \"carriers:profile:last_name:text\" | translate }}</label><p class=small-text>{{carriersdetails.carrierData.carrier_info.user.user_last_name}}</p></div></div></div><div class=form-group><div class=row><div class=col-6><label>{{ \"carriers:profile:email:text\" | translate }}</label><p class=small-text>{{carriersdetails.carrierData.carrier_info.user.user_email}}</p></div><div class=col-6><label>{{ \"carriers:profile:phone:text\" | translate }}</label><p class=small-text>{{carriersdetails.carrierData.carrier_info.user.user_phone}}</p></div></div></div><div class=form-group><div class=row><div class=col-6><label>{{ \"carriers:profile:bank:text\" | translate }}</label><p class=small-text>{{carriersdetails.carrierData.carrier_info.user.name_bank}}</p></div><div class=col-6><label>{{ \"carriers:profile:account_bank_number:text\" | translate }}</label><p class=small-text>{{carriersdetails.carrierData.carrier_info.user.number_account_bank}}</p></div></div></div><div class=form-group><div class=row><div class=col-6><label>{{ \"carriers:profile:company_name:text\" | translate }}</label><p class=small-text>{{carriersdetails.carrierData.carrier_info.company_name}}</p></div><div class=col-6><label>{{ \"carriers:profile:ein_ssn:text\" | translate }}</label><p class=small-text>{{carriersdetails.carrierData.carrier_info.ein_number}}</p></div></div></div><div class=\"form-group parrafo\"></div></div></div><div class=row><div class=col-12><h3 class=\"large-title title-profile\">{{ \"carriers:profile:company_info:title\" | translate}}</h3><div class=form-group><div class=row><div class=col-4><label>{{ \"carriers:profile:mc_number:text\" | translate }}</label><p class=small-text>{{carriersdetails.carrierData.carrier_info.mc_number}}</p></div><div class=col-4><label>{{ \"carriers:profile:dot_number:text\" | translate }}</label><p class=small-text>{{carriersdetails.carrierData.carrier_info.dot_number}}</p></div><div class=col-4><label>{{ \"carriers:profile:corp_number:text\" | translate }}</label><p class=small-text>{{carriersdetails.carrierData.carrier_info.corp_number}}</p></div></div></div><div class=form-group><div class=row><div class=col-4><label>{{ \"carriers:profile:comp_address:text\" | translate }}</label><p class=small-text>{{carriersdetails.carrierData.carrier_info.address_company}}</p></div><div class=col-4><label>{{ \"carriers:profile:comp_city:text\" | translate }}</label><p class=small-text>{{carriersdetails.carrierData.carrier_info.city_company}}</p></div><div class=col-4><label>{{ \"carriers:profile:comp_state:text\" | translate }}</label><p class=small-text>{{carriersdetails.carrierData.carrier_info.state_company}}</p></div></div></div><div class=form-group><div class=row><div class=col-4><label>{{ \"carriers:profile:comp_country:text\" | translate }}</label><p class=small-text>{{carriersdetails.carrierData.carrier_info.country_company}}</p></div><div class=col-4><label>{{ \"carriers:profile:comp_phone:text\" | translate }}</label><p class=small-text>{{carriersdetails.carrierData.carrier_info.phone_company}}</p></div><div class=col-4><label>{{ \"carriers:profile:comp_email:text\" | translate }}</label><p class=small-text>{{carriersdetails.carrierData.carrier_info.email_company}}</p></div></div></div></div></div><div class=row permission permission-only=\"[\'CARRIER\',\'OWNER\']\"><div class=col-12><h3 class=\"large-title title-profile\">Trucks availables</h3><ul ng-if=carriersdetails.carrierData.truck_results.length class=\"nav flex-column carrier-drivers-list\"><li ng-click=openTruckModal(truck.id) ng-repeat=\"truck in carriersdetails.carrierData.truck_results\" class=nav-item><div class=img-truck><img ng-if=\"truck.img_truck_imagenes[0][\'imagen-60\']\" ng-src=\"{{truck.img_truck_imagenes[0][\'imagen-60\']}}\" class=\"img-fluid rounded-circle\" border=0></div><span class=truck-name-table>{{truck.brand}} {{truck.model}} {{truck.dimension}}</span> <span class=driver-name-table>Driven by {{truck.driver.user.user_first_name}} {{truck.driver.user.user_last_name}}</span></li></ul></div></div></div></div></div><div class=\"row main-botonera\"><div class=\"col-12 text-right\" permission permission-only=\"[\'GENERADOR_CARGA\']\"><button style=\"max-width: 300px\" ng-if=\"carriersdetails.shipperCanAcceptRequest && carriersdetails.loadCarrierRequest\" ng-click=carriersdetails.answerRequestByCarrier() type=button class=\"btn btn-class1 bg-color-9 color-black\">{{ \'modals:carrier_requests:form:btn\' | translate }}</button></div></div></form></div>");
$templateCache.put("app/components/navbar/navbar.html","<nav class=navbar><a href=https://github.com/Swiip/generator-gulp-angular>Gulp Angular</a><ul><li class=active><a ng-href=#>Home</a></li><li><a ng-href=#>About</a></li><li><a ng-href=#>Contact</a></li></ul><ul class=acme-navbar-text><li>Application was created {{ vm.relativeDate }}.</li></ul></nav>");
$templateCache.put("app/components/pagination/pagination.html","<style>.page-item.page-active .page-link {\n    z-index: 2;\n    color: #fff!important;\n    background-color: #D4DD55!important;\n    border-color: #D4DD55!important;\n  }</style><div class=p-4><nav aria-label=\"Page navigation\"><ul class=\"pagination justify-content-center\"><li class=page-item><a class=page-link href=javascript:void(0) aria-label=Previous style=color:#000!important><span aria-hidden=true>&laquo;</span> <span class=sr-only>Previous</span></a></li><li class=page-item ng-repeat=\"page in pages\" ng-class=\"{\'page-active\': page === currentPage,\'disabled\' : page === \'...\'}\"><a class=page-link href=javascript:void(0) ng-click=changePage(page) style=color:#000!important>{{page}}</a></li><li class=page-item><a class=page-link href=javascript:void(0) aria-label=Next style=color:#000!important><span aria-hidden=true>&raquo;</span> <span class=sr-only>Next</span></a></li></ul></nav></div>");
$templateCache.put("app/drivers/templates/add.html","<div id=page-section-post-truck class=\"page-section page-section-with-margin col bg-color-white\"><h3 class=\"large-title title-section\">{{ \'drivers:add:section:title\' | translate }}</h3><form method=post id=postDriverFormId name=postDriverFormName ng-submit=driversadd.save(postDriverFormName) novalidate><div class=row><div class=col-12><div class=row><div class=col-4><div class=pic-square ngf-select ng-model=driversadd.dataNewDriver.pic name=pic ngf-pattern=\"\'image/*\'\" ngf-accept=\"\'image/*\'\" ngf-max-size=2MB><img ng-show=postDriverFormName.pic.$valid ngf-thumbnail=driversadd.dataNewDriver.pic class=img-fluid></div></div><div class=col-8><div class=form-group><div class=row><div class=col-6><label>{{ \'drivers:add:form:id_integration_driver:text\' | translate }}</label><span class=help-inline ng-show=postDriverFormName.id_integration_drivers.$error.required>*</span> <input type=text name=id_integration_drivers class=form-control ng-model=driversadd.dataNewDriver.id_integration_drivers placeholder=\'{{ \"drivers:add:form:id_integration_driver:text\" | translate }}\' required></div></div></div><div class=form-group><div class=row><div class=col-6><label>{{ \'drivers:add:form:name:text\' | translate }}</label><span class=help-inline ng-show=postDriverFormName.user_first_name.$error.required>*</span> <input type=text name=user_first_name class=form-control ng-model=driversadd.dataNewDriver.user_first_name placeholder=\'{{ \"drivers:add:form:name:text\" | translate }}\' required></div><div class=col-6><label>{{ \'drivers:add:form:lastname:text\' | translate }}</label><span class=help-inline ng-show=postDriverFormName.lastname.$error.required>*</span> <input type=text name=lastname class=form-control ng-model=driversadd.dataNewDriver.user_last_name placeholder=\'{{ \"drivers:add:form:lastname:text\" | translate }}\' required></div></div></div><div class=form-group><div class=row><div class=col-6><label>{{ \'drivers:add:form:phone:text\' | translate }}</label><span class=help-inline ng-show=postDriverFormName.phone.$error.required>*</span> <input type=text name=phone class=form-control ng-model=driversadd.dataNewDriver.user_phone placeholder=\'{{ \"drivers:add:form:phone:text\" | translate }}\' required></div><div class=col-6><label>{{ \'drivers:add:form:email:text\' | translate }}</label><span class=help-inline ng-show=postDriverFormName.email.$error.required>*</span> <input type=email name=email class=form-control ng-model=driversadd.dataNewDriver.user_email placeholder=\'{{ \"drivers:add:form:email:text\" | translate }}\' required></div></div></div></div></div><div class=form-group><div class=row><div class=col-6><label>{{ \'drivers:add:form:password:text\' | translate }}</label><span class=help-inline ng-show=postDriverFormName.password.$error.required>*</span> <input type=password name=password class=form-control ng-model=driversadd.dataNewDriver.user_password placeholder=\'{{ \"drivers:add:form:password:text\" | translate }}\' required></div><div class=col-6><label>{{ \'drivers:add:form:re_password:text\' | translate }}</label><span class=help-inline ng-show=postDriverFormName.re_password.$error.required>*</span> <input type=password name=re_password class=form-control ng-model=driversadd.dataNewDriver.user_confirmpassword placeholder=\'{{ \"drivers:add:form:re_password:text\" | translate }}\' required></div></div></div><div class=form-group><div class=row><div class=col-6><label>{{ \'drivers:add:form:country:text\' | translate }}</label><span class=help-inline ng-show=postDriverFormName.country.$error.required>*</span> <input type=text name=country class=form-control ng-model=driversadd.dataNewDriver.user_contry placeholder=\'{{ \"drivers:add:form:country:text\" | translate }}\' required></div><div class=col-6><label>{{ \'drivers:add:form:state:text\' | translate }}</label><span class=help-inline ng-show=postDriverFormName.state.$error.required>*</span> <input type=text name=state class=form-control ng-model=driversadd.dataNewDriver.user_state placeholder=\'{{ \"drivers:add:form:state:text\" | translate }}\' required></div></div></div><div class=form-group><div class=row><div class=col-6><label>{{ \'drivers:add:form:city:text\' | translate }}</label><span class=help-inline ng-show=postDriverFormName.city.$error.required>*</span> <input type=text name=city class=form-control ng-model=driversadd.dataNewDriver.user_city placeholder=\'{{ \"drivers:add:form:city:text\" | translate }}\' required></div><div class=col-6><label>{{ \'drivers:add:form:zipcode:text\' | translate }}</label><span class=help-inline ng-show=postDriverFormName.zipcode.$error.required>*</span> <input type=text name=zipcode class=form-control ng-model=driversadd.dataNewDriver.user_postalcode placeholder=\'{{ \"drivers:add:form:zipcode:text\" | translate }}\' required></div></div></div><div class=form-group><div class=row><div class=col-6><label>{{ \'drivers:add:form:insurance_number:text\' | translate }}</label><!--<span class=\"help-inline\" ng-show=\"postDriverFormName.insurance_number.$error.required\">*</span>--> <input type=text name=insurance_number class=form-control ng-model=driversadd.dataNewDriver.bond_insurance_num placeholder=\'{{ \"drivers:add:form:insurance_number:text\" | translate }}\'></div><div class=col-6><label>{{ \'drivers:add:form:insurance_company:text\' | translate }}</label><!--<span class=\"help-inline\" ng-show=\"postDriverFormName.insurance_company.$error.required\">*</span>--> <input type=text name=insurance_company class=form-control ng-model=driversadd.dataNewDriver.bond_insurance_comp placeholder=\'{{ \"drivers:add:form:insurance_company:text\" | translate }}\'></div></div></div><div class=form-group><div class=row><div class=col-6><label>{{ \'drivers:add:form:coupon_insurance:text\' | translate }}</label><!--<span class=\"help-inline\" ng-show=\"postDriverFormName.coupon_insurance.$error.required\">*</span>--> <input type=text name=coupon_insurance class=form-control ng-model=driversadd.dataNewDriver.bond_insurance_num_policy placeholder=\'{{ \"drivers:add:form:coupon_insurance:text\" | translate }}\'></div><div class=col-6><label>{{ \'drivers:add:form:license_number:text\' | translate }}</label><span class=help-inline ng-show=postDriverFormName.license_number.$error.required>*</span> <input type=text name=license_number class=form-control ng-model=driversadd.dataNewDriver.driver_license_num placeholder=\'{{ \"drivers:add:form:license_number:text\" | translate }}\' required></div></div></div><div class=form-group><div class=row><div class=col-12><label>{{ \'drivers:add:form:truck:text\' | translate }}</label><select name=truck id=driver ng-model=driversadd.dataNewDriver.id_truck class=\"form-control input-md\"><option value=\"\">{{ \'drivers:add:form:truck:any\' | translate }}</option><option ng-repeat=\"option in driversadd.trucksList\" value={{option.id}}>ID: {{option.id}} - {{option.brand}} {{option.marca}} {{option.model}}</option></select></div></div></div></div></div><div class=\"row main-botonera\"><div class=\"col-12 col-sm-9\"><button ng-disabled=driversadd.savingNewDriver type=submit class=\"btn btn-class1 bg-color-9 color-black\">{{ \'loads:add:form:btn:save_post_next\' | translate }}</button> <a ng-disabled=driversadd.savingNewDriver ng-click=driversadd.submitReturnListFunc(postDriverFormName) class=\"normal-link color-black small-text\">{{ \'loads:add:form:btn:save_return_list\' | translate }}</a></div><div class=\"col-12 col-sm-3 text-right\"><a ng-if=!driversadd.savingNewDriver ui-sref=private.drivers ui-sref-opts=\"{ reload: true }\" class=\"normal-link color-black small-text cancel-post-link\">{{ \'loads:add:form:btn:cancel\' | translate }}</a></div></div></form></div>");
$templateCache.put("app/drivers/templates/drivers.html","<div id=page-section-trucks class=\"page-section col\"><total-items></total-items><div class=\"col content-truck-list bg-color-white\"><h3 class=\"large-title title-section\">{{ \'drivers:section:title\' | translate }}</h3><br><div class=row><div class=\"col col-sm-6\"><input type=text class=pull-l name=driver_name_filter ng-model=drivers.driverOptions.driver_name ng-enter=drivers.setDriverNameFilter() ng-blur=drivers.setDriverNameFilter() placeholder=\"{{\'drivers:list:input:driver_name:filter\' | translate}}\"></div><div class=\"col col-sm-6 text-right botonera-list\"><div class=\"btn bg-color-9 color-black\" permission permission-only=\"[\'CARRIER\',\'OWNER\']\"><upload-component></upload-component></div><a permission permission-only=\"[\'CARRIER\']\" ui-sref=private.drivers.add ui-sref-opts=\"{ reload: true }\" class=\"btn btn-class1 bg-color-9 color-black\">{{ \'drivers:new_driver:btn\' | translate }}</a> <a permission permission-only=\"[\'OWNER\']\" ng-click=drivers.addDriverByOwnerMsg() class=\"btn btn-class1 bg-color-9 color-black\">{{ \'drivers:new_driver:btn\' | translate }}</a></div></div><div class=row><ul permission permission-only=\"[\'CARRIER\',\'OWNER\']\" class=\"nav nav-tabs nav-tabs-full-w\" role=tablist><li class=nav-item><a ng-class=\"{active: drivers.driverOptions.shortcut == \'all\' }\" class=\"nav-link custom-nav-link\" data-toggle=tab ng-click=\"drivers.changeCategory(\'all\')\" role=tab>{{ \'drivers:list:all:title\' | translate }}</a></li><li class=nav-item><a class=\"nav-link custom-nav-link\" data-toggle=tab ng-click=\"drivers.changeCategory(\'active\')\" role=tab>{{ \'drivers:list:active:title\' | translate }}</a></li><li class=nav-item><a class=\"nav-link custom-nav-link\" data-toggle=tab ng-click=\"drivers.changeCategory(\'inactive\')\" role=tab>{{ \'drivers:list:inactive:title\' | translate }}</a></li></ul></div><div class=\"tab-content tab-content-full-w\"><div class=\"tab-pane active\" id=content_trucks_tab role=tabpanel><div class=\"full-width content-tableData\"><table datatable=\"\" dt-options=drivers.datatableOptions dt-columns=drivers.dtColumns class=tableDataSort width=100% border=0><tbody permission permission-only=\"[\'CARRIER\',\'OWNER\']\"><tr ng-if=!drivers.driversList.length><td colspan=13><p class=text-center>{{ \"drivers:list:empty:text\" | translate }}</p></td></tr><tr ng-repeat-start=\"driver in drivers.driversList\"><td><img ng-if=driver.driver_img ng-src={{driver.driver_img}} class=\"img-fluid rounded-circle\" border=0></td><td class=info-truck><p class=truck-name-table>{{driver.driver_name}}</p><span class=driver-name-table>{{ \"drivers:details:driver_company_id:title\" | translate }}: {{driver.id_integration_drivers}}</span><br><span class=driver-name-table>{{driver.driver_details}}</span><br><span ng-if=\"driver.trucks.length > 0\" class=driver-name-table>{{\'drivers:details:truck_assigned:singular\' | translate }}: {{driver.trucks[0].brand}} {{driver.trucks[0].model}} - {{\'trucks:list:input:truck_id:filter\' | translate }}: {{driver.trucks[0].id}}</span> <a ng-if=\"driver.trucks.length > 0\" ng-click=drivers.goToSeeTruckId(driver.trucks[0].id) class=\"small-text normal-link pointer\">{{\'drivers:details:truck_assigned:go_to_see\' | translate }}</a> <span ng-if=\"driver.trucks.length <= 0\" class=driver-name-table>{{\'drivers:details:truck_assigned:empty\' | translate }}</span></td><td ng-bind-html=driver.driver_status></td><td><i ng-if=!driver.expanded ng-click=drivers.showDetailsUnique(driver.user_id) class=\"fa fa-angle-down show-load-details-btn\"></i> <i ng-if=driver.expanded ng-click=drivers.showDetailsUnique(driver.user_id) class=\"fa fa-angle-up show-load-details-btn\"></i></td></tr><tr class=detail-truck-table ng-repeat-end><td ng-if=driver.expanded colspan=12 class=no-padding><driver-details-row driver-info=driver></driver-details-row></td></tr></tbody></table></div></div></div></div></div>");
$templateCache.put("app/drivers/templates/edit.html","<div id=page-section-post-truck class=\"page-section page-section-with-margin col bg-color-white\"><ul permission permission-only=[] ng-if=\"driversedit.documents.length > 0\" class=\"nav nav-tabs nav-tabs-full-w\" role=tablist><li class=nav-item><a ng-class=\"{active: driversedit.isSet(1) }\" class=\"nav-link custom-nav-link\" data-toggle=tab ng-click=driversedit.setTab(1) role=tab>{{ \'drivers:edit:section:title\' | translate }}</a></li><li class=nav-item><a ng-class=\"{active: driversedit.isSet(2) }\" class=\"nav-link custom-nav-link\" data-toggle=tab ng-click=driversedit.setTab(2) role=tab>{{ \'profile:section:document:title\' | translate }}</a></li></ul><form method=post id=postDriverFormId name=postDriverFormName ng-submit=driversedit.save(postDriverFormName) novalidate><div class=\"tab-pane active\" role=tabpanel ng-show=driversedit.isSet(1)><h3 class=\"large-title title-section\">{{ \'drivers:edit:section:title\' | translate }}</h3><div ng-include=\"\'app/drivers/templates/tabs/tab-drive.html\'\"></div></div><div class=tab-pane role=tabpanel ng-show=driversedit.isSet(2)><h3 class=\"large-title title-profile\">{{\'profile:section:document:title\' | translate }}</h3><upload-document data=driversedit.user></upload-document></div></form></div>");
$templateCache.put("app/fastpay/templates/fast-pay.html","<div id=page-section-loads class=\"page-section col\"><total-items></total-items><div class=\"col content-load-list bg-color-white\"><h3 class=\"large-title title-section\">{{ \'fastpay:section:title\' | translate }}</h3><p class=small-text>{{ \'fastpay:section:descrip\' | translate }}</p><p class=small-text>{{ \'fastpay:section:descrip2\' | translate }}</p><ol><li class=small-text ng-repeat=\"x in [1,2,3,4]\">{{ \'fastpay:section:descrip:list:\'+x | translate }}</li></ol><h3 class=\"regular-text parrafo\">{{ \'fastpay:status:title\' | translate }}</h3><p ng-if=\"!fastpay.loadingData && fastpay.fastPayData.factoring_status == 1\" class=\"small-text title-section color-lemon-green\">{{ \'fastpay:status:approved:text\' | translate }}</p><p ng-if=\"!fastpay.loadingData && fastpay.fastPayData.factoring_status == 0\" class=\"small-text title-section color-pastel-red\">{{ \'fastpay:status:not_approved:text\' | translate }}</p><p ng-if=fastpay.loadingData class=\"small-text title-section\">---</p><h3 class=\"regular-text parrafo\">{{ \'fastpay:factoring_details:title\' | translate }}</h3><p class=\"small-text title-section\">----</p><h3 class=\"regular-text parrafo\">{{ \'fastpay:last_loads:title\' | translate }}</h3><main-loader ng-if=fastpay.loadingData></main-loader><div ng-if=!fastpay.loadingData class=\"full-width content-tableData\"><table datatable=ng dt-options=fastpay.datatableOptions class=tableDataSort width=100% border=0><thead><tr><th>{{ \'loads:table:column:profile_img\' | translate }}</th><th>{{ \'loads:table:column:shipper\' | translate }}</th><th>{{ \'loads:table:column:origin\' | translate }}</th><th>{{ \'loads:table:column:destination\' | translate }}</th><th>{{ \'loads:table:column:pickup\' | translate }}</th><th>{{ \'loads:table:column:delivery\' | translate }}</th><th>{{ \'loads:table:column:length\' | translate }}</th><th>{{ \'loads:table:column:weight\' | translate }}</th><th>{{ \'loads:table:column:size\' | translate }}</th><th>{{ \'loads:table:column:price\' | translate }}</th><th>{{ \'loads:table:column:ago\' | translate }}</th><th>{{ \'loads:table:column:status\' | translate }}</th><th>{{ \'loads:table:column:actions\' | translate }}</th></tr></thead><tbody><tr ng-repeat-start=\"load in fastpay.fastPayData.results\"><td><img ng-if=load.img_shipper ng-src={{load.img_shipper}} width=30 border=0></td><td>{{load.full_name_shipper}}</td><td>{{load.from}}</td><td>{{load.to}}</td><td>{{load.pickup_date_formatted}}</td><td>{{load.delivery_date_formatted}}</td><td>{{load.length_loads}}</td><td>{{load.weight}}</td><td>{{load.dimension}}</td><td>${{load.price}}</td><td am-time-ago=load.load_date></td><td ng-bind-html=load.status_btn></td><td><i ng-if=!load.expanded ng-click=fastpay.showDetailsUnique(load.load_id) class=\"fa fa-angle-down show-load-details-btn\"></i> <i ng-if=load.expanded ng-click=fastpay.showDetailsUnique(load.load_id) class=\"fa fa-angle-up show-load-details-btn\"></i></td></tr><tr class=detail-load-table ng-repeat-end><td ng-if=load.expanded colspan=13 class=no-padding><load-details-row load-id=load.load_id></load-details-row></td></tr></tbody></table></div></div></div>");
$templateCache.put("app/interestpoint/templates/interest-points.html","<div id=page-section-home class=\"page-section col\"><total-items></total-items><div class=\"col content-load-list bg-color-white\"><div class=row><div id=home_map class=\"col col-md-4 pull-l hidden-sm-down no-padding\"><div ng-if=!interestpoints.loadingMap><ui-gmap-google-map center=interestpoints.map.center zoom=interestpoints.map.zoom><ui-gmap-marker ng-repeat=\"m in interestpoints.mapMarkers\" coords=m.coords options=m.options idkey=m.id><ui-gmap-window><div class=windowmap-interestpoints><p class=place-title><img ng-src={{m.details.image}} class=\"pull-l img-windowmap\" border=0> {{m.details.name}}</p><div class=clearfix></div><p class=place-details><span>{{ \'interestpoints:nearby_points:place:type:title\' | translate }}:</span> {{m.details.type | capitalize }}</p><p class=place-details><span>{{ \'interestpoints:nearby_points:place:schedule:title\' | translate }}:</span> {{m.details.opening | capitalize }}</p><p class=place-details ng-class=\"\'place-\'+m.details.status\"><span>{{ \'interestpoints:nearby_points:place:status:title\' | translate }}:</span> {{ \'interestpoints:nearby_points:place:\'+m.details.status+\':text\' | translate }}</p></div></ui-gmap-window></ui-gmap-marker></ui-gmap-google-map></div></div><div class=\"col col-md-8 pull-l load-list-home\"><h3 permission permission-only=\"[\'CARRIER\', \'DRIVER\', \'OWNER\']\" class=large-title>{{ \'interestpoints:nearby_points:title\' | translate }}</h3><div class=row><div class=\"col text-right botonera-list\"><div class=dropdown><button class=\"btn btn-secondary dropdown-toggle\" type=button id=dropdownMenuButton data-toggle=dropdown aria-haspopup=true aria-expanded=false><span class=\"fa fa-filter\"></span></button><div class=\"dropdown-menu dropdown-menu-right\" aria-labelledby=dropdownMenuButton><div ng-click=interestpoints.setFilterPoints() ng-repeat=\"filter in interestpoints.filterList\" class=dropdown-item><input type=checkbox id={{filter.name}} name={{filter.name}} ng-model=filter.checked class=custom-checkbox><label for={{filter.name}}><span></span>{{filter.full_name}}</label></div></div></div></div></div><main-loader ng-if=interestpoints.loadingData></main-loader><div ng-if=!interestpoints.loadingData class=\"full-width content-tableData\"><table permission permission-only=\"[\'CARRIER\', \'DRIVER\', \'OWNER\']\" datatable=ng dt-options=interestpoints.datatableOptions class=\"tableDataSort table-interestpoints\" width=100% border=0><thead><tr><th></th><th></th></tr></thead><tbody><tr ng-repeat=\"item in interestpoints.nearbyPoints\"><td width=20%><img ng-src=\"https://maps.googleapis.com/maps/api/place/photo?maxwidth=400&photoreference={{item.photos[0].photo_reference}}&key={{interestpoints.apikeymaps}}\" class=img-fluid border=0></td><td width=80%><p ng-if=item.name class=place-title>{{item.name}}</p><p ng-if=!item.name class=place-title>--</p><p ng-if=item.types[0] class=place-details><span>{{ \'interestpoints:nearby_points:place:type:title\' | translate }}:</span> {{item.types[0] | capitalize }}</p><p ng-if=!item.types[0] class=place-details><span>{{ \'interestpoints:nearby_points:place:type:title\' | translate }}:</span> --</p><p ng-if=item.opening_hours.weekday_text.length class=place-details><span>{{ \'interestpoints:nearby_points:place:schedule:title\' | translate }}:</span></p><p ng-if=!item.opening_hours.weekday_text.length class=place-details><span>{{ \'interestpoints:nearby_points:place:schedule:title\' | translate }}:</span> --</p><p ng-if=item.opening_hours.weekday_text.length ng-repeat=\"weekday_txt in item.opening_hours.weekday_text\" class=place-details>{{weekday_txt}}</p><p ng-if=\"item.opening_hours && item.opening_hours.open_now\" class=\"place-details place-open\"><span>{{ \'interestpoints:nearby_points:place:status:title\' | translate }}:</span> {{ \'interestpoints:nearby_points:place:open:text\' | translate }}</p><p ng-if=\"item.opening_hours && !item.opening_hours.open_now\" class=\"place-details place-close\"><span>{{ \'interestpoints:nearby_points:place:status:title\' | translate }}:</span> {{ \'interestpoints:nearby_points:place:close:text\' | translate }}</p><p ng-if=!item.opening_hours class=place-details><span>{{ \'interestpoints:nearby_points:place:status:title\' | translate }}:</span> --</p></td></tr></tbody></table></div></div></div></div></div>");
$templateCache.put("app/loads/templates/add.html","<div id=page-section-post-load class=\"page-section page-section-with-margin col bg-color-white\"><h3 class=\"large-title title-section\">{{ \'loads:add:section:title\' | translate }}</h3><form method=post id=postLoadFormId name=postLoadFormName ng-submit=loadsadd.save(postLoadFormName) novalidate><div class=row><div class=\"col-12 col-sm-9\"><hr><div ng-include=\"\'app/loads/templates/directives/load-add-basic.html\'\"></div><hr><div ng-include=\"\'app/loads/templates/directives/load-add-technical.html\'\"></div><hr><div ng-include=\"\'app/loads/templates/directives/load-add-type.html\'\"></div></div><div class=\"col-12 col-sm-3\"></div></div><div class=\"row main-botonera\"><div class=\"col-12 col-sm-9\"><button ng-disabled=loadsadd.savingNewLoad type=submit class=\"btn btn-class1 bg-color-9 color-black\">{{ \'loads:add:form:btn:save_post_next\' | translate }}</button> <a ng-disabled=loadsadd.savingNewLoad ng-click=loadsadd.submitReturnListFunc(postLoadFormName) class=\"normal-link color-black small-text\">{{ \'loads:add:form:btn:save_return_list\' | translate }}</a></div><div class=\"col-12 col-sm-3 text-right\"><a ng-if=!loadsadd.savingNewLoad ui-sref=private.loads ui-sref-opts=\"{ reload: true }\" class=\"normal-link color-black small-text cancel-post-link\">{{ \'loads:add:form:btn:cancel\' | translate }}</a></div></div></form></div>");
$templateCache.put("app/loads/templates/details.html","<div id=page-section-post-load class=\"page-section page-section-with-margin col bg-color-white\"><ul class=\"nav nav-tabs nav-tabs-full-w\" role=tablist><li class=nav-item><a ng-class=\"{active: loadsdetails.isSet(1) }\" class=\"nav-link custom-nav-link\" data-toggle=tab ng-click=loadsdetails.setTab(1) role=tab>Detalles de la carga</a></li><li class=nav-item><a ng-class=\"{active: loadsdetails.isSet(2) }\" class=\"nav-link custom-nav-link\" data-toggle=tab ng-click=loadsdetails.setTab(2) role=tab>{{ \'loads:details:options:stops\' | translate }}</a></li></ul><div class=\"tab-tab-content tab-content-full-w\"><form method=post><div class=\"tab-pane active\" role=tabpanel ng-show=loadsdetails.isSet(1)><h3 class=\"large-title title-profile\">Detalles de la carga</h3><br><br><div ng-include=\"\'app/loads/templates/tabs/tab-details-loads.html\'\"></div></div><div class=tab-pane role=tabpanel ng-show=loadsdetails.isSet(2)><h3 class=\"large-title title-profile\">{{ \'loads:details:options:stops\' | translate }}</h3><br><br><stop-component></stop-component></div></form></div></div>");
$templateCache.put("app/loads/templates/edit.html","<div id=page-section-post-load class=\"page-section page-section-with-margin col bg-color-white\"><h3 class=\"large-title title-section\">{{ \'loads:edit:section:title\' | translate }}</h3><form method=post id=postLoadFormId name=postLoadFormName ng-submit=loadsedit.save(postLoadFormName) novalidate><div class=row><div class=\"col-12 col-sm-9\"><hr><div ng-include=\"\'app/loads/templates/directives/load-edit-basic.html\'\"></div><hr><div ng-include=\"\'app/loads/templates/directives/load-edit-technical.html\'\"></div><hr><div ng-include=\"\'app/loads/templates/directives/load-edit-type.html\'\"></div></div><div class=\"col-12 col-sm-3\"><button ng-disabled=loadsedit.fileSaving ngf-select=\"loadsedit.uploadLegalDoc($file, $invalidFiles)\" ngf-accept=\"\'image/jpg, image/jpeg\'\" class=\"btn btn-class1 bg-color-9 color-black mb-3\"><main-loader ng-if=loadsedit.fileSaving></main-loader><span ng-show=!loadsedit.fileSaving>{{ \'loads::add:form:upload_doc:btn\' | translate }}</span></button><p class=d-none ng-class=\"{\'d-block\': (!loadsedit.loadFilesPdfList.length && !loadsedit.loadFilesList.length)}\">{{ \'loads:details:documents:empty\' | translate }}</p><div ng-if=loadsedit.loadFilesList.length ng-image-gallery images=loadsedit.loadFilesList></div><ul ng-if=loadsedit.loadFilesPdfList.length class=\"nav documents-list\"><li class=\"nav-item parrafo\" ng-repeat=\"file in loadsedit.loadFilesPdfList\"><md-tooltip md-direction=top>{{file.invoice_name}}</md-tooltip><a href={{file.url}} class=\"normal-link small-text upload-link pointer\" target=_blank><span alt={{fileLegal.title}} class=\"fa fa-file-pdf-o\"></span><br><span>{{file.invoice_name | limitTo : 15}}</span></a></li></ul><ul ng-if=loadsedit.loadLegalDocsFilesList.length class=\"nav documents-list\"><li class=\"nav-item parrafo\" ng-repeat=\"fileLegal in loadsedit.loadLegalDocsFilesList\"><md-tooltip md-direction=top>{{fileLegal.invoice_name}}</md-tooltip><a href={{fileLegal.url}} target=_blank><span alt={{fileLegal.title}} class=\"fa fa-file-pdf-o\"></span><br><span>{{fileLegal.invoice_name | limitTo : 15}}</span></a></li></ul></div></div><div class=\"row main-botonera\"><div class=\"col-12 col-sm-9\"><button class=\"btn btn-class1 bg-color-9 color-black\" type=submit ng-disabled=loadsedit.savingUpdateLoad>{{ \'loads:add:form:btn:save_post_next\' | translate }}</button></div><div class=\"col-12 col-sm-3 text-right\"><a ng-if=!loadsedit.savingUpdateLoad ui-sref=private.loads ui-sref-opts=\"{ reload: true }\" class=\"normal-link color-black small-text cancel-post-link\">{{ \'loads:add:form:btn:cancel\' | translate }}</a></div></div></form></div>");
$templateCache.put("app/loads/templates/loads-log.html","<div id=page-section-loads class=\"page-section col\"><total-items></total-items><div class=\"col content-load-list bg-color-white\"><h3 class=\"large-title title-section\">{{ \'loadslog:section:title\' | translate }}</h3><div class=row><div class=\"col text-right botonera-list\"><a ng-click=loadslog.openSearchLoadsLogsModal() class=\"btn btn-class2 bg-color-9 color-black\"><span class=\"fa fa-calendar-o\"></span> {{ \'loadslog:options:filter:text\' | translate }}</a></div></div><div class=\"full-width content-tableData\"><h6>{{ \'loads:list:count\' | translate:{ count: loadslog.countLoads } }}</h6><table datatable=\"\" dt-options=loadslog.datatableOptions dt-columns=loadslog.dtColumns class=tableDataSort width=100% border=0><thead><tr><th permission permission-only=\"\'GENERADOR_CARGA\'\">{{\"loads:table:column:status\" | translate}}</th><th permission permission-only=\"\'GENERADOR_CARGA\'\">{{\"loads:table:column:origin\" | translate}}</th><th permission permission-only=\"\'GENERADOR_CARGA\'\">{{\"loads:table:column:destination\" | translate}}</th><th permission permission-only=\"\'GENERADOR_CARGA\'\">{{\"loads:table:column:pickup\" | translate}}</th><th permission permission-only=\"\'GENERADOR_CARGA\'\">{{\"loads:table:column:delivery\" | translate}}</th><th permission permission-only=\"\'GENERADOR_CARGA\'\">{{\"loads:table:column:distance\" | translate}}</th><th permission permission-only=\"\'GENERADOR_CARGA\'\">{{\"loads:table:column:length\" | translate}}</th><th permission permission-only=\"\'GENERADOR_CARGA\'\">{{\"loads:table:column:weight\" | translate}}</th><th permission permission-only=\"\'GENERADOR_CARGA\'\">{{\"loads:table:column:size\" | translate}}</th><th permission permission-only=\"\'GENERADOR_CARGA\'\">{{\"loads:table:column:price\" | translate}}</th><th permission permission-only=\"\'GENERADOR_CARGA\'\">{{\"loads:table:column:ago\" | translate}}</th><th permission permission-only=\"\'GENERADOR_CARGA\'\">{{\"loads:table:column:actions\" | translate}}</th><th permission permission-only=\"[\'CARRIER\', \'DRIVER\', \'OWNER\']\">{{\"loads:table:column:profile_img\" | translate}}</th><th permission permission-only=\"[\'CARRIER\', \'DRIVER\', \'OWNER\']\">{{\"loads:table:column:shipper\" | translate}}</th><th permission permission-only=\"[\'CARRIER\', \'DRIVER\', \'OWNER\']\">{{\"loads:table:column:origin\" | translate}}</th><th permission permission-only=\"[\'CARRIER\', \'DRIVER\', \'OWNER\']\">{{\"loads:table:column:destination\" | translate}}</th><th permission permission-only=\"[\'CARRIER\', \'DRIVER\', \'OWNER\']\">{{\"loads:table:column:pickup\" | translate}}</th><th permission permission-only=\"[\'CARRIER\', \'DRIVER\', \'OWNER\']\">{{\"loads:table:column:delivery\" | translate}}</th><th permission permission-only=\"[\'CARRIER\', \'DRIVER\', \'OWNER\']\">{{\"loads:table:column:length\" | translate}}</th><th permission permission-only=\"[\'CARRIER\', \'DRIVER\', \'OWNER\']\">{{\"loads:table:column:weight\" | translate}}</th><th permission permission-only=\"[\'CARRIER\', \'DRIVER\', \'OWNER\']\">{{\"loads:table:column:size\" | translate}}</th><th permission permission-only=\"[\'CARRIER\', \'DRIVER\', \'OWNER\']\">{{\"loads:table:column:price\" | translate}}</th><th permission permission-only=\"[\'CARRIER\', \'DRIVER\', \'OWNER\']\">{{\"loads:table:column:ago\" | translate}}</th><th permission permission-only=\"[\'CARRIER\', \'DRIVER\', \'OWNER\']\">{{\"loads:table:column:status\" | translate}}</th><th permission permission-only=\"[\'CARRIER\', \'DRIVER\', \'OWNER\']\">{{\"loads:table:column:actions\" | translate}}</th></tr></thead><tbody permission permission-only=\"\'GENERADOR_CARGA\'\"><tr ng-if=!loadslog.loadsList.length><td colspan=13><p class=text-center>{{ \"loads:list:empty:text\" | translate }}</p></td></tr><tr ng-repeat-start=\"loadlog in loadslog.loadsList\"><td class=tags-row colspan=13><div class=\"tag_item bg-color-5 color-armadillo\" ng-if=\"loadlog.posteverywhere == \'3\'\"><strong>{{ \"loads:table:tag:premium:text\" | translate }}</strong></div><div class=\"tag_item bg-color-9 color-black\" ng-if=\"loadlog.posteverywhere == \'2\'\"><strong>{{ \"loads:table:tag:standard:text\" | translate }}</strong></div></td></tr><tr><td ng-bind-html=loadlog.status_btn></td><td>{{loadlog.from}}</td><td>{{loadlog.to}}</td><td>{{loadlog.pickup_date_formatted}}</td><td>{{loadlog.delivery_date_formatted}}</td><td>{{loadlog.distance}}</td><td>{{loadlog.length_loads}}</td><td>{{loadlog.weight}}</td><td>{{loadlog.dimension}}</td><td>{{loadlog.price_to_show}}</td><td am-time-ago=loadlog.load_date></td><td><i ng-if=!loadlog.expanded ng-click=loadslog.showDetailsUnique(loadlog.load_id) class=\"fa fa-angle-down show-load-details-btn\"></i> <i ng-if=loadlog.expanded ng-click=loadslog.showDetailsUnique(loadlog.load_id) class=\"fa fa-angle-up show-load-details-btn\"></i></td></tr><tr class=detail-load-table ng-repeat-end><td ng-if=loadlog.expanded colspan=12 class=no-padding><load-details-row load-id=loadlog.load_id></load-details-row></td></tr></tbody><tbody permission permission-only=\"[\'CARRIER\', \'DRIVER\', \'OWNER\']\"><tr ng-if=!loadslog.loadsList.length><td colspan=13><p class=text-center>{{ \"loads:list:empty:text\" | translate }}</p></td></tr><tr ng-repeat-start=\"loadlog in loadslog.loadsList\"><td class=tags-row colspan=13><div class=\"tag_item bg-color-5 color-armadillo\" ng-if=\"loadlog.posteverywhere == \'3\'\"><strong>{{ \"loads:table:tag:premium:text\" | translate }}</strong></div><div class=\"tag_item bg-color-9 color-black\" ng-if=\"loadlog.posteverywhere == \'2\'\"><strong>{{ \"loads:table:tag:standard:text\" | translate }}</strong></div></td></tr><tr><td><img ng-if=load.img_shipper ng-src={{loadlog.img_shipper}} width=30 border=0></td><td>{{loadlog.full_name_shipper}}</td><td>{{loadlog.from}}</td><td>{{loadlog.to}}</td><td>{{loadlog.pickup_date_formatted}}</td><td>{{loadlog.delivery_date_formatted}}</td><td>{{loadlog.length_loads}}</td><td>{{loadlog.weight}}</td><td>{{loadlog.dimension}}</td><td>{{loadlog.price_to_show}}</td><td am-time-ago=loadlog.load_date></td><td ng-bind-html=loadlog.status_btn></td><td><i ng-if=!loadlog.expanded ng-click=loadslog.showDetailsUnique(loadlog.load_id) class=\"fa fa-angle-down show-load-details-btn\"></i> <i ng-if=loadlog.expanded ng-click=loadslog.showDetailsUnique(loadlog.load_id) class=\"fa fa-angle-up show-load-details-btn\"></i></td></tr><tr class=detail-load-table ng-repeat-end><td ng-if=loadlog.expanded colspan=12 class=no-padding><load-details-row load-id=loadlog.load_id posteverywhere=loadlog.posteverywhere></load-details-row></td></tr></tbody></table><div class=text-center><pagination on-change=loadslog.changePage(page) list=\"{{ {page: loadslog.loads.current_page,total: loadslog.loads.total_pages} }}\"></pagination></div></div></div></div>");
$templateCache.put("app/loads/templates/loads.html","<div id=page-section-loads class=\"page-section col\"><div class=\"alert alert-info\" role=alert ng-show=\"loads.resources.length > 0 && (loads.dataUser.user_status == \'0\' || loads.documentations.length < 8)\"><a ng-href ng-click=loads.redirectProfile() class=\"small-text normal-link\">{{ \'home:message_document:label\' | translate }}</a></div><total-items></total-items><div class=\"col content-load-list bg-color-white\"><h3 class=\"large-title title-section\">{{ \'loads:section:title\' | translate }}</h3><div class=row ng-if=!loads.v2 ng-show=loads.dataUser.user_status><div class=\"col text-right botonera-list\" permission permission-only=\"\'GENERADOR_CARGA\'\"><div class=row><div class=col-sm-10><div class=\"btn bg-color-9 color-black\" ng-hide=true><upload-component></upload-component></div></div><div class=col-sm-2><a ui-sref=private.loads.add ui-sref-opts=\"{ reload: true }\" class=\"btn btn-class1 bg-color-9 color-black\">{{ \'loads:new_load:btn\' | translate }}</a></div></div></div></div><div class=row ng-if=loads.v2><div class=\"col text-right botonera-list\"><button permission permission-only=\"\'GENERADOR_CARGA\'\" ui-sref=private.loads.register ui-sref-opts=\"{ reload: true }\" class=\"btn btn-class1 bg-color-9 color-black\">{{ \'loads:new_load:btn\' | translate }}</button></div></div><div ng-include=\"\'app/loads/templates/directives/load-tab.html\'\"></div><div class=\"tab-content tab-content-full-w\"><div class=\"tab-pane active\" id=content_loads_tab role=tabpanel><h6 class=loads-found-number>{{ \'loads:list:count\' | translate:{ count: loads.countLoads } }}</h6><input ng-if=\"loads.loadsOptions.search_type != \'my_search\'\" type=number class=pull-r name=load_id_filter ng-model=loads.loadsOptions.id_load ng-enter=loads.loadTab() placeholder=\"{{\'modals:search_load:fields:load_id:title\' | translate}}\"><div class=\"full-width content-tableData\"><table datatable=\"\" dt-options=loads.datatableOptions class=tableDataSort dt-columns=loads.dtColumns width=100% border=0><thead><tr><th permission permission-only=\"\'GENERADOR_CARGA\'\">{{\"loads:table:column:status\" | translate}}</th><th permission permission-only=\"\'GENERADOR_CARGA\'\">{{\"loads:table:column:origin\" | translate}}</th><th permission permission-only=\"\'GENERADOR_CARGA\'\">{{\"loads:table:column:destination\" | translate}}</th><th permission permission-only=\"\'GENERADOR_CARGA\'\">{{\"loads:table:column:pickup\" | translate}}</th><th permission permission-only=\"\'GENERADOR_CARGA\'\">{{\"loads:table:column:delivery\" | translate}}</th><th permission permission-only=\"\'GENERADOR_CARGA\'\">{{\"loads:table:column:distance\" | translate}}</th><th permission permission-only=\"\'GENERADOR_CARGA\'\">{{\"loads:table:column:length\" | translate}}</th><th permission permission-only=\"\'GENERADOR_CARGA\'\">{{\"loads:table:column:weight\" | translate}}</th><th permission permission-only=\"\'GENERADOR_CARGA\'\">{{\"loads:table:column:size\" | translate}}</th><th permission permission-only=\"\'GENERADOR_CARGA\'\">{{\"loads:table:column:price\" | translate}}</th><th permission permission-only=\"\'GENERADOR_CARGA\'\">{{\"loads:table:column:ago\" | translate}}</th><th permission permission-only=\"\'GENERADOR_CARGA\'\">{{\"loads:table:column:actions\" | translate}}</th><th permission permission-only=\"[\'CARRIER\', \'DRIVER\', \'OWNER\']\">{{\"loads:table:column:profile_img\" | translate}}</th><th permission permission-only=\"[\'CARRIER\', \'DRIVER\', \'OWNER\']\">{{\"loads:table:column:shipper\" | translate}}</th><th permission permission-only=\"[\'CARRIER\', \'DRIVER\', \'OWNER\']\">{{\"loads:table:column:origin\" | translate}}</th><th permission permission-only=\"[\'CARRIER\', \'DRIVER\', \'OWNER\']\">{{\"loads:table:column:destination\" | translate}}</th><th permission permission-only=\"[\'CARRIER\', \'DRIVER\', \'OWNER\']\">{{\"loads:table:column:pickup\" | translate}}</th><th permission permission-only=\"[\'CARRIER\', \'DRIVER\', \'OWNER\']\">{{\"loads:table:column:delivery\" | translate}}</th><th permission permission-only=\"[\'CARRIER\', \'DRIVER\', \'OWNER\']\">{{\"loads:table:column:length\" | translate}}</th><th permission permission-only=\"[\'CARRIER\', \'DRIVER\', \'OWNER\']\">{{\"loads:table:column:weight\" | translate}}</th><th permission permission-only=\"[\'CARRIER\', \'DRIVER\', \'OWNER\']\">{{\"loads:table:column:size\" | translate}}</th><th permission permission-only=\"[\'CARRIER\', \'DRIVER\', \'OWNER\']\">{{\"loads:table:column:price\" | translate}}</th><th permission permission-only=\"[\'CARRIER\', \'DRIVER\', \'OWNER\']\">{{\"loads:table:column:ago\" | translate}}</th><th permission permission-only=\"[\'CARRIER\', \'DRIVER\', \'OWNER\']\">{{\"loads:table:column:status\" | translate}}</th><th permission permission-only=\"[\'CARRIER\', \'DRIVER\', \'OWNER\']\">{{\"loads:table:column:actions\" | translate}}</th></tr></thead><tbody permission permission-only=\"\'GENERADOR_CARGA\'\"><tr ng-if=\"loads.loads.results.length == 0\"><td colspan=13><p class=text-center>{{ \"loads:list:empty:text\" | translate }}</p></td></tr><tr ng-repeat-start=\"load in loads.loads.results\"><td class=tags-row colspan=13><div class=\"tag_item bg-color-5 color-armadillo\" ng-if=\"load.posteverywhere == \'3\'\"><strong>{{ \"loads:table:tag:premium:text\" | translate }}</strong></div><div class=\"tag_item bg-color-9 color-black\" ng-if=\"load.posteverywhere == \'2\'\"><strong>{{ \"loads:table:tag:standard:text\" | translate }}</strong></div></td></tr><tr><td ng-bind-html=load.status_btn></td><td>{{load.from}}</td><td>{{load.to}}</td><td>{{load.pickup_date_formatted}}</td><td>{{load.delivery_date_formatted}}</td><td>{{load.distance}}</td><td>{{load.length_loads}}</td><td>{{load.weight}}</td><td>{{load.dimension}}</td><td>{{load.price_to_show}}</td><td am-time-ago=load.load_date></td><td><i ng-if=!load.expanded ng-click=loads.showDetailsUnique(load.load_id) class=\"fa fa-angle-down show-load-details-btn\"></i> <i ng-if=load.expanded ng-click=loads.showDetailsUnique(load.load_id) class=\"fa fa-angle-up show-load-details-btn\"></i></td></tr><tr class=detail-load-table ng-repeat-end><td ng-if=load.expanded colspan=12 class=no-padding><load-details-row load-id=load.load_id reload-parent=loads.reloadList()></load-details-row></td></tr></tbody><tbody permission permission-only=\"[\'CARRIER\', \'DRIVER\', \'OWNER\']\"><tr ng-if=\"loads.loads.results.length == 0\"><td colspan=13><p class=text-center>{{ \"loads:list:empty:text\" | translate }}</p></td></tr><tr ng-repeat-start=\"load in loads.loads.results\"><td class=tags-row colspan=13><div class=\"tag_item bg-color-5 color-armadillo\" ng-if=\"load.posteverywhere == \'3\'\"><strong>{{ \"loads:table:tag:premium:text\" | translate }}</strong></div><div class=\"tag_item bg-color-3 color-armadillo\" ng-if=\"load.posteverywhere == \'2\'\"><strong>{{ \"loads:table:tag:standard:text\" | translate }}</strong></div><div class=\"tag_item bg-color-3 color-armadillo\" ng-if=\"load.owner_request_carriers == \'1\' && load.status_loads == \'NOT_ASSIGNED\'\"><strong>{{ \"loads:table:tag:applied:text\" | translate }}</strong></div></td></tr><tr><td class=info-row><img ng-if=load.img_shipper ng-src={{load.img_shipper}} width=30 border=0></td><td class=info-row>{{load.full_name_shipper}}</td><td class=info-row>{{load.from}}</td><td class=info-row>{{load.to}}</td><td class=info-row>{{load.pickup_date_formatted}}</td><td class=info-row>{{load.delivery_date_formatted}}</td><td class=info-row>{{load.length_loads}}</td><td class=info-row>{{load.weight}}</td><td class=info-row>{{load.dimension}}</td><td class=info-row>{{load.price_to_show}}</td><td class=info-row am-time-ago=load.load_date></td><td class=info-row ng-bind-html=load.status_btn></td><td class=info-row><i ng-if=\"load.load_id !== loads.currentLoadId\" ng-click=loads.showDetailsUnique(load.load_id) class=\"fa fa-angle-down show-load-details-btn\"></i> <i ng-if=\"load.load_id === loads.currentLoadId\" ng-click=loads.detachCurrentLoadId() class=\"fa fa-angle-up show-load-details-btn\"></i></td></tr><tr class=detail-load-table ng-repeat-end><td ng-if=\"load.load_id === loads.currentLoadId && load.expanded != false\" colspan=13 class=no-padding><load-details-row load-id=load.load_id reload-parent=loads.reloadList() posteverywhere=load.posteverywhere></load-details-row></td></tr></tbody></table><div class=text-center><pagination on-change=loads.changePage(page) list=\"{{ {page: loads.loads.current_page,total: loads.loads.total_pages} }}\"></pagination></div></div></div></div></div></div>");
$templateCache.put("app/loads/templates/stops.html","<style>.trax{\n    background: #D4DD55;\n  }</style><div class=\"page-section page-section-with-margin col bg-color-white\"><h3 class=\"large-title title-section\">{{ \'loads:details:options:stops\' | translate }} of the load {{load_id}}</h3><br><br><div class=\"tab-pane active\" id=content_loads_tab role=tabpanel><div class=\"full-width text-center parrafo\"><div class=row><div class=\"col mt-2\"><b>{{\'loads:details:map:conversions:title\' | translate}}</b></div><div class=\"col mt-1\" style=\"font-size: 11px\"><img src=assets/images/common/start_point.png class=\"pull-l parrafo\" width=30 border=0> {{\'loads:details:map:start_point:explanation\' | translate}}</div><div class=\"col mt-1\" style=\"font-size: 11px\"><img src=assets/images/common/end_point.png class=\"pull-l parrafo\" width=30 border=0> {{\'loads:details:map:end_point:explanation\' | translate}}</div><div class=\"col mt-1\" style=\"font-size: 11px\"><img src=assets/images/common/point_1.png class=\"pull-l parrafo\" width=30 border=0> {{\'loads:details:map:stop:explanation\' | translate}}</div></div></div><div class=\"full-width text-right parrafo\"><a ui-sref=private.loads() ui-sref-opts={} class=\"normal-link color-black\"><span class=\"fa fa-arrow-left\"></span> {{ \'loads:details:options:comeback\' | translate }}</a></div><main-loader ng-show=loading></main-loader><div class=\"full-width content-tableData\" ng-hide=loading><table datatable=\"\" class=\"tableDataSort table table-hover\" width=100% border=0><thead class=text-center><th>id</th><th>Direccion</th><th>Logitud</th><th>Latitud</th><th>Status</th><th>Acciones</th></thead><tbody><tr data-ng-show=\"items.length < 1\"><td class=text-center colspan=13><br><h5>Ningún Registro Encontrado</h5></td></tr><tr ng-repeat=\"item in items\"><td><br>{{$index + 1}}<br></td><td>{{(item.address != null)? item.address.description : \"Sin Informacion\"}}</td><td>{{(item.address != null)? item.address.latitude: \"Sin Informacion\"}}</td><td>{{(item.address != null)? item.address.longitude: \"Sin Informacion\"}}</td><td>{{item.status}}</td><td><button type=button class=\"trax btn btn-default btn-sm\" ng-click=makeFormDinamic() permission permission-only=\"[\'CARRIER\']\" title=\"Enviar evidencia\"><i class=\"fa fa-paper-plane-o\" aria-hidden=true></i></button><!--<button type=\"button\"\n                      class=\"trax btn btn-default btn-sm\"\n                      ng-click=\"editItem()\"\n                      title=\"Editar informacion\">\n                <i class=\"fa fa-text-width\" aria-hidden=\"true\"></i>\n              </button>--></td></tr></tbody></table><div class=text-center><!--<pagination on-change=\"loads.changePage(page)\" list=\"{{ {page: loads.loads.current_page,total: loads.loads.total_pages} }}\"></pagination>--></div></div></div></div>");
$templateCache.put("app/main/templates/help.html","<div id=page-section-help class=\"page-section page-section-with-margin col bg-color-white\"><div class=\"row justify-content-center\"><div class=\"header-help-about col-8 text-center\"><img src=assets/images/common/logo-by-traxion.png class=img-fluid style=\"max-width: 340px\" border=0><h5 class=\"right_reserved small-text\">{{ \"help_about:logo:foot:text\" | translate }}</h5><p class=small-text>{{ \"help_about:logo:foot:text2\" | translate }}</p></div></div><div class=\"content-faq-help full-width\"><h3 class=\"large-title underline-text\">{{ \"help_about:title:text\" | translate }}</h3><div id=accordion role=tablist aria-multiselectable=true><div class=card><div class=card-header role=tab id=headingOne><h5 class=\"mb-0 color-black\"><div data-toggle=collapse data-parent=#accordion data-target=#collapseOne aria-expanded=true aria-controls=collapseOne class=pointer>{{ \"help_about:title:terms:text\" | translate }}</div></h5></div><div id=collapseOne class=collapse role=tabpanel aria-labelledby=headingOne><div class=card-block><div id=content-terms-conditions></div></div></div></div><div class=card><div class=card-header role=tab id=headingTwo><h5 class=\"mb-0 color-black\"><div data-toggle=collapse data-parent=#accordion data-target=#collapseTwo aria-expanded=true aria-controls=collapseTwo class=pointer>{{ \"help_about:title:eula:text\" | translate }}</div></h5></div><div id=collapseTwo class=collapse role=tabpanel aria-labelledby=headingTwo><div class=card-block><div id=content-eula></div></div></div></div><div class=card><div class=card-header role=tab id=headingThree><h5 class=\"mb-0 color-black\"><div data-toggle=collapse data-parent=#accordion data-target=#collapseThree aria-expanded=true aria-controls=collapseThree class=pointer>{{ \"help_about:title:privacy_policy:text\" | translate }}</div></h5></div><div id=collapseThree class=collapse role=tabpanel aria-labelledby=headingThree><div class=card-block><div id=content-privacy-policy></div></div></div></div><div class=card><div class=card-header role=tab id=headingFour><h5 class=\"mb-0 color-black\"><div data-toggle=collapse data-parent=#accordion data-target=#collapseFour aria-expanded=true aria-controls=collapseFour class=pointer>{{ \"help_about:title:faqs:text\" | translate }}</div></h5></div><div id=collapseFour class=collapse role=tabpanel aria-labelledby=headingFour><div class=card-block><div id=content-faqs></div></div></div></div></div><div ng-if=false class=\"content-btn-contact-us full-width text-center\"><a href=\"\" class=\"btn btn-class1 bg-color-9 color-black\">{{ \"help_about:contact:btn\" | translate }}</a></div></div></div>");
$templateCache.put("app/main/templates/home.html","<div id=page-section-home class=\"page-section col\"><div class=\"alert alert-info\" role=alert ng-show=\"home.resources.length > 0 && (home.dataUser.user_status == \'0\' || home.documentations.length < 8)\"><a ng-href ng-click=home.redirectProfile() class=\"small-text normal-link\">{{ \'home:message_document:label\' | translate }}</a></div><total-items></total-items><!-- <metric-main></metric-main> --><div class=\"col content-load-list bg-color-white\"><div class=row><div id=home_map class=\"col col-md-4 pull-l hidden-sm-down no-padding\" ng-if=!home.hiddenMap><div ng-if=!home.loadingMap><ui-gmap-google-map center=home.map.center zoom=home.map.zoom><ui-gmap-marker ng-repeat=\"m in home.mapMarkers\" coords=m.coords options=m.options idkey=m.id></ui-gmap-marker></ui-gmap-google-map></div></div><div ng-class=\"home.hiddenMap ? \'col-md-12\' : \'col-md-8\'\" class=\"col pull-l load-list-home\"><h3 permission permission-only=\"\'GENERADOR_CARGA\'\" class=large-title>{{ \'home:nearby_carriers:title\' | translate }}</h3><h3 permission permission-only=\"[\'CARRIER\', \'DRIVER\', \'OWNER\']\" class=large-title>{{ \'home:nearby_loads:title\' | translate }}</h3><main-loader ng-if=home.loadingData></main-loader><div ng-if=!home.loadingData class=\"full-width content-tableData content-tableData-home\"><table permission permission-only=\"\'GENERADOR_CARGA\'\" datatable=ng dt-options=home.datatableOptions class=tableDataSort width=100% border=0><thead><tr><th></th><th>Carrier</th><th>Trucks</th><th>Skills</th><th width=25%>Reviews</th><th width=18%>Contact</th><th></th></tr></thead><tbody><tr ng-repeat-start=\"item in home.nearbyCarriersOrLoads\" ng-click=home.showDetailsUnique(item.id)><td><img ng-if=\"item.carrier.user.img_perfil_imagenes[0][\'imagen-60\']\" ng-src=\"{{item.carrier.user.img_perfil_imagenes[0][\'imagen-60\']}}\" width=30 border=0></td><td>{{item.carrier.company_name}}</td><td>{{(item.truck_type.truck_type_name) ? item.truck_type.truck_type_name : \'\' }} {{(item.brand || item.model) ? item.brand+\' \'+item.model : \'\' }}</td><td>{{item.skills_truck_text}}</td><td ng-if=item.carrier.user.user_votes.length><ul class=\"nav user-calification\"><li class=nav-item><span ng-class=\"item.carrier.user.user_votes[0].total_prom >= 1 ? \'fa-star\' : \'fa-star-o\'\" class=fa></span></li><li class=nav-item><span ng-class=\"item.carrier.user.user_votes[0].total_prom >= 2 ? \'fa-star\' : \'fa-star-o\'\" class=fa></span></li><li class=nav-item><span ng-class=\"item.carrier.user.user_votes[0].total_prom >= 3 ? \'fa-star\' : \'fa-star-o\'\" class=fa></span></li><li class=nav-item><span ng-class=\"item.carrier.user.user_votes[0].total_prom >= 4 ? \'fa-star\' : \'fa-star-o\'\" class=fa></span></li><li class=nav-item><span ng-class=\"item.carrier.user.user_votes[0].total_prom >= 5 ? \'fa-star\' : \'fa-star-o\'\" class=fa></span></li></ul></td><td ng-if=!item.carrier.user.user_votes.length><ul class=\"nav user-calification\"><li class=nav-item><span class=\"fa fa-star-o\"></span></li><li class=nav-item><span class=\"fa fa-star-o\"></span></li><li class=nav-item><span class=\"fa fa-star-o\"></span></li><li class=nav-item><span class=\"fa fa-star-o\"></span></li><li class=nav-item><span class=\"fa fa-star-o\"></span></li></ul></td><td><span class=\"fa fa-phone vertical-middle color-new-blue\"></span> <a ng-href=tel:{{item.phone_contact}} class=\"small-text normal-link\">{{item.phone_contact}}</a></td><td><i ng-if=!item.expanded class=\"fa fa-angle-down show-load-details-btn\"></i> <i ng-if=item.expanded class=\"fa fa-angle-up show-load-details-btn\"></i></td></tr><tr class=detail-carrier-table ng-repeat-end><td ng-if=item.expanded colspan=7 class=no-padding><carrier-details-row carrier-info=item></carrier-details-row></td></tr></tbody></table><table permission permission-only=\"[\'CARRIER\', \'DRIVER\', \'OWNER\']\" datatable=ng dt-options=home.datatableOptions class=tableDataSort width=100% border=0><thead><tr><th></th><th>Shipper</th><th>Origin</th><th>Destination</th><th width=15%>Pickup</th><th width=15%>Delivery</th><th>Price</th><th>Ago</th><th></th></tr></thead><tbody><tr ng-repeat-start=\"item in home.nearbyCarriersOrLoads\" ng-click=home.showDetailsUnique(item.id)><td><img ng-if=\"item.load_generator.user.img_perfil_imagenes[0][\'imagen-60\']\" ng-src=\"{{item.load_generator.user.img_perfil_imagenes[0][\'imagen-60\']}}\" width=30 border=0></td><td>{{item.load_generator.company_name}}</td><td>{{item.city_pickup}}</td><td>{{item.city_delivery}}</td><td>{{item.pickup_date | amDateFormat:\'MMM DD YYYY\'}}</td><td>{{item.delivery_date | amDateFormat:\'MMM DD YYYY\'}}</td><td>{{item.price}}</td><td><span am-time-ago=item.load_date_register></span></td><td><i ng-if=!item.expanded class=\"fa fa-angle-down show-load-details-btn\"></i> <i ng-if=item.expanded class=\"fa fa-angle-up show-load-details-btn\"></i></td></tr><tr class=detail-load-table ng-repeat-end><td ng-if=item.expanded colspan=9 class=no-padding><load-details-row load-id=item.id reload-parent=home.getNearbyCarriersOrLoads()></load-details-row></td></tr></tbody></table></div></div></div></div></div>");
$templateCache.put("app/main/templates/invite-join-page.html","<div id=page-section-invite-to-join class=\"page-section page-section-with-margin col bg-color-white invite-join-panel\"><invite-join type=\"\"></invite-join></div>");
$templateCache.put("app/main/templates/main.html","");
$templateCache.put("app/main/templates/notification-settings-page.html","<div id=page-section-notification-settings class=\"page-section page-section-with-margin col bg-color-white\"><h3 class=\"large-title title-notification-settings\">{{\'notification_settings:section:title\' | translate }}</h3><div class=\"row panel-settings\"><div class=\"col-12 col-sm-12\"><h5 class=\"bold title-panel-settings\">{{\'notification_settings:loads_alerts:title\' | translate }}</h5><div class=row><div class=\"col-8 col-sm-8\"><div class=desc-panel-settings><span class=\"fa fa-bell\"></span> {{\'notification_settings:loads_alerts:desc\' | translate }}<p>{{\'notification_settings:loads_alerts:desc2\' | translate }}</p></div></div><div class=\"col-2 col-sm-2\"><input type=checkbox class=custom-checkbox id=statusload_message name=statusload_message ng-model=notificationsettingspage.settingsValues.statusload_message ng-true-value=1 ng-false-value=0><label for=statusload_message><span></span></label></div></div></div></div><div class=\"row panel-settings\" ng-if=\"notificationsettingspage.settingsValues.statusload_message == 1\"><div class=\"col-12 col-sm-12\"><h5 class=\"bold title-panel-settings\">{{\'notification_settings:alert_preferences:title\' | translate }}</h5><div class=\"row parrafo\"><div class=\"col-8 col-sm-8\"><div class=desc-panel-settings><span class=\"fa fa-check-circle\"></span> {{\'notification_settings:assigned_loads:desc\' | translate }}<p>{{\'notification_settings:assigned_loads:desc2\' | translate }}</p></div></div><div class=\"col-2 col-sm-2\"><input type=checkbox class=custom-checkbox id=assignedload_message name=assignedload_message ng-model=notificationsettingspage.settingsValues.assignedload_message ng-true-value=1 ng-false-value=0><label for=assignedload_message><span></span></label></div></div><div class=\"row parrafo\"><div class=\"col-8 col-sm-8\"><div class=desc-panel-settings><span class=\"fa fa-times-circle\"></span> {{\'notification_settings:cancelled_loads:desc\' | translate }}<p>{{\'notification_settings:cancelled_loads:desc2\' | translate }}</p></div></div><div class=\"col-2 col-sm-2\"><input type=checkbox class=custom-checkbox id=cancelload_message name=cancelload_message ng-model=notificationsettingspage.settingsValues.cancelload_message ng-true-value=1 ng-false-value=0><label for=cancelload_message><span></span></label></div></div><div class=\"row parrafo\"><div class=\"col-8 col-sm-8\"><div class=desc-panel-settings><span class=\"fa fa-truck\"></span> {{\'notification_settings:delivered_loads:desc\' | translate }}<p>{{\'notification_settings:delivered_loads:desc2\' | translate }}</p></div></div><div class=\"col-2 col-sm-2\"><input type=checkbox class=custom-checkbox id=deliveryload_message name=deliveryload_message ng-model=notificationsettingspage.settingsValues.deliveryload_message ng-true-value=1 ng-false-value=0><label for=deliveryload_message><span></span></label></div></div></div></div><div class=\"row main-botonera\"><div class=\"col-12 col-sm-9\"><button ng-disabled=notificationsettingspage.saving ng-click=notificationsettingspage.saveSettings() type=button class=\"btn btn-class1 bg-color-9 color-black\">{{ \'notification_settings:btn:save\' | translate }}</button></div><div class=\"col-12 col-sm-3 text-right\"><a ng-if=!notificationsettingspage.saving ui-sref=private.home ui-sref-opts=\"{ reload: true }\" class=\"normal-link color-black small-text cancel-post-link\">{{ \'notification_settings:btn:cancel\' | translate }}</a></div></div><div permission permission-only=\"\'GENERADOR_CARGA\'\" class=\"row panel-settings\"><div class=\"col-12 col-sm-12\"><h5 class=\"bold title-panel-settings\">{{\'notification_settings:automatic_assign:title\' | translate }}</h5><div class=row><div class=\"col-8 col-sm-8\"><div class=desc-panel-settings><span class=\"fa fa-bell\"></span> {{\'notification_settings:automatic_assign:desc\' | translate }}</div></div><div class=\"col-2 col-sm-2\"><input type=checkbox class=custom-checkbox id=automatic_assign name=automatic_assign ng-model=notificationsettingspage.automaticAssingParams.automatic_load ng-true-value=1 ng-false-value=0><label for=automatic_assign><span></span></label></div></div></div></div><div permission permission-only=\"\'GENERADOR_CARGA\'\" class=\"row main-botonera\"><div class=\"col-12 col-sm-9\"><button ng-disabled=notificationsettingspage.saving ng-click=notificationsettingspage.saveAutoAssign() type=button class=\"btn btn-class1 bg-color-9 color-black\">{{ \'notification_settings:automatic_assign:btn:save\' | translate }}</button></div></div></div>");
$templateCache.put("app/main/templates/notifications-page.html","<div id=page-section-notifications class=\"page-section page-section-with-margin col bg-color-white notification-list\"><notification-list list-type=notificationpage.notificationTypeList></notification-list></div>");
$templateCache.put("app/metrics/templates/statistics.html","<div id=page-section-home class=\"col page-section page-section-with-margin col bg-color-white\"><div class=\"content-faq-help full-width\"><h2 class=\"large-title title-section\">{{\"aside:left:menu:metrics\" | translate}}</h2><metric-main></metric-main></div><div class=\"row justify-content-center\"><div class=\"header-help-about col-8 text-center\"><img src=assets/images/common/logo-by-traxion.png class=img-fluid style=\"max-width: 340px\" border=0></div></div></div>");
$templateCache.put("app/profile/templates/profile.html","<div id=page-section-profile class=\"page-section page-section-with-margin col bg-color-white\"><ul permission permission-only=\"[\'CARRIER\', \'OWNER\',\'GENERADOR_CARGA\']\" class=\"nav nav-tabs nav-tabs-full-w\" ng-if=\"profile.documents.length > 0\" role=tablist><li class=nav-item><a ng-class=\"{active: profile.isSet(1) }\" class=\"nav-link custom-nav-link\" data-toggle=tab ng-click=profile.setTab(1) role=tab>{{\'profile:section:title\' | translate }}</a></li><li class=nav-item><a ng-class=\"{active: profile.isSet(2) }\" class=\"nav-link custom-nav-link\" data-toggle=tab ng-click=profile.setTab(2) role=tab>{{ \'profile:section:document:title\' | translate }}</a></li></ul><div class=\"tab-tab-content tab-content-full-w\"><form method=post><div class=\"tab-pane active\" role=tabpanel ng-show=profile.isSet(1)><h3 class=\"large-title title-profile\">{{\'profile:section:title\' | translate }}</h3><div ng-include=\"\'app/profile/templates/tabs/tab-profile.html\'\"></div></div><div class=tab-pane role=tabpanel ng-show=profile.isSet(2)><h3 class=\"large-title title-profile\">{{\'profile:section:document:title\' | translate }}</h3><upload-document data=profile.user></upload-document></div></form></div></div>");
$templateCache.put("app/trailers/templates/add.html","<div id=page-section-post-truck class=\"page-section page-section-with-margin col bg-color-white\"><h3 class=\"large-title title-section\">{{ \'trailers:add:section:title\' | translate }}</h3><form method=post id=postTrailerFormId name=postTrailerFormName ng-submit=trailersadd.save(postTrailerFormName) novalidate><div class=row><div class=col-12><div class=form-group><div class=row><div class=\"col-6 col-sm-6\"><label>{{ \'trailers:add:form:trailer_type\' | translate }}</label><span class=help-inline ng-show=postTrailerFormName.trailer_type.$error.required>*</span><select name=trailer_type id=trailer_type ng-model=trailersadd.dataNewTrailer.trailer_type class=\"form-control input-md\" required><option value=\"\">{{ \'trailers:add:form:select:any\' | translate }}</option><option ng-repeat=\"option in trailersadd.trailerTypesList\" value={{option.id}}>{{option.name}}</option></select></div><div class=\"col-6 col-sm-6\"><label>{{ \'trailers:add:form:length\' | translate }}</label><span class=help-inline ng-show=postTrailerFormName.length.$error.required>*</span><select name=length id=length ng-model=trailersadd.dataNewTrailer.length class=\"form-control input-md\" required><option value=\"\">{{ \'trailers:add:form:select:any\' | translate }}</option><option ng-repeat=\"option in trailersadd.loadsLengthList\" value={{option.id}}>{{option.name}}</option></select></div></div></div><div class=form-group><div class=row><div class=\"col-6 col-sm-6\"><label>{{ \'trailers:add:form:plate\' | translate }}</label><span class=help-inline ng-show=postTrailerFormName.plate.$error.required>*</span> <input type=text name=plate class=form-control ng-model=trailersadd.dataNewTrailer.plate placeholder=\'{{ \"trailers:add:form:plate\" | translate }}\' required></div><div class=\"col-6 col-sm-6\"><label>{{ \'trailers:add:form:location\' | translate }}</label><span class=help-inline ng-show=postTrailerFormName.location.$error.required>*</span> <input type=text name=location class=form-control ng-model=trailersadd.dataNewTrailer.location placeholder=\'{{ \"trailers:add:form:location\" | translate }}\' required></div></div></div><div class=form-group><div class=row><div class=\"col-6 col-sm-6\"><label>{{ \'trailers:add:form:status\' | translate }}</label><br><input type=checkbox class=custom-checkbox id=trailer_status name=trailer_status ng-model=trailersadd.dataNewTrailer.status ng-true-value=1 ng-false-value=0><label for=trailer_status><span></span>{{ \'trailers:add:form:status_active:text\' | translate }}</label></div><div class=\"col-6 col-sm-6\"><label>{{ \'trailers:add:form:truck_assoc\' | translate }}</label><select name=truck_id id=truck_id ng-model=trailersadd.dataNewTrailer.truck_id class=\"form-control input-md\"><option value=\"\">{{ \'trailers:add:form:select:any\' | translate }}</option><option ng-repeat=\"option in trailersadd.myTrucksList\" value={{option.id}}>{{\'trucks:details:company_id_unity:title\' | translate }}: {{option.company_id_unity_select}} - {{option.brand}} {{option.model}}</option></select></div></div></div></div></div><br><br><div class=\"row main-botonera\"><div class=\"col-12 col-sm-9\"><button ng-disabled=trailersadd.savingNewTrailer type=submit class=\"btn btn-class1 bg-color-9 color-black\">{{ \'loads:add:form:btn:save_post_next\' | translate }}</button> <a ng-disabled=trailersadd.savingNewTrailer ng-click=trailersadd.submitReturnListFunc(postTrailerFormName) class=\"normal-link color-black small-text\">{{ \'loads:add:form:btn:save_return_list\' | translate }}</a></div><div class=\"col-12 col-sm-3 text-right\"><a ng-if=!trailersadd.savingNewTrailer ui-sref=private.trailers ui-sref-opts=\"{ reload: true }\" class=\"normal-link color-black small-text cancel-post-link\">{{ \'loads:add:form:btn:cancel\' | translate }}</a></div></div></form></div>");
$templateCache.put("app/trailers/templates/edit.html","<div id=page-section-post-truck class=\"page-section page-section-with-margin col bg-color-white\"><h3 class=\"large-title title-section\">{{ \'trailers:edit:section:title\' | translate }}</h3><form method=post id=postTrailerFormId name=postTrailerFormName ng-submit=trailersedit.save(postTrailerFormName) novalidate><div class=row><div class=col-12><div class=form-group><div class=row><div class=\"col-6 col-sm-6\"><label>{{ \'trailers:add:form:trailer_type\' | translate }}</label><span class=help-inline ng-show=postTrailerFormName.trailer_type.$error.required>*</span><select name=trailer_type id=trailer_type ng-model=trailersedit.dataUpdateTrailer.trailer_type class=\"form-control input-md\" required><option value=\"\">{{ \'trailers:add:form:select:any\' | translate }}</option><option ng-repeat=\"option in trailersedit.trailerTypesList\" value={{option.id}}>{{option.name}}</option></select></div><div class=\"col-6 col-sm-6\"><label>{{ \'trailers:add:form:length\' | translate }}</label><span class=help-inline ng-show=postTrailerFormName.length.$error.required>*</span><select name=length id=length ng-model=trailersedit.dataUpdateTrailer.length class=\"form-control input-md\" required><option value=\"\">{{ \'trailers:add:form:select:any\' | translate }}</option><option ng-repeat=\"option in trailersedit.loadsLengthList\" value={{option.id}}>{{option.name}}</option></select></div></div></div><div class=form-group><div class=row><div class=\"col-6 col-sm-6\"><label>{{ \'trailers:add:form:plate\' | translate }}</label><span class=help-inline ng-show=postTrailerFormName.plate.$error.required>*</span> <input type=text name=plate class=form-control ng-model=trailersedit.dataUpdateTrailer.plate placeholder=\'{{ \"trailers:add:form:plate\" | translate }}\' required></div><div class=\"col-6 col-sm-6\"><label>{{ \'trailers:add:form:location\' | translate }}</label><span class=help-inline ng-show=postTrailerFormName.location.$error.required>*</span> <input type=text name=location class=form-control ng-model=trailersedit.dataUpdateTrailer.location placeholder=\'{{ \"trailers:add:form:location\" | translate }}\' required></div></div></div><div class=form-group><div class=row><div class=\"col-6 col-sm-6\"><label>{{ \'trailers:add:form:status\' | translate }}</label><br><input type=checkbox class=custom-checkbox id=trailer_status name=trailer_status ng-model=trailersedit.dataUpdateTrailer.status ng-true-value=1 ng-false-value=0><label for=trailer_status><span></span>{{ \'trailers:add:form:status_active:text\' | translate }}</label></div><div class=\"col-6 col-sm-6\"><label>{{ \'trailers:add:form:truck_assoc\' | translate }}</label><select name=truck_id id=truck_id ng-model=trailersedit.dataUpdateTrailer.truck_id class=\"form-control input-md\"><option value=\"\">{{ \'trailers:add:form:select:any\' | translate }}</option><option ng-repeat=\"option in trailersedit.myTrucksList\" value={{option.id}}>{{\'trucks:details:company_id_unity:title\' | translate }}: {{option.company_id_unity_select}} - {{option.brand}} {{option.model}}</option></select></div></div></div></div></div><br><br><div class=\"row main-botonera\"><div class=\"col-12 col-sm-9\"><button ng-disabled=trailersedit.savingTrailer type=submit class=\"btn btn-class1 bg-color-9 color-black\">{{ \'loads:add:form:btn:save_post_next\' | translate }}</button></div><div class=\"col-12 col-sm-3 text-right\"><a ng-if=!trailersedit.savingTrailer ui-sref=private.trailers ui-sref-opts=\"{ reload: true }\" class=\"normal-link color-black small-text cancel-post-link\">{{ \'loads:add:form:btn:cancel\' | translate }}</a></div></div></form></div>");
$templateCache.put("app/trailers/templates/trailers.html","<div id=page-section-trucks class=\"page-section col\"><total-items></total-items><div class=\"col content-truck-list bg-color-white\"><h3 class=\"large-title title-section\">{{ \'trailers:section:title\' | translate }}</h3><br><div class=row><div class=\"col col-sm-6\"><input type=text class=pull-l name=trailer_plate_filter ng-model=trailers.trailerOptions.plate ng-enter=trailers.setTrailerPlateFilter() ng-blur=trailers.setTrailerPlateFilter() placeholder=\"{{\'trailers:add:form:plate\' | translate}}\"></div><div class=\"col col-sm-6 text-right botonera-list\"><div permission permission-only=\"[\'CARRIER\', \'OWNER\']\" class=\"dropdown-actions-trailer inline-block\"><!--<div class=\"dropdown\">\n						<button class=\"btn btn-secondary dropdown-toggle btn-class2 bg-color-9 color-black\" type=\"button\" id=\"dropdownMenuButton\" data-toggle=\"dropdown\" aria-haspopup=\"true\" aria-expanded=\"false\">\n							{{ \'trailers:upload_trailers:btn\' | translate }}\n						</button>\n						<div class=\"dropdown-menu dropdown-menu-right\" aria-labelledby=\"dropdownMenuButton\">\n							<div class=\"dropdown-item\">\n								<a ng-click=\"trailers.openUploadTrailersModal()\" class=\"color-black pointer\">\n									{{ \'trailers:upload_trailers:new_trailers:opt\' | translate }}\n								</a>\n							</div>\n							<div ng-if=\"false\" class=\"dropdown-item\">\n								<a ng-click=\"trailers.openUploadTrailersUpdateModal()\" class=\"color-black pointer\">\n									{{ \'trailers:upload_trailers:update_trailers:opt\' | translate }}\n								</a>\n							</div>\n						</div>\n					</div>--><upload-component></upload-component></div><a permission permission-only=\"[\'CARRIER\', \'OWNER\']\" ui-sref=private.trailers.add ui-sref-opts=\"{ reload: true }\" class=\"btn btn-class2 bg-color-9 color-black\">{{ \'trailers:new_trailer:btn\' | translate }}</a></div></div><div class=row><ul permission permission-only=\"[\'CARRIER\', \'OWNER\']\" class=\"nav nav-tabs nav-tabs-full-w\" role=tablist><li class=nav-item><a ng-class=active class=\"nav-link custom-nav-link\" data-toggle=tab role=tab>{{ \'trailers:list:all:title\' | translate }}</a></li></ul></div><div class=\"tab-content tab-content-full-w\"><div class=\"tab-pane active\" id=content_trucks_tab role=tabpanel><div class=\"full-width content-tableData\"><table datatable=\"\" dt-options=trailers.datatableOptions dt-columns=trailers.dtColumns class=tableDataSort width=100% border=0><tbody permission permission-only=\"[\'CARRIER\', \'OWNER\']\"><tr ng-if=!trailers.trailersList.length><td colspan=13><p class=text-center>{{ \"trailers:list:empty:text\" | translate }}</p></td></tr><tr ng-repeat-start=\"trailer in trailers.trailersList\"><td class=info-truck><p class=truck-name-table>{{trailer.trailer_full_name}}</p><span class=driver-name-table>{{trailer.truck_full_name}}</span></td><td ng-bind-html=trailer.trailer_status></td><td><i ng-if=!trailer.expanded ng-click=trailers.showDetailsUnique(trailer.idtrailer_box) class=\"fa fa-angle-down show-load-details-btn\"></i> <i ng-if=trailer.expanded ng-click=trailers.showDetailsUnique(trailer.idtrailer_box) class=\"fa fa-angle-up show-load-details-btn\"></i></td></tr><tr class=detail-truck-table ng-repeat-end><td ng-if=trailer.expanded colspan=12 class=no-padding><trailer-details-row trailer-info=trailer reload-parent=trailers.loadTab()></trailer-details-row></td></tr></tbody></table></div></div></div></div></div>");
$templateCache.put("app/trucks/templates/add.html","<div id=page-section-post-truck class=\"page-section page-section-with-margin col bg-color-white\"><h3 class=\"large-title title-section\">{{ \'trucks:add:section:title\' | translate }}</h3><form method=post id=postTruckFormId name=postTruckFormName ng-submit=trucksadd.save(postTruckFormName) novalidate><div ng-include=\"\'app/trucks/templates/section/form-add-section.html\'\"></div><div ng-include=\"\'app/trucks/templates/section/btn-add-section.html\'\"></div></form></div>");
$templateCache.put("app/trucks/templates/edit.html","<div id=page-section-post-truck class=\"page-section page-section-with-margin col bg-color-white\"><ul permission permission-only=[] ng-if=\"trucksedit.documents.length > 0\" class=\"nav nav-tabs nav-tabs-full-w\" role=tablist><li class=nav-item><a ng-class=\"{active: trucksedit.isSet(1) }\" class=\"nav-link custom-nav-link\" data-toggle=tab ng-click=trucksedit.setTab(1) role=tab>{{ \'trucks:edit:section:title\' | translate }}</a></li><li class=nav-item><a ng-class=\"{active: trucksedit.isSet(2) }\" class=\"nav-link custom-nav-link\" data-toggle=tab ng-click=trucksedit.setTab(2) role=tab>{{ \'profile:section:document:title\' | translate }}</a></li></ul><form ng-if=!loadingTruckDetails method=post id=postTruckFormId name=postTruckFormName ng-submit=trucksedit.save(postTruckFormName) novalidate><div class=\"tab-pane active\" role=tabpanel ng-show=trucksedit.isSet(1)><h3 class=\"large-title title-section\">{{ \'trucks:edit:section:title\' | translate }}</h3><div ng-include=\"\'app/trucks/templates/tabs/tab-truck.html\'\"></div></div><div class=tab-pane role=tabpanel ng-show=trucksedit.isSet(2)><h3 class=\"large-title title-profile\">{{\'profile:section:document:title\' | translate }}</h3><upload-document data=trucksedit.user></upload-document></div></form></div>");
$templateCache.put("app/trucks/templates/truck_loads.html","<div id=page-section-loads class=\"page-section col\"><total-items></total-items><div class=\"col content-load-list bg-color-white\"><h3 class=\"large-title title-section\">{{ \'loads:section:title\' | translate }}</h3><div class=row><div class=\"col text-right botonera-list\"><a permission permission-only=\"\'GENERADOR_CARGA\'\" ui-sref=private.loads.add ui-sref-opts=\"{ reload: true }\" class=\"btn btn-class1 bg-color-9 color-black\">{{ \'loads:new_load:btn\' | translate }}</a></div></div><div class=row><ul permission permission-only=\"\'GENERADOR_CARGA\'\" class=\"nav nav-tabs nav-tabs-full-w\" role=tablist><li class=nav-item><a class=\"nav-link active\" data-toggle=tab ng-click=\"truckloads.changeCategory(\'my_loads\')\" role=tab>{{ \'loads:list:my_loads:title\' | translate }}</a></li><li class=nav-item><a class=nav-link data-toggle=tab ng-click=\"truckloads.changeCategory(\'assigned\')\" role=tab>{{ \'loads:list:assigned:title\' | translate }}</a></li><li class=nav-item><a class=nav-link data-toggle=tab ng-click=\"truckloads.changeCategory(\'not_assigned\')\" role=tab>{{ \'loads:list:not_assigned:title\' | translate }}</a></li><li class=nav-item><a class=nav-link data-toggle=tab ng-click=\"truckloads.changeCategory(\'pending\')\" role=tab>{{ \'loads:list:pending:title\' | translate }}</a></li></ul><ul permission permission-only=\"[\'CARRIER\', \'OWNER\']\" class=\"nav nav-tabs nav-tabs-full-w\" role=tablist><li class=nav-item><a ng-class=\"{active: truckloads.loadsOptions.search_type == \'all\' }\" class=nav-link data-toggle=tab ng-click=\"truckloads.changeCategory(\'all\')\" role=tab>{{ \'loads:list:all:title\' | translate }}</a></li><li class=nav-item><a class=nav-link data-toggle=tab ng-click=\"truckloads.changeCategory(\'current\')\" role=tab>{{ \'loads:list:current:title\' | translate }}</a></li><li class=nav-item><a class=nav-link data-toggle=tab ng-click=\"truckloads.changeCategory(\'not_assigned\')\" role=tab>{{ \'loads:list:suggest:title\' | translate }}</a></li><li class=nav-item><a ng-class=\"{active: truckloads.loadsOptions.search_type == \'my_search\' }\" class=nav-link data-toggle=tab ng-click=\"truckloads.changeCategory(\'my_search\')\" role=tab>{{ \'loads:list:my_search:title\' | translate }}</a></li></ul><ul permission permission-only=\"[\'DRIVER\',\'OWNER\']\" class=\"nav nav-tabs nav-tabs-full-w\" role=tablist><li class=nav-item><a class=nav-link data-toggle=tab ng-click=\"truckloads.changeCategory(\'current\')\" role=tab>{{ \'loads:list:current:title\' | translate }}</a></li><li class=nav-item><a ng-class=\"{active: truckloads.loadsOptions.search_type == \'my_search\' }\" class=nav-link data-toggle=tab ng-click=\"truckloads.changeCategory(\'my_search\')\" role=tab>{{ \'loads:list:my_search:title\' | translate }}</a></li></ul></div><div class=\"tab-content tab-content-full-w\"><div class=\"tab-pane active\" id=content_loads_tab role=tabpanel><div class=\"full-width content-tableData\"><table datatable=\"\" dt-options=truckloads.datatableOptions dt-columns=truckloads.dtColumns class=tableDataSort width=100% border=0><thead><tr><th permission permission-only=\"\'GENERADOR_CARGA\'\">{{\"loads:table:column:status\" | translate}}</th><th permission permission-only=\"\'GENERADOR_CARGA\'\">{{\"loads:table:column:origin\" | translate}}</th><th permission permission-only=\"\'GENERADOR_CARGA\'\">{{\"loads:table:column:destination\" | translate}}</th><th permission permission-only=\"\'GENERADOR_CARGA\'\">{{\"loads:table:column:pickup\" | translate}}</th><th permission permission-only=\"\'GENERADOR_CARGA\'\">{{\"loads:table:column:delivery\" | translate}}</th><th permission permission-only=\"\'GENERADOR_CARGA\'\">{{\"loads:table:column:distance\" | translate}}</th><th permission permission-only=\"\'GENERADOR_CARGA\'\">{{\"loads:table:column:length\" | translate}}</th><th permission permission-only=\"\'GENERADOR_CARGA\'\">{{\"loads:table:column:weight\" | translate}}</th><th permission permission-only=\"\'GENERADOR_CARGA\'\">{{\"loads:table:column:size\" | translate}}</th><th permission permission-only=\"\'GENERADOR_CARGA\'\">{{\"loads:table:column:price\" | translate}}</th><th permission permission-only=\"\'GENERADOR_CARGA\'\">{{\"loads:table:column:ago\" | translate}}</th><th permission permission-only=\"\'GENERADOR_CARGA\'\">{{\"loads:table:column:actions\" | translate}}</th><th permission permission-only=\"[\'CARRIER\', \'DRIVER\', \'OWNER\']\">{{\"loads:table:column:profile_img\" | translate}}</th><th permission permission-only=\"[\'CARRIER\', \'DRIVER\', \'OWNER\']\">{{\"loads:table:column:shipper\" | translate}}</th><th permission permission-only=\"[\'CARRIER\', \'DRIVER\', \'OWNER\']\">{{\"loads:table:column:origin\" | translate}}</th><th permission permission-only=\"[\'CARRIER\', \'DRIVER\', \'OWNER\']\">{{\"loads:table:column:destination\" | translate}}</th><th permission permission-only=\"[\'CARRIER\', \'DRIVER\', \'OWNER\']\">{{\"loads:table:column:pickup\" | translate}}</th><th permission permission-only=\"[\'CARRIER\', \'DRIVER\', \'OWNER\']\">{{\"loads:table:column:delivery\" | translate}}</th><th permission permission-only=\"[\'CARRIER\', \'DRIVER\', \'OWNER\']\">{{\"loads:table:column:length\" | translate}}</th><th permission permission-only=\"[\'CARRIER\', \'DRIVER\', \'OWNER\']\">{{\"loads:table:column:weight\" | translate}}</th><th permission permission-only=\"[\'CARRIER\', \'DRIVER\', \'OWNER\']\">{{\"loads:table:column:size\" | translate}}</th><th permission permission-only=\"[\'CARRIER\', \'DRIVER\', \'OWNER\']\">{{\"loads:table:column:price\" | translate}}</th><th permission permission-only=\"[\'CARRIER\', \'DRIVER\', \'OWNER\']\">{{\"loads:table:column:ago\" | translate}}</th><th permission permission-only=\"[\'CARRIER\', \'DRIVER\', \'OWNER\']\">{{\"loads:table:column:status\" | translate}}</th><th permission permission-only=\"[\'CARRIER\', \'DRIVER\', \'OWNER\']\">{{\"loads:table:column:actions\" | translate}}</th></tr></thead><tbody permission permission-only=\"\'GENERADOR_CARGA\'\"><tr ng-if=!truckloads.loadsList.length><td colspan=13><p class=text-center>{{ \"loads:list:empty:text\" | translate }}</p></td></tr><tr ng-repeat-start=\"load in truckloads.loadsList\"><td class=tags-row colspan=13><div class=\"tag_item bg-color-5 color-armadillo\" ng-if=\"load.posteverywhere == \'0\'\"><strong>{{ \"loads:table:tag:premium:text\" | translate }}</strong></div></td></tr><tr><td ng-bind-html=load.status_btn></td><td>{{load.from}}</td><td>{{load.to}}</td><td>{{load.pickup_date_formatted}}</td><td>{{load.delivery_date_formatted}}</td><td>{{load.distance}}</td><td>{{load.length_loads}}</td><td>{{load.weight}}</td><td>{{load.dimension}}</td><td>${{load.price}}</td><td am-time-ago=load.load_date></td><td><i ng-if=!load.expanded ng-click=truckloads.showDetailsUnique(load.load_id) class=\"fa fa-angle-down show-load-details-btn\"></i> <i ng-if=load.expanded ng-click=truckloads.showDetailsUnique(load.load_id) class=\"fa fa-angle-up show-load-details-btn\"></i></td></tr><tr class=detail-load-table ng-repeat-end><td ng-if=load.expanded colspan=12 class=no-padding><load-details-row load-id=load.load_id reload-parent=truckloads.reloadList()></load-details-row></td></tr></tbody><tbody permission permission-only=\"[\'CARRIER\', \'DRIVER\', \'OWNER\']\"><tr ng-if=!truckloads.loadsList.length><td colspan=13><p class=text-center>{{ \"loads:list:empty:text\" | translate }}</p></td></tr><tr ng-repeat-start=\"load in truckloads.loadsList\"><td class=tags-row colspan=13><div class=\"tag_item bg-color-5 color-armadillo\" ng-if=\"load.posteverywhere == \'0\'\"><strong>{{ \"loads:table:tag:premium:text\" | translate }}</strong></div><div class=\"tag_item bg-color-3 color-armadillo\" ng-if=\"load.owner_request_carriers == \'1\' && load.status_loads == \'NOT_ASSIGNED\'\"><strong>{{ \"loads:table:tag:applied:text\" | translate }}</strong></div></td></tr><tr><td class=info-row><img ng-if=load.img_shipper ng-src={{load.img_shipper}} width=30 border=0></td><td class=info-row>{{load.full_name_shipper}}</td><td class=info-row>{{load.from}}</td><td class=info-row>{{load.to}}</td><td class=info-row>{{load.pickup_date_formatted}}</td><td class=info-row>{{load.delivery_date_formatted}}</td><td class=info-row>{{load.length_loads}}</td><td class=info-row>{{load.weight}}</td><td class=info-row>{{load.dimension}}</td><td class=info-row>${{load.price}}</td><td class=info-row am-time-ago=load.load_date></td><td class=info-row ng-bind-html=load.status_btn></td><td class=info-row><i ng-click=truckloads.showDetailsUnique(load.load_id) class=\"fa fa-angle-down show-load-details-btn\"></i></td></tr><tr class=detail-load-table ng-repeat-end><td ng-if=load.expanded colspan=13 class=no-padding><load-details-row load-id=load.load_id reload-parent=truckloads.reloadList() posteverywhere=load.posteverywhere></load-details-row></td></tr></tbody></table></div></div></div></div></div>");
$templateCache.put("app/trucks/templates/trucks.html","<div id=page-section-trucks class=\"page-section col\"><total-items></total-items><div class=\"col content-truck-list bg-color-white\"><h3 class=\"large-title title-section\">{{ \'trucks:section:title\' | translate }}</h3><br><div class=row><div class=\"col col-sm-6\"><input type=text class=pull-l name=truck_id_filter ng-model=trucks.truckOptions.truck_id ng-enter=trucks.setTruckIdFilter() ng-blur=trucks.setTruckIdFilter() placeholder=\"{{\'trucks:list:input:truck_id:filter\' | translate}}\"></div><div class=\"col col-sm-6 text-right botonera-list\"><div permission permission-only=\"[\'CARRIER\', \'OWNER\']\" class=\"dropdown-actions-truck inline-block\"><upload-component></upload-component></div><a permission permission-only=\"[\'CARRIER\', \'OWNER\']\" ui-sref=private.trucks.add ui-sref-opts=\"{ reload: true }\" class=\"btn btn-class2 bg-color-9 color-black\">{{ \'trucks:new_truck:btn\' | translate }}</a></div></div><div class=row><ul permission permission-only=\"[\'CARRIER\', \'OWNER\']\" class=\"nav nav-tabs nav-tabs-full-w\" role=tablist><li class=nav-item><a ng-class=\"{active: trucks.truckOptions.shortcut == \'all\' }\" class=\"nav-link custom-nav-link\" data-toggle=tab ng-click=\"trucks.changeCategory(\'all\')\" role=tab>{{ \'trucks:list:all:title\' | translate }}</a></li><li class=nav-item><a class=\"nav-link custom-nav-link\" data-toggle=tab ng-click=\"trucks.changeCategory(\'active\')\" role=tab>{{ \'trucks:list:active:title\' | translate }}</a></li><li class=nav-item><a class=\"nav-link custom-nav-link\" data-toggle=tab ng-click=\"trucks.changeCategory(\'inactive\')\" role=tab>{{ \'trucks:list:inactive:title\' | translate }}</a></li></ul></div><div class=\"tab-content tab-content-full-w\"><div class=\"tab-pane active\" id=content_trucks_tab role=tabpanel><div class=\"full-width content-tableData\"><table datatable=\"\" dt-options=trucks.datatableOptions dt-columns=trucks.dtColumns class=tableDataSort width=100% border=0><tbody permission permission-only=\"[\'CARRIER\', \'OWNER\']\"><tr ng-if=!trucks.trucksList.length><td colspan=13><p class=text-center>{{ \"trucks:list:empty:text\" | translate }}</p></td></tr><tr ng-repeat-start=\"truck in trucks.trucksList\"><td><img ng-if=truck.truck_img ng-src={{truck.truck_img}} class=\"img-fluid rounded-circle\" border=0></td><td class=info-truck><p class=truck-name-table>{{truck.truck_name}}</p><span class=driver-name-table>{{ \"trucks:details:company_id_unity:title\" | translate }}: {{truck.company_id_unity}}</span><br><span class=driver-name-table>{{\'trucks:details:driven_by:title\' | translate }} {{truck.driver_name}}</span> <span ng-if=\"truck.driver != null\" class=driver-name-table>{{ \'drivers:details:driver_company_id:title\' | translate }}: {{truck.driver.id_integration_drivers}}</span> <a ng-if=\"truck.driver != null\" ng-click=trucks.goToSeeDriver(truck.driver.user.user_first_name) class=\"small-text normal-link pointer\">{{\'trucks:details:see_driver:text\' | translate }}</a></td><td ng-bind-html=truck.truck_status></td><td><i ng-if=!truck.expanded ng-click=trucks.showDetailsUnique(truck.id) class=\"fa fa-angle-down show-load-details-btn\"></i> <i ng-if=truck.expanded ng-click=trucks.showDetailsUnique(truck.id) class=\"fa fa-angle-up show-load-details-btn\"></i></td></tr><tr class=detail-truck-table ng-repeat-end><td ng-if=truck.expanded colspan=12 class=no-padding><truck-details-row truck-id=truck.id reload-parent=trucks.loadTab()></truck-details-row></td></tr></tbody></table></div></div></div></div></div>");
$templateCache.put("app/carriers/templates/directives/carrier-details-row.html","<div class=details-table-row><ul class=\"nav name-calification-details\"><li class=nav-item><h3 class=title-carrier-details>{{carrierData.carrier_info.company_name}}</h3></li><li ng-if=carrierData.carrier_info.user.user_votes.length class=nav-item><span ng-class=\"carrierData.carrier_info.user.user_votes[0].total_prom >= 1 ? \'fa-star\' : \'fa-star-o\'\" class=fa></span> <span ng-class=\"carrierData.carrier_info.user.user_votes[0].total_prom >= 2 ? \'fa-star\' : \'fa-star-o\'\" class=fa></span> <span ng-class=\"carrierData.carrier_info.user.user_votes[0].total_prom >= 3 ? \'fa-star\' : \'fa-star-o\'\" class=fa></span> <span ng-class=\"carrierData.carrier_info.user.user_votes[0].total_prom >= 4 ? \'fa-star\' : \'fa-star-o\'\" class=fa></span> <span ng-class=\"carrierData.carrier_info.user.user_votes[0].total_prom >= 5 ? \'fa-star\' : \'fa-star-o\'\" class=fa></span></li><li ng-if=!carrierData.carrier_info.user.user_votes.length class=nav-item><span class=\"fa fa-star-o\"></span> <span class=\"fa fa-star-o\"></span> <span class=\"fa fa-star-o\"></span> <span class=\"fa fa-star-o\"></span> <span class=\"fa fa-star-o\"></span></li></ul><div class=row><div class=\"col col-md-3 text-center\"><img ng-if=carrierData.img_perfil_carrier ng-src=\"{{carrierData.img_perfil_carrier[0][\'imagen-60\']}}\" class=img-fluid border=0><p class=foot-carrier-pic><span class=\"fa fa-phone color-new-blue vertical-middle\"></span> <a class=\"regular-text normal-link\">{{carrierData.carrier_info.phone_company}}</a></p></div><div class=\"col col-md-9 carrier-items-data\"><div class=\"row parrafo\"><div class=\"col col-sm-3\"><div class=form-group><label>{{ \'home:nearby_carriers:corp_number:label\' | translate }}</label><p>{{carrierData.carrier_info.corp_number}}</p></div><div class=form-group><label>{{ \'home:nearby_carriers:dot_number:label\' | translate }}</label><p>{{carrierData.carrier_info.dot_number}}</p></div><div class=form-group><label>{{ \'home:nearby_carriers:mc_number:label\' | translate }}</label><p>{{carrierData.carrier_info.mc_number}}</p></div><div class=form-group><label>{{ \'home:nearby_carriers:loads_transit:label\' | translate }}</label><p>{{loadsTransit}}</p></div><div class=form-group><label>{{ \'home:nearby_carriers:loads_transported:label\' | translate }}</label><p>{{carrierData.LoadsTransported}}</p></div><div class=form-group><label>{{ \'home:nearby_carriers:insurance_policy:label\' | translate }}</label><p>{{carrierData.carrier_info.bond_insurance_policy_num}}</p></div></div><div class=\"col col-sm-9\"><h3 class=title-carrier-details>{{ \'home:nearby_carriers:trucks_availables:label\' | translate }}</h3><ul ng-if=carrierData.truck_results.length class=\"nav flex-column carrier-drivers-list\"><li ng-click=openTruckModal(truck.id) ng-repeat=\"truck in carrierData.truck_results\" class=nav-item><div class=img-truck><img ng-if=\"truck.img_truck_imagenes[0][\'imagen-60\']\" ng-src=\"{{truck.img_truck_imagenes[0][\'imagen-60\']}}\" class=\"img-fluid rounded-circle\" border=0></div><span class=truck-name-table>{{truck.brand}} {{truck.model}} {{truck.dimension}}</span> <span class=driver-name-table>Driven by {{truck.driver.user.user_first_name}} {{truck.driver.user.user_last_name}}</span></li></ul></div></div></div></div></div>");
$templateCache.put("app/carriers/templates/modal/truck-info-modal.html","<div class=modal-body id=truck-info-modal><h3 class=\"title-modal text-left\">{{ \"carriers:truck:modal:title\" | translate }}</h3><div ng-if=!loadingData><div class=img-truck><img ng-if=\"truckinfomodal.infoTruck.imagenes_trucks[0][\'imagen-60\']\" ng-src=\"{{truckinfomodal.infoTruck.imagenes_trucks[0][\'imagen-60\']}}\" class=\"img-fluid rounded-circle\" border=0></div><span class=truck-name-table>{{truckinfomodal.infoTruck.brand}} {{truckinfomodal.infoTruck.model}}</span> <span class=driver-name-table>Driven by {{truckinfomodal.infoTruck.driver.user.user_first_name}} {{truckinfomodal.infoTruck.driver.user.user_last_name}}</span><br><br><form><h3 class=\"subtitle-modal text-left\">{{ \"carriers:truck:modal:basic_info:title\" | translate }}</h3><div class=\"row form-group\"><div class=\"col-6 col-sm-6\"><label class=small-text>{{ \"carriers:truck:modal:basic_info:brand:title\" | translate }}</label></div><div class=\"col-6 col-sm-6\">{{truckinfomodal.infoTruck.brand}}</div></div><div class=\"row form-group\"><div class=\"col-6 col-sm-6\"><label class=small-text>{{ \"carriers:truck:modal:basic_info:model:title\" | translate }}</label></div><div class=\"col-6 col-sm-6\">{{truckinfomodal.infoTruck.model}}</div></div><div class=\"row form-group\"><div class=\"col-6 col-sm-6\"><label class=small-text>{{ \"carriers:truck:modal:basic_info:year:title\" | translate }}</label></div><div class=\"col-6 col-sm-6\">{{truckinfomodal.infoTruck.year}}</div></div><div class=\"row form-group\"><div class=\"col-6 col-sm-6\"><label class=small-text>{{ \"carriers:truck:modal:basic_info:plate:title\" | translate }}</label></div><div class=\"col-6 col-sm-6\">{{truckinfomodal.infoTruck.plate}}</div></div><div class=\"row form-group\"><div class=\"col-6 col-sm-6\"><label class=small-text>{{ \"carriers:truck:modal:basic_info:driver:title\" | translate }}</label></div><div class=\"col-6 col-sm-6\">{{truckinfomodal.infoTruck.driver.user.user_first_name}} {{truckinfomodal.infoTruck.driver.user.user_last_name}}</div></div><h3 class=\"subtitle-modal text-left\">{{ \"carriers:truck:modal:truck_details:title\" | translate }}</h3><div class=\"row form-group\"><div class=\"col-6 col-sm-6\"><label class=small-text>{{ \"carriers:truck:modal:basic_info:type:title\" | translate }}</label></div><div class=\"col-6 col-sm-6\">{{truckinfomodal.infoTruck.truck_type.truck_type_name}}</div></div><div class=\"row form-group\"><div class=\"col-6 col-sm-6\"><label class=small-text>{{ \"carriers:truck:modal:basic_info:length:title\" | translate }}</label></div><div class=\"col-6 col-sm-6\">{{truckinfomodal.infoTruck.length}}</div></div><div class=\"row form-group\"><div class=\"col-6 col-sm-6\"><label class=small-text>{{ \"carriers:truck:modal:basic_info:weight:title\" | translate }}</label></div><div class=\"col-6 col-sm-6\">{{truckinfomodal.infoTruck.weight}}</div></div><div class=\"row form-group\"><div class=\"col-6 col-sm-6\"><label class=small-text>{{ \"carriers:truck:modal:basic_info:size:title\" | translate }}</label></div><div class=\"col-6 col-sm-6\">{{truckinfomodal.infoTruck.size}}</div></div><div class=\"row form-group\"><div class=\"col-6 col-sm-6\"><label class=small-text>{{ \"carriers:truck:modal:basic_info:skills:title\" | translate }}</label></div><div class=\"col-6 col-sm-6\">{{truckinfomodal.infoTruck.skills_truck_text}}</div></div><div class=\"row form-group\"><div class=\"col-6 col-sm-6\"><label class=small-text>{{ \"carriers:truck:modal:basic_info:capacity:title\" | translate }}</label></div><div class=\"col-6 col-sm-6\">{{truckinfomodal.infoTruck.truck_capacity.capacity_name}}</div></div><div class=\"row form-group\"><div class=\"col-6 col-sm-6\"><label class=small-text>{{ \"carriers:truck:modal:basic_info:max_distance:title\" | translate }}</label></div><div class=\"col-6 col-sm-6\">{{truckinfomodal.infoTruck.max_distance}}</div></div><div class=\"row form-group\"><div class=\"col-6 col-sm-6\"><label class=small-text>{{ \"carriers:truck:modal:basic_info:availability:title\" | translate }}</label></div><div class=\"col-6 col-sm-6\">{{truckinfomodal.infoTruck.truck_availability_text}}</div></div></form></div></div>");
$templateCache.put("app/drivers/templates/directives/driver-details-row.html","<div class=details-table-row><div ng-if=driverData.user_id class=row><div ng-if=driverData.user class=dropdown-actions-load><div class=dropdown><button class=\"btn btn-secondary dropdown-toggle\" type=button ng-if=driverData.user id=dropdownMenuButton data-toggle=dropdown aria-haspopup=true aria-expanded=false><span class=\"fa fa-ellipsis-h\"></span></button><div class=\"dropdown-menu dropdown-menu-right\" aria-labelledby=dropdownMenuButton><div ng-if=driverData.user class=dropdown-item><a ui-sref=\"private.drivers.edit({id: driverData.user.id})\" ui-sref-opts=\"{ id: driverData.user.id }\" class=color-black><span class=\"fa fa-pencil\"></span> {{ \'loads:details:options:edit\' | translate }}</a></div><div ng-if=driverData.user class=dropdown-item><a ui-sref=\"private.drivers.edit({id: driverData.user.id, tab : 2})\" ui-sref-opts=\"{ id: driverData.user.id }\" class=color-black><span class=\"fa fa-upload\"></span> {{ \'profile:section:document:title\' | translate }}</a></div></div></div></div><div class=\"col col-md-3 text-center\"><img ng-if=driverData.user.img_perfil_arr ng-src=\"{{driverData.user.img_perfil_arr[0][\'imagen-60\']}}\" class=img-fluid border=0></div><div class=\"col col-md-9 truck-items-data\"><div class=\"row parrafo\"><div class=\"col col-sm-3\"><h3 class=title-truck-details>{{ \'drivers:details:basic_info:title\' | translate }}</h3></div></div><div class=\"row parrafo\"><div class=\"col col-sm-3\"><label>{{ \'drivers:details:driver_company_id:title\' | translate }}</label><p ng-if=driverData.id_integration_drivers>{{driverData.id_integration_drivers}}</p><p ng-if=!driverData.id_integration_drivers>---</p></div><div class=\"col col-sm-3\"><label>{{ \'drivers:details:country:title\' | translate }}</label><p ng-if=driverData.user.user_contry>{{driverData.user.user_contry}}</p><p ng-if=!driverData.user.user_contry>---</p></div><div class=\"col col-sm-3\"><label>{{ \'drivers:details:insurance_number:title\' | translate }}</label><p ng-if=driverData.bond_insurance_num>{{driverData.bond_insurance_num}}</p><p ng-if=!driverData.bond_insurance_num>---</p></div></div><div class=\"row parrafo\"><div class=\"col col-sm-3\"><label>{{ \'drivers:details:first_name:title\' | translate }}</label><p ng-if=driverData.user.user_first_name>{{driverData.user.user_first_name}}</p><p ng-if=!driverData.user.user_first_name>---</p></div><div class=\"col col-sm-3\"><label>{{ \'drivers:details:city:title\' | translate }}</label><p ng-if=driverData.user.user_city>{{driverData.user.user_city}}</p><p ng-if=!driverData.user.user_city>---</p></div><div class=\"col col-sm-3\"><label>{{ \'drivers:details:insurance_company:title\' | translate }}</label><p ng-if=driverData.bond_insurance_comp>{{driverData.bond_insurance_comp}}</p><p ng-if=!driverData.bond_insurance_comp>---</p></div></div><div class=\"row parrafo\"><div class=\"col col-sm-3\"><label>{{ \'drivers:details:last_name:title\' | translate }}</label><p ng-if=driverData.user.user_last_name>{{driverData.user.user_last_name}}</p><p ng-if=!driverData.user.user_last_name>---</p></div><div class=\"col col-sm-3\"><label>{{ \'drivers:details:state:title\' | translate }}</label><p ng-if=driverData.user.user_state>{{driverData.user.user_state}}</p><p ng-if=!driverData.user.user_state>---</p></div><div class=\"col col-sm-3\"><label>{{ \'drivers:details:insurance_corp_number:title\' | translate }}</label><p ng-if=driverData.bond_insurance_num_policy>{{driverData.bond_insurance_num_policy}}</p><p ng-if=!driverData.bond_insurance_num_policy>---</p></div></div><div class=\"row parrafo\"><div class=\"col col-sm-3\"><label>{{ \'drivers:details:phone:title\' | translate }}</label><p ng-if=driverData.user.user_phone>{{driverData.user.user_phone}}</p><p ng-if=!driverData.user.user_phone>---</p></div><div class=\"col col-sm-3\"><label>{{ \'drivers:details:zipcode:title\' | translate }}</label><p ng-if=driverData.user.user_postalcode>{{driverData.user.user_postalcode}}</p><p ng-if=!driverData.user.user_postalcode>---</p></div><div class=\"col col-sm-3\"><label>{{ \'drivers:details:license_number:title\' | translate }}</label><p ng-if=driverData.driver_license_num>{{driverData.driver_license_num}}</p><p ng-if=!driverData.driver_license_num>---</p></div></div><div class=\"row parrafo\"><div class=\"col col-sm-3\"><label>{{ \'drivers:details:email:title\' | translate }}</label><p ng-if=driverData.user.user_email>{{driverData.user.user_email}}</p><p ng-if=!driverData.user.user_email>---</p></div></div><div class=\"row parrafo\"><div class=\"col col-sm-3\"><h3 class=title-truck-details>{{ \'drivers:details:truck_assigned:title\' | translate }}</h3></div></div><div class=\"row parrafo\" ng-if=\"driverData.trucks.length == 0\"><div class=col><p>{{\'drivers:details:truck_assigned:empty\' | translate }}</p></div></div><div class=\"row parrafo\" ng-repeat=\"truckDriver in driverData.trucks\"><div class=col><p><label>{{truckDriver.brand}} {{truckDriver.model}}</label><br><span>{{\'trucks:details:plate:title\' | translate }}: {{truckDriver.plate}}</span><br><span>{{\'trucks:list:input:truck_id:filter\' | translate }}: {{truckDriver.id}}</span><br><a ng-click=goToSeeTruckId(truckDriver.id) class=\"small-text normal-link pointer\">{{\'drivers:details:truck_assigned:go_to_see\' | translate }}</a></p></div></div></div></div></div>");
$templateCache.put("app/drivers/templates/tabs/tab-drive.html","<div class=row><div class=col-12><div class=row><div class=col-4><div class=pic-square ngf-select ng-model=driversedit.dataUpdateDriver.pic name=pic ngf-pattern=\"\'image/*\'\" ngf-accept=\"\'image/*\'\" ngf-max-size=2MB><img ng-show=postDriverFormName.pic.$valid ngf-thumbnail=driversedit.dataUpdateDriver.pic class=img-fluid> <img ng-show=!postDriverFormName.pic.$valid ngf-thumbnail=\"driversedit.driverData.user.img_perfil[0][\'imagen-60\']\" class=img-fluid></div></div><div class=col-8><div class=form-group><div class=row><div class=col-6><label>{{ \'drivers:add:form:id_integration_driver:text\' | translate }}</label><span class=help-inline ng-show=postDriverFormName.id_integration_drivers.$error.required>*</span> <input type=text name=id_integration_drivers class=form-control ng-model=driversedit.dataUpdateDriver.id_integration_drivers placeholder=\'{{ \"drivers:add:form:id_integration_driver:text\" | translate }}\' required></div></div></div><div class=form-group><div class=row><div class=col-6><label>{{ \'drivers:add:form:name:text\' | translate }}</label><span class=help-inline ng-show=postDriverFormName.user_first_name.$error.required>*</span> <input type=text name=user_first_name class=form-control ng-model=driversedit.dataUpdateDriver.user_first_name placeholder=\'{{ \"drivers:add:form:name:text\" | translate }}\' required></div><div class=col-6><label>{{ \'drivers:add:form:lastname:text\' | translate }}</label><span class=help-inline ng-show=postDriverFormName.lastname.$error.required>*</span> <input type=text name=lastname class=form-control ng-model=driversedit.dataUpdateDriver.user_last_name placeholder=\'{{ \"drivers:add:form:lastname:text\" | translate }}\' required></div></div></div><div class=form-group><div class=row><div class=col-6><label>{{ \'drivers:add:form:phone:text\' | translate }}</label><span class=help-inline ng-show=postDriverFormName.phone.$error.required>*</span> <input type=text name=phone class=form-control ng-model=driversedit.dataUpdateDriver.user_phone placeholder=\'{{ \"drivers:add:form:phone:text\" | translate }}\' required></div><div class=col-6><label>{{ \'drivers:add:form:email:text\' | translate }}</label><span class=help-inline ng-show=postDriverFormName.email.$error.required>*</span> <input type=email name=email class=form-control ng-model=driversedit.dataUpdateDriver.user_email placeholder=\'{{ \"drivers:add:form:email:text\" | translate }}\' required></div></div></div></div></div><div class=form-group><div class=row><div class=col-6><label>{{ \'drivers:add:form:country:text\' | translate }}</label><span class=help-inline ng-show=postDriverFormName.country.$error.required>*</span> <input type=text name=country class=form-control g-places-autocomplete force-selection=true ng-model=driversedit.dataUpdateDriver.user_contry placeholder=\'{{ \"drivers:add:form:country:text\" | translate }}\' required></div><div class=col-6><label>{{ \'drivers:add:form:state:text\' | translate }}</label><span class=help-inline ng-show=postDriverFormName.state.$error.required>*</span> <input type=text name=state class=form-control g-places-autocomplete force-selection=true ng-model=driversedit.dataUpdateDriver.user_state placeholder=\'{{ \"drivers:add:form:state:text\" | translate }}\' required></div></div></div><div class=form-group><div class=row><div class=col-6><label>{{ \'drivers:add:form:city:text\' | translate }}</label><span class=help-inline ng-show=postDriverFormName.city.$error.required>*</span> <input type=text name=city class=form-control g-places-autocomplete options=driversedit.optionsGoogleInputCity force-selection=true ng-model=driversedit.dataUpdateDriver.user_city placeholder=\'{{ \"drivers:add:form:city:text\" | translate }}\' required></div><div class=col-6><label>{{ \'drivers:add:form:zipcode:text\' | translate }}</label><span class=help-inline ng-show=postDriverFormName.zipcode.$error.required>*</span> <input type=text name=zipcode class=form-control ng-model=driversedit.dataUpdateDriver.user_postalcode placeholder=\'{{ \"drivers:add:form:zipcode:text\" | translate }}\' required></div></div></div><div class=form-group><div class=row><div class=col-6><label>{{ \'drivers:add:form:insurance_number:text\' | translate }}</label><!--<span class=\"help-inline\" ng-show=\"postDriverFormName.insurance_number.$error.required\">*</span>--> <input type=text name=insurance_number class=form-control ng-model=driversedit.dataUpdateDriver.bond_insurance_num placeholder=\'{{ \"drivers:add:form:insurance_number:text\" | translate }}\'></div><div class=col-6><label>{{ \'drivers:add:form:insurance_company:text\' | translate }}</label><!--<span class=\"help-inline\" ng-show=\"postDriverFormName.insurance_company.$error.required\">*</span>--> <input type=text name=insurance_company class=form-control ng-model=driversedit.dataUpdateDriver.bond_insurance_comp placeholder=\'{{ \"drivers:add:form:insurance_company:text\" | translate }}\'></div></div></div><div class=form-group><div class=row><div class=col-6><label>{{ \'drivers:add:form:coupon_insurance:text\' | translate }}</label><!--<span class=\"help-inline\" ng-show=\"postDriverFormName.coupon_insurance.$error.required\">*</span>--> <input type=text name=coupon_insurance class=form-control ng-model=driversedit.dataUpdateDriver.bond_insurance_num_policy placeholder=\'{{ \"drivers:add:form:coupon_insurance:text\" | translate }}\'></div><div class=col-6><label>{{ \'drivers:add:form:license_number:text\' | translate }}</label><span class=help-inline ng-show=postDriverFormName.license_number.$error.required>*</span> <input type=text name=license_number class=form-control ng-model=driversedit.dataUpdateDriver.driver_license_num placeholder=\'{{ \"drivers:add:form:license_number:text\" | translate }}\' required></div></div></div><div class=form-group><div class=row><div class=col-12><label>{{ \'drivers:add:form:truck:text\' | translate }}</label><span ng-if=\"driversedit.dataUpdateDriver.truck_id != null\"><br>{{ \'drivers:add:current_truck_assigned:text\' | translate }}: ID {{driversedit.dataUpdateDriver.truck_id}} - {{driversedit.driverData.trucks[0].brand}} {{driversedit.driverData.trucks[0].model}}</span><select name=truck id=driver ng-model=driversedit.dataUpdateDriver.truck_id class=\"form-control input-md\"><option value=\"\">{{ \'drivers:add:form:truck:any\' | translate }}</option><option ng-repeat=\"option in driversedit.trucksList\" value={{option.id}}>ID: {{option.id}} - {{option.brand}} {{option.marca}} {{option.model}}</option></select></div></div></div></div></div><div class=\"row main-botonera\"><div class=\"col-12 col-sm-9\"><button ng-disabled=driversedit.savingUpdateDriver type=submit class=\"btn btn-class1 bg-color-9 color-black\">{{ \'drivers:edit:form:btn:save_btn\' | translate }}</button> <a ng-disabled=driversedit.savingUpdateDriver ng-click=driversedit.submitReturnListFunc(postDriverFormName) class=\"normal-link color-black small-text\">{{ \'loads:add:form:btn:save_return_list\' | translate }}</a></div><div class=\"col-12 col-sm-3 text-right\"><a ng-if=!driversedit.savingUpdateDriver ui-sref=private.drivers ui-sref-opts=\"{ reload: true }\" class=\"normal-link color-black small-text cancel-post-link\">{{ \'loads:add:form:btn:cancel\' | translate }}</a></div></div>");
$templateCache.put("app/loads/templates/directives/load-add-basic.html","<h3 class=\"large-title subtitle-section\">{{ \'loads:add:form:section:basic_information:title\' | translate }}</h3><div class=form-group><div class=row><div class=\"col-7 col-md-7\"><label>{{ \'loads:add:form:select_pickup_address:text\' | translate }}</label><div class=row><div class=col-sm-12><select class=form-control ng-model=loadsadd.dataNewLoad.pickup_address_id ng-disabled=\"loadsadd.cmbAddresses.length < 1\" ng-change=loadsadd.setterInformation() ng-options=\"value.id as value.text for (key, value) in loadsadd.cmbAddresses\"><option value=\"\">{{ \'loads:add:form:select:any\' | translate }}</option></select></div></div></div></div></div><div class=form-group><div class=row><div class=col-md-4><div class=form-group><label class=field-label>Pais</label><span class=help-inline ng-show=postLoadFormName.country.$error.required>*</span><div class=input-group><select class=form-control name=country ng-model=loadsadd.dataNewLoad.country ng-change=loadsadd.setCountriesPickup() ng-disabled=\"loadsadd.cmbCountries.length < 1\" ng-options=\"value.id as value.name for (key, value) in loadsadd.cmbCountries\"><option value=\"\">{{ \'loads:add:form:select:any\' | translate }}</option></select></div></div></div><div class=col-md-4><div class=form-group><label>{{ \'loads:add:form:pickup_zip:text\' | translate }}</label><span class=help-inline ng-show=postLoadFormName.pickup_zip.$error.required>*</span><div class=input-group><input type=text class=form-control placeholder=\'{{ \"loads:add:form:pickup_zip:text\" | translate }}\' ng-model=loadsadd.dataNewLoad.zip_code_pickup ng-pattern=loadsadd.zip_regex_pickup ng-blur=loadsadd.getZipCodePickup() required></div></div></div><div class=col-md-4><div class=form-group><label class=field-label>{{ \'loads:add:form:origin:text\' | translate }}</label><span class=help-inline ng-show=postLoadFormName.origin.$error.required>*</span><div class=input-group><input type=text name=origin class=form-control g-places-autocomplete options=loadsadd.optionsGoogleInputCity force-selection=true ng-model=loadsadd.dataSelectPickupCity placeholder=\'{{ \"loads:add:form:origin:text\" | translate }}\' autocomplete=off readonly required></div></div></div></div></div><div class=form-group><div class=row><div class=col-md-4><div class=form-group><label class=field-label>{{ \'loads:add:form:city:text\' | translate }}</label><div class=input-group><input type=text name=origin class=form-control force-selection=true ng-model=loadsadd.dataSelectPickupState placeholder=\'{{ \"loads:add:form:city:text\" | translate }}\' autocomplete=off readonly required></div></div></div><div class=col-md-4><div class=form-group><label>{{ \'loads:add:form:pickup_address:text\' | translate }}</label><span class=help-inline ng-show=postLoadFormName.pickup_address.$error.required>*</span><div class=input-group><input type=text name=pickup_address class=form-control g-places-autocomplete force-selection=true ng-model=loadsadd.dataSelectPickupAddress ng-blur=loadsadd.checkOriginZip() placeholder=\'{{ \"loads:add:form:pickup_address:text\" | translate }}\' autocomplete=off required></div></div></div></div></div><div class=form-group><div class=row><div class=col-md-8><label>{{ \'loads:add:form:details_pickup_address:text\' | translate }}</label><input type=text class=form-control ng-model=loadsadd.dataNewLoad.detail_address_pickup placeholder=\'{{ \"loads:add:form:details_pickup_address:text\" | translate }}\'></div></div></div><div class=form-group><div class=row><div class=\"col-3 col-md-3 mt-3 pt-2\"><input type=checkbox class=custom-checkbox id=multiple_stops_yn name=multiple_stops_yn ng-change=loadsadd.resetMultipleStops() ng-model=loadsadd.dataNewLoad.allow_multiple_stops ng-true-value=1 ng-false-value=0><label for=multiple_stops_yn><span></span>{{ \'loads:add:form:allow_multiple_stops:text\' | translate }}</label></div><div ng-if=\"loadsadd.dataNewLoad.allow_multiple_stops == 1\" class=\"col-3 col-md-3 mt-3 pt-2\"><button type=button ng-click=loadsadd.addMultipleStop() class=\"btn btn-class2 bg-color-9 color-black\">{{ \'loads:add:form:add_multiple_stop:text\' | translate }}</button></div></div></div><div class=form-group ng-if=\"loadsadd.dataNewLoad.allow_multiple_stops == 1\"><div class=row><div class=col-12 style=\"margin-top: 5px\"><label>{{ \'loads:add:form:multiple_stops_explanation:text\' | translate }}</label></div></div><div class=row><div class=\"col-12 col-md-6 mr-2\" ng-repeat=\"multiplestopfield in loadsadd.camposParadasMultiples\" style=\"margin-top: 5px\"><label>{{ \'loads:add:form:multiple_stop_pretitle:text\' | translate }} {{(multiplestopfield.id + 1)}}</label><br><input type=text name=stop_{{multiplestopfield.id}} class=\"form-control inline-block\" g-places-autocomplete force-selection=true ng-model=multiplestopfield.address placeholder=\"\" autocomplete=off style=\"max-width: calc(100% - 33px)\"><div ng-if=\"multiplestopfield.id > 0\" class=inline-block style=\"margin-left: 3px\"><button type=button ng-click=loadsadd.deleteMultipleStop(multiplestopfield.id) class=\"btn btn-class2 bg-color-4 color-white\">{{ \'loads:add:form:delete_multiple_stop:text\' | translate }}</button></div></div></div></div><div class=form-group><div class=row><div class=\"col-6 col-sm-4\"><label>{{ \'loads:add:form:pickup_date:text\' | translate }}</label><span class=help-inline ng-show=postLoadFormName.pickup_date.$error.required>*</span> <input ng-blur=loadsadd.allowDeliveryDate() date-range-picker type=text class=\"form-control date-picker\" ng-model=loadsadd.dataNewLoad.pickup_date placeholder=\'{{ \"loads:add:form:pickup_date:text\" | translate }}\' options=loadsadd.optsDatePicker min=loadsadd.datePickerMinDate required></div><div class=\"col-6 col-sm-4\"><div class=row><label>{{ \'loads:add:form:timer_star_pickup:text\' | translate }}</label></div><div class=row><span class=help-inline ng-show=\"postLoadFormName.pickup_start_time_hour.$error.required || postLoadFormName.pickup_start_time_minutes.$error.required\">*</span><select style=\"width: 40%; display: inline-block; text-indent: 30%\" name=pickup_start_time_hour id=pickup_start_time_hour ng-model=loadsadd.pickup_start_time_hour class=\"form-control input-md\" required><option ng-repeat=\"hour in loadsadd.hour_select\" value={{hour}}>{{hour}}</option></select>&nbsp;:&nbsp;<select style=\"width: 40%; display: inline-block; text-indent: 30%\" name=pickup_start_time_minutes id=pickup_start_time_minutes ng-model=loadsadd.pickup_start_time_minutes class=\"form-control input-md\" required><option ng-repeat=\"minute in loadsadd.minutes_select\" value={{minute}}>{{minute}}</option></select></div></div><div class=\"col-6 col-sm-4\"><div class=row><label>{{ \'loads:add:form:timer_finish_pickup:text\' | translate }}</label></div><div class=row><span class=help-inline ng-show=\"postLoadFormName.pickup_finish_time_hour.$error.required || postLoadFormName.pickup_finish_time_minutes.$error.required\">*</span><select style=\"width: 40%; display: inline-block; text-indent: 30%\" name=pickup_finish_time_hour id=pickup_finish_time_hour ng-model=loadsadd.pickup_finish_time_hour class=\"form-control input-md\" required><option ng-repeat=\"hour in loadsadd.hour_select\" value={{hour}}>{{hour}}</option></select>&nbsp;:&nbsp;<select style=\"width: 40%; display: inline-block; text-indent: 30%\" name=pickup_finish_time_minutes id=pickup_finish_time_minutes ng-model=loadsadd.pickup_finish_time_minutes class=\"form-control input-md\" required><option ng-repeat=\"minute in loadsadd.minutes_select\" value={{minute}}>{{minute}}</option></select></div></div></div></div><div class=form-group><div class=col-sm-6><input type=checkbox class=custom-checkbox id=save_pickup_address name=save_pickup_address ng-model=loadsadd.dataNewLoad.save_pickup_address ng-true-value=1 ng-false-value=0><label for=save_pickup_address><span></span>{{ \'loads:add:form:save_pickup:text\' | translate }}</label></div></div><hr><div class=form-group><div class=row><div class=\"col-7 col-sm-7\"><label>{{ \'loads:add:form:select_delivery_address:text\' | translate }}</label><div class=row><div class=col-sm-12><select class=form-control ng-model=loadsadd.dataNewLoad.delivery_address_id ng-disabled=\"loadsadd.cmbAddresses.length < 1\" ng-change=loadsadd.setterInformation() ng-options=\"value.id as value.text for (key, value) in loadsadd.cmbAddresses\"><option value=\"\">{{ \'loads:add:form:select:any\' | translate }}</option></select></div></div></div></div></div><div class=form-group><div class=row><div class=col-md-4><div class=form-group><label class=field-label>Pais</label><span class=help-inline ng-show=postLoadFormName.country.$error.required>*</span><div class=input-group><select class=form-control name=country ng-model=loadsadd.dataNewLoad.countries_delivery ng-change=loadsadd.setCountriesDelivery() ng-disabled=\"loadsadd.cmbCountries.length < 1\" ng-options=\"value.id as value.name for (key, value) in loadsadd.cmbCountries\"><option value=\"\">{{ \'loads:add:form:select:any\' | translate }}</option></select></div></div></div><div class=col-md-4><label>{{ \'loads:add:form:delivery_zip:text\' | translate }}</label><span class=help-inline ng-show=postLoadFormName.delivery_zip.$error.required>*</span> <input type=text name=delivery_zip class=form-control ng-model=loadsadd.dataNewLoad.zip_code_delivery ng-pattern=loadsadd.zip_regex_delivery ng-blur=loadsadd.getZipCodeDelivery() placeholder=\'{{ \"loads:add:form:delivery_zip:text\" | translate }}\' required></div><div class=col-md-4><label>{{ \'loads:add:form:origin:text\' | translate }}</label><span class=help-inline ng-show=postLoadFormName.destination.$error.required>*</span> <input type=text name=destination class=form-control g-places-autocomplete options=loadsadd.optionsGoogleInputCity force-selection=true ng-model=loadsadd.dataSelectDeliveryCity placeholder=\'{{ \"loads:add:form:destination:text\" | translate }}\' autocomplete=off readonly required></div></div></div><div class=form-group><div class=row><div class=col-md-4><label>{{ \'loads:add:form:city:text\' | translate }}</label><input type=text name=destination class=form-control g-places-autocomplete options=loadsadd.optionsGoogleInputCity force-selection=true ng-model=loadsadd.dataSelectDeliveryState placeholder=\'{{ \"loads:add:form:city:text\" | translate }}\' autocomplete=off readonly required></div><div class=col-md-4><label>{{ \'loads:add:form:delivery_address:text\' | translate }}</label><span class=help-inline ng-show=postLoadFormName.delivery_address.$error.required>*</span> <input type=text name=delivery_address class=form-control g-places-autocomplete force-selection=true ng-model=loadsadd.dataSelectDeliveryAddress ng-blur=loadsadd.checkDestinationZip() placeholder=\'{{ \"loads:add:form:delivery_address:text\" | translate }}\' autocomplete=off required></div></div></div><div class=form-group><div class=row><div class=col-md-8><label>{{ \'loads:add:form:details_delivery_address:text\' | translate }}</label><input type=text name=detail_address_delivery class=form-control ng-model=loadsadd.dataNewLoad.detail_address_delivery placeholder=\'{{ \"loads:add:form:details_delivery_address:text\" | translate }}\'></div></div></div><div class=form-group><div class=row><div class=\"col-6 col-sm-4\"><label>{{ \'loads:add:form:delivery_date:text\' | translate }}</label><span class=help-inline ng-show=postLoadFormName.delivery_date.$error.required>*</span> <input ng-disabled=loadsadd.dateDeliveryDisabled date-range-picker type=text class=\"form-control date-picker\" ng-model=loadsadd.dataNewLoad.delivery_date placeholder=\'{{ \"loads:add:form:delivery_date:text\" | translate }}\' options=loadsadd.optsDatePicker min=loadsadd.dataNewLoad.pickup_date required></div><div class=\"col-6 col-sm-4\"><div class=row><label>{{ \'loads:add:form:timer_start_delivery:text\' | translate }}</label></div><div class=row><span class=help-inline ng-show=\"postLoadFormName.delivery_start_time_hour.$error.required || postLoadFormName.delivery_start_time_minutes.$error.required\">*</span><select style=\"width: 40%; display: inline-block; text-indent: 30%\" name=delivery_start_time_hour id=delivery_start_time_hour ng-model=loadsadd.delivery_start_time_hour class=\"form-control input-md\" required><option ng-repeat=\"hour in loadsadd.hour_select\" value={{hour}}>{{hour}}</option></select>&nbsp;:&nbsp;<select style=\"width: 40%; display: inline-block; text-indent: 30%\" name=delivery_start_time_minutes id=delivery_start_time_minutes ng-model=loadsadd.delivery_start_time_minutes class=\"form-control input-md\" required><option ng-repeat=\"minute in loadsadd.minutes_select\" value={{minute}}>{{minute}}</option></select></div></div><div class=\"col-6 col-sm-4\"><div class=row><label>{{ \'loads:add:form:timer_finish_delivery:text\' | translate }}</label></div><div class=row><span class=help-inline ng-show=\"lpostLoadFormName.delivery_finish_time_hour.$error.required || postLoadFormName.delivery_finish_time_minutes.$error.required\">*</span><select style=\"width: 40%; display: inline-block; text-indent: 30%\" name=delivery_finish_time_hour id=delivery_finish_time_hour ng-model=loadsadd.delivery_finish_time_hour class=\"form-control input-md\" required><option ng-repeat=\"hour in loadsadd.hour_select\" value={{hour}}>{{hour}}</option></select>&nbsp;:&nbsp;<select style=\"width: 40%; display: inline-block; text-indent: 30%\" name=delivery_finish_time_minutes id=delivery_finish_time_minutes ng-model=loadsadd.delivery_finish_time_minutes class=\"form-control input-md\" required><option ng-repeat=\"minute in loadsadd.minutes_select\" value={{minute}}>{{minute}}</option></select></div></div></div></div><div class=form-group><div class=col-sm-4><input type=checkbox class=custom-checkbox id=save_delivery_address name=save_delivery_address ng-model=loadsadd.dataNewLoad.save_delivery_address ng-true-value=1 ng-false-value=0><label for=save_delivery_address><span></span>{{ \'loads:add:form:save_delivery:text\' | translate }}</label></div></div>");
$templateCache.put("app/loads/templates/directives/load-add-technical.html","<h3 class=\"large-title subtitle-section\">{{ \'loads:add:form:section:technical_information:title\' | translate }}</h3><div class=form-group><div class=row><div class=\"col-6 col-sm-6\"><label>{{ \'loads:add:form:size:text\' | translate }} <span class=help-inline ng-show=postLoadFormName.dimension.$error.required>*</span></label><select class=\"form-control input-md\" name=dimension id=dimension ng-model=loadsadd.dataNewLoad.dimension ng-change=loadsadd.sizeConfigurationChange() required><option value=\"\">{{ \'loads:add:form:select:any\' | translate }}</option><option ng-repeat=\"option in loadsadd.itemsSizeLenLoads.LoadsSize_list\" value={{option.id}}>{{option.name}}</option></select></div><div class=\"col-6 col-sm-6\"><label>{{ \'loads:add:form:container_type:text\' | translate }}</label><select class=\"form-control input-md\" name=container id=container ng-model=loadsadd.dataNewLoad.container_type_code><option value=\"\">{{ \'loads:add:form:select:any\' | translate }}</option><option ng-repeat=\"option in loadsadd.cmbContainerTypes\" value={{option.value}}>{{option.text}}</option></select></div></div></div><div class=form-group><div class=row><div class=\"col-6 col-sm-6\"><label>{{ \'loads:add:form:truck_type:text\' | translate }} <span class=help-inline ng-show=postLoadFormName.truck_type_id.$error.required>*</span></label><select class=\"form-control input-md\" ng-model=loadsadd.truckTypeRequired ng-disabled=\"loadsadd.simpleTruckTypes.length < 1\" ng-change=loadsadd.truckTypeChange()><option value=\"\">{{ \'loads:add:form:select:any\' | translate }}</option><option ng-repeat=\"option in loadsadd.simpleTruckTypes\" value={{option.id}}>{{option.name}}</option></select></div><div class=\"col-6 col-sm-6\"><label>{{ \'loads:add:form:weight_unit:text\' | translate }} <span class=help-inline ng-show=postLoadFormName.length.$error.required>*</span></label><div class=row><div class=col-sm-12><select class=form-control ng-model=loadsadd.dataNewLoad.weight_unit ng-options=\"value.value as value.text for (key, value) in loadsadd.cmbWeightUnits\"></select></div></div></div></div></div><div class=form-group><div class=row><div class=\"col-6 col-sm-6\"><label>{{ \'loads:add:form:weight:text\' | translate }} {{\'loads:add:form:weight:only_number:text\' | translate}} {{loadsadd.dataNewLoad.weight_unit}} <span class=help-inline ng-show=\"postLoadFormName.weight.$error.required || (postLoadFormName.weight.$viewValue <= 0)\">*</span></label><div class=row><div class=col-sm-12><input class=form-control type=number name=weight ng-blur=loadsadd.cleanLoadWeightValue() ng-model=loadsadd.dataNewLoad.weight placeholder=\'{{ \"loads:add:form:weight:text\" | translate }}\' required></div></div></div><div class=\"col-6 col-sm-6\"><label>{{ \'loads:add:form:distance_unit:text\' | translate }} <span class=help-inline ng-show=postLoadFormName.length.$error.required>*</span></label><div class=row><div class=col-sm-12><select class=form-control ng-model=loadsadd.dataNewLoad.distance_unit ng-options=\"value.value as value.text for (key, value) in loadsadd.cmbDistanceUnits\"></select></div></div></div></div></div><div class=form-group><div class=row><div class=\"col-6 col-sm-6\"><label>{{ \'loads:add:form:height:text\' | translate }} {{\'loads:add:form:weight:only_number:text\' | translate}} {{loadsadd.dataNewLoad.distance_unit}} <span class=help-inline ng-show=\"postLoadFormName.height.$error.required || (postLoadFormName.height.$viewValue <= 0)\">*</span></label><div class=row><div class=col-sm-12><input class=form-control type=text name=height ng-blur=loadsadd.cleanLoadHeightValue() ng-model=loadsadd.dataNewLoad.height placeholder=\'{{ \"loads:add:form:height:text\" | translate }}\' required></div></div></div><div class=\"col-6 col-sm-6\"><label>{{ \'loads:add:form:length:text\' | translate }} {{\'loads:add:form:weight:only_number:text\' | translate}} {{loadsadd.dataNewLoad.distance_unit}} <span class=help-inline ng-show=postLoadFormName.length_loads.$error.required>*</span></label><div class=row><div class=col-sm-12><input class=form-control type=number name=length_loads ng-blur=loadsadd.cleanLoadLengthValue() ng-model=loadsadd.dataNewLoad.length_loads placeholder=\'{{ \"loads:add:form:length:text\" | translate }}\'></div></div></div></div></div><div class=form-group><div class=row><div class=\"col-6 col-sm-6\"><label>{{ \'loads:add:form:width:text\' | translate }} {{\'loads:add:form:weight:only_number:text\' | translate}} {{loadsadd.dataNewLoad.distance_unit}} <span class=help-inline ng-show=\"postLoadFormName.width.$error.required || (postLoadFormName.width.$viewValue <= 0)\">*</span></label><div class=row><div class=col-sm-12><input class=form-control type=text name=width ng-blur=loadsadd.cleanLoadWidthValue() ng-model=loadsadd.dataNewLoad.width placeholder=\'{{ \"loads:add:form:width:text\" | translate }}\' required></div></div></div><div class=\"col-6 col-sm-6\"><label>{{ \'loads:add:form:trailer_type_required:text\' | translate }}</label><span class=help-inline ng-show=postLoadFormName.trailer_type.$error.required>*</span><select ng-model=loadsadd.dataNewLoad.trailer_type class=\"form-control input-md\" ng-disabled=\"loadsadd.simpleTruckTypes.length < 1\" required><option value=\"\">{{ \'loads:add:form:select:any\' | translate }}</option><option ng-repeat=\"option in loadsadd.simpleTruckTypes\" value={{option.id}}>{{option.name}}</option></select></div></div></div><div class=form-group><div class=row><div class=col><label>{{ \'loads:add:form:load_type:text\' | translate }}</label><span class=help-inline ng-show=postLoadFormName.loadtype.$error.required>*</span><select name=loadtype id=loadtype ng-model=loadsadd.load_type_combo_box class=\"form-control input-md\" required><option value=\"\">{{ \'loads:add:form:select:any\' | translate }}</option><option ng-repeat=\"option in loadsadd.loadTypeList\" value={{option.id}}>{{option.name}}</option></select></div><div class=col><label>{{ \'loads:add:form:noot_load:text\' | translate }}</label><span class=help-inline ng-show=postLoadFormName.noot_load.$error.required>*</span> <input type=text name=noot_load class=form-control ng-model=loadsadd.dataNewLoad.noot_load placeholder=\'{{ \"loads:add:form:noot_load:text\" | translate }}\' required></div></div></div><div class=form-group><div class=row><div class=\"col-6 col-sm-6\"><label>{{ \'loads:add:form:consignee:text\' | translate }}</label><span class=help-inline ng-show=postLoadFormName.consignee.$error.required>*</span> <input type=text name=consignee class=form-control ng-model=loadsadd.dataNewLoad.consignee placeholder=\'{{ \"loads:add:form:consignee:text\" | translate }}\' required></div><div class=\"col-6 col-sm-6\"><label>{{ \'loads:add:form:receiver:text\' | translate }}</label><span class=help-inline ng-show=postLoadFormName.receiver.$error.required>*</span> <input type=text name=receiver class=form-control ng-model=loadsadd.dataNewLoad.receiver placeholder=\'{{ \"loads:add:form:receiver:text\" | translate }}\' required></div></div></div><div class=form-group><div class=row><div class=\"col-6 col-sm-3\"><label>{{ \'loads:add:form:price:text\' | translate }}</label><span class=help-inline ng-show=postLoadFormName.price.$error.required>*</span> <input type=text name=price class=form-control ng-model=loadsadd.dataNewLoad.price placeholder=\'{{ \"loads:add:form:price:text\" | translate }}\' required></div></div></div><div class=form-group><div class=row><div class=col><label>{{ \'loads:add:form:carrier_skills_required:text\' | translate }}</label><span class=help-inline ng-show=loadsadd.carrierSkillsRequired>*</span><ul class=list-checks><li ng-repeat=\"carrierskill in loadsadd.skillsRequiredCarrier\"><input type=checkbox id={{carrierskill.name}} name={{carrierskill.name}} ng-model=carrierskill.checked class=custom-checkbox><label for={{carrierskill.name}}><span></span>{{carrierskill.name}}</label></li></ul></div></div></div><div class=form-group ng-if=false><div class=row><div class=\"col-6 col-sm-6\"><label>{{ \'loads:add:form:load_type_license_id:text\' | translate }}</label><span class=help-inline ng-show=postLoadFormName.load_type_license_id.$error.required>*</span><select name=load_type_license_id id=load_type_license_id ng-model=loadsadd.dataNewLoad.load_type_license_id ng-change=loadsadd.driverLicenseChange() class=\"form-control input-md\" required><option value=\"\">{{ \'loads:add:form:select:any\' | translate }}</option><option ng-repeat=\"option in loadsadd.itemsSizeLenLoads.loadTypeLicense\" value={{option.id}}>{{option.categoria}}</option></select></div><div class=\"col-6 col-sm-6\"><div ng-show=\"loadsadd.loadLicenseTypeInfo != \'\'\" class=\"alert alert-info\" role=alert><b>{{loadsadd.loadLicenseTypeTitle}}</b><br><span style=font-size:12px>{{loadsadd.loadLicenseTypeInfo}}</span></div></div></div></div><div class=form-group><div class=row><div class=\"col-6 col-sm-6\"><label>{{ \'loads:add:form:commodity:text\' | translate }}</label><span class=help-inline ng-show=postLoadFormName.commodity.$error.required>*</span><select name=commodity id=commodity ng-model=loadsadd.dataNewLoad.commodity_id ng-change=loadsadd.commodityChange() class=\"form-control input-md\" required><option value=\"\">{{ \'loads:add:form:select:any\' | translate }}</option><option ng-repeat=\"option in loadsadd.itemsSizeLenLoads.ListCommodity\" value={{option.id}}>{{option.type_commodity}}</option></select></div><div class=\"col-6 col-sm-6\"><div ng-show=\"loadsadd.commodityExcludedInfo != \'\'\" class=\"alert alert-info\" role=alert><b>{{ \'loads:add:form:commodity_excluded:text\' | translate }}</b><br><span style=\"font-size:12px; word-break: break-all\">{{loadsadd.commodityExcludedInfo}}</span></div></div></div></div><!--<div class=\"form-group\">\n  <div class=\"row\">\n    <div class=\"col-6 col-sm-6\">\n      <label>{{ \'loads:add:form:profit:text\' | translate }}\n        <span class=\"help-inline\" ng-show=\"postLoadFormName.profit.$error.required\">*</span>\n      </label>\n      <select class=\"form-control input-md\"\n              id=\"profit\"\n              name=\"profit\"\n              ng-model=\"loadsadd.dataNewLoad.profit_center_code\">\n        <option value=\"\">{{ \'loads:add:form:select:any\' | translate }}</option>\n        <option ng-repeat=\"option in loadsadd.cmbProfitCenters\" value=\"{{option.value}}\">\n          {{option.text}}\n        </option>\n      </select>\n    </div>\n  </div>\n</div>-->");
$templateCache.put("app/loads/templates/directives/load-add-type.html","<h3 class=\"large-title subtitle-section\">{{ \'loads:add:form:section:load_type:title\' | translate }}</h3><div class=form-group ng-hide=true><input type=checkbox class=custom-checkbox id=recurrent_load name=recurrent_load ng-model=loadsadd.dataNewLoad.frecuency_active ng-true-value=1 ng-false-value=0><label for=recurrent_load><span></span>{{ \'loads:add:form:frecuency_active:text\' | translate }}</label></div><div class=form-group ng-if=\"loadsadd.dataNewLoad.frecuency_active == 1\"><div class=row><div class=\"col-6 col-sm-3\"><label>{{ \'loads:add:form:frecuency_id:text\' | translate }}</label><span class=help-inline ng-show=postLoadFormName.frecuency_id.$error.required>*</span><select name=frecuency_id id=frecuency_id ng-model=loadsadd.dataNewLoad.frecuency_id class=\"form-control input-md\" required><option value=\"\">{{ \'loads:add:form:select:any\' | translate }}</option><option ng-repeat=\"option in loadsadd.itemsSizeLenLoads.FrecuencyLoads_list\" value={{option.id}}>{{option.name}}</option></select></div><div ng-if=\"loadsadd.dataNewLoad.frecuency_id == 6\" class=\"col-6 col-sm-3\"><label>{{ \'loads:add:form:frecuency_data:text\' | translate }}</label><span class=help-inline ng-show=postLoadFormName.frecuency_data.$error.required>*</span> <input date-range-picker type=text name=frecuency_data class=form-control ng-model=loadsadd.dataNewLoad.frecuency_data options=loadsadd.optsDatePicker required></div></div></div><div class=form-group><label>{{ \'loads:add:form:comments:text\' | translate }}</label><textarea class=form-control name=additional_information ng-model=loadsadd.dataNewLoad.load_comments placeholder=\"{{ \'loads:add:form:comments:text\' | translate }}\"></textarea></div>");
$templateCache.put("app/loads/templates/directives/load-details-row.html","<div class=details-table-row><main-loader ng-if=loadingLoadData></main-loader><p ng-if=\"!loadingLoadData && !loadData.load_id\" class=text-center>{{ \'loads:details:error_data:text\' | translate }}</p><div ng-if=\"!loadingLoadData && loadData.load_id\" class=dropdown-actions-load><div class=dropdown><button ng-if=\"!loadingLoadData && loadData.status_loads !=\'CANCELADA\' && loadData.status_loads !=\'ENTREGADA\'  && loadData.status_loads !=\'PAGADA\'\" class=\"btn btn-secondary dropdown-toggle\" type=button id=dropdownMenuButton data-toggle=dropdown aria-haspopup=true aria-expanded=false><span class=\"fa fa-ellipsis-h\"></span></button><div class=\"dropdown-menu dropdown-menu-right\" aria-labelledby=dropdownMenuButton><div ng-if=!loadingLoadData class=dropdown-item><a ui-sref=\"private.loads.details({id: loadData.load_id})\" ui-sref-opts=\"{ id: loadData.load_id }\" class=color-black><span class=\"fa fa-eye\"></span> {{ \'loads:details:options:view\' | translate }}</a></div><div ng-if=!loadingLoadData class=dropdown-item><a ui-sref=\"private.loads.stops({id: loadData.load_id})\" ui-sref-opts=\"{ id: loadData.load_id }\" class=color-black><span class=\"fa fa-hand-paper-o\"></span> {{ \'loads:details:options:stops\' | translate }}</a></div><div permission permission-only=\"\'GENERADOR_CARGA\'\" ng-if=\"!loadingLoadData && loadData.status_loads ==\'NOT_ASSIGNED\'\" class=dropdown-item><a ui-sref=\"private.loads.edit({id: loadData.load_id})\" ui-sref-opts=\"{ id: loadData.load_id }\" class=color-black><span class=\"fa fa-pencil\"></span> {{ \'loads:details:options:edit\' | translate }}</a></div><div class=dropdown-item ng-repeat=\"item in status\" permission permission-only=\"[\'DRIVER\',\'OWNER\']\"><a ng-click=changeStatus() class=\"normal-link color-black pointer\"><span class=\"fa fa-truck\"></span> {{ item.event}} </a><!--<ul>\n            <li ng-repeat=\"statu in status\">\n              <a ng-click=\"changeStatus(\'EN_ORIGEN\')\" class=\"normal-link color-black pointer\">\n                <span class=\"fa fa-truck\"></span> {{ statu.event}}\n              </a>\n            </li>\n          </ul>--></div><!--<div permission permission-only=\"[\'DRIVER\',\'OWNER\']\" ng-if=\"!loadingLoadData && loadData.status_loads ==\'ACEPTADA\'\" class=\"dropdown-item\">\n          <a ng-click=\"changeStatusLoad(\'HACIA_ORIGEN\')\" class=\"normal-link color-black pointer disabled\">\n            <span class=\"fa fa-truck\"></span> {{ \'loads:table:status:hacia_origen:text\' | translate }}\n          </a>\n        </div>\n        <div permission permission-only=\"[\'DRIVER\',\'OWNER\']\" ng-if=\"!loadingLoadData && loadData.status_loads ==\'HACIA_ORIGEN\'\" class=\"dropdown-item\">\n          <a ng-click=\"changeStatusLoad(\'EN_ORIGEN\')\" class=\"normal-link color-black pointer\">\n            <span class=\"fa fa-truck\"></span> {{ \'loads:table:status:en_origen:text\' | translate }}\n          </a>\n        </div>\n        <div permission permission-only=\"[\'DRIVER\',\'OWNER\']\" ng-if=\"!loadingLoadData && loadData.status_loads ==\'EN_ORIGEN\'\" class=\"dropdown-item\">\n          <a ng-click=\"changeStatusLoad(\'CARGANDO\')\" class=\"normal-link color-black pointer\">\n            <span class=\"fa fa-truck\"></span> {{ \'loads:table:status:cargando:text\' | translate }}\n          </a>\n        </div>\n				<div permission permission-only=\"[\'DRIVER\',\'OWNER\']\" ng-if=\"!loadingLoadData && loadData.status_loads ==\'CARGANDO\'\" class=\"dropdown-item\">\n					<a ng-click=\"changeStatusLoad(\'EN_TRANSITO\')\" class=\"normal-link color-black pointer\">\n						<span class=\"fa fa-truck\"></span> {{ \'loads:details:options:in_transit\' | translate }}\n					</a>\n				</div>\n        <div permission permission-only=\"[\'DRIVER\',\'OWNER\']\" ng-if=\"!loadingLoadData && loadData.status_loads ==\'EN_TRANSITO\'\" class=\"dropdown-item\">\n          <a ng-click=\"changeStatusLoad(\'EN_DESTINO\')\" class=\"normal-link color-black pointer\">\n            <span class=\"fa fa-truck\"></span> {{ \'loads:table:status:en_destino:text\' | translate }}\n          </a>\n        </div>\n        <div permission permission-only=\"[\'DRIVER\',\'OWNER\']\" ng-if=\"!loadingLoadData && loadData.status_loads ==\'EN_DESTINO\'\" class=\"dropdown-item\">\n          <a ng-click=\"changeStatusLoad(\'DESCARGANDO\')\" class=\"normal-link color-black pointer\">\n            <span class=\"fa fa-truck\"></span> {{ \'loads:table:status:descargando:text\' | translate }}\n          </a>\n        </div>\n				<div permission permission-only=\"[\'DRIVER\',\'OWNER\']\" ng-if=\"!loadingLoadData && loadData.status_loads ==\'DESCARGANDO\'\" class=\"dropdown-item\">\n					<a ng-click=\"changeStatusLoad(\'ENTREGADA\')\" class=\"normal-link color-black pointer\">\n						<span class=\"fa fa-sign-language\"></span> {{ \'loads:details:options:delivered\' | translate }}\n					</a>\n				</div>\n				<div permission permission-only=\"\'GENERADOR_CARGA\'\" ng-if=\"!loadingLoadData && loadData.status_loads !=\'CANCELADA\' && loadData.status_loads !=\'ENTREGADA\'  && loadData.status_loads !=\'PAGADA\'\" class=\"dropdown-item\">\n					<a ng-click=\"openCancelLoadModal()\" class=\"normal-link color-black pointer\">\n						<span class=\"fa fa-ban\"></span> {{ \'loads:details:options:cancel\' | translate }}\n					</a>\n				</div>\n				<div permission permission-only=\"[\'CARRIER\',\'OWNER\']\" ng-if=\"!loadingLoadData && (loadData.status_loads ==\'ACEPTADA\' || loadData.status_loads ==\'EN_TRANSITO\')\" class=\"dropdown-item\">\n					<a ng-click=\"openCancelLoadModal()\" class=\"normal-link color-black pointer\">\n						<span class=\"fa fa-ban\"></span> {{ \'loads:details:options:cancel\' | translate }}\n					</a>\n				</div>--></div></div></div><div permission permission-only=\"[\'CARRIER\',\'OWNER\']\" ng-if=\"!loadingLoadData && loadData.load_id\" class=\"full-width parrafo info-owner-load\"><ul class=nav><li ng-if=loadData.info_load_generator.company_name class=nav-item>{{loadData.info_load_generator.company_name}}</li><li ng-if=loadData.info_load_generator.user.user_votes.length class=nav-item><span ng-class=\"loadData.info_load_generator.user.user_votes[0].total_prom >= 1 ? \'fa-star\' : \'fa-star-o\'\" class=fa></span> <span ng-class=\"loadData.info_load_generator.user.user_votes[0].total_prom >= 2 ? \'fa-star\' : \'fa-star-o\'\" class=fa></span> <span ng-class=\"loadData.info_load_generator.user.user_votes[0].total_prom >= 3 ? \'fa-star\' : \'fa-star-o\'\" class=fa></span> <span ng-class=\"loadData.info_load_generator.user.user_votes[0].total_prom >= 4 ? \'fa-star\' : \'fa-star-o\'\" class=fa></span> <span ng-class=\"loadData.info_load_generator.user.user_votes[0].total_prom >= 5 ? \'fa-star\' : \'fa-star-o\'\" class=fa></span></li><li ng-if=!loadData.info_load_generator.user.user_votes.length class=nav-item><span class=\"fa fa-star-o\"></span> <span class=\"fa fa-star-o\"></span> <span class=\"fa fa-star-o\"></span> <span class=\"fa fa-star-o\"></span> <span class=\"fa fa-star-o\"></span></li></ul></div><ul ng-if=\"!loadingLoadData && loadData.load_id\" class=\"nav pickup-destiny-details\"><li class=nav-item><h3 class=title-load-details>{{loadData.from}}</h3></li><li class=nav-item><span class=\"fa fa-arrow-right\"></span></li><li class=nav-item><h3 class=title-load-details>{{loadData.to}}</h3></li><li class=nav-item><span>{{loadData.distance}}</span></li></ul><div permission permission-only=\"[\'CARRIER\',\'OWNER\']\" ng-if=\"!loadingLoadData && loadData.load_id\" class=\"full-width parrafo info-owner-load\"><ul class=nav><li ng-if=\"loadData.status_load_btnbg && loadData.status_load_btncolor && loadData.status_load_btntext\" class=nav-item><button class=\"btn-details-status btn btn-class2 {{loadData.status_load_btnbg}} {{loadData.status_load_btncolor}}\">{{loadData.status_load_btntext}}</button></li></ul></div><div class=row><div ng-if=\"!loadingLoadData  && loadData.load_id\" id=loads_map class=\"col col-md-4 pull-l\"><div class=\"col loads-map-detail pull-l\"><div ng-if=!loadingMap><ui-gmap-google-map center=map.center zoom=map.zoom><ui-gmap-marker ng-repeat=\"m in markers\" coords=m.coords idkey=m.id options=m.options></ui-gmap-marker></ui-gmap-google-map></div></div><div class=clearfix></div><div class=\"col mt-2\"><b>{{\'loads:details:map:conversions:title\' | translate}}</b></div><div class=\"col mt-1\" style=\"font-size: 11px\"><img src=assets/images/common/start_point.png width=30 border=0> {{\'loads:details:map:start_point:explanation\' | translate}}</div><div class=\"col mt-1\" style=\"font-size: 11px\"><img src=assets/images/common/end_point.png width=30 border=0> {{\'loads:details:map:end_point:explanation\' | translate}}</div><div class=\"col mt-1\" style=\"font-size: 11px\"><img src=assets/images/common/point_1.png width=30 border=0> {{\'loads:details:map:stop:explanation\' | translate}}</div></div><div ng-if=\"!loadingLoadData  && loadData.load_id\" class=\"col col-md-8 pull-l load-items-data\"><div class=row><div class=col-6><div class=\"row parrafo\"><div class=\"col col-sm-6\"><label>{{\'loads:details:load_id:title\' | translate}}</label><p>{{loadData.load_id}}</p></div><div class=\"col col-sm-6\"><label>{{\'loads:details:pickup_address:title\' | translate}}</label><p><img src=assets/images/common/start_point.png width=27 border=0> {{loadData.pickup_address}}</p></div></div><div class=\"row parrafo\"><div class=\"col col-sm-6\"><label>{{\'loads:details:price:title\' | translate}}</label><p>{{loadData.price_to_show}}</p></div><div class=\"col col-sm-6\"><label>{{\'loads:details:delivery_address:title\' | translate}}</label><p><img src=assets/images/common/end_point.png width=27 border=0> {{loadData.delivery_address}}</p></div></div><div class=\"row parrafo\"><div class=\"col col-sm-6\"><label>{{\'loads:details:multiple_stops_yn:title\' | translate}}</label><p ng-if=\"loadData.stops_loads.length > 0\">{{\'loads:details:multiple_stops:yes:title\' | translate}}</p><p ng-if=\"loadData.stops_loads.length <= 0\">{{\'loads:details:multiple_stops:no:title\' | translate}}</p></div><div class=\"col col-sm-6\"><label>{{\'loads:details:multiple_stops_addresses:title\' | translate}}</label><p ng-repeat=\"(indexitem, multiplestopitem) in loadData.stops_loads\"><img src=assets/images/common/{{getImageMapPoint((indexitem+1))}}.png width=27 border=0> {{multiplestopitem.address_stop}}</p></div></div><div class=\"row parrafo\"><div class=\"col col-sm-6\"><label>{{\'loads:details:pickup_date:title\' | translate}}</label><p>{{loadData.pickup_date | amDateFormat:\'MMM DD YYYY\'}}</p></div><div class=\"col col-sm-6\"><label>{{\'loads:details:pickup_date_rage:title\' | translate}}</label><p>{{loadData.timer_star_pickup | amDateFormat:\'MMM DD/YY HH:mm:ss\'}} - {{loadData.timer_finish_pickup | amDateFormat:\'MMM DD/YY HH:mm:ss\'}}</p></div></div><div class=\"row parrafo\"><div class=\"col col-sm-6\"><label>{{\'loads:details:delivery_date:title\' | translate}}</label><p>{{loadData.delivery_date | amDateFormat:\'MMM DD YYYY\'}}</p></div><div class=\"col col-sm-6\"><label>{{\'loads:details:delivery_date_rage:title\' | translate}}</label><p>{{loadData.timer_start_delivery | amDateFormat:\'MMM DD/YY HH:mm:ss\'}} - {{loadData.timer_finish_delivery | amDateFormat:\'MMM DD/YY HH:mm:ss\'}}</p></div></div><div class=\"row parrafo\"><div class=\"col col-sm-6\"><label>{{\'loads:details:rate_miles:title\' | translate}}</label><p>{{loadData.rate_miles}}</p></div><div class=\"col col-sm-6\"><label>{{\'loads:details:length:title\' | translate}}</label><p>{{loadData.length_loads}}</p></div></div><div class=\"row parrafo\"><div class=\"col col-sm-6\"><label>{{\'loads:details:weight:title\' | translate}}</label><p>{{loadData.weight}}</p></div><div class=\"col col-sm-6\"><label>{{\'loads:details:size:title\' | translate}}</label><p>{{loadData.dimension}}</p></div></div><div permission permission-only=\"[\'GENERADOR_CARGA\', \'CARRIER\',\'OWNER\']\" class=\"row parrafo\"><div class=\"col col-sm-6\"><label>{{\'loads:details:tipocamion:title\' | translate}}</label><p>{{loadData.truck_type_text}}</p></div><div ng-if=false class=\"col col-sm-6\"><label>{{\'loads:details:license_type:title\' | translate}}</label><p>{{loadData.load_type_license.categoria}}</p></div></div><div permission permission-only=\"[\'GENERADOR_CARGA\', \'CARRIER\',\'OWNER\']\" class=\"row parrafo\"><div class=\"col col-sm-6\"><label>{{\'loads:details:consignee:title\' | translate}}</label><p>{{loadData.consignee}}</p></div><div class=\"col col-sm-6\"><label>{{\'loads:details:receiver:title\' | translate}}</label><p>{{loadData.receiver}}</p></div></div><div class=\"row parrafo\"><div class=\"col col-sm-6\"><label>{{\'loads:details:load_type:title\' | translate}}</label><p>{{loadData.type_load_text}}</p></div><div permission permission-only=\"\'GENERADOR_CARGA\'\" class=\"col col-sm-6\"><label>{{\'loads:details:recurrent:title\' | translate}}</label><p ng-if=\"loadData.recurrent_load_status != \'False\'\">{{\'loads:details:recurrent:options:yes\' | translate}}</p><p ng-if=\"loadData.recurrent_load_status == \'False\'\">{{\'loads:details:recurrent:options:no\' | translate}}</p></div><div permission permission-only=\"[\'CARRIER\',\'OWNER\']\" class=\"col col-sm-6\"><label>{{\'loads:details:fast_pay:title\' | translate}}</label><p ng-if=\"loadData.apply_factoring == false\">{{\'loads:details:fast_pay:options:no\' | translate}}</p><p ng-if=\"loadData.apply_factoring == true\">{{\'loads:details:fast_pay:options:yes\' | translate}}</p></div></div><div permission permission-only=\"\'GENERADOR_CARGA\'\" class=\"row parrafo\"><div ng-if=\"!loadingLoadData && loadData.status_loads ==\'NOT_ASSIGNED\'\" class=\"col col-sm-6\"><a ng-if=\"loadData.request_carriers == 0\" ng-click=openCarrierRequestModal() class=\"small-text normal-link pointer\">{{\'loads:details:carrier_requests:title\' | translate}} ({{loadData.request_carriers}})</a> <a ng-if=\"loadData.request_carriers != 0\" ng-click=openCarrierRequestModal() class=\"small-text normal-link color-pastel-red pointer\">{{\'loads:details:carrier_requests:title\' | translate}} ({{loadData.request_carriers}})</a></div><div ng-if=\"!loadingLoadData && loadData.status_loads !=\'NOT_ASSIGNED\'\" class=\"col col-sm-6\"></div><div class=\"col col-sm-6\"><label>{{\'loads:details:frecuency:title\' | translate}}</label><p ng-if=loadData.recurrent.name>{{loadData.recurrent.name}}</p></div></div><div permission permission-only=\"[\'CARRIER\',\'OWNER\']\" class=\"row parrafo\"><div class=\"col col-sm-6\"></div><div class=\"col col-sm-6\"><label>{{\'loads:details:fast_pay_status:title\' | translate}}</label><p ng-if=\"loadData.status_factoring == 0\">{{\'loads:details:fast_pay_status:options:not_applied\' | translate}}</p><p ng-if=\"loadData.status_factoring == 1\">{{\'loads:details:fast_pay_status:options:applied\' | translate}}</p></div></div><div class=\"row parrafo\"><div class=\"col col-sm-6\"><label>{{\'loads:details:noot_load:title\' | translate}}</label><p>{{loadData.noot_load}}</p></div><div class=\"col col-sm-6\"><label>{{\'loads:details:carrier_skills_required:title\' | translate}}</label><p>{{loadData.carrier_skills_required_text}}</p></div></div><div class=\"row parrafo\"><div class=\"col col-sm-6\"><label>{{\'loads:details:commodity:title\' | translate}}</label><p ng-if=loadData.commodity[0]>{{loadData.commodity[0].type_commodity}}</p></div><div class=\"col col-sm-6\"><label>{{\'loads:details:trailer_type:title\' | translate}}</label><p>{{loadData.trailer_type_desc}}</p></div></div></div><div class=col-6><div class=\"row parrafo\"><div class=col><label>{{\'loads:details:pickup_address_details:title\' | translate }}</label><p>{{loadData.detail_address_pickup}}</p></div></div><div class=\"row parrafo\"><div class=col><label>{{\'loads:details:delivery_address_details:title\' | translate }}</label><p>{{loadData.detail_address_delivery}}</p></div></div><div class=\"row parrafo\"><div class=col><label>{{\'loads:details:pickup_zip_code:title\' | translate }}</label><p>{{loadData.zip_code_pickup}}</p></div></div><div class=\"row parrafo\"><div class=col><label>{{\'loads:details:delivery_zip_code:title\' | translate }}</label><p>{{loadData.zip_code_delivery}}</p></div></div><div permission permission-only=\"[\'CARRIER\', \'GENERADOR_CARGA\', \'OWNER\']\" ng-if=\"(loadData.status_loads == \'PAGADA\' || loadData.status_loads == \'ENTREGADA\') && loadData.info_payment.length\" class=\"row parrafo\"><div class=col><label>{{\'loads:details:payment_day:title\' | translate }}</label><p>{{loadData.info_payment[0].payment_day}}</p></div></div><div permission permission-only=\"[\'CARRIER\', \'GENERADOR_CARGA\', \'OWNER\']\" ng-if=\"(loadData.status_loads == \'PAGADA\' || loadData.status_loads == \'ENTREGADA\') && loadData.info_payment.length\" class=\"row parrafo\"><div class=col><label>{{\'loads:details:payment_date:title\' | translate }}</label><p>{{loadData.info_payment[0].payment_date | amDateFormat:\'MMM DD YYYY\'}}</p></div></div><div permission permission-only=\"[\'CARRIER\', \'GENERADOR_CARGA\', \'OWNER\']\" ng-if=\"(loadData.status_loads == \'PAGADA\' || loadData.status_loads == \'ENTREGADA\') && loadData.info_payment.length\" class=\"row parrafo\"><div class=col><label>{{\'loads:details:payment_amount:title\' | translate }}</label><p>{{loadData.info_payment[0].ammount}}</p></div></div><div permission permission-only=\"[\'CARRIER\', \'GENERADOR_CARGA\', \'OWNER\']\" ng-if=\"(loadData.status_loads == \'PAGADA\' || loadData.status_loads == \'ENTREGADA\') && loadData.info_payment.length\" class=\"row parrafo\"><div class=col><label>{{\'loads:details:payment_transfered:title\' | translate }}</label><p>{{loadData.info_payment[0].transfered}}</p></div></div><div permission permission-only=\"[\'CARRIER\', \'GENERADOR_CARGA\', \'OWNER\']\" ng-if=\"(loadData.status_loads == \'PAGADA\' || loadData.status_loads == \'ENTREGADA\') && loadData.info_payment.length\" class=\"row parrafo\"><div class=col><label>{{\'loads:details:payment_percentage:title\' | translate }}</label><p>{{loadData.info_payment[0].payment_percentage}}</p></div></div><div permission permission-only=\"[\'CARRIER\', \'OWNER\']\" ng-if=\"loadData.status_loads == \'ENTREGADA\' && loadData.payment_information_carrier.id\" class=\"row parrafo\"><div class=col><label>{{\'loads:details:payment_day:title\' | translate }}</label><p>{{loadData.payment_information_carrier.payment_day}}</p></div></div><div permission permission-only=\"[\'CARRIER\', \'OWNER\']\" ng-if=\"loadData.status_loads == \'ENTREGADA\' && loadData.payment_information_carrier.id\" class=\"row parrafo\"><div class=col><label>{{\'loads:details:payment_date:title\' | translate }}</label><p>{{loadData.payment_information_carrier.payment_date | amDateFormat:\'MMM DD YYYY\'}}</p></div></div><div permission permission-only=\"[\'CARRIER\', \'OWNER\']\" ng-if=\"loadData.status_loads == \'ENTREGADA\' && loadData.payment_information_carrier.id\" class=\"row parrafo\"><div class=col><label>{{\'loads:details:payment_amount:title\' | translate }}</label><p>{{loadData.payment_information_carrier.ammount}}</p></div></div><div permission permission-only=\"[\'CARRIER\', \'OWNER\']\" ng-if=\"loadData.status_loads == \'ENTREGADA\' && loadData.payment_information_carrier.id\" class=\"row parrafo\"><div class=col><label>{{\'loads:details:payment_transfered:title\' | translate }}</label><p>{{loadData.payment_information_carrier.transfered}}</p></div></div><div permission permission-only=\"[\'CARRIER\', \'OWNER\']\" ng-if=\"loadData.status_loads == \'ENTREGADA\' && loadData.payment_information_carrier.id\" class=\"row parrafo\"><div class=col><label>{{\'loads:details:payment_percentage:title\' | translate }}</label><p>{{loadData.payment_information_carrier.payment_percentage}}</p></div></div><div ng-if=loadData.info_load_generator.phone_company class=\"row parrafo\"><div class=col><label>{{\'loads:details:contactinfo:title\' | translate }}</label><!-- <p><a ng-href=\"tel:{{loadData.info_load_generator.phone_company}}\" class=\"small-text normal-link\">{{loadData.info_load_generator.phone_company}}</a></p> --><p><a ng-href=tel:{{loadData.info_load_generator.phone_company}} class=\"small-text normal-link\">5571001586</a></p></div></div><div class=\"row parrafo\"><div class=col><label>{{\'loads:details:comments:title\' | translate }}</label><p>{{loadData.comments}}</p></div></div><div permission permission-only=\"\'GENERADOR_CARGA\'\" ng-if=\"!loadingLoadData && loadData.status_loads !=\'NOT_ASSIGNED\' && loadData.carrier\" class=\"row parrafo\"><div class=col><label>{{\'loads:details:carrier_assigned:title\' | translate}}</label><br><a ng-click=openCarrierAssignedInfoModal() class=\"small-text normal-link pointer\">{{loadData.carrier.company_name}} <img src=assets/images/common/see-more.png width=20 border=0></a></div></div><div permission permission-only=\"[\'CARRIER\', \'GENERADOR_CARGA\', \'DRIVER\', \'OWNER\']\" ng-if=\"!loadingLoadData && (loadData.status_loads ==\'ACEPTADA\' || loadData.status_loads ==\'EN_TRANSITO\' || loadData.status_loads ==\'ENTREGADA\') && loadData.history_load\" class=\"row parrafo\"><div class=col><label>{{\'loads:details:see_activity:title\' | translate}}</label><br><a ng-click=openLoadActivityInfoModal() class=\"small-text normal-link pointer\">{{\'loads:details:see_activity:link:title\' | translate}}</a></div></div><div permission permission-only=\"[\'CARRIER\', \'OWNER\']\" ng-if=\"!loadingLoadData && loadData.status_loads !=\'NOT_ASSIGNED\' && loadData.info_truck != 0\" class=\"row parrafo\"><div class=col><label>{{\'loads:details:truck_assigned:title\' | translate}}</label><br><div class=row><a ng-click=openTruckAssignedInfoModal() class=\"small-text normal-link pointer\">{{\'trucks:details:company_id_unity:title\' | translate}}: {{loadData.info_truck.company_id_unity}} - {{loadData.info_truck.brand}} {{loadData.info_truck.model}} <img src=assets/images/common/see-more.png width=20 border=0></a></div><div class=row><a ng-click=selectTruckAndDriver() class=\"small-text normal-link pointer\">{{\'loads:details:truck_assigned:change_truck:text\' | translate}} </a><!--  <a ng-click=\"openChooseTruckModal()\" class=\"small-text normal-link pointer\">\n                {{\'loads:details:truck_assigned:change_truck:text\' | translate}}\n              </a>--></div></div></div><div permission permission-only=\"[\'CARRIER\', \'OWNER\']\" ng-if=\"!loadingLoadData && loadData.status_loads !=\'NOT_ASSIGNED\' && loadData.info_truck != 0 && loadData.info_truck.driver\" class=\"row parrafo\"><div class=col><label>{{\'loads:details:driver:phone_contact\' | translate}}</label><br><p><a ng-href=tel:{{loadData.info_truck.driver.user.user_phone}} class=\"small-text normal-link\">{{loadData.info_truck.driver.user.user_phone}}</a></p></div></div><div permission permission-only=\"[\'CARRIER\', \'OWNER\']\" ng-if=\"!loadingLoadData && loadData.status_loads !=\'NOT_ASSIGNED\' && loadData.status_loads !=\'CANCELADA\' && loadData.info_truck == 0\" class=\"row parrafo\"><div class=col><label>{{\'loads:details:truck_assigned:title\' | translate}}</label><br><a ng-click=selectTruckAndDriver() class=\"small-text normal-link pointer\">{{\'loads:details:truck_assigned:change_truck:text\' | translate}} </a><!--<a ng-click=\"openChooseTruckModal()\" class=\"small-text normal-link pointer\">\n                {{\'loads:details:truck_assigned:choose_truck:text\' | translate}}\n              </a>--></div></div><div ng-if=\"(loadData.carrier.user_id && loadData.carrier.user_id == userDataProfile.user_id)\n								|| (loadData.info_load_generator.user_id && loadData.info_load_generator.user_id == userDataProfile.user_id)\n								|| (loadData.info_truck.truck_driver && loadData.info_truck.truck_driver == userDataProfile.user_id)\" class=\"row parrafo\"><div class=col><label>{{ \'loads:details:documents:title\' | translate }}</label><p>{{ \'loads:details:invoice:title\' | translate }}</p><p ng-if=\"!loadInvoiceImgFilesList.length && !loadInvoiceDocsFilesList.length\">{{ \'loads:details:documents:empty\' | translate }}</p><p ng-if=loadInvoiceImgFilesList.length>{{ \'loads:details:documents:images\' | translate }}</p><div ng-if=loadInvoiceImgFilesList.length ng-image-gallery images=loadInvoiceaImgFilesList></div><p ng-if=loadInvoiceDocsFilesList.length>{{ \'loads:details:documents:docs\' | translate }}</p><ul ng-if=loadInvoiceDocsFilesList.length class=\"nav documents-list\"><li class=\"nav-item parrafo\" ng-repeat=\"fileInvoice in loadInvoiceDocsFilesList\"><md-tooltip md-direction=top>{{fileInvoice.invoice_name}}</md-tooltip><a href={{fileInvoice.url}} target=_blank><span alt={{fileInvoice.title}} class=\"fa fa-file-pdf-o\"></span><br><span>{{fileInvoice.invoice_name | limitTo : 15}}</span></a></li></ul><br><p>{{ \'loads:details:legal_docs:title\' | translate }}</p><p ng-if=\"!loadLegalImgFilesList.length && !loadLegalDocsFilesList.length\">{{ \'loads:details:documents:empty\' | translate }}</p><p ng-if=loadLegalImgFilesList.length>{{ \'loads:details:documents:images\' | translate }}</p><div ng-if=loadLegalImgFilesList.length ng-image-gallery images=loadLegalImgFilesList></div><p ng-if=loadLegalDocsFilesList.length>{{ \'loads:details:documents:docs\' | translate }}</p><ul ng-if=loadLegalDocsFilesList.length class=\"nav documents-list\"><li class=\"nav-item parrafo\" ng-repeat=\"fileLegal in loadLegalDocsFilesList\"><md-tooltip md-direction=top>{{fileLegal.invoice_name}}</md-tooltip><a href={{fileLegal.url}} target=_blank><span alt={{fileLegal.title}} class=\"fa fa-file-pdf-o\"></span><br><span>{{fileLegal.invoice_name | limitTo : 15}}</span></a></li></ul><br><br><div ng-hide=\"search_type == \'for_me\'\"><button permission permission-only=\"[\'GENERADOR_CARGA\', \'DRIVER\']\" ng-if=\"loadData.status_loads !=\'PAGADA\'\" ng-disabled=loadData.legalDocFileSaving ngf-select=\"uploadLegalDoc($file, $invalidFiles)\" ngf-accept=\"\'image/jpg, image/jpeg, application/pdf\'\" class=\"btn btn-class2 bg-color-9 color-black\"><main-loader ng-if=loadData.legalDocFileSaving></main-loader><span ng-show=!loadData.legalDocFileSaving>{{ \'loads::add:form:upload_doc:btn\' | translate }}</span></button> <button permission permission-only=\"[\'CARRIER\', \'OWNER\']\" ng-if=\"loadData.carrier.user_id && loadData.carrier.user_id == userDataProfile.user_id\" ng-disabled=loadData.legalDocFileSaving ngf-select=\"uploadLegalDoc($file, $invalidFiles)\" ngf-accept=\"\'image/jpg, image/jpeg, application/pdf\'\" class=\"btn btn-class2 bg-color-9 color-black\"><main-loader ng-if=loadData.legalDocFileSaving></main-loader><span ng-show=!loadData.legalDocFileSaving>{{ \'loads::add:form:upload_doc:btn\' | translate }}</span></button></div></div></div><div ng-if=\"!loadingLoadData && loadData.status_loads ==\'CANCELADA\'\" class=\"row parrafo\"><div class=col><label>{{\'loads:details:reason_cancel:title\' | translate}}</label><p>{{loadData.reason_cancel_load}}</p></div></div><div ng-if=\"!loadingLoadData && loadData.status_loads ==\'CANCELADA\'\" class=\"row parrafo\"><div class=col><label>{{\'loads:details:reason_cancel:descrip\' | translate}}</label><p>{{loadData.reason_cancel_descrip}}</p></div></div></div></div></div></div><div class=clearfix></div><div class=row><div class=\"col col-sm-12\" ng-hide=\"dataUser.user_status == \'0\'\"><button ng-if=\"!loadingLoadData && loadData.status_loads ==\'NOT_ASSIGNED\' && loadData.owner_request_carriers == 0 && posteverywhere != \'1\'\" type=button permission ng-show=\"search_type == \'for_me\'\" permission-only=\"[\'CARRIER\', \'OWNER\']\" ng-click=selectTruckAndDriver() class=\"btn btn-class1 bg-color-9 color-black parrafo\">{{ \'loads:details:accept:btn\' | translate }}</button> <button ng-if=\"!loadingLoadData && loadData.status_loads ==\'NOT_ASSIGNED\' && loadData.owner_request_carriers == 0 && posteverywhere != \'1\'\" type=button permission ng-hide=\"search_type == \'for_me\'\" permission-only=\"[\'CARRIER\', \'OWNER\']\" ng-click=createRequestCarrierLoad() class=\"btn btn-class1 bg-color-9 color-black parrafo\">{{ \'loads:details:apply:btn\' | translate }}</button> <button ng-if=\"!loadingLoadData && loadData.status_loads !=\'NOT_ASSIGNED\' && loadData.status_loads !=\'ENTREGADA\' && loadData.owner_request_carriers == 0 && posteverywhere != \'1\'\" permission permission-only=\"[\'CARRIER\',\'OWNER\']\" type=button ng-click=rejectTmsRequest() class=\"btn btn-class1 bg-color-4 color-black parrafo\">{{ \'loads:details:notapply:btn\'| translate }}</button> <button ng-if=\"!loadingLoadData && loadData.status_loads !=\'NOT_ASSIGNED\' && loadData.owner_request_carriers == \'1\' && posteverywhere != \'1\'\" permission permission-only=\"[\'CARRIER\', \'OWNER\']\" ng-click=cancelRequestCarrierLoad() class=\"btn btn-class1 bg-color-4 color-white parrafo\">{{ \'loads:details:notapply:btn\' | translate }}</button> <a ng-if=\"!loadingLoadData && loadData.load_id\" permission permission-only=\"[\'CARRIER\', \'OWNER\']\" ng-click=openReportIssuesLoadModal() class=\"small-text normal-link\">{{ \'loads:details:report_suspect:text\' | translate }} </a><a ng-if=\"!loadingLoadData && loadData.status_loads !=\'CANCELADA\' && loadData.status_loads !=\'NOT_ASSIGNED\'\" permission permission-only=\"[\'GENERADOR_CARGA\']\" ng-click=openReportIssuesLoadModal() class=\"small-text normal-link\">{{ \'loads:details:report_suspect:text\' | translate }}</a></div></div></div>");
$templateCache.put("app/loads/templates/directives/load-edit-basic.html","<h3 class=\"large-title subtitle-section\">{{ \'loads:add:form:section:basic_information:title\' | translate }}</h3><div class=form-group><div class=row><div class=\"col-6 col-sm-6\"><label>{{ \'loads:add:form:pickup_address:text\' | translate }}</label><div class=row><div class=col-sm-8><select class=form-control ng-model=loadsedit.dataUpdateLoad.pickup_address_id ng-disabled=\"loadsedit.cmbAddresses.length < 1\" ng-change=loadsedit.setterInformation() ng-options=\"value.id as value.text for (key, value) in loadsedit.cmbAddresses\"><option value=\"\">{{ \'loads:add:form:select:any\' | translate }}</option></select></div><div class=col-sm-4><input type=checkbox class=custom-checkbox id=save_pickup_address name=save_pickup_address ng-model=loadsedit.dataUpdateLoad.save_pickup_address ng-true-value=1 ng-false-value=0><label for=save_pickup_address><span></span>{{ \'loads:add:form:save_pickup:text\' | translate }}</label></div></div></div><div class=\"col-6 col-sm-6\"><label>{{ \'loads:add:form:delivery_address:text\' | translate }}</label><div class=row><div class=col-sm-8><select class=form-control ng-model=loadsedit.dataUpdateLoad.delivery_address_id ng-disabled=\"loadsedit.cmbAddresses.length < 1\" ng-change=loadsedit.setterInformation() ng-options=\"value.id as value.text for (key, value) in loadsedit.cmbAddresses\"><option value=\"\">{{ \'loads:add:form:select:any\' | translate }}</option></select></div><div class=col-sm-4><input type=checkbox class=custom-checkbox id=save_delivery_address name=save_delivery_address ng-model=loadsedit.dataUpdateLoad.save_delivery_address ng-true-value=1 ng-false-value=0><label for=save_delivery_address><span></span>{{ \'loads:add:form:save_delivery:text\' | translate }}</label></div></div></div></div></div><div class=form-group><div class=row><div class=col-6><label>{{ \'loads:add:form:origin:text\' | translate }}</label><span class=help-inline ng-show=postLoadFormName.origin.$error.required>*</span> <input type=text class=form-control g-places-autocomplete options=loadsedit.optionsGoogleInputCity force-selection=true ng-model=loadsedit.dataSelectPickupCity placeholder=\'{{ \"loads:add:form:origin:text\" | translate }}\' autocomplete=off required></div><div class=col-6><label>{{ \'loads:add:form:destination:text\' | translate }}</label><span class=help-inline ng-show=postLoadFormName.destination.$error.required>*</span> <input type=text name=destination class=form-control g-places-autocomplete options=loadsedit.optionsGoogleInputCity force-selection=true ng-model=loadsedit.dataSelectDeliveryCity placeholder=\'{{ \"loads:add:form:destination:text\" | translate }}\' autocomplete=off required></div></div></div><div class=form-group><div class=row><div class=\"col-12 col-md-6\"><label>{{ \'loads:add:form:pickup_address:text\' | translate }}</label><span class=help-inline ng-show=postLoadFormName.pickup_address.$error.required>*</span> <input type=text name=pickup_address class=form-control g-places-autocomplete force-selection=true ng-model=loadsedit.dataSelectPickupAddress ng-blur=loadsedit.checkOriginZip() placeholder=\'{{ \"loads:add:form:pickup_address:text\" | translate }}\' autocomplete=off required></div><div class=\"col-6 col-md-3 mt-3 pt-2\"><input type=checkbox class=custom-checkbox id=multiple_stops_yn name=multiple_stops_yn ng-change=loadsedit.resetMultipleStops() ng-model=loadsedit.dataUpdateLoad.allow_multiple_stops ng-true-value=1 ng-false-value=0><label for=multiple_stops_yn><span></span>{{ \'loads:add:form:allow_multiple_stops:text\' | translate }}</label></div><div ng-if=\"loadsedit.dataUpdateLoad.allow_multiple_stops == 1\" class=\"col-6 col-md-3 mt-3 pt-2\"><button type=button ng-click=loadsedit.addMultipleStop() class=\"btn btn-class2 bg-color-9 color-black\">{{ \'loads:add:form:add_multiple_stop:text\' | translate }}</button></div></div></div><div ng-if=\"loadsedit.dataUpdateLoad.allow_multiple_stops == 1\" class=form-group><div class=row><div class=col-12 style=\"margin-top: 5px\"><label>{{ \'loads:add:form:multiple_stops_explanation:text\' | translate }}</label></div></div><div class=row><div class=\"col-12 col-md-6 mr-2\" ng-repeat=\"multiplestopfield in loadsedit.camposParadasMultiples\" style=\"margin-top: 5px\"><label>{{ \'loads:add:form:multiple_stop_pretitle:text\' | translate }} {{(multiplestopfield.id + 1)}}</label><br><input type=text name=stop_{{multiplestopfield.id}} class=\"form-control inline-block\" g-places-autocomplete force-selection=true ng-model=multiplestopfield.address placeholder=\"\" autocomplete=off style=\"max-width: calc(100% - 33px)\"><div ng-if=\"multiplestopfield.id > 0\" class=inline-block style=\"margin-left: 3px\"><button type=button ng-click=loadsedit.deleteMultipleStop(multiplestopfield.id) class=\"btn btn-class2 bg-color-4 color-white\">{{ \'loads:add:form:delete_multiple_stop:text\' | translate }}</button></div></div></div></div><div class=form-group><div class=row><div class=\"col-12 col-md-6\"><label>{{ \'loads:add:form:delivery_address:text\' | translate }}</label><span class=help-inline ng-show=postLoadFormName.delivery_address.$error.required>*</span> <input type=text name=delivery_address class=form-control g-places-autocomplete force-selection=true ng-model=loadsedit.dataSelectDeliveryAddress ng-blur=loadsedit.checkDestinationZip() placeholder=\'{{ \"loads:add:form:delivery_address:text\" | translate }}\' autocomplete=off required></div></div></div><div class=form-group><div class=row><div class=col-6><label>{{ \'loads:add:form:details_pickup_address:text\' | translate }}</label><input type=text name=detail_address_pickup class=form-control ng-model=loadsedit.dataUpdateLoad.detail_address_pickup placeholder=\'{{ \"loads:add:form:details_pickup_address:text\" | translate }}\'></div><div class=col-6><label>{{ \'loads:add:form:details_delivery_address:text\' | translate }}</label><input type=text name=detail_address_delivery class=form-control ng-model=loadsedit.dataUpdateLoad.detail_address_delivery placeholder=\'{{ \"loads:add:form:details_delivery_address:text\" | translate }}\'></div></div></div><div class=form-group><div class=row><div class=\"col-6 col-sm-4\"><label>{{ \'loads:add:form:pickup_date:text\' | translate }}</label><span class=help-inline ng-show=postLoadFormName.pickup_date.$error.required>*</span> <input ng-blur=loadsedit.allowDeliveryDate() date-range-picker type=text name=pickup_date class=\"form-control date-picker\" ng-model=loadsedit.dataUpdateLoad.pickup_date placeholder=\'{{ \"loads:add:form:pickup_date:text\" | translate }}\' options=loadsedit.optsDatePicker min=loadsedit.datePickerMinDate required></div><div class=\"col-6 col-sm-4\"><label>{{ \'loads:add:form:timer_star_pickup:text\' | translate }}</label><span class=help-inline ng-show=\"postLoadFormName.pickup_start_time_hour.$error.required || postLoadFormName.pickup_start_time_minutes.$error.required\">*</span><select style=\"width: 40%; display: inline-block; text-indent: 30%\" name=pickup_start_time_hour id=pickup_start_time_hour ng-model=loadsedit.pickup_start_time_hour class=\"form-control input-md\" required><option ng-repeat=\"hour in loadsedit.hour_select\" value={{hour}}>{{hour}}</option></select>&nbsp;:&nbsp;<select style=\"width: 40%; display: inline-block; text-indent: 30%\" name=pickup_start_time_minutes id=pickup_start_time_minutes ng-model=loadsedit.pickup_start_time_minutes class=\"form-control input-md\" required><option ng-repeat=\"minute in loadsedit.minutes_select\" value={{minute}}>{{minute}}</option></select></div><div class=\"col-6 col-sm-4\"><label>{{ \'loads:add:form:timer_finish_pickup:text\' | translate }}</label><span class=help-inline ng-show=\"postLoadFormName.pickup_finish_time_hour.$error.required || postLoadFormName.pickup_finish_time_minutes.$error.required\">*</span><select style=\"width: 40%; display: inline-block; text-indent: 30%\" name=pickup_finish_time_hour id=pickup_finish_time_hour ng-model=loadsedit.pickup_finish_time_hour class=\"form-control input-md\" required><option ng-repeat=\"hour in loadsedit.hour_select\" value={{hour}}>{{hour}}</option></select>&nbsp;:&nbsp;<select style=\"width: 40%; display: inline-block; text-indent: 30%\" name=pickup_finish_time_minutes id=pickup_finish_time_minutes ng-model=loadsedit.pickup_finish_time_minutes class=\"form-control input-md\" required><option ng-repeat=\"minute in loadsedit.minutes_select\" value={{minute}}>{{minute}}</option></select></div></div></div><div class=form-group><div class=row><div class=\"col-6 col-sm-4\"><label>{{ \'loads:add:form:delivery_date:text\' | translate }}</label><span class=help-inline ng-show=postLoadFormName.delivery_date.$error.required>*</span> <input ng-disabled=loadsedit.dateDeliveryDisabled ng-blur=loadsedit.afterDeliveryDate() date-range-picker type=text name=delivery_date class=\"form-control date-picker\" ng-model=loadsedit.dataUpdateLoad.delivery_date placeholder=\'{{ \"loads:add:form:delivery_date:text\" | translate }}\' options=loadsedit.optsDatePicker min=loadsedit.dataUpdateLoad.pickup_date required></div><div class=\"col-6 col-sm-4\"><label>{{ \'loads:add:form:timer_start_delivery:text\' | translate }}</label><span class=help-inline ng-show=\"postLoadFormName.delivery_start_time_hour.$error.required || postLoadFormName.delivery_start_time_minutes.$error.required\">*</span><select style=\"width: 40%; display: inline-block; text-indent: 30%\" name=delivery_start_time_hour id=delivery_start_time_hour ng-model=loadsedit.delivery_start_time_hour class=\"form-control input-md\" required><option ng-repeat=\"hour in loadsedit.hour_select\" value={{hour}}>{{hour}}</option></select>&nbsp;:&nbsp;<select style=\"width: 40%; display: inline-block; text-indent: 30%\" name=delivery_start_time_minutes id=delivery_start_time_minutes ng-model=loadsedit.delivery_start_time_minutes class=\"form-control input-md\" required><option ng-repeat=\"minute in loadsedit.minutes_select\" value={{minute}}>{{minute}}</option></select></div><div class=\"col-6 col-sm-4\"><label>{{ \'loads:add:form:timer_finish_delivery:text\' | translate }}</label><span class=help-inline ng-show=\"lpostLoadFormName.delivery_finish_time_hour.$error.required || postLoadFormName.delivery_finish_time_minutes.$error.required\">*</span><select style=\"width: 40%; display: inline-block; text-indent: 30%\" name=delivery_finish_time_hour id=delivery_finish_time_hour ng-model=loadsedit.delivery_finish_time_hour class=\"form-control input-md\" required><option ng-repeat=\"hour in loadsedit.hour_select\" value={{hour}}>{{hour}}</option></select>&nbsp;:&nbsp;<select style=\"width: 40%; display: inline-block; text-indent: 30%\" name=delivery_finish_time_minutes id=delivery_finish_time_minutes ng-model=loadsedit.delivery_finish_time_minutes class=\"form-control input-md\" required><option ng-repeat=\"minute in loadsedit.minutes_select\" value={{minute}}>{{minute}}</option></select></div></div></div><div class=form-group><div class=row><div class=\"col-6 col-sm-3\"><label>{{ \'loads:add:form:pickup_zip:text\' | translate }}</label><span class=help-inline ng-show=postLoadFormName.pickup_zip.$error.required>*</span> <input type=text name=pickup_zip class=form-control ng-model=loadsedit.dataUpdateLoad.zip_code_pickup placeholder=\'{{ \"loads:add:form:pickup_zip:text\" | translate }}\' required></div><div class=\"col-6 col-sm-3\"><label>{{ \'loads:add:form:delivery_zip:text\' | translate }}</label><span class=help-inline ng-show=postLoadFormName.delivery_zip.$error.required>*</span> <input type=text name=delivery_zip class=form-control ng-model=loadsedit.dataUpdateLoad.zip_code_delivery placeholder=\'{{ \"loads:add:form:delivery_zip:text\" | translate }}\' required></div></div></div>");
$templateCache.put("app/loads/templates/directives/load-edit-technical.html","<h3 class=\"large-title subtitle-section\">{{ \'loads:add:form:section:technical_information:title\' | translate }}</h3><div class=form-group><div class=row><div class=\"col-6 col-sm-6\"><label>{{ \'loads:add:form:size:text\' | translate }} <span class=help-inline ng-show=postLoadFormName.dimension.$error.required>*</span></label><select class=\"form-control input-md\" id=dimension name=dimension ng-model=loadsedit.dataUpdateLoad.dimension ng-change=loadsedit.sizeConfigurationChange() required><option value=\"\">{{ \'loads:add:form:select:any\' | translate }}</option><option ng-repeat=\"option in loadsedit.itemsSizeLenLoads.LoadsSize_list\" value={{option.id}}>{{option.name}}</option></select></div><div class=\"col-6 col-sm-6\"><label>{{ \'loads:add:form:container_type:text\' | translate }}</label><select class=\"form-control input-md\" name=container id=container ng-model=loadsedit.dataUpdateLoad.container_type_code><option value=\"\">{{ \'loads:add:form:select:any\' | translate }}</option><option ng-repeat=\"option in loadsedit.cmbContainerTypes\" value={{option.value}}>{{option.text}}</option></select></div></div></div><div class=form-group><div class=row><div class=\"col-6 col-sm-6\"><label>{{ \'loads:add:form:truck_type:text\' | translate }} <span class=help-inline ng-show=postLoadFormName.truck_type_id.$error.required>*</span></label><select class=\"form-control input-md\" name=truck_type_id ng-model=loadsedit.truckTypeRequired ng-change=loadsedit.truckTypeChange()><option value=\"\">{{ \'loads:add:form:select:any\' | translate }}</option><option ng-repeat=\"option in loadsedit.simpleTruckTypes\" value={{option.id}}>{{option.name}}</option></select></div><div class=\"col-6 col-sm-6\"><label>{{ \'loads:add:form:weight_unit:text\' | translate }} <span class=help-inline ng-show=postLoadFormName.length.$error.required>*</span></label><div class=row><div class=col-sm-12><select class=form-control ng-model=loadsedit.dataUpdateLoad.weight_unit ng-options=\"value.value as value.text for (key, value) in loadsedit.cmbWeightUnits\"></select></div></div></div></div></div><div class=form-group><div class=row><div class=\"col-6 col-sm-6\"><label>{{ \'loads:add:form:weight:text\' | translate }} {{\'loads:add:form:weight:only_number:text\' | translate}} {{loadsedit.dataUpdateLoad.weight_unit}} <span class=help-inline ng-show=\"postLoadFormName.weight.$error.required || (postLoadFormName.weight.$viewValue <= 0)\">*</span></label><div class=row><div class=col-sm-12><input class=form-control type=number name=weight ng-blur=loadsedit.cleanLoadWeightValue() ng-model=loadsedit.dataUpdateLoad.weight placeholder=\'{{ \"loads:add:form:weight:text\" | translate }}\' required></div></div></div><div class=\"col-6 col-sm-6\"><label>{{ \'loads:add:form:distance_unit:text\' | translate }} <span class=help-inline ng-show=postLoadFormName.length.$error.required>*</span></label><div class=row><div class=col-sm-12><select class=form-control ng-model=loadsedit.dataUpdateLoad.distance_unit ng-options=\"value.value as value.text for (key, value) in loadsedit.cmbDistanceUnits\"></select></div></div></div></div></div><div class=form-group><div class=row><div class=\"col-6 col-sm-6\"><label>{{ \'loads:add:form:length:text\' | translate }} {{\'loads:add:form:weight:only_number:text\' | translate}} {{loadsedit.dataUpdateLoad.distance_unit}} <span class=help-inline ng-show=postLoadFormName.length.$error.required>*</span></label><div class=row><div class=col-sm-12><input class=form-control type=number name=length_loads ng-blur=loadsedit.cleanLoadLengthValue() ng-model=loadsedit.dataUpdateLoad.length_loads placeholder=\'{{ \"loads:add:form:length:text\" | translate }}\'></div></div></div><div class=\"col-6 col-sm-6\"><label>{{ \'loads:add:form:height:text\' | translate }} {{\'loads:add:form:weight:only_number:text\' | translate}} {{loadsedit.dataUpdateLoad.distance_unit}} <span class=help-inline ng-show=\"postLoadFormName.height.$error.required || (postLoadFormName.height.$viewValue <= 0)\">*</span></label><div class=row><div class=col-sm-12><input class=form-control type=text name=height ng-blur=loadsedit.cleanLoadHeightValue() ng-model=loadsedit.dataUpdateLoad.height placeholder=\'{{ \"loads:add:form:height:text\" | translate }}\' required></div></div></div></div></div><div class=form-group><div class=row><div class=\"col-6 col-sm-6\"><label>{{ \'loads:add:form:width:text\' | translate }} {{\'loads:add:form:weight:only_number:text\' | translate}} {{loadsedit.dataUpdateLoad.distance_unit}} <span class=help-inline ng-show=\"postLoadFormName.width.$error.required || (postLoadFormName.width.$viewValue <= 0)\">*</span></label><div class=row><div class=col-sm-12><input class=form-control type=text name=width ng-blur=loadsedit.cleanLoadWidthValue() ng-model=loadsedit.dataUpdateLoad.width placeholder=\'{{ \"loads:add:form:width:text\" | translate }}\' required></div></div></div><div class=\"col-6 col-sm-6\"><label>{{ \'loads:add:form:trailer_type_required:text\' | translate }}</label><span class=help-inline ng-show=postLoadFormName.trailer_type.$error.required>*</span><select name=trailer_type id=trailer_type ng-model=loadsedit.dataUpdateLoad.trailer_type class=\"form-control input-md\" required><option value=\"\">{{ \'loads:add:form:select:any\' | translate }}</option><option ng-repeat=\"option in loadsedit.itemsSizeLenLoads.TrailerType\" value={{option.id}}>{{option.trailer_type_name}}</option></select></div></div></div><div class=form-group><div class=row><div class=col><label>{{ \'loads:add:form:load_type:text\' | translate }}</label><span class=help-inline ng-show=postLoadFormName.loadtype.$error.required>*</span><select name=loadtype id=loadtype ng-model=loadsedit.load_type_combo_box class=\"form-control input-md\" required><option value=\"\">{{ \'loads:add:form:select:any\' | translate }}</option><option ng-repeat=\"option in loadsedit.loadTypeList\" value={{option.id}}>{{option.name}}</option></select></div><div class=col><label>{{ \'loads:add:form:noot_load:text\' | translate }}</label><span class=help-inline ng-show=postLoadFormName.noot_load.$error.required>*</span> <input type=text name=noot_load class=form-control ng-model=loadsedit.dataUpdateLoad.noot_load placeholder=\'{{ \"loads:add:form:noot_load:text\" | translate }}\' required></div></div></div><div class=form-group><div class=row><div class=\"col-6 col-sm-6\"><label>{{ \'loads:add:form:consignee:text\' | translate }}</label><span class=help-inline ng-show=postLoadFormName.consignee.$error.required>*</span> <input type=text name=consignee class=form-control ng-model=loadsedit.dataUpdateLoad.consignee placeholder=\'{{ \"loads:add:form:consignee:text\" | translate }}\' required></div><div class=\"col-6 col-sm-6\"><label>{{ \'loads:add:form:receiver:text\' | translate }}</label><span class=help-inline ng-show=postLoadFormName.receiver.$error.required>*</span> <input type=text name=receiver class=form-control ng-model=loadsedit.dataUpdateLoad.receiver placeholder=\'{{ \"loads:add:form:receiver:text\" | translate }}\' required></div></div></div><div class=form-group><div class=row><div class=\"col-6 col-sm-3\"><label>{{ \'loads:add:form:price:text\' | translate }}</label><span class=help-inline ng-show=postLoadFormName.price.$error.required>*</span> <input type=text name=price class=form-control ng-model=loadsedit.dataUpdateLoad.price placeholder=\'{{ \"loads:add:form:price:text\" | translate }}\' required></div></div></div><div class=form-group><div class=row><div class=col><label>{{ \'loads:add:form:carrier_skills_required:text\' | translate }}</label><span class=help-inline ng-show=loadsedit.carrierSkillsRequired>*</span><ul class=list-checks><li ng-repeat=\"carrierskill in loadsedit.skillsRequiredCarrier\"><input type=checkbox id={{carrierskill.name}} name={{carrierskill.name}} ng-model=carrierskill.checked class=custom-checkbox><label for={{carrierskill.name}}><span></span>{{carrierskill.name}}</label></li></ul></div></div></div><div ng-if=false class=form-group><div class=row><div class=\"col-6 col-sm-6\"><label>{{ \'loads:add:form:load_type_license_id:text\' | translate }}</label><span class=help-inline ng-show=postLoadFormName.load_type_license_id.$error.required>*</span><select name=load_type_license_id id=load_type_license_id ng-model=loadsedit.dataUpdateLoad.load_type_license_id ng-change=loadsedit.driverLicenseChange() class=\"form-control input-md\" required><option value=\"\">{{ \'loads:add:form:select:any\' | translate }}</option><option ng-repeat=\"option in loadsedit.itemsSizeLenLoads.loadTypeLicense\" value={{option.id}}>{{option.categoria}}</option></select></div><div class=\"col-6 col-sm-6\"><div ng-show=\"loadsedit.loadLicenseTypeInfo != \'\'\" class=\"alert alert-info\" role=alert><b>{{loadsedit.loadLicenseTypeTitle}}</b><br><span style=font-size:12px>{{loadsedit.loadLicenseTypeInfo}}</span></div></div></div></div><div class=form-group><div class=row><div class=\"col-6 col-sm-6\"><label>{{ \'loads:add:form:commodity:text\' | translate }}</label><span class=help-inline ng-show=postLoadFormName.commodity.$error.required>*</span><select name=commodity id=commodity ng-model=loadsedit.dataUpdateLoad.commodity_id ng-change=loadsedit.commodityChange() class=\"form-control input-md\" required><option value=\"\">{{ \'loads:add:form:select:any\' | translate }}</option><option ng-repeat=\"option in loadsedit.itemsSizeLenLoads.ListCommodity\" value={{option.id}}>{{option.type_commodity}}</option></select></div><div class=\"col-6 col-sm-6\"><div ng-show=\"loadsedit.commodityExcludedInfo != \'\'\" class=\"alert alert-info\" role=alert><b>{{ \'loads:add:form:commodity_excluded:text\' | translate }}</b><br><span style=\"font-size:12px; word-break: break-all\">{{loadsedit.commodityExcludedInfo}}</span></div></div></div></div><!--<div class=\"form-group\">\n  <div class=\"row\">\n    <div class=\"col-6 col-sm-6\">\n      <label>{{ \'loads:add:form:profit:text\' | translate }}\n        <span class=\"help-inline\" ng-show=\"postLoadFormName.profit.$error.required\">*</span>\n      </label>\n      <select class=\"form-control input-md\"\n              id=\"profit\"\n              name=\"profit\"\n              ng-model=\"loadsedit.dataUpdateLoad.profit_center_code\">\n        <option value=\"\">{{ \'loads:add:form:select:any\' | translate }}</option>\n        <option ng-repeat=\"option in loadsedit.cmbProfitCenters\" value=\"{{option.value}}\">\n          {{option.text}}\n        </option>\n      </select>\n    </div>\n  </div>\n</div>-->");
$templateCache.put("app/loads/templates/directives/load-edit-type.html","<h3 class=\"large-title subtitle-section\">{{ \'loads:add:form:section:load_type:title\' | translate }}</h3><div class=form-group><input type=checkbox class=custom-checkbox id=recurrent_load name=recurrent_load ng-model=loadsedit.dataUpdateLoad.frecuency_active ng-true-value=1 ng-false-value=0><label for=recurrent_load><span></span>{{ \'loads:add:form:frecuency_active:text\' | translate }}</label></div><div ng-if=\"loadsedit.dataUpdateLoad.frecuency_active == 1\" class=form-group><div class=row><div class=\"col-6 col-sm-3\"><label>{{ \'loads:add:form:frecuency_id:text\' | translate }}</label><span class=help-inline ng-show=postLoadFormName.load_type.$error.required>*</span><select name=load_type id=load_type ng-model=loadsedit.dataUpdateLoad.frecuency_id class=\"form-control input-md\" required><option value=\"\">{{ \'loads:add:form:select:any\' | translate }}</option><option ng-repeat=\"option in loadsedit.itemsSizeLenLoads.FrecuencyLoads_list\" value={{option.id}}>{{option.name}}</option></select></div><div ng-if=\"loadsedit.dataUpdateLoad.frecuency_id == 6\" class=\"col-6 col-sm-3\"><label>{{ \'loads:add:form:frecuency_data:text\' | translate }}</label><span class=help-inline ng-show=postLoadFormName.frecuency_data.$error.required>*</span> <input date-range-picker type=text name=frecuency_data class=form-control ng-model=loadsedit.dataUpdateLoad.frecuency_data options=loadsedit.optsDatePicker required></div></div></div><div class=form-group><label>{{ \'loads:add:form:comments:text\' | translate }}</label><textarea class=form-control name=additional_information ng-model=loadsedit.dataUpdateLoad.load_comments placeholder=\"{{ \'loads:add:form:comments:text\' | translate }}\"></textarea></div>");
$templateCache.put("app/loads/templates/directives/load-tab.html","<div class=row><ul permission permission-only=\"\'GENERADOR_CARGA\'\" class=\"nav nav-tabs nav-tabs-full-w\" role=tablist><li class=nav-item><a class=\"nav-link custom-nav-link active\" data-toggle=tab ng-click=\"loads.changeCategory(\'my_loads\')\" role=tab>{{ \'loads:list:my_loads:title\' | translate }}</a></li><li class=nav-item><a class=\"nav-link custom-nav-link\" data-toggle=tab ng-click=\"loads.changeCategory(\'assigned\')\" role=tab>{{ \'loads:list:assigned:title\' | translate }}</a></li><li class=nav-item><a class=\"nav-link custom-nav-link\" data-toggle=tab ng-click=\"loads.changeCategory(\'not_assigned\')\" role=tab>{{ \'loads:list:not_assigned:title\' | translate }}</a></li><li class=nav-item><a class=\"nav-link custom-nav-link\" data-toggle=tab ng-click=\"loads.changeCategory(\'pending\')\" role=tab>{{ \'loads:list:pending:title\' | translate }}</a></li></ul><ul permission permission-only=\"[\'CARRIER\', \'OWNER\']\" class=\"nav nav-tabs nav-tabs-full-w\" role=tablist><li class=nav-item><a ng-class=\"{active: loads.loadsOptions.search_type == \'all\' }\" class=\"nav-link custom-nav-link\" data-toggle=tab ng-click=\"loads.changeCategory(\'all\')\" role=tab>{{ \'loads:list:all:title\' | translate }}</a></li><li class=nav-item><a class=\"nav-link custom-nav-link\" data-toggle=tab ng-click=\"loads.changeCategory(\'current\')\" role=tab>{{ \'loads:list:current:title\' | translate }}</a></li><li class=nav-item><a class=\"nav-link custom-nav-link\" data-toggle=tab ng-click=\"loads.changeCategory(\'not_assigned\')\" role=tab>{{ \'loads:list:suggest:title\' | translate }}</a></li><li class=nav-item><a class=\"nav-link custom-nav-link\" data-toggle=tab ng-click=\"loads.changeCategory(\'for_me\')\" role=tab>{{ \'loads:list:for_accept:title\' | translate }}</a></li><li class=nav-item><a ng-class=\"{active: loads.loadsOptions.search_type == \'my_search\' }\" class=\"nav-link custom-nav-link\" data-toggle=tab ng-click=\"loads.changeCategory(\'my_search\')\" role=tab>{{ \'loads:list:my_search:title\' | translate }}</a></li></ul><ul permission permission-only=\"[\'DRIVER\']\" class=\"nav nav-tabs nav-tabs-full-w\" role=tablist><li class=nav-item><a class=\"nav-link custom-nav-link\" data-toggle=tab ng-click=\"loads.changeCategory(\'current\')\" role=tab>{{ \'loads:list:current:title\' | translate }}</a></li><li class=nav-item><a ng-class=\"{active: loads.loadsOptions.search_type == \'my_search\' }\" class=\"nav-link custom-nav-link\" data-toggle=tab ng-click=\"loads.changeCategory(\'my_search\')\" role=tab>{{ \'loads:list:my_search:title\' | translate }}</a></li></ul></div>");
$templateCache.put("app/loads/templates/forms/create-form.html","<form><div class=form-group ng-show=\"checklistForm.length > 0 || !edit\"><p>¿Clonar Formulario?</p><div class=input-group><input type=checkbox class=form-control ng-model=item.clone></div></div><div class=form-group ng-show=item.clone><p>Seleccione una de tus plantillas *</p><div class=input-group><select class=form-control ng-model=item.form_id ng-options=\"value.form.id as value.form.name for (key, value) in checklistForm\"><option value=\"\">Seleccione opcion</option></select></div></div><div class=form-group ng-hide=item.clone><p>Nombre *</p><div class=input-group><input type=text class=form-control ng-model=item.form.name placeholder=\"Ingrese nombre\"></div></div><hr><br><div class=form-group ng-hide=item.clone><h4>¡Agregar Instruccion!</h4><div class=text-right><button class=\"btn btn-sm\" type=button ng-click=addMoreFields(edit) title=\"Agregar fields\"><span class=\"fa fa-plus-circle\"></span></button></div><br><table class=\"table table-bordered\" ng-repeat=\"field in moreAddFields\"><tr><td><div class=form-group><div class=row><div class=col-sm-8><input type=text class=form-control ng-model=item.form.fields[field.id].title placeholder=Pregunta></div><div class=col-sm-4><select class=form-control ng-model=item.form.fields[field.id].type ng-change=setTypeField() ng-options=\"value.id as value.name for (key, value) in cmbTypeFields\"><option value=\"\">Seleccione opcion</option></select></div></div><br><div class=row><div class=col-sm-8><input type=text class=form-control ng-model=item.form.fields[field.id].help placeholder=Ayuda ng-blur=storeFields(field.id,edit)></div></div><br><div class=col-sm-12 ng-show=\"item.form.fields[field.id].type == \'checkbox\'\"><div class=text-right><button class=\"btn btn-sm\" type=button ng-click=addMoreCheck(edit)><span class=\"fa fa-plus-circle\"></span></button></div><div class=col-sm-8><div class=form-group ng-repeat=\"checkbox in checkboxs\"><p></p><div class=input-group><input type=text class=form-control ng-keyup=setTextOfOption() ng-model=item.form.fields[field.id].options[checkbox.id].value placeholder=\"Agregar Opcion\"> <button class=\"btn btn-sm\" type=button ng-click=removeCheck(checkbox.id,edit)><span class=\"fa fa-minus-circle\"></span></button></div></div></div></div></div></td><td><button class=\"btn btn-sm\" type=button ng-click=removeFields(field.id,edit)><span class=\"fa fa-minus-circle\"></span></button></td></tr></table></div></form>");
$templateCache.put("app/loads/templates/forms/everyone-checklist.html","<style>.wrapper {\n    display: grid;\n    grid-template-columns: repeat(3, 1fr);\n    grid-gap: 10px;\n    grid-auto-rows: minmax(100px, auto);\n  }\n  .checklist {\n    border: solid 1px #A6A6A6;\n    text-align: center;\n    border-radius: 2px;\n    background: whitesmoke;\n\n  }</style><div class=wrapper><div class=checklist ng-repeat=\"dynamic in checklistForm\"><div style=\"text-align: right\"><i class=\"fa fa-times\" title=\"Quitar instrucciones\" aria-hidden=true ng-click=removeFormByStop() permission permission-only=\"[\'GENERADOR_CARGA\']\"></i></div><div><h4>{{dynamic.form.name}}</h4></div><div><form><div class=form-group ng-repeat=\"fields in dynamic.form.fields\"><p>{{fields.title}} {{(fields.required == true) ? \"*\": \"\"}}</p><div class=input-group ng-if=\"fields.type == \'select\'\"><select class=form-control ng-model=answers[fields.id] ng-options=\"value.id as (value.model +\' - \'+ value.brand) for (key, value) in cmbTrucks\"><option value=\"\">Seleccione Opcion</option></select></div><div class=input-group ng-if=\"fields.type == \'file\' || fields.type == \'gallery\' || fields.type == \'pod\' || fields.type == \'sign\'\"><div class=center><img src={{path}} width=50px height=50px ng-repeat=\"path in fields.answer\"></div></div><div class=input-group ng-if=\"fields.type == \'file\' || fields.type == \'gallery\' || fields.type == \'pod\' || fields.type == \'sign\'\"><div class=center><a ngf-select=\"uploadFile($file, fields)\" ngf-accept=\"\'image/jpg, image/jpeg\'\" ngf-max-size=100MB class=\"small-text normal-link inline-block parrafo pointer\"><i class=\"fa fa-upload\" aria-hidden=true></i> {{ \'profile:document:upload:title\' | translate }}</a></div></div><div class=input-group ng-if=\"fields.type == \'text\'\"><input type=text class=form-control ng-model=answers[fields.id] title={{fields.help}} ng-placeholder={{fields.placeholder}}></div><div class=input-group ng-if=\"fields.type == \'number\'\"><input type=number class=form-control ng-model=answers[fields.id] title={{fields.help}} placeholder={{fields.placeholder}}></div><div class=input-group ng-if=\"fields.type == \'textarea\'\"><textarea class=form-control ng-model=answers[fields.id] title={{fields.help}} placeholder={{fields.placeholder}}></textarea></div><div class=input-group ng-if=\"fields.type == \'checkbox\'\"><input type=checkbox class=form-control ng-model=answers[fields.id]></div></div></form></div><div style=\"text-align: right\"><button type=button title=\"Editar Intrucciones\" ng-click=editFormLetter() permission permission-only=\"[\'GENERADOR_CARGA\']\" class=\"btn bg-color-9 color-black\">Editar</button><!--<button\n          type=\"button\"\n          title=\"Agregar respuestas\"\n          ng-click=\"saveAnswers()\"\n          permission permission-only=\"[\'CARRIER\']\"\n          class=\"btn bg-color-9 color-black\">\n          Guardar\n        </button>--></div></div></div>");
$templateCache.put("app/loads/templates/forms/form-dinamic-checklist.html","<div class=col-sm-12 ng-repeat=\"dinamic in checklistForm\"><!--[\'checkbox\', \'select\', \'text\', \'textarea\', \'sign\', \'gallery\', \'files\']);--><form><div class=form-group ng-repeat=\"fields in dinamic.form.fields\"><p>{{fields.title}} {{(fields.required == true) ? \"*\": \"\"}}</p><div class=input-group ng-if=\"fields.type == \'select\'\"><select class=form-control ng-model=answers[fields.id] ng-disabled=\"cmbTrucks.length < 1\" ng-options=\"value.id as (value.model +\' - \'+ value.brand) for (key, value) in cmbTrucks\"><option value=\"\" ng-show=\"cmbTrucks.length < 1\"></option></select></div><div class=input-group ng-if=\"fields.type == \'file\' || fields.type == \'gallery\' || fields.type == \'pod\' || fields.type == \'sign\'\"><div class=center><a ngf-select=\"uploadFile($file, fields)\" ngf-accept=\"\'image/jpg, image/jpeg\'\" ngf-max-size=100MB class=\"small-text normal-link inline-block parrafo pointer\"><i class=\"fa fa-upload\" aria-hidden=true></i> {{ \'profile:document:upload:title\' | translate }}</a></div></div><div class=input-group ng-if=\"fields.type == \'text\'\"><input type=text class=form-control ng-model=answers[fields.id] title={{fields.help}} ng-placeholder={{fields.placeholder}}></div><div class=input-group ng-if=\"fields.type == \'number\'\"><input type=number class=form-control ng-model=answers[fields.id] title={{fields.help}} placeholder={{fields.placeholder}}></div><div class=input-group ng-if=\"fields.type == \'textarea\'\"><textarea class=form-control ng-model=answers[fields.id] title={{fields.help}} placeholder={{fields.placeholder}}></textarea></div><div class=input-group ng-if=\"fields.type == \'checkbox\'\"><input type=checkbox class=form-control ng-model=answers[fields.id]></div></div></form></div>{{dinamic.form.fields | json}}");
$templateCache.put("app/loads/templates/forms/form-select-truck.html","<form><div class=form-group><div class=input-group><select class=form-control ng-model=items.truck_id ng-disabled=\"cmbTrucks.length < 1\" ng-options=\"value.id as (value.model +\' - \'+ value.brand) for (key, value) in cmbTrucks\"><option value=\"\" ng-show=\"cmbTrucks.length < 1\">{{ \'loads:add:form:select:truck\' | translate }} {{loadData.trailer_type.trailer_type_name}}</option></select></div></div><div class=form-group><label style=\"font-size: 80%\">{{ \'modals:load_driver_select:title\' | translate }} *</label><div class=input-group><select class=form-control ng-model=items.driver_id ng-disabled=\"cmbDrivers.length < 1\" ng-options=\"value.id as (value.user_first_name +\' \'+ value.user_last_name) for (key, value) in cmbDrivers\"><option value=\"\">{{ \'loads:add:form:select:any\' | translate }}</option></select></div></div></form>");
$templateCache.put("app/loads/templates/modal/cancel-load.html","<div class=modal-body id=cancel-load-modal><h3 class=\"title-modal text-left\">{{ \'modals:cancel_load:title\' | translate }}</h3><p class=\"small-text parrafo\">{{ \'modals:cancel_load:desc\' | translate }}</p><form method=post id=cancelLoadFormId name=cancelLoadFormName ng-submit=cancelload.sendCancel(cancelLoadFormName) novalidate><div class=form-group><label class=title-field>{{ \'modals:cancel_load:form:reason:text\' | translate }}</label><select name=reason-opt id=reason-opt ng-model=cancelload.dataToSend.reason_cancel class=\"form-control input-md\" required><option value=\"\">{{ \'modals:cancel_load:form:select:empty\' | translate }}</option><option ng-repeat=\"option in cancelload.itemsSizeLenLoads.ReasonLoadCancel_list\" value={{option.id}}>{{option.name_reason}}</option></select></div><div class=form-group><textarea ng-model=cancelload.dataToSend.reason_cancel_descrip name=comment-reason class=form-control placeholder=\"Please add your comment\" required></textarea></div><div class=\"form-group text-right\"><button ng-disabled=cancelload.savingCancel type=submit class=\"btn btn-class1 bg-color-4 color-white\">{{ \'modals:cancel_load:btn\' | translate}}</button></div></form></div>");
$templateCache.put("app/loads/templates/modal/carrier-assigned-info.html","<div class=modal-body id=carrier-assigned-modal><h3 class=\"title-modal text-left\">{{ \'modals:carrier_assigned:title\' | translate }}</h3><main-loader ng-if=\"carrierassignedinfo.loadingInfo && !carrierassignedinfo.finalCarrierData\"></main-loader><p ng-if=\"!carrierassignedinfo.loadingInfo && !carrierassignedinfo.finalCarrierData\" class=parrafo>{{ \'modals:carrier_assigned:empty_info\' | translate }}</p><div ng-if=\"!carrierassignedinfo.loadingInfo && carrierassignedinfo.finalCarrierData\" class=full-width><div class=\"row parrafo\"><div class=\"col-3 col-sm-3\"><div class=pic-square><img ng-if=carrierassignedinfo.finalCarrierData.img_perfil_carrier ng-src=\"{{carrierassignedinfo.finalCarrierData.img_perfil_carrier[0][\'imagen-60\']}}\" border=0></div></div><div class=\"col-8 col-sm-8\"><p class=\"title-field parrafo\">{{carrierassignedinfo.finalCarrierData.carrier_info.company_name}}</p><div ng-if=carrierassignedinfo.finalCarrierData.carrier_info.user.user_votes.length class=full-width><ul class=\"nav user-calification\"><li class=nav-item><span ng-class=\"carrierassignedinfo.finalCarrierData.carrier_info.user.user_votes[0].total_prom >= 1 ? \'fa-star\' : \'fa-star-o\'\" class=fa></span></li><li class=nav-item><span ng-class=\"carrierassignedinfo.finalCarrierData.carrier_info.user.user_votes[0].total_prom >= 2 ? \'fa-star\' : \'fa-star-o\'\" class=fa></span></li><li class=nav-item><span ng-class=\"carrierassignedinfo.finalCarrierData.carrier_info.user.user_votes[0].total_prom >= 3 ? \'fa-star\' : \'fa-star-o\'\" class=fa></span></li><li class=nav-item><span ng-class=\"carrierassignedinfo.finalCarrierData.carrier_info.user.user_votes[0].total_prom >= 4 ? \'fa-star\' : \'fa-star-o\'\" class=fa></span></li><li class=nav-item><span ng-class=\"carrierassignedinfo.finalCarrierData.carrier_info.user.user_votes[0].total_prom >= 5 ? \'fa-star\' : \'fa-star-o\'\" class=fa></span></li></ul></div><div ng-if=!carrierassignedinfo.finalCarrierData.carrier_info.user.user_votes.length class=full-width><ul class=\"nav user-calification\"><li class=nav-item><span class=\"fa fa-star-o\"></span></li><li class=nav-item><span class=\"fa fa-star-o\"></span></li><li class=nav-item><span class=\"fa fa-star-o\"></span></li><li class=nav-item><span class=\"fa fa-star-o\"></span></li><li class=nav-item><span class=\"fa fa-star-o\"></span></li></ul></div><p class=\"text-field no-margin\">Loads Delivered: {{carrierassignedinfo.finalCarrierData.LoadsTransported}}</p><p class=\"text-field no-margin\">Contact: {{carrierassignedinfo.finalCarrierData.carrier_info.phone_company}}</p></div></div><h4 class=\"subtitle-modal text-left\">{{ \'modals:carrier_assigned:basic_info:title\' | translate }}</h4><div class=row><div class=\"col col-sm-6\"><label class=title-field>{{ \'modals:carrier_assigned:basic_info:corp_number:title\' | translate }}</label><p class=text-field>{{carrierassignedinfo.finalCarrierData.carrier_info.corp_number}}</p></div><div class=\"col col-sm-6\"><label class=title-field>{{ \'modals:carrier_assigned:basic_info:ein_number:title\' | translate }}</label><p class=text-field>{{carrierassignedinfo.finalCarrierData.carrier_info.ein_number}}</p></div></div><div class=row><div class=\"col col-sm-6\"><label class=title-field>{{ \'modals:carrier_assigned:basic_info:carrier_city:title\' | translate }}</label><p class=text-field>{{carrierassignedinfo.finalCarrierData.carrier_info.city_company}} - {{carrierassignedinfo.finalCarrierData.carrier_info.state_company}}</p></div><div class=\"col col-sm-6\"><label class=title-field>{{ \'modals:carrier_assigned:basic_info:insurance_policy:title\' | translate }}</label><p class=text-field>{{carrierassignedinfo.finalCarrierData.carrier_info.bond_insurance_policy_num}}</p></div></div><!--<h4 class=\"subtitle-modal text-left\">Truck assigned</h4>--></div></div>");
$templateCache.put("app/loads/templates/modal/carrier-requests.html","<div class=modal-body id=carrier-requests-modal><h3 class=\"title-modal text-left\">{{ \'modals:carrier_requests:title\' | translate }}</h3><p ng-if=\"!carrierrequests.loadingInfo && carrierrequests.carrierReqList.length <= 0\" class=\"small-text parrafo\">{{ \'modals:carrier_requests:empty_requests:text\' | translate }}</p><p ng-if=\"!carrierrequests.loadingInfo && carrierrequests.carrierReqList.length > 0\" class=\"small-text parrafo\">{{ \'modals:carrier_requests:description\' | translate }}</p><form ng-if=\"!carrierrequests.loadingInfo && carrierrequests.carrierReqList.length > 0\" method=post id=carrierRequestFormId name=carrierRequestFormName ng-submit=carrierrequests.sendConfirmRequest(carrierRequestFormName) novalidate><div class=\"full-width content-tableData parrafo\"><table datatable=ng dt-options=carrierrequests.datatableOptions class=tableDataSort width=100% border=0><thead><tr><th></th><th></th><th></th><th></th><th></th><th></th><th></th></tr></thead><tbody><tr ng-repeat=\"carrier in carrierrequests.carrierReqList\"><td class=relative><input ng-model=carrierrequests.dataRequest.carrier type=radio id=carrier_{{carrier.id_request}} name=carrier_id value={{carrier.id_request}} required><label for=carrier_{{carrier.id_request}}></label><div class=check><div class=inside></div></div></td><td ng-click=carrierrequests.seeCarrierProfile(carrier.carrier.user_id) class=pointer><img ng-if=carrier.img_perfil_carrier ng-src=\"{{carrier.img_perfil_carrier[0][\'imagen-60\']}}\" width=40 border=0></td><td ng-click=carrierrequests.seeCarrierProfile(carrier.carrier.user_id) class=pointer>{{carrier.carrier.company_name}}</td><td ng-click=carrierrequests.seeCarrierProfile(carrier.carrier.user_id) class=pointer>{{carrier.CantidadTruck}}</td><td ng-click=carrierrequests.seeCarrierProfile(carrier.carrier.user_id) class=pointer>{{carrier.SkillsCarrierText}}</td><td ng-click=carrierrequests.seeCarrierProfile(carrier.carrier.user_id) class=pointer width=20% ng-if=carrier.carrier.user.user_votes.length><ul class=\"nav user-calification\"><li class=nav-item><span ng-class=\"carrier.carrier.user.user_votes[0].total_prom >= 1 ? \'fa-star\' : \'fa-star-o\'\" class=fa></span></li><li class=nav-item><span ng-class=\"carrier.carrier.user.user_votes[0].total_prom >= 2 ? \'fa-star\' : \'fa-star-o\'\" class=fa></span></li><li class=nav-item><span ng-class=\"carrier.carrier.user.user_votes[0].total_prom >= 3 ? \'fa-star\' : \'fa-star-o\'\" class=fa></span></li><li class=nav-item><span ng-class=\"carrier.carrier.user.user_votes[0].total_prom >= 4 ? \'fa-star\' : \'fa-star-o\'\" class=fa></span></li><li class=nav-item><span ng-class=\"carrier.carrier.user.user_votes[0].total_prom >= 5 ? \'fa-star\' : \'fa-star-o\'\" class=fa></span></li></ul></td><td ng-click=carrierrequests.seeCarrierProfile(carrier.carrier.user_id) class=pointer width=20% ng-if=!carrier.carrier.user.user_votes.length><ul class=\"nav user-calification\"><li class=nav-item><span class=\"fa fa-star-o\"></span></li><li class=nav-item><span class=\"fa fa-star-o\"></span></li><li class=nav-item><span class=\"fa fa-star-o\"></span></li><li class=nav-item><span class=\"fa fa-star-o\"></span></li><li class=nav-item><span class=\"fa fa-star-o\"></span></li></ul></td><td ng-click=carrierrequests.seeCarrierProfile(carrier.carrier.user_id) class=pointer width=15%><span class=\"fa fa-phone vertical-middle\"></span> <a href=# class=\"small-text normal-link\">{{carrier.carrier.phone_company}}</a></td></tr></tbody></table></div><div class=\"full-width text-right\"><button style=\"max-width: 300px\" ng-disabled=carrierrequests.savingRequest type=submit class=\"btn btn-class1 bg-color-9 color-black\">{{ \'modals:carrier_requests:form:btn\' | translate }}</button></div></form></div>");
$templateCache.put("app/loads/templates/modal/checked-load-price.html","<div class=modal-body id=load-price-modal><h3 class=\"title-modal text-left\">{{ \'modals:load_price_suggested:title\' | translate }}</h3><p class=\"small-text parrafo\">{{ \'modals:load_price_suggested:desc\' | translate:{ price: loadprice.priceSuggested } }}</p><div class=\"form-group text-right\"><button ng-click=loadprice.selectPrice(true) type=button class=\"btn btn-class1 bg-color-9 color-black\">{{ \'modals:load_price_suggested:btn_suggested\' | translate}}</button> <button ng-click=loadprice.selectPrice(false) type=button class=\"btn btn-class1 bg-color-white color-black\">{{ \'modals:load_price_suggested:btn_client_price\' | translate}}</button></div></div>");
$templateCache.put("app/loads/templates/modal/load-activity-info.html","<div class=modal-body id=load-activity-info-modal><h3 class=\"title-modal text-left\">{{ \'modals:load_activity:title\' | translate }}</h3><p ng-if=!loadactivityinfo.loadData.history_load class=parrafo>{{ \'modals:load_activity:empty_info\' | translate }}</p><div ng-if=loadactivityinfo.loadData.history_load class=full-width><div class=\"row parrafo\"><div class=\"col-12 col-sm-12\"><div class=\"row parrafo\" ng-repeat=\"history in loadactivityinfo.loadData.history_load\"><div class=\"col-1 col-sm-1 relative\"><div class=round-point-activity></div><div class=line-activity></div></div><div class=\"col-2 col-sm-2\"><div class=pic-square><img ng-if=history.img_perfil ng-src=\"{{history.img_perfil[0][\'imagen-60\']}}\" border=0></div></div><div class=\"col-9 col-sm-9\"><p class=description-activity ng-if=\"history.key == \'apply_load_accept\'\">{{\'modals:load_activity:assigned_load_to:text\' | translate}} {{history.name_request}}</p><p class=description-activity ng-if=\"history.key == \'apply_load_collected\'\">{{\'modals:load_activity:load_collected:text\' | translate}}</p><p class=description-activity ng-if=\"history.key == \'apply_load_transit\'\">{{\'modals:load_activity:load_transit:text\' | translate}} {{history.name_request}}</p><p class=description-activity ng-if=\"history.key == \'apply_load_delivered\'\">{{\'modals:load_activity:load_delivered:text\' | translate}} {{history.name_request}}</p><p class=date-activity><span class=\"fa fa-clock\"></span> {{history.date_register | amDateFormat:\'MMM DD YYYY\'}}</p></div></div><div class=row><div class=\"col-1 col-sm-1 relative\"><div class=round-point-activity></div></div><div class=\"col-2 col-sm-2\"><div class=pic-square></div></div><div class=\"col-9 col-sm-9\"><p class=description-activity>--</p><p class=date-activity><span class=\"fa fa-clock\"></span> --</p></div></div></div></div></div></div>");
$templateCache.put("app/loads/templates/modal/load-truck-select.html","<div class=modal-body id=load-truck-select-modal><h3 class=\"title-modal text-left\">{{ \'modals:load_truck_select:title\' | translate }}</h3><p ng-if=\"!loadtruckselect.loadingInfo && loadtruckselect.dataRequest.length <= 0\" class=\"small-text parrafo\"><!--{{ \'modals:load_truck_select:empty_trucks:text\' | translate }}--> {{ \'modals:load_truck_select:full_trucks:text\' | translate }}</p><form ng-if=\"!loadtruckselect.loadingInfo && loadtruckselect.dataRequest.length > 0\" method=post id=loadTruckSelectFormId name=loadTruckSelectFormName ng-submit=loadtruckselect.sendConfirmSelect(loadTruckSelectFormName) novalidate><div class=\"full-width content-tableData parrafo\"><table class=tableDataSort width=100% border=0><thead><tr><th></th><th></th><th></th><th></th></tr></thead><tbody><tr ng-repeat=\"truck in loadtruckselect.dataRequest\"><td class=relative><input ng-model=loadtruckselect.dataTruckSelect.truck_id type=radio id=truck_{{truck.id}} name=truck_id value={{truck.id}} required><label for=truck_{{truck.id}}></label><div class=check><div class=inside></div></div></td><td><img ng-if=truck.truck_img ng-src={{truck.truck_img}} class=\"img-fluid rounded-circle\" border=0></td><td><p class=truck-name-table style=\"margin-bottom: 0px\">{{truck.truck_name}}</p><span class=driver-name-table>Driven by {{truck.driver_name}}</span></td><td ng-bind-html=truck.truck_status></td></tr></tbody></table></div><div class=\"full-width text-right\"><button ng-disabled=loadtruckselect.savingRequest type=submit class=\"btn btn-class1 bg-color-9 color-black\">{{ \'modals:load_truck_select:form:btn\' | translate }}</button></div></form></div>");
$templateCache.put("app/loads/templates/modal/report-issues-load.html","<div class=modal-body id=cancel-load-modal><h3 class=\"title-modal text-left\">{{ \'modals:report_issues_load:title\' | translate }}</h3><p class=\"small-text parrafo\">{{ \'modals:report_issues_load:desc\' | translate }}</p><form method=post id=reportIssuesLoadFormId name=reportIssuesLoadFormName ng-submit=reportissuesload.sendReport(reportIssuesLoadFormName) novalidate><div class=form-group><textarea ng-model=reportissuesload.dataToSend.description name=comment-reason class=form-control placeholder=\"{{ \'modals:report_issues_load:form:placeholder\' | translate }}\" required></textarea></div><div class=\"form-group text-right\"><button ng-click=reportissuesload.closePopup() type=button class=\"btn btn-class1 bg-color-white color-armadillo\">{{ \'modals:report_issues_load:close:btn\' | translate }}</button> <button ng-disabled=reportissuesload.savingReport type=submit class=\"btn btn-class1 bg-color-4 color-white\">{{ \'modals:report_issues_load:btn\' | translate}}</button></div></form></div>");
$templateCache.put("app/loads/templates/modal/search-load-log.html","<div class=modal-body id=load-search-modal><h3 class=\"title-modal text-left\">{{ \'modals:loads_log:search:title\' | translate }}</h3><form method=post id=searchLoadLogFormId name=searchLoadLogFormName ng-submit=searchloadlog.sendDataLoadsLog(searchLoadLogFormName) novalidate><div class=form-group><div class=row><div class=col-12><label class=title-field>{{ \'modals:loads_log:search:fields:type:title\' | translate }}</label><select name=shortcut id=shortcut ng-model=searchloadlog.searchData.shortcut class=\"form-control input-md\"><option ng-repeat=\"option in searchloadlog.shortCutTypes\" value={{option.id}}>{{option.name}}</option></select></div></div></div><div ng-if=\"searchloadlog.searchData.shortcut == \'custom\'\" class=form-group><div class=row><div class=\"col-12 col-sm-6\"><label class=title-field>{{ \'modals:loads_log:search:fields:custom_date_from:title\' | translate }}</label><input ng-blur=searchloadlog.allowDateTo() date-range-picker id=date_from ng-model=searchloadlog.searchData.date_from name=date_from type=text placeholder=\"\" class=\"form-control input-md date-picker\" options=searchloadlog.optsDatePicker></div><div class=\"col-12 col-sm-6\"><label class=title-field>{{ \'modals:loads_log:search:fields:custom_date_to:title\' | translate }}</label><input ng-disabled=searchloadlog.dateToDisabled date-range-picker type=text name=date_to class=\"form-control date-picker\" ng-model=searchloadlog.searchData.date_to placeholder=\"\" options=searchloadlog.optsDatePicker2 min=searchloadlog.searchData.date_from></div></div></div><div class=form-group><div class=row><div class=col-12><label class=title-field>{{ \'modals:loads_log:search:fields:load_id:title\' | translate }}</label><input type=text name=load_id class=\"form-control date-picker\" ng-model=searchloadlog.searchData.load_id placeholder=\"\"></div></div></div><div class=form-group><div class=row><div class=col-12><button type=submit class=\"btn btn-class1 bg-color-9 color-black\">{{ \'modals:loads_log:search:btn:text\' | translate }}</button></div></div></div></form></div>");
$templateCache.put("app/loads/templates/modal/truck-assigned-info.html","<div class=modal-body id=truck-assigned-modal><h3 class=\"title-modal text-left\">{{ \'modals:truck_assigned:title\' | translate }}</h3><main-loader ng-if=\"truckassignedinfo.loadingInfo && !truckassignedinfo.finalTruckData\"></main-loader><p ng-if=\"!truckassignedinfo.loadingInfo && !truckassignedinfo.finalTruckData\" class=parrafo>{{ \'modals:truck_assigned:empty_info\' | translate }}</p><div ng-if=\"!truckassignedinfo.loadingInfo && truckassignedinfo.finalTruckData\" class=full-width><ul ng-if=truckassignedinfo.finalTruckData.id class=\"nav name-calification-details\"><li class=nav-item><h5 style=margin-right:15px class=title-truck-details>{{truckassignedinfo.finalTruckData.brand}} {{truckassignedinfo.finalTruckData.model}}</h5></li><li ng-if=truckassignedinfo.finalTruckData.driver.user.user_votes.length class=nav-item><span ng-class=\"truckassignedinfo.finalTruckData.driver.user.user_votes[0].total_prom >= 1 ? \'fa-star\' : \'fa-star-o\'\" class=fa></span> <span ng-class=\"truckassignedinfo.finalTruckData.driver.user.user_votes[0].total_prom >= 2 ? \'fa-star\' : \'fa-star-o\'\" class=fa></span> <span ng-class=\"truckassignedinfo.finalTruckData.driver.user.user_votes[0].total_prom >= 3 ? \'fa-star\' : \'fa-star-o\'\" class=fa></span> <span ng-class=\"truckassignedinfo.finalTruckData.driver.user.user_votes[0].total_prom >= 4 ? \'fa-star\' : \'fa-star-o\'\" class=fa></span> <span ng-class=\"truckassignedinfo.finalTruckData.driver.user.user_votes[0].total_prom >= 5 ? \'fa-star\' : \'fa-star-o\'\" class=fa></span></li><li ng-if=!truckassignedinfo.finalTruckData.driver.user.user_votes.length class=nav-item><span class=\"fa fa-star-o\"></span> <span class=\"fa fa-star-o\"></span> <span class=\"fa fa-star-o\"></span> <span class=\"fa fa-star-o\"></span> <span class=\"fa fa-star-o\"></span></li></ul><div ng-if=truckassignedinfo.finalTruckData.id class=\"row parrafo\"><div class=\"col col-md-12\"><img ng-if=truckassignedinfo.finalTruckData.imagenes_trucks ng-src=\"{{truckassignedinfo.finalTruckData.imagenes_trucks[0][\'imagen-60\']}}\" class=\"img-fluid pull-left\" border=0><p class=foot-truck-pic style=margin-left:75px>{{ \'trucks:details:loads_delivered:title\' | translate }}: {{truckassignedinfo.finalTruckData.Loads_Transported}}</p></div></div><div ng-if=truckassignedinfo.finalTruckData.id class=row><div class=\"col truck-items-data\"><div class=row><div class=\"col col-sm-6\"><label class=\"small-text no-margin\">{{ \'trucks:details:brand:title\' | translate }}</label><p ng-if=truckassignedinfo.finalTruckData.brand>{{truckassignedinfo.finalTruckData.brand}}</p><p ng-if=!truckassignedinfo.finalTruckData.brand>---</p></div><div class=\"col col-sm-6\"><label class=\"small-text no-margin\">{{ \'trucks:details:model:title\' | translate }}</label><p ng-if=truckassignedinfo.finalTruckData.model>{{truckassignedinfo.finalTruckData.model}}</p><p ng-if=!truckassignedinfo.finalTruckData.model>---</p></div></div><div class=row><div class=\"col col-sm-6\"><label class=\"small-text no-margin\">{{ \'trucks:details:year:title\' | translate }}</label><p ng-if=truckassignedinfo.finalTruckData.year>{{truckassignedinfo.finalTruckData.year}}</p><p ng-if=!truckassignedinfo.finalTruckData.year>---</p></div><div class=\"col col-sm-6\"><label class=\"small-text no-margin\">{{ \'trucks:details:plate:title\' | translate }}</label><p ng-if=truckassignedinfo.finalTruckData.plate>{{truckassignedinfo.finalTruckData.plate}}</p><p ng-if=!truckassignedinfo.finalTruckData.plate>---</p></div></div><div class=row><div class=\"col col-sm-6\"><label class=\"small-text no-margin\">{{ \'trucks:details:driven_by:title\' | translate }}</label><p ng-if=\"truckassignedinfo.finalTruckData.driver.user.user_first_name || truckassignedinfo.finalTruckData.driver.user.user_last_name\">{{truckassignedinfo.finalTruckData.driver.user.user_first_name}} {{truckassignedinfo.finalTruckData.driver.user.user_last_name}}</p><p ng-if=\"!truckassignedinfo.finalTruckData.driver.user.user_first_name && !truckassignedinfo.finalTruckData.driver.user.user_last_name\">---</p></div><div class=\"col col-sm-6\"><label class=\"small-text no-margin\">{{ \'trucks:details:trailer_type:title\' | translate }}</label><p ng-if=truckassignedinfo.finalTruckData.truck_type.truck_type_name>{{truckassignedinfo.finalTruckData.truck_type.truck_type_name}}</p><p ng-if=!truckassignedinfo.finalTruckData.truck_type.truck_type_name>---</p></div></div><div class=row><div class=\"col col-sm-6\"><label class=\"small-text no-margin\">{{ \'trucks:details:length:title\' | translate }}</label><p ng-if=truckassignedinfo.finalTruckData.length>{{truckassignedinfo.finalTruckData.length}}</p><p ng-if=!truckassignedinfo.finalTruckData.length>---</p></div><div class=\"col col-sm-6\"><label class=\"small-text no-margin\">{{ \'trucks:details:weight:title\' | translate }}</label><p ng-if=truckassignedinfo.finalTruckData.weight>{{truckassignedinfo.finalTruckData.weight}}</p><p ng-if=!truckassignedinfo.finalTruckData.weight>---</p></div></div><div class=row><div class=\"col col-sm-6\"><label class=\"small-text no-margin\">{{ \'trucks:details:size:title\' | translate }}</label><p ng-if=truckassignedinfo.finalTruckData.size>{{truckassignedinfo.finalTruckData.size}}</p><p ng-if=!truckassignedinfo.finalTruckData.size>---</p></div><div class=\"col col-sm-6\"><label class=\"small-text no-margin\">{{ \'trucks:details:skills:title\' | translate }}</label><p>{{truckassignedinfo.finalTruckData.SkillsTruckText}}</p></div></div><div class=row><div class=\"col col-sm-6\"><label class=\"small-text no-margin\">{{ \'trucks:details:capacity:title\' | translate }}</label><p ng-if=truckassignedinfo.finalTruckData.truck_capacity.capacity_name>{{truckassignedinfo.finalTruckData.truck_capacity.capacity_name}}</p><p ng-if=!truckassignedinfo.finalTruckData.truck_capacity.capacity_name>---</p></div><div class=\"col col-sm-6\"><label class=\"small-text no-margin\">{{ \'trucks:details:max_distance:title\' | translate }}</label><p ng-if=truckassignedinfo.finalTruckData.max_distance>{{truckassignedinfo.finalTruckData.max_distance}}</p><p ng-if=!truckassignedinfo.finalTruckData.max_distance>---</p></div></div><div class=row><div class=\"col col-sm-6\"><label class=\"small-text no-margin\">{{ \'trucks:details:availiability:title\' | translate }}</label><p>{{truckassignedinfo.finalTruckData.AvailabilityTruckText}}</p></div><div class=\"col col-sm-6\"><a ng-click=truckassignedinfo.goToTruckLoads() class=\"small-text normal-link load-search-lessf pointer\">{{ \'trucks:details:truck_loads:title\' | translate }}</a></div></div><div class=row><div class=\"col col-sm-12 relative\"><div class=truck-item-large><label class=\"small-text no-margin\">{{ \'trucks:details:additional_info:title\' | translate }}</label><p ng-if=truckassignedinfo.finalTruckData.additional_info>{{truckassignedinfo.finalTruckData.additional_info}}</p><p ng-if=!truckassignedinfo.finalTruckData.additional_info>---</p></div></div></div></div></div></div></div>");
$templateCache.put("app/loads/templates/tabs/make-forms.html","<main-loader ng-show=loading></main-loader><div class=container ng-hide=loading><div class=row><div class=\"col text-right botonera-list\"><div class=row><div class=col-sm-12><button type=button title=\"Agregar Instrucciones\" ng-click=makeFormLetter() permission permission-only=\"[\'GENERADOR_CARGA\']\" class=\"btn bg-color-9 color-black\">Agregar Instrucciones</button></div></div></div></div><div class=col-md-12><div class=text-center><h4>Instrucciones</h4><br><div ng-include=\"\'app/loads/templates/forms/everyone-checklist.html\'\"></div></div></div></div>");
$templateCache.put("app/loads/templates/tabs/tab-details-loads.html","<div class=row><div class=\"col-12 col-sm-6\"><div class=full-width ng-if=\"!loadsdetails.loadingDataDetails && loadsdetails.loadData.load_id\"><ul class=\"nav pickup-destiny-details\"><li class=nav-item><h3 class=title-load-details>{{loadsdetails.loadData.from}}</h3></li><li class=nav-item><span class=\"fa fa-arrow-right\"></span></li><li class=nav-item><h3 class=title-load-details>{{loadsdetails.loadData.to}}</h3></li><li class=nav-item><span>{{loadsdetails.loadData.distance}}</span></li></ul><div class=row><div class=\"col-12 col-sm-6 parrafo\"><label>{{\'loads:details:load_id:title\' | translate}}</label><p>{{loadsdetails.loadData.load_id}}</p></div></div><div class=row><div class=\"col-12 col-sm-6 parrafo\"><label>{{\'loads:details:pickup_address:title\' | translate}}</label><p>{{loadsdetails.loadData.pickup_address}}</p></div><div class=\"col-12 col-sm-6 parrafo\"><label>{{\'loads:details:pickup_address_details:title\' | translate }}</label><p>{{loadsdetails.loadData.detail_address_pickup}}</p></div></div><div class=row><div class=\"col-12 col-sm-6 parrafo\"><label>{{\'loads:details:delivery_address:title\' | translate}}</label><p>{{loadsdetails.loadData.delivery_address}}</p></div><div class=\"col-12 col-sm-6 parrafo\"><label>{{\'loads:details:delivery_address_details:title\' | translate }}</label><p>{{loadsdetails.loadData.detail_address_delivery}}</p></div></div><div class=row><div class=\"col-12 col-sm-6 parrafo\"><label>{{\'loads:details:multiple_stops_yn:title\' | translate}}</label><p ng-if=\"loadsdetails.loadData.stops_loads.length > 0\">{{\'loads:details:multiple_stops:yes:title\' | translate}}</p><p ng-if=\"loadsdetails.loadData.stops_loads.length <= 0\">{{\'loads:details:multiple_stops:no:title\' | translate}}</p></div><div class=\"col-12 col-sm-6 parrafo\"><label>{{\'loads:details:multiple_stops_addresses:title\' | translate }}</label><p ng-repeat=\"multiplestopitem in loadsdetails.loadData.stops_loads\">{{multiplestopitem.address_stop}}</p></div></div><div class=row><div class=\"col-12 col-sm-6 parrafo\"><label>{{\'loads:details:pickup_date:title\' | translate}}</label><p>{{loadsdetails.loadData.pickup_date | amDateFormat:\'MMM DD YYYY\'}}</p></div><div class=\"col-12 col-sm-6 parrafo\"><label>{{\'loads:details:pickup_date_rage:title\' | translate}}</label><p>{{loadsdetails.loadData.timer_star_pickup | amDateFormat:\'MMM DD/YY HH:mm:ss\'}} - {{loadsdetails.loadData.timer_finish_pickup | amDateFormat:\'MMM DD/YY HH:mm:ss\'}}</p></div></div><div class=row><div class=\"col-12 col-sm-6 parrafo\"><label>{{\'loads:details:delivery_date:title\' | translate}}</label><p>{{loadsdetails.loadData.delivery_date | amDateFormat:\'MMM DD YYYY\'}}</p></div><div class=\"col-12 col-sm-6 parrafo\"><label>{{\'loads:details:pickup_date_rage:title\' | translate}}</label><p>{{loadsdetails.loadData.timer_start_delivery | amDateFormat:\'MMM DD/YY HH:mm:ss\'}} - {{loadsdetails.loadData.timer_finish_delivery | amDateFormat:\'MMM DD/YY HH:mm:ss\'}}</p></div></div><div class=row><div class=\"col-12 col-sm-6 parrafo\"><label>{{\'loads:details:pickup_zip_code:title\' | translate }}</label><p>{{loadsdetails.loadData.zip_code_pickup}}</p></div><div class=\"col-12 col-sm-6 parrafo\"><label>{{\'loads:details:delivery_zip_code:title\' | translate }}</label><p>{{loadsdetails.loadData.zip_code_delivery}}</p></div></div><div class=row><div class=\"col-12 col-sm-6 parrafo\"><label>{{\'loads:details:price:title\' | translate}}</label><p>{{loadsdetails.loadData.price_to_show}}</p></div><div class=\"col-12 col-sm-6 parrafo\"><label>{{\'loads:details:rate_miles:title\' | translate}}</label><p>{{loadsdetails.loadData.rate_miles}}</p></div></div><div class=row><div class=\"col-12 col-sm-6 parrafo\"><label>{{\'loads:details:length:title\' | translate}}</label><p>{{loadsdetails.loadData.length_loads}}</p></div><div class=\"col-12 col-sm-6 parrafo\"><label>{{\'loads:details:weight:title\' | translate}}</label><p>{{loadsdetails.loadData.weight}}</p></div></div><div class=row><div class=\"col-12 col-sm-6 parrafo\"><label>{{\'loads:details:size:title\' | translate}}</label><p>{{loadsdetails.loadData.dimension}}</p></div><div class=\"col-12 col-sm-6 parrafo\"><label>{{\'loads:details:load_type:title\' | translate}}</label><p>{{loadsdetails.loadData.type_load_text}}</p></div></div><div permission permission-only=\"[\'GENERADOR_CARGA\', \'CARRIER\',\'OWNER\']\" class=row><div class=\"col col-sm-6 parrafo\"><label>{{\'loads:details:tipocamion:title\' | translate}}</label><p>{{loadsdetails.loadData.truck_type_text}}</p></div><div ng-if=false class=\"col col-sm-6 parrafo\"><label>{{\'loads:details:license_type:title\' | translate}}</label><p>{{loadsdetails.loadData.load_type_license.categoria}}</p></div><div class=\"col-12 col-sm-6 parrafo\"><label>{{\'loads:details:noot_load:title\' | translate}}</label><p>{{loadsdetails.loadData.noot_load}}</p></div></div><div permission permission-only=\"[\'GENERADOR_CARGA\', \'CARRIER\',\'OWNER\']\" class=row><div class=\"col col-sm-6 parrafo\"><label>{{\'loads:details:consignee:title\' | translate}}</label><p>{{loadsdetails.loadData.consignee}}</p></div><div class=\"col col-sm-6 parrafo\"><label>{{\'loads:details:receiver:title\' | translate}}</label><p>{{loadsdetails.loadData.receiver}}</p></div></div><div class=row><div class=\"col-12 col-sm-6 parrafo\"><label>{{\'loads:details:carrier_skills_required:title\' | translate}}</label><p>{{loadsdetails.loadData.carrier_skills_required_text}}</p></div><div class=\"col-12 col-sm-6 parrafo\"><label>{{\'loads:details:trailer_type:title\' | translate}}</label><p>{{loadsdetails.loadData.trailer_type_desc}}</p></div></div><div class=row><div permission permission-only=\"\'GENERADOR_CARGA\'\" ng-if=\"!loadsdetails.loadingDataDetails && loadsdetails.loadData.status_loads !=\'NOT_ASSIGNED\' && loadsdetails.loadData.carrier\" class=\"col-12 col-sm-6 parrafo\"><label>{{\'loads:details:carrier_assigned:title\' | translate}}</label><p><a ng-click=loadsdetails.openCarrierAssignedInfoModal() class=\"small-text normal-link pointer\">{{loadsdetails.loadData.carrier.company_name}} <img src=assets/images/common/see-more.png width=20 border=0></a></p></div><div permission permission-only=\"[\'CARRIER\',\'OWNER\']\" ng-if=\"!loadsdetails.loadingDataDetails && loadsdetails.loadData.status_loads !=\'NOT_ASSIGNED\' && loadsdetails.loadData.carrier\" class=\"col-12 col-sm-6 parrafo\"><label ng-if=\"loadsdetails.loadData.carrier.user_id == loadsdetails.myData.user_id\">{{\'loads:details:carrier_assigned:title\' | translate}}</label><p ng-if=\"loadsdetails.loadData.carrier.user_id == loadsdetails.myData.user_id\">{{\'loads:details:carrier_assigned:me:text\' | translate}}</p></div></div><div permission permission-only=\"\'GENERADOR_CARGA\'\" class=row><div class=\"col-12 col-sm-6 parrafo\"><label>{{\'loads:details:recurrent:title\' | translate}}</label><p ng-if=\"loadsdetails.loadData.recurrent_load_status != \'False\'\">{{\'loads:details:recurrent:options:yes\' | translate}}</p><p ng-if=\"loadsdetails.loadData.recurrent_load_status == \'False\'\">{{\'loads:details:recurrent:options:no\' | translate}}</p></div><div class=\"col-12 col-sm-6 parrafo\"><label>{{\'loads:details:frecuency:title\' | translate}}</label><p ng-if=loadsdetails.loadData.recurrent.name>{{loadsdetails.loadData.recurrent.name}}</p></div></div><div class=row><div class=\"col-12 col-sm-6 parrafo\"><label>{{\'loads:details:commodity:title\' | translate}}</label><p ng-if=loadsdetails.loadData.commodity[0]>{{loadsdetails.loadData.commodity[0].type_commodity}}</p></div></div><div class=row permission permission-only=\"[\'CARRIER\',\'OWNER\']\"><div class=\"col-12 col-sm-6 parrafo\"><label>{{\'loads:details:fast_pay_status:title\' | translate}}</label><p ng-if=\"loadsdetails.loadData.status_factoring == 0\">{{\'loads:details:fast_pay_status:options:not_applied\' | translate}}Not applied</p><p ng-if=\"loadsdetails.loadData.status_factoring == 1\">{{\'loads:details:fast_pay_status:options:applied\' | translate}}Applied</p></div><div ng-if=\"!loadsdetails.loadingDataDetails && loadsdetails.loadData.status_loads !=\'NOT_ASSIGNED\' && loadsdetails.loadData.info_truck != 0\" class=\"col-12 col-sm-6 parrafo\"><label>{{\'loads:details:truck_assigned:title\' | translate}}</label><br><a ng-click=loadsdetails.openTruckAssignedInfoModal() class=\"small-text normal-link pointer\">{{loadsdetails.loadData.info_truck.brand}} {{loadsdetails.loadData.info_truck.model}}</a></div><div ng-if=\"!loadsdetails.loadingDataDetails && loadsdetails.loadData.status_loads !=\'NOT_ASSIGNED\' && loadsdetails.loadData.status_loads !=\'CANCELADA\' && loadsdetails.loadData.info_truck == 0\" class=\"col-12 col-sm-6 parrafo\"><label>{{\'loads:details:truck_assigned:title\' | translate}}</label><br><a ng-click=loadsdetails.openChooseTruckModal() class=\"small-text normal-link pointer\">{{\'loads:details:truck_assigned:choose_truck:text\' | translate}}</a></div></div><div class=row><div ng-if=\"!loadsdetails.loadingDataDetails && loadsdetails.loadData.status_loads !=\'NOT_ASSIGNED\' && loadsdetails.loadData.info_truck != 0 && loadsdetails.loadData.info_truck.driver\" class=\"col-12 col-sm-6 parrafo\"><label>{{\'loads:details:driver:phone_contact\' | translate}}</label><br><p><a ng-href=tel:{{loadsdetails.loadData.info_truck.driver.user.user_phone}} class=\"small-text normal-link\">{{loadsdetails.loadData.info_truck.driver.user.user_phone}}</a></p></div><div permission permission-only=\"\'GENERADOR_CARGA\'\" ng-if=\"!loadsdetails.loadingDataDetails && loadsdetails.loadData.status_loads ==\'NOT_ASSIGNED\'\" class=\"col-12 col-sm-6 parrafo\"><a ng-if=\"loadsdetails.loadData.request_carriers == 0\" ng-click=loadsdetails.openCarrierRequestModal() class=\"small-text normal-link pointer\">{{\'loads:details:carrier_requests:title\' | translate}} ({{loadsdetails.loadData.request_carriers}})</a> <a ng-if=\"loadsdetails.loadData.request_carriers != 0\" ng-click=loadsdetails.openCarrierRequestModal() class=\"small-text normal-link color-pastel-red pointer\">{{\'loads:details:carrier_requests:title\' | translate}} ({{loadsdetails.loadData.request_carriers}})</a></div><div ng-if=\"!loadsdetails.loadingDataDetails && (loadsdetails.loadData.status_loads ==\'ACEPTADA\' || loadsdetails.loadData.status_loads ==\'EN_TRANSITO\' || loadsdetails.loadData.status_loads ==\'ENTREGADA\') && loadsdetails.loadData.history_load\" class=\"col-12 col-sm-6 parrafo\"><label>{{\'loads:details:see_activity:title\' | translate}}</label><br><a ng-click=loadsdetails.openLoadActivityInfoModal() class=\"small-text normal-link pointer\">{{\'loads:details:see_activity:link:title\' | translate}}</a></div></div><div permission permission-only=\"[\'CARRIER\', \'GENERADOR_CARGA\', \'OWNER\']\" ng-if=\"(loadsdetails.loadData.status_loads == \'PAGADA\' || loadsdetails.loadData.status_loads == \'ENTREGADA\') && loadsdetails.loadData.info_payment.length\" class=row><div class=\"col-12 col-sm-6 parrafo\"><label>{{\'loads:details:payment_day:title\' | translate }}</label><p>{{loadsdetails.loadData.info_payment[0].payment_day}}</p></div><div class=\"col-12 col-sm-6 parrafo\"><label>{{\'loads:details:payment_date:title\' | translate }}</label><p>{{loadsdetails.loadData.info_payment[0].payment_date | amDateFormat:\'MMM DD YYYY\'}}</p></div></div><div permission permission-only=\"[\'CARRIER\', \'GENERADOR_CARGA\', \'OWNER\']\" ng-if=\"(loadsdetails.loadData.status_loads == \'PAGADA\' || loadsdetails.loadData.status_loads == \'ENTREGADA\') && loadsdetails.loadData.info_payment.length\" class=row><div class=\"col-12 col-sm-6 parrafo\"><label>{{\'loads:details:payment_amount:title\' | translate }}</label><p>{{loadsdetails.loadData.info_payment[0].ammount}}</p></div><div class=\"col-12 col-sm-6 parrafo\"><label>{{\'loads:details:payment_transfered:title\' | translate }}</label><p>{{loadsdetails.loadData.info_payment[0].transfered}}</p></div></div><div permission permission-only=\"[\'CARRIER\', \'GENERADOR_CARGA\', \'OWNER\']\" ng-if=\"(loadsdetails.loadData.status_loads == \'PAGADA\' || loadsdetails.loadData.status_loads == \'ENTREGADA\') && loadsdetails.loadData.info_payment.length\" class=row><div class=\"col-12 col-sm-6 parrafo\"><label>{{\'loads:details:payment_percentage:title\' | translate }}</label><p>{{loadsdetails.loadData.info_payment[0].payment_percentage}}</p></div></div><div ng-if=loadsdetails.loadData.info_load_generator.phone_company class=row><div class=\"col-12 col-sm-6 parrafo\"><label>{{\'loads:details:contactinfo:title\' | translate }}</label><p><a ng-href=tel:{{loadsdetails.loadData.info_load_generator.phone_company}} class=\"small-text normal-link\">{{loadsdetails.loadData.info_load_generator.phone_company}}</a></p></div></div><div class=row><div class=\"col-12 parrafo\"><label>{{\'loads:details:comments:title\' | translate }}</label><p>{{loadsdetails.loadData.comments}}</p></div></div><div ng-if=\"(loadsdetails.loadData.carrier.user_id && loadsdetails.loadData.carrier.user_id == loadsdetails.myData.user_id)\n							|| (loadsdetails.loadData.info_load_generator.user_id && loadsdetails.loadData.info_load_generator.user_id == loadsdetails.myData.user_id)\n							|| (loadsdetails.loadData.info_truck.truck_driver && loadsdetails.loadData.info_truck.truck_driver == loadsdetails.myData.user_id)\" class=row><div class=\"col-12 parrafo\"><label>{{ \'loads:details:documents:title\' | translate }}</label><p>{{ \'loads:details:invoice:title\' | translate }}</p><p ng-if=\"!loadsdetails.loadInvoiceImgFilesList.length && !loadsdetails.loadInvoiceDocsFilesList.length\">{{ \'loads:details:documents:empty\' | translate }}</p><p ng-if=loadsdetails.loadInvoiceImgFilesList.length>{{ \'loads:details:documents:images\' | translate }}</p><div ng-if=loadsdetails.loadInvoiceImgFilesList.length ng-image-gallery images=loadsdetails.loadInvoiceImgFilesList></div><p ng-if=loadsdetails.loadInvoiceDocsFilesList.length>{{ \'loads:details:documents:docs\' | translate }}</p><ul ng-if=loadsdetails.loadInvoiceDocsFilesList.length class=\"nav documents-list\"><li class=\"nav-item parrafo\" ng-repeat=\"fileInvoice in loadsdetails.loadInvoiceDocsFilesList\"><md-tooltip md-direction=top>{{fileInvoice.invoice_name}}</md-tooltip><a href={{fileInvoice.url}} target=_blank><span alt={{fileInvoice.title}} class=\"fa fa-file-pdf-o\"></span><br><span>{{fileInvoice.invoice_name | limitTo : 15}}</span></a></li></ul><p>{{ \'loads:details:legal_docs:title\' | translate }}</p><p ng-if=\"!loadsdetails.loadLegalImgFilesList.length && !loadsdetails.loadLegalDocsFilesList.length\">{{ \'loads:details:documents:empty\' | translate }}</p><div ng-if=loadsdetails.loadLegalImgFilesList.length ng-image-gallery images=loadsdetails.loadLegalImgFilesList></div><p ng-if=loadsdetails.loadLegalDocsFilesList.length>{{ \'loads:details:documents:docs\' | translate }}</p><ul ng-if=loadsdetails.loadLegalDocsFilesList.length class=\"nav documents-list\"><li class=\"nav-item parrafo\" ng-repeat=\"fileLegal in loadsdetails.loadLegalDocsFilesList\"><md-tooltip md-direction=top>{{fileLegal.invoice_name}}</md-tooltip><a href={{fileLegal.url}} target=_blank><span alt={{fileLegal.title}} class=\"fa fa-file-pdf-o\"></span><br><span>{{fileLegal.invoice_name | limitTo : 15}}</span></a></li></ul><br><br><button permission permission-only=\"\'GENERADOR_CARGA\'\" ng-if=\"loadsdetails.loadData.status_loads !=\'PAGADA\'\" ng-disabled=loadsdetails.legalDocFileSaving ngf-select=\"loadsdetails.uploadLegalDoc($file, $invalidFiles)\" ngf-accept=\"\'image/jpg, image/jpeg, application/pdf\'\" class=\"btn btn-class2 bg-color-9 color-black\"><main-loader ng-if=loadsdetails.legalDocFileSaving></main-loader><span ng-show=!loadsdetails.legalDocFileSaving>{{ \'loads::add:form:upload_doc:btn\' | translate }}</span></button> <button permission permission-only=\"[\'CARRIER\',\'OWNER\']\" ng-if=\"loadsdetails.loadData.carrier.user_id && loadsdetails.loadData.carrier.user_id == loadsdetails.myData.user_id\" ng-disabled=loadsdetails.legalDocFileSaving ngf-select=\"loadsdetails.uploadLegalDoc($file, $invalidFiles)\" ngf-accept=\"\'image/jpg, image/jpeg, application/pdf\'\" class=\"btn btn-class2 bg-color-9 color-black\"><main-loader ng-if=loadsdetails.legalDocFileSaving></main-loader><span ng-show=!loadsdetails.legalDocFileSaving>{{ \'loads::add:form:upload_doc:btn\' | translate }}</span></button></div></div></div></div><div class=\"col-12 col-sm-6\"><div class=\"full-width text-right parrafo\"><a ui-sref=private.loads() ui-sref-opts={} class=\"normal-link color-black\"><span class=\"fa fa-arrow-left\"></span> {{ \'loads:details:options:comeback\' | translate }}</a></div><div class=\"full-width loads-map-detail parrafo\" ng-if=\"!loadsdetails.loadingDataDetails && loadsdetails.loadData.load_id\"><div ng-if=!loadsdetails.loadingMap><ui-gmap-google-map center=loadsdetails.map.center zoom=loadsdetails.map.zoom><ui-gmap-marker ng-repeat=\"m in loadsdetails.markers\" coords=m.coords idkey=m.id options=m.options></ui-gmap-marker></ui-gmap-google-map></div></div><div class=\"full-width text-center parrafo\"><div class=row><div class=\"col mt-2\"><b>{{\'loads:details:map:conversions:title\' | translate}}</b></div><div class=\"col mt-1\" style=\"font-size: 11px\"><img src=assets/images/common/start_point.png class=\"pull-l parrafo\" width=30 border=0> {{\'loads:details:map:start_point:explanation\' | translate}}</div><div class=\"col mt-1\" style=\"font-size: 11px\"><img src=assets/images/common/end_point.png class=\"pull-l parrafo\" width=30 border=0> {{\'loads:details:map:end_point:explanation\' | translate}}</div><div class=\"col mt-1\" style=\"font-size: 11px\"><img src=assets/images/common/point_1.png class=\"pull-l parrafo\" width=30 border=0> {{\'loads:details:map:stop:explanation\' | translate}}</div></div></div><div class=\"full-width text-center\" ng-hide=\"loadsdetails.userData.user_status == \'0\'\"><button ng-if=\"!loadsdetails.loadingDataDetails && loadsdetails.loadData.status_loads ==\'NOT_ASSIGNED\' && loadsdetails.loadData.owner_request_carriers == 0 && posteverywhere != \'1\'\" permission permission-only=\"[\'CARRIER\',\'OWNER\']\" type=button permission ng-show=\"loadsdetails.search_type == \'for_me\'\" permission-only=\"[\'CARRIER\', \'OWNER\']\" ng-click=openChooseTruckModal() class=\"btn btn-class1 bg-color-9 color-black parrafo\">{{ \'loads:details:accept:btn\' | translate }}</button> <button ng-if=\"!loadsdetails.loadingLoadData && loadsdetails.loadData.status_loads ==\'NOT_ASSIGNED\' && loadsdetails.loadData.owner_request_carriers == 0 && posteverywhere != \'1\'\" type=button permission ng-hide=\"loadsdetails.search_type == \'for_me\'\" permission-only=\"[\'CARRIER\', \'OWNER\']\" ng-click=createRequestCarrierLoad() class=\"btn btn-class1 bg-color-9 color-black parrafo\">{{ \'loads:details:apply:btn\' | translate }}</button> <button ng-if=\"!loadsdetails.loadingLoadData && loadsdetails.loadData.status_loads !=\'NOT_ASSIGNED\' && loadsdetails.loadData.owner_request_carriers == 0 && posteverywhere != \'1\'\" permission permission-only=\"[\'CARRIER\',\'OWNER\']\" type=button ng-click=loadsdetails.rejectTmsRequest() class=\"btn btn-class1 bg-color-4 color-black parrafo\">{{ \'loads:details:notapply:btn\'| translate }}</button> <button ng-if=\"!loadsdetails.loadingDataDetails && loadsdetails.loadData.status_loads ==\'NOT_ASSIGNED\' && loadsdetails.loadData.owner_request_carriers == \'1\' && posteverywhere != \'1\'\" permission permission-only=\"[\'CARRIER\',\'OWNER\']\" ng-click=loadsdetails.cancelRequestCarrierLoad() class=\"btn btn-class1 bg-color-4 color-white parrafo\">{{ \'loads:details:notapply:btn\' | translate }}</button><br><a ng-if=\"!loadsdetails.loadingDataDetails && loadsdetails.loadData.load_id\" permission permission-only=\"[\'CARRIER\',\'OWNER\']\" ng-click=loadsdetails.openReportIssuesLoadModal() class=\"small-text normal-link\">{{ \'loads:details:report_suspect:text\' | translate }}</a></div></div></div>");
$templateCache.put("app/loads/templates/tabs/tab-stop.html","<div class=col-sm-12><div class=\"full-width text-right parrafo\"><a ui-sref=private.loads() ui-sref-opts={} class=\"normal-link color-black\"><span class=\"fa fa-arrow-left\"></span> {{ \'loads:details:options:comeback\' | translate }}</a></div><div class=\"full-width content-tableData\"><table datatable=\"\" class=\"tableDataSort table\" width=100% border=0><thead class=text-center><th>id</th><th>Direccion</th><th>Logitud</th><th>Latitud</th><th>Status</th><th>Acciones</th></thead><tbody><tr data-ng-show=\"items.length < 1\"><td class=text-center colspan=13><br><h4>Ningún Registro Encontrado</h4></td></tr><tr ng-repeat-start=\"item in items\"><td><br>{{$index + 1}}<br></td><td>{{(item.address != null)? item.address.description : \"Sin Informacion\"}}</td><td>{{(item.address != null)? item.address.latitude: \"Sin Informacion\"}}</td><td>{{(item.address != null)? item.address.longitude: \"Sin Informacion\"}}</td><td>{{item.status}}</td><td><span class=\"fa fa-angle-down\" ng-click=displayForms(false) ng-hide=evince[item.id]></span> <span class=\"fa fa-angle-up\" ng-click=displayForms(true) ng-hide=!evince[item.id]></span></td></tr><tr ng-repeat-end><td ng-show=evince[item.id] colspan=6 style=\"background: #fafafa\"><br><br><div ng-include=\"\'app/loads/templates/tabs/make-forms.html\'\"></div><br><br></td></tr></tbody></table><div class=text-center><!--<pagination on-change=\"loads.changePage(page)\" list=\"{{ {page: loads.loads.current_page,total: loads.loads.total_pages} }}\"></pagination>--></div></div></div>");
$templateCache.put("app/loads/v2/templates/load-basic.html","");
$templateCache.put("app/loads/v2/templates/load-technical.html","");
$templateCache.put("app/loads/v2/templates/load-type.html","<!DOCTYPE html><html lang=en><head><meta charset=UTF-8><title>$Title$</title></head><body>$END$</body></html>");
$templateCache.put("app/loads/v2/templates/load.html","<div id=page-section-post-load class=\"page-section page-section-with-margin col bg-color-white\" ng-controller=\"LoadsAddController as loadsadd\" ng-init=initialize()><h3 class=\"large-title title-section\">{{ \'loads:add:section:title\' | translate }}</h3><form method=post id=postLoadFormId name=postLoadFormName ng-submit=loadsadd.save(postLoadFormName) novalidate><div class=row><div class=\"col-12 col-sm-9\"><hr><div ng-include=\"\'app/loads/templates/load-basic.html\'\"></div><hr><div ng-include=\"\'app/loads/templates/load-technical.html\'\"></div><hr><div ng-include=\"\'app/loads/templates/load-type.html\'\"></div></div><div class=\"col-12 col-sm-3\"></div></div><div class=\"row main-botonera\"><div class=\"col-12 col-sm-9\"><button ng-disabled=loadsadd.savingNewLoad type=submit class=\"btn btn-class1 bg-color-9 color-black\">{{ \'loads:add:form:btn:save_post_next\' | translate }}</button> <a ng-disabled=loadsadd.savingNewLoad ng-click=loadsadd.submitReturnListFunc(postLoadFormName) class=\"normal-link color-black small-text\">{{ \'loads:add:form:btn:save_return_list\' | translate }}</a></div><div class=\"col-12 col-sm-3 text-right\"><a ng-if=!loadsadd.savingNewLoad ui-sref=private.loads ui-sref-opts=\"{ reload: true }\" class=\"normal-link color-black small-text cancel-post-link\">{{ \'loads:add:form:btn:cancel\' | translate }}</a></div></div></form></div>");
$templateCache.put("app/main/templates/directives/app-aside.html","<div class=\"menu-asside hidden-sm-down\"><ul class=\"nav flex-column\"><li class=nav-item ui-sref-active=active><a class=\"nav-link color-black\" ui-sref=private.home ui-sref-opts=\"{ reload: true }\"><img src=assets/images/menu/home.png class=menu-icon border=0> {{\"aside:left:menu:home\" | translate}}</a></li><li class=nav-item ui-sref-active=active><a class=\"nav-link color-black\" ui-sref=private.loads ui-sref-opts=\"{ reload: true }\"><img src=assets/images/menu/shipment-package.png class=menu-icon border=0> {{\"aside:left:menu:loads\" | translate}}</a></li><li class=nav-item ui-sref-active=active ng-hide=\"profile == \'driver\'\"><a class=\"nav-link color-black\" ui-sref=private.metrics ui-sref-opts=\"{ reload: true }\"><img src=assets/images/menu/metrics.png class=menu-icon border=0> {{\"aside:left:menu:metrics\" | translate}}</a></li><div ng-if=\"me.user_status === 1\"><li class=nav-item ui-sref-active=active><a class=\"nav-link color-black\" ui-sref=private.loadslog ui-sref-opts=\"{ reload: true }\"><img src=assets/images/menu/time-clock-circle.png class=menu-icon border=0> {{\"aside:left:menu:loads_log\" | translate}}</a></li><li permission permission-only=\"\'GENERADOR_CARGA\'\" class=nav-item ng-class=\"{\'active\': carriersActive}\"><a class=\"nav-link color-black\" ui-sref=private.carriers ui-sref-opts=\"{ reload: true }\"><img src=assets/images/menu/delivery-truck.png class=menu-icon border=0> {{\"aside:left:menu:carriers\" | translate}}</a></li><li permission permission-only=\"[\'CARRIER\', \'OWNER\']\" class=nav-item ui-sref-active=active><a class=\"nav-link color-black\" ui-sref=private.trucks ui-sref-opts=\"{ reload: true }\"><img src=assets/images/menu/delivery-truck.png class=menu-icon border=0> {{\"aside:left:menu:trucks\" | translate}}</a></li><li permission permission-only=\"[\'CARRIER\', \'OWNER\']\" class=nav-item ui-sref-active=active><a class=\"nav-link color-black\" ui-sref=private.trailers ui-sref-opts=\"{ reload: true }\"><img src=assets/images/menu/trailers.png class=menu-icon border=0> {{\"aside:left:menu:trailers\" | translate}}</a></li><li permission permission-only=\"[\'CARRIER\', \'OWNER\']\" class=nav-item ui-sref-active=active><a class=\"nav-link color-black\" ui-sref=private.drivers ui-sref-opts=\"{ reload: true }\"><span class=\"fa fa-users\"></span> {{\"aside:left:menu:drivers\" | translate}}</a></li><li permission permission-only=\"[\'CARRIER\', \'OWNER\']\" class=nav-item ui-sref-active=active><a class=\"nav-link color-black\" ui-sref=private.fast_pay ui-sref-opts=\"{ reload: true }\"><img src=assets/images/menu/currency-dollar-circle.png class=menu-icon border=0> {{\"aside:left:menu:fast_pay\" | translate}}</a></li><li permission permission-only=\"[\'CARRIER\', \'DRIVER\', \'OWNER\']\" class=nav-item ui-sref-active=active><a class=\"nav-link color-black\" ui-sref=private.interest_points ui-sref-opts=\"{ reload: true }\"><img src=assets/images/menu/flag-plain.png class=menu-icon border=0> {{\"aside:left:menu:interest_points\" | translate}}</a></li><li class=nav-item ui-sref-active=active><a class=\"nav-link color-black\" ui-sref=private.notification_settings ui-sref-opts=\"{ reload: true }\"><img src=assets/images/menu/settings.png class=menu-icon border=0> {{\"aside:left:menu:settings\" | translate}}</a></li><li class=nav-item ui-sref-active=active><a class=\"nav-link color-black\" ui-sref=private.help ui-sref-opts=\"{ reload: true }\"><img src=assets/images/menu/information-circle.png class=menu-icon border=0> {{\"aside:left:menu:help\" | translate}}</a></li></div></ul></div>");
$templateCache.put("app/main/templates/directives/app-header.html","<nav class=\"navbar fixed-top navbar-toggleable-sm navbar-light bg-faded\"><button class=\"navbar-toggler navbar-toggler-right\" type=button data-toggle=collapse data-target=#navbarUserOptions aria-controls=navbarUserOptions aria-expanded=false aria-label=\"Toggle navigation\"><span class=navbar-toggler-icon></span></button> <a class=navbar-brand ui-sref=private.home ui-sref-opts=\"{ reload: true }\"><img src=assets/images/common/logo.png class=\"d-inline-block align-middle\" alt=\"\"></a><div class=\"collapse navbar-collapse\" id=navbarUserOptions><div class=\"col-md-6 no-padding\"><form class=\"form-inline my-2 my-lg-0 form-main-search\"><div class=input-group><span class=input-group-addon><button class=\"btn btn-image\"><i class=\"fa fa-search\"></i></button> </span><input permission permission-only=\"\'GENERADOR_CARGA\'\" type=text class=form-control placeholder=\"{{\'header:search:input:shipper\' | translate}}\" ng-click=openSearchCarriersModal()> <input permission permission-only=\"[\'CARRIER\', \'DRIVER\', \'OWNER\']\" type=text class=form-control placeholder=\"{{\'header:search:input:carrier\' | translate}}\" ng-click=openSearchLoadsModal()></div></form></div><ul class=\"navbar-nav ml-auto\"><li class=\"nav-item notify-header-item dropdown hidden-sm-down\"><a class=\"nav-link dropdown-toggle\" href=# id=navbarDropdownInviteJoinPanel data-toggle=dropdown aria-haspopup=true aria-expanded=false><span class=info-badge></span> <span class=\"fa fa-heart\"></span></a><div class=\"dropdown-menu dropdown-menu-right invite-join-panel\" aria-labelledby=navbarDropdownInviteJoinPanel><invite-join type=\"\"></invite-join></div></li><li class=\"nav-item notify-header-item hidden-md-up\"><a class=nav-link ui-sref=private.invite_join ui-sref-opts=\"{ reload: true }\"><span class=info-badge></span> <span class=\"fa fa-heart\"></span></a></li><li id=notify-header-item-dropdown class=\"nav-item notify-header-item dropdown hidden-sm-down\"><a ng-click=setReadNotifications() class=\"nav-link dropdown-toggle\" href=# id=navbarDropdownNotificationPanel data-toggle=dropdown aria-haspopup=true aria-expanded=false><span class=info-badge>{{notificationsCount}}</span> <span class=\"fa fa-bell-o\"></span></a><div class=\"dropdown-menu dropdown-menu-right notification-list\" aria-labelledby=navbarDropdownNotificationPanel><notification-list list-type=notificationTypeList></notification-list></div></li><li class=\"nav-item notify-header-item hidden-md-up\"><a class=nav-link ui-sref=private.notifications ui-sref-opts=\"{ reload: true }\"><span class=info-badge>{{notificationsCount}}</span> <span class=\"fa fa-bell-o\"></span></a></li><li class=\"nav-item dropdown\"><a class=\"nav-link color-black dropdown-toggle\" id=navbarDropdownUserOpt data-toggle=dropdown aria-haspopup=true aria-expanded=false>{{user.user_first_name | capitalize }} {{user.user_last_name | capitalize }} <i class=\"fa fa-angle-down\"></i></a><div class=\"dropdown-menu dropdown-menu-right user-options-dropdown\" aria-labelledby=navbarDropdownUserOpt><div class=col><div class=row><div class=col-3><div class=row><img ng-if=\"!user.img_perfil_imagenes || user.img_perfil_imagenes.length == 0\" src=assets/images/common/profile_pic.png class=\"img-fluid rounded-circle\"> <img ng-if=\"user.img_perfil_imagenes && user.img_perfil_imagenes.length > 0\" ng-src=\"{{user.img_perfil_imagenes[0][\'imagen-180\']}}\" class=\"img-fluid rounded-circle\"></div></div><div class=col-9><p class=user-name>{{user.user_first_name | capitalize }} {{user.user_last_name | capitalize }}</p><p class=user-email>{{user.user_email}}</p><p class=\"user-profile uppercase-text\" ng-if=userDataProfile>{{ \'header:profile:\'+ profile +\':title\' | translate }}</p><br><button ng-click=goToProfile() class=\"btn btn-class2 bg-color-9 color-black\" style=margin-bottom:20px>{{ \'header:view_profile:btn\' | translate }}</button></div></div></div><hr><div class=\"col option-list\"><!--<a href=\"#\" class=\"link-opt-lst1\">{{ \'header:user:menu_options:terms\' | translate }}</a>\n	    				<a href=\"#\" class=\"link-opt-lst1\">{{ \'header:user:menu_options:faqs\' | translate }}</a>--> <a ng-click=logout() class=\"link-opt-lst2 color-pastel-red\">{{ \'header:user:menu_options:sign_out\' | translate }}</a></div></div></li></ul></div></nav>");
$templateCache.put("app/main/templates/directives/invite-join.html","<div><h4 class=\"title-section text-center\">{{ \'header:invite_join:title\' | translate }}</h4><p class=\"descrip-section small-text text-center\">{{ \'header:invite_join:descrip\' | translate }}</p><div ng-if=false class=\"full-width text-center\"><a ng-click=shareFacebook() class=\"inline-block social-share-icon\"><img src=assets/images/common/facebook.png border=0> </a><a ng-click=shareTwitter() class=\"inline-block social-share-icon\"><img src=assets/images/common/twitter.png border=0></a></div><div class=\"row justify-content-center\"><div class=col-8><form method=post id=inviteJoinFormId name=inviteJoinFormName ng-submit=sendMailInvitation(inviteJoinFormName) novalidate><div class=form-group><input type=text ng-model=dataSend.emailsString name=emails_share class=form-control placeholder=\"Enter emails (commas separate)\" required></div><div class=\"form-group text-center\"><button type=submit class=\"btn btn-class1 bg-color-9 color-black\">{{ \'header:invite_join:mail:btn\' | translate }}</button></div></form></div></div></div>");
$templateCache.put("app/main/templates/directives/main-loader.html","<div class=\"full-width text-center\"><img src=assets/images/common/loader-loads-app.gif class=loader-img alt=\"\"></div>");
$templateCache.put("app/main/templates/directives/metrics.html","<!-- Styles --><style>.chart {\n    width: 80%;\n    height: 350px;\n  }</style><!-- HTML --><div class=\"col data-count-loads hidden-sm-down bg-color-white\" ng-hide=\"profile == \'DRIVER\'\"><div class=row><div class=col-md-5><div class=input-group><input date-range-picker=t1 type=text class=\"form-control date-picker\" ng-model=betweenDate options=option placeholder=\"Seleccione rango de fechas\"> <span class=\"input-group-addon primary-button\"><i class=\"fa fa-calendar\" aria-hidden=true></i></span></div></div></div><br><br><div class=row ng-hide=\"profile == \'CARRIER\'\"><div class=col-sm-12><ul class=nav><li class=nav-item><div class=data-load-circle><div class=data-load-circle-inter><span>{{totalPublished}}</span></div></div><p class=item-data-load-name>{{ \'metrics:status:total:published\' | translate }}</p></li></ul></div></div><div class=row><div class=col-md-6><h5>{{\"metrics:title:assigned\" | translate}}: {{assigned}}%</h5><div class=chart id=chartdiv></div></div><div class=col-md-6><h5>{{\"metrics:title:delivered\" | translate}}: {{delivered}}%</h5><div class=chart id=chart2div></div></div><div class=col-md-6><h5>{{\"metrics:title:cancelled\" | translate}}: {{cancelled}}%</h5><div class=chart id=chart3div></div></div><div class=col-md-6><h5>{{\"metrics:title:pod\" | translate}}: {{pod}}%</h5><div class=chart id=chart4div></div></div></div></div>");
$templateCache.put("app/main/templates/directives/notification-list.html","<div><h3 class=\"title-section inline-block\">Notifications</h3><a ui-sref=private.notification_settings ui-sref-opts=\"{ reload: true }\" class=\"pull-r notification-settings-link\"><span class=\"fa fa-cog\"></span></a><div class=clearfix></div><ul ng-if=\"listType == \'page\'\" class=\"nav flex-column\"><li class=nav-item><a ui-sref=\"private.loads.details({id: notification.loads_id})\" ui-sref-opts=\"{ id: notification.loads_id }\" ng-repeat=\"notification in notificationList\"><div class=read-status-notification><div class=badge ng-class=\"{active: notification.is_read == \'N\' }\">1</div></div><div class=text-notification><p>{{notification.text_notification_action}}</p></div><div class=date-notification><p am-time-ago=notification.timecreate></p></div></a></li></ul><div class=notification-content-scroll ng-if=\"listType == \'widget\'\"><a class=dropdown-item ui-sref=\"private.loads.details({id: notification.loads_id})\" ui-sref-opts=\"{ id: notification.loads_id }\" ng-repeat=\"notification in notificationList\"><div class=read-status-notification><div class=badge ng-class=\"{active: notification.is_read == \'N\' }\">1</div></div><div class=text-notification><p>{{notification.text_notification_action}}</p></div><div class=date-notification><p am-time-ago=notification.timecreate></p></div></a><div id=loader-notifications><main-loader ng-if=\"totalPages > currentPage\"></main-loader></div></div></div>");
$templateCache.put("app/main/templates/directives/total-items.html","<div class=\"col data-count-loads hidden-sm-down bg-color-white\"><ul class=nav><li class=nav-item><div class=data-load-circle><div class=data-load-circle-inter><span ng-if=loadingItemsData>0</span> <span ng-if=!loadingItemsData>{{totalItems.current_loads}}</span></div></div><p class=item-data-load-name>{{ \'home:total_items:current_loads:title\' | translate }}</p></li><li class=nav-item><div class=\"data-load-circle border-color-bright-turquoise\"><div class=data-load-circle-inter><span ng-if=loadingItemsData>0</span> <span ng-if=!loadingItemsData>{{totalItems.pending_assign}}</span></div></div><p class=item-data-load-name>{{ \'home:total_items:pending_assign:title\' | translate }}</p></li><li class=nav-item><div class=\"data-load-circle border-color-pastel-red\"><div class=data-load-circle-inter><span ng-if=loadingItemsData>0</span> <span ng-if=!loadingItemsData>{{totalItems.posted_loads}}</span></div></div><p class=item-data-load-name>{{ \'home:total_items:posted_loads:title\' | translate }}</p></li><li class=nav-item><div class=\"data-load-circle border-color-purple\"><div class=data-load-circle-inter><span ng-if=loadingItemsData>0</span> <span ng-if=!loadingItemsData>{{totalItems.available_trucks}}</span></div></div><p class=item-data-load-name>{{ \'home:total_items:available_trucks:title\' | translate }}</p></li><li class=nav-item><div class=\"data-load-circle border-color-blue-king\"><div class=data-load-circle-inter><span ng-if=loadingItemsData>0</span> <span ng-if=!loadingItemsData>{{totalItems.all_loads}}</span></div></div><p class=item-data-load-name>{{ \'home:total_items:all_loads:title\' | translate }}</p></li></ul></div>");
$templateCache.put("app/main/templates/layouts/private.html","<div class=\"main-scheme container-table\"><!-- header --><app-header></app-header><app-aside></app-aside><!-- menu asside --><div class=contain-page-section ui-view=container></div></div>");
$templateCache.put("app/main/templates/layouts/public.html","<div id=container_login class=container-table><div id=container-row class=\"row full-height\" ui-view=container></div></div>");
$templateCache.put("app/main/templates/modal/search-carrier.html","<div class=modal-body id=carrier-search-modal><h3 class=\"title-modal text-left\">{{ \'modals:search_carrier:title\' | translate }}</h3><form novalidate><div class=form-group><div class=row><div class=col-12><label class=title-field>{{ \'modals:search_carrier:fields:company:title\' | translate }}</label><input id=company ng-model=searchcarrier.searchData.company name=company type=text placeholder=\"\" class=\"form-control input-md\" required></div></div></div><div class=form-group><div class=row><div class=\"col-12 col-sm-8\"><label class=title-field>{{ \'modals:search_carrier:fields:trailer_type:title\' | translate }}</label><select name=trailer_type id=trailer_type ng-model=searchcarrier.searchData.trailer_type class=\"form-control input-md\"><option ng-repeat=\"option in searchcarrier.itemsSizeLenLoads.Trucktypes_list\" value={{option.id}}>{{option.truck_type_name}}</option></select></div><div class=\"col-12 col-sm-4\"><label class=title-field>{{ \'modals:search_carrier:fields:length:title\' | translate }}</label><input type=number name=length class=form-control ng-model=searchcarrier.searchData.len placeholder=\"\"></div></div></div><div class=form-group><div class=\"row align-items-center\"><div class=\"col-12 col-sm-4\"><label class=title-field>{{ \'modals:search_carrier:fields:weight:title\' | translate }}</label><input type=number name=wei class=form-control ng-model=searchcarrier.searchData.wei placeholder=\"\"></div><div class=\"col-12 col-sm-4\"><label class=title-field>{{ \'modals:search_carrier:fields:size:title\' | translate }}</label><select name=size id=size ng-model=searchcarrier.searchData.size class=\"form-control input-md\"><option ng-repeat=\"option in searchcarrier.itemsSizeLenLoads.TruckCapacity_list\" value={{option.id}}>{{option.capacity_name}}</option></select></div></div></div><div class=form-group><div class=\"row align-items-center\"><div class=col-12><label class=title-field>{{ \'modals:search_carrier:fields:skills:title\' | translate }}</label><ul class=list-checks><li ng-repeat=\"skill in searchcarrier.skillList\"><input type=checkbox id={{skill.name}} name={{skill.name}} ng-model=skill.checked class=custom-checkbox><label for={{skill.name}}><span></span>{{skill.name}}</label></li></ul></div></div></div><div class=form-group><div class=\"row align-items-center\"><div class=\"col-12 col-sm-8\"><label class=title-field>{{ \'modals:search_load:fields:review:title\' | translate }}</label><div class=clearfix></div><ul class=\"nav reviews-calification\"><li class=nav-item><span ng-class=\"{\'fa-star\': hover1 || hover2 || hover3 || hover4 || hover5 || searchcarrier.searchData.reviews >= 1, \'fa-star-o\': !hover1 && !hover2 && !hover3 && !hover4 && !hover5 && searchcarrier.searchData.reviews < 1}\" ng-init=\"hover1 = false\" ng-mouseenter=\"hover1 = true\" ng-mouseleave=\"hover1 = false\" ng-click=\"searchcarrier.setReview(\'1\')\" class=fa></span></li><li class=nav-item><span ng-class=\"{\'fa-star\': hover2 || hover3 || hover4 || hover5 || searchcarrier.searchData.reviews >= 2, \'fa-star-o\': !hover2 && !hover3 && !hover4 && !hover5 && searchcarrier.searchData.reviews < 2}\" ng-init=\"hover2 = false\" ng-mouseenter=\"hover2 = true\" ng-mouseleave=\"hover2 = false\" ng-click=\"searchcarrier.setReview(\'2\')\" class=fa></span></li><li class=nav-item><span ng-class=\"{\'fa-star\': hover3 || hover4 || hover5 || searchcarrier.searchData.reviews >= 3, \'fa-star-o\': !hover3 && !hover4 && !hover5 && searchcarrier.searchData.reviews < 3}\" ng-init=\"hover3 = false\" ng-mouseenter=\"hover3 = true\" ng-mouseleave=\"hover3 = false\" ng-click=\"searchcarrier.setReview(\'3\')\" class=fa></span></li><li class=nav-item><span ng-class=\"{\'fa-star\': hover4 || hover5 || searchcarrier.searchData.reviews >= 4, \'fa-star-o\': !hover4 && !hover5 && searchcarrier.searchData.reviews < 4}\" ng-init=\"hover4 = false\" ng-mouseenter=\"hover4 = true\" ng-mouseleave=\"hover4 = false\" ng-click=\"searchcarrier.setReview(\'4\')\" class=fa></span></li><li class=nav-item><span ng-class=\"{\'fa-star\': hover5 || searchcarrier.searchData.reviews >= 5, \'fa-star-o\': !hover5 && searchcarrier.searchData.reviews < 5}\" ng-init=\"hover5 = false\" ng-mouseenter=\"hover5 = true\" ng-mouseleave=\"hover5 = false\" ng-click=\"searchcarrier.setReview(\'5\')\" class=fa></span></li><li class=nav-item><a ng-click=\"searchcarrier.setReview(\'0\')\" class=\"small-text normal-link load-search-lessf pointer\">Reset review</a></li></ul></div></div></div><div class=form-group><div class=\"row align-items-center justify-content-end\"><div class=\"col-12 col-sm-4\"><button ng-click=searchcarrier.resetDataFormSearch() class=\"btn btn-class1 bg-color-white color-black\" style=\"padding-left: 0; padding-right: 0\">{{ \'modals:search_carrier:reset_filters:btn\' | translate }}</button></div><div class=\"col-12 col-sm-4\"><button ng-click=searchcarrier.sendDataFormSearch() class=\"btn btn-class1 bg-color-9 color-black\">{{ \'modals:search_carrier:search:btn\' | translate }}</button></div></div></div></form></div>");
$templateCache.put("app/main/templates/modal/search-load.html","<div class=modal-body id=load-search-modal><h3 class=\"title-modal text-left\">{{ \'modals:search_load:title\' | translate }}</h3><form novalidate><div class=form-group><div class=row><div class=\"col-12 col-sm-6\"><label class=title-field>{{ \'modals:search_load:fields:from:title\' | translate }}</label>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; <span><input type=checkbox id=any_from name=any_from ng-model=searchload.from_any class=custom-checkbox ng-change=searchload.fromAnyChanged()><label for=any_from><span></span>{{ \'modals:search_load:fields:any:title\' | translate }}</label></span><input ng-disabled=searchload.from_any g-places-autocomplete force-selection=true id=from ng-model=searchload.searchData.fromObject name=from type=text placeholder=\"\" class=\"form-control input-md\" required></div><div class=\"col-12 col-sm-6\"><label class=title-field>{{ \'modals:search_load:fields:to:title\' | translate }}</label>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; <span><input type=checkbox id=any_to name=any_to ng-model=searchload.to_any class=custom-checkbox ng-change=searchload.toAnyChanged()><label for=any_to><span></span>{{ \'modals:search_load:fields:any:title\' | translate }}</label></span><input ng-disabled=searchload.to_any g-places-autocomplete force-selection=true id=from ng-model=searchload.searchData.toObject name=to type=text placeholder=\"\" class=\"form-control input-md\" required></div></div></div><div ng-if=searchload.advancedOptions class=form-group><div class=row><div class=\"col-12 col-sm-6\"><label class=title-field>{{ \'modals:search_load:fields:pricemin:title\' | translate }}</label>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; <span><input type=checkbox id=any_price name=any_price ng-model=searchload.price_any class=custom-checkbox ng-change=searchload.priceAnyChanged()><label for=any_price><span></span>{{ \'modals:search_load:fields:any:title\' | translate }}</label></span><input ng-disabled=searchload.price_any ng-blur=searchload.allowPriceMax() id=price_min ng-model=searchload.searchData.price_min name=price_min type=number placeholder=\"\" class=\"form-control input-md\" required></div><div class=\"col-12 col-sm-6\"><label class=title-field>{{ \'modals:search_load:fields:pricemax:title\' | translate }}</label><input ng-disabled=searchload.price_any ng-blur=searchload.allowPriceMax() ng-disabled=searchload.priceMaxDisabled type=number name=price_max class=form-control ng-model=searchload.searchData.price_max placeholder=\"\" min=searchload.searchData.price_min required></div></div></div><div ng-if=searchload.advancedOptions class=form-group><div class=row><div class=\"col-12 col-sm-6\"><label class=title-field>{{ \'modals:search_load:fields:size:title\' | translate }}</label><select name=size id=size ng-model=searchload.searchData.size class=\"form-control input-md\" ng-change=searchload.sizeConfigurationChange() required><option value=\"\">{{ \'loads:add:form:select:any\' | translate }}</option><option ng-repeat=\"option in searchload.itemsSizeLenLoads.LoadsSize_list\" value={{option.id}}>{{option.name}}</option></select></div><div ng-show=\"searchload.truckTypeConf == \'S\'\" class=\"col-12 col-sm-6\"><label class=title-field>{{ \'modals:search_load:fields:truck_type:title\' | translate }}</label><select name=truck_type id=truck_type ng-model=searchload.searchData.truck_type class=\"form-control input-md\" ng-change=searchload.truckTypeChange()><option value=\"\">{{ \'loads:add:form:select:any\' | translate }}</option><option ng-repeat=\"option in searchload.simpleTruckTypes\" value={{option.id}}>{{option.name}}</option></select></div><div ng-show=\"searchload.truckTypeConf == \'F\'\" class=\"col-12 col-sm-6\"><label class=title-field>{{ \'modals:search_load:fields:truck_type:title\' | translate }}</label><select name=truck_type id=truck_type ng-model=searchload.searchData.truck_type class=\"form-control input-md\" ng-change=searchload.truckTypeChange()><option value=\"\">{{ \'loads:add:form:select:any\' | translate }}</option><option ng-repeat=\"option in searchload.fullTruckTypes\" value={{option.id}}>{{option.name}}</option></select></div><div ng-show=\"searchload.truckTypeConf == \'NA\'\" class=\"col-12 col-sm-6\"><label class=title-field>{{ \'modals:search_load:fields:truck_type:title\' | translate }}</label><select name=truck_type id=truck_type ng-model=searchload.searchData.truck_type class=\"form-control input-md\" disabled><option value=\"\">{{ \'loads:add:form:select:any\' | translate }}</option></select></div></div></div><div ng-if=searchload.advancedOptions class=form-group><div class=row><div ng-show=\"searchload.lenghtType == \'S\'\" class=\"col-12 col-sm-6\"><label class=title-field>{{ \'modals:search_load:fields:length:title\' | translate }}</label><select name=length id=length ng-model=searchload.searchData.length class=\"form-control input-md\"><option value=\"\">{{ \'loads:add:form:select:any\' | translate }}</option><option ng-repeat=\"option in searchload.simpleLoadsLength\" value={{option.name}}>{{option.name}}</option></select></div><div ng-show=\"searchload.lenghtType == \'F\'\" class=\"col-12 col-sm-6\"><label class=title-field>{{ \'modals:search_load:fields:length:title\' | translate }}</label><select name=length id=length ng-model=searchload.searchData.length class=\"form-control input-md\"><option value=\"\">{{ \'loads:add:form:select:any\' | translate }}</option><option ng-repeat=\"option in searchload.fullLoadsLength\" value={{option.name}}>{{option.name}}</option></select></div><div ng-show=\"searchload.lenghtType == \'NA\'\" class=\"col-12 col-sm-6\"><label class=title-field>{{ \'modals:search_load:fields:length:title\' | translate }}</label><select name=length id=length ng-model=searchload.searchData.length class=\"form-control input-md\" disabled><option value=\"\">{{ \'loads:add:form:select:any\' | translate }}</option></select></div></div></div><div ng-if=searchload.advancedOptions class=form-group><div class=row><div class=\"col-12 col-sm-6\"><label class=title-field>{{ \'modals:search_load:fields:weight:title\' | translate }}</label><input type=number name=weight class=form-control ng-model=searchload.searchData.weight placeholder=\"\" required></div><div class=\"col-12 col-sm-6\"><label class=title-field>{{ \'modals:search_load:fields:load_type:title\' | translate }}</label><select name=load_type id=load_type ng-model=searchload.searchData.load_type class=\"form-control input-md\" required><option value=\"\">{{ \'loads:add:form:select:any\' | translate }}</option><option ng-repeat=\"option in searchload.itemsSizeLenLoads.LoadsType_list\" value={{option.id}}>{{option.skill_name}}</option></select></div></div></div><div class=form-group><div class=row><div class=\"col-12 col-sm-6\"><label class=title-field>{{ \'modals:search_load:fields:pickupdate:title\' | translate }}</label><input ng-blur=searchload.allowDeliveryDate() date-range-picker id=pickup ng-model=searchload.searchData.pickup name=pickup type=text placeholder=\"\" class=\"form-control input-md date-picker\" options=searchload.optsDatePicker max=searchload.searchData.delivery required></div><div class=\"col-12 col-sm-6\"><label class=title-field>{{ \'modals:search_load:fields:deliverydate:title\' | translate }}</label><input ng-blur=searchload.allowPickupDate() date-range-picker type=text name=delivery class=\"form-control date-picker\" ng-model=searchload.searchData.delivery placeholder=\"\" options=searchload.optsDatePicker min=searchload.searchData.pickup required></div></div></div><div ng-if=searchload.advancedOptions class=form-group><div class=row><div class=col-12><label class=title-field>{{ \'modals:search_load:fields:deadhead:title\' | translate }}</label><input type=number name=deadhead class=form-control ng-model=searchload.searchData.deadhead placeholder=\"\" required></div></div></div><div class=form-group><div class=row><div class=col-12><label class=title-field>{{ \'modals:search_load:fields:load_id:title\' | translate }}</label><input type=text name=load_id class=form-control ng-model=searchload.searchData.load_id placeholder=\"\" required></div></div></div><div ng-if=searchload.advancedOptions class=form-group><div class=row><div class=col-12><label class=title-field>{{ \'modals:search_load:fields:shipper:title\' | translate }}</label><input type=text name=shipper class=form-control ng-model=searchload.searchData.shipper placeholder=\"\" required></div></div></div><div ng-if=searchload.advancedOptions class=form-group><div class=row><div class=col-12><label class=title-field>{{ \'modals:search_load:fields:review:title\' | translate }}</label><div class=clearfix></div><ul class=\"nav reviews-calification\"><li class=nav-item><span ng-class=\"{\'fa-star\': hover1 || hover2 || hover3 || hover4 || hover5 || searchload.searchData.review >= 1, \'fa-star-o\': !hover1 && !hover2 && !hover3 && !hover4 && !hover5 && searchload.searchData.review < 1}\" ng-init=\"hover1 = false\" ng-mouseenter=\"hover1 = true\" ng-mouseleave=\"hover1 = false\" ng-click=\"searchload.setReview(\'1\')\" class=fa></span></li><li class=nav-item><span ng-class=\"{\'fa-star\': hover2 || hover3 || hover4 || hover5 || searchload.searchData.review >= 2, \'fa-star-o\': !hover2 && !hover3 && !hover4 && !hover5 && searchload.searchData.review < 2}\" ng-init=\"hover2 = false\" ng-mouseenter=\"hover2 = true\" ng-mouseleave=\"hover2 = false\" ng-click=\"searchload.setReview(\'2\')\" class=fa></span></li><li class=nav-item><span ng-class=\"{\'fa-star\': hover3 || hover4 || hover5 || searchload.searchData.review >= 3, \'fa-star-o\': !hover3 && !hover4 && !hover5 && searchload.searchData.review < 3}\" ng-init=\"hover3 = false\" ng-mouseenter=\"hover3 = true\" ng-mouseleave=\"hover3 = false\" ng-click=\"searchload.setReview(\'3\')\" class=fa></span></li><li class=nav-item><span ng-class=\"{\'fa-star\': hover4 || hover5 || searchload.searchData.review >= 4, \'fa-star-o\': !hover4 && !hover5 && searchload.searchData.review < 4}\" ng-init=\"hover4 = false\" ng-mouseenter=\"hover4 = true\" ng-mouseleave=\"hover4 = false\" ng-click=\"searchload.setReview(\'4\')\" class=fa></span></li><li class=nav-item><span ng-class=\"{\'fa-star\': hover5 || searchload.searchData.review >= 5, \'fa-star-o\': !hover5 && searchload.searchData.review < 5}\" ng-init=\"hover5 = false\" ng-mouseenter=\"hover5 = true\" ng-mouseleave=\"hover5 = false\" ng-click=\"searchload.setReview(\'5\')\" class=fa></span></li><li class=nav-item><a ng-click=\"searchload.setReview(\'0\')\" class=\"small-text normal-link load-search-lessf pointer\">Reset review</a></li></ul></div></div></div><div class=form-group><div class=row><div class=\"col-8 content-links-filter\"><a ng-click=searchload.showHideAdvancedFilters() ng-if=!searchload.advancedOptions class=\"small-text normal-link color-black load-search-lessf pointer\">{{ \"modals:search_load:more_filter:text\" | translate }}</a> <a ng-click=searchload.showHideAdvancedFilters() ng-if=searchload.advancedOptions class=\"small-text normal-link color-black load-search-lessf pointer\">{{ \"modals:search_load:less_filter:text\" | translate }}</a> <a ng-click=\"searchload.resetFilters(\'all\')\" class=\"small-text normal-link color-black load-search-resetf pointer\">{{ \"modals:search_load:reset_filter:text\" | translate }}</a></div><div class=col-4><button ng-click=searchload.sendDataFormSearch() class=\"btn btn-class1 bg-color-9 color-black\">Search</button></div></div></div></form></div>");
$templateCache.put("app/main/templates/upload/form-upload-file.html","<div><div class=box-btn><a ngf-select=\"uploadFile($file, value)\" ngf-accept=\"\'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet\'\" ngf-max-size=100MB class=\"small-text normal-link inline-block parrafo pointer\"><i class=\"fa fa-upload\" aria-hidden=true></i> {{ \'profile:document:upload:title\' | translate }}</a></div></div>");
$templateCache.put("app/main/templates/upload/uploads.html","<div class=dropdown><button class=\"btn dropdown-toggle bg-color-9 color-black\" type=button id=dropdownMenuButton data-toggle=dropdown aria-haspopup=true aria-expanded=false>{{ textButon }}</button><div class=\"dropdown-menu dropdown-menu-right\" aria-labelledby=dropdownMenuButton><div class=dropdown-item><a ng-click=throwUploadMassive() class=\"color-black pointer\">{{ textUpload }}</a></div><!--<div class=\"dropdown-item\">\n      &lt;!&ndash;<a ng-click=\"trucks.openUploadTrucksUpdateModal()\" class=\"color-black pointer\">\n        {{ \'trucks:upload_trucks:update_trucks:opt\' | translate }}\n      </a>&ndash;&gt;\n    </div>--></div></div>");
$templateCache.put("app/profile/templates/form/form-edit-document.html","<form><div class=form-group><h4>{{editDataDocument.document.name}}</h4></div><div class=form-group><label>Fecha de Expiración *</label><div class=input-group><input date-range-picker type=text class=\"form-control date-picker\" ng-model=editDataDocument.document.expired placeholder=\"Ingrese Fecha de Expiracion del documento\" options=options min=today readonly required> <span class=\"input-group-addon primary-button\"><i class=\"fa fa-calendar\" aria-hidden=true></i></span></div></div></form>");
$templateCache.put("app/profile/templates/modal/edit.html","<div class=modal-body id=edit-profile-modal><h3 class=\"title-modal text-left\">{{ \'profile:edit:section:title\' | translate }}</h3><p class=\"subtitle-login small-text\">{{ \'sign_up:right_side:subtitle\'+editprofile.subtitleForm | translate }}</p><div class=full-width><form ng-if=\"editprofile.validateForm == \'basic_info\'\" class=animationIf method=post id=editProfileFormId name=editProfileFormName ng-submit=editprofile.validateEdit(editProfileFormName) novalidate><div class=form-group><div class=row><div class=\"col-12 col-sm-6\"><label class=\"bold uppercase-text\">{{ \'sign_up:form:first_name:label\' | translate }}(*)</label><input id=user_first_name ng-model=editprofile.dataUser.user_first_name name=user_first_name type=text placeholder=\"\" class=\"form-control input-md\" required></div><div class=\"col-12 col-sm-6\"><label class=\"bold uppercase-text\">{{ \'sign_up:form:last_name:label\' | translate }}(*)</label><input id=user_last_name ng-model=editprofile.dataUser.user_last_name name=user_last_name type=text placeholder=\"\" class=\"form-control input-md\" required></div></div></div><div class=form-group><div class=row><div class=\"col-12 col-sm-6\" ng-if=\"editprofile.profileEdit==\'GENERADOR_CARGA\'\"><label class=\"bold uppercase-text\">{{ \'sign_up:form:document_type:label\' | translate }}(*)</label><select name=document_type id=document_type ng-model=editprofile.dataUser.document_type class=\"form-control input-md\" required><option ng-repeat=\"documentTypeItem in editprofile.shipperDocTypeOptions\" value={{documentTypeItem.id}}>{{documentTypeItem.name}}</option></select></div><div class=\"col-12 col-sm-6\" ng-if=\"editprofile.profileEdit!=\'GENERADOR_CARGA\'\"><label class=\"bold uppercase-text\">{{ \'sign_up:form:document_type:label\' | translate }}(*)</label><select name=document_type id=document_type ng-model=editprofile.dataUser.document_type class=\"form-control input-md\" required><option ng-repeat=\"documentTypeItem2 in editprofile.notShipperDocTypeOptions\" value={{documentTypeItem2.id}}>{{documentTypeItem2.name}}</option></select></div><div class=\"col-12 col-sm-6\"><label class=\"bold uppercase-text\">{{ \'sign_up:form:document_number:label\' | translate }}(*)</label><input id=document_number ng-model=editprofile.dataUser.document_number name=document_number type=text placeholder=\"\" class=\"form-control input-md\" required></div></div></div><div class=form-group><div class=row><div class=\"col-12 col-sm-6\"><label class=\"bold uppercase-text\">{{ \'sign_up:form:phone:label\' | translate }}</label><input id=user_phone ng-model=editprofile.dataUser.user_phone name=user_phone type=text placeholder=\"\" class=\"form-control input-md\"></div><div class=\"col-12 col-sm-6\"><label class=\"bold uppercase-text\">{{ \'sign_up:form:email:label\' | translate }}(*)</label><input id=user_email ng-model=editprofile.dataUser.user_email name=user_email type=email placeholder=\"\" class=\"form-control input-md\" required></div></div></div><div class=form-group><div class=row><div class=\"col-12 col-sm-6\"><label class=\"bold uppercase-text\">{{ \'sign_up:form:password:label\' | translate }}</label><input id=user_password ng-model=editprofile.dataUser.user_new_password name=user_password type=password placeholder=\"\" class=\"form-control input-md\"></div><!--<div class=\"col-12 col-sm-6\">\n						<label class=\"bold uppercase-text\">{{ \'sign_up:form:bank_name:label\' | translate }}</label>\n						<input id=\"name_bank\" ng-model=\"editprofile.dataUser.name_bank\" name=\"name_bank\" type=\"text\" placeholder=\'\' class=\"form-control input-md\" required>\n					</div>--></div></div><!--<div class=\"form-group\">\n				<div class=\"row\">\n					<div class=\"col-12 col-sm-6\">\n						<label class=\"bold uppercase-text\">{{ \'sign_up:form:bank_account_number:label\' | translate }}</label>\n						<input id=\"number_account_bank\" ng-model=\"editprofile.dataUser.number_account_bank\" name=\"number_account_bank\" type=\"text\" placeholder=\'\' class=\"form-control input-md\" required>\n					</div>\n				</div>\n			</div>--><div class=\"form-group text-right\"><button type=submit class=\"btn btn-class2 bg-color-9 color-black\">{{ \'sign_up:form:next:btn\' | translate }}</button></div></form><form ng-if=\"editprofile.validateForm == \'company_info\'\" class=animationIf method=post id=editProfileFormId2 name=editProfileFormName2 ng-submit=editprofile.validateEdit(editProfileFormName2) novalidate><div ng-if=\"editprofile.profileEdit==\'GENERADOR_CARGA\'\" class=form-group><div class=row><div class=\"col-12 col-sm-6\"><label class=\"bold uppercase-text\">{{ \'sign_up:form:company_email:label\' | translate }}</label><input id=email_company ng-model=editprofile.dataUser.email_company name=email_company type=email placeholder=\"\" class=\"form-control input-md\"></div></div></div><div ng-if=\"editprofile.profileEdit!=\'GENERADOR_CARGA\'\" class=form-group><div class=row><div class=\"col-12 col-sm-6\"><label class=\"bold uppercase-text\">{{ \'sign_up:form:company_name:label\' | translate }}</label><input id=company_name ng-model=editprofile.dataUser.company_name name=company_name type=text placeholder=\"\" class=\"form-control input-md\"></div><div class=\"col-12 col-sm-6\"><label class=\"bold uppercase-text\">{{ \'sign_up:form:company_city:label\' | translate }}</label><input type=text name=city_company class=\"form-control input-md\" g-places-autocomplete force-selection=true ng-model=editprofile.companyCitySelect placeholder=\"\"></div></div></div><div ng-if=\"editprofile.profileEdit!=\'GENERADOR_CARGA\'\" class=form-group><div class=row><div class=\"col-12 col-sm-6\"><label class=\"bold uppercase-text\">{{ \'sign_up:form:company_state:label\' | translate }}</label><input type=text name=state_company class=\"form-control input-md\" g-places-autocomplete force-selection=true ng-model=editprofile.companyStateSelect placeholder=\"\"></div><div class=\"col-12 col-sm-6\"><label class=\"bold uppercase-text\">{{ \'sign_up:form:company_country:label\' | translate }}</label><input type=text name=country_company class=\"form-control input-md\" g-places-autocomplete force-selection=true ng-model=editprofile.companyCountrySelect placeholder=\"\"></div></div></div><div ng-if=\"editprofile.profileEdit!=\'GENERADOR_CARGA\'\" class=form-group><div class=row><div class=\"col-12 col-sm-6\"><label class=\"bold uppercase-text\">{{ \'sign_up:form:company_phone:label\' | translate }}</label><input id=phone_company ng-model=editprofile.dataUser.phone_company name=phone_company type=text placeholder=\"\" class=\"form-control input-md\"></div><div class=\"col-12 col-sm-6\"><label class=\"bold uppercase-text\">{{ \'sign_up:form:company_email:label\' | translate }}</label><input id=email_company ng-model=editprofile.dataUser.email_company name=email_company type=email placeholder=\"\" class=\"form-control input-md\"></div></div></div><div ng-if=\"editprofile.profileEdit!=\'GENERADOR_CARGA\'\" class=form-group><div class=row><div class=\"col-12 col-sm-6\"><label class=\"bold uppercase-text\">{{ \'sign_up:form:address:label\' | translate }}</label><input id=address_company ng-model=editprofile.dataUser.address_company name=address_company type=text placeholder=\"\" class=\"form-control input-md\"></div><div class=\"col-12 col-sm-6\"><label class=\"bold uppercase-text\">{{ \'sign_up:form:mc_number:label\' | translate }}</label><input id=mc_number ng-model=editprofile.dataUser.mc_number name=mc_number type=text placeholder=\"\" class=\"form-control input-md\"></div></div></div><div ng-if=\"editprofile.profileEdit!=\'GENERADOR_CARGA\'\" class=form-group><div class=row><div class=\"col-12 col-sm-6\"><label class=\"bold uppercase-text\">{{ \'sign_up:form:dot_number:label\' | translate }}</label><input id=dot_number ng-model=editprofile.dataUser.dot_number name=dot_number type=text placeholder=\"\" class=\"form-control input-md\"></div><div class=\"col-12 col-sm-6\"><label class=\"bold uppercase-text\">{{ \'sign_up:form:ein_number:label\' | translate }}</label><input id=ein_number ng-model=editprofile.dataUser.user_ein_ssn name=ein_number type=text placeholder=\"\" class=\"form-control input-md\"></div></div></div><div ng-if=\"editprofile.profileEdit!=\'GENERADOR_CARGA\'\" class=form-group><div class=row><div class=\"col-12 col-sm-6\"><label class=\"bold uppercase-text\">{{ \'sign_up:form:corp_number:label\' | translate }}</label><input id=corp_number ng-model=editprofile.dataUser.corp_number name=corp_number type=text placeholder=\"\" class=\"form-control input-md\"></div></div></div><div class=\"form-group text-right\"><button ng-click=editprofile.comeBackForm() type=button class=\"btn btn-class2 bg-color-white color-saint-juan\">{{ \'sign_up:form:back:btn\' | translate }}</button> <button type=submit class=\"btn btn-class2 bg-color-9 color-black\">{{ \'sign_up:form:finish:btn\' | translate }}</button></div></form><form ng-if=\"editprofile.validateForm == \'insurance_info\'\" class=animationIf method=post id=editProfileFormId3 name=editProfileFormName3 ng-submit=editprofile.validateEdit(editProfileFormName3) novalidate><div class=form-group><div class=row><div class=\"col-12 col-sm-6\"><label class=\"bold uppercase-text\">{{ \'sign_up:form:policy_number:label\' | translate }}</label><input id=bond_insurance_num_policy ng-model=editprofile.dataUser.bond_insurance_num_policy name=bond_insurance_num_policy type=text placeholder=\"\" class=\"form-control input-md\"></div><div class=\"col-12 col-sm-6\"><label class=\"bold uppercase-text\">{{ \'sign_up:form:company_insurance:label\' | translate }}</label><input id=bond_insurance_comp ng-model=editprofile.dataUser.bond_insurance_comp name=bond_insurance_comp type=text placeholder=\"\" class=\"form-control input-md\"></div></div></div><div class=form-group><div class=row><div class=\"col-12 col-sm-6\"><label class=\"bold uppercase-text\">{{ \'sign_up:form:bond_policy_number:label\' | translate }}</label><input id=bond_insurance_num ng-model=editprofile.dataUser.bond_insurance_num name=bond_insurance_num type=text placeholder=\"\" class=\"form-control input-md\"></div><div class=\"col-12 col-sm-6\"><label class=\"bold uppercase-text\">{{ \'sign_up:form:bank_name:label\' | translate }}</label><input id=name_bank ng-model=editprofile.dataUser.name_bank name=name_bank type=text placeholder=\"\" class=\"form-control input-md\" required></div></div></div><div class=form-group><div class=row><div class=\"col-12 col-sm-6\"><label class=\"bold uppercase-text\">{{ \'sign_up:form:bank_account_number:label\' | translate }}</label><input id=number_account_bank ng-model=editprofile.dataUser.number_account_bank name=number_account_bank type=text placeholder=\"\" class=\"form-control input-md\" required></div></div></div><div class=\"form-group text-right\"><button ng-click=editprofile.comeBackForm() type=button class=\"btn btn-class2 bg-color-white color-saint-juan\">{{ \'sign_up:form:back:btn\' | translate }}</button> <button type=submit class=\"btn btn-class2 bg-color-9 color-black\">{{ \'sign_up:form:finish:btn\' | translate }}</button></div></form></div></div>");
$templateCache.put("app/profile/templates/tabs/tab-document.html","<style>@import url(\'https://fonts.googleapis.com/css?family=Poppins&display=swap\');\n  body{\n    background: #f2f2f2;\n    font-family: \'Poppins\', sans-serif;\n  }\n  h3{\n    font-family: \'Poppins\', sans-serif;\n  }\n  .social-box .box{\n    background: #ffffff;\n    border-radius: 10px;\n    padding: 40px 20px;\n    margin: 20px 0px;\n    cursor: pointer;\n    transition: all 0.5s ease-out;\n    box-shadow: 0 0 6px #e0e0e0;\n  }\n  .social-box .box:hover{\n    box-shadow: 0 0 6px #D4DD55;\n  }\n  .social-box .box .box-text{\n    margin:20px 0px;\n    font-size: 15px;\n    line-height: 30px;\n  }\n  .social-box .box .box-btn a{\n    text-decoration: none;\n    color: #D4DD55;\n    font-size: 16px;\n  }\n  .fa{\n    color: #D4DD55;\n  }</style><div class=social-box><div class=\"alert alert-warning\" role=alert ng-hide=\"user.document_status == \'in_review\' || user.document_status == \'accepted\'\"><span>{{ \'profile:document:message:success\' | translate }}</span></div><div class=\"alert alert-info\" role=alert ng-show=\"user.document_status == \'in_review\'\"><span>{{ \'profile:document:message:review\' | translate }}</span></div><div class=\"alert alert-danger\" role=alert ng-show=\"user.document_status == \'rejected\'\"><span>{{ \'profile:document:message:review:rejected\' | translate }}</span></div><div class=\"alert alert-success\" role=alert ng-show=\"user.document_status == \'accepted\'\"><span>{{ \'profile:document:message:review:accepted\' | translate }}</span></div><div><div class=text-right><button class=\"btn btn-class1 bg-color-9 color-black ng-binding\" ng-click=sendReview() ng-disabled=\"files.length < requered.length\" ng-show=\"user.document_status == \'pending\'\">{{ \'profile:document:send:validate\' | translate }}</button></div><div class=row><div class=\"col-lg-6 col-xs-12 text-center\" ng-repeat=\"(key, value) in documents\" ng-hide=\"value.files.length < 1 && value.hide\"><div class=box><i class=\"fa fa-camera fa-3x\" aria-hidden=true></i><div class=box-title><a href={{value.template}} title=\"Descargar Template\" ng-if=value.template target=_blank><h3 ng-bind=value.name></h3></a><h3 ng-bind=value.name ng-if=\"value.template == null\" title=\"No cuenta con template\"></h3><span class=help-inline ng-if=\"value.required == true\">Requerido</span></div><div class=box-text><span ng-bind=value.description></span></div><span class=\"fa help-inline\" ng-show=value.comment>Comentarios</span><div class=box-text ng-show=value.comment><span ng-bind=value.comment></span></div><div class=row><div class=box-btn ng-class=\"{\'col-sm-6\' : value.expiration, \'col-sm-12\' : !value.expiration}\" ng-hide=!value.editable><a ngf-select=\"uploadDocument($file, value)\" ng-if=\"value.format != null\" ngf-accept=\"\'image/jpg, image/jpeg, application/pdf\'\" ngf-max-size=5MB class=\"small-text normal-link inline-block parrafo pointer\"><i class=\"fa fa-upload\" aria-hidden=true></i> {{ \'profile:document:upload:title\' | translate }} </a><a ngf-select=\"uploadDocument($file, value)\" ng-if=\"value.format == null\" ngf-max-size=5MB class=\"small-text normal-link inline-block parrafo pointer\"><i class=\"fa fa-upload\" aria-hidden=true></i> {{ \'profile:document:upload:title\' | translate }}</a></div><div class=\"col-sm-6 box-btn\" ng-if=value.expiration><a ng-click=editImage(value) title=\"Agregar fecha de expiración\" class=\"small-text normal-link inline-block parrafo pointer\"><i class=\"fa fa-calendar\" aria-hidden=true></i> {{ \'profile:document:expiration:date\' | translate }}</a></div></div><div class=table-responsive style=\"height: 150px; overflow-y: scroll\"><table class=\"table table-hover\"><tr ng-repeat=\"document in value.files\"><td><a href={{document.url}} target=_blank><img ng-src={{document.url}} ng-if=\"document.ext != \'pdf\'\" border=10px width=40px height=40px> </a><a href={{document.url}} target=_blank><i class=\"fa fa-file-pdf-o fa-2x\" aria-hidden=true ng-if=\"document.ext == \'pdf\'\"></i></a></td><td>{{(document.filename)? document.filename : \"\" }}</td><td class=col-sm-3>{{(document.expiration)? (document.expiration | date : \'y-MMMM-dd\') : \"\" }}</td><td><a ng-click=removeImage(value,document) title=Remove><i class=\"fa fa-trash\" aria-hidden=true></i></a></td></tr></table></div></div></div></div></div></div>");
$templateCache.put("app/profile/templates/tabs/tab-profile.html","<div class=row><div class=col><div class=section-profile><div class=row><div class=col-2><div ng-if=!profile.myProfileData.img_perfil_imagenes[0] class=\"content-img-profile rounded-circle\"></div><img ng-if=profile.myProfileData.img_perfil_imagenes[0] ng-src=\"{{profile.myProfileData.img_perfil_imagenes[0][\'imagen-270\']}}\" class=\"img-fluid rounded-circle\" border=0><div class=\"full-width text-center\"><a ng-if=!profile.fileSaving ngf-select=\"profile.uploadImgProfile($file, $invalidFiles)\" ngf-accept=\"\'image/jpg, image/jpeg\'\" class=\"small-text normal-link inline-block parrafo pointer\">{{ \'profile:edit:images:label\' | translate }}</a><p class=\"small-text parrafo\">{{ \'profile:active_since:text\' | translate }}: {{ profile.myProfileData.user_register | amUtc | amDateFormat:\'MM/YYYY\'}}</p><ul ng-if=profile.myProfileData.user_votes.length class=\"nav user-calification\"><li class=nav-item><span ng-class=\"profile.myProfileData.user_votes[0].total_prom >= 1 ? \'fa-star\' : \'fa-star-o\'\" class=fa></span></li><li class=nav-item><span ng-class=\"profile.myProfileData.user_votes[0].total_prom >= 2 ? \'fa-star\' : \'fa-star-o\'\" class=fa></span></li><li class=nav-item><span ng-class=\"profile.myProfileData.user_votes[0].total_prom >= 3 ? \'fa-star\' : \'fa-star-o\'\" class=fa></span></li><li class=nav-item><span ng-class=\"profile.myProfileData.user_votes[0].total_prom >= 4 ? \'fa-star\' : \'fa-star-o\'\" class=fa></span></li><li class=nav-item><span ng-class=\"profile.myProfileData.user_votes[0].total_prom >= 5 ? \'fa-star\' : \'fa-star-o\'\" class=fa></span></li></ul><ul ng-if=!profile.myProfileData.user_votes.length class=\"nav user-calification\"><li class=nav-item><span class=\"fa fa-star-o\"></span></li><li class=nav-item><span class=\"fa fa-star-o\"></span></li><li class=nav-item><span class=\"fa fa-star-o\"></span></li><li class=nav-item><span class=\"fa fa-star-o\"></span></li><li class=nav-item><span class=\"fa fa-star-o\"></span></li></ul></div></div><div class=col-10><div class=form-group><div class=row><div class=col-6><label>{{ \'sign_up:form:first_name:label\' | translate }}</label><p class=small-text>{{(profile.myProfileData.user_first_name) ? profile.myProfileData.user_first_name : \'---\' }}</p></div><div class=col-6><label>{{ \'sign_up:form:last_name:label\' | translate }}</label><p class=small-text>{{profile.myProfileData.user_last_name ? profile.myProfileData.user_last_name : \'---\'}}</p></div></div></div><div class=form-group><div class=row><div class=col-6><label>{{ \'sign_up:form:document_type:label\' | translate }}</label><p class=small-text>{{(profile.myProfileData.document_type) ? profile.myProfileData.document_type : \'---\' }}</p></div><div class=col-6><label>{{ \'sign_up:form:document_number:label\' | translate }}</label><p class=small-text>{{profile.myProfileData.document_number ? profile.myProfileData.document_number : \'---\'}}</p></div></div></div><div class=form-group><div class=row><div class=col-6><label>{{ \'sign_up:form:email:label\' | translate }}</label><p class=small-text>{{profile.myProfileData.user_email ? profile.myProfileData.user_email : \'---\'}}</p></div><div class=col-6><label>{{ \'sign_up:form:phone:label\' | translate }}</label><p class=small-text>{{profile.myProfileData.user_phone ? profile.myProfileData.user_phone : \'---\'}}</p></div></div></div><div class=form-group><div class=row><div class=col-6><label>{{ \'sign_up:form:company_name:label\' | translate }}</label><p class=small-text>{{profile.infoCompanyFinal.company_name}}</p></div></div></div><div permission permission-only=\"[\'DRIVER\',\'OWNER\']\" class=form-group><div class=row><div class=col-6><label>{{ \'profile:fields:driver_id:label\' | translate }}</label><p class=small-text>{{profile.myProfileData.id ? profile.myProfileData.id : \'---\'}}</p></div><div class=col-6><label>{{ \'profile:fields:driver_license:label\' | translate }}</label><p class=small-text>{{profile.specificProfileData.driver_license_num ? profile.specificProfileData.driver_license_num : \'---\'}}</p></div></div></div></div></div></div><div class=section-profile ng-if=\"profile.data.user_status == 1\"><div class=row><div class=col><h3 class=\"large-title subtitle-profile\">{{ \'profile:company_info:title\' | translate }}</h3><div permission permission-only=\"[\'CARRIER\',\'OWNER\']\" class=form-group><div class=row><div class=col-6><label>{{ \'sign_up:form:mc_number:label\' | translate }}</label><p class=small-text>{{profile.infoCompanyFinal.mc_number}}</p></div><div class=col-6><label>{{ \'sign_up:form:dot_number:label\' | translate }}</label><p class=small-text>{{profile.infoCompanyFinal.dot_number}}</p></div></div></div><div class=form-group><div class=row><div class=col-6><label>{{ \'profile:fields:ein_ssn:label\' | translate }}</label><p class=small-text>{{profile.myProfileData.user_ein_ssn ? profile.myProfileData.user_ein_ssn : profile.infoCompanyFinal.ein_number}}</p></div><div class=col-6><label>{{ \'sign_up:form:corp_number:label\' | translate }}</label><p class=small-text>{{profile.myProfileData.corp_number}}</p></div></div></div><div class=form-group><div class=row><div class=col-4><label>{{ \'sign_up:form:address:label\' | translate }}</label><p class=small-text>{{profile.infoCompanyFinal.address_company}}</p></div><div class=col-4><label>{{ \'sign_up:form:company_city:label\' | translate }}</label><p class=small-text>{{profile.infoCompanyFinal.city_company}}</p></div><div class=col-4><label>{{ \'sign_up:form:company_state:label\' | translate }}</label><p class=small-text>{{profile.infoCompanyFinal.state_company}}</p></div></div></div><div class=form-group><div class=row><div class=col-4><label>{{ \'sign_up:form:company_country:label\' | translate }}</label><p class=small-text>{{profile.infoCompanyFinal.country_company}}</p></div><div class=col-4><label>{{ \'sign_up:form:company_phone:label\' | translate }}</label><p class=small-text>{{profile.infoCompanyFinal.phone_company}}</p></div><div class=col-4><label>{{ \'sign_up:form:company_email:label\' | translate }}</label><p class=small-text>{{profile.infoCompanyFinal.email_company}}</p></div></div></div></div></div></div><div ng-if=false class=section-profile><div class=row><div class=col><h3 class=\"large-title subtitle-profile\">{{ \'profile:insurance_info:title\' | translate }}</h3><div class=form-group><div class=row><div class=col-4><label>{{ \'sign_up:form:policy_number:label\' | translate }}</label><p class=small-text>{{profile.specificProfileData.bond_insurance_policy_num ? profile.specificProfileData.bond_insurance_policy_num : \'---\'}}</p></div><div class=col-4><label>{{ \'sign_up:form:company_insurance:label\' | translate }}</label><p class=small-text>{{profile.specificProfileData.bond_insurance_comp ? profile.specificProfileData.bond_insurance_comp : \'---\'}}</p></div><div class=col-4><label>{{ \'sign_up:form:bond_policy_number:label\' | translate }}</label><p class=small-text>{{profile.myProfileData.bond_insurance_num ? profile.myProfileData.bond_insurance_num : \'---\'}}</p></div></div></div></div></div></div><div permission permission-only=\"[\'CARRIER\',\'OWNER\']\" class=section-profile ng-if=\"profile.data.user_status == 1\"><div class=row><div class=col><div class=form-group><label>{{ \'profile:trucks:title\' | translate }}</label><p class=small-text>{{profile.countTrucks}}</p></div></div></div></div></div></div><div permission permission-only=\"[\'CARRIER\', \'GENERADOR_CARGA\', \'OWNER\']\" class=row><div class=\"col text-right\"><button ng-click=profile.openEditProfileModal() class=\"btn btn-class1 bg-color-9 color-black\">{{ \'profile:edit:images:label\' | translate }}</button></div></div>");
$templateCache.put("app/trailers/templates/directives/trailer-details-row.html","<div class=details-table-row><p ng-if=\"!loadingTrailerData && !trailerData.idtrailer_box\" class=text-center>{{ \'trailers:details:error_data:text\' | translate }}</p><div ng-if=\"!loadingTrailerData && trailerData.idtrailer_box\" class=dropdown-actions-truck><div class=dropdown><button class=\"btn btn-secondary dropdown-toggle\" type=button id=dropdownMenuButton data-toggle=dropdown aria-haspopup=true aria-expanded=false><span class=\"fa fa-ellipsis-h\"></span></button><div class=\"dropdown-menu dropdown-menu-right\" aria-labelledby=dropdownMenuButton><div permission permission-only=\"[\'CARRIER\', \'OWNER\']\" class=dropdown-item><a ui-sref=\"private.trailers.edit({id: trailerData.idtrailer_box})\" ui-sref-opts=\"{ id: trailerData.idtrailer_box }\" class=color-black><span class=\"fa fa-pencil\"></span> {{ \"trailers:details:edit:text\" | translate }}</a></div><div permission permission-only=\"[\'CARRIER\', \'OWNER\']\" class=dropdown-item><a ng-click=trailerToggleActive()><span ng-if=\"trailerData.estatus==\'0\'\" class=\"fa fa-thumbs-up\"></span> <span ng-if=\"trailerData.estatus==\'1\'\" class=\"fa fa-thumbs-down\"></span> <span ng-if=\"trailerData.estatus==\'1\'\">{{ \'trailers:details:inactive_trailer:text\' | translate }}</span> <span ng-if=\"trailerData.estatus==\'0\'\">{{ \'trailers:details:active_trailer:text\' | translate }}</span></a></div></div></div></div><ul ng-if=\"!loadingTrailerData && trailerData.idtrailer_box\" class=\"nav name-calification-details\"><li class=nav-item><h3 class=title-truck-details>Trailer {{\'trailers:add:form:plate\' | translate }} {{trailerData.placa}}</h3></li></ul><div ng-if=\"!loadingTrailerData && trailerData.idtrailer_box\" class=row><div class=\"col col-md-9 truck-items-data\"><div class=\"row parrafo\"><div class=col><h3 class=title-truck-details>{{ \'trailers:details:basic_info:title\' | translate }}</h3></div></div><div class=\"row parrafo\"><div class=\"col col-sm-6\"><label>{{ \'trailers:add:form:trailer_type\' | translate }}</label><p ng-if=trailerInfo.trailer_type_id>{{trailerInfo.trailer_type.trailer_type_name}}</p><p ng-if=!trailerInfo.trailer_type_id>---</p></div><div class=\"col col-sm-6\"><label>{{ \'trailers:add:form:length\' | translate }}</label><p ng-if=trailerInfo.loadlength_id>{{trailerInfo.length.name}}</p><p ng-if=!trailerInfo.loadlength_id>---</p></div></div><div class=\"row parrafo\"><div class=\"col col-sm-6\"><label>{{ \'trailers:add:form:plate\' | translate }}</label><p ng-if=trailerInfo.placa>{{trailerInfo.placa}}</p><p ng-if=!trailerInfo.placa>---</p></div><div class=\"col col-sm-6\"><label>{{ \'trailers:add:form:location\' | translate }}</label><p ng-if=trailerInfo.ubicacion>{{trailerInfo.ubicacion}}</p><p ng-if=!trailerInfo.ubicacion>---</p></div></div><div class=\"row parrafo\"><div class=\"col col-sm-6\"><label>{{ \'trailers:add:form:status\' | translate }}</label><p>{{statusName}}</p></div><div class=\"col col-sm-6\"><label>{{ \'trailers:details:truck_assigned:title\' | translate }}</label><p ng-if=trailerInfo.truck_full_name>{{trailerInfo.truck_full_name}}<br><a ng-click=goToSeeTruck(trailerInfo.trucks_id) class=\"small-text normal-link pointer\">{{\'trailers:details:truck_assigned:go_to_see\' | translate }}</a></p><p ng-if=!trailerInfo.truck_full_name>---</p></div></div></div></div></div>");
$templateCache.put("app/trailers/templates/modal/trailers-upload.html","<div class=modal-body id=trailers-upload-modal><h3 class=\"title-modal text-left\">{{ \'modals:trailer_upload:title\' | translate }}</h3><form method=post id=trucksUploadFormId name=trailersUploadFormName ng-submit=trailersupload.sendDataUpload(trailersUploadFormName) novalidate><div class=form-group><div class=row><div class=col-12><label class=title-field>{{ \'modals:trailer_upload:fields:file_xls:title\' | translate }}</label><br><input type=file name=file id=file ng-files=trailersupload.getFiles($files) required></div></div></div><div class=form-group><div class=row><div class=col-12><label class=title-field>{{ \'modals:trailer_upload:fields:api_key:title\' | translate }}</label><input id=api_key ng-model=trailersupload.dataHeader.api_key name=api_key type=text placeholder=\"\" class=form-control required></div></div></div><div class=form-group><div class=row><div class=col-12><label class=title-field>{{ \'modals:trailer_upload:fields:notification_email:title\' | translate }}</label><input id=notification_email ng-model=trailersupload.dataHeader.notificacion_email name=notification_email type=email placeholder=\"\" class=form-control required></div></div></div><div class=form-group><div class=row><div class=col-6><button ng-disabled=trailersupload.saving type=submit class=\"btn btn-class1 bg-color-9 color-black\">{{ \'modals:trailer_upload:submit:btn:text\' | translate }}</button></div><div class=\"col-6 text-right\"><a ng-if=!trailersupload.saving ng-click=trailersupload.closePopup() class=\"normal-link color-black small-text cancel-post-link\">{{ \'loads:add:form:btn:cancel\' | translate }}</a></div></div></div></form></div>");
$templateCache.put("app/trucks/templates/directives/truck-details-row.html","<div class=details-table-row><main-loader ng-if=loadingTruckData></main-loader><p ng-if=\"!loadingTruckData && !truckData.id\" class=text-center>{{ \'trucks:details:error_data:text\' | translate }}</p><div ng-if=\"!loadingTruckData && truckData.id\" class=dropdown-actions-truck><div class=dropdown><button class=\"btn btn-secondary dropdown-toggle\" type=button id=dropdownMenuButton data-toggle=dropdown aria-haspopup=true aria-expanded=false><span class=\"fa fa-ellipsis-h\"></span></button><div class=\"dropdown-menu dropdown-menu-right\" aria-labelledby=dropdownMenuButton><div permission permission-only=\"[\'CARRIER\', \'OWNER\']\" class=dropdown-item><a ui-sref=\"private.trucks.edit({id: truckData.id})\" ui-sref-opts=\"{ id: truckData.id }\" class=color-black><span class=\"fa fa-pencil\"></span> {{ \"trucks:details:edit:text\" | translate }}</a></div><div permission permission-only=\"[\'CARRIER\', \'OWNER\']\" class=dropdown-item><a ui-sref=\"private.trucks.edit({id: truckData.id, tab : 2})\" ui-sref-opts=\"{ id: truckData.id }\" class=color-black><span class=\"fa fa-upload\"></span> {{ \'profile:section:document:title\' | translate }}</a></div><div permission permission-only=\"[\'CARRIER\', \'OWNER\']\" class=dropdown-item><a ng-click=truckToggleActive()><span ng-if=\"truckData.status==\'0\'\" class=\"fa fa-thumbs-up\"></span> <span ng-if=\"truckData.status==\'1\'\" class=\"fa fa-thumbs-down\"></span> <span ng-if=\"truckData.status==\'1\'\">{{ \'trucks:details:inactive_truck:text\' | translate }}</span> <span ng-if=\"truckData.status==\'0\'\">{{ \'trucks:details:active_truck:text\' | translate }}</span></a></div></div></div></div><ul ng-if=\"!loadingTruckData && truckData.id\" class=\"nav name-calification-details\"><li class=nav-item><h3 class=title-truck-details>{{truckData.brand}} {{truckData.model}}</h3></li><li ng-if=truckData.driver.user.user_votes.length class=nav-item><span ng-class=\"truckData.driver.user.user_votes[0].total_prom >= 1 ? \'fa-star\' : \'fa-star-o\'\" class=fa></span> <span ng-class=\"truckData.driver.user.user_votes[0].total_prom >= 2 ? \'fa-star\' : \'fa-star-o\'\" class=fa></span> <span ng-class=\"truckData.driver.user.user_votes[0].total_prom >= 3 ? \'fa-star\' : \'fa-star-o\'\" class=fa></span> <span ng-class=\"truckData.driver.user.user_votes[0].total_prom >= 4 ? \'fa-star\' : \'fa-star-o\'\" class=fa></span> <span ng-class=\"truckData.driver.user.user_votes[0].total_prom >= 5 ? \'fa-star\' : \'fa-star-o\'\" class=fa></span></li><li ng-if=!truckData.driver.user.user_votes.length class=nav-item><span class=\"fa fa-star-o\"></span> <span class=\"fa fa-star-o\"></span> <span class=\"fa fa-star-o\"></span> <span class=\"fa fa-star-o\"></span> <span class=\"fa fa-star-o\"></span></li></ul><div ng-if=\"!loadingTruckData && truckData.id\" class=row><div class=\"col col-md-3 text-center\"><img ng-if=truckData.imagenes_trucks ng-src=\"{{truckData.imagenes_trucks[0][\'imagen-60\']}}\" class=img-fluid border=0><p class=foot-truck-pic>{{ \'trucks:details:loads_delivered:title\' | translate }}: {{truckData.Loads_Transported}}</p></div><div class=\"col col-md-9 truck-items-data\"><div class=\"row parrafo\"><div class=\"col col-sm-3\"><h3 class=title-truck-details>{{ \'trucks:details:basic_info:title\' | translate }}</h3></div><div class=\"col col-sm-3\"><h3 class=title-truck-details>{{ \'trucks:details:truck_details:title\' | translate }}</h3></div></div><div class=\"row parrafo\"><div class=\"col col-sm-3\"><label>{{ \'trucks:details:company_id_unity:title\' | translate }}</label><p ng-if=truckData.company_id_unity>{{truckData.company_id_unity}}</p><p ng-if=!truckData.company_id_unity>---</p></div><div class=\"col col-sm-3\"><label>{{ \'trucks:details:configuration:title\' | translate }}</label><p ng-if=truckData.configuration>{{truckData.configuration}}</p><p ng-if=!truckData.configuration>---</p></div><div class=\"col col-sm-3\"><label>{{ \'trucks:details:skills:title\' | translate }}</label><p>{{truckData.SkillsTruckText}}</p></div><div class=\"col col-sm-3\"><!--espacio para loads assigned --></div></div><div class=\"row parrafo\"><div class=\"col col-sm-3\"><label>{{ \'trucks:details:model:title\' | translate }}</label><p ng-if=truckData.model>{{truckData.model}}</p><p ng-if=!truckData.model>---</p></div><div class=\"col col-sm-3\"><label>{{ \'trucks:details:truck_type:title\' | translate }}</label><p ng-if=truckData.truck_type.truck_type_name>{{truckData.truck_type.truck_type_name}}</p><p ng-if=!truckData.truck_type.truck_type_name>---</p></div><div class=\"col col-sm-3 relative\"><div class=truck-item-large><label>{{ \'trucks:details:additional_info:title\' | translate }}</label><p ng-if=\"truckData.additional_info && truckData.additional_info != \'null\'\">{{truckData.additional_info}}</p><p ng-if=\"!truckData.additional_info || truckData.additional_info == \'null\'\">---</p></div></div></div><div class=\"row parrafo\"><div class=\"col col-sm-3\"><label>{{ \'trucks:details:year:title\' | translate }}</label><p ng-if=truckData.year>{{truckData.year}}</p><p ng-if=!truckData.year>---</p></div><div class=\"col col-sm-3\"><label>{{ \'trucks:details:length:title\' | translate }}</label><p ng-if=\"truckData.length && truckData.length != \'null\'\">{{truckData.length}}</p><p ng-if=\"!truckData.length || truckData.length == \'null\'\">---</p></div><div class=\"col col-sm-3\"><label>{{ \'trucks:details:max_distance:title\' | translate }}</label><p ng-if=truckData.max_distance>{{truckData.max_distance}}</p><p ng-if=!truckData.max_distance>---</p></div></div><div class=\"row parrafo\"><div class=\"col col-sm-3\"><label>{{ \'trucks:details:plate:title\' | translate }}</label><p ng-if=truckData.plate>{{truckData.plate}}</p><p ng-if=!truckData.plate>---</p></div><div class=\"col col-sm-3\"><label>{{ \'trucks:details:weight:title\' | translate }}</label><p ng-if=truckData.weight>{{truckData.weight}}</p><p ng-if=!truckData.weight>---</p></div><div class=\"col col-sm-3\"><label>{{ \'trucks:details:availiability:title\' | translate }}</label><p>{{truckData.AvailabilityTruckText}}</p></div></div><div class=\"row parrafo\"><div class=\"col col-sm-3\"><label>{{ \'trucks:details:driven_by:title\' | translate }}</label><p ng-if=\"truckData.driver.user.user_first_name || truckData.driver.user.user_last_name\">{{truckData.driver.user.user_first_name}} {{truckData.driver.user.user_last_name}}</p><p ng-if=\"!truckData.driver.user.user_first_name && !truckData.driver.user.user_last_name\">---</p><a ng-if=\"truckData.driver.user.user_first_name || truckData.driver.user.user_last_name\" ng-click=goToSeeDriver(truckData.driver.user.user_first_name) class=\"small-text normal-link pointer\">{{\'trucks:details:see_driver:text\' | translate }}</a></div><div class=\"col col-sm-3\"><label>{{ \'drivers:details:driver_company_id:title\' | translate }}</label><p ng-if=truckData.driver.id_integration_drivers>{{truckData.driver.id_integration_drivers}}</p><p ng-if=!truckData.driver.id_integration_drivers>---</p></div></div><div class=\"row parrafo\"><div class=\"col col-sm-3\"><a ui-sref=\"private.trucks.loads({id: truckData.id})\" ui-sref-opts=\"{ id: truckData.id }\" class=\"small-text normal-link load-search-lessf pointer\">{{ \'trucks:details:truck_loads:title\' | translate }}</a></div></div><div class=\"row parrafo\"><div class=\"col col-sm-3\"><h3 class=title-truck-details>{{ \'trucks:details:truck_trailer_details:title\' | translate }}</h3></div></div><div ng-if=\"truckData.trailer == null\" class=\"row parrafo\"><div class=\"col col-sm-6\"><p>{{ \'trucks:details:truck_trailer_no_assigned:text\' | translate }}</p></div></div><div ng-if=\"truckData.trailer != null\" class=\"row parrafo\"><div class=\"col col-sm-3\"><label>{{ \'trailers:add:form:trailer_type\' | translate }}</label><p ng-if=truckData.trailer.trailer_type_id>{{truckData.trailer.trailer_type.trailer_type_name}}</p><p ng-if=!truckData.trailer.trailer_type_id>---</p></div><div class=\"col col-sm-3\"><label>{{ \'trailers:add:form:plate\' | translate }}</label><p ng-if=truckData.trailer.placa>{{truckData.trailer.placa}}</p><p ng-if=!truckData.trailer.placa>---</p></div><div class=\"col col-sm-3\"><label>{{ \'trailers:add:form:length\' | translate }}</label><p ng-if=truckData.trailer.loadlength_id>{{truckData.trailer.length.name}}</p><p ng-if=!truckData.trailer.loadlength_id>---</p></div></div><div ng-if=\"truckData.trailer != null\" class=\"row parrafo\"><div class=\"col col-sm-3\"><a ng-click=goToSeeTrailerId(truckData.trailer.idtrailer_box) class=\"small-text normal-link pointer\">{{\'trucks:details:see_trailer:text\' | translate }}</a><p></p></div></div></div></div></div>");
$templateCache.put("app/trucks/templates/modal/trucks-upload.html","<div class=modal-body id=trucks-upload-modal><h3 class=\"title-modal text-left\">{{ \'modals:truck_upload:title\' | translate }}</h3><form method=post id=trucksUploadFormId name=trucksUploadFormName ng-submit=trucksupload.sendDataUpload(trucksUploadFormName) novalidate><div class=form-group><div class=row><div class=col-12><label class=title-field>{{ \'modals:truck_upload:fields:file_xls:title\' | translate }}</label><br><input type=file name=file id=file ng-files=trucksupload.getFiles($files) required></div></div></div><div class=form-group><div class=row><div class=col-12><label class=title-field>{{ \'modals:truck_upload:fields:api_key:title\' | translate }}</label><input id=api_key ng-model=trucksupload.dataHeader.api_key name=api_key type=text placeholder=\"\" class=form-control required></div></div></div><div class=form-group><div class=row><div class=col-12><label class=title-field>{{ \'modals:truck_upload:fields:notification_email:title\' | translate }}</label><input id=notification_email ng-model=trucksupload.dataHeader.notificacion_email name=notification_email type=email placeholder=\"\" class=form-control required></div></div></div><div class=form-group><div class=row><div class=col-6><button ng-disabled=trucksupload.saving type=submit class=\"btn btn-class1 bg-color-9 color-black\">{{ \'modals:truck_upload:submit:btn:text\' | translate }}</button></div><div class=\"col-6 text-right\"><a ng-if=!trucksupload.saving ng-click=trucksupload.closePopup() class=\"normal-link color-black small-text cancel-post-link\">{{ \'loads:add:form:btn:cancel\' | translate }}</a></div></div></div></form></div>");
$templateCache.put("app/trucks/templates/section/btn-add-section.html","<div class=\"row main-botonera\"><div class=\"col-12 col-sm-9\"><button ng-disabled=trucksadd.savingNewTruck type=submit class=\"btn btn-class1 bg-color-9 color-black\">{{ \'loads:add:form:btn:save_post_next\' | translate }}</button> <a ng-disabled=trucksadd.savingNewTruck ng-click=trucksadd.submitReturnListFunc(postTruckFormName) class=\"normal-link color-black small-text\">{{ \'loads:add:form:btn:save_return_list\' | translate }}</a></div><div class=\"col-12 col-sm-3 text-right\"><a ng-if=!trucksadd.savingNewTruck ui-sref=private.trucks ui-sref-opts=\"{ reload: true }\" class=\"normal-link color-black small-text cancel-post-link\">{{ \'loads:add:form:btn:cancel\' | translate }}</a></div></div>");
$templateCache.put("app/trucks/templates/section/form-add-section.html","<div class=row><div class=col-12><div class=row><div class=col-4><div class=pic-square ngf-select ng-model=trucksadd.dataNewTruck.pic name=pic ngf-pattern=\"\'image/*\'\" ngf-accept=\"\'image/*\'\" ngf-max-size=2MB><img ng-show=postTruckFormName.pic.$valid ngf-thumbnail=trucksadd.dataNewTruck.pic class=img-fluid></div></div><div class=col-8><div class=form-group><div class=row><div class=col-6><label>{{ \'trucks:add:company_id_unity:text\' | translate }}</label><span class=help-inline ng-show=postTruckFormName.unity_id.$error.required>*</span> <input type=text name=unity_id class=form-control ng-model=trucksadd.dataNewTruck.unity_id placeholder=\'{{ \"trucks:add:company_id_unity:text\" | translate }}\' required></div></div></div><div class=form-group><div class=row><div class=col-6><label>{{ \'trucks:add:form:brand:text\' | translate }}</label><span class=help-inline ng-show=postTruckFormName.brand.$error.required>*</span><select name=brand id=brand ng-model=trucksadd.dataNewTruck.brand class=\"form-control input-md\" required><option value=\"\">{{ \'trucks:add:form:select:any\' | translate }}</option><option ng-repeat=\"option in trucksadd.brandTruckList\" value={{option.tag}}>{{option.name}}</option></select></div><div class=col-6><label>{{ \'trucks:add:form:model:text\' | translate }}</label><span class=help-inline ng-show=postTruckFormName.model.$error.required>*</span> <input type=text name=model class=form-control ng-model=trucksadd.dataNewTruck.model placeholder=\'{{ \"trucks:add:form:model:text\" | translate }}\' required></div></div></div><div class=form-group><div class=row><div class=col-6><label>{{ \'trucks:add:form:year:text\' | translate }}</label><span class=help-inline ng-show=postTruckFormName.year.$error.required>*</span> <input type=number name=year class=form-control ng-model=trucksadd.dataNewTruck.year placeholder=\'{{ \"trucks:add:form:year:text\" | translate }}\' required></div><div class=col-6><label>{{ \'trucks:add:form:plate:text\' | translate }}</label><span class=help-inline ng-show=postTruckFormName.plate.$error.required>*</span> <input type=text name=plate class=form-control ng-model=trucksadd.dataNewTruck.plate placeholder=\'{{ \"trucks:add:form:plate:text\" | translate }}\' required></div></div></div></div></div><div class=form-group><div class=row><div class=col-6><label>{{ \'trucks:add:form:driver:text\' | translate }}</label><select id=driver ng-model=trucksadd.dataNewTruck.id_driver class=\"form-control input-md\"><option value=\"\">{{ \'trucks:add:form:select:any\' | translate }}</option><option ng-repeat=\"option in trucksadd.myDriversList\" value={{option.id}}>{{option.user_first_name}} {{option.user_last_name}}</option></select></div></div></div><div class=form-group><div class=row><div class=\"col-6 col-sm-3\"><label>{{ \'trucks:add:form:configuration:text\' | translate }}</label><span class=help-inline ng-show=postTruckFormName.loadsize_id.$error.required>*</span><select name=loadsize_id id=loadsize_id ng-model=trucksadd.dataNewTruck.loadsize_id ng-change=trucksadd.sizeConfigurationChange() class=\"form-control input-md\" required><option value=\"\">{{ \'trucks:add:form:select:any\' | translate }}</option><option ng-repeat=\"option in trucksadd.itemsSizeLenLoads.LoadsSize_list\" value={{option.id}}>{{option.name}}</option></select></div><div ng-show=\"trucksadd.truckTypeConf == \'S\'\" class=\"col-6 col-sm-3\"><label>{{ \'trucks:add:form:truck_type:text\' | translate }}</label><span class=help-inline ng-show=postTruckFormName.id_truck_type.$error.required>*</span><select name=id_truck_type ng-model=trucksadd.truckTypeRequired ng-change=trucksadd.truckTypeChange() class=\"form-control input-md\"><option value=\"\">{{ \'trucks:add:form:select:any\' | translate }}</option><option ng-repeat=\"option in trucksadd.simpleTruckTypes\" value={{option.id}}>{{option.name}}</option></select></div><div ng-show=\"trucksadd.truckTypeConf == \'F\'\" class=\"col-6 col-sm-3\"><label>{{ \'trucks:add:form:truck_type:text\' | translate }}</label><span class=help-inline ng-show=postTruckFormName.id_truck_type.$error.required>*</span><select name=id_truck_type ng-model=trucksadd.truckTypeRequired ng-change=trucksadd.truckTypeChange() class=\"form-control input-md\"><option value=\"\">{{ \'trucks:add:form:select:any\' | translate }}</option><option ng-repeat=\"option in trucksadd.fullTruckTypes\" value={{option.id}}>{{option.name}}</option></select></div><div ng-show=\"trucksadd.truckTypeConf == \'NA\'\" class=\"col-6 col-sm-3\"><label>{{ \'trucks:add:form:truck_type:text\' | translate }}</label><select name=id_truck_type ng-model=trucksadd.truckTypeRequired class=\"form-control input-md\" disabled><option value=\"\">{{ \'trucks:add:form:select:any\' | translate }}</option></select></div><div ng-show=\"trucksadd.lenghtType == \'S\'\" class=\"col-6 col-sm-3\"><label>{{ \'trucks:add:form:length:text\' | translate }}</label><span class=help-inline ng-show=postTruckFormName.length.$error.required>*</span><select name=length id=length ng-model=trucksadd.dataNewTruck.length class=\"form-control input-md\"><option value=\"\">{{ \'trucks:add:form:select:any\' | translate }}</option><option ng-repeat=\"option in trucksadd.simpleLoadsLength\" value={{option.name}}>{{option.name}}</option></select></div><div ng-show=\"trucksadd.lenghtType == \'F\'\" class=\"col-6 col-sm-3\"><label>{{ \'trucks:add:form:length:text\' | translate }}</label><span class=help-inline ng-show=postTruckFormName.length.$error.required>*</span><select name=length ng-model=trucksadd.dataNewTruck.length class=\"form-control input-md\"><option value=\"\">{{ \'trucks:add:form:select:any\' | translate }}</option><option ng-repeat=\"option in trucksadd.fullLoadsLength\" value={{option.name}}>{{option.name}}</option></select></div><div ng-show=\"trucksadd.lenghtType == \'NA\'\" class=\"col-6 col-sm-3\"><label>{{ \'trucks:add:form:length:text\' | translate }}</label><select name=length ng-model=trucksadd.dataNewTruck.length class=\"form-control input-md\" disabled><option value=\"\">{{ \'trucks:add:form:select:any\' | translate }}</option></select></div><div class=\"col-6 col-sm-3\"><label>{{ \'trucks:add:form:weight:text\' | translate }}</label><span class=help-inline ng-show=postTruckFormName.weight.$error.required>*</span> <input type=number name=weight class=form-control ng-model=trucksadd.dataNewTruck.weight placeholder=\'{{ \"trucks:add:form:weight:text\" | translate }}\' required></div></div></div><div class=form-group><div class=row><div class=\"col-6 col-sm-3\"><label>{{ \'trucks:add:form:trailer_type:text\' | translate }}</label><span class=help-inline ng-show=postTruckFormName.trailer_type_id.$error.required>*</span><select name=trailer_type_id id=trailer_type_id ng-model=trucksadd.dataNewTruck.trailer_type_id class=\"form-control input-md\" required><option value=\"\">{{ \'trucks:add:form:select:any\' | translate }}</option><option ng-repeat=\"option in trucksadd.itemsSizeLenLoads.TrailerType\" value={{option.id}}>{{option.trailer_type_name}}</option></select></div><div class=col-6><label>{{ \'trucks:add:form:trailer:text\' | translate }}</label><span class=help-inline ng-show=postTruckFormName.trailer_id.$error.required>*</span><select name=trailer_id id=trailer_id ng-model=trucksadd.dataNewTruck.trailer_id class=\"form-control input-md\"><option value=\"\">{{ \'trucks:add:form:select:any\' | translate }}</option><option ng-repeat=\"option in trucksadd.myTrailersList\" value={{option.idtrailer_box}}>{{ \'trailers:add:form:plate\' | translate }}: {{option.placa}} - {{option.trailer_type.trailer_type_name}}</option></select></div></div></div><div class=form-group><label class=title-checks>{{ \'trucks:add:form:skills:text\' | translate }}</label><ul class=list-checks><li ng-repeat=\"skill in trucksadd.skillList\"><input type=checkbox id={{skill.name}} name={{skill.name}} ng-model=skill.checked class=custom-checkbox><label for={{skill.name}}><span></span>{{skill.name}}</label></li></ul></div><div class=form-group ng-hide=true><div class=row><div class=\"col-6 col-sm-3\"><label>{{ \'trucks:add:form:max_distance:text\' | translate }}</label><span class=help-inline ng-show=postTruckFormName.max_distance.$error.required>*</span> <input type=number name=max_distance class=form-control ng-model=trucksadd.dataNewTruck.max_distance placeholder=\'{{ \"trucks:add:form:max_distance:text\" | translate }}\'></div></div></div><div class=form-group><label class=title-checks>{{ \'trucks:add:form:availability:text\' | translate }}</label><ul class=list-checks><li ng-repeat=\"available_item in trucksadd.availabilityList\"><input type=checkbox id={{available_item.name}} name={{available_item.name}} ng-model=available_item.checked class=custom-checkbox><label for={{available_item.name}}><span></span>{{available_item.name}}</label></li></ul></div><div class=form-group><label>{{ \'trucks:add:form:additional_info:text\' | translate }}</label><textarea class=form-control name=additional_information ng-model=trucksadd.dataNewTruck.additional_info placeholder=\"{{ \'trucks:add:form:additional_info:text\' | translate }}\"></textarea></div></div></div>");
$templateCache.put("app/trucks/templates/tabs/tab-truck.html","<div class=row><div class=col-12><div class=row><div class=col-4><div class=pic-square ngf-select ng-model=trucksedit.dataUpdateTruck.pic name=pic ngf-pattern=\"\'image/*\'\" ngf-accept=\"\'image/*\'\" ngf-max-size=2MB><img ng-show=postTruckFormName.pic.$valid ngf-thumbnail=trucksedit.dataUpdateTruck.pic class=img-fluid></div></div><div class=col-8><div class=form-group><div class=row><div class=col-6><label>{{ \'trucks:add:company_id_unity:text\' | translate }}</label><span class=help-inline ng-show=postTruckFormName.unity_id.$error.required>*</span> <input type=text name=unity_id class=form-control ng-model=trucksedit.dataUpdateTruck.unity_id placeholder=\'{{ \"trucks:add:company_id_unity:text\" | translate }}\' required></div></div></div><div class=form-group><div class=row><div class=col-6><label>{{ \'trucks:add:form:brand:text\' | translate }}</label><span class=help-inline ng-show=postTruckFormName.brand.$error.required>*</span><select name=brand id=brand ng-model=trucksedit.dataUpdateTruck.brand class=\"form-control input-md\" required><option value=\"\">{{ \'trucks:add:form:select:any\' | translate }}</option><option ng-repeat=\"option in trucksedit.brandTruckList\" value={{option.tag}}>{{option.name}}</option></select></div><div class=col-6><label>{{ \'trucks:add:form:model:text\' | translate }}</label><span class=help-inline ng-show=postTruckFormName.model.$error.required>*</span> <input type=text name=model class=form-control ng-model=trucksedit.dataUpdateTruck.model placeholder=\'{{ \"trucks:add:form:brand:text\" | translate }}\' required></div></div></div><div class=form-group><div class=row><div class=col-6><label>{{ \'trucks:add:form:year:text\' | translate }}</label><span class=help-inline ng-show=postTruckFormName.year.$error.required>*</span> <input type=number name=year class=form-control ng-model=trucksedit.dataUpdateTruck.year placeholder=\'{{ \"trucks:add:form:year:text\" | translate }}\' required></div><div class=col-6><label>{{ \'trucks:add:form:plate:text\' | translate }}</label><span class=help-inline ng-show=postTruckFormName.plate.$error.required>*</span> <input type=text name=plate class=form-control ng-model=trucksedit.dataUpdateTruck.plate placeholder=\'{{ \"trucks:add:form:plate:text\" | translate }}\' required></div></div></div></div></div><div class=form-group><div class=row><div class=col-6><label>{{ \'trucks:add:form:driver:text\' | translate }}</label><select name=driver id=driver ng-model=trucksedit.dataUpdateTruck.id_driver class=\"form-control input-md\"><option value=\"\">{{ \'trucks:add:form:select:any\' | translate }}</option><option ng-repeat=\"option in trucksedit.myDriversList\" value={{option.id}}>{{option.user_first_name}} {{option.user_last_name}}</option></select></div></div></div><div class=form-group><div class=row><div class=\"col-6 col-sm-3\"><label>{{ \'trucks:add:form:configuration:text\' | translate }}</label><span class=help-inline ng-show=postTruckFormName.loadsize_id.$error.required>*</span><select name=loadsize_id id=loadsize_id ng-model=trucksedit.dataUpdateTruck.loadsize_id ng-change=trucksedit.sizeConfigurationChange() class=\"form-control input-md\" required><option value=\"\">{{ \'trucks:add:form:select:any\' | translate }}</option><option ng-repeat=\"option in trucksedit.itemsSizeLenLoads.LoadsSize_list\" value={{option.id}}>{{option.name}}</option></select></div><div ng-show=\"trucksedit.truckTypeConf == \'S\'\" class=\"col-6 col-sm-3\"><label>{{ \'trucks:add:form:truck_type:text\' | translate }}</label><span class=help-inline ng-show=postTruckFormName.id_truck_type.$error.required>*</span><select name=id_truck_type id=id_truck_type ng-model=trucksedit.truckTypeRequired ng-change=trucksedit.truckTypeChange() class=\"form-control input-md\"><option value=\"\">{{ \'trucks:add:form:select:any\' | translate }}</option><option ng-repeat=\"option in trucksedit.simpleTruckTypes\" value={{option.id}}>{{option.name}}</option></select></div><div ng-show=\"trucksedit.truckTypeConf == \'F\'\" class=\"col-6 col-sm-3\"><label>{{ \'trucks:add:form:truck_type:text\' | translate }}</label><span class=help-inline ng-show=postTruckFormName.id_truck_type.$error.required>*</span><select name=id_truck_type id=id_truck_type ng-model=trucksedit.truckTypeRequired ng-change=trucksedit.truckTypeChange() class=\"form-control input-md\"><option value=\"\">{{ \'trucks:add:form:select:any\' | translate }}</option><option ng-repeat=\"option in trucksedit.fullTruckTypes\" value={{option.id}}>{{option.name}}</option></select></div><div ng-show=\"trucksedit.truckTypeConf == \'NA\'\" class=\"col-6 col-sm-3\"><label>{{ \'trucks:add:form:truck_type:text\' | translate }}</label><select name=id_truck_type id=id_truck_type ng-model=trucksedit.truckTypeRequired class=\"form-control input-md\" disabled><option value=\"\">{{ \'trucks:add:form:select:any\' | translate }}</option></select></div><div ng-show=\"trucksedit.lenghtType == \'S\'\" class=\"col-6 col-sm-3\"><label>{{ \'trucks:add:form:length:text\' | translate }}</label><span class=help-inline ng-show=postTruckFormName.length.$error.required>*</span><select name=length id=length ng-model=trucksedit.dataUpdateTruck.length class=\"form-control input-md\"><option value=\"\">{{ \'trucks:add:form:select:any\' | translate }}</option><option ng-repeat=\"option in trucksedit.simpleLoadsLength\" value={{option.name}}>{{option.name}}</option></select></div><div ng-show=\"trucksedit.lenghtType == \'F\'\" class=\"col-6 col-sm-3\"><label>{{ \'trucks:add:form:length:text\' | translate }}</label><span class=help-inline ng-show=postTruckFormName.length.$error.required>*</span><select name=length id=length ng-model=trucksedit.dataUpdateTruck.length class=\"form-control input-md\"><option value=\"\">{{ \'trucks:add:form:select:any\' | translate }}</option><option ng-repeat=\"option in trucksedit.fullLoadsLength\" value={{option.name}}>{{option.name}}</option></select></div><div ng-show=\"trucksedit.lenghtType == \'NA\'\" class=\"col-6 col-sm-3\"><label>{{ \'trucks:add:form:length:text\' | translate }}</label><select name=length id=length ng-model=trucksedit.dataUpdateTruck.length class=\"form-control input-md\" disabled><option value=\"\">{{ \'trucks:add:form:select:any\' | translate }}</option></select></div><div class=\"col-6 col-sm-3\"><label>{{ \'trucks:add:form:weight:text\' | translate }}</label><span class=help-inline ng-show=postTruckFormName.weight.$error.required>*</span> <input type=number name=weight class=form-control ng-model=trucksedit.dataUpdateTruck.weight placeholder=\'{{ \"trucks:add:form:weight:text\" | translate }}\' required></div></div></div><div class=form-group><div class=row><div class=\"col-6 col-sm-3\"><label>{{ \'trucks:add:form:trailer_type:text\' | translate }}</label><span class=help-inline ng-show=postTruckFormName.trailer_type_id.$error.required>*</span><select name=trailer_type_id id=trailer_type_id ng-model=trucksedit.dataUpdateTruck.trailer_type_id class=\"form-control input-md\" required><option value=\"\">{{ \'trucks:add:form:select:any\' | translate }}</option><option ng-repeat=\"option in trucksedit.itemsSizeLenLoads.TrailerType\" value={{option.id}}>{{option.trailer_type_name}}</option></select></div><div class=col-6><label>{{ \'trucks:add:form:trailer:text\' | translate }}</label><span class=help-inline ng-show=postTruckFormName.trailer_id.$error.required>*</span><select name=trailer_id id=trailer_id ng-model=trucksedit.dataUpdateTruck.trailer_id class=\"form-control input-md\"><option value=\"\">{{ \'trucks:add:form:select:any\' | translate }}</option><option ng-repeat=\"option in trucksedit.myTrailersList\" value={{option.idtrailer_box}}>{{ \'trailers:add:form:plate\' | translate }}: {{option.placa}} - {{option.trailer_type.trailer_type_name}}</option></select></div></div></div><div class=form-group><label class=title-checks>{{ \'trucks:add:form:skills:text\' | translate }}</label><ul class=list-checks><li ng-repeat=\"skill in trucksedit.skillList\"><input type=checkbox id={{skill.name}} name={{skill.name}} ng-model=skill.checked class=custom-checkbox><label for={{skill.name}}><span></span>{{skill.name}}</label></li></ul></div><div class=form-group ng-hide=true><div class=row><div class=\"col-6 col-sm-3\"><label>{{ \'trucks:add:form:max_distance:text\' | translate }}</label><span class=help-inline ng-show=postTruckFormName.max_distance.$error.required>*</span> <input type=number name=max_distance class=form-control ng-model=trucksedit.dataUpdateTruck.max_distance placeholder=\'{{ \"trucks:add:form:max_distance:text\" | translate }}\'></div></div></div><div class=form-group><label class=title-checks>{{ \'trucks:add:form:availability:text\' | translate }}</label><ul class=list-checks><li ng-repeat=\"available_item in trucksedit.availabilityList\"><input type=checkbox id={{available_item.name}} name={{available_item.name}} ng-model=available_item.checked class=custom-checkbox><label for={{available_item.name}}><span></span>{{available_item.name}}</label></li></ul></div><div class=form-group><label>{{ \'trucks:add:form:additional_info:text\' | translate }}</label><textarea class=form-control name=additional_information ng-model=trucksedit.dataUpdateTruck.additional_info placeholder=\"{{ \'trucks:add:form:additional_info:text\' | translate }}\"></textarea></div></div></div><div class=\"row main-botonera\"><div class=\"col-12 col-sm-9\"><button ng-disabled=trucksedit.savingTruck type=submit class=\"btn btn-class1 bg-color-9 color-black\">{{ \'trucks:edit:form:btn\' | translate }}</button></div><div class=\"col-12 col-sm-3 text-right\"><a ng-if=!trucksedit.savingTruck ui-sref=private.trucks ui-sref-opts=\"{ reload: true }\" class=\"normal-link color-black small-text cancel-post-link\">{{ \'loads:add:form:btn:cancel\' | translate }}</a></div></div>");}]);